

!(function (e) {
    var t = {};
    function n(r) {
        if (t[r]) return t[r].exports;
        var i = (t[r] = { i: r, l: !1, exports: {} });
        return e[r].call(i.exports, i, i.exports, n), (i.l = !0), i.exports;
    }
    (n.m = e),
        (n.c = t),
        (n.d = function (e, t, r) {
            n.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: r });
        }),
        (n.r = function (e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
        }),
        (n.t = function (e, t) {
            if ((1 & t && (e = n(e)), 8 & t)) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var r = Object.create(null);
            if ((n.r(r), Object.defineProperty(r, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e))
                for (var i in e)
                    n.d(
                        r,
                        i,
                        function (t) {
                            return e[t];
                        }.bind(null, i)
                    );
            return r;
        }),
        (n.n = function (e) {
            var t =
                e && e.__esModule
                    ? function () {
                          return e.default;
                      }
                    : function () {
                          return e;
                      };
            return n.d(t, "a", t), t;
        }),
        (n.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (n.p = ""),
        n((n.s = 12));
})([
    function (e, t, n) {
        var r;
        /*!
         * jQuery JavaScript Library v3.6.0
         * https://jquery.com/
         *
         * Includes Sizzle.js
         * https://sizzlejs.com/
         *
         * Copyright OpenJS Foundation and other contributors
         * Released under the MIT license
         * https://jquery.org/license
         *
         * Date: 2021-03-02T17:08Z
         */ !(function (t, n) {
            "use strict";
            "object" == typeof e.exports
                ? (e.exports = t.document
                      ? n(t, !0)
                      : function (e) {
                            if (!e.document) throw new Error("jQuery requires a window with a document");
                            return n(e);
                        })
                : n(t);
        })("undefined" != typeof window ? window : this, function (n, i) {
            "use strict";
            var o = [],
                a = Object.getPrototypeOf,
                s = o.slice,
                l = o.flat
                    ? function (e) {
                          return o.flat.call(e);
                      }
                    : function (e) {
                          return o.concat.apply([], e);
                      },
                c = o.push,
                u = o.indexOf,
                d = {},
                p = d.toString,
                h = d.hasOwnProperty,
                f = h.toString,
                m = f.call(Object),
                g = {},
                v = function (e) {
                    return "function" == typeof e && "number" != typeof e.nodeType && "function" != typeof e.item;
                },
                y = function (e) {
                    return null != e && e === e.window;
                },
                b = n.document,
                w = { type: !0, src: !0, nonce: !0, noModule: !0 };
            function x(e, t, n) {
                var r,
                    i,
                    o = (n = n || b).createElement("script");
                if (((o.text = e), t)) for (r in w) (i = t[r] || (t.getAttribute && t.getAttribute(r))) && o.setAttribute(r, i);
                n.head.appendChild(o).parentNode.removeChild(o);
            }
            function E(e) {
                return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? d[p.call(e)] || "object" : typeof e;
            }
            var C = "3.6.0",
                S = function (e, t) {
                    return new S.fn.init(e, t);
                };
            function T(e) {
                var t = !!e && "length" in e && e.length,
                    n = E(e);
                return !v(e) && !y(e) && ("array" === n || 0 === t || ("number" == typeof t && t > 0 && t - 1 in e));
            }
            (S.fn = S.prototype = {
                jquery: C,
                constructor: S,
                length: 0,
                toArray: function () {
                    return s.call(this);
                },
                get: function (e) {
                    return null == e ? s.call(this) : e < 0 ? this[e + this.length] : this[e];
                },
                pushStack: function (e) {
                    var t = S.merge(this.constructor(), e);
                    return (t.prevObject = this), t;
                },
                each: function (e) {
                    return S.each(this, e);
                },
                map: function (e) {
                    return this.pushStack(
                        S.map(this, function (t, n) {
                            return e.call(t, n, t);
                        })
                    );
                },
                slice: function () {
                    return this.pushStack(s.apply(this, arguments));
                },
                first: function () {
                    return this.eq(0);
                },
                last: function () {
                    return this.eq(-1);
                },
                even: function () {
                    return this.pushStack(
                        S.grep(this, function (e, t) {
                            return (t + 1) % 2;
                        })
                    );
                },
                odd: function () {
                    return this.pushStack(
                        S.grep(this, function (e, t) {
                            return t % 2;
                        })
                    );
                },
                eq: function (e) {
                    var t = this.length,
                        n = +e + (e < 0 ? t : 0);
                    return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
                },
                end: function () {
                    return this.prevObject || this.constructor();
                },
                push: c,
                sort: o.sort,
                splice: o.splice,
            }),
                (S.extend = S.fn.extend = function () {
                    var e,
                        t,
                        n,
                        r,
                        i,
                        o,
                        a = arguments[0] || {},
                        s = 1,
                        l = arguments.length,
                        c = !1;
                    for ("boolean" == typeof a && ((c = a), (a = arguments[s] || {}), s++), "object" == typeof a || v(a) || (a = {}), s === l && ((a = this), s--); s < l; s++)
                        if (null != (e = arguments[s]))
                            for (t in e)
                                (r = e[t]),
                                    "__proto__" !== t &&
                                        a !== r &&
                                        (c && r && (S.isPlainObject(r) || (i = Array.isArray(r)))
                                            ? ((n = a[t]), (o = i && !Array.isArray(n) ? [] : i || S.isPlainObject(n) ? n : {}), (i = !1), (a[t] = S.extend(c, o, r)))
                                            : void 0 !== r && (a[t] = r));
                    return a;
                }),
                S.extend({
                    expando: "jQuery" + (C + Math.random()).replace(/\D/g, ""),
                    isReady: !0,
                    error: function (e) {
                        throw new Error(e);
                    },
                    noop: function () {},
                    isPlainObject: function (e) {
                        var t, n;
                        return !(!e || "[object Object]" !== p.call(e)) && (!(t = a(e)) || ("function" == typeof (n = h.call(t, "constructor") && t.constructor) && f.call(n) === m));
                    },
                    isEmptyObject: function (e) {
                        var t;
                        for (t in e) return !1;
                        return !0;
                    },
                    globalEval: function (e, t, n) {
                        x(e, { nonce: t && t.nonce }, n);
                    },
                    each: function (e, t) {
                        var n,
                            r = 0;
                        if (T(e)) for (n = e.length; r < n && !1 !== t.call(e[r], r, e[r]); r++);
                        else for (r in e) if (!1 === t.call(e[r], r, e[r])) break;
                        return e;
                    },
                    makeArray: function (e, t) {
                        var n = t || [];
                        return null != e && (T(Object(e)) ? S.merge(n, "string" == typeof e ? [e] : e) : c.call(n, e)), n;
                    },
                    inArray: function (e, t, n) {
                        return null == t ? -1 : u.call(t, e, n);
                    },
                    merge: function (e, t) {
                        for (var n = +t.length, r = 0, i = e.length; r < n; r++) e[i++] = t[r];
                        return (e.length = i), e;
                    },
                    grep: function (e, t, n) {
                        for (var r = [], i = 0, o = e.length, a = !n; i < o; i++) !t(e[i], i) !== a && r.push(e[i]);
                        return r;
                    },
                    map: function (e, t, n) {
                        var r,
                            i,
                            o = 0,
                            a = [];
                        if (T(e)) for (r = e.length; o < r; o++) null != (i = t(e[o], o, n)) && a.push(i);
                        else for (o in e) null != (i = t(e[o], o, n)) && a.push(i);
                        return l(a);
                    },
                    guid: 1,
                    support: g,
                }),
                "function" == typeof Symbol && (S.fn[Symbol.iterator] = o[Symbol.iterator]),
                S.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
                    d["[object " + t + "]"] = t.toLowerCase();
                });
            var k =
                /*!
                 * Sizzle CSS Selector Engine v2.3.6
                 * https://sizzlejs.com/
                 *
                 * Copyright JS Foundation and other contributors
                 * Released under the MIT license
                 * https://js.foundation/
                 *
                 * Date: 2021-02-16
                 */
                (function (e) {
                    var t,
                        n,
                        r,
                        i,
                        o,
                        a,
                        s,
                        l,
                        c,
                        u,
                        d,
                        p,
                        h,
                        f,
                        m,
                        g,
                        v,
                        y,
                        b,
                        w = "sizzle" + 1 * new Date(),
                        x = e.document,
                        E = 0,
                        C = 0,
                        S = le(),
                        T = le(),
                        k = le(),
                        A = le(),
                        _ = function (e, t) {
                            return e === t && (d = !0), 0;
                        },
                        L = {}.hasOwnProperty,
                        $ = [],
                        D = $.pop,
                        O = $.push,
                        q = $.push,
                        M = $.slice,
                        P = function (e, t) {
                            for (var n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
                            return -1;
                        },
                        I = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                        N = "[\\x20\\t\\r\\n\\f]",
                        z = "(?:\\\\[\\da-fA-F]{1,6}" + N + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
                        R = "\\[" + N + "*(" + z + ")(?:" + N + "*([*^$|!~]?=)" + N + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + z + "))|)" + N + "*\\]",
                        F = ":(" + z + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + R + ")*)|.*)\\)|)",
                        B = new RegExp(N + "+", "g"),
                        j = new RegExp("^" + N + "+|((?:^|[^\\\\])(?:\\\\.)*)" + N + "+$", "g"),
                        H = new RegExp("^" + N + "*," + N + "*"),
                        V = new RegExp("^" + N + "*([>+~]|" + N + ")" + N + "*"),
                        W = new RegExp(N + "|>"),
                        U = new RegExp(F),
                        G = new RegExp("^" + z + "$"),
                        Y = {
                            ID: new RegExp("^#(" + z + ")"),
                            CLASS: new RegExp("^\\.(" + z + ")"),
                            TAG: new RegExp("^(" + z + "|[*])"),
                            ATTR: new RegExp("^" + R),
                            PSEUDO: new RegExp("^" + F),
                            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + N + "*(even|odd|(([+-]|)(\\d*)n|)" + N + "*(?:([+-]|)" + N + "*(\\d+)|))" + N + "*\\)|)", "i"),
                            bool: new RegExp("^(?:" + I + ")$", "i"),
                            needsContext: new RegExp("^" + N + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + N + "*((?:-\\d)?\\d*)" + N + "*\\)|)(?=[^-]|$)", "i"),
                        },
                        X = /HTML$/i,
                        K = /^(?:input|select|textarea|button)$/i,
                        J = /^h\d$/i,
                        Z = /^[^{]+\{\s*\[native \w/,
                        Q = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                        ee = /[+~]/,
                        te = new RegExp("\\\\[\\da-fA-F]{1,6}" + N + "?|\\\\([^\\r\\n\\f])", "g"),
                        ne = function (e, t) {
                            var n = "0x" + e.slice(1) - 65536;
                            return t || (n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode((n >> 10) | 55296, (1023 & n) | 56320));
                        },
                        re = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                        ie = function (e, t) {
                            return t ? ("\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " ") : "\\" + e;
                        },
                        oe = function () {
                            p();
                        },
                        ae = we(
                            function (e) {
                                return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
                            },
                            { dir: "parentNode", next: "legend" }
                        );
                    try {
                        q.apply(($ = M.call(x.childNodes)), x.childNodes), $[x.childNodes.length].nodeType;
                    } catch (e) {
                        q = {
                            apply: $.length
                                ? function (e, t) {
                                      O.apply(e, M.call(t));
                                  }
                                : function (e, t) {
                                      for (var n = e.length, r = 0; (e[n++] = t[r++]); );
                                      e.length = n - 1;
                                  },
                        };
                    }
                    function se(e, t, r, i) {
                        var o,
                            s,
                            c,
                            u,
                            d,
                            f,
                            v,
                            y = t && t.ownerDocument,
                            x = t ? t.nodeType : 9;
                        if (((r = r || []), "string" != typeof e || !e || (1 !== x && 9 !== x && 11 !== x))) return r;
                        if (!i && (p(t), (t = t || h), m)) {
                            if (11 !== x && (d = Q.exec(e)))
                                if ((o = d[1])) {
                                    if (9 === x) {
                                        if (!(c = t.getElementById(o))) return r;
                                        if (c.id === o) return r.push(c), r;
                                    } else if (y && (c = y.getElementById(o)) && b(t, c) && c.id === o) return r.push(c), r;
                                } else {
                                    if (d[2]) return q.apply(r, t.getElementsByTagName(e)), r;
                                    if ((o = d[3]) && n.getElementsByClassName && t.getElementsByClassName) return q.apply(r, t.getElementsByClassName(o)), r;
                                }
                            if (n.qsa && !A[e + " "] && (!g || !g.test(e)) && (1 !== x || "object" !== t.nodeName.toLowerCase())) {
                                if (((v = e), (y = t), 1 === x && (W.test(e) || V.test(e)))) {
                                    for (((y = (ee.test(e) && ve(t.parentNode)) || t) === t && n.scope) || ((u = t.getAttribute("id")) ? (u = u.replace(re, ie)) : t.setAttribute("id", (u = w))), s = (f = a(e)).length; s--; )
                                        f[s] = (u ? "#" + u : ":scope") + " " + be(f[s]);
                                    v = f.join(",");
                                }
                                try {
                                    return q.apply(r, y.querySelectorAll(v)), r;
                                } catch (t) {
                                    A(e, !0);
                                } finally {
                                    u === w && t.removeAttribute("id");
                                }
                            }
                        }
                        return l(e.replace(j, "$1"), t, r, i);
                    }
                    function le() {
                        var e = [];
                        return function t(n, i) {
                            return e.push(n + " ") > r.cacheLength && delete t[e.shift()], (t[n + " "] = i);
                        };
                    }
                    function ce(e) {
                        return (e[w] = !0), e;
                    }
                    function ue(e) {
                        var t = h.createElement("fieldset");
                        try {
                            return !!e(t);
                        } catch (e) {
                            return !1;
                        } finally {
                            t.parentNode && t.parentNode.removeChild(t), (t = null);
                        }
                    }
                    function de(e, t) {
                        for (var n = e.split("|"), i = n.length; i--; ) r.attrHandle[n[i]] = t;
                    }
                    function pe(e, t) {
                        var n = t && e,
                            r = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
                        if (r) return r;
                        if (n) for (; (n = n.nextSibling); ) if (n === t) return -1;
                        return e ? 1 : -1;
                    }
                    function he(e) {
                        return function (t) {
                            return "input" === t.nodeName.toLowerCase() && t.type === e;
                        };
                    }
                    function fe(e) {
                        return function (t) {
                            var n = t.nodeName.toLowerCase();
                            return ("input" === n || "button" === n) && t.type === e;
                        };
                    }
                    function me(e) {
                        return function (t) {
                            return "form" in t
                                ? t.parentNode && !1 === t.disabled
                                    ? "label" in t
                                        ? "label" in t.parentNode
                                            ? t.parentNode.disabled === e
                                            : t.disabled === e
                                        : t.isDisabled === e || (t.isDisabled !== !e && ae(t) === e)
                                    : t.disabled === e
                                : "label" in t && t.disabled === e;
                        };
                    }
                    function ge(e) {
                        return ce(function (t) {
                            return (
                                (t = +t),
                                ce(function (n, r) {
                                    for (var i, o = e([], n.length, t), a = o.length; a--; ) n[(i = o[a])] && (n[i] = !(r[i] = n[i]));
                                })
                            );
                        });
                    }
                    function ve(e) {
                        return e && void 0 !== e.getElementsByTagName && e;
                    }
                    for (t in ((n = se.support = {}),
                    (o = se.isXML = function (e) {
                        var t = e && e.namespaceURI,
                            n = e && (e.ownerDocument || e).documentElement;
                        return !X.test(t || (n && n.nodeName) || "HTML");
                    }),
                    (p = se.setDocument = function (e) {
                        var t,
                            i,
                            a = e ? e.ownerDocument || e : x;
                        return a != h && 9 === a.nodeType && a.documentElement
                            ? ((f = (h = a).documentElement),
                              (m = !o(h)),
                              x != h && (i = h.defaultView) && i.top !== i && (i.addEventListener ? i.addEventListener("unload", oe, !1) : i.attachEvent && i.attachEvent("onunload", oe)),
                              (n.scope = ue(function (e) {
                                  return f.appendChild(e).appendChild(h.createElement("div")), void 0 !== e.querySelectorAll && !e.querySelectorAll(":scope fieldset div").length;
                              })),
                              (n.attributes = ue(function (e) {
                                  return (e.className = "i"), !e.getAttribute("className");
                              })),
                              (n.getElementsByTagName = ue(function (e) {
                                  return e.appendChild(h.createComment("")), !e.getElementsByTagName("*").length;
                              })),
                              (n.getElementsByClassName = Z.test(h.getElementsByClassName)),
                              (n.getById = ue(function (e) {
                                  return (f.appendChild(e).id = w), !h.getElementsByName || !h.getElementsByName(w).length;
                              })),
                              n.getById
                                  ? ((r.filter.ID = function (e) {
                                        var t = e.replace(te, ne);
                                        return function (e) {
                                            return e.getAttribute("id") === t;
                                        };
                                    }),
                                    (r.find.ID = function (e, t) {
                                        if (void 0 !== t.getElementById && m) {
                                            var n = t.getElementById(e);
                                            return n ? [n] : [];
                                        }
                                    }))
                                  : ((r.filter.ID = function (e) {
                                        var t = e.replace(te, ne);
                                        return function (e) {
                                            var n = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                                            return n && n.value === t;
                                        };
                                    }),
                                    (r.find.ID = function (e, t) {
                                        if (void 0 !== t.getElementById && m) {
                                            var n,
                                                r,
                                                i,
                                                o = t.getElementById(e);
                                            if (o) {
                                                if ((n = o.getAttributeNode("id")) && n.value === e) return [o];
                                                for (i = t.getElementsByName(e), r = 0; (o = i[r++]); ) if ((n = o.getAttributeNode("id")) && n.value === e) return [o];
                                            }
                                            return [];
                                        }
                                    })),
                              (r.find.TAG = n.getElementsByTagName
                                  ? function (e, t) {
                                        return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : n.qsa ? t.querySelectorAll(e) : void 0;
                                    }
                                  : function (e, t) {
                                        var n,
                                            r = [],
                                            i = 0,
                                            o = t.getElementsByTagName(e);
                                        if ("*" === e) {
                                            for (; (n = o[i++]); ) 1 === n.nodeType && r.push(n);
                                            return r;
                                        }
                                        return o;
                                    }),
                              (r.find.CLASS =
                                  n.getElementsByClassName &&
                                  function (e, t) {
                                      if (void 0 !== t.getElementsByClassName && m) return t.getElementsByClassName(e);
                                  }),
                              (v = []),
                              (g = []),
                              (n.qsa = Z.test(h.querySelectorAll)) &&
                                  (ue(function (e) {
                                      var t;
                                      (f.appendChild(e).innerHTML = "<a id='" + w + "'></a><select id='" + w + "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                                          e.querySelectorAll("[msallowcapture^='']").length && g.push("[*^$]=" + N + "*(?:''|\"\")"),
                                          e.querySelectorAll("[selected]").length || g.push("\\[" + N + "*(?:value|" + I + ")"),
                                          e.querySelectorAll("[id~=" + w + "-]").length || g.push("~="),
                                          (t = h.createElement("input")).setAttribute("name", ""),
                                          e.appendChild(t),
                                          e.querySelectorAll("[name='']").length || g.push("\\[" + N + "*name" + N + "*=" + N + "*(?:''|\"\")"),
                                          e.querySelectorAll(":checked").length || g.push(":checked"),
                                          e.querySelectorAll("a#" + w + "+*").length || g.push(".#.+[+~]"),
                                          e.querySelectorAll("\\\f"),
                                          g.push("[\\r\\n\\f]");
                                  }),
                                  ue(function (e) {
                                      e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                                      var t = h.createElement("input");
                                      t.setAttribute("type", "hidden"),
                                          e.appendChild(t).setAttribute("name", "D"),
                                          e.querySelectorAll("[name=d]").length && g.push("name" + N + "*[*^$|!~]?="),
                                          2 !== e.querySelectorAll(":enabled").length && g.push(":enabled", ":disabled"),
                                          (f.appendChild(e).disabled = !0),
                                          2 !== e.querySelectorAll(":disabled").length && g.push(":enabled", ":disabled"),
                                          e.querySelectorAll("*,:x"),
                                          g.push(",.*:");
                                  })),
                              (n.matchesSelector = Z.test((y = f.matches || f.webkitMatchesSelector || f.mozMatchesSelector || f.oMatchesSelector || f.msMatchesSelector))) &&
                                  ue(function (e) {
                                      (n.disconnectedMatch = y.call(e, "*")), y.call(e, "[s!='']:x"), v.push("!=", F);
                                  }),
                              (g = g.length && new RegExp(g.join("|"))),
                              (v = v.length && new RegExp(v.join("|"))),
                              (t = Z.test(f.compareDocumentPosition)),
                              (b =
                                  t || Z.test(f.contains)
                                      ? function (e, t) {
                                            var n = 9 === e.nodeType ? e.documentElement : e,
                                                r = t && t.parentNode;
                                            return e === r || !(!r || 1 !== r.nodeType || !(n.contains ? n.contains(r) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r)));
                                        }
                                      : function (e, t) {
                                            if (t) for (; (t = t.parentNode); ) if (t === e) return !0;
                                            return !1;
                                        }),
                              (_ = t
                                  ? function (e, t) {
                                        if (e === t) return (d = !0), 0;
                                        var r = !e.compareDocumentPosition - !t.compareDocumentPosition;
                                        return (
                                            r ||
                                            (1 & (r = (e.ownerDocument || e) == (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || (!n.sortDetached && t.compareDocumentPosition(e) === r)
                                                ? e == h || (e.ownerDocument == x && b(x, e))
                                                    ? -1
                                                    : t == h || (t.ownerDocument == x && b(x, t))
                                                    ? 1
                                                    : u
                                                    ? P(u, e) - P(u, t)
                                                    : 0
                                                : 4 & r
                                                ? -1
                                                : 1)
                                        );
                                    }
                                  : function (e, t) {
                                        if (e === t) return (d = !0), 0;
                                        var n,
                                            r = 0,
                                            i = e.parentNode,
                                            o = t.parentNode,
                                            a = [e],
                                            s = [t];
                                        if (!i || !o) return e == h ? -1 : t == h ? 1 : i ? -1 : o ? 1 : u ? P(u, e) - P(u, t) : 0;
                                        if (i === o) return pe(e, t);
                                        for (n = e; (n = n.parentNode); ) a.unshift(n);
                                        for (n = t; (n = n.parentNode); ) s.unshift(n);
                                        for (; a[r] === s[r]; ) r++;
                                        return r ? pe(a[r], s[r]) : a[r] == x ? -1 : s[r] == x ? 1 : 0;
                                    }),
                              h)
                            : h;
                    }),
                    (se.matches = function (e, t) {
                        return se(e, null, null, t);
                    }),
                    (se.matchesSelector = function (e, t) {
                        if ((p(e), n.matchesSelector && m && !A[t + " "] && (!v || !v.test(t)) && (!g || !g.test(t))))
                            try {
                                var r = y.call(e, t);
                                if (r || n.disconnectedMatch || (e.document && 11 !== e.document.nodeType)) return r;
                            } catch (e) {
                                A(t, !0);
                            }
                        return se(t, h, null, [e]).length > 0;
                    }),
                    (se.contains = function (e, t) {
                        return (e.ownerDocument || e) != h && p(e), b(e, t);
                    }),
                    (se.attr = function (e, t) {
                        (e.ownerDocument || e) != h && p(e);
                        var i = r.attrHandle[t.toLowerCase()],
                            o = i && L.call(r.attrHandle, t.toLowerCase()) ? i(e, t, !m) : void 0;
                        return void 0 !== o ? o : n.attributes || !m ? e.getAttribute(t) : (o = e.getAttributeNode(t)) && o.specified ? o.value : null;
                    }),
                    (se.escape = function (e) {
                        return (e + "").replace(re, ie);
                    }),
                    (se.error = function (e) {
                        throw new Error("Syntax error, unrecognized expression: " + e);
                    }),
                    (se.uniqueSort = function (e) {
                        var t,
                            r = [],
                            i = 0,
                            o = 0;
                        if (((d = !n.detectDuplicates), (u = !n.sortStable && e.slice(0)), e.sort(_), d)) {
                            for (; (t = e[o++]); ) t === e[o] && (i = r.push(o));
                            for (; i--; ) e.splice(r[i], 1);
                        }
                        return (u = null), e;
                    }),
                    (i = se.getText = function (e) {
                        var t,
                            n = "",
                            r = 0,
                            o = e.nodeType;
                        if (o) {
                            if (1 === o || 9 === o || 11 === o) {
                                if ("string" == typeof e.textContent) return e.textContent;
                                for (e = e.firstChild; e; e = e.nextSibling) n += i(e);
                            } else if (3 === o || 4 === o) return e.nodeValue;
                        } else for (; (t = e[r++]); ) n += i(t);
                        return n;
                    }),
                    (r = se.selectors = {
                        cacheLength: 50,
                        createPseudo: ce,
                        match: Y,
                        attrHandle: {},
                        find: {},
                        relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } },
                        preFilter: {
                            ATTR: function (e) {
                                return (e[1] = e[1].replace(te, ne)), (e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne)), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
                            },
                            CHILD: function (e) {
                                return (
                                    (e[1] = e[1].toLowerCase()),
                                    "nth" === e[1].slice(0, 3) ? (e[3] || se.error(e[0]), (e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3]))), (e[5] = +(e[7] + e[8] || "odd" === e[3]))) : e[3] && se.error(e[0]),
                                    e
                                );
                            },
                            PSEUDO: function (e) {
                                var t,
                                    n = !e[6] && e[2];
                                return Y.CHILD.test(e[0])
                                    ? null
                                    : (e[3] ? (e[2] = e[4] || e[5] || "") : n && U.test(n) && (t = a(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))), e.slice(0, 3));
                            },
                        },
                        filter: {
                            TAG: function (e) {
                                var t = e.replace(te, ne).toLowerCase();
                                return "*" === e
                                    ? function () {
                                          return !0;
                                      }
                                    : function (e) {
                                          return e.nodeName && e.nodeName.toLowerCase() === t;
                                      };
                            },
                            CLASS: function (e) {
                                var t = S[e + " "];
                                return (
                                    t ||
                                    ((t = new RegExp("(^|" + N + ")" + e + "(" + N + "|$)")) &&
                                        S(e, function (e) {
                                            return t.test(("string" == typeof e.className && e.className) || (void 0 !== e.getAttribute && e.getAttribute("class")) || "");
                                        }))
                                );
                            },
                            ATTR: function (e, t, n) {
                                return function (r) {
                                    var i = se.attr(r, e);
                                    return null == i
                                        ? "!=" === t
                                        : !t ||
                                              ((i += ""),
                                              "=" === t
                                                  ? i === n
                                                  : "!=" === t
                                                  ? i !== n
                                                  : "^=" === t
                                                  ? n && 0 === i.indexOf(n)
                                                  : "*=" === t
                                                  ? n && i.indexOf(n) > -1
                                                  : "$=" === t
                                                  ? n && i.slice(-n.length) === n
                                                  : "~=" === t
                                                  ? (" " + i.replace(B, " ") + " ").indexOf(n) > -1
                                                  : "|=" === t && (i === n || i.slice(0, n.length + 1) === n + "-"));
                                };
                            },
                            CHILD: function (e, t, n, r, i) {
                                var o = "nth" !== e.slice(0, 3),
                                    a = "last" !== e.slice(-4),
                                    s = "of-type" === t;
                                return 1 === r && 0 === i
                                    ? function (e) {
                                          return !!e.parentNode;
                                      }
                                    : function (t, n, l) {
                                          var c,
                                              u,
                                              d,
                                              p,
                                              h,
                                              f,
                                              m = o !== a ? "nextSibling" : "previousSibling",
                                              g = t.parentNode,
                                              v = s && t.nodeName.toLowerCase(),
                                              y = !l && !s,
                                              b = !1;
                                          if (g) {
                                              if (o) {
                                                  for (; m; ) {
                                                      for (p = t; (p = p[m]); ) if (s ? p.nodeName.toLowerCase() === v : 1 === p.nodeType) return !1;
                                                      f = m = "only" === e && !f && "nextSibling";
                                                  }
                                                  return !0;
                                              }
                                              if (((f = [a ? g.firstChild : g.lastChild]), a && y)) {
                                                  for (
                                                      b = (h = (c = (u = (d = (p = g)[w] || (p[w] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[e] || [])[0] === E && c[1]) && c[2], p = h && g.childNodes[h];
                                                      (p = (++h && p && p[m]) || (b = h = 0) || f.pop());

                                                  )
                                                      if (1 === p.nodeType && ++b && p === t) {
                                                          u[e] = [E, h, b];
                                                          break;
                                                      }
                                              } else if ((y && (b = h = (c = (u = (d = (p = t)[w] || (p[w] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[e] || [])[0] === E && c[1]), !1 === b))
                                                  for (
                                                      ;
                                                      (p = (++h && p && p[m]) || (b = h = 0) || f.pop()) &&
                                                      ((s ? p.nodeName.toLowerCase() !== v : 1 !== p.nodeType) || !++b || (y && ((u = (d = p[w] || (p[w] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[e] = [E, b]), p !== t));

                                                  );
                                              return (b -= i) === r || (b % r == 0 && b / r >= 0);
                                          }
                                      };
                            },
                            PSEUDO: function (e, t) {
                                var n,
                                    i = r.pseudos[e] || r.setFilters[e.toLowerCase()] || se.error("unsupported pseudo: " + e);
                                return i[w]
                                    ? i(t)
                                    : i.length > 1
                                    ? ((n = [e, e, "", t]),
                                      r.setFilters.hasOwnProperty(e.toLowerCase())
                                          ? ce(function (e, n) {
                                                for (var r, o = i(e, t), a = o.length; a--; ) e[(r = P(e, o[a]))] = !(n[r] = o[a]);
                                            })
                                          : function (e) {
                                                return i(e, 0, n);
                                            })
                                    : i;
                            },
                        },
                        pseudos: {
                            not: ce(function (e) {
                                var t = [],
                                    n = [],
                                    r = s(e.replace(j, "$1"));
                                return r[w]
                                    ? ce(function (e, t, n, i) {
                                          for (var o, a = r(e, null, i, []), s = e.length; s--; ) (o = a[s]) && (e[s] = !(t[s] = o));
                                      })
                                    : function (e, i, o) {
                                          return (t[0] = e), r(t, null, o, n), (t[0] = null), !n.pop();
                                      };
                            }),
                            has: ce(function (e) {
                                return function (t) {
                                    return se(e, t).length > 0;
                                };
                            }),
                            contains: ce(function (e) {
                                return (
                                    (e = e.replace(te, ne)),
                                    function (t) {
                                        return (t.textContent || i(t)).indexOf(e) > -1;
                                    }
                                );
                            }),
                            lang: ce(function (e) {
                                return (
                                    G.test(e || "") || se.error("unsupported lang: " + e),
                                    (e = e.replace(te, ne).toLowerCase()),
                                    function (t) {
                                        var n;
                                        do {
                                            if ((n = m ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang"))) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-");
                                        } while ((t = t.parentNode) && 1 === t.nodeType);
                                        return !1;
                                    }
                                );
                            }),
                            target: function (t) {
                                var n = e.location && e.location.hash;
                                return n && n.slice(1) === t.id;
                            },
                            root: function (e) {
                                return e === f;
                            },
                            focus: function (e) {
                                return e === h.activeElement && (!h.hasFocus || h.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
                            },
                            enabled: me(!1),
                            disabled: me(!0),
                            checked: function (e) {
                                var t = e.nodeName.toLowerCase();
                                return ("input" === t && !!e.checked) || ("option" === t && !!e.selected);
                            },
                            selected: function (e) {
                                return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
                            },
                            empty: function (e) {
                                for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
                                return !0;
                            },
                            parent: function (e) {
                                return !r.pseudos.empty(e);
                            },
                            header: function (e) {
                                return J.test(e.nodeName);
                            },
                            input: function (e) {
                                return K.test(e.nodeName);
                            },
                            button: function (e) {
                                var t = e.nodeName.toLowerCase();
                                return ("input" === t && "button" === e.type) || "button" === t;
                            },
                            text: function (e) {
                                var t;
                                return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
                            },
                            first: ge(function () {
                                return [0];
                            }),
                            last: ge(function (e, t) {
                                return [t - 1];
                            }),
                            eq: ge(function (e, t, n) {
                                return [n < 0 ? n + t : n];
                            }),
                            even: ge(function (e, t) {
                                for (var n = 0; n < t; n += 2) e.push(n);
                                return e;
                            }),
                            odd: ge(function (e, t) {
                                for (var n = 1; n < t; n += 2) e.push(n);
                                return e;
                            }),
                            lt: ge(function (e, t, n) {
                                for (var r = n < 0 ? n + t : n > t ? t : n; --r >= 0; ) e.push(r);
                                return e;
                            }),
                            gt: ge(function (e, t, n) {
                                for (var r = n < 0 ? n + t : n; ++r < t; ) e.push(r);
                                return e;
                            }),
                        },
                    }),
                    (r.pseudos.nth = r.pseudos.eq),
                    { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
                        r.pseudos[t] = he(t);
                    for (t in { submit: !0, reset: !0 }) r.pseudos[t] = fe(t);
                    function ye() {}
                    function be(e) {
                        for (var t = 0, n = e.length, r = ""; t < n; t++) r += e[t].value;
                        return r;
                    }
                    function we(e, t, n) {
                        var r = t.dir,
                            i = t.next,
                            o = i || r,
                            a = n && "parentNode" === o,
                            s = C++;
                        return t.first
                            ? function (t, n, i) {
                                  for (; (t = t[r]); ) if (1 === t.nodeType || a) return e(t, n, i);
                                  return !1;
                              }
                            : function (t, n, l) {
                                  var c,
                                      u,
                                      d,
                                      p = [E, s];
                                  if (l) {
                                      for (; (t = t[r]); ) if ((1 === t.nodeType || a) && e(t, n, l)) return !0;
                                  } else
                                      for (; (t = t[r]); )
                                          if (1 === t.nodeType || a)
                                              if (((u = (d = t[w] || (t[w] = {}))[t.uniqueID] || (d[t.uniqueID] = {})), i && i === t.nodeName.toLowerCase())) t = t[r] || t;
                                              else {
                                                  if ((c = u[o]) && c[0] === E && c[1] === s) return (p[2] = c[2]);
                                                  if (((u[o] = p), (p[2] = e(t, n, l)))) return !0;
                                              }
                                  return !1;
                              };
                    }
                    function xe(e) {
                        return e.length > 1
                            ? function (t, n, r) {
                                  for (var i = e.length; i--; ) if (!e[i](t, n, r)) return !1;
                                  return !0;
                              }
                            : e[0];
                    }
                    function Ee(e, t, n, r, i) {
                        for (var o, a = [], s = 0, l = e.length, c = null != t; s < l; s++) (o = e[s]) && ((n && !n(o, r, i)) || (a.push(o), c && t.push(s)));
                        return a;
                    }
                    function Ce(e, t, n, r, i, o) {
                        return (
                            r && !r[w] && (r = Ce(r)),
                            i && !i[w] && (i = Ce(i, o)),
                            ce(function (o, a, s, l) {
                                var c,
                                    u,
                                    d,
                                    p = [],
                                    h = [],
                                    f = a.length,
                                    m =
                                        o ||
                                        (function (e, t, n) {
                                            for (var r = 0, i = t.length; r < i; r++) se(e, t[r], n);
                                            return n;
                                        })(t || "*", s.nodeType ? [s] : s, []),
                                    g = !e || (!o && t) ? m : Ee(m, p, e, s, l),
                                    v = n ? (i || (o ? e : f || r) ? [] : a) : g;
                                if ((n && n(g, v, s, l), r)) for (c = Ee(v, h), r(c, [], s, l), u = c.length; u--; ) (d = c[u]) && (v[h[u]] = !(g[h[u]] = d));
                                if (o) {
                                    if (i || e) {
                                        if (i) {
                                            for (c = [], u = v.length; u--; ) (d = v[u]) && c.push((g[u] = d));
                                            i(null, (v = []), c, l);
                                        }
                                        for (u = v.length; u--; ) (d = v[u]) && (c = i ? P(o, d) : p[u]) > -1 && (o[c] = !(a[c] = d));
                                    }
                                } else (v = Ee(v === a ? v.splice(f, v.length) : v)), i ? i(null, a, v, l) : q.apply(a, v);
                            })
                        );
                    }
                    function Se(e) {
                        for (
                            var t,
                                n,
                                i,
                                o = e.length,
                                a = r.relative[e[0].type],
                                s = a || r.relative[" "],
                                l = a ? 1 : 0,
                                u = we(
                                    function (e) {
                                        return e === t;
                                    },
                                    s,
                                    !0
                                ),
                                d = we(
                                    function (e) {
                                        return P(t, e) > -1;
                                    },
                                    s,
                                    !0
                                ),
                                p = [
                                    function (e, n, r) {
                                        var i = (!a && (r || n !== c)) || ((t = n).nodeType ? u(e, n, r) : d(e, n, r));
                                        return (t = null), i;
                                    },
                                ];
                            l < o;
                            l++
                        )
                            if ((n = r.relative[e[l].type])) p = [we(xe(p), n)];
                            else {
                                if ((n = r.filter[e[l].type].apply(null, e[l].matches))[w]) {
                                    for (i = ++l; i < o && !r.relative[e[i].type]; i++);
                                    return Ce(
                                        l > 1 && xe(p),
                                        l > 1 && be(e.slice(0, l - 1).concat({ value: " " === e[l - 2].type ? "*" : "" })).replace(j, "$1"),
                                        n,
                                        l < i && Se(e.slice(l, i)),
                                        i < o && Se((e = e.slice(i))),
                                        i < o && be(e)
                                    );
                                }
                                p.push(n);
                            }
                        return xe(p);
                    }
                    return (
                        (ye.prototype = r.filters = r.pseudos),
                        (r.setFilters = new ye()),
                        (a = se.tokenize = function (e, t) {
                            var n,
                                i,
                                o,
                                a,
                                s,
                                l,
                                c,
                                u = T[e + " "];
                            if (u) return t ? 0 : u.slice(0);
                            for (s = e, l = [], c = r.preFilter; s; ) {
                                for (a in ((n && !(i = H.exec(s))) || (i && (s = s.slice(i[0].length) || s), l.push((o = []))),
                                (n = !1),
                                (i = V.exec(s)) && ((n = i.shift()), o.push({ value: n, type: i[0].replace(j, " ") }), (s = s.slice(n.length))),
                                r.filter))
                                    !(i = Y[a].exec(s)) || (c[a] && !(i = c[a](i))) || ((n = i.shift()), o.push({ value: n, type: a, matches: i }), (s = s.slice(n.length)));
                                if (!n) break;
                            }
                            return t ? s.length : s ? se.error(e) : T(e, l).slice(0);
                        }),
                        (s = se.compile = function (e, t) {
                            var n,
                                i = [],
                                o = [],
                                s = k[e + " "];
                            if (!s) {
                                for (t || (t = a(e)), n = t.length; n--; ) (s = Se(t[n]))[w] ? i.push(s) : o.push(s);
                                (s = k(
                                    e,
                                    (function (e, t) {
                                        var n = t.length > 0,
                                            i = e.length > 0,
                                            o = function (o, a, s, l, u) {
                                                var d,
                                                    f,
                                                    g,
                                                    v = 0,
                                                    y = "0",
                                                    b = o && [],
                                                    w = [],
                                                    x = c,
                                                    C = o || (i && r.find.TAG("*", u)),
                                                    S = (E += null == x ? 1 : Math.random() || 0.1),
                                                    T = C.length;
                                                for (u && (c = a == h || a || u); y !== T && null != (d = C[y]); y++) {
                                                    if (i && d) {
                                                        for (f = 0, a || d.ownerDocument == h || (p(d), (s = !m)); (g = e[f++]); )
                                                            if (g(d, a || h, s)) {
                                                                l.push(d);
                                                                break;
                                                            }
                                                        u && (E = S);
                                                    }
                                                    n && ((d = !g && d) && v--, o && b.push(d));
                                                }
                                                if (((v += y), n && y !== v)) {
                                                    for (f = 0; (g = t[f++]); ) g(b, w, a, s);
                                                    if (o) {
                                                        if (v > 0) for (; y--; ) b[y] || w[y] || (w[y] = D.call(l));
                                                        w = Ee(w);
                                                    }
                                                    q.apply(l, w), u && !o && w.length > 0 && v + t.length > 1 && se.uniqueSort(l);
                                                }
                                                return u && ((E = S), (c = x)), b;
                                            };
                                        return n ? ce(o) : o;
                                    })(o, i)
                                )),
                                    (s.selector = e);
                            }
                            return s;
                        }),
                        (l = se.select = function (e, t, n, i) {
                            var o,
                                l,
                                c,
                                u,
                                d,
                                p = "function" == typeof e && e,
                                h = !i && a((e = p.selector || e));
                            if (((n = n || []), 1 === h.length)) {
                                if ((l = h[0] = h[0].slice(0)).length > 2 && "ID" === (c = l[0]).type && 9 === t.nodeType && m && r.relative[l[1].type]) {
                                    if (!(t = (r.find.ID(c.matches[0].replace(te, ne), t) || [])[0])) return n;
                                    p && (t = t.parentNode), (e = e.slice(l.shift().value.length));
                                }
                                for (o = Y.needsContext.test(e) ? 0 : l.length; o-- && ((c = l[o]), !r.relative[(u = c.type)]); )
                                    if ((d = r.find[u]) && (i = d(c.matches[0].replace(te, ne), (ee.test(l[0].type) && ve(t.parentNode)) || t))) {
                                        if ((l.splice(o, 1), !(e = i.length && be(l)))) return q.apply(n, i), n;
                                        break;
                                    }
                            }
                            return (p || s(e, h))(i, t, !m, n, !t || (ee.test(e) && ve(t.parentNode)) || t), n;
                        }),
                        (n.sortStable = w.split("").sort(_).join("") === w),
                        (n.detectDuplicates = !!d),
                        p(),
                        (n.sortDetached = ue(function (e) {
                            return 1 & e.compareDocumentPosition(h.createElement("fieldset"));
                        })),
                        ue(function (e) {
                            return (e.innerHTML = "<a href='#'></a>"), "#" === e.firstChild.getAttribute("href");
                        }) ||
                            de("type|href|height|width", function (e, t, n) {
                                if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
                            }),
                        (n.attributes &&
                            ue(function (e) {
                                return (e.innerHTML = "<input/>"), e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
                            })) ||
                            de("value", function (e, t, n) {
                                if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
                            }),
                        ue(function (e) {
                            return null == e.getAttribute("disabled");
                        }) ||
                            de(I, function (e, t, n) {
                                var r;
                                if (!n) return !0 === e[t] ? t.toLowerCase() : (r = e.getAttributeNode(t)) && r.specified ? r.value : null;
                            }),
                        se
                    );
                })(n);
            (S.find = k), (S.expr = k.selectors), (S.expr[":"] = S.expr.pseudos), (S.uniqueSort = S.unique = k.uniqueSort), (S.text = k.getText), (S.isXMLDoc = k.isXML), (S.contains = k.contains), (S.escapeSelector = k.escape);
            var A = function (e, t, n) {
                    for (var r = [], i = void 0 !== n; (e = e[t]) && 9 !== e.nodeType; )
                        if (1 === e.nodeType) {
                            if (i && S(e).is(n)) break;
                            r.push(e);
                        }
                    return r;
                },
                _ = function (e, t) {
                    for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
                    return n;
                },
                L = S.expr.match.needsContext;
            function $(e, t) {
                return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
            }
            var D = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
            function O(e, t, n) {
                return v(t)
                    ? S.grep(e, function (e, r) {
                          return !!t.call(e, r, e) !== n;
                      })
                    : t.nodeType
                    ? S.grep(e, function (e) {
                          return (e === t) !== n;
                      })
                    : "string" != typeof t
                    ? S.grep(e, function (e) {
                          return u.call(t, e) > -1 !== n;
                      })
                    : S.filter(t, e, n);
            }
            (S.filter = function (e, t, n) {
                var r = t[0];
                return (
                    n && (e = ":not(" + e + ")"),
                    1 === t.length && 1 === r.nodeType
                        ? S.find.matchesSelector(r, e)
                            ? [r]
                            : []
                        : S.find.matches(
                              e,
                              S.grep(t, function (e) {
                                  return 1 === e.nodeType;
                              })
                          )
                );
            }),
                S.fn.extend({
                    find: function (e) {
                        var t,
                            n,
                            r = this.length,
                            i = this;
                        if ("string" != typeof e)
                            return this.pushStack(
                                S(e).filter(function () {
                                    for (t = 0; t < r; t++) if (S.contains(i[t], this)) return !0;
                                })
                            );
                        for (n = this.pushStack([]), t = 0; t < r; t++) S.find(e, i[t], n);
                        return r > 1 ? S.uniqueSort(n) : n;
                    },
                    filter: function (e) {
                        return this.pushStack(O(this, e || [], !1));
                    },
                    not: function (e) {
                        return this.pushStack(O(this, e || [], !0));
                    },
                    is: function (e) {
                        return !!O(this, "string" == typeof e && L.test(e) ? S(e) : e || [], !1).length;
                    },
                });
            var q,
                M = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
            ((S.fn.init = function (e, t, n) {
                var r, i;
                if (!e) return this;
                if (((n = n || q), "string" == typeof e)) {
                    if (!(r = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : M.exec(e)) || (!r[1] && t)) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
                    if (r[1]) {
                        if (((t = t instanceof S ? t[0] : t), S.merge(this, S.parseHTML(r[1], t && t.nodeType ? t.ownerDocument || t : b, !0)), D.test(r[1]) && S.isPlainObject(t)))
                            for (r in t) v(this[r]) ? this[r](t[r]) : this.attr(r, t[r]);
                        return this;
                    }
                    return (i = b.getElementById(r[2])) && ((this[0] = i), (this.length = 1)), this;
                }
                return e.nodeType ? ((this[0] = e), (this.length = 1), this) : v(e) ? (void 0 !== n.ready ? n.ready(e) : e(S)) : S.makeArray(e, this);
            }).prototype = S.fn),
                (q = S(b));
            var P = /^(?:parents|prev(?:Until|All))/,
                I = { children: !0, contents: !0, next: !0, prev: !0 };
            function N(e, t) {
                for (; (e = e[t]) && 1 !== e.nodeType; );
                return e;
            }
            S.fn.extend({
                has: function (e) {
                    var t = S(e, this),
                        n = t.length;
                    return this.filter(function () {
                        for (var e = 0; e < n; e++) if (S.contains(this, t[e])) return !0;
                    });
                },
                closest: function (e, t) {
                    var n,
                        r = 0,
                        i = this.length,
                        o = [],
                        a = "string" != typeof e && S(e);
                    if (!L.test(e))
                        for (; r < i; r++)
                            for (n = this[r]; n && n !== t; n = n.parentNode)
                                if (n.nodeType < 11 && (a ? a.index(n) > -1 : 1 === n.nodeType && S.find.matchesSelector(n, e))) {
                                    o.push(n);
                                    break;
                                }
                    return this.pushStack(o.length > 1 ? S.uniqueSort(o) : o);
                },
                index: function (e) {
                    return e ? ("string" == typeof e ? u.call(S(e), this[0]) : u.call(this, e.jquery ? e[0] : e)) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
                },
                add: function (e, t) {
                    return this.pushStack(S.uniqueSort(S.merge(this.get(), S(e, t))));
                },
                addBack: function (e) {
                    return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
                },
            }),
                S.each(
                    {
                        parent: function (e) {
                            var t = e.parentNode;
                            return t && 11 !== t.nodeType ? t : null;
                        },
                        parents: function (e) {
                            return A(e, "parentNode");
                        },
                        parentsUntil: function (e, t, n) {
                            return A(e, "parentNode", n);
                        },
                        next: function (e) {
                            return N(e, "nextSibling");
                        },
                        prev: function (e) {
                            return N(e, "previousSibling");
                        },
                        nextAll: function (e) {
                            return A(e, "nextSibling");
                        },
                        prevAll: function (e) {
                            return A(e, "previousSibling");
                        },
                        nextUntil: function (e, t, n) {
                            return A(e, "nextSibling", n);
                        },
                        prevUntil: function (e, t, n) {
                            return A(e, "previousSibling", n);
                        },
                        siblings: function (e) {
                            return _((e.parentNode || {}).firstChild, e);
                        },
                        children: function (e) {
                            return _(e.firstChild);
                        },
                        contents: function (e) {
                            return null != e.contentDocument && a(e.contentDocument) ? e.contentDocument : ($(e, "template") && (e = e.content || e), S.merge([], e.childNodes));
                        },
                    },
                    function (e, t) {
                        S.fn[e] = function (n, r) {
                            var i = S.map(this, t, n);
                            return "Until" !== e.slice(-5) && (r = n), r && "string" == typeof r && (i = S.filter(r, i)), this.length > 1 && (I[e] || S.uniqueSort(i), P.test(e) && i.reverse()), this.pushStack(i);
                        };
                    }
                );
            var z = /[^\x20\t\r\n\f]+/g;
            function R(e) {
                return e;
            }
            function F(e) {
                throw e;
            }
            function B(e, t, n, r) {
                var i;
                try {
                    e && v((i = e.promise)) ? i.call(e).done(t).fail(n) : e && v((i = e.then)) ? i.call(e, t, n) : t.apply(void 0, [e].slice(r));
                } catch (e) {
                    n.apply(void 0, [e]);
                }
            }
            (S.Callbacks = function (e) {
                e =
                    "string" == typeof e
                        ? (function (e) {
                              var t = {};
                              return (
                                  S.each(e.match(z) || [], function (e, n) {
                                      t[n] = !0;
                                  }),
                                  t
                              );
                          })(e)
                        : S.extend({}, e);
                var t,
                    n,
                    r,
                    i,
                    o = [],
                    a = [],
                    s = -1,
                    l = function () {
                        for (i = i || e.once, r = t = !0; a.length; s = -1) for (n = a.shift(); ++s < o.length; ) !1 === o[s].apply(n[0], n[1]) && e.stopOnFalse && ((s = o.length), (n = !1));
                        e.memory || (n = !1), (t = !1), i && (o = n ? [] : "");
                    },
                    c = {
                        add: function () {
                            return (
                                o &&
                                    (n && !t && ((s = o.length - 1), a.push(n)),
                                    (function t(n) {
                                        S.each(n, function (n, r) {
                                            v(r) ? (e.unique && c.has(r)) || o.push(r) : r && r.length && "string" !== E(r) && t(r);
                                        });
                                    })(arguments),
                                    n && !t && l()),
                                this
                            );
                        },
                        remove: function () {
                            return (
                                S.each(arguments, function (e, t) {
                                    for (var n; (n = S.inArray(t, o, n)) > -1; ) o.splice(n, 1), n <= s && s--;
                                }),
                                this
                            );
                        },
                        has: function (e) {
                            return e ? S.inArray(e, o) > -1 : o.length > 0;
                        },
                        empty: function () {
                            return o && (o = []), this;
                        },
                        disable: function () {
                            return (i = a = []), (o = n = ""), this;
                        },
                        disabled: function () {
                            return !o;
                        },
                        lock: function () {
                            return (i = a = []), n || t || (o = n = ""), this;
                        },
                        locked: function () {
                            return !!i;
                        },
                        fireWith: function (e, n) {
                            return i || ((n = [e, (n = n || []).slice ? n.slice() : n]), a.push(n), t || l()), this;
                        },
                        fire: function () {
                            return c.fireWith(this, arguments), this;
                        },
                        fired: function () {
                            return !!r;
                        },
                    };
                return c;
            }),
                S.extend({
                    Deferred: function (e) {
                        var t = [
                                ["notify", "progress", S.Callbacks("memory"), S.Callbacks("memory"), 2],
                                ["resolve", "done", S.Callbacks("once memory"), S.Callbacks("once memory"), 0, "resolved"],
                                ["reject", "fail", S.Callbacks("once memory"), S.Callbacks("once memory"), 1, "rejected"],
                            ],
                            r = "pending",
                            i = {
                                state: function () {
                                    return r;
                                },
                                always: function () {
                                    return o.done(arguments).fail(arguments), this;
                                },
                                catch: function (e) {
                                    return i.then(null, e);
                                },
                                pipe: function () {
                                    var e = arguments;
                                    return S.Deferred(function (n) {
                                        S.each(t, function (t, r) {
                                            var i = v(e[r[4]]) && e[r[4]];
                                            o[r[1]](function () {
                                                var e = i && i.apply(this, arguments);
                                                e && v(e.promise) ? e.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[r[0] + "With"](this, i ? [e] : arguments);
                                            });
                                        }),
                                            (e = null);
                                    }).promise();
                                },
                                then: function (e, r, i) {
                                    var o = 0;
                                    function a(e, t, r, i) {
                                        return function () {
                                            var s = this,
                                                l = arguments,
                                                c = function () {
                                                    var n, c;
                                                    if (!(e < o)) {
                                                        if ((n = r.apply(s, l)) === t.promise()) throw new TypeError("Thenable self-resolution");
                                                        (c = n && ("object" == typeof n || "function" == typeof n) && n.then),
                                                            v(c)
                                                                ? i
                                                                    ? c.call(n, a(o, t, R, i), a(o, t, F, i))
                                                                    : (o++, c.call(n, a(o, t, R, i), a(o, t, F, i), a(o, t, R, t.notifyWith)))
                                                                : (r !== R && ((s = void 0), (l = [n])), (i || t.resolveWith)(s, l));
                                                    }
                                                },
                                                u = i
                                                    ? c
                                                    : function () {
                                                          try {
                                                              c();
                                                          } catch (n) {
                                                              S.Deferred.exceptionHook && S.Deferred.exceptionHook(n, u.stackTrace), e + 1 >= o && (r !== F && ((s = void 0), (l = [n])), t.rejectWith(s, l));
                                                          }
                                                      };
                                            e ? u() : (S.Deferred.getStackHook && (u.stackTrace = S.Deferred.getStackHook()), n.setTimeout(u));
                                        };
                                    }
                                    return S.Deferred(function (n) {
                                        t[0][3].add(a(0, n, v(i) ? i : R, n.notifyWith)), t[1][3].add(a(0, n, v(e) ? e : R)), t[2][3].add(a(0, n, v(r) ? r : F));
                                    }).promise();
                                },
                                promise: function (e) {
                                    return null != e ? S.extend(e, i) : i;
                                },
                            },
                            o = {};
                        return (
                            S.each(t, function (e, n) {
                                var a = n[2],
                                    s = n[5];
                                (i[n[1]] = a.add),
                                    s &&
                                        a.add(
                                            function () {
                                                r = s;
                                            },
                                            t[3 - e][2].disable,
                                            t[3 - e][3].disable,
                                            t[0][2].lock,
                                            t[0][3].lock
                                        ),
                                    a.add(n[3].fire),
                                    (o[n[0]] = function () {
                                        return o[n[0] + "With"](this === o ? void 0 : this, arguments), this;
                                    }),
                                    (o[n[0] + "With"] = a.fireWith);
                            }),
                            i.promise(o),
                            e && e.call(o, o),
                            o
                        );
                    },
                    when: function (e) {
                        var t = arguments.length,
                            n = t,
                            r = Array(n),
                            i = s.call(arguments),
                            o = S.Deferred(),
                            a = function (e) {
                                return function (n) {
                                    (r[e] = this), (i[e] = arguments.length > 1 ? s.call(arguments) : n), --t || o.resolveWith(r, i);
                                };
                            };
                        if (t <= 1 && (B(e, o.done(a(n)).resolve, o.reject, !t), "pending" === o.state() || v(i[n] && i[n].then))) return o.then();
                        for (; n--; ) B(i[n], a(n), o.reject);
                        return o.promise();
                    },
                });
            var j = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
            (S.Deferred.exceptionHook = function (e, t) {
                n.console && n.console.warn && e && j.test(e.name) && n.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t);
            }),
                (S.readyException = function (e) {
                    n.setTimeout(function () {
                        throw e;
                    });
                });
            var H = S.Deferred();
            function V() {
                b.removeEventListener("DOMContentLoaded", V), n.removeEventListener("load", V), S.ready();
            }
            (S.fn.ready = function (e) {
                return (
                    H.then(e).catch(function (e) {
                        S.readyException(e);
                    }),
                    this
                );
            }),
                S.extend({
                    isReady: !1,
                    readyWait: 1,
                    ready: function (e) {
                        (!0 === e ? --S.readyWait : S.isReady) || ((S.isReady = !0), (!0 !== e && --S.readyWait > 0) || H.resolveWith(b, [S]));
                    },
                }),
                (S.ready.then = H.then),
                "complete" === b.readyState || ("loading" !== b.readyState && !b.documentElement.doScroll) ? n.setTimeout(S.ready) : (b.addEventListener("DOMContentLoaded", V), n.addEventListener("load", V));
            var W = function (e, t, n, r, i, o, a) {
                    var s = 0,
                        l = e.length,
                        c = null == n;
                    if ("object" === E(n)) for (s in ((i = !0), n)) W(e, t, s, n[s], !0, o, a);
                    else if (
                        void 0 !== r &&
                        ((i = !0),
                        v(r) || (a = !0),
                        c &&
                            (a
                                ? (t.call(e, r), (t = null))
                                : ((c = t),
                                  (t = function (e, t, n) {
                                      return c.call(S(e), n);
                                  }))),
                        t)
                    )
                        for (; s < l; s++) t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)));
                    return i ? e : c ? t.call(e) : l ? t(e[0], n) : o;
                },
                U = /^-ms-/,
                G = /-([a-z])/g;
            function Y(e, t) {
                return t.toUpperCase();
            }
            function X(e) {
                return e.replace(U, "ms-").replace(G, Y);
            }
            var K = function (e) {
                return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
            };
            function J() {
                this.expando = S.expando + J.uid++;
            }
            (J.uid = 1),
                (J.prototype = {
                    cache: function (e) {
                        var t = e[this.expando];
                        return t || ((t = {}), K(e) && (e.nodeType ? (e[this.expando] = t) : Object.defineProperty(e, this.expando, { value: t, configurable: !0 }))), t;
                    },
                    set: function (e, t, n) {
                        var r,
                            i = this.cache(e);
                        if ("string" == typeof t) i[X(t)] = n;
                        else for (r in t) i[X(r)] = t[r];
                        return i;
                    },
                    get: function (e, t) {
                        return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][X(t)];
                    },
                    access: function (e, t, n) {
                        return void 0 === t || (t && "string" == typeof t && void 0 === n) ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t);
                    },
                    remove: function (e, t) {
                        var n,
                            r = e[this.expando];
                        if (void 0 !== r) {
                            if (void 0 !== t) {
                                n = (t = Array.isArray(t) ? t.map(X) : (t = X(t)) in r ? [t] : t.match(z) || []).length;
                                for (; n--; ) delete r[t[n]];
                            }
                            (void 0 === t || S.isEmptyObject(r)) && (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
                        }
                    },
                    hasData: function (e) {
                        var t = e[this.expando];
                        return void 0 !== t && !S.isEmptyObject(t);
                    },
                });
            var Z = new J(),
                Q = new J(),
                ee = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
                te = /[A-Z]/g;
            function ne(e, t, n) {
                var r;
                if (void 0 === n && 1 === e.nodeType)
                    if (((r = "data-" + t.replace(te, "-$&").toLowerCase()), "string" == typeof (n = e.getAttribute(r)))) {
                        try {
                            n = (function (e) {
                                return "true" === e || ("false" !== e && ("null" === e ? null : e === +e + "" ? +e : ee.test(e) ? JSON.parse(e) : e));
                            })(n);
                        } catch (e) {}
                        Q.set(e, t, n);
                    } else n = void 0;
                return n;
            }
            S.extend({
                hasData: function (e) {
                    return Q.hasData(e) || Z.hasData(e);
                },
                data: function (e, t, n) {
                    return Q.access(e, t, n);
                },
                removeData: function (e, t) {
                    Q.remove(e, t);
                },
                _data: function (e, t, n) {
                    return Z.access(e, t, n);
                },
                _removeData: function (e, t) {
                    Z.remove(e, t);
                },
            }),
                S.fn.extend({
                    data: function (e, t) {
                        var n,
                            r,
                            i,
                            o = this[0],
                            a = o && o.attributes;
                        if (void 0 === e) {
                            if (this.length && ((i = Q.get(o)), 1 === o.nodeType && !Z.get(o, "hasDataAttrs"))) {
                                for (n = a.length; n--; ) a[n] && 0 === (r = a[n].name).indexOf("data-") && ((r = X(r.slice(5))), ne(o, r, i[r]));
                                Z.set(o, "hasDataAttrs", !0);
                            }
                            return i;
                        }
                        return "object" == typeof e
                            ? this.each(function () {
                                  Q.set(this, e);
                              })
                            : W(
                                  this,
                                  function (t) {
                                      var n;
                                      if (o && void 0 === t) return void 0 !== (n = Q.get(o, e)) || void 0 !== (n = ne(o, e)) ? n : void 0;
                                      this.each(function () {
                                          Q.set(this, e, t);
                                      });
                                  },
                                  null,
                                  t,
                                  arguments.length > 1,
                                  null,
                                  !0
                              );
                    },
                    removeData: function (e) {
                        return this.each(function () {
                            Q.remove(this, e);
                        });
                    },
                }),
                S.extend({
                    queue: function (e, t, n) {
                        var r;
                        if (e) return (t = (t || "fx") + "queue"), (r = Z.get(e, t)), n && (!r || Array.isArray(n) ? (r = Z.access(e, t, S.makeArray(n))) : r.push(n)), r || [];
                    },
                    dequeue: function (e, t) {
                        t = t || "fx";
                        var n = S.queue(e, t),
                            r = n.length,
                            i = n.shift(),
                            o = S._queueHooks(e, t);
                        "inprogress" === i && ((i = n.shift()), r--),
                            i &&
                                ("fx" === t && n.unshift("inprogress"),
                                delete o.stop,
                                i.call(
                                    e,
                                    function () {
                                        S.dequeue(e, t);
                                    },
                                    o
                                )),
                            !r && o && o.empty.fire();
                    },
                    _queueHooks: function (e, t) {
                        var n = t + "queueHooks";
                        return (
                            Z.get(e, n) ||
                            Z.access(e, n, {
                                empty: S.Callbacks("once memory").add(function () {
                                    Z.remove(e, [t + "queue", n]);
                                }),
                            })
                        );
                    },
                }),
                S.fn.extend({
                    queue: function (e, t) {
                        var n = 2;
                        return (
                            "string" != typeof e && ((t = e), (e = "fx"), n--),
                            arguments.length < n
                                ? S.queue(this[0], e)
                                : void 0 === t
                                ? this
                                : this.each(function () {
                                      var n = S.queue(this, e, t);
                                      S._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && S.dequeue(this, e);
                                  })
                        );
                    },
                    dequeue: function (e) {
                        return this.each(function () {
                            S.dequeue(this, e);
                        });
                    },
                    clearQueue: function (e) {
                        return this.queue(e || "fx", []);
                    },
                    promise: function (e, t) {
                        var n,
                            r = 1,
                            i = S.Deferred(),
                            o = this,
                            a = this.length,
                            s = function () {
                                --r || i.resolveWith(o, [o]);
                            };
                        for ("string" != typeof e && ((t = e), (e = void 0)), e = e || "fx"; a--; ) (n = Z.get(o[a], e + "queueHooks")) && n.empty && (r++, n.empty.add(s));
                        return s(), i.promise(t);
                    },
                });
            var re = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
                ie = new RegExp("^(?:([+-])=|)(" + re + ")([a-z%]*)$", "i"),
                oe = ["Top", "Right", "Bottom", "Left"],
                ae = b.documentElement,
                se = function (e) {
                    return S.contains(e.ownerDocument, e);
                },
                le = { composed: !0 };
            ae.getRootNode &&
                (se = function (e) {
                    return S.contains(e.ownerDocument, e) || e.getRootNode(le) === e.ownerDocument;
                });
            var ce = function (e, t) {
                return "none" === (e = t || e).style.display || ("" === e.style.display && se(e) && "none" === S.css(e, "display"));
            };
            function ue(e, t, n, r) {
                var i,
                    o,
                    a = 20,
                    s = r
                        ? function () {
                              return r.cur();
                          }
                        : function () {
                              return S.css(e, t, "");
                          },
                    l = s(),
                    c = (n && n[3]) || (S.cssNumber[t] ? "" : "px"),
                    u = e.nodeType && (S.cssNumber[t] || ("px" !== c && +l)) && ie.exec(S.css(e, t));
                if (u && u[3] !== c) {
                    for (l /= 2, c = c || u[3], u = +l || 1; a--; ) S.style(e, t, u + c), (1 - o) * (1 - (o = s() / l || 0.5)) <= 0 && (a = 0), (u /= o);
                    (u *= 2), S.style(e, t, u + c), (n = n || []);
                }
                return n && ((u = +u || +l || 0), (i = n[1] ? u + (n[1] + 1) * n[2] : +n[2]), r && ((r.unit = c), (r.start = u), (r.end = i))), i;
            }
            var de = {};
            function pe(e) {
                var t,
                    n = e.ownerDocument,
                    r = e.nodeName,
                    i = de[r];
                return i || ((t = n.body.appendChild(n.createElement(r))), (i = S.css(t, "display")), t.parentNode.removeChild(t), "none" === i && (i = "block"), (de[r] = i), i);
            }
            function he(e, t) {
                for (var n, r, i = [], o = 0, a = e.length; o < a; o++)
                    (r = e[o]).style &&
                        ((n = r.style.display),
                        t ? ("none" === n && ((i[o] = Z.get(r, "display") || null), i[o] || (r.style.display = "")), "" === r.style.display && ce(r) && (i[o] = pe(r))) : "none" !== n && ((i[o] = "none"), Z.set(r, "display", n)));
                for (o = 0; o < a; o++) null != i[o] && (e[o].style.display = i[o]);
                return e;
            }
            S.fn.extend({
                show: function () {
                    return he(this, !0);
                },
                hide: function () {
                    return he(this);
                },
                toggle: function (e) {
                    return "boolean" == typeof e
                        ? e
                            ? this.show()
                            : this.hide()
                        : this.each(function () {
                              ce(this) ? S(this).show() : S(this).hide();
                          });
                },
            });
            var fe,
                me,
                ge = /^(?:checkbox|radio)$/i,
                ve = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
                ye = /^$|^module$|\/(?:java|ecma)script/i;
            (fe = b.createDocumentFragment().appendChild(b.createElement("div"))),
                (me = b.createElement("input")).setAttribute("type", "radio"),
                me.setAttribute("checked", "checked"),
                me.setAttribute("name", "t"),
                fe.appendChild(me),
                (g.checkClone = fe.cloneNode(!0).cloneNode(!0).lastChild.checked),
                (fe.innerHTML = "<textarea>x</textarea>"),
                (g.noCloneChecked = !!fe.cloneNode(!0).lastChild.defaultValue),
                (fe.innerHTML = "<option></option>"),
                (g.option = !!fe.lastChild);
            var be = { thead: [1, "<table>", "</table>"], col: [2, "<table><colgroup>", "</colgroup></table>"], tr: [2, "<table><tbody>", "</tbody></table>"], td: [3, "<table><tbody><tr>", "</tr></tbody></table>"], _default: [0, "", ""] };
            function we(e, t) {
                var n;
                return (n = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : []), void 0 === t || (t && $(e, t)) ? S.merge([e], n) : n;
            }
            function xe(e, t) {
                for (var n = 0, r = e.length; n < r; n++) Z.set(e[n], "globalEval", !t || Z.get(t[n], "globalEval"));
            }
            (be.tbody = be.tfoot = be.colgroup = be.caption = be.thead), (be.th = be.td), g.option || (be.optgroup = be.option = [1, "<select multiple='multiple'>", "</select>"]);
            var Ee = /<|&#?\w+;/;
            function Ce(e, t, n, r, i) {
                for (var o, a, s, l, c, u, d = t.createDocumentFragment(), p = [], h = 0, f = e.length; h < f; h++)
                    if ((o = e[h]) || 0 === o)
                        if ("object" === E(o)) S.merge(p, o.nodeType ? [o] : o);
                        else if (Ee.test(o)) {
                            for (a = a || d.appendChild(t.createElement("div")), s = (ve.exec(o) || ["", ""])[1].toLowerCase(), l = be[s] || be._default, a.innerHTML = l[1] + S.htmlPrefilter(o) + l[2], u = l[0]; u--; ) a = a.lastChild;
                            S.merge(p, a.childNodes), ((a = d.firstChild).textContent = "");
                        } else p.push(t.createTextNode(o));
                for (d.textContent = "", h = 0; (o = p[h++]); )
                    if (r && S.inArray(o, r) > -1) i && i.push(o);
                    else if (((c = se(o)), (a = we(d.appendChild(o), "script")), c && xe(a), n)) for (u = 0; (o = a[u++]); ) ye.test(o.type || "") && n.push(o);
                return d;
            }
            var Se = /^([^.]*)(?:\.(.+)|)/;
            function Te() {
                return !0;
            }
            function ke() {
                return !1;
            }
            function Ae(e, t) {
                return (
                    (e ===
                        (function () {
                            try {
                                return b.activeElement;
                            } catch (e) {}
                        })()) ==
                    ("focus" === t)
                );
            }
            function _e(e, t, n, r, i, o) {
                var a, s;
                if ("object" == typeof t) {
                    for (s in ("string" != typeof n && ((r = r || n), (n = void 0)), t)) _e(e, s, n, r, t[s], o);
                    return e;
                }
                if ((null == r && null == i ? ((i = n), (r = n = void 0)) : null == i && ("string" == typeof n ? ((i = r), (r = void 0)) : ((i = r), (r = n), (n = void 0))), !1 === i)) i = ke;
                else if (!i) return e;
                return (
                    1 === o &&
                        ((a = i),
                        (i = function (e) {
                            return S().off(e), a.apply(this, arguments);
                        }),
                        (i.guid = a.guid || (a.guid = S.guid++))),
                    e.each(function () {
                        S.event.add(this, t, i, r, n);
                    })
                );
            }
            function Le(e, t, n) {
                n
                    ? (Z.set(e, t, !1),
                      S.event.add(e, t, {
                          namespace: !1,
                          handler: function (e) {
                              var r,
                                  i,
                                  o = Z.get(this, t);
                              if (1 & e.isTrigger && this[t]) {
                                  if (o.length) (S.event.special[t] || {}).delegateType && e.stopPropagation();
                                  else if (((o = s.call(arguments)), Z.set(this, t, o), (r = n(this, t)), this[t](), o !== (i = Z.get(this, t)) || r ? Z.set(this, t, !1) : (i = {}), o !== i))
                                      return e.stopImmediatePropagation(), e.preventDefault(), i && i.value;
                              } else o.length && (Z.set(this, t, { value: S.event.trigger(S.extend(o[0], S.Event.prototype), o.slice(1), this) }), e.stopImmediatePropagation());
                          },
                      }))
                    : void 0 === Z.get(e, t) && S.event.add(e, t, Te);
            }
            (S.event = {
                global: {},
                add: function (e, t, n, r, i) {
                    var o,
                        a,
                        s,
                        l,
                        c,
                        u,
                        d,
                        p,
                        h,
                        f,
                        m,
                        g = Z.get(e);
                    if (K(e))
                        for (
                            n.handler && ((n = (o = n).handler), (i = o.selector)),
                                i && S.find.matchesSelector(ae, i),
                                n.guid || (n.guid = S.guid++),
                                (l = g.events) || (l = g.events = Object.create(null)),
                                (a = g.handle) ||
                                    (a = g.handle = function (t) {
                                        return void 0 !== S && S.event.triggered !== t.type ? S.event.dispatch.apply(e, arguments) : void 0;
                                    }),
                                c = (t = (t || "").match(z) || [""]).length;
                            c--;

                        )
                            (h = m = (s = Se.exec(t[c]) || [])[1]),
                                (f = (s[2] || "").split(".").sort()),
                                h &&
                                    ((d = S.event.special[h] || {}),
                                    (h = (i ? d.delegateType : d.bindType) || h),
                                    (d = S.event.special[h] || {}),
                                    (u = S.extend({ type: h, origType: m, data: r, handler: n, guid: n.guid, selector: i, needsContext: i && S.expr.match.needsContext.test(i), namespace: f.join(".") }, o)),
                                    (p = l[h]) || (((p = l[h] = []).delegateCount = 0), (d.setup && !1 !== d.setup.call(e, r, f, a)) || (e.addEventListener && e.addEventListener(h, a))),
                                    d.add && (d.add.call(e, u), u.handler.guid || (u.handler.guid = n.guid)),
                                    i ? p.splice(p.delegateCount++, 0, u) : p.push(u),
                                    (S.event.global[h] = !0));
                },
                remove: function (e, t, n, r, i) {
                    var o,
                        a,
                        s,
                        l,
                        c,
                        u,
                        d,
                        p,
                        h,
                        f,
                        m,
                        g = Z.hasData(e) && Z.get(e);
                    if (g && (l = g.events)) {
                        for (c = (t = (t || "").match(z) || [""]).length; c--; )
                            if (((h = m = (s = Se.exec(t[c]) || [])[1]), (f = (s[2] || "").split(".").sort()), h)) {
                                for (d = S.event.special[h] || {}, p = l[(h = (r ? d.delegateType : d.bindType) || h)] || [], s = s[2] && new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"), a = o = p.length; o--; )
                                    (u = p[o]),
                                        (!i && m !== u.origType) ||
                                            (n && n.guid !== u.guid) ||
                                            (s && !s.test(u.namespace)) ||
                                            (r && r !== u.selector && ("**" !== r || !u.selector)) ||
                                            (p.splice(o, 1), u.selector && p.delegateCount--, d.remove && d.remove.call(e, u));
                                a && !p.length && ((d.teardown && !1 !== d.teardown.call(e, f, g.handle)) || S.removeEvent(e, h, g.handle), delete l[h]);
                            } else for (h in l) S.event.remove(e, h + t[c], n, r, !0);
                        S.isEmptyObject(l) && Z.remove(e, "handle events");
                    }
                },
                dispatch: function (e) {
                    var t,
                        n,
                        r,
                        i,
                        o,
                        a,
                        s = new Array(arguments.length),
                        l = S.event.fix(e),
                        c = (Z.get(this, "events") || Object.create(null))[l.type] || [],
                        u = S.event.special[l.type] || {};
                    for (s[0] = l, t = 1; t < arguments.length; t++) s[t] = arguments[t];
                    if (((l.delegateTarget = this), !u.preDispatch || !1 !== u.preDispatch.call(this, l))) {
                        for (a = S.event.handlers.call(this, l, c), t = 0; (i = a[t++]) && !l.isPropagationStopped(); )
                            for (l.currentTarget = i.elem, n = 0; (o = i.handlers[n++]) && !l.isImmediatePropagationStopped(); )
                                (l.rnamespace && !1 !== o.namespace && !l.rnamespace.test(o.namespace)) ||
                                    ((l.handleObj = o), (l.data = o.data), void 0 !== (r = ((S.event.special[o.origType] || {}).handle || o.handler).apply(i.elem, s)) && !1 === (l.result = r) && (l.preventDefault(), l.stopPropagation()));
                        return u.postDispatch && u.postDispatch.call(this, l), l.result;
                    }
                },
                handlers: function (e, t) {
                    var n,
                        r,
                        i,
                        o,
                        a,
                        s = [],
                        l = t.delegateCount,
                        c = e.target;
                    if (l && c.nodeType && !("click" === e.type && e.button >= 1))
                        for (; c !== this; c = c.parentNode || this)
                            if (1 === c.nodeType && ("click" !== e.type || !0 !== c.disabled)) {
                                for (o = [], a = {}, n = 0; n < l; n++) void 0 === a[(i = (r = t[n]).selector + " ")] && (a[i] = r.needsContext ? S(i, this).index(c) > -1 : S.find(i, this, null, [c]).length), a[i] && o.push(r);
                                o.length && s.push({ elem: c, handlers: o });
                            }
                    return (c = this), l < t.length && s.push({ elem: c, handlers: t.slice(l) }), s;
                },
                addProp: function (e, t) {
                    Object.defineProperty(S.Event.prototype, e, {
                        enumerable: !0,
                        configurable: !0,
                        get: v(t)
                            ? function () {
                                  if (this.originalEvent) return t(this.originalEvent);
                              }
                            : function () {
                                  if (this.originalEvent) return this.originalEvent[e];
                              },
                        set: function (t) {
                            Object.defineProperty(this, e, { enumerable: !0, configurable: !0, writable: !0, value: t });
                        },
                    });
                },
                fix: function (e) {
                    return e[S.expando] ? e : new S.Event(e);
                },
                special: {
                    load: { noBubble: !0 },
                    click: {
                        setup: function (e) {
                            var t = this || e;
                            return ge.test(t.type) && t.click && $(t, "input") && Le(t, "click", Te), !1;
                        },
                        trigger: function (e) {
                            var t = this || e;
                            return ge.test(t.type) && t.click && $(t, "input") && Le(t, "click"), !0;
                        },
                        _default: function (e) {
                            var t = e.target;
                            return (ge.test(t.type) && t.click && $(t, "input") && Z.get(t, "click")) || $(t, "a");
                        },
                    },
                    beforeunload: {
                        postDispatch: function (e) {
                            void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
                        },
                    },
                },
            }),
                (S.removeEvent = function (e, t, n) {
                    e.removeEventListener && e.removeEventListener(t, n);
                }),
                (S.Event = function (e, t) {
                    if (!(this instanceof S.Event)) return new S.Event(e, t);
                    e && e.type
                        ? ((this.originalEvent = e),
                          (this.type = e.type),
                          (this.isDefaultPrevented = e.defaultPrevented || (void 0 === e.defaultPrevented && !1 === e.returnValue) ? Te : ke),
                          (this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target),
                          (this.currentTarget = e.currentTarget),
                          (this.relatedTarget = e.relatedTarget))
                        : (this.type = e),
                        t && S.extend(this, t),
                        (this.timeStamp = (e && e.timeStamp) || Date.now()),
                        (this[S.expando] = !0);
                }),
                (S.Event.prototype = {
                    constructor: S.Event,
                    isDefaultPrevented: ke,
                    isPropagationStopped: ke,
                    isImmediatePropagationStopped: ke,
                    isSimulated: !1,
                    preventDefault: function () {
                        var e = this.originalEvent;
                        (this.isDefaultPrevented = Te), e && !this.isSimulated && e.preventDefault();
                    },
                    stopPropagation: function () {
                        var e = this.originalEvent;
                        (this.isPropagationStopped = Te), e && !this.isSimulated && e.stopPropagation();
                    },
                    stopImmediatePropagation: function () {
                        var e = this.originalEvent;
                        (this.isImmediatePropagationStopped = Te), e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation();
                    },
                }),
                S.each(
                    {
                        altKey: !0,
                        bubbles: !0,
                        cancelable: !0,
                        changedTouches: !0,
                        ctrlKey: !0,
                        detail: !0,
                        eventPhase: !0,
                        metaKey: !0,
                        pageX: !0,
                        pageY: !0,
                        shiftKey: !0,
                        view: !0,
                        char: !0,
                        code: !0,
                        charCode: !0,
                        key: !0,
                        keyCode: !0,
                        button: !0,
                        buttons: !0,
                        clientX: !0,
                        clientY: !0,
                        offsetX: !0,
                        offsetY: !0,
                        pointerId: !0,
                        pointerType: !0,
                        screenX: !0,
                        screenY: !0,
                        targetTouches: !0,
                        toElement: !0,
                        touches: !0,
                        which: !0,
                    },
                    S.event.addProp
                ),
                S.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
                    S.event.special[e] = {
                        setup: function () {
                            return Le(this, e, Ae), !1;
                        },
                        trigger: function () {
                            return Le(this, e), !0;
                        },
                        _default: function () {
                            return !0;
                        },
                        delegateType: t,
                    };
                }),
                S.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (e, t) {
                    S.event.special[e] = {
                        delegateType: t,
                        bindType: t,
                        handle: function (e) {
                            var n,
                                r = e.relatedTarget,
                                i = e.handleObj;
                            return (r && (r === this || S.contains(this, r))) || ((e.type = i.origType), (n = i.handler.apply(this, arguments)), (e.type = t)), n;
                        },
                    };
                }),
                S.fn.extend({
                    on: function (e, t, n, r) {
                        return _e(this, e, t, n, r);
                    },
                    one: function (e, t, n, r) {
                        return _e(this, e, t, n, r, 1);
                    },
                    off: function (e, t, n) {
                        var r, i;
                        if (e && e.preventDefault && e.handleObj) return (r = e.handleObj), S(e.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler), this;
                        if ("object" == typeof e) {
                            for (i in e) this.off(i, t, e[i]);
                            return this;
                        }
                        return (
                            (!1 !== t && "function" != typeof t) || ((n = t), (t = void 0)),
                            !1 === n && (n = ke),
                            this.each(function () {
                                S.event.remove(this, e, n, t);
                            })
                        );
                    },
                });
            var $e = /<script|<style|<link/i,
                De = /checked\s*(?:[^=]|=\s*.checked.)/i,
                Oe = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
            function qe(e, t) {
                return ($(e, "table") && $(11 !== t.nodeType ? t : t.firstChild, "tr") && S(e).children("tbody")[0]) || e;
            }
            function Me(e) {
                return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
            }
            function Pe(e) {
                return "true/" === (e.type || "").slice(0, 5) ? (e.type = e.type.slice(5)) : e.removeAttribute("type"), e;
            }
            function Ie(e, t) {
                var n, r, i, o, a, s;
                if (1 === t.nodeType) {
                    if (Z.hasData(e) && (s = Z.get(e).events)) for (i in (Z.remove(t, "handle events"), s)) for (n = 0, r = s[i].length; n < r; n++) S.event.add(t, i, s[i][n]);
                    Q.hasData(e) && ((o = Q.access(e)), (a = S.extend({}, o)), Q.set(t, a));
                }
            }
            function Ne(e, t) {
                var n = t.nodeName.toLowerCase();
                "input" === n && ge.test(e.type) ? (t.checked = e.checked) : ("input" !== n && "textarea" !== n) || (t.defaultValue = e.defaultValue);
            }
            function ze(e, t, n, r) {
                t = l(t);
                var i,
                    o,
                    a,
                    s,
                    c,
                    u,
                    d = 0,
                    p = e.length,
                    h = p - 1,
                    f = t[0],
                    m = v(f);
                if (m || (p > 1 && "string" == typeof f && !g.checkClone && De.test(f)))
                    return e.each(function (i) {
                        var o = e.eq(i);
                        m && (t[0] = f.call(this, i, o.html())), ze(o, t, n, r);
                    });
                if (p && ((o = (i = Ce(t, e[0].ownerDocument, !1, e, r)).firstChild), 1 === i.childNodes.length && (i = o), o || r)) {
                    for (s = (a = S.map(we(i, "script"), Me)).length; d < p; d++) (c = i), d !== h && ((c = S.clone(c, !0, !0)), s && S.merge(a, we(c, "script"))), n.call(e[d], c, d);
                    if (s)
                        for (u = a[a.length - 1].ownerDocument, S.map(a, Pe), d = 0; d < s; d++)
                            (c = a[d]),
                                ye.test(c.type || "") &&
                                    !Z.access(c, "globalEval") &&
                                    S.contains(u, c) &&
                                    (c.src && "module" !== (c.type || "").toLowerCase() ? S._evalUrl && !c.noModule && S._evalUrl(c.src, { nonce: c.nonce || c.getAttribute("nonce") }, u) : x(c.textContent.replace(Oe, ""), c, u));
                }
                return e;
            }
            function Re(e, t, n) {
                for (var r, i = t ? S.filter(t, e) : e, o = 0; null != (r = i[o]); o++) n || 1 !== r.nodeType || S.cleanData(we(r)), r.parentNode && (n && se(r) && xe(we(r, "script")), r.parentNode.removeChild(r));
                return e;
            }
            S.extend({
                htmlPrefilter: function (e) {
                    return e;
                },
                clone: function (e, t, n) {
                    var r,
                        i,
                        o,
                        a,
                        s = e.cloneNode(!0),
                        l = se(e);
                    if (!(g.noCloneChecked || (1 !== e.nodeType && 11 !== e.nodeType) || S.isXMLDoc(e))) for (a = we(s), r = 0, i = (o = we(e)).length; r < i; r++) Ne(o[r], a[r]);
                    if (t)
                        if (n) for (o = o || we(e), a = a || we(s), r = 0, i = o.length; r < i; r++) Ie(o[r], a[r]);
                        else Ie(e, s);
                    return (a = we(s, "script")).length > 0 && xe(a, !l && we(e, "script")), s;
                },
                cleanData: function (e) {
                    for (var t, n, r, i = S.event.special, o = 0; void 0 !== (n = e[o]); o++)
                        if (K(n)) {
                            if ((t = n[Z.expando])) {
                                if (t.events) for (r in t.events) i[r] ? S.event.remove(n, r) : S.removeEvent(n, r, t.handle);
                                n[Z.expando] = void 0;
                            }
                            n[Q.expando] && (n[Q.expando] = void 0);
                        }
                },
            }),
                S.fn.extend({
                    detach: function (e) {
                        return Re(this, e, !0);
                    },
                    remove: function (e) {
                        return Re(this, e);
                    },
                    text: function (e) {
                        return W(
                            this,
                            function (e) {
                                return void 0 === e
                                    ? S.text(this)
                                    : this.empty().each(function () {
                                          (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || (this.textContent = e);
                                      });
                            },
                            null,
                            e,
                            arguments.length
                        );
                    },
                    append: function () {
                        return ze(this, arguments, function (e) {
                            (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || qe(this, e).appendChild(e);
                        });
                    },
                    prepend: function () {
                        return ze(this, arguments, function (e) {
                            if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                                var t = qe(this, e);
                                t.insertBefore(e, t.firstChild);
                            }
                        });
                    },
                    before: function () {
                        return ze(this, arguments, function (e) {
                            this.parentNode && this.parentNode.insertBefore(e, this);
                        });
                    },
                    after: function () {
                        return ze(this, arguments, function (e) {
                            this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
                        });
                    },
                    empty: function () {
                        for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (S.cleanData(we(e, !1)), (e.textContent = ""));
                        return this;
                    },
                    clone: function (e, t) {
                        return (
                            (e = null != e && e),
                            (t = null == t ? e : t),
                            this.map(function () {
                                return S.clone(this, e, t);
                            })
                        );
                    },
                    html: function (e) {
                        return W(
                            this,
                            function (e) {
                                var t = this[0] || {},
                                    n = 0,
                                    r = this.length;
                                if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                                if ("string" == typeof e && !$e.test(e) && !be[(ve.exec(e) || ["", ""])[1].toLowerCase()]) {
                                    e = S.htmlPrefilter(e);
                                    try {
                                        for (; n < r; n++) 1 === (t = this[n] || {}).nodeType && (S.cleanData(we(t, !1)), (t.innerHTML = e));
                                        t = 0;
                                    } catch (e) {}
                                }
                                t && this.empty().append(e);
                            },
                            null,
                            e,
                            arguments.length
                        );
                    },
                    replaceWith: function () {
                        var e = [];
                        return ze(
                            this,
                            arguments,
                            function (t) {
                                var n = this.parentNode;
                                S.inArray(this, e) < 0 && (S.cleanData(we(this)), n && n.replaceChild(t, this));
                            },
                            e
                        );
                    },
                }),
                S.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (e, t) {
                    S.fn[e] = function (e) {
                        for (var n, r = [], i = S(e), o = i.length - 1, a = 0; a <= o; a++) (n = a === o ? this : this.clone(!0)), S(i[a])[t](n), c.apply(r, n.get());
                        return this.pushStack(r);
                    };
                });
            var Fe = new RegExp("^(" + re + ")(?!px)[a-z%]+$", "i"),
                Be = function (e) {
                    var t = e.ownerDocument.defaultView;
                    return (t && t.opener) || (t = n), t.getComputedStyle(e);
                },
                je = function (e, t, n) {
                    var r,
                        i,
                        o = {};
                    for (i in t) (o[i] = e.style[i]), (e.style[i] = t[i]);
                    for (i in ((r = n.call(e)), t)) e.style[i] = o[i];
                    return r;
                },
                He = new RegExp(oe.join("|"), "i");
            function Ve(e, t, n) {
                var r,
                    i,
                    o,
                    a,
                    s = e.style;
                return (
                    (n = n || Be(e)) &&
                        ("" !== (a = n.getPropertyValue(t) || n[t]) || se(e) || (a = S.style(e, t)),
                        !g.pixelBoxStyles() && Fe.test(a) && He.test(t) && ((r = s.width), (i = s.minWidth), (o = s.maxWidth), (s.minWidth = s.maxWidth = s.width = a), (a = n.width), (s.width = r), (s.minWidth = i), (s.maxWidth = o))),
                    void 0 !== a ? a + "" : a
                );
            }
            function We(e, t) {
                return {
                    get: function () {
                        if (!e()) return (this.get = t).apply(this, arguments);
                        delete this.get;
                    },
                };
            }
            !(function () {
                function e() {
                    if (u) {
                        (c.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
                            (u.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
                            ae.appendChild(c).appendChild(u);
                        var e = n.getComputedStyle(u);
                        (r = "1%" !== e.top),
                            (l = 12 === t(e.marginLeft)),
                            (u.style.right = "60%"),
                            (a = 36 === t(e.right)),
                            (i = 36 === t(e.width)),
                            (u.style.position = "absolute"),
                            (o = 12 === t(u.offsetWidth / 3)),
                            ae.removeChild(c),
                            (u = null);
                    }
                }
                function t(e) {
                    return Math.round(parseFloat(e));
                }
                var r,
                    i,
                    o,
                    a,
                    s,
                    l,
                    c = b.createElement("div"),
                    u = b.createElement("div");
                u.style &&
                    ((u.style.backgroundClip = "content-box"),
                    (u.cloneNode(!0).style.backgroundClip = ""),
                    (g.clearCloneStyle = "content-box" === u.style.backgroundClip),
                    S.extend(g, {
                        boxSizingReliable: function () {
                            return e(), i;
                        },
                        pixelBoxStyles: function () {
                            return e(), a;
                        },
                        pixelPosition: function () {
                            return e(), r;
                        },
                        reliableMarginLeft: function () {
                            return e(), l;
                        },
                        scrollboxSize: function () {
                            return e(), o;
                        },
                        reliableTrDimensions: function () {
                            var e, t, r, i;
                            return (
                                null == s &&
                                    ((e = b.createElement("table")),
                                    (t = b.createElement("tr")),
                                    (r = b.createElement("div")),
                                    (e.style.cssText = "position:absolute;left:-11111px;border-collapse:separate"),
                                    (t.style.cssText = "border:1px solid"),
                                    (t.style.height = "1px"),
                                    (r.style.height = "9px"),
                                    (r.style.display = "block"),
                                    ae.appendChild(e).appendChild(t).appendChild(r),
                                    (i = n.getComputedStyle(t)),
                                    (s = parseInt(i.height, 10) + parseInt(i.borderTopWidth, 10) + parseInt(i.borderBottomWidth, 10) === t.offsetHeight),
                                    ae.removeChild(e)),
                                s
                            );
                        },
                    }));
            })();
            var Ue = ["Webkit", "Moz", "ms"],
                Ge = b.createElement("div").style,
                Ye = {};
            function Xe(e) {
                var t = S.cssProps[e] || Ye[e];
                return (
                    t ||
                    (e in Ge
                        ? e
                        : (Ye[e] =
                              (function (e) {
                                  for (var t = e[0].toUpperCase() + e.slice(1), n = Ue.length; n--; ) if ((e = Ue[n] + t) in Ge) return e;
                              })(e) || e))
                );
            }
            var Ke = /^(none|table(?!-c[ea]).+)/,
                Je = /^--/,
                Ze = { position: "absolute", visibility: "hidden", display: "block" },
                Qe = { letterSpacing: "0", fontWeight: "400" };
            function et(e, t, n) {
                var r = ie.exec(t);
                return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t;
            }
            function tt(e, t, n, r, i, o) {
                var a = "width" === t ? 1 : 0,
                    s = 0,
                    l = 0;
                if (n === (r ? "border" : "content")) return 0;
                for (; a < 4; a += 2)
                    "margin" === n && (l += S.css(e, n + oe[a], !0, i)),
                        r
                            ? ("content" === n && (l -= S.css(e, "padding" + oe[a], !0, i)), "margin" !== n && (l -= S.css(e, "border" + oe[a] + "Width", !0, i)))
                            : ((l += S.css(e, "padding" + oe[a], !0, i)), "padding" !== n ? (l += S.css(e, "border" + oe[a] + "Width", !0, i)) : (s += S.css(e, "border" + oe[a] + "Width", !0, i)));
                return !r && o >= 0 && (l += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - o - l - s - 0.5)) || 0), l;
            }
            function nt(e, t, n) {
                var r = Be(e),
                    i = (!g.boxSizingReliable() || n) && "border-box" === S.css(e, "boxSizing", !1, r),
                    o = i,
                    a = Ve(e, t, r),
                    s = "offset" + t[0].toUpperCase() + t.slice(1);
                if (Fe.test(a)) {
                    if (!n) return a;
                    a = "auto";
                }
                return (
                    ((!g.boxSizingReliable() && i) || (!g.reliableTrDimensions() && $(e, "tr")) || "auto" === a || (!parseFloat(a) && "inline" === S.css(e, "display", !1, r))) &&
                        e.getClientRects().length &&
                        ((i = "border-box" === S.css(e, "boxSizing", !1, r)), (o = s in e) && (a = e[s])),
                    (a = parseFloat(a) || 0) + tt(e, t, n || (i ? "border" : "content"), o, r, a) + "px"
                );
            }
            function rt(e, t, n, r, i) {
                return new rt.prototype.init(e, t, n, r, i);
            }
            S.extend({
                cssHooks: {
                    opacity: {
                        get: function (e, t) {
                            if (t) {
                                var n = Ve(e, "opacity");
                                return "" === n ? "1" : n;
                            }
                        },
                    },
                },
                cssNumber: {
                    animationIterationCount: !0,
                    columnCount: !0,
                    fillOpacity: !0,
                    flexGrow: !0,
                    flexShrink: !0,
                    fontWeight: !0,
                    gridArea: !0,
                    gridColumn: !0,
                    gridColumnEnd: !0,
                    gridColumnStart: !0,
                    gridRow: !0,
                    gridRowEnd: !0,
                    gridRowStart: !0,
                    lineHeight: !0,
                    opacity: !0,
                    order: !0,
                    orphans: !0,
                    widows: !0,
                    zIndex: !0,
                    zoom: !0,
                },
                cssProps: {},
                style: function (e, t, n, r) {
                    if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                        var i,
                            o,
                            a,
                            s = X(t),
                            l = Je.test(t),
                            c = e.style;
                        if ((l || (t = Xe(s)), (a = S.cssHooks[t] || S.cssHooks[s]), void 0 === n)) return a && "get" in a && void 0 !== (i = a.get(e, !1, r)) ? i : c[t];
                        "string" === (o = typeof n) && (i = ie.exec(n)) && i[1] && ((n = ue(e, t, i)), (o = "number")),
                            null != n &&
                                n == n &&
                                ("number" !== o || l || (n += (i && i[3]) || (S.cssNumber[s] ? "" : "px")),
                                g.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (c[t] = "inherit"),
                                (a && "set" in a && void 0 === (n = a.set(e, n, r))) || (l ? c.setProperty(t, n) : (c[t] = n)));
                    }
                },
                css: function (e, t, n, r) {
                    var i,
                        o,
                        a,
                        s = X(t);
                    return (
                        Je.test(t) || (t = Xe(s)),
                        (a = S.cssHooks[t] || S.cssHooks[s]) && "get" in a && (i = a.get(e, !0, n)),
                        void 0 === i && (i = Ve(e, t, r)),
                        "normal" === i && t in Qe && (i = Qe[t]),
                        "" === n || n ? ((o = parseFloat(i)), !0 === n || isFinite(o) ? o || 0 : i) : i
                    );
                },
            }),
                S.each(["height", "width"], function (e, t) {
                    S.cssHooks[t] = {
                        get: function (e, n, r) {
                            if (n)
                                return !Ke.test(S.css(e, "display")) || (e.getClientRects().length && e.getBoundingClientRect().width)
                                    ? nt(e, t, r)
                                    : je(e, Ze, function () {
                                          return nt(e, t, r);
                                      });
                        },
                        set: function (e, n, r) {
                            var i,
                                o = Be(e),
                                a = !g.scrollboxSize() && "absolute" === o.position,
                                s = (a || r) && "border-box" === S.css(e, "boxSizing", !1, o),
                                l = r ? tt(e, t, r, s, o) : 0;
                            return (
                                s && a && (l -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(o[t]) - tt(e, t, "border", !1, o) - 0.5)),
                                l && (i = ie.exec(n)) && "px" !== (i[3] || "px") && ((e.style[t] = n), (n = S.css(e, t))),
                                et(0, n, l)
                            );
                        },
                    };
                }),
                (S.cssHooks.marginLeft = We(g.reliableMarginLeft, function (e, t) {
                    if (t)
                        return (
                            (parseFloat(Ve(e, "marginLeft")) ||
                                e.getBoundingClientRect().left -
                                    je(e, { marginLeft: 0 }, function () {
                                        return e.getBoundingClientRect().left;
                                    })) + "px"
                        );
                })),
                S.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
                    (S.cssHooks[e + t] = {
                        expand: function (n) {
                            for (var r = 0, i = {}, o = "string" == typeof n ? n.split(" ") : [n]; r < 4; r++) i[e + oe[r] + t] = o[r] || o[r - 2] || o[0];
                            return i;
                        },
                    }),
                        "margin" !== e && (S.cssHooks[e + t].set = et);
                }),
                S.fn.extend({
                    css: function (e, t) {
                        return W(
                            this,
                            function (e, t, n) {
                                var r,
                                    i,
                                    o = {},
                                    a = 0;
                                if (Array.isArray(t)) {
                                    for (r = Be(e), i = t.length; a < i; a++) o[t[a]] = S.css(e, t[a], !1, r);
                                    return o;
                                }
                                return void 0 !== n ? S.style(e, t, n) : S.css(e, t);
                            },
                            e,
                            t,
                            arguments.length > 1
                        );
                    },
                }),
                (S.Tween = rt),
                (rt.prototype = {
                    constructor: rt,
                    init: function (e, t, n, r, i, o) {
                        (this.elem = e), (this.prop = n), (this.easing = i || S.easing._default), (this.options = t), (this.start = this.now = this.cur()), (this.end = r), (this.unit = o || (S.cssNumber[n] ? "" : "px"));
                    },
                    cur: function () {
                        var e = rt.propHooks[this.prop];
                        return e && e.get ? e.get(this) : rt.propHooks._default.get(this);
                    },
                    run: function (e) {
                        var t,
                            n = rt.propHooks[this.prop];
                        return (
                            this.options.duration ? (this.pos = t = S.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration)) : (this.pos = t = e),
                            (this.now = (this.end - this.start) * t + this.start),
                            this.options.step && this.options.step.call(this.elem, this.now, this),
                            n && n.set ? n.set(this) : rt.propHooks._default.set(this),
                            this
                        );
                    },
                }),
                (rt.prototype.init.prototype = rt.prototype),
                (rt.propHooks = {
                    _default: {
                        get: function (e) {
                            var t;
                            return 1 !== e.elem.nodeType || (null != e.elem[e.prop] && null == e.elem.style[e.prop]) ? e.elem[e.prop] : (t = S.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0;
                        },
                        set: function (e) {
                            S.fx.step[e.prop] ? S.fx.step[e.prop](e) : 1 !== e.elem.nodeType || (!S.cssHooks[e.prop] && null == e.elem.style[Xe(e.prop)]) ? (e.elem[e.prop] = e.now) : S.style(e.elem, e.prop, e.now + e.unit);
                        },
                    },
                }),
                (rt.propHooks.scrollTop = rt.propHooks.scrollLeft = {
                    set: function (e) {
                        e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
                    },
                }),
                (S.easing = {
                    linear: function (e) {
                        return e;
                    },
                    swing: function (e) {
                        return 0.5 - Math.cos(e * Math.PI) / 2;
                    },
                    _default: "swing",
                }),
                (S.fx = rt.prototype.init),
                (S.fx.step = {});
            var it,
                ot,
                at = /^(?:toggle|show|hide)$/,
                st = /queueHooks$/;
            function lt() {
                ot && (!1 === b.hidden && n.requestAnimationFrame ? n.requestAnimationFrame(lt) : n.setTimeout(lt, S.fx.interval), S.fx.tick());
            }
            function ct() {
                return (
                    n.setTimeout(function () {
                        it = void 0;
                    }),
                    (it = Date.now())
                );
            }
            function ut(e, t) {
                var n,
                    r = 0,
                    i = { height: e };
                for (t = t ? 1 : 0; r < 4; r += 2 - t) i["margin" + (n = oe[r])] = i["padding" + n] = e;
                return t && (i.opacity = i.width = e), i;
            }
            function dt(e, t, n) {
                for (var r, i = (pt.tweeners[t] || []).concat(pt.tweeners["*"]), o = 0, a = i.length; o < a; o++) if ((r = i[o].call(n, t, e))) return r;
            }
            function pt(e, t, n) {
                var r,
                    i,
                    o = 0,
                    a = pt.prefilters.length,
                    s = S.Deferred().always(function () {
                        delete l.elem;
                    }),
                    l = function () {
                        if (i) return !1;
                        for (var t = it || ct(), n = Math.max(0, c.startTime + c.duration - t), r = 1 - (n / c.duration || 0), o = 0, a = c.tweens.length; o < a; o++) c.tweens[o].run(r);
                        return s.notifyWith(e, [c, r, n]), r < 1 && a ? n : (a || s.notifyWith(e, [c, 1, 0]), s.resolveWith(e, [c]), !1);
                    },
                    c = s.promise({
                        elem: e,
                        props: S.extend({}, t),
                        opts: S.extend(!0, { specialEasing: {}, easing: S.easing._default }, n),
                        originalProperties: t,
                        originalOptions: n,
                        startTime: it || ct(),
                        duration: n.duration,
                        tweens: [],
                        createTween: function (t, n) {
                            var r = S.Tween(e, c.opts, t, n, c.opts.specialEasing[t] || c.opts.easing);
                            return c.tweens.push(r), r;
                        },
                        stop: function (t) {
                            var n = 0,
                                r = t ? c.tweens.length : 0;
                            if (i) return this;
                            for (i = !0; n < r; n++) c.tweens[n].run(1);
                            return t ? (s.notifyWith(e, [c, 1, 0]), s.resolveWith(e, [c, t])) : s.rejectWith(e, [c, t]), this;
                        },
                    }),
                    u = c.props;
                for (
                    !(function (e, t) {
                        var n, r, i, o, a;
                        for (n in e)
                            if (((i = t[(r = X(n))]), (o = e[n]), Array.isArray(o) && ((i = o[1]), (o = e[n] = o[0])), n !== r && ((e[r] = o), delete e[n]), (a = S.cssHooks[r]) && ("expand" in a)))
                                for (n in ((o = a.expand(o)), delete e[r], o)) (n in e) || ((e[n] = o[n]), (t[n] = i));
                            else t[r] = i;
                    })(u, c.opts.specialEasing);
                    o < a;
                    o++
                )
                    if ((r = pt.prefilters[o].call(c, e, u, c.opts))) return v(r.stop) && (S._queueHooks(c.elem, c.opts.queue).stop = r.stop.bind(r)), r;
                return (
                    S.map(u, dt, c),
                    v(c.opts.start) && c.opts.start.call(e, c),
                    c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always),
                    S.fx.timer(S.extend(l, { elem: e, anim: c, queue: c.opts.queue })),
                    c
                );
            }
            (S.Animation = S.extend(pt, {
                tweeners: {
                    "*": [
                        function (e, t) {
                            var n = this.createTween(e, t);
                            return ue(n.elem, e, ie.exec(t), n), n;
                        },
                    ],
                },
                tweener: function (e, t) {
                    v(e) ? ((t = e), (e = ["*"])) : (e = e.match(z));
                    for (var n, r = 0, i = e.length; r < i; r++) (n = e[r]), (pt.tweeners[n] = pt.tweeners[n] || []), pt.tweeners[n].unshift(t);
                },
                prefilters: [
                    function (e, t, n) {
                        var r,
                            i,
                            o,
                            a,
                            s,
                            l,
                            c,
                            u,
                            d = "width" in t || "height" in t,
                            p = this,
                            h = {},
                            f = e.style,
                            m = e.nodeType && ce(e),
                            g = Z.get(e, "fxshow");
                        for (r in (n.queue ||
                            (null == (a = S._queueHooks(e, "fx")).unqueued &&
                                ((a.unqueued = 0),
                                (s = a.empty.fire),
                                (a.empty.fire = function () {
                                    a.unqueued || s();
                                })),
                            a.unqueued++,
                            p.always(function () {
                                p.always(function () {
                                    a.unqueued--, S.queue(e, "fx").length || a.empty.fire();
                                });
                            })),
                        t))
                            if (((i = t[r]), at.test(i))) {
                                if ((delete t[r], (o = o || "toggle" === i), i === (m ? "hide" : "show"))) {
                                    if ("show" !== i || !g || void 0 === g[r]) continue;
                                    m = !0;
                                }
                                h[r] = (g && g[r]) || S.style(e, r);
                            }
                        if ((l = !S.isEmptyObject(t)) || !S.isEmptyObject(h))
                            for (r in (d &&
                                1 === e.nodeType &&
                                ((n.overflow = [f.overflow, f.overflowX, f.overflowY]),
                                null == (c = g && g.display) && (c = Z.get(e, "display")),
                                "none" === (u = S.css(e, "display")) && (c ? (u = c) : (he([e], !0), (c = e.style.display || c), (u = S.css(e, "display")), he([e]))),
                                ("inline" === u || ("inline-block" === u && null != c)) &&
                                    "none" === S.css(e, "float") &&
                                    (l ||
                                        (p.done(function () {
                                            f.display = c;
                                        }),
                                        null == c && ((u = f.display), (c = "none" === u ? "" : u))),
                                    (f.display = "inline-block"))),
                            n.overflow &&
                                ((f.overflow = "hidden"),
                                p.always(function () {
                                    (f.overflow = n.overflow[0]), (f.overflowX = n.overflow[1]), (f.overflowY = n.overflow[2]);
                                })),
                            (l = !1),
                            h))
                                l ||
                                    (g ? "hidden" in g && (m = g.hidden) : (g = Z.access(e, "fxshow", { display: c })),
                                    o && (g.hidden = !m),
                                    m && he([e], !0),
                                    p.done(function () {
                                        for (r in (m || he([e]), Z.remove(e, "fxshow"), h)) S.style(e, r, h[r]);
                                    })),
                                    (l = dt(m ? g[r] : 0, r, p)),
                                    r in g || ((g[r] = l.start), m && ((l.end = l.start), (l.start = 0)));
                    },
                ],
                prefilter: function (e, t) {
                    t ? pt.prefilters.unshift(e) : pt.prefilters.push(e);
                },
            })),
                (S.speed = function (e, t, n) {
                    var r = e && "object" == typeof e ? S.extend({}, e) : { complete: n || (!n && t) || (v(e) && e), duration: e, easing: (n && t) || (t && !v(t) && t) };
                    return (
                        S.fx.off ? (r.duration = 0) : "number" != typeof r.duration && (r.duration in S.fx.speeds ? (r.duration = S.fx.speeds[r.duration]) : (r.duration = S.fx.speeds._default)),
                        (null != r.queue && !0 !== r.queue) || (r.queue = "fx"),
                        (r.old = r.complete),
                        (r.complete = function () {
                            v(r.old) && r.old.call(this), r.queue && S.dequeue(this, r.queue);
                        }),
                        r
                    );
                }),
                S.fn.extend({
                    fadeTo: function (e, t, n, r) {
                        return this.filter(ce).css("opacity", 0).show().end().animate({ opacity: t }, e, n, r);
                    },
                    animate: function (e, t, n, r) {
                        var i = S.isEmptyObject(e),
                            o = S.speed(t, n, r),
                            a = function () {
                                var t = pt(this, S.extend({}, e), o);
                                (i || Z.get(this, "finish")) && t.stop(!0);
                            };
                        return (a.finish = a), i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a);
                    },
                    stop: function (e, t, n) {
                        var r = function (e) {
                            var t = e.stop;
                            delete e.stop, t(n);
                        };
                        return (
                            "string" != typeof e && ((n = t), (t = e), (e = void 0)),
                            t && this.queue(e || "fx", []),
                            this.each(function () {
                                var t = !0,
                                    i = null != e && e + "queueHooks",
                                    o = S.timers,
                                    a = Z.get(this);
                                if (i) a[i] && a[i].stop && r(a[i]);
                                else for (i in a) a[i] && a[i].stop && st.test(i) && r(a[i]);
                                for (i = o.length; i--; ) o[i].elem !== this || (null != e && o[i].queue !== e) || (o[i].anim.stop(n), (t = !1), o.splice(i, 1));
                                (!t && n) || S.dequeue(this, e);
                            })
                        );
                    },
                    finish: function (e) {
                        return (
                            !1 !== e && (e = e || "fx"),
                            this.each(function () {
                                var t,
                                    n = Z.get(this),
                                    r = n[e + "queue"],
                                    i = n[e + "queueHooks"],
                                    o = S.timers,
                                    a = r ? r.length : 0;
                                for (n.finish = !0, S.queue(this, e, []), i && i.stop && i.stop.call(this, !0), t = o.length; t--; ) o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0), o.splice(t, 1));
                                for (t = 0; t < a; t++) r[t] && r[t].finish && r[t].finish.call(this);
                                delete n.finish;
                            })
                        );
                    },
                }),
                S.each(["toggle", "show", "hide"], function (e, t) {
                    var n = S.fn[t];
                    S.fn[t] = function (e, r, i) {
                        return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(ut(t, !0), e, r, i);
                    };
                }),
                S.each({ slideDown: ut("show"), slideUp: ut("hide"), slideToggle: ut("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (e, t) {
                    S.fn[e] = function (e, n, r) {
                        return this.animate(t, e, n, r);
                    };
                }),
                (S.timers = []),
                (S.fx.tick = function () {
                    var e,
                        t = 0,
                        n = S.timers;
                    for (it = Date.now(); t < n.length; t++) (e = n[t])() || n[t] !== e || n.splice(t--, 1);
                    n.length || S.fx.stop(), (it = void 0);
                }),
                (S.fx.timer = function (e) {
                    S.timers.push(e), S.fx.start();
                }),
                (S.fx.interval = 13),
                (S.fx.start = function () {
                    ot || ((ot = !0), lt());
                }),
                (S.fx.stop = function () {
                    ot = null;
                }),
                (S.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
                (S.fn.delay = function (e, t) {
                    return (
                        (e = (S.fx && S.fx.speeds[e]) || e),
                        (t = t || "fx"),
                        this.queue(t, function (t, r) {
                            var i = n.setTimeout(t, e);
                            r.stop = function () {
                                n.clearTimeout(i);
                            };
                        })
                    );
                }),
                (function () {
                    var e = b.createElement("input"),
                        t = b.createElement("select").appendChild(b.createElement("option"));
                    (e.type = "checkbox"), (g.checkOn = "" !== e.value), (g.optSelected = t.selected), ((e = b.createElement("input")).value = "t"), (e.type = "radio"), (g.radioValue = "t" === e.value);
                })();
            var ht,
                ft = S.expr.attrHandle;
            S.fn.extend({
                attr: function (e, t) {
                    return W(this, S.attr, e, t, arguments.length > 1);
                },
                removeAttr: function (e) {
                    return this.each(function () {
                        S.removeAttr(this, e);
                    });
                },
            }),
                S.extend({
                    attr: function (e, t, n) {
                        var r,
                            i,
                            o = e.nodeType;
                        if (3 !== o && 8 !== o && 2 !== o)
                            return void 0 === e.getAttribute
                                ? S.prop(e, t, n)
                                : ((1 === o && S.isXMLDoc(e)) || (i = S.attrHooks[t.toLowerCase()] || (S.expr.match.bool.test(t) ? ht : void 0)),
                                  void 0 !== n
                                      ? null === n
                                          ? void S.removeAttr(e, t)
                                          : i && "set" in i && void 0 !== (r = i.set(e, n, t))
                                          ? r
                                          : (e.setAttribute(t, n + ""), n)
                                      : i && "get" in i && null !== (r = i.get(e, t))
                                      ? r
                                      : null == (r = S.find.attr(e, t))
                                      ? void 0
                                      : r);
                    },
                    attrHooks: {
                        type: {
                            set: function (e, t) {
                                if (!g.radioValue && "radio" === t && $(e, "input")) {
                                    var n = e.value;
                                    return e.setAttribute("type", t), n && (e.value = n), t;
                                }
                            },
                        },
                    },
                    removeAttr: function (e, t) {
                        var n,
                            r = 0,
                            i = t && t.match(z);
                        if (i && 1 === e.nodeType) for (; (n = i[r++]); ) e.removeAttribute(n);
                    },
                }),
                (ht = {
                    set: function (e, t, n) {
                        return !1 === t ? S.removeAttr(e, n) : e.setAttribute(n, n), n;
                    },
                }),
                S.each(S.expr.match.bool.source.match(/\w+/g), function (e, t) {
                    var n = ft[t] || S.find.attr;
                    ft[t] = function (e, t, r) {
                        var i,
                            o,
                            a = t.toLowerCase();
                        return r || ((o = ft[a]), (ft[a] = i), (i = null != n(e, t, r) ? a : null), (ft[a] = o)), i;
                    };
                });
            var mt = /^(?:input|select|textarea|button)$/i,
                gt = /^(?:a|area)$/i;
            function vt(e) {
                return (e.match(z) || []).join(" ");
            }
            function yt(e) {
                return (e.getAttribute && e.getAttribute("class")) || "";
            }
            function bt(e) {
                return Array.isArray(e) ? e : ("string" == typeof e && e.match(z)) || [];
            }
            S.fn.extend({
                prop: function (e, t) {
                    return W(this, S.prop, e, t, arguments.length > 1);
                },
                removeProp: function (e) {
                    return this.each(function () {
                        delete this[S.propFix[e] || e];
                    });
                },
            }),
                S.extend({
                    prop: function (e, t, n) {
                        var r,
                            i,
                            o = e.nodeType;
                        if (3 !== o && 8 !== o && 2 !== o)
                            return (
                                (1 === o && S.isXMLDoc(e)) || ((t = S.propFix[t] || t), (i = S.propHooks[t])),
                                void 0 !== n ? (i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : (e[t] = n)) : i && "get" in i && null !== (r = i.get(e, t)) ? r : e[t]
                            );
                    },
                    propHooks: {
                        tabIndex: {
                            get: function (e) {
                                var t = S.find.attr(e, "tabindex");
                                return t ? parseInt(t, 10) : mt.test(e.nodeName) || (gt.test(e.nodeName) && e.href) ? 0 : -1;
                            },
                        },
                    },
                    propFix: { for: "htmlFor", class: "className" },
                }),
                g.optSelected ||
                    (S.propHooks.selected = {
                        get: function (e) {
                            var t = e.parentNode;
                            return t && t.parentNode && t.parentNode.selectedIndex, null;
                        },
                        set: function (e) {
                            var t = e.parentNode;
                            t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
                        },
                    }),
                S.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
                    S.propFix[this.toLowerCase()] = this;
                }),
                S.fn.extend({
                    addClass: function (e) {
                        var t,
                            n,
                            r,
                            i,
                            o,
                            a,
                            s,
                            l = 0;
                        if (v(e))
                            return this.each(function (t) {
                                S(this).addClass(e.call(this, t, yt(this)));
                            });
                        if ((t = bt(e)).length)
                            for (; (n = this[l++]); )
                                if (((i = yt(n)), (r = 1 === n.nodeType && " " + vt(i) + " "))) {
                                    for (a = 0; (o = t[a++]); ) r.indexOf(" " + o + " ") < 0 && (r += o + " ");
                                    i !== (s = vt(r)) && n.setAttribute("class", s);
                                }
                        return this;
                    },
                    removeClass: function (e) {
                        var t,
                            n,
                            r,
                            i,
                            o,
                            a,
                            s,
                            l = 0;
                        if (v(e))
                            return this.each(function (t) {
                                S(this).removeClass(e.call(this, t, yt(this)));
                            });
                        if (!arguments.length) return this.attr("class", "");
                        if ((t = bt(e)).length)
                            for (; (n = this[l++]); )
                                if (((i = yt(n)), (r = 1 === n.nodeType && " " + vt(i) + " "))) {
                                    for (a = 0; (o = t[a++]); ) for (; r.indexOf(" " + o + " ") > -1; ) r = r.replace(" " + o + " ", " ");
                                    i !== (s = vt(r)) && n.setAttribute("class", s);
                                }
                        return this;
                    },
                    toggleClass: function (e, t) {
                        var n = typeof e,
                            r = "string" === n || Array.isArray(e);
                        return "boolean" == typeof t && r
                            ? t
                                ? this.addClass(e)
                                : this.removeClass(e)
                            : v(e)
                            ? this.each(function (n) {
                                  S(this).toggleClass(e.call(this, n, yt(this), t), t);
                              })
                            : this.each(function () {
                                  var t, i, o, a;
                                  if (r) for (i = 0, o = S(this), a = bt(e); (t = a[i++]); ) o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
                                  else (void 0 !== e && "boolean" !== n) || ((t = yt(this)) && Z.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : Z.get(this, "__className__") || ""));
                              });
                    },
                    hasClass: function (e) {
                        var t,
                            n,
                            r = 0;
                        for (t = " " + e + " "; (n = this[r++]); ) if (1 === n.nodeType && (" " + vt(yt(n)) + " ").indexOf(t) > -1) return !0;
                        return !1;
                    },
                });
            var wt = /\r/g;
            S.fn.extend({
                val: function (e) {
                    var t,
                        n,
                        r,
                        i = this[0];
                    return arguments.length
                        ? ((r = v(e)),
                          this.each(function (n) {
                              var i;
                              1 === this.nodeType &&
                                  (null == (i = r ? e.call(this, n, S(this).val()) : e)
                                      ? (i = "")
                                      : "number" == typeof i
                                      ? (i += "")
                                      : Array.isArray(i) &&
                                        (i = S.map(i, function (e) {
                                            return null == e ? "" : e + "";
                                        })),
                                  ((t = S.valHooks[this.type] || S.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, i, "value")) || (this.value = i));
                          }))
                        : i
                        ? (t = S.valHooks[i.type] || S.valHooks[i.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(i, "value"))
                            ? n
                            : "string" == typeof (n = i.value)
                            ? n.replace(wt, "")
                            : null == n
                            ? ""
                            : n
                        : void 0;
                },
            }),
                S.extend({
                    valHooks: {
                        option: {
                            get: function (e) {
                                var t = S.find.attr(e, "value");
                                return null != t ? t : vt(S.text(e));
                            },
                        },
                        select: {
                            get: function (e) {
                                var t,
                                    n,
                                    r,
                                    i = e.options,
                                    o = e.selectedIndex,
                                    a = "select-one" === e.type,
                                    s = a ? null : [],
                                    l = a ? o + 1 : i.length;
                                for (r = o < 0 ? l : a ? o : 0; r < l; r++)
                                    if (((n = i[r]).selected || r === o) && !n.disabled && (!n.parentNode.disabled || !$(n.parentNode, "optgroup"))) {
                                        if (((t = S(n).val()), a)) return t;
                                        s.push(t);
                                    }
                                return s;
                            },
                            set: function (e, t) {
                                for (var n, r, i = e.options, o = S.makeArray(t), a = i.length; a--; ) ((r = i[a]).selected = S.inArray(S.valHooks.option.get(r), o) > -1) && (n = !0);
                                return n || (e.selectedIndex = -1), o;
                            },
                        },
                    },
                }),
                S.each(["radio", "checkbox"], function () {
                    (S.valHooks[this] = {
                        set: function (e, t) {
                            if (Array.isArray(t)) return (e.checked = S.inArray(S(e).val(), t) > -1);
                        },
                    }),
                        g.checkOn ||
                            (S.valHooks[this].get = function (e) {
                                return null === e.getAttribute("value") ? "on" : e.value;
                            });
                }),
                (g.focusin = "onfocusin" in n);
            var xt = /^(?:focusinfocus|focusoutblur)$/,
                Et = function (e) {
                    e.stopPropagation();
                };
            S.extend(S.event, {
                trigger: function (e, t, r, i) {
                    var o,
                        a,
                        s,
                        l,
                        c,
                        u,
                        d,
                        p,
                        f = [r || b],
                        m = h.call(e, "type") ? e.type : e,
                        g = h.call(e, "namespace") ? e.namespace.split(".") : [];
                    if (
                        ((a = p = s = r = r || b),
                        3 !== r.nodeType &&
                            8 !== r.nodeType &&
                            !xt.test(m + S.event.triggered) &&
                            (m.indexOf(".") > -1 && ((g = m.split(".")), (m = g.shift()), g.sort()),
                            (c = m.indexOf(":") < 0 && "on" + m),
                            ((e = e[S.expando] ? e : new S.Event(m, "object" == typeof e && e)).isTrigger = i ? 2 : 3),
                            (e.namespace = g.join(".")),
                            (e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + g.join("\\.(?:.*\\.|)") + "(\\.|$)") : null),
                            (e.result = void 0),
                            e.target || (e.target = r),
                            (t = null == t ? [e] : S.makeArray(t, [e])),
                            (d = S.event.special[m] || {}),
                            i || !d.trigger || !1 !== d.trigger.apply(r, t)))
                    ) {
                        if (!i && !d.noBubble && !y(r)) {
                            for (l = d.delegateType || m, xt.test(l + m) || (a = a.parentNode); a; a = a.parentNode) f.push(a), (s = a);
                            s === (r.ownerDocument || b) && f.push(s.defaultView || s.parentWindow || n);
                        }
                        for (o = 0; (a = f[o++]) && !e.isPropagationStopped(); )
                            (p = a),
                                (e.type = o > 1 ? l : d.bindType || m),
                                (u = (Z.get(a, "events") || Object.create(null))[e.type] && Z.get(a, "handle")) && u.apply(a, t),
                                (u = c && a[c]) && u.apply && K(a) && ((e.result = u.apply(a, t)), !1 === e.result && e.preventDefault());
                        return (
                            (e.type = m),
                            i ||
                                e.isDefaultPrevented() ||
                                (d._default && !1 !== d._default.apply(f.pop(), t)) ||
                                !K(r) ||
                                (c &&
                                    v(r[m]) &&
                                    !y(r) &&
                                    ((s = r[c]) && (r[c] = null),
                                    (S.event.triggered = m),
                                    e.isPropagationStopped() && p.addEventListener(m, Et),
                                    r[m](),
                                    e.isPropagationStopped() && p.removeEventListener(m, Et),
                                    (S.event.triggered = void 0),
                                    s && (r[c] = s))),
                            e.result
                        );
                    }
                },
                simulate: function (e, t, n) {
                    var r = S.extend(new S.Event(), n, { type: e, isSimulated: !0 });
                    S.event.trigger(r, null, t);
                },
            }),
                S.fn.extend({
                    trigger: function (e, t) {
                        return this.each(function () {
                            S.event.trigger(e, t, this);
                        });
                    },
                    triggerHandler: function (e, t) {
                        var n = this[0];
                        if (n) return S.event.trigger(e, t, n, !0);
                    },
                }),
                g.focusin ||
                    S.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
                        var n = function (e) {
                            S.event.simulate(t, e.target, S.event.fix(e));
                        };
                        S.event.special[t] = {
                            setup: function () {
                                var r = this.ownerDocument || this.document || this,
                                    i = Z.access(r, t);
                                i || r.addEventListener(e, n, !0), Z.access(r, t, (i || 0) + 1);
                            },
                            teardown: function () {
                                var r = this.ownerDocument || this.document || this,
                                    i = Z.access(r, t) - 1;
                                i ? Z.access(r, t, i) : (r.removeEventListener(e, n, !0), Z.remove(r, t));
                            },
                        };
                    });
            var Ct = n.location,
                St = { guid: Date.now() },
                Tt = /\?/;
            S.parseXML = function (e) {
                var t, r;
                if (!e || "string" != typeof e) return null;
                try {
                    t = new n.DOMParser().parseFromString(e, "text/xml");
                } catch (e) {}
                return (
                    (r = t && t.getElementsByTagName("parsererror")[0]),
                    (t && !r) ||
                        S.error(
                            "Invalid XML: " +
                                (r
                                    ? S.map(r.childNodes, function (e) {
                                          return e.textContent;
                                      }).join("\n")
                                    : e)
                        ),
                    t
                );
            };
            var kt = /\[\]$/,
                At = /\r?\n/g,
                _t = /^(?:submit|button|image|reset|file)$/i,
                Lt = /^(?:input|select|textarea|keygen)/i;
            function $t(e, t, n, r) {
                var i;
                if (Array.isArray(t))
                    S.each(t, function (t, i) {
                        n || kt.test(e) ? r(e, i) : $t(e + "[" + ("object" == typeof i && null != i ? t : "") + "]", i, n, r);
                    });
                else if (n || "object" !== E(t)) r(e, t);
                else for (i in t) $t(e + "[" + i + "]", t[i], n, r);
            }
            (S.param = function (e, t) {
                var n,
                    r = [],
                    i = function (e, t) {
                        var n = v(t) ? t() : t;
                        r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
                    };
                if (null == e) return "";
                if (Array.isArray(e) || (e.jquery && !S.isPlainObject(e)))
                    S.each(e, function () {
                        i(this.name, this.value);
                    });
                else for (n in e) $t(n, e[n], t, i);
                return r.join("&");
            }),
                S.fn.extend({
                    serialize: function () {
                        return S.param(this.serializeArray());
                    },
                    serializeArray: function () {
                        return this.map(function () {
                            var e = S.prop(this, "elements");
                            return e ? S.makeArray(e) : this;
                        })
                            .filter(function () {
                                var e = this.type;
                                return this.name && !S(this).is(":disabled") && Lt.test(this.nodeName) && !_t.test(e) && (this.checked || !ge.test(e));
                            })
                            .map(function (e, t) {
                                var n = S(this).val();
                                return null == n
                                    ? null
                                    : Array.isArray(n)
                                    ? S.map(n, function (e) {
                                          return { name: t.name, value: e.replace(At, "\r\n") };
                                      })
                                    : { name: t.name, value: n.replace(At, "\r\n") };
                            })
                            .get();
                    },
                });
            var Dt = /%20/g,
                Ot = /#.*$/,
                qt = /([?&])_=[^&]*/,
                Mt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
                Pt = /^(?:GET|HEAD)$/,
                It = /^\/\//,
                Nt = {},
                zt = {},
                Rt = "*/".concat("*"),
                Ft = b.createElement("a");
            function Bt(e) {
                return function (t, n) {
                    "string" != typeof t && ((n = t), (t = "*"));
                    var r,
                        i = 0,
                        o = t.toLowerCase().match(z) || [];
                    if (v(n)) for (; (r = o[i++]); ) "+" === r[0] ? ((r = r.slice(1) || "*"), (e[r] = e[r] || []).unshift(n)) : (e[r] = e[r] || []).push(n);
                };
            }
            function jt(e, t, n, r) {
                var i = {},
                    o = e === zt;
                function a(s) {
                    var l;
                    return (
                        (i[s] = !0),
                        S.each(e[s] || [], function (e, s) {
                            var c = s(t, n, r);
                            return "string" != typeof c || o || i[c] ? (o ? !(l = c) : void 0) : (t.dataTypes.unshift(c), a(c), !1);
                        }),
                        l
                    );
                }
                return a(t.dataTypes[0]) || (!i["*"] && a("*"));
            }
            function Ht(e, t) {
                var n,
                    r,
                    i = S.ajaxSettings.flatOptions || {};
                for (n in t) void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
                return r && S.extend(!0, e, r), e;
            }
            (Ft.href = Ct.href),
                S.extend({
                    active: 0,
                    lastModified: {},
                    etag: {},
                    ajaxSettings: {
                        url: Ct.href,
                        type: "GET",
                        isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Ct.protocol),
                        global: !0,
                        processData: !0,
                        async: !0,
                        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                        accepts: { "*": Rt, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" },
                        contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                        responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" },
                        converters: { "* text": String, "text html": !0, "text json": JSON.parse, "text xml": S.parseXML },
                        flatOptions: { url: !0, context: !0 },
                    },
                    ajaxSetup: function (e, t) {
                        return t ? Ht(Ht(e, S.ajaxSettings), t) : Ht(S.ajaxSettings, e);
                    },
                    ajaxPrefilter: Bt(Nt),
                    ajaxTransport: Bt(zt),
                    ajax: function (e, t) {
                        "object" == typeof e && ((t = e), (e = void 0)), (t = t || {});
                        var r,
                            i,
                            o,
                            a,
                            s,
                            l,
                            c,
                            u,
                            d,
                            p,
                            h = S.ajaxSetup({}, t),
                            f = h.context || h,
                            m = h.context && (f.nodeType || f.jquery) ? S(f) : S.event,
                            g = S.Deferred(),
                            v = S.Callbacks("once memory"),
                            y = h.statusCode || {},
                            w = {},
                            x = {},
                            E = "canceled",
                            C = {
                                readyState: 0,
                                getResponseHeader: function (e) {
                                    var t;
                                    if (c) {
                                        if (!a) for (a = {}; (t = Mt.exec(o)); ) a[t[1].toLowerCase() + " "] = (a[t[1].toLowerCase() + " "] || []).concat(t[2]);
                                        t = a[e.toLowerCase() + " "];
                                    }
                                    return null == t ? null : t.join(", ");
                                },
                                getAllResponseHeaders: function () {
                                    return c ? o : null;
                                },
                                setRequestHeader: function (e, t) {
                                    return null == c && ((e = x[e.toLowerCase()] = x[e.toLowerCase()] || e), (w[e] = t)), this;
                                },
                                overrideMimeType: function (e) {
                                    return null == c && (h.mimeType = e), this;
                                },
                                statusCode: function (e) {
                                    var t;
                                    if (e)
                                        if (c) C.always(e[C.status]);
                                        else for (t in e) y[t] = [y[t], e[t]];
                                    return this;
                                },
                                abort: function (e) {
                                    var t = e || E;
                                    return r && r.abort(t), T(0, t), this;
                                },
                            };
                        if (
                            (g.promise(C),
                            (h.url = ((e || h.url || Ct.href) + "").replace(It, Ct.protocol + "//")),
                            (h.type = t.method || t.type || h.method || h.type),
                            (h.dataTypes = (h.dataType || "*").toLowerCase().match(z) || [""]),
                            null == h.crossDomain)
                        ) {
                            l = b.createElement("a");
                            try {
                                (l.href = h.url), (l.href = l.href), (h.crossDomain = Ft.protocol + "//" + Ft.host != l.protocol + "//" + l.host);
                            } catch (e) {
                                h.crossDomain = !0;
                            }
                        }
                        if ((h.data && h.processData && "string" != typeof h.data && (h.data = S.param(h.data, h.traditional)), jt(Nt, h, t, C), c)) return C;
                        for (d in ((u = S.event && h.global) && 0 == S.active++ && S.event.trigger("ajaxStart"),
                        (h.type = h.type.toUpperCase()),
                        (h.hasContent = !Pt.test(h.type)),
                        (i = h.url.replace(Ot, "")),
                        h.hasContent
                            ? h.data && h.processData && 0 === (h.contentType || "").indexOf("application/x-www-form-urlencoded") && (h.data = h.data.replace(Dt, "+"))
                            : ((p = h.url.slice(i.length)),
                              h.data && (h.processData || "string" == typeof h.data) && ((i += (Tt.test(i) ? "&" : "?") + h.data), delete h.data),
                              !1 === h.cache && ((i = i.replace(qt, "$1")), (p = (Tt.test(i) ? "&" : "?") + "_=" + St.guid++ + p)),
                              (h.url = i + p)),
                        h.ifModified && (S.lastModified[i] && C.setRequestHeader("If-Modified-Since", S.lastModified[i]), S.etag[i] && C.setRequestHeader("If-None-Match", S.etag[i])),
                        ((h.data && h.hasContent && !1 !== h.contentType) || t.contentType) && C.setRequestHeader("Content-Type", h.contentType),
                        C.setRequestHeader("Accept", h.dataTypes[0] && h.accepts[h.dataTypes[0]] ? h.accepts[h.dataTypes[0]] + ("*" !== h.dataTypes[0] ? ", " + Rt + "; q=0.01" : "") : h.accepts["*"]),
                        h.headers))
                            C.setRequestHeader(d, h.headers[d]);
                        if (h.beforeSend && (!1 === h.beforeSend.call(f, C, h) || c)) return C.abort();
                        if (((E = "abort"), v.add(h.complete), C.done(h.success), C.fail(h.error), (r = jt(zt, h, t, C)))) {
                            if (((C.readyState = 1), u && m.trigger("ajaxSend", [C, h]), c)) return C;
                            h.async &&
                                h.timeout > 0 &&
                                (s = n.setTimeout(function () {
                                    C.abort("timeout");
                                }, h.timeout));
                            try {
                                (c = !1), r.send(w, T);
                            } catch (e) {
                                if (c) throw e;
                                T(-1, e);
                            }
                        } else T(-1, "No Transport");
                        function T(e, t, a, l) {
                            var d,
                                p,
                                b,
                                w,
                                x,
                                E = t;
                            c ||
                                ((c = !0),
                                s && n.clearTimeout(s),
                                (r = void 0),
                                (o = l || ""),
                                (C.readyState = e > 0 ? 4 : 0),
                                (d = (e >= 200 && e < 300) || 304 === e),
                                a &&
                                    (w = (function (e, t, n) {
                                        for (var r, i, o, a, s = e.contents, l = e.dataTypes; "*" === l[0]; ) l.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"));
                                        if (r)
                                            for (i in s)
                                                if (s[i] && s[i].test(r)) {
                                                    l.unshift(i);
                                                    break;
                                                }
                                        if (l[0] in n) o = l[0];
                                        else {
                                            for (i in n) {
                                                if (!l[0] || e.converters[i + " " + l[0]]) {
                                                    o = i;
                                                    break;
                                                }
                                                a || (a = i);
                                            }
                                            o = o || a;
                                        }
                                        if (o) return o !== l[0] && l.unshift(o), n[o];
                                    })(h, C, a)),
                                !d && S.inArray("script", h.dataTypes) > -1 && S.inArray("json", h.dataTypes) < 0 && (h.converters["text script"] = function () {}),
                                (w = (function (e, t, n, r) {
                                    var i,
                                        o,
                                        a,
                                        s,
                                        l,
                                        c = {},
                                        u = e.dataTypes.slice();
                                    if (u[1]) for (a in e.converters) c[a.toLowerCase()] = e.converters[a];
                                    for (o = u.shift(); o; )
                                        if ((e.responseFields[o] && (n[e.responseFields[o]] = t), !l && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)), (l = o), (o = u.shift())))
                                            if ("*" === o) o = l;
                                            else if ("*" !== l && l !== o) {
                                                if (!(a = c[l + " " + o] || c["* " + o]))
                                                    for (i in c)
                                                        if ((s = i.split(" "))[1] === o && (a = c[l + " " + s[0]] || c["* " + s[0]])) {
                                                            !0 === a ? (a = c[i]) : !0 !== c[i] && ((o = s[0]), u.unshift(s[1]));
                                                            break;
                                                        }
                                                if (!0 !== a)
                                                    if (a && e.throws) t = a(t);
                                                    else
                                                        try {
                                                            t = a(t);
                                                        } catch (e) {
                                                            return { state: "parsererror", error: a ? e : "No conversion from " + l + " to " + o };
                                                        }
                                            }
                                    return { state: "success", data: t };
                                })(h, w, C, d)),
                                d
                                    ? (h.ifModified && ((x = C.getResponseHeader("Last-Modified")) && (S.lastModified[i] = x), (x = C.getResponseHeader("etag")) && (S.etag[i] = x)),
                                      204 === e || "HEAD" === h.type ? (E = "nocontent") : 304 === e ? (E = "notmodified") : ((E = w.state), (p = w.data), (d = !(b = w.error))))
                                    : ((b = E), (!e && E) || ((E = "error"), e < 0 && (e = 0))),
                                (C.status = e),
                                (C.statusText = (t || E) + ""),
                                d ? g.resolveWith(f, [p, E, C]) : g.rejectWith(f, [C, E, b]),
                                C.statusCode(y),
                                (y = void 0),
                                u && m.trigger(d ? "ajaxSuccess" : "ajaxError", [C, h, d ? p : b]),
                                v.fireWith(f, [C, E]),
                                u && (m.trigger("ajaxComplete", [C, h]), --S.active || S.event.trigger("ajaxStop")));
                        }
                        return C;
                    },
                    getJSON: function (e, t, n) {
                        return S.get(e, t, n, "json");
                    },
                    getScript: function (e, t) {
                        return S.get(e, void 0, t, "script");
                    },
                }),
                S.each(["get", "post"], function (e, t) {
                    S[t] = function (e, n, r, i) {
                        return v(n) && ((i = i || r), (r = n), (n = void 0)), S.ajax(S.extend({ url: e, type: t, dataType: i, data: n, success: r }, S.isPlainObject(e) && e));
                    };
                }),
                S.ajaxPrefilter(function (e) {
                    var t;
                    for (t in e.headers) "content-type" === t.toLowerCase() && (e.contentType = e.headers[t] || "");
                }),
                (S._evalUrl = function (e, t, n) {
                    return S.ajax({
                        url: e,
                        type: "GET",
                        dataType: "script",
                        cache: !0,
                        async: !1,
                        global: !1,
                        converters: { "text script": function () {} },
                        dataFilter: function (e) {
                            S.globalEval(e, t, n);
                        },
                    });
                }),
                S.fn.extend({
                    wrapAll: function (e) {
                        var t;
                        return (
                            this[0] &&
                                (v(e) && (e = e.call(this[0])),
                                (t = S(e, this[0].ownerDocument).eq(0).clone(!0)),
                                this[0].parentNode && t.insertBefore(this[0]),
                                t
                                    .map(function () {
                                        for (var e = this; e.firstElementChild; ) e = e.firstElementChild;
                                        return e;
                                    })
                                    .append(this)),
                            this
                        );
                    },
                    wrapInner: function (e) {
                        return v(e)
                            ? this.each(function (t) {
                                  S(this).wrapInner(e.call(this, t));
                              })
                            : this.each(function () {
                                  var t = S(this),
                                      n = t.contents();
                                  n.length ? n.wrapAll(e) : t.append(e);
                              });
                    },
                    wrap: function (e) {
                        var t = v(e);
                        return this.each(function (n) {
                            S(this).wrapAll(t ? e.call(this, n) : e);
                        });
                    },
                    unwrap: function (e) {
                        return (
                            this.parent(e)
                                .not("body")
                                .each(function () {
                                    S(this).replaceWith(this.childNodes);
                                }),
                            this
                        );
                    },
                }),
                (S.expr.pseudos.hidden = function (e) {
                    return !S.expr.pseudos.visible(e);
                }),
                (S.expr.pseudos.visible = function (e) {
                    return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
                }),
                (S.ajaxSettings.xhr = function () {
                    try {
                        return new n.XMLHttpRequest();
                    } catch (e) {}
                });
            var Vt = { 0: 200, 1223: 204 },
                Wt = S.ajaxSettings.xhr();
            (g.cors = !!Wt && "withCredentials" in Wt),
                (g.ajax = Wt = !!Wt),
                S.ajaxTransport(function (e) {
                    var t, r;
                    if (g.cors || (Wt && !e.crossDomain))
                        return {
                            send: function (i, o) {
                                var a,
                                    s = e.xhr();
                                if ((s.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields)) for (a in e.xhrFields) s[a] = e.xhrFields[a];
                                for (a in (e.mimeType && s.overrideMimeType && s.overrideMimeType(e.mimeType), e.crossDomain || i["X-Requested-With"] || (i["X-Requested-With"] = "XMLHttpRequest"), i)) s.setRequestHeader(a, i[a]);
                                (t = function (e) {
                                    return function () {
                                        t &&
                                            ((t = r = s.onload = s.onerror = s.onabort = s.ontimeout = s.onreadystatechange = null),
                                            "abort" === e
                                                ? s.abort()
                                                : "error" === e
                                                ? "number" != typeof s.status
                                                    ? o(0, "error")
                                                    : o(s.status, s.statusText)
                                                : o(
                                                      Vt[s.status] || s.status,
                                                      s.statusText,
                                                      "text" !== (s.responseType || "text") || "string" != typeof s.responseText ? { binary: s.response } : { text: s.responseText },
                                                      s.getAllResponseHeaders()
                                                  ));
                                    };
                                }),
                                    (s.onload = t()),
                                    (r = s.onerror = s.ontimeout = t("error")),
                                    void 0 !== s.onabort
                                        ? (s.onabort = r)
                                        : (s.onreadystatechange = function () {
                                              4 === s.readyState &&
                                                  n.setTimeout(function () {
                                                      t && r();
                                                  });
                                          }),
                                    (t = t("abort"));
                                try {
                                    s.send((e.hasContent && e.data) || null);
                                } catch (e) {
                                    if (t) throw e;
                                }
                            },
                            abort: function () {
                                t && t();
                            },
                        };
                }),
                S.ajaxPrefilter(function (e) {
                    e.crossDomain && (e.contents.script = !1);
                }),
                S.ajaxSetup({
                    accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" },
                    contents: { script: /\b(?:java|ecma)script\b/ },
                    converters: {
                        "text script": function (e) {
                            return S.globalEval(e), e;
                        },
                    },
                }),
                S.ajaxPrefilter("script", function (e) {
                    void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
                }),
                S.ajaxTransport("script", function (e) {
                    var t, n;
                    if (e.crossDomain || e.scriptAttrs)
                        return {
                            send: function (r, i) {
                                (t = S("<script>")
                                    .attr(e.scriptAttrs || {})
                                    .prop({ charset: e.scriptCharset, src: e.url })
                                    .on(
                                        "load error",
                                        (n = function (e) {
                                            t.remove(), (n = null), e && i("error" === e.type ? 404 : 200, e.type);
                                        })
                                    )),
                                    b.head.appendChild(t[0]);
                            },
                            abort: function () {
                                n && n();
                            },
                        };
                });
            var Ut,
                Gt = [],
                Yt = /(=)\?(?=&|$)|\?\?/;
            S.ajaxSetup({
                jsonp: "callback",
                jsonpCallback: function () {
                    var e = Gt.pop() || S.expando + "_" + St.guid++;
                    return (this[e] = !0), e;
                },
            }),
                S.ajaxPrefilter("json jsonp", function (e, t, r) {
                    var i,
                        o,
                        a,
                        s = !1 !== e.jsonp && (Yt.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && Yt.test(e.data) && "data");
                    if (s || "jsonp" === e.dataTypes[0])
                        return (
                            (i = e.jsonpCallback = v(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
                            s ? (e[s] = e[s].replace(Yt, "$1" + i)) : !1 !== e.jsonp && (e.url += (Tt.test(e.url) ? "&" : "?") + e.jsonp + "=" + i),
                            (e.converters["script json"] = function () {
                                return a || S.error(i + " was not called"), a[0];
                            }),
                            (e.dataTypes[0] = "json"),
                            (o = n[i]),
                            (n[i] = function () {
                                a = arguments;
                            }),
                            r.always(function () {
                                void 0 === o ? S(n).removeProp(i) : (n[i] = o), e[i] && ((e.jsonpCallback = t.jsonpCallback), Gt.push(i)), a && v(o) && o(a[0]), (a = o = void 0);
                            }),
                            "script"
                        );
                }),
                (g.createHTMLDocument = (((Ut = b.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>"), 2 === Ut.childNodes.length)),
                (S.parseHTML = function (e, t, n) {
                    return "string" != typeof e
                        ? []
                        : ("boolean" == typeof t && ((n = t), (t = !1)),
                          t || (g.createHTMLDocument ? (((r = (t = b.implementation.createHTMLDocument("")).createElement("base")).href = b.location.href), t.head.appendChild(r)) : (t = b)),
                          (o = !n && []),
                          (i = D.exec(e)) ? [t.createElement(i[1])] : ((i = Ce([e], t, o)), o && o.length && S(o).remove(), S.merge([], i.childNodes)));
                    var r, i, o;
                }),
                (S.fn.load = function (e, t, n) {
                    var r,
                        i,
                        o,
                        a = this,
                        s = e.indexOf(" ");
                    return (
                        s > -1 && ((r = vt(e.slice(s))), (e = e.slice(0, s))),
                        v(t) ? ((n = t), (t = void 0)) : t && "object" == typeof t && (i = "POST"),
                        a.length > 0 &&
                            S.ajax({ url: e, type: i || "GET", dataType: "html", data: t })
                                .done(function (e) {
                                    (o = arguments), a.html(r ? S("<div>").append(S.parseHTML(e)).find(r) : e);
                                })
                                .always(
                                    n &&
                                        function (e, t) {
                                            a.each(function () {
                                                n.apply(this, o || [e.responseText, t, e]);
                                            });
                                        }
                                ),
                        this
                    );
                }),
                (S.expr.pseudos.animated = function (e) {
                    return S.grep(S.timers, function (t) {
                        return e === t.elem;
                    }).length;
                }),
                (S.offset = {
                    setOffset: function (e, t, n) {
                        var r,
                            i,
                            o,
                            a,
                            s,
                            l,
                            c = S.css(e, "position"),
                            u = S(e),
                            d = {};
                        "static" === c && (e.style.position = "relative"),
                            (s = u.offset()),
                            (o = S.css(e, "top")),
                            (l = S.css(e, "left")),
                            ("absolute" === c || "fixed" === c) && (o + l).indexOf("auto") > -1 ? ((a = (r = u.position()).top), (i = r.left)) : ((a = parseFloat(o) || 0), (i = parseFloat(l) || 0)),
                            v(t) && (t = t.call(e, n, S.extend({}, s))),
                            null != t.top && (d.top = t.top - s.top + a),
                            null != t.left && (d.left = t.left - s.left + i),
                            "using" in t ? t.using.call(e, d) : u.css(d);
                    },
                }),
                S.fn.extend({
                    offset: function (e) {
                        if (arguments.length)
                            return void 0 === e
                                ? this
                                : this.each(function (t) {
                                      S.offset.setOffset(this, e, t);
                                  });
                        var t,
                            n,
                            r = this[0];
                        return r ? (r.getClientRects().length ? ((t = r.getBoundingClientRect()), (n = r.ownerDocument.defaultView), { top: t.top + n.pageYOffset, left: t.left + n.pageXOffset }) : { top: 0, left: 0 }) : void 0;
                    },
                    position: function () {
                        if (this[0]) {
                            var e,
                                t,
                                n,
                                r = this[0],
                                i = { top: 0, left: 0 };
                            if ("fixed" === S.css(r, "position")) t = r.getBoundingClientRect();
                            else {
                                for (t = this.offset(), n = r.ownerDocument, e = r.offsetParent || n.documentElement; e && (e === n.body || e === n.documentElement) && "static" === S.css(e, "position"); ) e = e.parentNode;
                                e && e !== r && 1 === e.nodeType && (((i = S(e).offset()).top += S.css(e, "borderTopWidth", !0)), (i.left += S.css(e, "borderLeftWidth", !0)));
                            }
                            return { top: t.top - i.top - S.css(r, "marginTop", !0), left: t.left - i.left - S.css(r, "marginLeft", !0) };
                        }
                    },
                    offsetParent: function () {
                        return this.map(function () {
                            for (var e = this.offsetParent; e && "static" === S.css(e, "position"); ) e = e.offsetParent;
                            return e || ae;
                        });
                    },
                }),
                S.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (e, t) {
                    var n = "pageYOffset" === t;
                    S.fn[e] = function (r) {
                        return W(
                            this,
                            function (e, r, i) {
                                var o;
                                if ((y(e) ? (o = e) : 9 === e.nodeType && (o = e.defaultView), void 0 === i)) return o ? o[t] : e[r];
                                o ? o.scrollTo(n ? o.pageXOffset : i, n ? i : o.pageYOffset) : (e[r] = i);
                            },
                            e,
                            r,
                            arguments.length
                        );
                    };
                }),
                S.each(["top", "left"], function (e, t) {
                    S.cssHooks[t] = We(g.pixelPosition, function (e, n) {
                        if (n) return (n = Ve(e, t)), Fe.test(n) ? S(e).position()[t] + "px" : n;
                    });
                }),
                S.each({ Height: "height", Width: "width" }, function (e, t) {
                    S.each({ padding: "inner" + e, content: t, "": "outer" + e }, function (n, r) {
                        S.fn[r] = function (i, o) {
                            var a = arguments.length && (n || "boolean" != typeof i),
                                s = n || (!0 === i || !0 === o ? "margin" : "border");
                            return W(
                                this,
                                function (t, n, i) {
                                    var o;
                                    return y(t)
                                        ? 0 === r.indexOf("outer")
                                            ? t["inner" + e]
                                            : t.document.documentElement["client" + e]
                                        : 9 === t.nodeType
                                        ? ((o = t.documentElement), Math.max(t.body["scroll" + e], o["scroll" + e], t.body["offset" + e], o["offset" + e], o["client" + e]))
                                        : void 0 === i
                                        ? S.css(t, n, s)
                                        : S.style(t, n, i, s);
                                },
                                t,
                                a ? i : void 0,
                                a
                            );
                        };
                    });
                }),
                S.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
                    S.fn[t] = function (e) {
                        return this.on(t, e);
                    };
                }),
                S.fn.extend({
                    bind: function (e, t, n) {
                        return this.on(e, null, t, n);
                    },
                    unbind: function (e, t) {
                        return this.off(e, null, t);
                    },
                    delegate: function (e, t, n, r) {
                        return this.on(t, e, n, r);
                    },
                    undelegate: function (e, t, n) {
                        return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
                    },
                    hover: function (e, t) {
                        return this.mouseenter(e).mouseleave(t || e);
                    },
                }),
                S.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (e, t) {
                    S.fn[t] = function (e, n) {
                        return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
                    };
                });
            var Xt = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
            (S.proxy = function (e, t) {
                var n, r, i;
                if (("string" == typeof t && ((n = e[t]), (t = e), (e = n)), v(e)))
                    return (
                        (r = s.call(arguments, 2)),
                        (i = function () {
                            return e.apply(t || this, r.concat(s.call(arguments)));
                        }),
                        (i.guid = e.guid = e.guid || S.guid++),
                        i
                    );
            }),
                (S.holdReady = function (e) {
                    e ? S.readyWait++ : S.ready(!0);
                }),
                (S.isArray = Array.isArray),
                (S.parseJSON = JSON.parse),
                (S.nodeName = $),
                (S.isFunction = v),
                (S.isWindow = y),
                (S.camelCase = X),
                (S.type = E),
                (S.now = Date.now),
                (S.isNumeric = function (e) {
                    var t = S.type(e);
                    return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
                }),
                (S.trim = function (e) {
                    return null == e ? "" : (e + "").replace(Xt, "");
                }),
                void 0 ===
                    (r = function () {
                        return S;
                    }.apply(t, [])) || (e.exports = r);
            var Kt = n.jQuery,
                Jt = n.$;
            return (
                (S.noConflict = function (e) {
                    return n.$ === S && (n.$ = Jt), e && n.jQuery === S && (n.jQuery = Kt), S;
                }),
                void 0 === i && (n.jQuery = n.$ = S),
                S
            );
        });
    },
    function (e, t, n) {
        "use strict";
        (function (e, n) {
            /*!
             * Vue.js v2.6.12
             * (c) 2014-2020 Evan You
             * Released under the MIT License.
             */
            var r = Object.freeze({});
            function i(e) {
                return null == e;
            }
            function o(e) {
                return null != e;
            }
            function a(e) {
                return !0 === e;
            }
            function s(e) {
                return "string" == typeof e || "number" == typeof e || "symbol" == typeof e || "boolean" == typeof e;
            }
            function l(e) {
                return null !== e && "object" == typeof e;
            }
            var c = Object.prototype.toString;
            function u(e) {
                return "[object Object]" === c.call(e);
            }
            function d(e) {
                return "[object RegExp]" === c.call(e);
            }
            function p(e) {
                var t = parseFloat(String(e));
                return t >= 0 && Math.floor(t) === t && isFinite(e);
            }
            function h(e) {
                return o(e) && "function" == typeof e.then && "function" == typeof e.catch;
            }
            function f(e) {
                return null == e ? "" : Array.isArray(e) || (u(e) && e.toString === c) ? JSON.stringify(e, null, 2) : String(e);
            }
            function m(e) {
                var t = parseFloat(e);
                return isNaN(t) ? e : t;
            }
            function g(e, t) {
                for (var n = Object.create(null), r = e.split(","), i = 0; i < r.length; i++) n[r[i]] = !0;
                return t
                    ? function (e) {
                          return n[e.toLowerCase()];
                      }
                    : function (e) {
                          return n[e];
                      };
            }
            var v = g("slot,component", !0),
                y = g("key,ref,slot,slot-scope,is");
            function b(e, t) {
                if (e.length) {
                    var n = e.indexOf(t);
                    if (n > -1) return e.splice(n, 1);
                }
            }
            var w = Object.prototype.hasOwnProperty;
            function x(e, t) {
                return w.call(e, t);
            }
            function E(e) {
                var t = Object.create(null);
                return function (n) {
                    return t[n] || (t[n] = e(n));
                };
            }
            var C = /-(\w)/g,
                S = E(function (e) {
                    return e.replace(C, function (e, t) {
                        return t ? t.toUpperCase() : "";
                    });
                }),
                T = E(function (e) {
                    return e.charAt(0).toUpperCase() + e.slice(1);
                }),
                k = /\B([A-Z])/g,
                A = E(function (e) {
                    return e.replace(k, "-$1").toLowerCase();
                });
            var _ = Function.prototype.bind
                ? function (e, t) {
                      return e.bind(t);
                  }
                : function (e, t) {
                      function n(n) {
                          var r = arguments.length;
                          return r ? (r > 1 ? e.apply(t, arguments) : e.call(t, n)) : e.call(t);
                      }
                      return (n._length = e.length), n;
                  };
            function L(e, t) {
                t = t || 0;
                for (var n = e.length - t, r = new Array(n); n--; ) r[n] = e[n + t];
                return r;
            }
            function $(e, t) {
                for (var n in t) e[n] = t[n];
                return e;
            }
            function D(e) {
                for (var t = {}, n = 0; n < e.length; n++) e[n] && $(t, e[n]);
                return t;
            }
            function O(e, t, n) {}
            var q = function (e, t, n) {
                    return !1;
                },
                M = function (e) {
                    return e;
                };
            function P(e, t) {
                if (e === t) return !0;
                var n = l(e),
                    r = l(t);
                if (!n || !r) return !n && !r && String(e) === String(t);
                try {
                    var i = Array.isArray(e),
                        o = Array.isArray(t);
                    if (i && o)
                        return (
                            e.length === t.length &&
                            e.every(function (e, n) {
                                return P(e, t[n]);
                            })
                        );
                    if (e instanceof Date && t instanceof Date) return e.getTime() === t.getTime();
                    if (i || o) return !1;
                    var a = Object.keys(e),
                        s = Object.keys(t);
                    return (
                        a.length === s.length &&
                        a.every(function (n) {
                            return P(e[n], t[n]);
                        })
                    );
                } catch (e) {
                    return !1;
                }
            }
            function I(e, t) {
                for (var n = 0; n < e.length; n++) if (P(e[n], t)) return n;
                return -1;
            }
            function N(e) {
                var t = !1;
                return function () {
                    t || ((t = !0), e.apply(this, arguments));
                };
            }
            var z = "data-server-rendered",
                R = ["component", "directive", "filter"],
                F = ["beforeCreate", "created", "beforeMount", "mounted", "beforeUpdate", "updated", "beforeDestroy", "destroyed", "activated", "deactivated", "errorCaptured", "serverPrefetch"],
                B = {
                    optionMergeStrategies: Object.create(null),
                    silent: !1,
                    productionTip: !1,
                    devtools: !1,
                    performance: !1,
                    errorHandler: null,
                    warnHandler: null,
                    ignoredElements: [],
                    keyCodes: Object.create(null),
                    isReservedTag: q,
                    isReservedAttr: q,
                    isUnknownElement: q,
                    getTagNamespace: O,
                    parsePlatformTagName: M,
                    mustUseProp: q,
                    async: !0,
                    _lifecycleHooks: F,
                },
                j = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;
            function H(e) {
                var t = (e + "").charCodeAt(0);
                return 36 === t || 95 === t;
            }
            function V(e, t, n, r) {
                Object.defineProperty(e, t, { value: n, enumerable: !!r, writable: !0, configurable: !0 });
            }
            var W = new RegExp("[^" + j.source + ".$_\\d]");
            var U,
                G = "__proto__" in {},
                Y = "undefined" != typeof window,
                X = "undefined" != typeof WXEnvironment && !!WXEnvironment.platform,
                K = X && WXEnvironment.platform.toLowerCase(),
                J = Y && window.navigator.userAgent.toLowerCase(),
                Z = J && /msie|trident/.test(J),
                Q = J && J.indexOf("msie 9.0") > 0,
                ee = J && J.indexOf("edge/") > 0,
                te = (J && J.indexOf("android"), (J && /iphone|ipad|ipod|ios/.test(J)) || "ios" === K),
                ne = (J && /chrome\/\d+/.test(J), J && /phantomjs/.test(J), J && J.match(/firefox\/(\d+)/)),
                re = {}.watch,
                ie = !1;
            if (Y)
                try {
                    var oe = {};
                    Object.defineProperty(oe, "passive", {
                        get: function () {
                            ie = !0;
                        },
                    }),
                        window.addEventListener("test-passive", null, oe);
                } catch (e) {}
            var ae = function () {
                    return void 0 === U && (U = !Y && !X && void 0 !== e && e.process && "server" === e.process.env.VUE_ENV), U;
                },
                se = Y && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
            function le(e) {
                return "function" == typeof e && /native code/.test(e.toString());
            }
            var ce,
                ue = "undefined" != typeof Symbol && le(Symbol) && "undefined" != typeof Reflect && le(Reflect.ownKeys);
            ce =
                "undefined" != typeof Set && le(Set)
                    ? Set
                    : (function () {
                          function e() {
                              this.set = Object.create(null);
                          }
                          return (
                              (e.prototype.has = function (e) {
                                  return !0 === this.set[e];
                              }),
                              (e.prototype.add = function (e) {
                                  this.set[e] = !0;
                              }),
                              (e.prototype.clear = function () {
                                  this.set = Object.create(null);
                              }),
                              e
                          );
                      })();
            var de = O,
                pe = 0,
                he = function () {
                    (this.id = pe++), (this.subs = []);
                };
            (he.prototype.addSub = function (e) {
                this.subs.push(e);
            }),
                (he.prototype.removeSub = function (e) {
                    b(this.subs, e);
                }),
                (he.prototype.depend = function () {
                    he.target && he.target.addDep(this);
                }),
                (he.prototype.notify = function () {
                    var e = this.subs.slice();
                    for (var t = 0, n = e.length; t < n; t++) e[t].update();
                }),
                (he.target = null);
            var fe = [];
            function me(e) {
                fe.push(e), (he.target = e);
            }
            function ge() {
                fe.pop(), (he.target = fe[fe.length - 1]);
            }
            var ve = function (e, t, n, r, i, o, a, s) {
                    (this.tag = e),
                        (this.data = t),
                        (this.children = n),
                        (this.text = r),
                        (this.elm = i),
                        (this.ns = void 0),
                        (this.context = o),
                        (this.fnContext = void 0),
                        (this.fnOptions = void 0),
                        (this.fnScopeId = void 0),
                        (this.key = t && t.key),
                        (this.componentOptions = a),
                        (this.componentInstance = void 0),
                        (this.parent = void 0),
                        (this.raw = !1),
                        (this.isStatic = !1),
                        (this.isRootInsert = !0),
                        (this.isComment = !1),
                        (this.isCloned = !1),
                        (this.isOnce = !1),
                        (this.asyncFactory = s),
                        (this.asyncMeta = void 0),
                        (this.isAsyncPlaceholder = !1);
                },
                ye = { child: { configurable: !0 } };
            (ye.child.get = function () {
                return this.componentInstance;
            }),
                Object.defineProperties(ve.prototype, ye);
            var be = function (e) {
                void 0 === e && (e = "");
                var t = new ve();
                return (t.text = e), (t.isComment = !0), t;
            };
            function we(e) {
                return new ve(void 0, void 0, void 0, String(e));
            }
            function xe(e) {
                var t = new ve(e.tag, e.data, e.children && e.children.slice(), e.text, e.elm, e.context, e.componentOptions, e.asyncFactory);
                return (
                    (t.ns = e.ns),
                    (t.isStatic = e.isStatic),
                    (t.key = e.key),
                    (t.isComment = e.isComment),
                    (t.fnContext = e.fnContext),
                    (t.fnOptions = e.fnOptions),
                    (t.fnScopeId = e.fnScopeId),
                    (t.asyncMeta = e.asyncMeta),
                    (t.isCloned = !0),
                    t
                );
            }
            var Ee = Array.prototype,
                Ce = Object.create(Ee);
            ["push", "pop", "shift", "unshift", "splice", "sort", "reverse"].forEach(function (e) {
                var t = Ee[e];
                V(Ce, e, function () {
                    for (var n = [], r = arguments.length; r--; ) n[r] = arguments[r];
                    var i,
                        o = t.apply(this, n),
                        a = this.__ob__;
                    switch (e) {
                        case "push":
                        case "unshift":
                            i = n;
                            break;
                        case "splice":
                            i = n.slice(2);
                    }
                    return i && a.observeArray(i), a.dep.notify(), o;
                });
            });
            var Se = Object.getOwnPropertyNames(Ce),
                Te = !0;
            function ke(e) {
                Te = e;
            }
            var Ae = function (e) {
                (this.value = e),
                    (this.dep = new he()),
                    (this.vmCount = 0),
                    V(e, "__ob__", this),
                    Array.isArray(e)
                        ? (G
                              ? (function (e, t) {
                                    e.__proto__ = t;
                                })(e, Ce)
                              : (function (e, t, n) {
                                    for (var r = 0, i = n.length; r < i; r++) {
                                        var o = n[r];
                                        V(e, o, t[o]);
                                    }
                                })(e, Ce, Se),
                          this.observeArray(e))
                        : this.walk(e);
            };
            function _e(e, t) {
                var n;
                if (l(e) && !(e instanceof ve))
                    return x(e, "__ob__") && e.__ob__ instanceof Ae ? (n = e.__ob__) : Te && !ae() && (Array.isArray(e) || u(e)) && Object.isExtensible(e) && !e._isVue && (n = new Ae(e)), t && n && n.vmCount++, n;
            }
            function Le(e, t, n, r, i) {
                var o = new he(),
                    a = Object.getOwnPropertyDescriptor(e, t);
                if (!a || !1 !== a.configurable) {
                    var s = a && a.get,
                        l = a && a.set;
                    (s && !l) || 2 !== arguments.length || (n = e[t]);
                    var c = !i && _e(n);
                    Object.defineProperty(e, t, {
                        enumerable: !0,
                        configurable: !0,
                        get: function () {
                            var t = s ? s.call(e) : n;
                            return he.target && (o.depend(), c && (c.dep.depend(), Array.isArray(t) && Oe(t))), t;
                        },
                        set: function (t) {
                            var r = s ? s.call(e) : n;
                            t === r || (t != t && r != r) || (s && !l) || (l ? l.call(e, t) : (n = t), (c = !i && _e(t)), o.notify());
                        },
                    });
                }
            }
            function $e(e, t, n) {
                if (Array.isArray(e) && p(t)) return (e.length = Math.max(e.length, t)), e.splice(t, 1, n), n;
                if (t in e && !(t in Object.prototype)) return (e[t] = n), n;
                var r = e.__ob__;
                return e._isVue || (r && r.vmCount) ? n : r ? (Le(r.value, t, n), r.dep.notify(), n) : ((e[t] = n), n);
            }
            function De(e, t) {
                if (Array.isArray(e) && p(t)) e.splice(t, 1);
                else {
                    var n = e.__ob__;
                    e._isVue || (n && n.vmCount) || (x(e, t) && (delete e[t], n && n.dep.notify()));
                }
            }
            function Oe(e) {
                for (var t = void 0, n = 0, r = e.length; n < r; n++) (t = e[n]) && t.__ob__ && t.__ob__.dep.depend(), Array.isArray(t) && Oe(t);
            }
            (Ae.prototype.walk = function (e) {
                for (var t = Object.keys(e), n = 0; n < t.length; n++) Le(e, t[n]);
            }),
                (Ae.prototype.observeArray = function (e) {
                    for (var t = 0, n = e.length; t < n; t++) _e(e[t]);
                });
            var qe = B.optionMergeStrategies;
            function Me(e, t) {
                if (!t) return e;
                for (var n, r, i, o = ue ? Reflect.ownKeys(t) : Object.keys(t), a = 0; a < o.length; a++) "__ob__" !== (n = o[a]) && ((r = e[n]), (i = t[n]), x(e, n) ? r !== i && u(r) && u(i) && Me(r, i) : $e(e, n, i));
                return e;
            }
            function Pe(e, t, n) {
                return n
                    ? function () {
                          var r = "function" == typeof t ? t.call(n, n) : t,
                              i = "function" == typeof e ? e.call(n, n) : e;
                          return r ? Me(r, i) : i;
                      }
                    : t
                    ? e
                        ? function () {
                              return Me("function" == typeof t ? t.call(this, this) : t, "function" == typeof e ? e.call(this, this) : e);
                          }
                        : t
                    : e;
            }
            function Ie(e, t) {
                var n = t ? (e ? e.concat(t) : Array.isArray(t) ? t : [t]) : e;
                return n
                    ? (function (e) {
                          for (var t = [], n = 0; n < e.length; n++) -1 === t.indexOf(e[n]) && t.push(e[n]);
                          return t;
                      })(n)
                    : n;
            }
            function Ne(e, t, n, r) {
                var i = Object.create(e || null);
                return t ? $(i, t) : i;
            }
            (qe.data = function (e, t, n) {
                return n ? Pe(e, t, n) : t && "function" != typeof t ? e : Pe(e, t);
            }),
                F.forEach(function (e) {
                    qe[e] = Ie;
                }),
                R.forEach(function (e) {
                    qe[e + "s"] = Ne;
                }),
                (qe.watch = function (e, t, n, r) {
                    if ((e === re && (e = void 0), t === re && (t = void 0), !t)) return Object.create(e || null);
                    if (!e) return t;
                    var i = {};
                    for (var o in ($(i, e), t)) {
                        var a = i[o],
                            s = t[o];
                        a && !Array.isArray(a) && (a = [a]), (i[o] = a ? a.concat(s) : Array.isArray(s) ? s : [s]);
                    }
                    return i;
                }),
                (qe.props = qe.methods = qe.inject = qe.computed = function (e, t, n, r) {
                    if (!e) return t;
                    var i = Object.create(null);
                    return $(i, e), t && $(i, t), i;
                }),
                (qe.provide = Pe);
            var ze = function (e, t) {
                return void 0 === t ? e : t;
            };
            function Re(e, t, n) {
                if (
                    ("function" == typeof t && (t = t.options),
                    (function (e, t) {
                        var n = e.props;
                        if (n) {
                            var r,
                                i,
                                o = {};
                            if (Array.isArray(n)) for (r = n.length; r--; ) "string" == typeof (i = n[r]) && (o[S(i)] = { type: null });
                            else if (u(n)) for (var a in n) (i = n[a]), (o[S(a)] = u(i) ? i : { type: i });
                            e.props = o;
                        }
                    })(t),
                    (function (e, t) {
                        var n = e.inject;
                        if (n) {
                            var r = (e.inject = {});
                            if (Array.isArray(n)) for (var i = 0; i < n.length; i++) r[n[i]] = { from: n[i] };
                            else if (u(n))
                                for (var o in n) {
                                    var a = n[o];
                                    r[o] = u(a) ? $({ from: o }, a) : { from: a };
                                }
                        }
                    })(t),
                    (function (e) {
                        var t = e.directives;
                        if (t)
                            for (var n in t) {
                                var r = t[n];
                                "function" == typeof r && (t[n] = { bind: r, update: r });
                            }
                    })(t),
                    !t._base && (t.extends && (e = Re(e, t.extends, n)), t.mixins))
                )
                    for (var r = 0, i = t.mixins.length; r < i; r++) e = Re(e, t.mixins[r], n);
                var o,
                    a = {};
                for (o in e) s(o);
                for (o in t) x(e, o) || s(o);
                function s(r) {
                    var i = qe[r] || ze;
                    a[r] = i(e[r], t[r], n, r);
                }
                return a;
            }
            function Fe(e, t, n, r) {
                if ("string" == typeof n) {
                    var i = e[t];
                    if (x(i, n)) return i[n];
                    var o = S(n);
                    if (x(i, o)) return i[o];
                    var a = T(o);
                    return x(i, a) ? i[a] : i[n] || i[o] || i[a];
                }
            }
            function Be(e, t, n, r) {
                var i = t[e],
                    o = !x(n, e),
                    a = n[e],
                    s = Ve(Boolean, i.type);
                if (s > -1)
                    if (o && !x(i, "default")) a = !1;
                    else if ("" === a || a === A(e)) {
                        var l = Ve(String, i.type);
                        (l < 0 || s < l) && (a = !0);
                    }
                if (void 0 === a) {
                    a = (function (e, t, n) {
                        if (!x(t, "default")) return;
                        var r = t.default;
                        0;
                        if (e && e.$options.propsData && void 0 === e.$options.propsData[n] && void 0 !== e._props[n]) return e._props[n];
                        return "function" == typeof r && "Function" !== je(t.type) ? r.call(e) : r;
                    })(r, i, e);
                    var c = Te;
                    ke(!0), _e(a), ke(c);
                }
                return a;
            }
            function je(e) {
                var t = e && e.toString().match(/^\s*function (\w+)/);
                return t ? t[1] : "";
            }
            function He(e, t) {
                return je(e) === je(t);
            }
            function Ve(e, t) {
                if (!Array.isArray(t)) return He(t, e) ? 0 : -1;
                for (var n = 0, r = t.length; n < r; n++) if (He(t[n], e)) return n;
                return -1;
            }
            function We(e, t, n) {
                me();
                try {
                    if (t)
                        for (var r = t; (r = r.$parent); ) {
                            var i = r.$options.errorCaptured;
                            if (i)
                                for (var o = 0; o < i.length; o++)
                                    try {
                                        if (!1 === i[o].call(r, e, t, n)) return;
                                    } catch (e) {
                                        Ge(e, r, "errorCaptured hook");
                                    }
                        }
                    Ge(e, t, n);
                } finally {
                    ge();
                }
            }
            function Ue(e, t, n, r, i) {
                var o;
                try {
                    (o = n ? e.apply(t, n) : e.call(t)) &&
                        !o._isVue &&
                        h(o) &&
                        !o._handled &&
                        (o.catch(function (e) {
                            return We(e, r, i + " (Promise/async)");
                        }),
                        (o._handled = !0));
                } catch (e) {
                    We(e, r, i);
                }
                return o;
            }
            function Ge(e, t, n) {
                if (B.errorHandler)
                    try {
                        return B.errorHandler.call(null, e, t, n);
                    } catch (t) {
                        t !== e && Ye(t, null, "config.errorHandler");
                    }
                Ye(e, t, n);
            }
            function Ye(e, t, n) {
                if ((!Y && !X) || "undefined" == typeof console) throw e;
                console.error(e);
            }
            var Xe,
                Ke = !1,
                Je = [],
                Ze = !1;
            function Qe() {
                Ze = !1;
                var e = Je.slice(0);
                Je.length = 0;
                for (var t = 0; t < e.length; t++) e[t]();
            }
            if ("undefined" != typeof Promise && le(Promise)) {
                var et = Promise.resolve();
                (Xe = function () {
                    et.then(Qe), te && setTimeout(O);
                }),
                    (Ke = !0);
            } else if (Z || "undefined" == typeof MutationObserver || (!le(MutationObserver) && "[object MutationObserverConstructor]" !== MutationObserver.toString()))
                Xe =
                    void 0 !== n && le(n)
                        ? function () {
                              n(Qe);
                          }
                        : function () {
                              setTimeout(Qe, 0);
                          };
            else {
                var tt = 1,
                    nt = new MutationObserver(Qe),
                    rt = document.createTextNode(String(tt));
                nt.observe(rt, { characterData: !0 }),
                    (Xe = function () {
                        (tt = (tt + 1) % 2), (rt.data = String(tt));
                    }),
                    (Ke = !0);
            }
            function it(e, t) {
                var n;
                if (
                    (Je.push(function () {
                        if (e)
                            try {
                                e.call(t);
                            } catch (e) {
                                We(e, t, "nextTick");
                            }
                        else n && n(t);
                    }),
                    Ze || ((Ze = !0), Xe()),
                    !e && "undefined" != typeof Promise)
                )
                    return new Promise(function (e) {
                        n = e;
                    });
            }
            var ot = new ce();
            function at(e) {
                st(e, ot), ot.clear();
            }
            function st(e, t) {
                var n,
                    r,
                    i = Array.isArray(e);
                if (!((!i && !l(e)) || Object.isFrozen(e) || e instanceof ve)) {
                    if (e.__ob__) {
                        var o = e.__ob__.dep.id;
                        if (t.has(o)) return;
                        t.add(o);
                    }
                    if (i) for (n = e.length; n--; ) st(e[n], t);
                    else for (n = (r = Object.keys(e)).length; n--; ) st(e[r[n]], t);
                }
            }
            var lt = E(function (e) {
                var t = "&" === e.charAt(0),
                    n = "~" === (e = t ? e.slice(1) : e).charAt(0),
                    r = "!" === (e = n ? e.slice(1) : e).charAt(0);
                return { name: (e = r ? e.slice(1) : e), once: n, capture: r, passive: t };
            });
            function ct(e, t) {
                function n() {
                    var e = arguments,
                        r = n.fns;
                    if (!Array.isArray(r)) return Ue(r, null, arguments, t, "v-on handler");
                    for (var i = r.slice(), o = 0; o < i.length; o++) Ue(i[o], null, e, t, "v-on handler");
                }
                return (n.fns = e), n;
            }
            function ut(e, t, n, r, o, s) {
                var l, c, u, d;
                for (l in e)
                    (c = e[l]),
                        (u = t[l]),
                        (d = lt(l)),
                        i(c) || (i(u) ? (i(c.fns) && (c = e[l] = ct(c, s)), a(d.once) && (c = e[l] = o(d.name, c, d.capture)), n(d.name, c, d.capture, d.passive, d.params)) : c !== u && ((u.fns = c), (e[l] = u)));
                for (l in t) i(e[l]) && r((d = lt(l)).name, t[l], d.capture);
            }
            function dt(e, t, n) {
                var r;
                e instanceof ve && (e = e.data.hook || (e.data.hook = {}));
                var s = e[t];
                function l() {
                    n.apply(this, arguments), b(r.fns, l);
                }
                i(s) ? (r = ct([l])) : o(s.fns) && a(s.merged) ? (r = s).fns.push(l) : (r = ct([s, l])), (r.merged = !0), (e[t] = r);
            }
            function pt(e, t, n, r, i) {
                if (o(t)) {
                    if (x(t, n)) return (e[n] = t[n]), i || delete t[n], !0;
                    if (x(t, r)) return (e[n] = t[r]), i || delete t[r], !0;
                }
                return !1;
            }
            function ht(e) {
                return s(e) ? [we(e)] : Array.isArray(e) ? mt(e) : void 0;
            }
            function ft(e) {
                return o(e) && o(e.text) && !1 === e.isComment;
            }
            function mt(e, t) {
                var n,
                    r,
                    l,
                    c,
                    u = [];
                for (n = 0; n < e.length; n++)
                    i((r = e[n])) ||
                        "boolean" == typeof r ||
                        ((c = u[(l = u.length - 1)]),
                        Array.isArray(r)
                            ? r.length > 0 && (ft((r = mt(r, (t || "") + "_" + n))[0]) && ft(c) && ((u[l] = we(c.text + r[0].text)), r.shift()), u.push.apply(u, r))
                            : s(r)
                            ? ft(c)
                                ? (u[l] = we(c.text + r))
                                : "" !== r && u.push(we(r))
                            : ft(r) && ft(c)
                            ? (u[l] = we(c.text + r.text))
                            : (a(e._isVList) && o(r.tag) && i(r.key) && o(t) && (r.key = "__vlist" + t + "_" + n + "__"), u.push(r)));
                return u;
            }
            function gt(e, t) {
                if (e) {
                    for (var n = Object.create(null), r = ue ? Reflect.ownKeys(e) : Object.keys(e), i = 0; i < r.length; i++) {
                        var o = r[i];
                        if ("__ob__" !== o) {
                            for (var a = e[o].from, s = t; s; ) {
                                if (s._provided && x(s._provided, a)) {
                                    n[o] = s._provided[a];
                                    break;
                                }
                                s = s.$parent;
                            }
                            if (!s)
                                if ("default" in e[o]) {
                                    var l = e[o].default;
                                    n[o] = "function" == typeof l ? l.call(t) : l;
                                } else 0;
                        }
                    }
                    return n;
                }
            }
            function vt(e, t) {
                if (!e || !e.length) return {};
                for (var n = {}, r = 0, i = e.length; r < i; r++) {
                    var o = e[r],
                        a = o.data;
                    if ((a && a.attrs && a.attrs.slot && delete a.attrs.slot, (o.context !== t && o.fnContext !== t) || !a || null == a.slot)) (n.default || (n.default = [])).push(o);
                    else {
                        var s = a.slot,
                            l = n[s] || (n[s] = []);
                        "template" === o.tag ? l.push.apply(l, o.children || []) : l.push(o);
                    }
                }
                for (var c in n) n[c].every(yt) && delete n[c];
                return n;
            }
            function yt(e) {
                return (e.isComment && !e.asyncFactory) || " " === e.text;
            }
            function bt(e, t, n) {
                var i,
                    o = Object.keys(t).length > 0,
                    a = e ? !!e.$stable : !o,
                    s = e && e.$key;
                if (e) {
                    if (e._normalized) return e._normalized;
                    if (a && n && n !== r && s === n.$key && !o && !n.$hasNormal) return n;
                    for (var l in ((i = {}), e)) e[l] && "$" !== l[0] && (i[l] = wt(t, l, e[l]));
                } else i = {};
                for (var c in t) c in i || (i[c] = xt(t, c));
                return e && Object.isExtensible(e) && (e._normalized = i), V(i, "$stable", a), V(i, "$key", s), V(i, "$hasNormal", o), i;
            }
            function wt(e, t, n) {
                var r = function () {
                    var e = arguments.length ? n.apply(null, arguments) : n({});
                    return (e = e && "object" == typeof e && !Array.isArray(e) ? [e] : ht(e)) && (0 === e.length || (1 === e.length && e[0].isComment)) ? void 0 : e;
                };
                return n.proxy && Object.defineProperty(e, t, { get: r, enumerable: !0, configurable: !0 }), r;
            }
            function xt(e, t) {
                return function () {
                    return e[t];
                };
            }
            function Et(e, t) {
                var n, r, i, a, s;
                if (Array.isArray(e) || "string" == typeof e) for (n = new Array(e.length), r = 0, i = e.length; r < i; r++) n[r] = t(e[r], r);
                else if ("number" == typeof e) for (n = new Array(e), r = 0; r < e; r++) n[r] = t(r + 1, r);
                else if (l(e))
                    if (ue && e[Symbol.iterator]) {
                        n = [];
                        for (var c = e[Symbol.iterator](), u = c.next(); !u.done; ) n.push(t(u.value, n.length)), (u = c.next());
                    } else for (a = Object.keys(e), n = new Array(a.length), r = 0, i = a.length; r < i; r++) (s = a[r]), (n[r] = t(e[s], s, r));
                return o(n) || (n = []), (n._isVList = !0), n;
            }
            function Ct(e, t, n, r) {
                var i,
                    o = this.$scopedSlots[e];
                o ? ((n = n || {}), r && (n = $($({}, r), n)), (i = o(n) || t)) : (i = this.$slots[e] || t);
                var a = n && n.slot;
                return a ? this.$createElement("template", { slot: a }, i) : i;
            }
            function St(e) {
                return Fe(this.$options, "filters", e) || M;
            }
            function Tt(e, t) {
                return Array.isArray(e) ? -1 === e.indexOf(t) : e !== t;
            }
            function kt(e, t, n, r, i) {
                var o = B.keyCodes[t] || n;
                return i && r && !B.keyCodes[t] ? Tt(i, r) : o ? Tt(o, e) : r ? A(r) !== t : void 0;
            }
            function At(e, t, n, r, i) {
                if (n)
                    if (l(n)) {
                        var o;
                        Array.isArray(n) && (n = D(n));
                        var a = function (a) {
                            if ("class" === a || "style" === a || y(a)) o = e;
                            else {
                                var s = e.attrs && e.attrs.type;
                                o = r || B.mustUseProp(t, s, a) ? e.domProps || (e.domProps = {}) : e.attrs || (e.attrs = {});
                            }
                            var l = S(a),
                                c = A(a);
                            l in o ||
                                c in o ||
                                ((o[a] = n[a]),
                                i &&
                                    ((e.on || (e.on = {}))["update:" + a] = function (e) {
                                        n[a] = e;
                                    }));
                        };
                        for (var s in n) a(s);
                    } else;
                return e;
            }
            function _t(e, t) {
                var n = this._staticTrees || (this._staticTrees = []),
                    r = n[e];
                return (r && !t) || $t((r = n[e] = this.$options.staticRenderFns[e].call(this._renderProxy, null, this)), "__static__" + e, !1), r;
            }
            function Lt(e, t, n) {
                return $t(e, "__once__" + t + (n ? "_" + n : ""), !0), e;
            }
            function $t(e, t, n) {
                if (Array.isArray(e)) for (var r = 0; r < e.length; r++) e[r] && "string" != typeof e[r] && Dt(e[r], t + "_" + r, n);
                else Dt(e, t, n);
            }
            function Dt(e, t, n) {
                (e.isStatic = !0), (e.key = t), (e.isOnce = n);
            }
            function Ot(e, t) {
                if (t)
                    if (u(t)) {
                        var n = (e.on = e.on ? $({}, e.on) : {});
                        for (var r in t) {
                            var i = n[r],
                                o = t[r];
                            n[r] = i ? [].concat(i, o) : o;
                        }
                    } else;
                return e;
            }
            function qt(e, t, n, r) {
                t = t || { $stable: !n };
                for (var i = 0; i < e.length; i++) {
                    var o = e[i];
                    Array.isArray(o) ? qt(o, t, n) : o && (o.proxy && (o.fn.proxy = !0), (t[o.key] = o.fn));
                }
                return r && (t.$key = r), t;
            }
            function Mt(e, t) {
                for (var n = 0; n < t.length; n += 2) {
                    var r = t[n];
                    "string" == typeof r && r && (e[t[n]] = t[n + 1]);
                }
                return e;
            }
            function Pt(e, t) {
                return "string" == typeof e ? t + e : e;
            }
            function It(e) {
                (e._o = Lt), (e._n = m), (e._s = f), (e._l = Et), (e._t = Ct), (e._q = P), (e._i = I), (e._m = _t), (e._f = St), (e._k = kt), (e._b = At), (e._v = we), (e._e = be), (e._u = qt), (e._g = Ot), (e._d = Mt), (e._p = Pt);
            }
            function Nt(e, t, n, i, o) {
                var s,
                    l = this,
                    c = o.options;
                x(i, "_uid") ? ((s = Object.create(i))._original = i) : ((s = i), (i = i._original));
                var u = a(c._compiled),
                    d = !u;
                (this.data = e),
                    (this.props = t),
                    (this.children = n),
                    (this.parent = i),
                    (this.listeners = e.on || r),
                    (this.injections = gt(c.inject, i)),
                    (this.slots = function () {
                        return l.$slots || bt(e.scopedSlots, (l.$slots = vt(n, i))), l.$slots;
                    }),
                    Object.defineProperty(this, "scopedSlots", {
                        enumerable: !0,
                        get: function () {
                            return bt(e.scopedSlots, this.slots());
                        },
                    }),
                    u && ((this.$options = c), (this.$slots = this.slots()), (this.$scopedSlots = bt(e.scopedSlots, this.$slots))),
                    c._scopeId
                        ? (this._c = function (e, t, n, r) {
                              var o = Ut(s, e, t, n, r, d);
                              return o && !Array.isArray(o) && ((o.fnScopeId = c._scopeId), (o.fnContext = i)), o;
                          })
                        : (this._c = function (e, t, n, r) {
                              return Ut(s, e, t, n, r, d);
                          });
            }
            function zt(e, t, n, r, i) {
                var o = xe(e);
                return (o.fnContext = n), (o.fnOptions = r), t.slot && ((o.data || (o.data = {})).slot = t.slot), o;
            }
            function Rt(e, t) {
                for (var n in t) e[S(n)] = t[n];
            }
            It(Nt.prototype);
            var Ft = {
                    init: function (e, t) {
                        if (e.componentInstance && !e.componentInstance._isDestroyed && e.data.keepAlive) {
                            var n = e;
                            Ft.prepatch(n, n);
                        } else {
                            (e.componentInstance = (function (e, t) {
                                var n = { _isComponent: !0, _parentVnode: e, parent: t },
                                    r = e.data.inlineTemplate;
                                o(r) && ((n.render = r.render), (n.staticRenderFns = r.staticRenderFns));
                                return new e.componentOptions.Ctor(n);
                            })(e, rn)).$mount(t ? e.elm : void 0, t);
                        }
                    },
                    prepatch: function (e, t) {
                        var n = t.componentOptions;
                        !(function (e, t, n, i, o) {
                            0;
                            var a = i.data.scopedSlots,
                                s = e.$scopedSlots,
                                l = !!((a && !a.$stable) || (s !== r && !s.$stable) || (a && e.$scopedSlots.$key !== a.$key)),
                                c = !!(o || e.$options._renderChildren || l);
                            (e.$options._parentVnode = i), (e.$vnode = i), e._vnode && (e._vnode.parent = i);
                            if (((e.$options._renderChildren = o), (e.$attrs = i.data.attrs || r), (e.$listeners = n || r), t && e.$options.props)) {
                                ke(!1);
                                for (var u = e._props, d = e.$options._propKeys || [], p = 0; p < d.length; p++) {
                                    var h = d[p],
                                        f = e.$options.props;
                                    u[h] = Be(h, f, t, e);
                                }
                                ke(!0), (e.$options.propsData = t);
                            }
                            n = n || r;
                            var m = e.$options._parentListeners;
                            (e.$options._parentListeners = n), nn(e, n, m), c && ((e.$slots = vt(o, i.context)), e.$forceUpdate());
                            0;
                        })((t.componentInstance = e.componentInstance), n.propsData, n.listeners, t, n.children);
                    },
                    insert: function (e) {
                        var t,
                            n = e.context,
                            r = e.componentInstance;
                        r._isMounted || ((r._isMounted = !0), cn(r, "mounted")), e.data.keepAlive && (n._isMounted ? (((t = r)._inactive = !1), dn.push(t)) : sn(r, !0));
                    },
                    destroy: function (e) {
                        var t = e.componentInstance;
                        t._isDestroyed || (e.data.keepAlive ? ln(t, !0) : t.$destroy());
                    },
                },
                Bt = Object.keys(Ft);
            function jt(e, t, n, s, c) {
                if (!i(e)) {
                    var u = n.$options._base;
                    if ((l(e) && (e = u.extend(e)), "function" == typeof e)) {
                        var d;
                        if (
                            i(e.cid) &&
                            ((e = (function (e, t) {
                                if (a(e.error) && o(e.errorComp)) return e.errorComp;
                                if (o(e.resolved)) return e.resolved;
                                var n = Xt;
                                n && o(e.owners) && -1 === e.owners.indexOf(n) && e.owners.push(n);
                                if (a(e.loading) && o(e.loadingComp)) return e.loadingComp;
                                if (n && !o(e.owners)) {
                                    var r = (e.owners = [n]),
                                        s = !0,
                                        c = null,
                                        u = null;
                                    n.$on("hook:destroyed", function () {
                                        return b(r, n);
                                    });
                                    var d = function (e) {
                                            for (var t = 0, n = r.length; t < n; t++) r[t].$forceUpdate();
                                            e && ((r.length = 0), null !== c && (clearTimeout(c), (c = null)), null !== u && (clearTimeout(u), (u = null)));
                                        },
                                        p = N(function (n) {
                                            (e.resolved = Kt(n, t)), s ? (r.length = 0) : d(!0);
                                        }),
                                        f = N(function (t) {
                                            o(e.errorComp) && ((e.error = !0), d(!0));
                                        }),
                                        m = e(p, f);
                                    return (
                                        l(m) &&
                                            (h(m)
                                                ? i(e.resolved) && m.then(p, f)
                                                : h(m.component) &&
                                                  (m.component.then(p, f),
                                                  o(m.error) && (e.errorComp = Kt(m.error, t)),
                                                  o(m.loading) &&
                                                      ((e.loadingComp = Kt(m.loading, t)),
                                                      0 === m.delay
                                                          ? (e.loading = !0)
                                                          : (c = setTimeout(function () {
                                                                (c = null), i(e.resolved) && i(e.error) && ((e.loading = !0), d(!1));
                                                            }, m.delay || 200))),
                                                  o(m.timeout) &&
                                                      (u = setTimeout(function () {
                                                          (u = null), i(e.resolved) && f(null);
                                                      }, m.timeout)))),
                                        (s = !1),
                                        e.loading ? e.loadingComp : e.resolved
                                    );
                                }
                            })((d = e), u)),
                            void 0 === e)
                        )
                            return (function (e, t, n, r, i) {
                                var o = be();
                                return (o.asyncFactory = e), (o.asyncMeta = { data: t, context: n, children: r, tag: i }), o;
                            })(d, t, n, s, c);
                        (t = t || {}),
                            Dn(e),
                            o(t.model) &&
                                (function (e, t) {
                                    var n = (e.model && e.model.prop) || "value",
                                        r = (e.model && e.model.event) || "input";
                                    (t.attrs || (t.attrs = {}))[n] = t.model.value;
                                    var i = t.on || (t.on = {}),
                                        a = i[r],
                                        s = t.model.callback;
                                    o(a) ? (Array.isArray(a) ? -1 === a.indexOf(s) : a !== s) && (i[r] = [s].concat(a)) : (i[r] = s);
                                })(e.options, t);
                        var p = (function (e, t, n) {
                            var r = t.options.props;
                            if (!i(r)) {
                                var a = {},
                                    s = e.attrs,
                                    l = e.props;
                                if (o(s) || o(l))
                                    for (var c in r) {
                                        var u = A(c);
                                        pt(a, l, c, u, !0) || pt(a, s, c, u, !1);
                                    }
                                return a;
                            }
                        })(t, e);
                        if (a(e.options.functional))
                            return (function (e, t, n, i, a) {
                                var s = e.options,
                                    l = {},
                                    c = s.props;
                                if (o(c)) for (var u in c) l[u] = Be(u, c, t || r);
                                else o(n.attrs) && Rt(l, n.attrs), o(n.props) && Rt(l, n.props);
                                var d = new Nt(n, l, a, i, e),
                                    p = s.render.call(null, d._c, d);
                                if (p instanceof ve) return zt(p, n, d.parent, s);
                                if (Array.isArray(p)) {
                                    for (var h = ht(p) || [], f = new Array(h.length), m = 0; m < h.length; m++) f[m] = zt(h[m], n, d.parent, s);
                                    return f;
                                }
                            })(e, p, t, n, s);
                        var f = t.on;
                        if (((t.on = t.nativeOn), a(e.options.abstract))) {
                            var m = t.slot;
                            (t = {}), m && (t.slot = m);
                        }
                        !(function (e) {
                            for (var t = e.hook || (e.hook = {}), n = 0; n < Bt.length; n++) {
                                var r = Bt[n],
                                    i = t[r],
                                    o = Ft[r];
                                i === o || (i && i._merged) || (t[r] = i ? Ht(o, i) : o);
                            }
                        })(t);
                        var g = e.options.name || c;
                        return new ve("vue-component-" + e.cid + (g ? "-" + g : ""), t, void 0, void 0, void 0, n, { Ctor: e, propsData: p, listeners: f, tag: c, children: s }, d);
                    }
                }
            }
            function Ht(e, t) {
                var n = function (n, r) {
                    e(n, r), t(n, r);
                };
                return (n._merged = !0), n;
            }
            var Vt = 1,
                Wt = 2;
            function Ut(e, t, n, r, i, c) {
                return (
                    (Array.isArray(n) || s(n)) && ((i = r), (r = n), (n = void 0)),
                    a(c) && (i = Wt),
                    (function (e, t, n, r, i) {
                        if (o(n) && o(n.__ob__)) return be();
                        o(n) && o(n.is) && (t = n.is);
                        if (!t) return be();
                        0;
                        Array.isArray(r) && "function" == typeof r[0] && (((n = n || {}).scopedSlots = { default: r[0] }), (r.length = 0));
                        i === Wt
                            ? (r = ht(r))
                            : i === Vt &&
                              (r = (function (e) {
                                  for (var t = 0; t < e.length; t++) if (Array.isArray(e[t])) return Array.prototype.concat.apply([], e);
                                  return e;
                              })(r));
                        var a, s;
                        if ("string" == typeof t) {
                            var c;
                            (s = (e.$vnode && e.$vnode.ns) || B.getTagNamespace(t)),
                                (a = B.isReservedTag(t) ? new ve(B.parsePlatformTagName(t), n, r, void 0, void 0, e) : (n && n.pre) || !o((c = Fe(e.$options, "components", t))) ? new ve(t, n, r, void 0, void 0, e) : jt(c, n, e, r, t));
                        } else a = jt(t, n, e, r);
                        return Array.isArray(a)
                            ? a
                            : o(a)
                            ? (o(s) && Gt(a, s),
                              o(n) &&
                                  (function (e) {
                                      l(e.style) && at(e.style);
                                      l(e.class) && at(e.class);
                                  })(n),
                              a)
                            : be();
                    })(e, t, n, r, i)
                );
            }
            function Gt(e, t, n) {
                if (((e.ns = t), "foreignObject" === e.tag && ((t = void 0), (n = !0)), o(e.children)))
                    for (var r = 0, s = e.children.length; r < s; r++) {
                        var l = e.children[r];
                        o(l.tag) && (i(l.ns) || (a(n) && "svg" !== l.tag)) && Gt(l, t, n);
                    }
            }
            var Yt,
                Xt = null;
            function Kt(e, t) {
                return (e.__esModule || (ue && "Module" === e[Symbol.toStringTag])) && (e = e.default), l(e) ? t.extend(e) : e;
            }
            function Jt(e) {
                return e.isComment && e.asyncFactory;
            }
            function Zt(e) {
                if (Array.isArray(e))
                    for (var t = 0; t < e.length; t++) {
                        var n = e[t];
                        if (o(n) && (o(n.componentOptions) || Jt(n))) return n;
                    }
            }
            function Qt(e, t) {
                Yt.$on(e, t);
            }
            function en(e, t) {
                Yt.$off(e, t);
            }
            function tn(e, t) {
                var n = Yt;
                return function r() {
                    null !== t.apply(null, arguments) && n.$off(e, r);
                };
            }
            function nn(e, t, n) {
                (Yt = e), ut(t, n || {}, Qt, en, tn, e), (Yt = void 0);
            }
            var rn = null;
            function on(e) {
                var t = rn;
                return (
                    (rn = e),
                    function () {
                        rn = t;
                    }
                );
            }
            function an(e) {
                for (; e && (e = e.$parent); ) if (e._inactive) return !0;
                return !1;
            }
            function sn(e, t) {
                if (t) {
                    if (((e._directInactive = !1), an(e))) return;
                } else if (e._directInactive) return;
                if (e._inactive || null === e._inactive) {
                    e._inactive = !1;
                    for (var n = 0; n < e.$children.length; n++) sn(e.$children[n]);
                    cn(e, "activated");
                }
            }
            function ln(e, t) {
                if (!((t && ((e._directInactive = !0), an(e))) || e._inactive)) {
                    e._inactive = !0;
                    for (var n = 0; n < e.$children.length; n++) ln(e.$children[n]);
                    cn(e, "deactivated");
                }
            }
            function cn(e, t) {
                me();
                var n = e.$options[t],
                    r = t + " hook";
                if (n) for (var i = 0, o = n.length; i < o; i++) Ue(n[i], e, null, e, r);
                e._hasHookEvent && e.$emit("hook:" + t), ge();
            }
            var un = [],
                dn = [],
                pn = {},
                hn = !1,
                fn = !1,
                mn = 0;
            var gn = 0,
                vn = Date.now;
            if (Y && !Z) {
                var yn = window.performance;
                yn &&
                    "function" == typeof yn.now &&
                    vn() > document.createEvent("Event").timeStamp &&
                    (vn = function () {
                        return yn.now();
                    });
            }
            function bn() {
                var e, t;
                for (
                    gn = vn(),
                        fn = !0,
                        un.sort(function (e, t) {
                            return e.id - t.id;
                        }),
                        mn = 0;
                    mn < un.length;
                    mn++
                )
                    (e = un[mn]).before && e.before(), (t = e.id), (pn[t] = null), e.run();
                var n = dn.slice(),
                    r = un.slice();
                (mn = un.length = dn.length = 0),
                    (pn = {}),
                    (hn = fn = !1),
                    (function (e) {
                        for (var t = 0; t < e.length; t++) (e[t]._inactive = !0), sn(e[t], !0);
                    })(n),
                    (function (e) {
                        var t = e.length;
                        for (; t--; ) {
                            var n = e[t],
                                r = n.vm;
                            r._watcher === n && r._isMounted && !r._isDestroyed && cn(r, "updated");
                        }
                    })(r),
                    se && B.devtools && se.emit("flush");
            }
            var wn = 0,
                xn = function (e, t, n, r, i) {
                    (this.vm = e),
                        i && (e._watcher = this),
                        e._watchers.push(this),
                        r ? ((this.deep = !!r.deep), (this.user = !!r.user), (this.lazy = !!r.lazy), (this.sync = !!r.sync), (this.before = r.before)) : (this.deep = this.user = this.lazy = this.sync = !1),
                        (this.cb = n),
                        (this.id = ++wn),
                        (this.active = !0),
                        (this.dirty = this.lazy),
                        (this.deps = []),
                        (this.newDeps = []),
                        (this.depIds = new ce()),
                        (this.newDepIds = new ce()),
                        (this.expression = ""),
                        "function" == typeof t
                            ? (this.getter = t)
                            : ((this.getter = (function (e) {
                                  if (!W.test(e)) {
                                      var t = e.split(".");
                                      return function (e) {
                                          for (var n = 0; n < t.length; n++) {
                                              if (!e) return;
                                              e = e[t[n]];
                                          }
                                          return e;
                                      };
                                  }
                              })(t)),
                              this.getter || (this.getter = O)),
                        (this.value = this.lazy ? void 0 : this.get());
                };
            (xn.prototype.get = function () {
                var e;
                me(this);
                var t = this.vm;
                try {
                    e = this.getter.call(t, t);
                } catch (e) {
                    if (!this.user) throw e;
                    We(e, t, 'getter for watcher "' + this.expression + '"');
                } finally {
                    this.deep && at(e), ge(), this.cleanupDeps();
                }
                return e;
            }),
                (xn.prototype.addDep = function (e) {
                    var t = e.id;
                    this.newDepIds.has(t) || (this.newDepIds.add(t), this.newDeps.push(e), this.depIds.has(t) || e.addSub(this));
                }),
                (xn.prototype.cleanupDeps = function () {
                    for (var e = this.deps.length; e--; ) {
                        var t = this.deps[e];
                        this.newDepIds.has(t.id) || t.removeSub(this);
                    }
                    var n = this.depIds;
                    (this.depIds = this.newDepIds), (this.newDepIds = n), this.newDepIds.clear(), (n = this.deps), (this.deps = this.newDeps), (this.newDeps = n), (this.newDeps.length = 0);
                }),
                (xn.prototype.update = function () {
                    this.lazy
                        ? (this.dirty = !0)
                        : this.sync
                        ? this.run()
                        : (function (e) {
                              var t = e.id;
                              if (null == pn[t]) {
                                  if (((pn[t] = !0), fn)) {
                                      for (var n = un.length - 1; n > mn && un[n].id > e.id; ) n--;
                                      un.splice(n + 1, 0, e);
                                  } else un.push(e);
                                  hn || ((hn = !0), it(bn));
                              }
                          })(this);
                }),
                (xn.prototype.run = function () {
                    if (this.active) {
                        var e = this.get();
                        if (e !== this.value || l(e) || this.deep) {
                            var t = this.value;
                            if (((this.value = e), this.user))
                                try {
                                    this.cb.call(this.vm, e, t);
                                } catch (e) {
                                    We(e, this.vm, 'callback for watcher "' + this.expression + '"');
                                }
                            else this.cb.call(this.vm, e, t);
                        }
                    }
                }),
                (xn.prototype.evaluate = function () {
                    (this.value = this.get()), (this.dirty = !1);
                }),
                (xn.prototype.depend = function () {
                    for (var e = this.deps.length; e--; ) this.deps[e].depend();
                }),
                (xn.prototype.teardown = function () {
                    if (this.active) {
                        this.vm._isBeingDestroyed || b(this.vm._watchers, this);
                        for (var e = this.deps.length; e--; ) this.deps[e].removeSub(this);
                        this.active = !1;
                    }
                });
            var En = { enumerable: !0, configurable: !0, get: O, set: O };
            function Cn(e, t, n) {
                (En.get = function () {
                    return this[t][n];
                }),
                    (En.set = function (e) {
                        this[t][n] = e;
                    }),
                    Object.defineProperty(e, n, En);
            }
            function Sn(e) {
                e._watchers = [];
                var t = e.$options;
                t.props &&
                    (function (e, t) {
                        var n = e.$options.propsData || {},
                            r = (e._props = {}),
                            i = (e.$options._propKeys = []),
                            o = !e.$parent;
                        o || ke(!1);
                        var a = function (o) {
                            i.push(o);
                            var a = Be(o, t, n, e);
                            Le(r, o, a), o in e || Cn(e, "_props", o);
                        };
                        for (var s in t) a(s);
                        ke(!0);
                    })(e, t.props),
                    t.methods &&
                        (function (e, t) {
                            e.$options.props;
                            for (var n in t) e[n] = "function" != typeof t[n] ? O : _(t[n], e);
                        })(e, t.methods),
                    t.data
                        ? (function (e) {
                              var t = e.$options.data;
                              (t = e._data =
                                  "function" == typeof t
                                      ? (function (e, t) {
                                            me();
                                            try {
                                                return e.call(t, t);
                                            } catch (e) {
                                                return We(e, t, "data()"), {};
                                            } finally {
                                                ge();
                                            }
                                        })(t, e)
                                      : t || {}),
                                  u(t) || (t = {});
                              var n = Object.keys(t),
                                  r = e.$options.props,
                                  i = (e.$options.methods, n.length);
                              for (; i--; ) {
                                  var o = n[i];
                                  0, (r && x(r, o)) || H(o) || Cn(e, "_data", o);
                              }
                              _e(t, !0);
                          })(e)
                        : _e((e._data = {}), !0),
                    t.computed &&
                        (function (e, t) {
                            var n = (e._computedWatchers = Object.create(null)),
                                r = ae();
                            for (var i in t) {
                                var o = t[i],
                                    a = "function" == typeof o ? o : o.get;
                                0, r || (n[i] = new xn(e, a || O, O, Tn)), i in e || kn(e, i, o);
                            }
                        })(e, t.computed),
                    t.watch &&
                        t.watch !== re &&
                        (function (e, t) {
                            for (var n in t) {
                                var r = t[n];
                                if (Array.isArray(r)) for (var i = 0; i < r.length; i++) Ln(e, n, r[i]);
                                else Ln(e, n, r);
                            }
                        })(e, t.watch);
            }
            var Tn = { lazy: !0 };
            function kn(e, t, n) {
                var r = !ae();
                "function" == typeof n ? ((En.get = r ? An(t) : _n(n)), (En.set = O)) : ((En.get = n.get ? (r && !1 !== n.cache ? An(t) : _n(n.get)) : O), (En.set = n.set || O)), Object.defineProperty(e, t, En);
            }
            function An(e) {
                return function () {
                    var t = this._computedWatchers && this._computedWatchers[e];
                    if (t) return t.dirty && t.evaluate(), he.target && t.depend(), t.value;
                };
            }
            function _n(e) {
                return function () {
                    return e.call(this, this);
                };
            }
            function Ln(e, t, n, r) {
                return u(n) && ((r = n), (n = n.handler)), "string" == typeof n && (n = e[n]), e.$watch(t, n, r);
            }
            var $n = 0;
            function Dn(e) {
                var t = e.options;
                if (e.super) {
                    var n = Dn(e.super);
                    if (n !== e.superOptions) {
                        e.superOptions = n;
                        var r = (function (e) {
                            var t,
                                n = e.options,
                                r = e.sealedOptions;
                            for (var i in n) n[i] !== r[i] && (t || (t = {}), (t[i] = n[i]));
                            return t;
                        })(e);
                        r && $(e.extendOptions, r), (t = e.options = Re(n, e.extendOptions)).name && (t.components[t.name] = e);
                    }
                }
                return t;
            }
            function On(e) {
                this._init(e);
            }
            function qn(e) {
                e.cid = 0;
                var t = 1;
                e.extend = function (e) {
                    e = e || {};
                    var n = this,
                        r = n.cid,
                        i = e._Ctor || (e._Ctor = {});
                    if (i[r]) return i[r];
                    var o = e.name || n.options.name;
                    var a = function (e) {
                        this._init(e);
                    };
                    return (
                        ((a.prototype = Object.create(n.prototype)).constructor = a),
                        (a.cid = t++),
                        (a.options = Re(n.options, e)),
                        (a.super = n),
                        a.options.props &&
                            (function (e) {
                                var t = e.options.props;
                                for (var n in t) Cn(e.prototype, "_props", n);
                            })(a),
                        a.options.computed &&
                            (function (e) {
                                var t = e.options.computed;
                                for (var n in t) kn(e.prototype, n, t[n]);
                            })(a),
                        (a.extend = n.extend),
                        (a.mixin = n.mixin),
                        (a.use = n.use),
                        R.forEach(function (e) {
                            a[e] = n[e];
                        }),
                        o && (a.options.components[o] = a),
                        (a.superOptions = n.options),
                        (a.extendOptions = e),
                        (a.sealedOptions = $({}, a.options)),
                        (i[r] = a),
                        a
                    );
                };
            }
            function Mn(e) {
                return e && (e.Ctor.options.name || e.tag);
            }
            function Pn(e, t) {
                return Array.isArray(e) ? e.indexOf(t) > -1 : "string" == typeof e ? e.split(",").indexOf(t) > -1 : !!d(e) && e.test(t);
            }
            function In(e, t) {
                var n = e.cache,
                    r = e.keys,
                    i = e._vnode;
                for (var o in n) {
                    var a = n[o];
                    if (a) {
                        var s = Mn(a.componentOptions);
                        s && !t(s) && Nn(n, o, r, i);
                    }
                }
            }
            function Nn(e, t, n, r) {
                var i = e[t];
                !i || (r && i.tag === r.tag) || i.componentInstance.$destroy(), (e[t] = null), b(n, t);
            }
            !(function (e) {
                e.prototype._init = function (e) {
                    var t = this;
                    (t._uid = $n++),
                        (t._isVue = !0),
                        e && e._isComponent
                            ? (function (e, t) {
                                  var n = (e.$options = Object.create(e.constructor.options)),
                                      r = t._parentVnode;
                                  (n.parent = t.parent), (n._parentVnode = r);
                                  var i = r.componentOptions;
                                  (n.propsData = i.propsData), (n._parentListeners = i.listeners), (n._renderChildren = i.children), (n._componentTag = i.tag), t.render && ((n.render = t.render), (n.staticRenderFns = t.staticRenderFns));
                              })(t, e)
                            : (t.$options = Re(Dn(t.constructor), e || {}, t)),
                        (t._renderProxy = t),
                        (t._self = t),
                        (function (e) {
                            var t = e.$options,
                                n = t.parent;
                            if (n && !t.abstract) {
                                for (; n.$options.abstract && n.$parent; ) n = n.$parent;
                                n.$children.push(e);
                            }
                            (e.$parent = n),
                                (e.$root = n ? n.$root : e),
                                (e.$children = []),
                                (e.$refs = {}),
                                (e._watcher = null),
                                (e._inactive = null),
                                (e._directInactive = !1),
                                (e._isMounted = !1),
                                (e._isDestroyed = !1),
                                (e._isBeingDestroyed = !1);
                        })(t),
                        (function (e) {
                            (e._events = Object.create(null)), (e._hasHookEvent = !1);
                            var t = e.$options._parentListeners;
                            t && nn(e, t);
                        })(t),
                        (function (e) {
                            (e._vnode = null), (e._staticTrees = null);
                            var t = e.$options,
                                n = (e.$vnode = t._parentVnode),
                                i = n && n.context;
                            (e.$slots = vt(t._renderChildren, i)),
                                (e.$scopedSlots = r),
                                (e._c = function (t, n, r, i) {
                                    return Ut(e, t, n, r, i, !1);
                                }),
                                (e.$createElement = function (t, n, r, i) {
                                    return Ut(e, t, n, r, i, !0);
                                });
                            var o = n && n.data;
                            Le(e, "$attrs", (o && o.attrs) || r, null, !0), Le(e, "$listeners", t._parentListeners || r, null, !0);
                        })(t),
                        cn(t, "beforeCreate"),
                        (function (e) {
                            var t = gt(e.$options.inject, e);
                            t &&
                                (ke(!1),
                                Object.keys(t).forEach(function (n) {
                                    Le(e, n, t[n]);
                                }),
                                ke(!0));
                        })(t),
                        Sn(t),
                        (function (e) {
                            var t = e.$options.provide;
                            t && (e._provided = "function" == typeof t ? t.call(e) : t);
                        })(t),
                        cn(t, "created"),
                        t.$options.el && t.$mount(t.$options.el);
                };
            })(On),
                (function (e) {
                    var t = {
                            get: function () {
                                return this._data;
                            },
                        },
                        n = {
                            get: function () {
                                return this._props;
                            },
                        };
                    Object.defineProperty(e.prototype, "$data", t),
                        Object.defineProperty(e.prototype, "$props", n),
                        (e.prototype.$set = $e),
                        (e.prototype.$delete = De),
                        (e.prototype.$watch = function (e, t, n) {
                            var r = this;
                            if (u(t)) return Ln(r, e, t, n);
                            (n = n || {}).user = !0;
                            var i = new xn(r, e, t, n);
                            if (n.immediate)
                                try {
                                    t.call(r, i.value);
                                } catch (e) {
                                    We(e, r, 'callback for immediate watcher "' + i.expression + '"');
                                }
                            return function () {
                                i.teardown();
                            };
                        });
                })(On),
                (function (e) {
                    var t = /^hook:/;
                    (e.prototype.$on = function (e, n) {
                        var r = this;
                        if (Array.isArray(e)) for (var i = 0, o = e.length; i < o; i++) r.$on(e[i], n);
                        else (r._events[e] || (r._events[e] = [])).push(n), t.test(e) && (r._hasHookEvent = !0);
                        return r;
                    }),
                        (e.prototype.$once = function (e, t) {
                            var n = this;
                            function r() {
                                n.$off(e, r), t.apply(n, arguments);
                            }
                            return (r.fn = t), n.$on(e, r), n;
                        }),
                        (e.prototype.$off = function (e, t) {
                            var n = this;
                            if (!arguments.length) return (n._events = Object.create(null)), n;
                            if (Array.isArray(e)) {
                                for (var r = 0, i = e.length; r < i; r++) n.$off(e[r], t);
                                return n;
                            }
                            var o,
                                a = n._events[e];
                            if (!a) return n;
                            if (!t) return (n._events[e] = null), n;
                            for (var s = a.length; s--; )
                                if ((o = a[s]) === t || o.fn === t) {
                                    a.splice(s, 1);
                                    break;
                                }
                            return n;
                        }),
                        (e.prototype.$emit = function (e) {
                            var t = this,
                                n = t._events[e];
                            if (n) {
                                n = n.length > 1 ? L(n) : n;
                                for (var r = L(arguments, 1), i = 'event handler for "' + e + '"', o = 0, a = n.length; o < a; o++) Ue(n[o], t, r, t, i);
                            }
                            return t;
                        });
                })(On),
                (function (e) {
                    (e.prototype._update = function (e, t) {
                        var n = this,
                            r = n.$el,
                            i = n._vnode,
                            o = on(n);
                        (n._vnode = e),
                            (n.$el = i ? n.__patch__(i, e) : n.__patch__(n.$el, e, t, !1)),
                            o(),
                            r && (r.__vue__ = null),
                            n.$el && (n.$el.__vue__ = n),
                            n.$vnode && n.$parent && n.$vnode === n.$parent._vnode && (n.$parent.$el = n.$el);
                    }),
                        (e.prototype.$forceUpdate = function () {
                            this._watcher && this._watcher.update();
                        }),
                        (e.prototype.$destroy = function () {
                            var e = this;
                            if (!e._isBeingDestroyed) {
                                cn(e, "beforeDestroy"), (e._isBeingDestroyed = !0);
                                var t = e.$parent;
                                !t || t._isBeingDestroyed || e.$options.abstract || b(t.$children, e), e._watcher && e._watcher.teardown();
                                for (var n = e._watchers.length; n--; ) e._watchers[n].teardown();
                                e._data.__ob__ && e._data.__ob__.vmCount--, (e._isDestroyed = !0), e.__patch__(e._vnode, null), cn(e, "destroyed"), e.$off(), e.$el && (e.$el.__vue__ = null), e.$vnode && (e.$vnode.parent = null);
                            }
                        });
                })(On),
                (function (e) {
                    It(e.prototype),
                        (e.prototype.$nextTick = function (e) {
                            return it(e, this);
                        }),
                        (e.prototype._render = function () {
                            var e,
                                t = this,
                                n = t.$options,
                                r = n.render,
                                i = n._parentVnode;
                            i && (t.$scopedSlots = bt(i.data.scopedSlots, t.$slots, t.$scopedSlots)), (t.$vnode = i);
                            try {
                                (Xt = t), (e = r.call(t._renderProxy, t.$createElement));
                            } catch (n) {
                                We(n, t, "render"), (e = t._vnode);
                            } finally {
                                Xt = null;
                            }
                            return Array.isArray(e) && 1 === e.length && (e = e[0]), e instanceof ve || (e = be()), (e.parent = i), e;
                        });
                })(On);
            var zn = [String, RegExp, Array],
                Rn = {
                    KeepAlive: {
                        name: "keep-alive",
                        abstract: !0,
                        props: { include: zn, exclude: zn, max: [String, Number] },
                        created: function () {
                            (this.cache = Object.create(null)), (this.keys = []);
                        },
                        destroyed: function () {
                            for (var e in this.cache) Nn(this.cache, e, this.keys);
                        },
                        mounted: function () {
                            var e = this;
                            this.$watch("include", function (t) {
                                In(e, function (e) {
                                    return Pn(t, e);
                                });
                            }),
                                this.$watch("exclude", function (t) {
                                    In(e, function (e) {
                                        return !Pn(t, e);
                                    });
                                });
                        },
                        render: function () {
                            var e = this.$slots.default,
                                t = Zt(e),
                                n = t && t.componentOptions;
                            if (n) {
                                var r = Mn(n),
                                    i = this.include,
                                    o = this.exclude;
                                if ((i && (!r || !Pn(i, r))) || (o && r && Pn(o, r))) return t;
                                var a = this.cache,
                                    s = this.keys,
                                    l = null == t.key ? n.Ctor.cid + (n.tag ? "::" + n.tag : "") : t.key;
                                a[l] ? ((t.componentInstance = a[l].componentInstance), b(s, l), s.push(l)) : ((a[l] = t), s.push(l), this.max && s.length > parseInt(this.max) && Nn(a, s[0], s, this._vnode)), (t.data.keepAlive = !0);
                            }
                            return t || (e && e[0]);
                        },
                    },
                };
            !(function (e) {
                var t = {
                    get: function () {
                        return B;
                    },
                };
                Object.defineProperty(e, "config", t),
                    (e.util = { warn: de, extend: $, mergeOptions: Re, defineReactive: Le }),
                    (e.set = $e),
                    (e.delete = De),
                    (e.nextTick = it),
                    (e.observable = function (e) {
                        return _e(e), e;
                    }),
                    (e.options = Object.create(null)),
                    R.forEach(function (t) {
                        e.options[t + "s"] = Object.create(null);
                    }),
                    (e.options._base = e),
                    $(e.options.components, Rn),
                    (function (e) {
                        e.use = function (e) {
                            var t = this._installedPlugins || (this._installedPlugins = []);
                            if (t.indexOf(e) > -1) return this;
                            var n = L(arguments, 1);
                            return n.unshift(this), "function" == typeof e.install ? e.install.apply(e, n) : "function" == typeof e && e.apply(null, n), t.push(e), this;
                        };
                    })(e),
                    (function (e) {
                        e.mixin = function (e) {
                            return (this.options = Re(this.options, e)), this;
                        };
                    })(e),
                    qn(e),
                    (function (e) {
                        R.forEach(function (t) {
                            e[t] = function (e, n) {
                                return n
                                    ? ("component" === t && u(n) && ((n.name = n.name || e), (n = this.options._base.extend(n))),
                                      "directive" === t && "function" == typeof n && (n = { bind: n, update: n }),
                                      (this.options[t + "s"][e] = n),
                                      n)
                                    : this.options[t + "s"][e];
                            };
                        });
                    })(e);
            })(On),
                Object.defineProperty(On.prototype, "$isServer", { get: ae }),
                Object.defineProperty(On.prototype, "$ssrContext", {
                    get: function () {
                        return this.$vnode && this.$vnode.ssrContext;
                    },
                }),
                Object.defineProperty(On, "FunctionalRenderContext", { value: Nt }),
                (On.version = "2.6.12");
            var Fn = g("style,class"),
                Bn = g("input,textarea,option,select,progress"),
                jn = function (e, t, n) {
                    return ("value" === n && Bn(e) && "button" !== t) || ("selected" === n && "option" === e) || ("checked" === n && "input" === e) || ("muted" === n && "video" === e);
                },
                Hn = g("contenteditable,draggable,spellcheck"),
                Vn = g("events,caret,typing,plaintext-only"),
                Wn = function (e, t) {
                    return Kn(t) || "false" === t ? "false" : "contenteditable" === e && Vn(t) ? t : "true";
                },
                Un = g(
                    "allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,translate,truespeed,typemustmatch,visible"
                ),
                Gn = "http://www.w3.org/1999/xlink",
                Yn = function (e) {
                    return ":" === e.charAt(5) && "xlink" === e.slice(0, 5);
                },
                Xn = function (e) {
                    return Yn(e) ? e.slice(6, e.length) : "";
                },
                Kn = function (e) {
                    return null == e || !1 === e;
                };
            function Jn(e) {
                for (var t = e.data, n = e, r = e; o(r.componentInstance); ) (r = r.componentInstance._vnode) && r.data && (t = Zn(r.data, t));
                for (; o((n = n.parent)); ) n && n.data && (t = Zn(t, n.data));
                return (function (e, t) {
                    if (o(e) || o(t)) return Qn(e, er(t));
                    return "";
                })(t.staticClass, t.class);
            }
            function Zn(e, t) {
                return { staticClass: Qn(e.staticClass, t.staticClass), class: o(e.class) ? [e.class, t.class] : t.class };
            }
            function Qn(e, t) {
                return e ? (t ? e + " " + t : e) : t || "";
            }
            function er(e) {
                return Array.isArray(e)
                    ? (function (e) {
                          for (var t, n = "", r = 0, i = e.length; r < i; r++) o((t = er(e[r]))) && "" !== t && (n && (n += " "), (n += t));
                          return n;
                      })(e)
                    : l(e)
                    ? (function (e) {
                          var t = "";
                          for (var n in e) e[n] && (t && (t += " "), (t += n));
                          return t;
                      })(e)
                    : "string" == typeof e
                    ? e
                    : "";
            }
            var tr = { svg: "http://www.w3.org/2000/svg", math: "http://www.w3.org/1998/Math/MathML" },
                nr = g(
                    "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"
                ),
                rr = g("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view", !0),
                ir = function (e) {
                    return nr(e) || rr(e);
                };
            function or(e) {
                return rr(e) ? "svg" : "math" === e ? "math" : void 0;
            }
            var ar = Object.create(null);
            var sr = g("text,number,password,search,email,tel,url");
            function lr(e) {
                if ("string" == typeof e) {
                    var t = document.querySelector(e);
                    return t || document.createElement("div");
                }
                return e;
            }
            var cr = Object.freeze({
                    createElement: function (e, t) {
                        var n = document.createElement(e);
                        return "select" !== e || (t.data && t.data.attrs && void 0 !== t.data.attrs.multiple && n.setAttribute("multiple", "multiple")), n;
                    },
                    createElementNS: function (e, t) {
                        return document.createElementNS(tr[e], t);
                    },
                    createTextNode: function (e) {
                        return document.createTextNode(e);
                    },
                    createComment: function (e) {
                        return document.createComment(e);
                    },
                    insertBefore: function (e, t, n) {
                        e.insertBefore(t, n);
                    },
                    removeChild: function (e, t) {
                        e.removeChild(t);
                    },
                    appendChild: function (e, t) {
                        e.appendChild(t);
                    },
                    parentNode: function (e) {
                        return e.parentNode;
                    },
                    nextSibling: function (e) {
                        return e.nextSibling;
                    },
                    tagName: function (e) {
                        return e.tagName;
                    },
                    setTextContent: function (e, t) {
                        e.textContent = t;
                    },
                    setStyleScope: function (e, t) {
                        e.setAttribute(t, "");
                    },
                }),
                ur = {
                    create: function (e, t) {
                        dr(t);
                    },
                    update: function (e, t) {
                        e.data.ref !== t.data.ref && (dr(e, !0), dr(t));
                    },
                    destroy: function (e) {
                        dr(e, !0);
                    },
                };
            function dr(e, t) {
                var n = e.data.ref;
                if (o(n)) {
                    var r = e.context,
                        i = e.componentInstance || e.elm,
                        a = r.$refs;
                    t ? (Array.isArray(a[n]) ? b(a[n], i) : a[n] === i && (a[n] = void 0)) : e.data.refInFor ? (Array.isArray(a[n]) ? a[n].indexOf(i) < 0 && a[n].push(i) : (a[n] = [i])) : (a[n] = i);
                }
            }
            var pr = new ve("", {}, []),
                hr = ["create", "activate", "update", "remove", "destroy"];
            function fr(e, t) {
                return (
                    e.key === t.key &&
                    ((e.tag === t.tag &&
                        e.isComment === t.isComment &&
                        o(e.data) === o(t.data) &&
                        (function (e, t) {
                            if ("input" !== e.tag) return !0;
                            var n,
                                r = o((n = e.data)) && o((n = n.attrs)) && n.type,
                                i = o((n = t.data)) && o((n = n.attrs)) && n.type;
                            return r === i || (sr(r) && sr(i));
                        })(e, t)) ||
                        (a(e.isAsyncPlaceholder) && e.asyncFactory === t.asyncFactory && i(t.asyncFactory.error)))
                );
            }
            function mr(e, t, n) {
                var r,
                    i,
                    a = {};
                for (r = t; r <= n; ++r) o((i = e[r].key)) && (a[i] = r);
                return a;
            }
            var gr = {
                create: vr,
                update: vr,
                destroy: function (e) {
                    vr(e, pr);
                },
            };
            function vr(e, t) {
                (e.data.directives || t.data.directives) &&
                    (function (e, t) {
                        var n,
                            r,
                            i,
                            o = e === pr,
                            a = t === pr,
                            s = br(e.data.directives, e.context),
                            l = br(t.data.directives, t.context),
                            c = [],
                            u = [];
                        for (n in l)
                            (r = s[n]), (i = l[n]), r ? ((i.oldValue = r.value), (i.oldArg = r.arg), xr(i, "update", t, e), i.def && i.def.componentUpdated && u.push(i)) : (xr(i, "bind", t, e), i.def && i.def.inserted && c.push(i));
                        if (c.length) {
                            var d = function () {
                                for (var n = 0; n < c.length; n++) xr(c[n], "inserted", t, e);
                            };
                            o ? dt(t, "insert", d) : d();
                        }
                        u.length &&
                            dt(t, "postpatch", function () {
                                for (var n = 0; n < u.length; n++) xr(u[n], "componentUpdated", t, e);
                            });
                        if (!o) for (n in s) l[n] || xr(s[n], "unbind", e, e, a);
                    })(e, t);
            }
            var yr = Object.create(null);
            function br(e, t) {
                var n,
                    r,
                    i = Object.create(null);
                if (!e) return i;
                for (n = 0; n < e.length; n++) (r = e[n]).modifiers || (r.modifiers = yr), (i[wr(r)] = r), (r.def = Fe(t.$options, "directives", r.name));
                return i;
            }
            function wr(e) {
                return e.rawName || e.name + "." + Object.keys(e.modifiers || {}).join(".");
            }
            function xr(e, t, n, r, i) {
                var o = e.def && e.def[t];
                if (o)
                    try {
                        o(n.elm, e, n, r, i);
                    } catch (r) {
                        We(r, n.context, "directive " + e.name + " " + t + " hook");
                    }
            }
            var Er = [ur, gr];
            function Cr(e, t) {
                var n = t.componentOptions;
                if (!((o(n) && !1 === n.Ctor.options.inheritAttrs) || (i(e.data.attrs) && i(t.data.attrs)))) {
                    var r,
                        a,
                        s = t.elm,
                        l = e.data.attrs || {},
                        c = t.data.attrs || {};
                    for (r in (o(c.__ob__) && (c = t.data.attrs = $({}, c)), c)) (a = c[r]), l[r] !== a && Sr(s, r, a);
                    for (r in ((Z || ee) && c.value !== l.value && Sr(s, "value", c.value), l)) i(c[r]) && (Yn(r) ? s.removeAttributeNS(Gn, Xn(r)) : Hn(r) || s.removeAttribute(r));
                }
            }
            function Sr(e, t, n) {
                e.tagName.indexOf("-") > -1
                    ? Tr(e, t, n)
                    : Un(t)
                    ? Kn(n)
                        ? e.removeAttribute(t)
                        : ((n = "allowfullscreen" === t && "EMBED" === e.tagName ? "true" : t), e.setAttribute(t, n))
                    : Hn(t)
                    ? e.setAttribute(t, Wn(t, n))
                    : Yn(t)
                    ? Kn(n)
                        ? e.removeAttributeNS(Gn, Xn(t))
                        : e.setAttributeNS(Gn, t, n)
                    : Tr(e, t, n);
            }
            function Tr(e, t, n) {
                if (Kn(n)) e.removeAttribute(t);
                else {
                    if (Z && !Q && "TEXTAREA" === e.tagName && "placeholder" === t && "" !== n && !e.__ieph) {
                        var r = function (t) {
                            t.stopImmediatePropagation(), e.removeEventListener("input", r);
                        };
                        e.addEventListener("input", r), (e.__ieph = !0);
                    }
                    e.setAttribute(t, n);
                }
            }
            var kr = { create: Cr, update: Cr };
            function Ar(e, t) {
                var n = t.elm,
                    r = t.data,
                    a = e.data;
                if (!(i(r.staticClass) && i(r.class) && (i(a) || (i(a.staticClass) && i(a.class))))) {
                    var s = Jn(t),
                        l = n._transitionClasses;
                    o(l) && (s = Qn(s, er(l))), s !== n._prevClass && (n.setAttribute("class", s), (n._prevClass = s));
                }
            }
            var _r,
                Lr,
                $r,
                Dr,
                Or,
                qr,
                Mr = { create: Ar, update: Ar },
                Pr = /[\w).+\-_$\]]/;
            function Ir(e) {
                var t,
                    n,
                    r,
                    i,
                    o,
                    a = !1,
                    s = !1,
                    l = !1,
                    c = !1,
                    u = 0,
                    d = 0,
                    p = 0,
                    h = 0;
                for (r = 0; r < e.length; r++)
                    if (((n = t), (t = e.charCodeAt(r)), a)) 39 === t && 92 !== n && (a = !1);
                    else if (s) 34 === t && 92 !== n && (s = !1);
                    else if (l) 96 === t && 92 !== n && (l = !1);
                    else if (c) 47 === t && 92 !== n && (c = !1);
                    else if (124 !== t || 124 === e.charCodeAt(r + 1) || 124 === e.charCodeAt(r - 1) || u || d || p) {
                        switch (t) {
                            case 34:
                                s = !0;
                                break;
                            case 39:
                                a = !0;
                                break;
                            case 96:
                                l = !0;
                                break;
                            case 40:
                                p++;
                                break;
                            case 41:
                                p--;
                                break;
                            case 91:
                                d++;
                                break;
                            case 93:
                                d--;
                                break;
                            case 123:
                                u++;
                                break;
                            case 125:
                                u--;
                        }
                        if (47 === t) {
                            for (var f = r - 1, m = void 0; f >= 0 && " " === (m = e.charAt(f)); f--);
                            (m && Pr.test(m)) || (c = !0);
                        }
                    } else void 0 === i ? ((h = r + 1), (i = e.slice(0, r).trim())) : g();
                function g() {
                    (o || (o = [])).push(e.slice(h, r).trim()), (h = r + 1);
                }
                if ((void 0 === i ? (i = e.slice(0, r).trim()) : 0 !== h && g(), o)) for (r = 0; r < o.length; r++) i = Nr(i, o[r]);
                return i;
            }
            function Nr(e, t) {
                var n = t.indexOf("(");
                if (n < 0) return '_f("' + t + '")(' + e + ")";
                var r = t.slice(0, n),
                    i = t.slice(n + 1);
                return '_f("' + r + '")(' + e + (")" !== i ? "," + i : i);
            }
            function zr(e, t) {
                console.error("[Vue compiler]: " + e);
            }
            function Rr(e, t) {
                return e
                    ? e
                          .map(function (e) {
                              return e[t];
                          })
                          .filter(function (e) {
                              return e;
                          })
                    : [];
            }
            function Fr(e, t, n, r, i) {
                (e.props || (e.props = [])).push(Xr({ name: t, value: n, dynamic: i }, r)), (e.plain = !1);
            }
            function Br(e, t, n, r, i) {
                (i ? e.dynamicAttrs || (e.dynamicAttrs = []) : e.attrs || (e.attrs = [])).push(Xr({ name: t, value: n, dynamic: i }, r)), (e.plain = !1);
            }
            function jr(e, t, n, r) {
                (e.attrsMap[t] = n), e.attrsList.push(Xr({ name: t, value: n }, r));
            }
            function Hr(e, t, n, r, i, o, a, s) {
                (e.directives || (e.directives = [])).push(Xr({ name: t, rawName: n, value: r, arg: i, isDynamicArg: o, modifiers: a }, s)), (e.plain = !1);
            }
            function Vr(e, t, n) {
                return n ? "_p(" + t + ',"' + e + '")' : e + t;
            }
            function Wr(e, t, n, i, o, a, s, l) {
                var c;
                (i = i || r).right
                    ? l
                        ? (t = "(" + t + ")==='click'?'contextmenu':(" + t + ")")
                        : "click" === t && ((t = "contextmenu"), delete i.right)
                    : i.middle && (l ? (t = "(" + t + ")==='click'?'mouseup':(" + t + ")") : "click" === t && (t = "mouseup")),
                    i.capture && (delete i.capture, (t = Vr("!", t, l))),
                    i.once && (delete i.once, (t = Vr("~", t, l))),
                    i.passive && (delete i.passive, (t = Vr("&", t, l))),
                    i.native ? (delete i.native, (c = e.nativeEvents || (e.nativeEvents = {}))) : (c = e.events || (e.events = {}));
                var u = Xr({ value: n.trim(), dynamic: l }, s);
                i !== r && (u.modifiers = i);
                var d = c[t];
                Array.isArray(d) ? (o ? d.unshift(u) : d.push(u)) : (c[t] = d ? (o ? [u, d] : [d, u]) : u), (e.plain = !1);
            }
            function Ur(e, t, n) {
                var r = Gr(e, ":" + t) || Gr(e, "v-bind:" + t);
                if (null != r) return Ir(r);
                if (!1 !== n) {
                    var i = Gr(e, t);
                    if (null != i) return JSON.stringify(i);
                }
            }
            function Gr(e, t, n) {
                var r;
                if (null != (r = e.attrsMap[t]))
                    for (var i = e.attrsList, o = 0, a = i.length; o < a; o++)
                        if (i[o].name === t) {
                            i.splice(o, 1);
                            break;
                        }
                return n && delete e.attrsMap[t], r;
            }
            function Yr(e, t) {
                for (var n = e.attrsList, r = 0, i = n.length; r < i; r++) {
                    var o = n[r];
                    if (t.test(o.name)) return n.splice(r, 1), o;
                }
            }
            function Xr(e, t) {
                return t && (null != t.start && (e.start = t.start), null != t.end && (e.end = t.end)), e;
            }
            function Kr(e, t, n) {
                var r = n || {},
                    i = r.number,
                    o = "$$v",
                    a = o;
                r.trim && (a = "(typeof $$v === 'string'? $$v.trim(): $$v)"), i && (a = "_n(" + a + ")");
                var s = Jr(t, a);
                e.model = { value: "(" + t + ")", expression: JSON.stringify(t), callback: "function ($$v) {" + s + "}" };
            }
            function Jr(e, t) {
                var n = (function (e) {
                    if (((e = e.trim()), (_r = e.length), e.indexOf("[") < 0 || e.lastIndexOf("]") < _r - 1)) return (Dr = e.lastIndexOf(".")) > -1 ? { exp: e.slice(0, Dr), key: '"' + e.slice(Dr + 1) + '"' } : { exp: e, key: null };
                    (Lr = e), (Dr = Or = qr = 0);
                    for (; !Qr(); ) ei(($r = Zr())) ? ni($r) : 91 === $r && ti($r);
                    return { exp: e.slice(0, Or), key: e.slice(Or + 1, qr) };
                })(e);
                return null === n.key ? e + "=" + t : "$set(" + n.exp + ", " + n.key + ", " + t + ")";
            }
            function Zr() {
                return Lr.charCodeAt(++Dr);
            }
            function Qr() {
                return Dr >= _r;
            }
            function ei(e) {
                return 34 === e || 39 === e;
            }
            function ti(e) {
                var t = 1;
                for (Or = Dr; !Qr(); )
                    if (ei((e = Zr()))) ni(e);
                    else if ((91 === e && t++, 93 === e && t--, 0 === t)) {
                        qr = Dr;
                        break;
                    }
            }
            function ni(e) {
                for (var t = e; !Qr() && (e = Zr()) !== t; );
            }
            var ri,
                ii = "__r",
                oi = "__c";
            function ai(e, t, n) {
                var r = ri;
                return function i() {
                    null !== t.apply(null, arguments) && ci(e, i, n, r);
                };
            }
            var si = Ke && !(ne && Number(ne[1]) <= 53);
            function li(e, t, n, r) {
                if (si) {
                    var i = gn,
                        o = t;
                    t = o._wrapper = function (e) {
                        if (e.target === e.currentTarget || e.timeStamp >= i || e.timeStamp <= 0 || e.target.ownerDocument !== document) return o.apply(this, arguments);
                    };
                }
                ri.addEventListener(e, t, ie ? { capture: n, passive: r } : n);
            }
            function ci(e, t, n, r) {
                (r || ri).removeEventListener(e, t._wrapper || t, n);
            }
            function ui(e, t) {
                if (!i(e.data.on) || !i(t.data.on)) {
                    var n = t.data.on || {},
                        r = e.data.on || {};
                    (ri = t.elm),
                        (function (e) {
                            if (o(e[ii])) {
                                var t = Z ? "change" : "input";
                                (e[t] = [].concat(e[ii], e[t] || [])), delete e[ii];
                            }
                            o(e[oi]) && ((e.change = [].concat(e[oi], e.change || [])), delete e[oi]);
                        })(n),
                        ut(n, r, li, ci, ai, t.context),
                        (ri = void 0);
                }
            }
            var di,
                pi = { create: ui, update: ui };
            function hi(e, t) {
                if (!i(e.data.domProps) || !i(t.data.domProps)) {
                    var n,
                        r,
                        a = t.elm,
                        s = e.data.domProps || {},
                        l = t.data.domProps || {};
                    for (n in (o(l.__ob__) && (l = t.data.domProps = $({}, l)), s)) n in l || (a[n] = "");
                    for (n in l) {
                        if (((r = l[n]), "textContent" === n || "innerHTML" === n)) {
                            if ((t.children && (t.children.length = 0), r === s[n])) continue;
                            1 === a.childNodes.length && a.removeChild(a.childNodes[0]);
                        }
                        if ("value" === n && "PROGRESS" !== a.tagName) {
                            a._value = r;
                            var c = i(r) ? "" : String(r);
                            fi(a, c) && (a.value = c);
                        } else if ("innerHTML" === n && rr(a.tagName) && i(a.innerHTML)) {
                            (di = di || document.createElement("div")).innerHTML = "<svg>" + r + "</svg>";
                            for (var u = di.firstChild; a.firstChild; ) a.removeChild(a.firstChild);
                            for (; u.firstChild; ) a.appendChild(u.firstChild);
                        } else if (r !== s[n])
                            try {
                                a[n] = r;
                            } catch (e) {}
                    }
                }
            }
            function fi(e, t) {
                return (
                    !e.composing &&
                    ("OPTION" === e.tagName ||
                        (function (e, t) {
                            var n = !0;
                            try {
                                n = document.activeElement !== e;
                            } catch (e) {}
                            return n && e.value !== t;
                        })(e, t) ||
                        (function (e, t) {
                            var n = e.value,
                                r = e._vModifiers;
                            if (o(r)) {
                                if (r.number) return m(n) !== m(t);
                                if (r.trim) return n.trim() !== t.trim();
                            }
                            return n !== t;
                        })(e, t))
                );
            }
            var mi = { create: hi, update: hi },
                gi = E(function (e) {
                    var t = {},
                        n = /:(.+)/;
                    return (
                        e.split(/;(?![^(]*\))/g).forEach(function (e) {
                            if (e) {
                                var r = e.split(n);
                                r.length > 1 && (t[r[0].trim()] = r[1].trim());
                            }
                        }),
                        t
                    );
                });
            function vi(e) {
                var t = yi(e.style);
                return e.staticStyle ? $(e.staticStyle, t) : t;
            }
            function yi(e) {
                return Array.isArray(e) ? D(e) : "string" == typeof e ? gi(e) : e;
            }
            var bi,
                wi = /^--/,
                xi = /\s*!important$/,
                Ei = function (e, t, n) {
                    if (wi.test(t)) e.style.setProperty(t, n);
                    else if (xi.test(n)) e.style.setProperty(A(t), n.replace(xi, ""), "important");
                    else {
                        var r = Si(t);
                        if (Array.isArray(n)) for (var i = 0, o = n.length; i < o; i++) e.style[r] = n[i];
                        else e.style[r] = n;
                    }
                },
                Ci = ["Webkit", "Moz", "ms"],
                Si = E(function (e) {
                    if (((bi = bi || document.createElement("div").style), "filter" !== (e = S(e)) && e in bi)) return e;
                    for (var t = e.charAt(0).toUpperCase() + e.slice(1), n = 0; n < Ci.length; n++) {
                        var r = Ci[n] + t;
                        if (r in bi) return r;
                    }
                });
            function Ti(e, t) {
                var n = t.data,
                    r = e.data;
                if (!(i(n.staticStyle) && i(n.style) && i(r.staticStyle) && i(r.style))) {
                    var a,
                        s,
                        l = t.elm,
                        c = r.staticStyle,
                        u = r.normalizedStyle || r.style || {},
                        d = c || u,
                        p = yi(t.data.style) || {};
                    t.data.normalizedStyle = o(p.__ob__) ? $({}, p) : p;
                    var h = (function (e, t) {
                        var n,
                            r = {};
                        if (t) for (var i = e; i.componentInstance; ) (i = i.componentInstance._vnode) && i.data && (n = vi(i.data)) && $(r, n);
                        (n = vi(e.data)) && $(r, n);
                        for (var o = e; (o = o.parent); ) o.data && (n = vi(o.data)) && $(r, n);
                        return r;
                    })(t, !0);
                    for (s in d) i(h[s]) && Ei(l, s, "");
                    for (s in h) (a = h[s]) !== d[s] && Ei(l, s, null == a ? "" : a);
                }
            }
            var ki = { create: Ti, update: Ti },
                Ai = /\s+/;
            function _i(e, t) {
                if (t && (t = t.trim()))
                    if (e.classList)
                        t.indexOf(" ") > -1
                            ? t.split(Ai).forEach(function (t) {
                                  return e.classList.add(t);
                              })
                            : e.classList.add(t);
                    else {
                        var n = " " + (e.getAttribute("class") || "") + " ";
                        n.indexOf(" " + t + " ") < 0 && e.setAttribute("class", (n + t).trim());
                    }
            }
            function Li(e, t) {
                if (t && (t = t.trim()))
                    if (e.classList)
                        t.indexOf(" ") > -1
                            ? t.split(Ai).forEach(function (t) {
                                  return e.classList.remove(t);
                              })
                            : e.classList.remove(t),
                            e.classList.length || e.removeAttribute("class");
                    else {
                        for (var n = " " + (e.getAttribute("class") || "") + " ", r = " " + t + " "; n.indexOf(r) >= 0; ) n = n.replace(r, " ");
                        (n = n.trim()) ? e.setAttribute("class", n) : e.removeAttribute("class");
                    }
            }
            function $i(e) {
                if (e) {
                    if ("object" == typeof e) {
                        var t = {};
                        return !1 !== e.css && $(t, Di(e.name || "v")), $(t, e), t;
                    }
                    return "string" == typeof e ? Di(e) : void 0;
                }
            }
            var Di = E(function (e) {
                    return { enterClass: e + "-enter", enterToClass: e + "-enter-to", enterActiveClass: e + "-enter-active", leaveClass: e + "-leave", leaveToClass: e + "-leave-to", leaveActiveClass: e + "-leave-active" };
                }),
                Oi = Y && !Q,
                qi = "transition",
                Mi = "animation",
                Pi = "transition",
                Ii = "transitionend",
                Ni = "animation",
                zi = "animationend";
            Oi &&
                (void 0 === window.ontransitionend && void 0 !== window.onwebkittransitionend && ((Pi = "WebkitTransition"), (Ii = "webkitTransitionEnd")),
                void 0 === window.onanimationend && void 0 !== window.onwebkitanimationend && ((Ni = "WebkitAnimation"), (zi = "webkitAnimationEnd")));
            var Ri = Y
                ? window.requestAnimationFrame
                    ? window.requestAnimationFrame.bind(window)
                    : setTimeout
                : function (e) {
                      return e();
                  };
            function Fi(e) {
                Ri(function () {
                    Ri(e);
                });
            }
            function Bi(e, t) {
                var n = e._transitionClasses || (e._transitionClasses = []);
                n.indexOf(t) < 0 && (n.push(t), _i(e, t));
            }
            function ji(e, t) {
                e._transitionClasses && b(e._transitionClasses, t), Li(e, t);
            }
            function Hi(e, t, n) {
                var r = Wi(e, t),
                    i = r.type,
                    o = r.timeout,
                    a = r.propCount;
                if (!i) return n();
                var s = i === qi ? Ii : zi,
                    l = 0,
                    c = function () {
                        e.removeEventListener(s, u), n();
                    },
                    u = function (t) {
                        t.target === e && ++l >= a && c();
                    };
                setTimeout(function () {
                    l < a && c();
                }, o + 1),
                    e.addEventListener(s, u);
            }
            var Vi = /\b(transform|all)(,|$)/;
            function Wi(e, t) {
                var n,
                    r = window.getComputedStyle(e),
                    i = (r[Pi + "Delay"] || "").split(", "),
                    o = (r[Pi + "Duration"] || "").split(", "),
                    a = Ui(i, o),
                    s = (r[Ni + "Delay"] || "").split(", "),
                    l = (r[Ni + "Duration"] || "").split(", "),
                    c = Ui(s, l),
                    u = 0,
                    d = 0;
                return (
                    t === qi ? a > 0 && ((n = qi), (u = a), (d = o.length)) : t === Mi ? c > 0 && ((n = Mi), (u = c), (d = l.length)) : (d = (n = (u = Math.max(a, c)) > 0 ? (a > c ? qi : Mi) : null) ? (n === qi ? o.length : l.length) : 0),
                    { type: n, timeout: u, propCount: d, hasTransform: n === qi && Vi.test(r[Pi + "Property"]) }
                );
            }
            function Ui(e, t) {
                for (; e.length < t.length; ) e = e.concat(e);
                return Math.max.apply(
                    null,
                    t.map(function (t, n) {
                        return Gi(t) + Gi(e[n]);
                    })
                );
            }
            function Gi(e) {
                return 1e3 * Number(e.slice(0, -1).replace(",", "."));
            }
            function Yi(e, t) {
                var n = e.elm;
                o(n._leaveCb) && ((n._leaveCb.cancelled = !0), n._leaveCb());
                var r = $i(e.data.transition);
                if (!i(r) && !o(n._enterCb) && 1 === n.nodeType) {
                    for (
                        var a = r.css,
                            s = r.type,
                            c = r.enterClass,
                            u = r.enterToClass,
                            d = r.enterActiveClass,
                            p = r.appearClass,
                            h = r.appearToClass,
                            f = r.appearActiveClass,
                            g = r.beforeEnter,
                            v = r.enter,
                            y = r.afterEnter,
                            b = r.enterCancelled,
                            w = r.beforeAppear,
                            x = r.appear,
                            E = r.afterAppear,
                            C = r.appearCancelled,
                            S = r.duration,
                            T = rn,
                            k = rn.$vnode;
                        k && k.parent;

                    )
                        (T = k.context), (k = k.parent);
                    var A = !T._isMounted || !e.isRootInsert;
                    if (!A || x || "" === x) {
                        var _ = A && p ? p : c,
                            L = A && f ? f : d,
                            $ = A && h ? h : u,
                            D = (A && w) || g,
                            O = A && "function" == typeof x ? x : v,
                            q = (A && E) || y,
                            M = (A && C) || b,
                            P = m(l(S) ? S.enter : S);
                        0;
                        var I = !1 !== a && !Q,
                            z = Ji(O),
                            R = (n._enterCb = N(function () {
                                I && (ji(n, $), ji(n, L)), R.cancelled ? (I && ji(n, _), M && M(n)) : q && q(n), (n._enterCb = null);
                            }));
                        e.data.show ||
                            dt(e, "insert", function () {
                                var t = n.parentNode,
                                    r = t && t._pending && t._pending[e.key];
                                r && r.tag === e.tag && r.elm._leaveCb && r.elm._leaveCb(), O && O(n, R);
                            }),
                            D && D(n),
                            I &&
                                (Bi(n, _),
                                Bi(n, L),
                                Fi(function () {
                                    ji(n, _), R.cancelled || (Bi(n, $), z || (Ki(P) ? setTimeout(R, P) : Hi(n, s, R)));
                                })),
                            e.data.show && (t && t(), O && O(n, R)),
                            I || z || R();
                    }
                }
            }
            function Xi(e, t) {
                var n = e.elm;
                o(n._enterCb) && ((n._enterCb.cancelled = !0), n._enterCb());
                var r = $i(e.data.transition);
                if (i(r) || 1 !== n.nodeType) return t();
                if (!o(n._leaveCb)) {
                    var a = r.css,
                        s = r.type,
                        c = r.leaveClass,
                        u = r.leaveToClass,
                        d = r.leaveActiveClass,
                        p = r.beforeLeave,
                        h = r.leave,
                        f = r.afterLeave,
                        g = r.leaveCancelled,
                        v = r.delayLeave,
                        y = r.duration,
                        b = !1 !== a && !Q,
                        w = Ji(h),
                        x = m(l(y) ? y.leave : y);
                    0;
                    var E = (n._leaveCb = N(function () {
                        n.parentNode && n.parentNode._pending && (n.parentNode._pending[e.key] = null), b && (ji(n, u), ji(n, d)), E.cancelled ? (b && ji(n, c), g && g(n)) : (t(), f && f(n)), (n._leaveCb = null);
                    }));
                    v ? v(C) : C();
                }
                function C() {
                    E.cancelled ||
                        (!e.data.show && n.parentNode && ((n.parentNode._pending || (n.parentNode._pending = {}))[e.key] = e),
                        p && p(n),
                        b &&
                            (Bi(n, c),
                            Bi(n, d),
                            Fi(function () {
                                ji(n, c), E.cancelled || (Bi(n, u), w || (Ki(x) ? setTimeout(E, x) : Hi(n, s, E)));
                            })),
                        h && h(n, E),
                        b || w || E());
                }
            }
            function Ki(e) {
                return "number" == typeof e && !isNaN(e);
            }
            function Ji(e) {
                if (i(e)) return !1;
                var t = e.fns;
                return o(t) ? Ji(Array.isArray(t) ? t[0] : t) : (e._length || e.length) > 1;
            }
            function Zi(e, t) {
                !0 !== t.data.show && Yi(t);
            }
            var Qi = (function (e) {
                var t,
                    n,
                    r = {},
                    l = e.modules,
                    c = e.nodeOps;
                for (t = 0; t < hr.length; ++t) for (r[hr[t]] = [], n = 0; n < l.length; ++n) o(l[n][hr[t]]) && r[hr[t]].push(l[n][hr[t]]);
                function u(e) {
                    var t = c.parentNode(e);
                    o(t) && c.removeChild(t, e);
                }
                function d(e, t, n, i, s, l, u) {
                    if (
                        (o(e.elm) && o(l) && (e = l[u] = xe(e)),
                        (e.isRootInsert = !s),
                        !(function (e, t, n, i) {
                            var s = e.data;
                            if (o(s)) {
                                var l = o(e.componentInstance) && s.keepAlive;
                                if ((o((s = s.hook)) && o((s = s.init)) && s(e, !1), o(e.componentInstance)))
                                    return (
                                        p(e, t),
                                        h(n, e.elm, i),
                                        a(l) &&
                                            (function (e, t, n, i) {
                                                var a,
                                                    s = e;
                                                for (; s.componentInstance; )
                                                    if (o((a = (s = s.componentInstance._vnode).data)) && o((a = a.transition))) {
                                                        for (a = 0; a < r.activate.length; ++a) r.activate[a](pr, s);
                                                        t.push(s);
                                                        break;
                                                    }
                                                h(n, e.elm, i);
                                            })(e, t, n, i),
                                        !0
                                    );
                            }
                        })(e, t, n, i))
                    ) {
                        var d = e.data,
                            m = e.children,
                            g = e.tag;
                        o(g)
                            ? ((e.elm = e.ns ? c.createElementNS(e.ns, g) : c.createElement(g, e)), y(e), f(e, m, t), o(d) && v(e, t), h(n, e.elm, i))
                            : a(e.isComment)
                            ? ((e.elm = c.createComment(e.text)), h(n, e.elm, i))
                            : ((e.elm = c.createTextNode(e.text)), h(n, e.elm, i));
                    }
                }
                function p(e, t) {
                    o(e.data.pendingInsert) && (t.push.apply(t, e.data.pendingInsert), (e.data.pendingInsert = null)), (e.elm = e.componentInstance.$el), m(e) ? (v(e, t), y(e)) : (dr(e), t.push(e));
                }
                function h(e, t, n) {
                    o(e) && (o(n) ? c.parentNode(n) === e && c.insertBefore(e, t, n) : c.appendChild(e, t));
                }
                function f(e, t, n) {
                    if (Array.isArray(t)) {
                        0;
                        for (var r = 0; r < t.length; ++r) d(t[r], n, e.elm, null, !0, t, r);
                    } else s(e.text) && c.appendChild(e.elm, c.createTextNode(String(e.text)));
                }
                function m(e) {
                    for (; e.componentInstance; ) e = e.componentInstance._vnode;
                    return o(e.tag);
                }
                function v(e, n) {
                    for (var i = 0; i < r.create.length; ++i) r.create[i](pr, e);
                    o((t = e.data.hook)) && (o(t.create) && t.create(pr, e), o(t.insert) && n.push(e));
                }
                function y(e) {
                    var t;
                    if (o((t = e.fnScopeId))) c.setStyleScope(e.elm, t);
                    else for (var n = e; n; ) o((t = n.context)) && o((t = t.$options._scopeId)) && c.setStyleScope(e.elm, t), (n = n.parent);
                    o((t = rn)) && t !== e.context && t !== e.fnContext && o((t = t.$options._scopeId)) && c.setStyleScope(e.elm, t);
                }
                function b(e, t, n, r, i, o) {
                    for (; r <= i; ++r) d(n[r], o, e, t, !1, n, r);
                }
                function w(e) {
                    var t,
                        n,
                        i = e.data;
                    if (o(i)) for (o((t = i.hook)) && o((t = t.destroy)) && t(e), t = 0; t < r.destroy.length; ++t) r.destroy[t](e);
                    if (o((t = e.children))) for (n = 0; n < e.children.length; ++n) w(e.children[n]);
                }
                function x(e, t, n) {
                    for (; t <= n; ++t) {
                        var r = e[t];
                        o(r) && (o(r.tag) ? (E(r), w(r)) : u(r.elm));
                    }
                }
                function E(e, t) {
                    if (o(t) || o(e.data)) {
                        var n,
                            i = r.remove.length + 1;
                        for (
                            o(t)
                                ? (t.listeners += i)
                                : (t = (function (e, t) {
                                      function n() {
                                          0 == --n.listeners && u(e);
                                      }
                                      return (n.listeners = t), n;
                                  })(e.elm, i)),
                                o((n = e.componentInstance)) && o((n = n._vnode)) && o(n.data) && E(n, t),
                                n = 0;
                            n < r.remove.length;
                            ++n
                        )
                            r.remove[n](e, t);
                        o((n = e.data.hook)) && o((n = n.remove)) ? n(e, t) : t();
                    } else u(e.elm);
                }
                function C(e, t, n, r) {
                    for (var i = n; i < r; i++) {
                        var a = t[i];
                        if (o(a) && fr(e, a)) return i;
                    }
                }
                function S(e, t, n, s, l, u) {
                    if (e !== t) {
                        o(t.elm) && o(s) && (t = s[l] = xe(t));
                        var p = (t.elm = e.elm);
                        if (a(e.isAsyncPlaceholder)) o(t.asyncFactory.resolved) ? A(e.elm, t, n) : (t.isAsyncPlaceholder = !0);
                        else if (a(t.isStatic) && a(e.isStatic) && t.key === e.key && (a(t.isCloned) || a(t.isOnce))) t.componentInstance = e.componentInstance;
                        else {
                            var h,
                                f = t.data;
                            o(f) && o((h = f.hook)) && o((h = h.prepatch)) && h(e, t);
                            var g = e.children,
                                v = t.children;
                            if (o(f) && m(t)) {
                                for (h = 0; h < r.update.length; ++h) r.update[h](e, t);
                                o((h = f.hook)) && o((h = h.update)) && h(e, t);
                            }
                            i(t.text)
                                ? o(g) && o(v)
                                    ? g !== v &&
                                      (function (e, t, n, r, a) {
                                          var s,
                                              l,
                                              u,
                                              p = 0,
                                              h = 0,
                                              f = t.length - 1,
                                              m = t[0],
                                              g = t[f],
                                              v = n.length - 1,
                                              y = n[0],
                                              w = n[v],
                                              E = !a;
                                          for (; p <= f && h <= v; )
                                              i(m)
                                                  ? (m = t[++p])
                                                  : i(g)
                                                  ? (g = t[--f])
                                                  : fr(m, y)
                                                  ? (S(m, y, r, n, h), (m = t[++p]), (y = n[++h]))
                                                  : fr(g, w)
                                                  ? (S(g, w, r, n, v), (g = t[--f]), (w = n[--v]))
                                                  : fr(m, w)
                                                  ? (S(m, w, r, n, v), E && c.insertBefore(e, m.elm, c.nextSibling(g.elm)), (m = t[++p]), (w = n[--v]))
                                                  : fr(g, y)
                                                  ? (S(g, y, r, n, h), E && c.insertBefore(e, g.elm, m.elm), (g = t[--f]), (y = n[++h]))
                                                  : (i(s) && (s = mr(t, p, f)),
                                                    i((l = o(y.key) ? s[y.key] : C(y, t, p, f)))
                                                        ? d(y, r, e, m.elm, !1, n, h)
                                                        : fr((u = t[l]), y)
                                                        ? (S(u, y, r, n, h), (t[l] = void 0), E && c.insertBefore(e, u.elm, m.elm))
                                                        : d(y, r, e, m.elm, !1, n, h),
                                                    (y = n[++h]));
                                          p > f ? b(e, i(n[v + 1]) ? null : n[v + 1].elm, n, h, v, r) : h > v && x(t, p, f);
                                      })(p, g, v, n, u)
                                    : o(v)
                                    ? (o(e.text) && c.setTextContent(p, ""), b(p, null, v, 0, v.length - 1, n))
                                    : o(g)
                                    ? x(g, 0, g.length - 1)
                                    : o(e.text) && c.setTextContent(p, "")
                                : e.text !== t.text && c.setTextContent(p, t.text),
                                o(f) && o((h = f.hook)) && o((h = h.postpatch)) && h(e, t);
                        }
                    }
                }
                function T(e, t, n) {
                    if (a(n) && o(e.parent)) e.parent.data.pendingInsert = t;
                    else for (var r = 0; r < t.length; ++r) t[r].data.hook.insert(t[r]);
                }
                var k = g("attrs,class,staticClass,staticStyle,key");
                function A(e, t, n, r) {
                    var i,
                        s = t.tag,
                        l = t.data,
                        c = t.children;
                    if (((r = r || (l && l.pre)), (t.elm = e), a(t.isComment) && o(t.asyncFactory))) return (t.isAsyncPlaceholder = !0), !0;
                    if (o(l) && (o((i = l.hook)) && o((i = i.init)) && i(t, !0), o((i = t.componentInstance)))) return p(t, n), !0;
                    if (o(s)) {
                        if (o(c))
                            if (e.hasChildNodes())
                                if (o((i = l)) && o((i = i.domProps)) && o((i = i.innerHTML))) {
                                    if (i !== e.innerHTML) return !1;
                                } else {
                                    for (var u = !0, d = e.firstChild, h = 0; h < c.length; h++) {
                                        if (!d || !A(d, c[h], n, r)) {
                                            u = !1;
                                            break;
                                        }
                                        d = d.nextSibling;
                                    }
                                    if (!u || d) return !1;
                                }
                            else f(t, c, n);
                        if (o(l)) {
                            var m = !1;
                            for (var g in l)
                                if (!k(g)) {
                                    (m = !0), v(t, n);
                                    break;
                                }
                            !m && l.class && at(l.class);
                        }
                    } else e.data !== t.text && (e.data = t.text);
                    return !0;
                }
                return function (e, t, n, s) {
                    if (!i(t)) {
                        var l,
                            u = !1,
                            p = [];
                        if (i(e)) (u = !0), d(t, p);
                        else {
                            var h = o(e.nodeType);
                            if (!h && fr(e, t)) S(e, t, p, null, null, s);
                            else {
                                if (h) {
                                    if ((1 === e.nodeType && e.hasAttribute(z) && (e.removeAttribute(z), (n = !0)), a(n) && A(e, t, p))) return T(t, p, !0), e;
                                    (l = e), (e = new ve(c.tagName(l).toLowerCase(), {}, [], void 0, l));
                                }
                                var f = e.elm,
                                    g = c.parentNode(f);
                                if ((d(t, p, f._leaveCb ? null : g, c.nextSibling(f)), o(t.parent)))
                                    for (var v = t.parent, y = m(t); v; ) {
                                        for (var b = 0; b < r.destroy.length; ++b) r.destroy[b](v);
                                        if (((v.elm = t.elm), y)) {
                                            for (var E = 0; E < r.create.length; ++E) r.create[E](pr, v);
                                            var C = v.data.hook.insert;
                                            if (C.merged) for (var k = 1; k < C.fns.length; k++) C.fns[k]();
                                        } else dr(v);
                                        v = v.parent;
                                    }
                                o(g) ? x([e], 0, 0) : o(e.tag) && w(e);
                            }
                        }
                        return T(t, p, u), t.elm;
                    }
                    o(e) && w(e);
                };
            })({
                nodeOps: cr,
                modules: [
                    kr,
                    Mr,
                    pi,
                    mi,
                    ki,
                    Y
                        ? {
                              create: Zi,
                              activate: Zi,
                              remove: function (e, t) {
                                  !0 !== e.data.show ? Xi(e, t) : t();
                              },
                          }
                        : {},
                ].concat(Er),
            });
            Q &&
                document.addEventListener("selectionchange", function () {
                    var e = document.activeElement;
                    e && e.vmodel && so(e, "input");
                });
            var eo = {
                inserted: function (e, t, n, r) {
                    "select" === n.tag
                        ? (r.elm && !r.elm._vOptions
                              ? dt(n, "postpatch", function () {
                                    eo.componentUpdated(e, t, n);
                                })
                              : to(e, t, n.context),
                          (e._vOptions = [].map.call(e.options, io)))
                        : ("textarea" === n.tag || sr(e.type)) &&
                          ((e._vModifiers = t.modifiers), t.modifiers.lazy || (e.addEventListener("compositionstart", oo), e.addEventListener("compositionend", ao), e.addEventListener("change", ao), Q && (e.vmodel = !0)));
                },
                componentUpdated: function (e, t, n) {
                    if ("select" === n.tag) {
                        to(e, t, n.context);
                        var r = e._vOptions,
                            i = (e._vOptions = [].map.call(e.options, io));
                        if (
                            i.some(function (e, t) {
                                return !P(e, r[t]);
                            })
                        )
                            (e.multiple
                                ? t.value.some(function (e) {
                                      return ro(e, i);
                                  })
                                : t.value !== t.oldValue && ro(t.value, i)) && so(e, "change");
                    }
                },
            };
            function to(e, t, n) {
                no(e, t, n),
                    (Z || ee) &&
                        setTimeout(function () {
                            no(e, t, n);
                        }, 0);
            }
            function no(e, t, n) {
                var r = t.value,
                    i = e.multiple;
                if (!i || Array.isArray(r)) {
                    for (var o, a, s = 0, l = e.options.length; s < l; s++)
                        if (((a = e.options[s]), i)) (o = I(r, io(a)) > -1), a.selected !== o && (a.selected = o);
                        else if (P(io(a), r)) return void (e.selectedIndex !== s && (e.selectedIndex = s));
                    i || (e.selectedIndex = -1);
                }
            }
            function ro(e, t) {
                return t.every(function (t) {
                    return !P(t, e);
                });
            }
            function io(e) {
                return "_value" in e ? e._value : e.value;
            }
            function oo(e) {
                e.target.composing = !0;
            }
            function ao(e) {
                e.target.composing && ((e.target.composing = !1), so(e.target, "input"));
            }
            function so(e, t) {
                var n = document.createEvent("HTMLEvents");
                n.initEvent(t, !0, !0), e.dispatchEvent(n);
            }
            function lo(e) {
                return !e.componentInstance || (e.data && e.data.transition) ? e : lo(e.componentInstance._vnode);
            }
            var co = {
                    bind: function (e, t, n) {
                        var r = t.value,
                            i = (n = lo(n)).data && n.data.transition,
                            o = (e.__vOriginalDisplay = "none" === e.style.display ? "" : e.style.display);
                        r && i
                            ? ((n.data.show = !0),
                              Yi(n, function () {
                                  e.style.display = o;
                              }))
                            : (e.style.display = r ? o : "none");
                    },
                    update: function (e, t, n) {
                        var r = t.value;
                        !r != !t.oldValue &&
                            ((n = lo(n)).data && n.data.transition
                                ? ((n.data.show = !0),
                                  r
                                      ? Yi(n, function () {
                                            e.style.display = e.__vOriginalDisplay;
                                        })
                                      : Xi(n, function () {
                                            e.style.display = "none";
                                        }))
                                : (e.style.display = r ? e.__vOriginalDisplay : "none"));
                    },
                    unbind: function (e, t, n, r, i) {
                        i || (e.style.display = e.__vOriginalDisplay);
                    },
                },
                uo = { model: eo, show: co },
                po = {
                    name: String,
                    appear: Boolean,
                    css: Boolean,
                    mode: String,
                    type: String,
                    enterClass: String,
                    leaveClass: String,
                    enterToClass: String,
                    leaveToClass: String,
                    enterActiveClass: String,
                    leaveActiveClass: String,
                    appearClass: String,
                    appearActiveClass: String,
                    appearToClass: String,
                    duration: [Number, String, Object],
                };
            function ho(e) {
                var t = e && e.componentOptions;
                return t && t.Ctor.options.abstract ? ho(Zt(t.children)) : e;
            }
            function fo(e) {
                var t = {},
                    n = e.$options;
                for (var r in n.propsData) t[r] = e[r];
                var i = n._parentListeners;
                for (var o in i) t[S(o)] = i[o];
                return t;
            }
            function mo(e, t) {
                if (/\d-keep-alive$/.test(t.tag)) return e("keep-alive", { props: t.componentOptions.propsData });
            }
            var go = function (e) {
                    return e.tag || Jt(e);
                },
                vo = function (e) {
                    return "show" === e.name;
                },
                yo = {
                    name: "transition",
                    props: po,
                    abstract: !0,
                    render: function (e) {
                        var t = this,
                            n = this.$slots.default;
                        if (n && (n = n.filter(go)).length) {
                            0;
                            var r = this.mode;
                            0;
                            var i = n[0];
                            if (
                                (function (e) {
                                    for (; (e = e.parent); ) if (e.data.transition) return !0;
                                })(this.$vnode)
                            )
                                return i;
                            var o = ho(i);
                            if (!o) return i;
                            if (this._leaving) return mo(e, i);
                            var a = "__transition-" + this._uid + "-";
                            o.key = null == o.key ? (o.isComment ? a + "comment" : a + o.tag) : s(o.key) ? (0 === String(o.key).indexOf(a) ? o.key : a + o.key) : o.key;
                            var l = ((o.data || (o.data = {})).transition = fo(this)),
                                c = this._vnode,
                                u = ho(c);
                            if (
                                (o.data.directives && o.data.directives.some(vo) && (o.data.show = !0),
                                u &&
                                    u.data &&
                                    !(function (e, t) {
                                        return t.key === e.key && t.tag === e.tag;
                                    })(o, u) &&
                                    !Jt(u) &&
                                    (!u.componentInstance || !u.componentInstance._vnode.isComment))
                            ) {
                                var d = (u.data.transition = $({}, l));
                                if ("out-in" === r)
                                    return (
                                        (this._leaving = !0),
                                        dt(d, "afterLeave", function () {
                                            (t._leaving = !1), t.$forceUpdate();
                                        }),
                                        mo(e, i)
                                    );
                                if ("in-out" === r) {
                                    if (Jt(o)) return c;
                                    var p,
                                        h = function () {
                                            p();
                                        };
                                    dt(l, "afterEnter", h),
                                        dt(l, "enterCancelled", h),
                                        dt(d, "delayLeave", function (e) {
                                            p = e;
                                        });
                                }
                            }
                            return i;
                        }
                    },
                },
                bo = $({ tag: String, moveClass: String }, po);
            function wo(e) {
                e.elm._moveCb && e.elm._moveCb(), e.elm._enterCb && e.elm._enterCb();
            }
            function xo(e) {
                e.data.newPos = e.elm.getBoundingClientRect();
            }
            function Eo(e) {
                var t = e.data.pos,
                    n = e.data.newPos,
                    r = t.left - n.left,
                    i = t.top - n.top;
                if (r || i) {
                    e.data.moved = !0;
                    var o = e.elm.style;
                    (o.transform = o.WebkitTransform = "translate(" + r + "px," + i + "px)"), (o.transitionDuration = "0s");
                }
            }
            delete bo.mode;
            var Co = {
                Transition: yo,
                TransitionGroup: {
                    props: bo,
                    beforeMount: function () {
                        var e = this,
                            t = this._update;
                        this._update = function (n, r) {
                            var i = on(e);
                            e.__patch__(e._vnode, e.kept, !1, !0), (e._vnode = e.kept), i(), t.call(e, n, r);
                        };
                    },
                    render: function (e) {
                        for (
                            var t = this.tag || this.$vnode.data.tag || "span", n = Object.create(null), r = (this.prevChildren = this.children), i = this.$slots.default || [], o = (this.children = []), a = fo(this), s = 0;
                            s < i.length;
                            s++
                        ) {
                            var l = i[s];
                            if (l.tag)
                                if (null != l.key && 0 !== String(l.key).indexOf("__vlist")) o.push(l), (n[l.key] = l), ((l.data || (l.data = {})).transition = a);
                                else;
                        }
                        if (r) {
                            for (var c = [], u = [], d = 0; d < r.length; d++) {
                                var p = r[d];
                                (p.data.transition = a), (p.data.pos = p.elm.getBoundingClientRect()), n[p.key] ? c.push(p) : u.push(p);
                            }
                            (this.kept = e(t, null, c)), (this.removed = u);
                        }
                        return e(t, null, o);
                    },
                    updated: function () {
                        var e = this.prevChildren,
                            t = this.moveClass || (this.name || "v") + "-move";
                        e.length &&
                            this.hasMove(e[0].elm, t) &&
                            (e.forEach(wo),
                            e.forEach(xo),
                            e.forEach(Eo),
                            (this._reflow = document.body.offsetHeight),
                            e.forEach(function (e) {
                                if (e.data.moved) {
                                    var n = e.elm,
                                        r = n.style;
                                    Bi(n, t),
                                        (r.transform = r.WebkitTransform = r.transitionDuration = ""),
                                        n.addEventListener(
                                            Ii,
                                            (n._moveCb = function e(r) {
                                                (r && r.target !== n) || (r && !/transform$/.test(r.propertyName)) || (n.removeEventListener(Ii, e), (n._moveCb = null), ji(n, t));
                                            })
                                        );
                                }
                            }));
                    },
                    methods: {
                        hasMove: function (e, t) {
                            if (!Oi) return !1;
                            if (this._hasMove) return this._hasMove;
                            var n = e.cloneNode();
                            e._transitionClasses &&
                                e._transitionClasses.forEach(function (e) {
                                    Li(n, e);
                                }),
                                _i(n, t),
                                (n.style.display = "none"),
                                this.$el.appendChild(n);
                            var r = Wi(n);
                            return this.$el.removeChild(n), (this._hasMove = r.hasTransform);
                        },
                    },
                },
            };
            (On.config.mustUseProp = jn),
                (On.config.isReservedTag = ir),
                (On.config.isReservedAttr = Fn),
                (On.config.getTagNamespace = or),
                (On.config.isUnknownElement = function (e) {
                    if (!Y) return !0;
                    if (ir(e)) return !1;
                    if (((e = e.toLowerCase()), null != ar[e])) return ar[e];
                    var t = document.createElement(e);
                    return e.indexOf("-") > -1 ? (ar[e] = t.constructor === window.HTMLUnknownElement || t.constructor === window.HTMLElement) : (ar[e] = /HTMLUnknownElement/.test(t.toString()));
                }),
                $(On.options.directives, uo),
                $(On.options.components, Co),
                (On.prototype.__patch__ = Y ? Qi : O),
                (On.prototype.$mount = function (e, t) {
                    return (function (e, t, n) {
                        var r;
                        return (
                            (e.$el = t),
                            e.$options.render || (e.$options.render = be),
                            cn(e, "beforeMount"),
                            (r = function () {
                                e._update(e._render(), n);
                            }),
                            new xn(
                                e,
                                r,
                                O,
                                {
                                    before: function () {
                                        e._isMounted && !e._isDestroyed && cn(e, "beforeUpdate");
                                    },
                                },
                                !0
                            ),
                            (n = !1),
                            null == e.$vnode && ((e._isMounted = !0), cn(e, "mounted")),
                            e
                        );
                    })(this, (e = e && Y ? lr(e) : void 0), t);
                }),
                Y &&
                    setTimeout(function () {
                        B.devtools && se && se.emit("init", On);
                    }, 0);
            var So = /\{\{((?:.|\r?\n)+?)\}\}/g,
                To = /[-.*+?^${}()|[\]\/\\]/g,
                ko = E(function (e) {
                    var t = e[0].replace(To, "\\$&"),
                        n = e[1].replace(To, "\\$&");
                    return new RegExp(t + "((?:.|\\n)+?)" + n, "g");
                });
            var Ao = {
                staticKeys: ["staticClass"],
                transformNode: function (e, t) {
                    t.warn;
                    var n = Gr(e, "class");
                    n && (e.staticClass = JSON.stringify(n));
                    var r = Ur(e, "class", !1);
                    r && (e.classBinding = r);
                },
                genData: function (e) {
                    var t = "";
                    return e.staticClass && (t += "staticClass:" + e.staticClass + ","), e.classBinding && (t += "class:" + e.classBinding + ","), t;
                },
            };
            var _o,
                Lo = {
                    staticKeys: ["staticStyle"],
                    transformNode: function (e, t) {
                        t.warn;
                        var n = Gr(e, "style");
                        n && (e.staticStyle = JSON.stringify(gi(n)));
                        var r = Ur(e, "style", !1);
                        r && (e.styleBinding = r);
                    },
                    genData: function (e) {
                        var t = "";
                        return e.staticStyle && (t += "staticStyle:" + e.staticStyle + ","), e.styleBinding && (t += "style:(" + e.styleBinding + "),"), t;
                    },
                },
                $o = function (e) {
                    return ((_o = _o || document.createElement("div")).innerHTML = e), _o.textContent;
                },
                Do = g("area,base,br,col,embed,frame,hr,img,input,isindex,keygen,link,meta,param,source,track,wbr"),
                Oo = g("colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source"),
                qo = g(
                    "address,article,aside,base,blockquote,body,caption,col,colgroup,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,title,tr,track"
                ),
                Mo = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,
                Po = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,
                Io = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + j.source + "]*",
                No = "((?:" + Io + "\\:)?" + Io + ")",
                zo = new RegExp("^<" + No),
                Ro = /^\s*(\/?)>/,
                Fo = new RegExp("^<\\/" + No + "[^>]*>"),
                Bo = /^<!DOCTYPE [^>]+>/i,
                jo = /^<!\--/,
                Ho = /^<!\[/,
                Vo = g("script,style,textarea", !0),
                Wo = {},
                Uo = { "&lt;": "<", "&gt;": ">", "&quot;": '"', "&amp;": "&", "&#10;": "\n", "&#9;": "\t", "&#39;": "'" },
                Go = /&(?:lt|gt|quot|amp|#39);/g,
                Yo = /&(?:lt|gt|quot|amp|#39|#10|#9);/g,
                Xo = g("pre,textarea", !0),
                Ko = function (e, t) {
                    return e && Xo(e) && "\n" === t[0];
                };
            function Jo(e, t) {
                var n = t ? Yo : Go;
                return e.replace(n, function (e) {
                    return Uo[e];
                });
            }
            var Zo,
                Qo,
                ea,
                ta,
                na,
                ra,
                ia,
                oa,
                aa = /^@|^v-on:/,
                sa = /^v-|^@|^:|^#/,
                la = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,
                ca = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/,
                ua = /^\(|\)$/g,
                da = /^\[.*\]$/,
                pa = /:(.*)$/,
                ha = /^:|^\.|^v-bind:/,
                fa = /\.[^.\]]+(?=[^\]]*$)/g,
                ma = /^v-slot(:|$)|^#/,
                ga = /[\r\n]/,
                va = /\s+/g,
                ya = E($o),
                ba = "_empty_";
            function wa(e, t, n) {
                return { type: 1, tag: e, attrsList: t, attrsMap: Aa(t), rawAttrsMap: {}, parent: n, children: [] };
            }
            function xa(e, t) {
                (Zo = t.warn || zr), (ra = t.isPreTag || q), (ia = t.mustUseProp || q), (oa = t.getTagNamespace || q);
                var n = t.isReservedTag || q;
                (function (e) {
                    return !!e.component || !n(e.tag);
                },
                    (ea = Rr(t.modules, "transformNode")),
                    (ta = Rr(t.modules, "preTransformNode")),
                    (na = Rr(t.modules, "postTransformNode")),
                    (Qo = t.delimiters));
                var r,
                    i,
                    o = [],
                    a = !1 !== t.preserveWhitespace,
                    s = t.whitespace,
                    l = !1,
                    c = !1;
                function u(e) {
                    if ((d(e), l || e.processed || (e = Ea(e, t)), o.length || e === r || (r.if && (e.elseif || e.else) && Sa(r, { exp: e.elseif, block: e })), i && !e.forbidden))
                        if (e.elseif || e.else)
                            (a = e),
                                (s = (function (e) {
                                    for (var t = e.length; t--; ) {
                                        if (1 === e[t].type) return e[t];
                                        e.pop();
                                    }
                                })(i.children)),
                                s && s.if && Sa(s, { exp: a.elseif, block: a });
                        else {
                            if (e.slotScope) {
                                var n = e.slotTarget || '"default"';
                                (i.scopedSlots || (i.scopedSlots = {}))[n] = e;
                            }
                            i.children.push(e), (e.parent = i);
                        }
                    var a, s;
                    (e.children = e.children.filter(function (e) {
                        return !e.slotScope;
                    })),
                        d(e),
                        e.pre && (l = !1),
                        ra(e.tag) && (c = !1);
                    for (var u = 0; u < na.length; u++) na[u](e, t);
                }
                function d(e) {
                    if (!c) for (var t; (t = e.children[e.children.length - 1]) && 3 === t.type && " " === t.text; ) e.children.pop();
                }
                return (
                    (function (e, t) {
                        for (var n, r, i = [], o = t.expectHTML, a = t.isUnaryTag || q, s = t.canBeLeftOpenTag || q, l = 0; e; ) {
                            if (((n = e), r && Vo(r))) {
                                var c = 0,
                                    u = r.toLowerCase(),
                                    d = Wo[u] || (Wo[u] = new RegExp("([\\s\\S]*?)(</" + u + "[^>]*>)", "i")),
                                    p = e.replace(d, function (e, n, r) {
                                        return (c = r.length), Vo(u) || "noscript" === u || (n = n.replace(/<!\--([\s\S]*?)-->/g, "$1").replace(/<!\[CDATA\[([\s\S]*?)]]>/g, "$1")), Ko(u, n) && (n = n.slice(1)), t.chars && t.chars(n), "";
                                    });
                                (l += e.length - p.length), (e = p), k(u, l - c, l);
                            } else {
                                var h = e.indexOf("<");
                                if (0 === h) {
                                    if (jo.test(e)) {
                                        var f = e.indexOf("--\x3e");
                                        if (f >= 0) {
                                            t.shouldKeepComment && t.comment(e.substring(4, f), l, l + f + 3), C(f + 3);
                                            continue;
                                        }
                                    }
                                    if (Ho.test(e)) {
                                        var m = e.indexOf("]>");
                                        if (m >= 0) {
                                            C(m + 2);
                                            continue;
                                        }
                                    }
                                    var g = e.match(Bo);
                                    if (g) {
                                        C(g[0].length);
                                        continue;
                                    }
                                    var v = e.match(Fo);
                                    if (v) {
                                        var y = l;
                                        C(v[0].length), k(v[1], y, l);
                                        continue;
                                    }
                                    var b = S();
                                    if (b) {
                                        T(b), Ko(b.tagName, e) && C(1);
                                        continue;
                                    }
                                }
                                var w = void 0,
                                    x = void 0,
                                    E = void 0;
                                if (h >= 0) {
                                    for (x = e.slice(h); !(Fo.test(x) || zo.test(x) || jo.test(x) || Ho.test(x) || (E = x.indexOf("<", 1)) < 0); ) (h += E), (x = e.slice(h));
                                    w = e.substring(0, h);
                                }
                                h < 0 && (w = e), w && C(w.length), t.chars && w && t.chars(w, l - w.length, l);
                            }
                            if (e === n) {
                                t.chars && t.chars(e);
                                break;
                            }
                        }
                        function C(t) {
                            (l += t), (e = e.substring(t));
                        }
                        function S() {
                            var t = e.match(zo);
                            if (t) {
                                var n,
                                    r,
                                    i = { tagName: t[1], attrs: [], start: l };
                                for (C(t[0].length); !(n = e.match(Ro)) && (r = e.match(Po) || e.match(Mo)); ) (r.start = l), C(r[0].length), (r.end = l), i.attrs.push(r);
                                if (n) return (i.unarySlash = n[1]), C(n[0].length), (i.end = l), i;
                            }
                        }
                        function T(e) {
                            var n = e.tagName,
                                l = e.unarySlash;
                            o && ("p" === r && qo(n) && k(r), s(n) && r === n && k(n));
                            for (var c = a(n) || !!l, u = e.attrs.length, d = new Array(u), p = 0; p < u; p++) {
                                var h = e.attrs[p],
                                    f = h[3] || h[4] || h[5] || "",
                                    m = "a" === n && "href" === h[1] ? t.shouldDecodeNewlinesForHref : t.shouldDecodeNewlines;
                                d[p] = { name: h[1], value: Jo(f, m) };
                            }
                            c || (i.push({ tag: n, lowerCasedTag: n.toLowerCase(), attrs: d, start: e.start, end: e.end }), (r = n)), t.start && t.start(n, d, c, e.start, e.end);
                        }
                        function k(e, n, o) {
                            var a, s;
                            if ((null == n && (n = l), null == o && (o = l), e)) for (s = e.toLowerCase(), a = i.length - 1; a >= 0 && i[a].lowerCasedTag !== s; a--);
                            else a = 0;
                            if (a >= 0) {
                                for (var c = i.length - 1; c >= a; c--) t.end && t.end(i[c].tag, n, o);
                                (i.length = a), (r = a && i[a - 1].tag);
                            } else "br" === s ? t.start && t.start(e, [], !0, n, o) : "p" === s && (t.start && t.start(e, [], !1, n, o), t.end && t.end(e, n, o));
                        }
                        k();
                    })(e, {
                        warn: Zo,
                        expectHTML: t.expectHTML,
                        isUnaryTag: t.isUnaryTag,
                        canBeLeftOpenTag: t.canBeLeftOpenTag,
                        shouldDecodeNewlines: t.shouldDecodeNewlines,
                        shouldDecodeNewlinesForHref: t.shouldDecodeNewlinesForHref,
                        shouldKeepComment: t.comments,
                        outputSourceRange: t.outputSourceRange,
                        start: function (e, n, a, s, d) {
                            var p = (i && i.ns) || oa(e);
                            Z &&
                                "svg" === p &&
                                (n = (function (e) {
                                    for (var t = [], n = 0; n < e.length; n++) {
                                        var r = e[n];
                                        _a.test(r.name) || ((r.name = r.name.replace(La, "")), t.push(r));
                                    }
                                    return t;
                                })(n));
                            var h,
                                f = wa(e, n, i);
                            p && (f.ns = p), ("style" !== (h = f).tag && ("script" !== h.tag || (h.attrsMap.type && "text/javascript" !== h.attrsMap.type))) || ae() || (f.forbidden = !0);
                            for (var m = 0; m < ta.length; m++) f = ta[m](f, t) || f;
                            l ||
                                (!(function (e) {
                                    null != Gr(e, "v-pre") && (e.pre = !0);
                                })(f),
                                f.pre && (l = !0)),
                                ra(f.tag) && (c = !0),
                                l
                                    ? (function (e) {
                                          var t = e.attrsList,
                                              n = t.length;
                                          if (n)
                                              for (var r = (e.attrs = new Array(n)), i = 0; i < n; i++)
                                                  (r[i] = { name: t[i].name, value: JSON.stringify(t[i].value) }), null != t[i].start && ((r[i].start = t[i].start), (r[i].end = t[i].end));
                                          else e.pre || (e.plain = !0);
                                      })(f)
                                    : f.processed ||
                                      (Ca(f),
                                      (function (e) {
                                          var t = Gr(e, "v-if");
                                          if (t) (e.if = t), Sa(e, { exp: t, block: e });
                                          else {
                                              null != Gr(e, "v-else") && (e.else = !0);
                                              var n = Gr(e, "v-else-if");
                                              n && (e.elseif = n);
                                          }
                                      })(f),
                                      (function (e) {
                                          var t = Gr(e, "v-once");
                                          null != t && (e.once = !0);
                                      })(f)),
                                r || (r = f),
                                a ? u(f) : ((i = f), o.push(f));
                        },
                        end: function (e, t, n) {
                            var r = o[o.length - 1];
                            (o.length -= 1), (i = o[o.length - 1]), u(r);
                        },
                        chars: function (e, t, n) {
                            if (i && (!Z || "textarea" !== i.tag || i.attrsMap.placeholder !== e)) {
                                var r,
                                    o,
                                    u,
                                    d = i.children;
                                if ((e = c || e.trim() ? ("script" === (r = i).tag || "style" === r.tag ? e : ya(e)) : d.length ? (s ? ("condense" === s && ga.test(e) ? "" : " ") : a ? " " : "") : ""))
                                    c || "condense" !== s || (e = e.replace(va, " ")),
                                        !l &&
                                        " " !== e &&
                                        (o = (function (e, t) {
                                            var n = t ? ko(t) : So;
                                            if (n.test(e)) {
                                                for (var r, i, o, a = [], s = [], l = (n.lastIndex = 0); (r = n.exec(e)); ) {
                                                    (i = r.index) > l && (s.push((o = e.slice(l, i))), a.push(JSON.stringify(o)));
                                                    var c = Ir(r[1].trim());
                                                    a.push("_s(" + c + ")"), s.push({ "@binding": c }), (l = i + r[0].length);
                                                }
                                                return l < e.length && (s.push((o = e.slice(l))), a.push(JSON.stringify(o))), { expression: a.join("+"), tokens: s };
                                            }
                                        })(e, Qo))
                                            ? (u = { type: 2, expression: o.expression, tokens: o.tokens, text: e })
                                            : (" " === e && d.length && " " === d[d.length - 1].text) || (u = { type: 3, text: e }),
                                        u && d.push(u);
                            }
                        },
                        comment: function (e, t, n) {
                            if (i) {
                                var r = { type: 3, text: e, isComment: !0 };
                                0, i.children.push(r);
                            }
                        },
                    }),
                    r
                );
            }
            function Ea(e, t) {
                var n;
                !(function (e) {
                    var t = Ur(e, "key");
                    if (t) {
                        e.key = t;
                    }
                })(e),
                    (e.plain = !e.key && !e.scopedSlots && !e.attrsList.length),
                    (function (e) {
                        var t = Ur(e, "ref");
                        t &&
                            ((e.ref = t),
                            (e.refInFor = (function (e) {
                                var t = e;
                                for (; t; ) {
                                    if (void 0 !== t.for) return !0;
                                    t = t.parent;
                                }
                                return !1;
                            })(e)));
                    })(e),
                    (function (e) {
                        var t;
                        "template" === e.tag ? ((t = Gr(e, "scope")), (e.slotScope = t || Gr(e, "slot-scope"))) : (t = Gr(e, "slot-scope")) && (e.slotScope = t);
                        var n = Ur(e, "slot");
                        n &&
                            ((e.slotTarget = '""' === n ? '"default"' : n),
                            (e.slotTargetDynamic = !(!e.attrsMap[":slot"] && !e.attrsMap["v-bind:slot"])),
                            "template" === e.tag ||
                                e.slotScope ||
                                Br(
                                    e,
                                    "slot",
                                    n,
                                    (function (e, t) {
                                        return e.rawAttrsMap[":" + t] || e.rawAttrsMap["v-bind:" + t] || e.rawAttrsMap[t];
                                    })(e, "slot")
                                ));
                        if ("template" === e.tag) {
                            var r = Yr(e, ma);
                            if (r) {
                                0;
                                var i = Ta(r),
                                    o = i.name,
                                    a = i.dynamic;
                                (e.slotTarget = o), (e.slotTargetDynamic = a), (e.slotScope = r.value || ba);
                            }
                        } else {
                            var s = Yr(e, ma);
                            if (s) {
                                0;
                                var l = e.scopedSlots || (e.scopedSlots = {}),
                                    c = Ta(s),
                                    u = c.name,
                                    d = c.dynamic,
                                    p = (l[u] = wa("template", [], e));
                                (p.slotTarget = u),
                                    (p.slotTargetDynamic = d),
                                    (p.children = e.children.filter(function (e) {
                                        if (!e.slotScope) return (e.parent = p), !0;
                                    })),
                                    (p.slotScope = s.value || ba),
                                    (e.children = []),
                                    (e.plain = !1);
                            }
                        }
                    })(e),
                    "slot" === (n = e).tag && (n.slotName = Ur(n, "name")),
                    (function (e) {
                        var t;
                        (t = Ur(e, "is")) && (e.component = t);
                        null != Gr(e, "inline-template") && (e.inlineTemplate = !0);
                    })(e);
                for (var r = 0; r < ea.length; r++) e = ea[r](e, t) || e;
                return (
                    (function (e) {
                        var t,
                            n,
                            r,
                            i,
                            o,
                            a,
                            s,
                            l,
                            c = e.attrsList;
                        for (t = 0, n = c.length; t < n; t++) {
                            if (((r = i = c[t].name), (o = c[t].value), sa.test(r)))
                                if (((e.hasBindings = !0), (a = ka(r.replace(sa, ""))) && (r = r.replace(fa, "")), ha.test(r)))
                                    (r = r.replace(ha, "")),
                                        (o = Ir(o)),
                                        (l = da.test(r)) && (r = r.slice(1, -1)),
                                        a &&
                                            (a.prop && !l && "innerHtml" === (r = S(r)) && (r = "innerHTML"),
                                            a.camel && !l && (r = S(r)),
                                            a.sync &&
                                                ((s = Jr(o, "$event")),
                                                l ? Wr(e, '"update:"+(' + r + ")", s, null, !1, 0, c[t], !0) : (Wr(e, "update:" + S(r), s, null, !1, 0, c[t]), A(r) !== S(r) && Wr(e, "update:" + A(r), s, null, !1, 0, c[t])))),
                                        (a && a.prop) || (!e.component && ia(e.tag, e.attrsMap.type, r)) ? Fr(e, r, o, c[t], l) : Br(e, r, o, c[t], l);
                                else if (aa.test(r)) (r = r.replace(aa, "")), (l = da.test(r)) && (r = r.slice(1, -1)), Wr(e, r, o, a, !1, 0, c[t], l);
                                else {
                                    var u = (r = r.replace(sa, "")).match(pa),
                                        d = u && u[1];
                                    (l = !1), d && ((r = r.slice(0, -(d.length + 1))), da.test(d) && ((d = d.slice(1, -1)), (l = !0))), Hr(e, r, i, o, d, l, a, c[t]);
                                }
                            else Br(e, r, JSON.stringify(o), c[t]), !e.component && "muted" === r && ia(e.tag, e.attrsMap.type, r) && Fr(e, r, "true", c[t]);
                        }
                    })(e),
                    e
                );
            }
            function Ca(e) {
                var t;
                if ((t = Gr(e, "v-for"))) {
                    var n = (function (e) {
                        var t = e.match(la);
                        if (!t) return;
                        var n = {};
                        n.for = t[2].trim();
                        var r = t[1].trim().replace(ua, ""),
                            i = r.match(ca);
                        i ? ((n.alias = r.replace(ca, "").trim()), (n.iterator1 = i[1].trim()), i[2] && (n.iterator2 = i[2].trim())) : (n.alias = r);
                        return n;
                    })(t);
                    n && $(e, n);
                }
            }
            function Sa(e, t) {
                e.ifConditions || (e.ifConditions = []), e.ifConditions.push(t);
            }
            function Ta(e) {
                var t = e.name.replace(ma, "");
                return t || ("#" !== e.name[0] && (t = "default")), da.test(t) ? { name: t.slice(1, -1), dynamic: !0 } : { name: '"' + t + '"', dynamic: !1 };
            }
            function ka(e) {
                var t = e.match(fa);
                if (t) {
                    var n = {};
                    return (
                        t.forEach(function (e) {
                            n[e.slice(1)] = !0;
                        }),
                        n
                    );
                }
            }
            function Aa(e) {
                for (var t = {}, n = 0, r = e.length; n < r; n++) t[e[n].name] = e[n].value;
                return t;
            }
            var _a = /^xmlns:NS\d+/,
                La = /^NS\d+:/;
            function $a(e) {
                return wa(e.tag, e.attrsList.slice(), e.parent);
            }
            var Da = [
                Ao,
                Lo,
                {
                    preTransformNode: function (e, t) {
                        if ("input" === e.tag) {
                            var n,
                                r = e.attrsMap;
                            if (!r["v-model"]) return;
                            if (((r[":type"] || r["v-bind:type"]) && (n = Ur(e, "type")), r.type || n || !r["v-bind"] || (n = "(" + r["v-bind"] + ").type"), n)) {
                                var i = Gr(e, "v-if", !0),
                                    o = i ? "&&(" + i + ")" : "",
                                    a = null != Gr(e, "v-else", !0),
                                    s = Gr(e, "v-else-if", !0),
                                    l = $a(e);
                                Ca(l), jr(l, "type", "checkbox"), Ea(l, t), (l.processed = !0), (l.if = "(" + n + ")==='checkbox'" + o), Sa(l, { exp: l.if, block: l });
                                var c = $a(e);
                                Gr(c, "v-for", !0), jr(c, "type", "radio"), Ea(c, t), Sa(l, { exp: "(" + n + ")==='radio'" + o, block: c });
                                var u = $a(e);
                                return Gr(u, "v-for", !0), jr(u, ":type", n), Ea(u, t), Sa(l, { exp: i, block: u }), a ? (l.else = !0) : s && (l.elseif = s), l;
                            }
                        }
                    },
                },
            ];
            var Oa,
                qa,
                Ma = {
                    model: function (e, t, n) {
                        n;
                        var r = t.value,
                            i = t.modifiers,
                            o = e.tag,
                            a = e.attrsMap.type;
                        if (e.component) return Kr(e, r, i), !1;
                        if ("select" === o)
                            !(function (e, t, n) {
                                var r = n && n.number,
                                    i =
                                        'var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return ' +
                                        (r ? "_n(val)" : "val") +
                                        "});";
                                (i = i + " " + Jr(t, "$event.target.multiple ? $$selectedVal : $$selectedVal[0]")), Wr(e, "change", i, null, !0);
                            })(e, r, i);
                        else if ("input" === o && "checkbox" === a)
                            !(function (e, t, n) {
                                var r = n && n.number,
                                    i = Ur(e, "value") || "null",
                                    o = Ur(e, "true-value") || "true",
                                    a = Ur(e, "false-value") || "false";
                                Fr(e, "checked", "Array.isArray(" + t + ")?_i(" + t + "," + i + ")>-1" + ("true" === o ? ":(" + t + ")" : ":_q(" + t + "," + o + ")")),
                                    Wr(
                                        e,
                                        "change",
                                        "var $$a=" +
                                            t +
                                            ",$$el=$event.target,$$c=$$el.checked?(" +
                                            o +
                                            "):(" +
                                            a +
                                            ");if(Array.isArray($$a)){var $$v=" +
                                            (r ? "_n(" + i + ")" : i) +
                                            ",$$i=_i($$a,$$v);if($$el.checked){$$i<0&&(" +
                                            Jr(t, "$$a.concat([$$v])") +
                                            ")}else{$$i>-1&&(" +
                                            Jr(t, "$$a.slice(0,$$i).concat($$a.slice($$i+1))") +
                                            ")}}else{" +
                                            Jr(t, "$$c") +
                                            "}",
                                        null,
                                        !0
                                    );
                            })(e, r, i);
                        else if ("input" === o && "radio" === a)
                            !(function (e, t, n) {
                                var r = n && n.number,
                                    i = Ur(e, "value") || "null";
                                Fr(e, "checked", "_q(" + t + "," + (i = r ? "_n(" + i + ")" : i) + ")"), Wr(e, "change", Jr(t, i), null, !0);
                            })(e, r, i);
                        else if ("input" === o || "textarea" === o)
                            !(function (e, t, n) {
                                var r = e.attrsMap.type;
                                0;
                                var i = n || {},
                                    o = i.lazy,
                                    a = i.number,
                                    s = i.trim,
                                    l = !o && "range" !== r,
                                    c = o ? "change" : "range" === r ? ii : "input",
                                    u = "$event.target.value";
                                s && (u = "$event.target.value.trim()");
                                a && (u = "_n(" + u + ")");
                                var d = Jr(t, u);
                                l && (d = "if($event.target.composing)return;" + d);
                                Fr(e, "value", "(" + t + ")"), Wr(e, c, d, null, !0), (s || a) && Wr(e, "blur", "$forceUpdate()");
                            })(e, r, i);
                        else {
                            if (!B.isReservedTag(o)) return Kr(e, r, i), !1;
                        }
                        return !0;
                    },
                    text: function (e, t) {
                        t.value && Fr(e, "textContent", "_s(" + t.value + ")", t);
                    },
                    html: function (e, t) {
                        t.value && Fr(e, "innerHTML", "_s(" + t.value + ")", t);
                    },
                },
                Pa = {
                    expectHTML: !0,
                    modules: Da,
                    directives: Ma,
                    isPreTag: function (e) {
                        return "pre" === e;
                    },
                    isUnaryTag: Do,
                    mustUseProp: jn,
                    canBeLeftOpenTag: Oo,
                    isReservedTag: ir,
                    getTagNamespace: or,
                    staticKeys: (function (e) {
                        return e
                            .reduce(function (e, t) {
                                return e.concat(t.staticKeys || []);
                            }, [])
                            .join(",");
                    })(Da),
                },
                Ia = E(function (e) {
                    return g("type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap" + (e ? "," + e : ""));
                });
            function Na(e, t) {
                e && ((Oa = Ia(t.staticKeys || "")), (qa = t.isReservedTag || q), za(e), Ra(e, !1));
            }
            function za(e) {
                if (
                    ((e.static = (function (e) {
                        if (2 === e.type) return !1;
                        if (3 === e.type) return !0;
                        return !(
                            !e.pre &&
                            (e.hasBindings ||
                                e.if ||
                                e.for ||
                                v(e.tag) ||
                                !qa(e.tag) ||
                                (function (e) {
                                    for (; e.parent; ) {
                                        if ("template" !== (e = e.parent).tag) return !1;
                                        if (e.for) return !0;
                                    }
                                    return !1;
                                })(e) ||
                                !Object.keys(e).every(Oa))
                        );
                    })(e)),
                    1 === e.type)
                ) {
                    if (!qa(e.tag) && "slot" !== e.tag && null == e.attrsMap["inline-template"]) return;
                    for (var t = 0, n = e.children.length; t < n; t++) {
                        var r = e.children[t];
                        za(r), r.static || (e.static = !1);
                    }
                    if (e.ifConditions)
                        for (var i = 1, o = e.ifConditions.length; i < o; i++) {
                            var a = e.ifConditions[i].block;
                            za(a), a.static || (e.static = !1);
                        }
                }
            }
            function Ra(e, t) {
                if (1 === e.type) {
                    if (((e.static || e.once) && (e.staticInFor = t), e.static && e.children.length && (1 !== e.children.length || 3 !== e.children[0].type))) return void (e.staticRoot = !0);
                    if (((e.staticRoot = !1), e.children)) for (var n = 0, r = e.children.length; n < r; n++) Ra(e.children[n], t || !!e.for);
                    if (e.ifConditions) for (var i = 1, o = e.ifConditions.length; i < o; i++) Ra(e.ifConditions[i].block, t);
                }
            }
            var Fa = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/,
                Ba = /\([^)]*?\);*$/,
                ja = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/,
                Ha = { esc: 27, tab: 9, enter: 13, space: 32, up: 38, left: 37, right: 39, down: 40, delete: [8, 46] },
                Va = {
                    esc: ["Esc", "Escape"],
                    tab: "Tab",
                    enter: "Enter",
                    space: [" ", "Spacebar"],
                    up: ["Up", "ArrowUp"],
                    left: ["Left", "ArrowLeft"],
                    right: ["Right", "ArrowRight"],
                    down: ["Down", "ArrowDown"],
                    delete: ["Backspace", "Delete", "Del"],
                },
                Wa = function (e) {
                    return "if(" + e + ")return null;";
                },
                Ua = {
                    stop: "$event.stopPropagation();",
                    prevent: "$event.preventDefault();",
                    self: Wa("$event.target !== $event.currentTarget"),
                    ctrl: Wa("!$event.ctrlKey"),
                    shift: Wa("!$event.shiftKey"),
                    alt: Wa("!$event.altKey"),
                    meta: Wa("!$event.metaKey"),
                    left: Wa("'button' in $event && $event.button !== 0"),
                    middle: Wa("'button' in $event && $event.button !== 1"),
                    right: Wa("'button' in $event && $event.button !== 2"),
                };
            function Ga(e, t) {
                var n = t ? "nativeOn:" : "on:",
                    r = "",
                    i = "";
                for (var o in e) {
                    var a = Ya(e[o]);
                    e[o] && e[o].dynamic ? (i += o + "," + a + ",") : (r += '"' + o + '":' + a + ",");
                }
                return (r = "{" + r.slice(0, -1) + "}"), i ? n + "_d(" + r + ",[" + i.slice(0, -1) + "])" : n + r;
            }
            function Ya(e) {
                if (!e) return "function(){}";
                if (Array.isArray(e))
                    return (
                        "[" +
                        e
                            .map(function (e) {
                                return Ya(e);
                            })
                            .join(",") +
                        "]"
                    );
                var t = ja.test(e.value),
                    n = Fa.test(e.value),
                    r = ja.test(e.value.replace(Ba, ""));
                if (e.modifiers) {
                    var i = "",
                        o = "",
                        a = [];
                    for (var s in e.modifiers)
                        if (Ua[s]) (o += Ua[s]), Ha[s] && a.push(s);
                        else if ("exact" === s) {
                            var l = e.modifiers;
                            o += Wa(
                                ["ctrl", "shift", "alt", "meta"]
                                    .filter(function (e) {
                                        return !l[e];
                                    })
                                    .map(function (e) {
                                        return "$event." + e + "Key";
                                    })
                                    .join("||")
                            );
                        } else a.push(s);
                    return (
                        a.length &&
                            (i += (function (e) {
                                return "if(!$event.type.indexOf('key')&&" + e.map(Xa).join("&&") + ")return null;";
                            })(a)),
                        o && (i += o),
                        "function($event){" + i + (t ? "return " + e.value + "($event)" : n ? "return (" + e.value + ")($event)" : r ? "return " + e.value : e.value) + "}"
                    );
                }
                return t || n ? e.value : "function($event){" + (r ? "return " + e.value : e.value) + "}";
            }
            function Xa(e) {
                var t = parseInt(e, 10);
                if (t) return "$event.keyCode!==" + t;
                var n = Ha[e],
                    r = Va[e];
                return "_k($event.keyCode," + JSON.stringify(e) + "," + JSON.stringify(n) + ",$event.key," + JSON.stringify(r) + ")";
            }
            var Ka = {
                    on: function (e, t) {
                        e.wrapListeners = function (e) {
                            return "_g(" + e + "," + t.value + ")";
                        };
                    },
                    bind: function (e, t) {
                        e.wrapData = function (n) {
                            return "_b(" + n + ",'" + e.tag + "'," + t.value + "," + (t.modifiers && t.modifiers.prop ? "true" : "false") + (t.modifiers && t.modifiers.sync ? ",true" : "") + ")";
                        };
                    },
                    cloak: O,
                },
                Ja = function (e) {
                    (this.options = e), (this.warn = e.warn || zr), (this.transforms = Rr(e.modules, "transformCode")), (this.dataGenFns = Rr(e.modules, "genData")), (this.directives = $($({}, Ka), e.directives));
                    var t = e.isReservedTag || q;
                    (this.maybeComponent = function (e) {
                        return !!e.component || !t(e.tag);
                    }),
                        (this.onceId = 0),
                        (this.staticRenderFns = []),
                        (this.pre = !1);
                };
            function Za(e, t) {
                var n = new Ja(t);
                return { render: "with(this){return " + (e ? Qa(e, n) : '_c("div")') + "}", staticRenderFns: n.staticRenderFns };
            }
            function Qa(e, t) {
                if ((e.parent && (e.pre = e.pre || e.parent.pre), e.staticRoot && !e.staticProcessed)) return es(e, t);
                if (e.once && !e.onceProcessed) return ts(e, t);
                if (e.for && !e.forProcessed) return is(e, t);
                if (e.if && !e.ifProcessed) return ns(e, t);
                if ("template" !== e.tag || e.slotTarget || t.pre) {
                    if ("slot" === e.tag)
                        return (function (e, t) {
                            var n = e.slotName || '"default"',
                                r = ls(e, t),
                                i = "_t(" + n + (r ? "," + r : ""),
                                o =
                                    e.attrs || e.dynamicAttrs
                                        ? ds(
                                              (e.attrs || []).concat(e.dynamicAttrs || []).map(function (e) {
                                                  return { name: S(e.name), value: e.value, dynamic: e.dynamic };
                                              })
                                          )
                                        : null,
                                a = e.attrsMap["v-bind"];
                            (!o && !a) || r || (i += ",null");
                            o && (i += "," + o);
                            a && (i += (o ? "" : ",null") + "," + a);
                            return i + ")";
                        })(e, t);
                    var n;
                    if (e.component)
                        n = (function (e, t, n) {
                            var r = t.inlineTemplate ? null : ls(t, n, !0);
                            return "_c(" + e + "," + os(t, n) + (r ? "," + r : "") + ")";
                        })(e.component, e, t);
                    else {
                        var r;
                        (!e.plain || (e.pre && t.maybeComponent(e))) && (r = os(e, t));
                        var i = e.inlineTemplate ? null : ls(e, t, !0);
                        n = "_c('" + e.tag + "'" + (r ? "," + r : "") + (i ? "," + i : "") + ")";
                    }
                    for (var o = 0; o < t.transforms.length; o++) n = t.transforms[o](e, n);
                    return n;
                }
                return ls(e, t) || "void 0";
            }
            function es(e, t) {
                e.staticProcessed = !0;
                var n = t.pre;
                return e.pre && (t.pre = e.pre), t.staticRenderFns.push("with(this){return " + Qa(e, t) + "}"), (t.pre = n), "_m(" + (t.staticRenderFns.length - 1) + (e.staticInFor ? ",true" : "") + ")";
            }
            function ts(e, t) {
                if (((e.onceProcessed = !0), e.if && !e.ifProcessed)) return ns(e, t);
                if (e.staticInFor) {
                    for (var n = "", r = e.parent; r; ) {
                        if (r.for) {
                            n = r.key;
                            break;
                        }
                        r = r.parent;
                    }
                    return n ? "_o(" + Qa(e, t) + "," + t.onceId++ + "," + n + ")" : Qa(e, t);
                }
                return es(e, t);
            }
            function ns(e, t, n, r) {
                return (e.ifProcessed = !0), rs(e.ifConditions.slice(), t, n, r);
            }
            function rs(e, t, n, r) {
                if (!e.length) return r || "_e()";
                var i = e.shift();
                return i.exp ? "(" + i.exp + ")?" + o(i.block) + ":" + rs(e, t, n, r) : "" + o(i.block);
                function o(e) {
                    return n ? n(e, t) : e.once ? ts(e, t) : Qa(e, t);
                }
            }
            function is(e, t, n, r) {
                var i = e.for,
                    o = e.alias,
                    a = e.iterator1 ? "," + e.iterator1 : "",
                    s = e.iterator2 ? "," + e.iterator2 : "";
                return (e.forProcessed = !0), (r || "_l") + "((" + i + "),function(" + o + a + s + "){return " + (n || Qa)(e, t) + "})";
            }
            function os(e, t) {
                var n = "{",
                    r = (function (e, t) {
                        var n = e.directives;
                        if (!n) return;
                        var r,
                            i,
                            o,
                            a,
                            s = "directives:[",
                            l = !1;
                        for (r = 0, i = n.length; r < i; r++) {
                            (o = n[r]), (a = !0);
                            var c = t.directives[o.name];
                            c && (a = !!c(e, o, t.warn)),
                                a &&
                                    ((l = !0),
                                    (s +=
                                        '{name:"' +
                                        o.name +
                                        '",rawName:"' +
                                        o.rawName +
                                        '"' +
                                        (o.value ? ",value:(" + o.value + "),expression:" + JSON.stringify(o.value) : "") +
                                        (o.arg ? ",arg:" + (o.isDynamicArg ? o.arg : '"' + o.arg + '"') : "") +
                                        (o.modifiers ? ",modifiers:" + JSON.stringify(o.modifiers) : "") +
                                        "},"));
                        }
                        if (l) return s.slice(0, -1) + "]";
                    })(e, t);
                r && (n += r + ","), e.key && (n += "key:" + e.key + ","), e.ref && (n += "ref:" + e.ref + ","), e.refInFor && (n += "refInFor:true,"), e.pre && (n += "pre:true,"), e.component && (n += 'tag:"' + e.tag + '",');
                for (var i = 0; i < t.dataGenFns.length; i++) n += t.dataGenFns[i](e);
                if (
                    (e.attrs && (n += "attrs:" + ds(e.attrs) + ","),
                    e.props && (n += "domProps:" + ds(e.props) + ","),
                    e.events && (n += Ga(e.events, !1) + ","),
                    e.nativeEvents && (n += Ga(e.nativeEvents, !0) + ","),
                    e.slotTarget && !e.slotScope && (n += "slot:" + e.slotTarget + ","),
                    e.scopedSlots &&
                        (n +=
                            (function (e, t, n) {
                                var r =
                                        e.for ||
                                        Object.keys(t).some(function (e) {
                                            var n = t[e];
                                            return n.slotTargetDynamic || n.if || n.for || as(n);
                                        }),
                                    i = !!e.if;
                                if (!r)
                                    for (var o = e.parent; o; ) {
                                        if ((o.slotScope && o.slotScope !== ba) || o.for) {
                                            r = !0;
                                            break;
                                        }
                                        o.if && (i = !0), (o = o.parent);
                                    }
                                var a = Object.keys(t)
                                    .map(function (e) {
                                        return ss(t[e], n);
                                    })
                                    .join(",");
                                return (
                                    "scopedSlots:_u([" +
                                    a +
                                    "]" +
                                    (r ? ",null,true" : "") +
                                    (!r && i
                                        ? ",null,false," +
                                          (function (e) {
                                              var t = 5381,
                                                  n = e.length;
                                              for (; n; ) t = (33 * t) ^ e.charCodeAt(--n);
                                              return t >>> 0;
                                          })(a)
                                        : "") +
                                    ")"
                                );
                            })(e, e.scopedSlots, t) + ","),
                    e.model && (n += "model:{value:" + e.model.value + ",callback:" + e.model.callback + ",expression:" + e.model.expression + "},"),
                    e.inlineTemplate)
                ) {
                    var o = (function (e, t) {
                        var n = e.children[0];
                        0;
                        if (n && 1 === n.type) {
                            var r = Za(n, t.options);
                            return (
                                "inlineTemplate:{render:function(){" +
                                r.render +
                                "},staticRenderFns:[" +
                                r.staticRenderFns
                                    .map(function (e) {
                                        return "function(){" + e + "}";
                                    })
                                    .join(",") +
                                "]}"
                            );
                        }
                    })(e, t);
                    o && (n += o + ",");
                }
                return (n = n.replace(/,$/, "") + "}"), e.dynamicAttrs && (n = "_b(" + n + ',"' + e.tag + '",' + ds(e.dynamicAttrs) + ")"), e.wrapData && (n = e.wrapData(n)), e.wrapListeners && (n = e.wrapListeners(n)), n;
            }
            function as(e) {
                return 1 === e.type && ("slot" === e.tag || e.children.some(as));
            }
            function ss(e, t) {
                var n = e.attrsMap["slot-scope"];
                if (e.if && !e.ifProcessed && !n) return ns(e, t, ss, "null");
                if (e.for && !e.forProcessed) return is(e, t, ss);
                var r = e.slotScope === ba ? "" : String(e.slotScope),
                    i = "function(" + r + "){return " + ("template" === e.tag ? (e.if && n ? "(" + e.if + ")?" + (ls(e, t) || "undefined") + ":undefined" : ls(e, t) || "undefined") : Qa(e, t)) + "}",
                    o = r ? "" : ",proxy:true";
                return "{key:" + (e.slotTarget || '"default"') + ",fn:" + i + o + "}";
            }
            function ls(e, t, n, r, i) {
                var o = e.children;
                if (o.length) {
                    var a = o[0];
                    if (1 === o.length && a.for && "template" !== a.tag && "slot" !== a.tag) {
                        var s = n ? (t.maybeComponent(a) ? ",1" : ",0") : "";
                        return "" + (r || Qa)(a, t) + s;
                    }
                    var l = n
                            ? (function (e, t) {
                                  for (var n = 0, r = 0; r < e.length; r++) {
                                      var i = e[r];
                                      if (1 === i.type) {
                                          if (
                                              cs(i) ||
                                              (i.ifConditions &&
                                                  i.ifConditions.some(function (e) {
                                                      return cs(e.block);
                                                  }))
                                          ) {
                                              n = 2;
                                              break;
                                          }
                                          (t(i) ||
                                              (i.ifConditions &&
                                                  i.ifConditions.some(function (e) {
                                                      return t(e.block);
                                                  }))) &&
                                              (n = 1);
                                      }
                                  }
                                  return n;
                              })(o, t.maybeComponent)
                            : 0,
                        c = i || us;
                    return (
                        "[" +
                        o
                            .map(function (e) {
                                return c(e, t);
                            })
                            .join(",") +
                        "]" +
                        (l ? "," + l : "")
                    );
                }
            }
            function cs(e) {
                return void 0 !== e.for || "template" === e.tag || "slot" === e.tag;
            }
            function us(e, t) {
                return 1 === e.type
                    ? Qa(e, t)
                    : 3 === e.type && e.isComment
                    ? (function (e) {
                          return "_e(" + JSON.stringify(e.text) + ")";
                      })(e)
                    : (function (e) {
                          return "_v(" + (2 === e.type ? e.expression : ps(JSON.stringify(e.text))) + ")";
                      })(e);
            }
            function ds(e) {
                for (var t = "", n = "", r = 0; r < e.length; r++) {
                    var i = e[r],
                        o = ps(i.value);
                    i.dynamic ? (n += i.name + "," + o + ",") : (t += '"' + i.name + '":' + o + ",");
                }
                return (t = "{" + t.slice(0, -1) + "}"), n ? "_d(" + t + ",[" + n.slice(0, -1) + "])" : t;
            }
            function ps(e) {
                return e.replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
            }
            new RegExp(
                "\\b" +
                    "do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,super,throw,while,yield,delete,export,import,return,switch,default,extends,finally,continue,debugger,function,arguments"
                        .split(",")
                        .join("\\b|\\b") +
                    "\\b"
            ),
                new RegExp("\\b" + "delete,typeof,void".split(",").join("\\s*\\([^\\)]*\\)|\\b") + "\\s*\\([^\\)]*\\)");
            function hs(e, t) {
                try {
                    return new Function(e);
                } catch (n) {
                    return t.push({ err: n, code: e }), O;
                }
            }
            function fs(e) {
                var t = Object.create(null);
                return function (n, r, i) {
                    (r = $({}, r)).warn;
                    delete r.warn;
                    var o = r.delimiters ? String(r.delimiters) + n : n;
                    if (t[o]) return t[o];
                    var a = e(n, r);
                    var s = {},
                        l = [];
                    return (
                        (s.render = hs(a.render, l)),
                        (s.staticRenderFns = a.staticRenderFns.map(function (e) {
                            return hs(e, l);
                        })),
                        (t[o] = s)
                    );
                };
            }
            var ms,
                gs,
                vs =
                    ((ms = function (e, t) {
                        var n = xa(e.trim(), t);
                        !1 !== t.optimize && Na(n, t);
                        var r = Za(n, t);
                        return { ast: n, render: r.render, staticRenderFns: r.staticRenderFns };
                    }),
                    function (e) {
                        function t(t, n) {
                            var r = Object.create(e),
                                i = [],
                                o = [];
                            if (n)
                                for (var a in (n.modules && (r.modules = (e.modules || []).concat(n.modules)), n.directives && (r.directives = $(Object.create(e.directives || null), n.directives)), n))
                                    "modules" !== a && "directives" !== a && (r[a] = n[a]);
                            r.warn = function (e, t, n) {
                                (n ? o : i).push(e);
                            };
                            var s = ms(t.trim(), r);
                            return (s.errors = i), (s.tips = o), s;
                        }
                        return { compile: t, compileToFunctions: fs(t) };
                    }),
                ys = vs(Pa),
                bs = (ys.compile, ys.compileToFunctions);
            function ws(e) {
                return ((gs = gs || document.createElement("div")).innerHTML = e ? '<a href="\n"/>' : '<div a="\n"/>'), gs.innerHTML.indexOf("&#10;") > 0;
            }
            var xs = !!Y && ws(!1),
                Es = !!Y && ws(!0),
                Cs = E(function (e) {
                    var t = lr(e);
                    return t && t.innerHTML;
                }),
                Ss = On.prototype.$mount;
            (On.prototype.$mount = function (e, t) {
                if ((e = e && lr(e)) === document.body || e === document.documentElement) return this;
                var n = this.$options;
                if (!n.render) {
                    var r = n.template;
                    if (r)
                        if ("string" == typeof r) "#" === r.charAt(0) && (r = Cs(r));
                        else {
                            if (!r.nodeType) return this;
                            r = r.innerHTML;
                        }
                    else
                        e &&
                            (r = (function (e) {
                                if (e.outerHTML) return e.outerHTML;
                                var t = document.createElement("div");
                                return t.appendChild(e.cloneNode(!0)), t.innerHTML;
                            })(e));
                    if (r) {
                        0;
                        var i = bs(r, { outputSourceRange: !1, shouldDecodeNewlines: xs, shouldDecodeNewlinesForHref: Es, delimiters: n.delimiters, comments: n.comments }, this),
                            o = i.render,
                            a = i.staticRenderFns;
                        (n.render = o), (n.staticRenderFns = a);
                    }
                }
                return Ss.call(this, e, t);
            }),
                (On.compile = bs),
                (t.a = On);
        }.call(this, n(3), n(8).setImmediate));
    },
    function (e, t, n) {
        !(function (t, n) {
            var r = (function (e, t, n) {
                "use strict";
                var r, i;
                if (
                    ((function () {
                        var t,
                            n = {
                                lazyClass: "lazyload",
                                loadedClass: "lazyloaded",
                                loadingClass: "lazyloading",
                                preloadClass: "lazypreload",
                                errorClass: "lazyerror",
                                autosizesClass: "lazyautosizes",
                                fastLoadedClass: "ls-is-cached",
                                iframeLoadMode: 0,
                                srcAttr: "data-src",
                                srcsetAttr: "data-srcset",
                                sizesAttr: "data-sizes",
                                minSize: 40,
                                customMedia: {},
                                init: !0,
                                expFactor: 1.5,
                                hFac: 0.8,
                                loadMode: 2,
                                loadHidden: !0,
                                ricTimeout: 0,
                                throttleDelay: 125,
                            };
                        for (t in ((i = e.lazySizesConfig || e.lazysizesConfig || {}), n)) t in i || (i[t] = n[t]);
                    })(),
                    !t || !t.getElementsByClassName)
                )
                    return { init: function () {}, cfg: i, noSupport: !0 };
                var o = t.documentElement,
                    a = e.HTMLPictureElement,
                    s = "addEventListener",
                    l = "getAttribute",
                    c = e[s].bind(e),
                    u = e.setTimeout,
                    d = e.requestAnimationFrame || u,
                    p = e.requestIdleCallback,
                    h = /^picture$/i,
                    f = ["load", "error", "lazyincluded", "_lazyloaded"],
                    m = {},
                    g = Array.prototype.forEach,
                    v = function (e, t) {
                        return m[t] || (m[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")), m[t].test(e[l]("class") || "") && m[t];
                    },
                    y = function (e, t) {
                        v(e, t) || e.setAttribute("class", (e[l]("class") || "").trim() + " " + t);
                    },
                    b = function (e, t) {
                        var n;
                        (n = v(e, t)) && e.setAttribute("class", (e[l]("class") || "").replace(n, " "));
                    },
                    w = function (e, t, n) {
                        var r = n ? s : "removeEventListener";
                        n && w(e, t),
                            f.forEach(function (n) {
                                e[r](n, t);
                            });
                    },
                    x = function (e, n, i, o, a) {
                        var s = t.createEvent("Event");
                        return i || (i = {}), (i.instance = r), s.initEvent(n, !o, !a), (s.detail = i), e.dispatchEvent(s), s;
                    },
                    E = function (t, n) {
                        var r;
                        !a && (r = e.picturefill || i.pf) ? (n && n.src && !t[l]("srcset") && t.setAttribute("srcset", n.src), r({ reevaluate: !0, elements: [t] })) : n && n.src && (t.src = n.src);
                    },
                    C = function (e, t) {
                        return (getComputedStyle(e, null) || {})[t];
                    },
                    S = function (e, t, n) {
                        for (n = n || e.offsetWidth; n < i.minSize && t && !e._lazysizesWidth; ) (n = t.offsetWidth), (t = t.parentNode);
                        return n;
                    },
                    T =
                        ((ye = []),
                        (be = []),
                        (we = ye),
                        (xe = function () {
                            var e = we;
                            for (we = ye.length ? be : ye, ge = !0, ve = !1; e.length; ) e.shift()();
                            ge = !1;
                        }),
                        (Ee = function (e, n) {
                            ge && !n ? e.apply(this, arguments) : (we.push(e), ve || ((ve = !0), (t.hidden ? u : d)(xe)));
                        }),
                        (Ee._lsFlush = xe),
                        Ee),
                    k = function (e, t) {
                        return t
                            ? function () {
                                  T(e);
                              }
                            : function () {
                                  var t = this,
                                      n = arguments;
                                  T(function () {
                                      e.apply(t, n);
                                  });
                              };
                    },
                    A = function (e) {
                        var t,
                            r = 0,
                            o = i.throttleDelay,
                            a = i.ricTimeout,
                            s = function () {
                                (t = !1), (r = n.now()), e();
                            },
                            l =
                                p && a > 49
                                    ? function () {
                                          p(s, { timeout: a }), a !== i.ricTimeout && (a = i.ricTimeout);
                                      }
                                    : k(function () {
                                          u(s);
                                      }, !0);
                        return function (e) {
                            var i;
                            (e = !0 === e) && (a = 33), t || ((t = !0), (i = o - (n.now() - r)) < 0 && (i = 0), e || i < 9 ? l() : u(l, i));
                        };
                    },
                    _ = function (e) {
                        var t,
                            r,
                            i = 99,
                            o = function () {
                                (t = null), e();
                            },
                            a = function () {
                                var e = n.now() - r;
                                e < i ? u(a, i - e) : (p || o)(o);
                            };
                        return function () {
                            (r = n.now()), t || (t = u(a, i));
                        };
                    },
                    L =
                        ((Y = /^img$/i),
                        (X = /^iframe$/i),
                        (K = "onscroll" in e && !/(gle|ing)bot/.test(navigator.userAgent)),
                        (J = 0),
                        (Z = 0),
                        (Q = 0),
                        (ee = -1),
                        (te = function (e) {
                            Q--, (!e || Q < 0 || !e.target) && (Q = 0);
                        }),
                        (ne = function (e) {
                            return null == G && (G = "hidden" == C(t.body, "visibility")), G || !("hidden" == C(e.parentNode, "visibility") && "hidden" == C(e, "visibility"));
                        }),
                        (re = function (e, n) {
                            var r,
                                i = e,
                                a = ne(e);
                            for (H -= n, U += n, V -= n, W += n; a && (i = i.offsetParent) && i != t.body && i != o; )
                                (a = (C(i, "opacity") || 1) > 0) && "visible" != C(i, "overflow") && ((r = i.getBoundingClientRect()), (a = W > r.left && V < r.right && U > r.top - 1 && H < r.bottom + 1));
                            return a;
                        }),
                        (ie = function () {
                            var e,
                                n,
                                a,
                                s,
                                c,
                                u,
                                d,
                                p,
                                h,
                                f,
                                m,
                                g,
                                v = r.elements;
                            if ((R = i.loadMode) && Q < 8 && (e = v.length)) {
                                for (n = 0, ee++; n < e; n++)
                                    if (v[n] && !v[n]._lazyRace)
                                        if (!K || (r.prematureUnveil && r.prematureUnveil(v[n]))) pe(v[n]);
                                        else if (
                                            (((p = v[n][l]("data-expand")) && (u = 1 * p)) || (u = Z),
                                            f ||
                                                ((f = !i.expand || i.expand < 1 ? (o.clientHeight > 500 && o.clientWidth > 500 ? 500 : 370) : i.expand),
                                                (r._defEx = f),
                                                (m = f * i.expFactor),
                                                (g = i.hFac),
                                                (G = null),
                                                Z < m && Q < 1 && ee > 2 && R > 2 && !t.hidden ? ((Z = m), (ee = 0)) : (Z = R > 1 && ee > 1 && Q < 6 ? f : J)),
                                            h !== u && ((B = innerWidth + u * g), (j = innerHeight + u), (d = -1 * u), (h = u)),
                                            (a = v[n].getBoundingClientRect()),
                                            (U = a.bottom) >= d &&
                                                (H = a.top) <= j &&
                                                (W = a.right) >= d * g &&
                                                (V = a.left) <= B &&
                                                (U || W || V || H) &&
                                                (i.loadHidden || ne(v[n])) &&
                                                ((N && Q < 3 && !p && (R < 3 || ee < 4)) || re(v[n], u)))
                                        ) {
                                            if ((pe(v[n]), (c = !0), Q > 9)) break;
                                        } else !c && N && !s && Q < 4 && ee < 4 && R > 2 && (I[0] || i.preloadAfterLoad) && (I[0] || (!p && (U || W || V || H || "auto" != v[n][l](i.sizesAttr)))) && (s = I[0] || v[n]);
                                s && !c && pe(s);
                            }
                        }),
                        (oe = A(ie)),
                        (ae = function (e) {
                            var t = e.target;
                            t._lazyCache ? delete t._lazyCache : (te(e), y(t, i.loadedClass), b(t, i.loadingClass), w(t, le), x(t, "lazyloaded"));
                        }),
                        (se = k(ae)),
                        (le = function (e) {
                            se({ target: e.target });
                        }),
                        (ce = function (e, t) {
                            var n = e.getAttribute("data-load-mode") || i.iframeLoadMode;
                            0 == n ? e.contentWindow.location.replace(t) : 1 == n && (e.src = t);
                        }),
                        (ue = function (e) {
                            var t,
                                n = e[l](i.srcsetAttr);
                            (t = i.customMedia[e[l]("data-media") || e[l]("media")]) && e.setAttribute("media", t), n && e.setAttribute("srcset", n);
                        }),
                        (de = k(function (e, t, n, r, o) {
                            var a, s, c, d, p, f;
                            (p = x(e, "lazybeforeunveil", t)).defaultPrevented ||
                                (r && (n ? y(e, i.autosizesClass) : e.setAttribute("sizes", r)),
                                (s = e[l](i.srcsetAttr)),
                                (a = e[l](i.srcAttr)),
                                o && (d = (c = e.parentNode) && h.test(c.nodeName || "")),
                                (f = t.firesLoad || ("src" in e && (s || a || d))),
                                (p = { target: e }),
                                y(e, i.loadingClass),
                                f && (clearTimeout(z), (z = u(te, 2500)), w(e, le, !0)),
                                d && g.call(c.getElementsByTagName("source"), ue),
                                s ? e.setAttribute("srcset", s) : a && !d && (X.test(e.nodeName) ? ce(e, a) : (e.src = a)),
                                o && (s || d) && E(e, { src: a })),
                                e._lazyRace && delete e._lazyRace,
                                b(e, i.lazyClass),
                                T(function () {
                                    var t = e.complete && e.naturalWidth > 1;
                                    (f && !t) ||
                                        (t && y(e, i.fastLoadedClass),
                                        ae(p),
                                        (e._lazyCache = !0),
                                        u(function () {
                                            "_lazyCache" in e && delete e._lazyCache;
                                        }, 9)),
                                        "lazy" == e.loading && Q--;
                                }, !0);
                        })),
                        (pe = function (e) {
                            if (!e._lazyRace) {
                                var t,
                                    n = Y.test(e.nodeName),
                                    r = n && (e[l](i.sizesAttr) || e[l]("sizes")),
                                    o = "auto" == r;
                                ((!o && N) || !n || (!e[l]("src") && !e.srcset) || e.complete || v(e, i.errorClass) || !v(e, i.lazyClass)) &&
                                    ((t = x(e, "lazyunveilread").detail), o && $.updateElem(e, !0, e.offsetWidth), (e._lazyRace = !0), Q++, de(e, t, o, r, n));
                            }
                        }),
                        (he = _(function () {
                            (i.loadMode = 3), oe();
                        })),
                        (fe = function () {
                            3 == i.loadMode && (i.loadMode = 2), he();
                        }),
                        (me = function () {
                            N || (n.now() - F < 999 ? u(me, 999) : ((N = !0), (i.loadMode = 3), oe(), c("scroll", fe, !0)));
                        }),
                        {
                            _: function () {
                                (F = n.now()),
                                    (r.elements = t.getElementsByClassName(i.lazyClass)),
                                    (I = t.getElementsByClassName(i.lazyClass + " " + i.preloadClass)),
                                    c("scroll", oe, !0),
                                    c("resize", oe, !0),
                                    c("pageshow", function (e) {
                                        if (e.persisted) {
                                            var n = t.querySelectorAll("." + i.loadingClass);
                                            n.length &&
                                                n.forEach &&
                                                d(function () {
                                                    n.forEach(function (e) {
                                                        e.complete && pe(e);
                                                    });
                                                });
                                        }
                                    }),
                                    e.MutationObserver ? new MutationObserver(oe).observe(o, { childList: !0, subtree: !0, attributes: !0 }) : (o[s]("DOMNodeInserted", oe, !0), o[s]("DOMAttrModified", oe, !0), setInterval(oe, 999)),
                                    c("hashchange", oe, !0),
                                    ["focus", "mouseover", "click", "load", "transitionend", "animationend"].forEach(function (e) {
                                        t[s](e, oe, !0);
                                    }),
                                    /d$|^c/.test(t.readyState) ? me() : (c("load", me), t[s]("DOMContentLoaded", oe), u(me, 2e4)),
                                    r.elements.length ? (ie(), T._lsFlush()) : oe();
                            },
                            checkElems: oe,
                            unveil: pe,
                            _aLSL: fe,
                        }),
                    $ =
                        ((q = k(function (e, t, n, r) {
                            var i, o, a;
                            if (((e._lazysizesWidth = r), (r += "px"), e.setAttribute("sizes", r), h.test(t.nodeName || ""))) for (o = 0, a = (i = t.getElementsByTagName("source")).length; o < a; o++) i[o].setAttribute("sizes", r);
                            n.detail.dataAttr || E(e, n.detail);
                        })),
                        (M = function (e, t, n) {
                            var r,
                                i = e.parentNode;
                            i && ((n = S(e, i, n)), (r = x(e, "lazybeforesizes", { width: n, dataAttr: !!t })).defaultPrevented || ((n = r.detail.width) && n !== e._lazysizesWidth && q(e, i, r, n)));
                        }),
                        (P = _(function () {
                            var e,
                                t = O.length;
                            if (t) for (e = 0; e < t; e++) M(O[e]);
                        })),
                        {
                            _: function () {
                                (O = t.getElementsByClassName(i.autosizesClass)), c("resize", P);
                            },
                            checkElems: P,
                            updateElem: M,
                        }),
                    D = function () {
                        !D.i && t.getElementsByClassName && ((D.i = !0), $._(), L._());
                    };
                var O, q, M, P;
                var I, N, z, R, F, B, j, H, V, W, U, G, Y, X, K, J, Z, Q, ee, te, ne, re, ie, oe, ae, se, le, ce, ue, de, pe, he, fe, me;
                var ge, ve, ye, be, we, xe, Ee;
                return (
                    u(function () {
                        i.init && D();
                    }),
                    (r = { cfg: i, autoSizer: $, loader: L, init: D, uP: E, aC: y, rC: b, hC: v, fire: x, gW: S, rAF: T })
                );
            })(t, t.document, Date);
            (t.lazySizes = r), e.exports && (e.exports = r);
        })("undefined" != typeof window ? window : {});
    },
    function (e, t) {
        var n;
        n = (function () {
            return this;
        })();
        try {
            n = n || new Function("return this")();
        } catch (e) {
            "object" == typeof window && (n = window);
        }
        e.exports = n;
    },
    function (e, t, n) {
        "use strict";
        e.exports = function (e, t, n) {
            var r,
                i,
                o,
                a,
                s = !1,
                l = !1,
                c = {},
                u = 0,
                d = 0,
                p = { sensitivity: 7, interval: 100, timeout: 0, handleFocus: !1 };
            function h(e) {
                (r = e.clientX), (i = e.clientY);
            }
            function f(e, n) {
                if ((d && (d = clearTimeout(d)), Math.abs(o - r) + Math.abs(a - i) < p.sensitivity)) return (u = 1), l ? void 0 : t.call(e, n);
                (o = r),
                    (a = i),
                    (d = setTimeout(function () {
                        f(e, n);
                    }, p.interval));
            }
            function m(t) {
                return (
                    (s = !0),
                    d && (d = clearTimeout(d)),
                    e.removeEventListener("mousemove", h, !1),
                    1 !== u &&
                        ((o = t.clientX),
                        (a = t.clientY),
                        e.addEventListener("mousemove", h, !1),
                        (d = setTimeout(function () {
                            f(e, t);
                        }, p.interval))),
                    this
                );
            }
            function g(t) {
                return (
                    (s = !1),
                    d && (d = clearTimeout(d)),
                    e.removeEventListener("mousemove", h, !1),
                    1 === u &&
                        (d = setTimeout(function () {
                            !(function (e, t) {
                                d && (d = clearTimeout(d)), (u = 0), l || n.call(e, t);
                            })(e, t);
                        }, p.timeout)),
                    this
                );
            }
            function v(n) {
                s || ((l = !0), t.call(e, n));
            }
            function y(t) {
                !s && l && ((l = !1), n.call(e, t));
            }
            function b() {
                e.removeEventListener("focus", v, !1), e.removeEventListener("blur", y, !1);
            }
            return (
                (c.options = function (t) {
                    var n = t.handleFocus !== p.handleFocus;
                    return (p = Object.assign({}, p, t)), n && (p.handleFocus ? (e.addEventListener("focus", v, !1), e.addEventListener("blur", y, !1)) : b()), c;
                }),
                (c.remove = function () {
                    e && (e.removeEventListener("mouseover", m, !1), e.removeEventListener("mouseout", g, !1), b());
                }),
                e && (e.addEventListener("mouseover", m, !1), e.addEventListener("mouseout", g, !1)),
                c
            );
        };
    },
    function (e, t, n) {
        var r, i;
        /*!
         * imagesLoaded v4.1.4
         * JavaScript is all like "You images are done yet or what?"
         * MIT License
         */ !(function (o, a) {
            "use strict";
            (r = [n(6)]),
                (i = function (e) {
                    return (function (e, t) {
                        var n = e.jQuery,
                            r = e.console;
                        function i(e, t) {
                            for (var n in t) e[n] = t[n];
                            return e;
                        }
                        var o = Array.prototype.slice;
                        function a(e) {
                            return Array.isArray(e) ? e : "object" == typeof e && "number" == typeof e.length ? o.call(e) : [e];
                        }
                        function s(e, t, o) {
                            if (!(this instanceof s)) return new s(e, t, o);
                            var l = e;
                            "string" == typeof e && (l = document.querySelectorAll(e)),
                                l
                                    ? ((this.elements = a(l)),
                                      (this.options = i({}, this.options)),
                                      "function" == typeof t ? (o = t) : i(this.options, t),
                                      o && this.on("always", o),
                                      this.getImages(),
                                      n && (this.jqDeferred = new n.Deferred()),
                                      setTimeout(this.check.bind(this)))
                                    : r.error("Bad element for imagesLoaded " + (l || e));
                        }
                        (s.prototype = Object.create(t.prototype)),
                            (s.prototype.options = {}),
                            (s.prototype.getImages = function () {
                                (this.images = []), this.elements.forEach(this.addElementImages, this);
                            }),
                            (s.prototype.addElementImages = function (e) {
                                "IMG" == e.nodeName && this.addImage(e), !0 === this.options.background && this.addElementBackgroundImages(e);
                                var t = e.nodeType;
                                if (t && l[t]) {
                                    for (var n = e.querySelectorAll("img"), r = 0; r < n.length; r++) {
                                        var i = n[r];
                                        this.addImage(i);
                                    }
                                    if ("string" == typeof this.options.background) {
                                        var o = e.querySelectorAll(this.options.background);
                                        for (r = 0; r < o.length; r++) {
                                            var a = o[r];
                                            this.addElementBackgroundImages(a);
                                        }
                                    }
                                }
                            });
                        var l = { 1: !0, 9: !0, 11: !0 };
                        function c(e) {
                            this.img = e;
                        }
                        function u(e, t) {
                            (this.url = e), (this.element = t), (this.img = new Image());
                        }
                        return (
                            (s.prototype.addElementBackgroundImages = function (e) {
                                var t = getComputedStyle(e);
                                if (t)
                                    for (var n = /url\((['"])?(.*?)\1\)/gi, r = n.exec(t.backgroundImage); null !== r; ) {
                                        var i = r && r[2];
                                        i && this.addBackground(i, e), (r = n.exec(t.backgroundImage));
                                    }
                            }),
                            (s.prototype.addImage = function (e) {
                                var t = new c(e);
                                this.images.push(t);
                            }),
                            (s.prototype.addBackground = function (e, t) {
                                var n = new u(e, t);
                                this.images.push(n);
                            }),
                            (s.prototype.check = function () {
                                var e = this;
                                function t(t, n, r) {
                                    setTimeout(function () {
                                        e.progress(t, n, r);
                                    });
                                }
                                (this.progressedCount = 0),
                                    (this.hasAnyBroken = !1),
                                    this.images.length
                                        ? this.images.forEach(function (e) {
                                              e.once("progress", t), e.check();
                                          })
                                        : this.complete();
                            }),
                            (s.prototype.progress = function (e, t, n) {
                                this.progressedCount++,
                                    (this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded),
                                    this.emitEvent("progress", [this, e, t]),
                                    this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, e),
                                    this.progressedCount == this.images.length && this.complete(),
                                    this.options.debug && r && r.log("progress: " + n, e, t);
                            }),
                            (s.prototype.complete = function () {
                                var e = this.hasAnyBroken ? "fail" : "done";
                                if (((this.isComplete = !0), this.emitEvent(e, [this]), this.emitEvent("always", [this]), this.jqDeferred)) {
                                    var t = this.hasAnyBroken ? "reject" : "resolve";
                                    this.jqDeferred[t](this);
                                }
                            }),
                            (c.prototype = Object.create(t.prototype)),
                            (c.prototype.check = function () {
                                this.getIsImageComplete()
                                    ? this.confirm(0 !== this.img.naturalWidth, "naturalWidth")
                                    : ((this.proxyImage = new Image()),
                                      this.proxyImage.addEventListener("load", this),
                                      this.proxyImage.addEventListener("error", this),
                                      this.img.addEventListener("load", this),
                                      this.img.addEventListener("error", this),
                                      (this.proxyImage.src = this.img.src));
                            }),
                            (c.prototype.getIsImageComplete = function () {
                                return this.img.complete && this.img.naturalWidth;
                            }),
                            (c.prototype.confirm = function (e, t) {
                                (this.isLoaded = e), this.emitEvent("progress", [this, this.img, t]);
                            }),
                            (c.prototype.handleEvent = function (e) {
                                var t = "on" + e.type;
                                this[t] && this[t](e);
                            }),
                            (c.prototype.onload = function () {
                                this.confirm(!0, "onload"), this.unbindEvents();
                            }),
                            (c.prototype.onerror = function () {
                                this.confirm(!1, "onerror"), this.unbindEvents();
                            }),
                            (c.prototype.unbindEvents = function () {
                                this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
                            }),
                            (u.prototype = Object.create(c.prototype)),
                            (u.prototype.check = function () {
                                this.img.addEventListener("load", this),
                                    this.img.addEventListener("error", this),
                                    (this.img.src = this.url),
                                    this.getIsImageComplete() && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents());
                            }),
                            (u.prototype.unbindEvents = function () {
                                this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
                            }),
                            (u.prototype.confirm = function (e, t) {
                                (this.isLoaded = e), this.emitEvent("progress", [this, this.element, t]);
                            }),
                            (s.makeJQueryPlugin = function (t) {
                                (t = t || e.jQuery) &&
                                    ((n = t).fn.imagesLoaded = function (e, t) {
                                        return new s(this, e, t).jqDeferred.promise(n(this));
                                    });
                            }),
                            s.makeJQueryPlugin(),
                            s
                        );
                    })(o, e);
                }.apply(t, r)),
                void 0 === i || (e.exports = i);
        })("undefined" != typeof window ? window : this);
    },
    function (e, t, n) {
        var r, i;
        "undefined" != typeof window && window,
            void 0 ===
                (i =
                    "function" ==
                    typeof (r = function () {
                        "use strict";
                        function e() {}
                        var t = e.prototype;
                        return (
                            (t.on = function (e, t) {
                                if (e && t) {
                                    var n = (this._events = this._events || {}),
                                        r = (n[e] = n[e] || []);
                                    return -1 == r.indexOf(t) && r.push(t), this;
                                }
                            }),
                            (t.once = function (e, t) {
                                if (e && t) {
                                    this.on(e, t);
                                    var n = (this._onceEvents = this._onceEvents || {});
                                    return ((n[e] = n[e] || {})[t] = !0), this;
                                }
                            }),
                            (t.off = function (e, t) {
                                var n = this._events && this._events[e];
                                if (n && n.length) {
                                    var r = n.indexOf(t);
                                    return -1 != r && n.splice(r, 1), this;
                                }
                            }),
                            (t.emitEvent = function (e, t) {
                                var n = this._events && this._events[e];
                                if (n && n.length) {
                                    (n = n.slice(0)), (t = t || []);
                                    for (var r = this._onceEvents && this._onceEvents[e], i = 0; i < n.length; i++) {
                                        var o = n[i];
                                        r && r[o] && (this.off(e, o), delete r[o]), o.apply(this, t);
                                    }
                                    return this;
                                }
                            }),
                            (t.allOff = function () {
                                delete this._events, delete this._onceEvents;
                            }),
                            e
                        );
                    })
                        ? r.call(t, n, t, e)
                        : r) || (e.exports = i);
    },
    function (e, t, n) {
        var r, i;
        /*!
         * getSize v2.0.3
         * measure size of elements
         * MIT license
         */ window,
            void 0 ===
                (i =
                    "function" ==
                    typeof (r = function () {
                        "use strict";
                        function e(e) {
                            var t = parseFloat(e);
                            return -1 == e.indexOf("%") && !isNaN(t) && t;
                        }
                        function t() {}
                        var n =
                                "undefined" == typeof console
                                    ? t
                                    : function (e) {
                                          console.error(e);
                                      },
                            r = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
                            i = r.length;
                        function o() {
                            for (var e = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 }, t = 0; t < i; t++) e[r[t]] = 0;
                            return e;
                        }
                        function a(e) {
                            var t = getComputedStyle(e);
                            return t || n("Style returned " + t + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), t;
                        }
                        var s,
                            l = !1;
                        function c() {
                            if (!l) {
                                l = !0;
                                var t = document.createElement("div");
                                (t.style.width = "200px"), (t.style.padding = "1px 2px 3px 4px"), (t.style.borderStyle = "solid"), (t.style.borderWidth = "1px 2px 3px 4px"), (t.style.boxSizing = "border-box");
                                var n = document.body || document.documentElement;
                                n.appendChild(t);
                                var r = a(t);
                                (s = 200 == Math.round(e(r.width))), (u.isBoxSizeOuter = s), n.removeChild(t);
                            }
                        }
                        function u(t) {
                            if ((c(), "string" == typeof t && (t = document.querySelector(t)), t && "object" == typeof t && t.nodeType)) {
                                var n = a(t);
                                if ("none" == n.display) return o();
                                var l = {};
                                (l.width = t.offsetWidth), (l.height = t.offsetHeight);
                                for (var u = (l.isBorderBox = "border-box" == n.boxSizing), d = 0; d < i; d++) {
                                    var p = r[d],
                                        h = n[p],
                                        f = parseFloat(h);
                                    l[p] = isNaN(f) ? 0 : f;
                                }
                                var m = l.paddingLeft + l.paddingRight,
                                    g = l.paddingTop + l.paddingBottom,
                                    v = l.marginLeft + l.marginRight,
                                    y = l.marginTop + l.marginBottom,
                                    b = l.borderLeftWidth + l.borderRightWidth,
                                    w = l.borderTopWidth + l.borderBottomWidth,
                                    x = u && s,
                                    E = e(n.width);
                                !1 !== E && (l.width = E + (x ? 0 : m + b));
                                var C = e(n.height);
                                return !1 !== C && (l.height = C + (x ? 0 : g + w)), (l.innerWidth = l.width - (m + b)), (l.innerHeight = l.height - (g + w)), (l.outerWidth = l.width + v), (l.outerHeight = l.height + y), l;
                            }
                        }
                        return u;
                    })
                        ? r.call(t, n, t, e)
                        : r) || (e.exports = i);
    },
    function (e, t, n) {
        (function (e) {
            var r = (void 0 !== e && e) || ("undefined" != typeof self && self) || window,
                i = Function.prototype.apply;
            function o(e, t) {
                (this._id = e), (this._clearFn = t);
            }
            (t.setTimeout = function () {
                return new o(i.call(setTimeout, r, arguments), clearTimeout);
            }),
                (t.setInterval = function () {
                    return new o(i.call(setInterval, r, arguments), clearInterval);
                }),
                (t.clearTimeout = t.clearInterval = function (e) {
                    e && e.close();
                }),
                (o.prototype.unref = o.prototype.ref = function () {}),
                (o.prototype.close = function () {
                    this._clearFn.call(r, this._id);
                }),
                (t.enroll = function (e, t) {
                    clearTimeout(e._idleTimeoutId), (e._idleTimeout = t);
                }),
                (t.unenroll = function (e) {
                    clearTimeout(e._idleTimeoutId), (e._idleTimeout = -1);
                }),
                (t._unrefActive = t.active = function (e) {
                    clearTimeout(e._idleTimeoutId);
                    var t = e._idleTimeout;
                    t >= 0 &&
                        (e._idleTimeoutId = setTimeout(function () {
                            e._onTimeout && e._onTimeout();
                        }, t));
                }),
                n(21),
                (t.setImmediate = ("undefined" != typeof self && self.setImmediate) || (void 0 !== e && e.setImmediate) || (this && this.setImmediate)),
                (t.clearImmediate = ("undefined" != typeof self && self.clearImmediate) || (void 0 !== e && e.clearImmediate) || (this && this.clearImmediate));
        }.call(this, n(3)));
    },
    function (e, t, n) {
        var r, i, o;
        (i = [e, t]),
            (r = function (e, t) {
                "use strict";
                var n, r;
                function i(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                Object.defineProperty(t, "__esModule", { value: !0 });
                var o = (function () {
                    function e(e, t) {
                        for (var n = 0; n < t.length; n++) {
                            var r = t[n];
                            (r.enumerable = r.enumerable || !1), (r.configurable = !0), "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                        }
                    }
                    return function (t, n, r) {
                        return n && e(t.prototype, n), r && e(t, r), t;
                    };
                })();
                function a(e, t) {
                    return t.indexOf(e) >= 0;
                }
                function s(e, t) {
                    for (var n in t)
                        if (null == e[n]) {
                            var r = t[n];
                            e[n] = r;
                        }
                    return e;
                }
                function l(e) {
                    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(e);
                }
                function c(e) {
                    var t = !(arguments.length <= 1 || void 0 === arguments[1]) && arguments[1],
                        n = !(arguments.length <= 2 || void 0 === arguments[2]) && arguments[2],
                        r = arguments.length <= 3 || void 0 === arguments[3] ? null : arguments[3],
                        i = void 0;
                    return (
                        null != document.createEvent ? (i = document.createEvent("CustomEvent")).initCustomEvent(e, t, n, r) : null != document.createEventObject ? ((i = document.createEventObject()).eventType = e) : (i.eventName = e), i
                    );
                }
                function u(e, t) {
                    null != e.dispatchEvent ? e.dispatchEvent(t) : t in (null != e) ? e[t]() : "on" + t in (null != e) && e["on" + t]();
                }
                function d(e, t, n) {
                    null != e.addEventListener ? e.addEventListener(t, n, !1) : null != e.attachEvent ? e.attachEvent("on" + t, n) : (e[t] = n);
                }
                function p(e, t, n) {
                    null != e.removeEventListener ? e.removeEventListener(t, n, !1) : null != e.detachEvent ? e.detachEvent("on" + t, n) : delete e[t];
                }
                function h() {
                    return "innerHeight" in window ? window.innerHeight : document.documentElement.clientHeight;
                }
                var f =
                        window.WeakMap ||
                        window.MozWeakMap ||
                        (function () {
                            function e() {
                                i(this, e), (this.keys = []), (this.values = []);
                            }
                            return (
                                o(e, [
                                    {
                                        key: "get",
                                        value: function (e) {
                                            for (var t = 0; t < this.keys.length; t++) if (this.keys[t] === e) return this.values[t];
                                        },
                                    },
                                    {
                                        key: "set",
                                        value: function (e, t) {
                                            for (var n = 0; n < this.keys.length; n++) if (this.keys[n] === e) return (this.values[n] = t), this;
                                            return this.keys.push(e), this.values.push(t), this;
                                        },
                                    },
                                ]),
                                e
                            );
                        })(),
                    m =
                        window.MutationObserver ||
                        window.WebkitMutationObserver ||
                        window.MozMutationObserver ||
                        ((r = n = (function () {
                            function e() {
                                i(this, e),
                                    "undefined" != typeof console &&
                                        null !== console &&
                                        (console.warn("MutationObserver is not supported by your browser."), console.warn("WOW.js cannot detect dom mutations, please call .sync() after loading new content."));
                            }
                            return o(e, [{ key: "observe", value: function () {} }]), e;
                        })()),
                        (n.notSupported = !0),
                        r),
                    g =
                        window.getComputedStyle ||
                        function (e) {
                            var t = /(\-([a-z]){1})/g;
                            return {
                                getPropertyValue: function (n) {
                                    "float" === n && (n = "styleFloat"),
                                        t.test(n) &&
                                            n.replace(t, function (e, t) {
                                                return t.toUpperCase();
                                            });
                                    var r = e.currentStyle;
                                    return (null != r ? r[n] : void 0) || null;
                                },
                            };
                        },
                    v = (function () {
                        function e() {
                            var t = arguments.length <= 0 || void 0 === arguments[0] ? {} : arguments[0];
                            i(this, e),
                                (this.defaults = { boxClass: "wow", animateClass: "animated", offset: 0, mobile: !0, live: !0, callback: null, scrollContainer: null }),
                                (this.animate =
                                    "requestAnimationFrame" in window
                                        ? function (e) {
                                              return window.requestAnimationFrame(e);
                                          }
                                        : function (e) {
                                              return e();
                                          }),
                                (this.vendors = ["moz", "webkit"]),
                                (this.start = this.start.bind(this)),
                                (this.resetAnimation = this.resetAnimation.bind(this)),
                                (this.scrollHandler = this.scrollHandler.bind(this)),
                                (this.scrollCallback = this.scrollCallback.bind(this)),
                                (this.scrolled = !0),
                                (this.config = s(t, this.defaults)),
                                null != t.scrollContainer && (this.config.scrollContainer = document.querySelector(t.scrollContainer)),
                                (this.animationNameCache = new f()),
                                (this.wowEvent = c(this.config.boxClass));
                        }
                        return (
                            o(e, [
                                {
                                    key: "init",
                                    value: function () {
                                        (this.element = window.document.documentElement), a(document.readyState, ["interactive", "complete"]) ? this.start() : d(document, "DOMContentLoaded", this.start), (this.finished = []);
                                    },
                                },
                                {
                                    key: "start",
                                    value: function () {
                                        var e = this;
                                        if (((this.stopped = !1), (this.boxes = [].slice.call(this.element.querySelectorAll("." + this.config.boxClass))), (this.all = this.boxes.slice(0)), this.boxes.length))
                                            if (this.disabled()) this.resetStyle();
                                            else
                                                for (var t = 0; t < this.boxes.length; t++) {
                                                    var n = this.boxes[t];
                                                    this.applyStyle(n, !0);
                                                }
                                        this.disabled() || (d(this.config.scrollContainer || window, "scroll", this.scrollHandler), d(window, "resize", this.scrollHandler), (this.interval = setInterval(this.scrollCallback, 50))),
                                            this.config.live &&
                                                new m(function (t) {
                                                    for (var n = 0; n < t.length; n++)
                                                        for (var r = t[n], i = 0; i < r.addedNodes.length; i++) {
                                                            var o = r.addedNodes[i];
                                                            e.doSync(o);
                                                        }
                                                }).observe(document.body, { childList: !0, subtree: !0 });
                                    },
                                },
                                {
                                    key: "stop",
                                    value: function () {
                                        (this.stopped = !0), p(this.config.scrollContainer || window, "scroll", this.scrollHandler), p(window, "resize", this.scrollHandler), null != this.interval && clearInterval(this.interval);
                                    },
                                },
                                {
                                    key: "sync",
                                    value: function () {
                                        m.notSupported && this.doSync(this.element);
                                    },
                                },
                                {
                                    key: "doSync",
                                    value: function (e) {
                                        if ((null == e && (e = this.element), 1 === e.nodeType))
                                            for (var t = (e = e.parentNode || e).querySelectorAll("." + this.config.boxClass), n = 0; n < t.length; n++) {
                                                var r = t[n];
                                                a(r, this.all) || (this.boxes.push(r), this.all.push(r), this.stopped || this.disabled() ? this.resetStyle() : this.applyStyle(r, !0), (this.scrolled = !0));
                                            }
                                    },
                                },
                                {
                                    key: "show",
                                    value: function (e) {
                                        return (
                                            this.applyStyle(e),
                                            (e.className = e.className + " " + this.config.animateClass),
                                            null != this.config.callback && this.config.callback(e),
                                            u(e, this.wowEvent),
                                            d(e, "animationend", this.resetAnimation),
                                            d(e, "oanimationend", this.resetAnimation),
                                            d(e, "webkitAnimationEnd", this.resetAnimation),
                                            d(e, "MSAnimationEnd", this.resetAnimation),
                                            e
                                        );
                                    },
                                },
                                {
                                    key: "applyStyle",
                                    value: function (e, t) {
                                        var n = this,
                                            r = e.getAttribute("data-wow-duration"),
                                            i = e.getAttribute("data-wow-delay"),
                                            o = e.getAttribute("data-wow-iteration");
                                        return this.animate(function () {
                                            return n.customStyle(e, t, r, i, o);
                                        });
                                    },
                                },
                                {
                                    key: "resetStyle",
                                    value: function () {
                                        for (var e = 0; e < this.boxes.length; e++) this.boxes[e].style.visibility = "visible";
                                    },
                                },
                                {
                                    key: "resetAnimation",
                                    value: function (e) {
                                        if (e.type.toLowerCase().indexOf("animationend") >= 0) {
                                            var t = e.target || e.srcElement;
                                            t.className = t.className.replace(this.config.animateClass, "").trim();
                                        }
                                    },
                                },
                                {
                                    key: "customStyle",
                                    value: function (e, t, n, r, i) {
                                        return (
                                            t && this.cacheAnimationName(e),
                                            (e.style.visibility = t ? "hidden" : "visible"),
                                            n && this.vendorSet(e.style, { animationDuration: n }),
                                            r && this.vendorSet(e.style, { animationDelay: r }),
                                            i && this.vendorSet(e.style, { animationIterationCount: i }),
                                            this.vendorSet(e.style, { animationName: t ? "none" : this.cachedAnimationName(e) }),
                                            e
                                        );
                                    },
                                },
                                {
                                    key: "vendorSet",
                                    value: function (e, t) {
                                        for (var n in t)
                                            if (t.hasOwnProperty(n)) {
                                                var r = t[n];
                                                e["" + n] = r;
                                                for (var i = 0; i < this.vendors.length; i++) e["" + this.vendors[i] + n.charAt(0).toUpperCase() + n.substr(1)] = r;
                                            }
                                    },
                                },
                                {
                                    key: "vendorCSS",
                                    value: function (e, t) {
                                        for (var n = g(e), r = n.getPropertyCSSValue(t), i = 0; i < this.vendors.length; i++) {
                                            var o = this.vendors[i];
                                            r = r || n.getPropertyCSSValue("-" + o + "-" + t);
                                        }
                                        return r;
                                    },
                                },
                                {
                                    key: "animationName",
                                    value: function (e) {
                                        var t = void 0;
                                        try {
                                            t = this.vendorCSS(e, "animation-name").cssText;
                                        } catch (n) {
                                            t = g(e).getPropertyValue("animation-name");
                                        }
                                        return "none" === t ? "" : t;
                                    },
                                },
                                {
                                    key: "cacheAnimationName",
                                    value: function (e) {
                                        return this.animationNameCache.set(e, this.animationName(e));
                                    },
                                },
                                {
                                    key: "cachedAnimationName",
                                    value: function (e) {
                                        return this.animationNameCache.get(e);
                                    },
                                },
                                {
                                    key: "scrollHandler",
                                    value: function () {
                                        this.scrolled = !0;
                                    },
                                },
                                {
                                    key: "scrollCallback",
                                    value: function () {
                                        if (this.scrolled) {
                                            this.scrolled = !1;
                                            for (var e = [], t = 0; t < this.boxes.length; t++) {
                                                var n = this.boxes[t];
                                                if (n) {
                                                    if (this.isVisible(n)) {
                                                        this.show(n);
                                                        continue;
                                                    }
                                                    e.push(n);
                                                }
                                            }
                                            (this.boxes = e), this.boxes.length || this.config.live || this.stop();
                                        }
                                    },
                                },
                                {
                                    key: "offsetTop",
                                    value: function (e) {
                                        for (; void 0 === e.offsetTop; ) e = e.parentNode;
                                        for (var t = e.offsetTop; e.offsetParent; ) t += (e = e.offsetParent).offsetTop;
                                        return t;
                                    },
                                },
                                {
                                    key: "isVisible",
                                    value: function (e) {
                                        var t = e.getAttribute("data-wow-offset") || this.config.offset,
                                            n = (this.config.scrollContainer && this.config.scrollContainer.scrollTop) || window.pageYOffset,
                                            r = n + Math.min(this.element.clientHeight, h()) - t,
                                            i = this.offsetTop(e),
                                            o = i + e.clientHeight;
                                        return i <= r && o >= n;
                                    },
                                },
                                {
                                    key: "disabled",
                                    value: function () {
                                        return !this.config.mobile && l(navigator.userAgent);
                                    },
                                },
                            ]),
                            e
                        );
                    })();
                (t.default = v), (e.exports = t.default);
            }),
            void 0 === (o = "function" == typeof r ? r.apply(t, i) : r) || (e.exports = o);
    },
    function (e, t, n) {
        (function (n) {
            var r, i, o;
            "undefined" != typeof window && window,
                (i = []),
                void 0 ===
                    (o =
                        "function" ==
                        typeof (r = function () {
                            var e = function (t, n) {
                                "use strict";
                                var r = Object.create(e.prototype),
                                    i = 0,
                                    o = 0,
                                    a = 0,
                                    s = 0,
                                    l = [],
                                    c = !0,
                                    u =
                                        window.requestAnimationFrame ||
                                        window.webkitRequestAnimationFrame ||
                                        window.mozRequestAnimationFrame ||
                                        window.msRequestAnimationFrame ||
                                        window.oRequestAnimationFrame ||
                                        function (e) {
                                            return setTimeout(e, 1e3 / 60);
                                        },
                                    d = null,
                                    p = !1;
                                try {
                                    var h = Object.defineProperty({}, "passive", {
                                        get: function () {
                                            p = !0;
                                        },
                                    });
                                    window.addEventListener("testPassive", null, h), window.removeEventListener("testPassive", null, h);
                                } catch (e) {}
                                var f = window.cancelAnimationFrame || window.mozCancelAnimationFrame || clearTimeout,
                                    m =
                                        window.transformProp ||
                                        (function () {
                                            var e = document.createElement("div");
                                            if (null === e.style.transform) {
                                                var t = ["Webkit", "Moz", "ms"];
                                                for (var n in t) if (void 0 !== e.style[t[n] + "Transform"]) return t[n] + "Transform";
                                            }
                                            return "transform";
                                        })();
                                function g() {
                                    if (3 === r.options.breakpoints.length && Array.isArray(r.options.breakpoints)) {
                                        var e,
                                            t = !0,
                                            n = !0;
                                        if (
                                            (r.options.breakpoints.forEach(function (r) {
                                                "number" != typeof r && (n = !1), null !== e && r < e && (t = !1), (e = r);
                                            }),
                                            t && n)
                                        )
                                            return;
                                    }
                                    (r.options.breakpoints = [576, 768, 1201]), console.warn("Rellax: You must pass an array of 3 numbers in ascending order to the breakpoints option. Defaults reverted");
                                }
                                (r.options = {
                                    speed: -2,
                                    verticalSpeed: null,
                                    horizontalSpeed: null,
                                    breakpoints: [576, 768, 1201],
                                    center: !1,
                                    wrapper: null,
                                    relativeToWrapper: !1,
                                    round: !0,
                                    vertical: !0,
                                    horizontal: !1,
                                    verticalScrollAxis: "y",
                                    horizontalScrollAxis: "x",
                                    callback: function () {},
                                }),
                                    n &&
                                        Object.keys(n).forEach(function (e) {
                                            r.options[e] = n[e];
                                        }),
                                    n && n.breakpoints && g(),
                                    t || (t = ".rellax");
                                var v = "string" == typeof t ? document.querySelectorAll(t) : [t];
                                if (v.length > 0) {
                                    if (((r.elems = v), r.options.wrapper && !r.options.wrapper.nodeType)) {
                                        var y = document.querySelector(r.options.wrapper);
                                        if (!y) return void console.warn("Rellax: The wrapper you're trying to use doesn't exist.");
                                        r.options.wrapper = y;
                                    }
                                    var b,
                                        w = function (e) {
                                            var t = r.options.breakpoints;
                                            return e < t[0] ? "xs" : e >= t[0] && e < t[1] ? "sm" : e >= t[1] && e < t[2] ? "md" : "lg";
                                        },
                                        x = function () {
                                            for (var e = 0; e < r.elems.length; e++) {
                                                var t = C(r.elems[e]);
                                                l.push(t);
                                            }
                                        },
                                        E = function () {
                                            for (var e = 0; e < l.length; e++) r.elems[e].style.cssText = l[e].style;
                                            (l = []), (o = window.innerHeight), (s = window.innerWidth), (b = w(s)), S(), x(), _(), c && (window.addEventListener("resize", E), (c = !1), A());
                                        },
                                        C = function (e) {
                                            var t,
                                                n = e.getAttribute("data-rellax-percentage"),
                                                i = e.getAttribute("data-rellax-speed"),
                                                a = e.getAttribute("data-rellax-xs-speed"),
                                                l = e.getAttribute("data-rellax-mobile-speed"),
                                                c = e.getAttribute("data-rellax-tablet-speed"),
                                                u = e.getAttribute("data-rellax-desktop-speed"),
                                                d = e.getAttribute("data-rellax-vertical-speed"),
                                                p = e.getAttribute("data-rellax-horizontal-speed"),
                                                h = e.getAttribute("data-rellax-vertical-scroll-axis"),
                                                f = e.getAttribute("data-rellax-horizontal-scroll-axis"),
                                                m = e.getAttribute("data-rellax-zindex") || 0,
                                                g = e.getAttribute("data-rellax-min"),
                                                v = e.getAttribute("data-rellax-max"),
                                                y = e.getAttribute("data-rellax-min-x"),
                                                w = e.getAttribute("data-rellax-max-x"),
                                                x = e.getAttribute("data-rellax-min-y"),
                                                E = e.getAttribute("data-rellax-max-y"),
                                                C = !0;
                                            a || l || c || u ? (t = { xs: a, sm: l, md: c, lg: u }) : (C = !1);
                                            var S = r.options.wrapper ? r.options.wrapper.scrollTop : window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                                            r.options.relativeToWrapper && (S = (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) - r.options.wrapper.offsetTop);
                                            var k = r.options.vertical && (n || r.options.center) ? S : 0,
                                                A =
                                                    r.options.horizontal && (n || r.options.center)
                                                        ? r.options.wrapper
                                                            ? r.options.wrapper.scrollLeft
                                                            : window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft
                                                        : 0,
                                                _ = k + e.getBoundingClientRect().top,
                                                L = e.clientHeight || e.offsetHeight || e.scrollHeight,
                                                $ = A + e.getBoundingClientRect().left,
                                                D = e.clientWidth || e.offsetWidth || e.scrollWidth,
                                                O = n || (k - _ + o) / (L + o),
                                                q = n || (A - $ + s) / (D + s);
                                            r.options.center && ((q = 0.5), (O = 0.5));
                                            var M = C && null !== t[b] ? Number(t[b]) : i || r.options.speed,
                                                P = d || r.options.verticalSpeed,
                                                I = p || r.options.horizontalSpeed,
                                                N = h || r.options.verticalScrollAxis,
                                                z = f || r.options.horizontalScrollAxis,
                                                R = T(q, O, M, P, I),
                                                F = e.style.cssText,
                                                B = "",
                                                j = /transform\s*:/i.exec(F);
                                            if (j) {
                                                var H = j.index,
                                                    V = F.slice(H),
                                                    W = V.indexOf(";");
                                                B = W ? " " + V.slice(11, W).replace(/\s/g, "") : " " + V.slice(11).replace(/\s/g, "");
                                            }
                                            return {
                                                baseX: R.x,
                                                baseY: R.y,
                                                top: _,
                                                left: $,
                                                height: L,
                                                width: D,
                                                speed: M,
                                                verticalSpeed: P,
                                                horizontalSpeed: I,
                                                verticalScrollAxis: N,
                                                horizontalScrollAxis: z,
                                                style: F,
                                                transform: B,
                                                zindex: m,
                                                min: g,
                                                max: v,
                                                minX: y,
                                                maxX: w,
                                                minY: x,
                                                maxY: E,
                                            };
                                        },
                                        S = function () {
                                            var e = i,
                                                t = a;
                                            if (
                                                ((i = r.options.wrapper ? r.options.wrapper.scrollTop : (document.documentElement || document.body.parentNode || document.body).scrollTop || window.pageYOffset),
                                                (a = r.options.wrapper ? r.options.wrapper.scrollLeft : (document.documentElement || document.body.parentNode || document.body).scrollLeft || window.pageXOffset),
                                                r.options.relativeToWrapper)
                                            ) {
                                                var n = (document.documentElement || document.body.parentNode || document.body).scrollTop || window.pageYOffset;
                                                i = n - r.options.wrapper.offsetTop;
                                            }
                                            return !(e == i || !r.options.vertical) || !(t == a || !r.options.horizontal);
                                        },
                                        T = function (e, t, n, i, o) {
                                            var a = {},
                                                s = (o || n) * (100 * (1 - e)),
                                                l = (i || n) * (100 * (1 - t));
                                            return (a.x = r.options.round ? Math.round(s) : Math.round(100 * s) / 100), (a.y = r.options.round ? Math.round(l) : Math.round(100 * l) / 100), a;
                                        },
                                        k = function () {
                                            window.removeEventListener("resize", k),
                                                window.removeEventListener("orientationchange", k),
                                                (r.options.wrapper ? r.options.wrapper : window).removeEventListener("scroll", k),
                                                (r.options.wrapper ? r.options.wrapper : document).removeEventListener("touchmove", k),
                                                (d = u(A));
                                        },
                                        A = function () {
                                            S() && !1 === c
                                                ? (_(), (d = u(A)))
                                                : ((d = null),
                                                  window.addEventListener("resize", k),
                                                  window.addEventListener("orientationchange", k),
                                                  (r.options.wrapper ? r.options.wrapper : window).addEventListener("scroll", k, !!p && { passive: !0 }),
                                                  (r.options.wrapper ? r.options.wrapper : document).addEventListener("touchmove", k, !!p && { passive: !0 }));
                                        },
                                        _ = function () {
                                            for (var e, t = 0; t < r.elems.length; t++) {
                                                var n = l[t].verticalScrollAxis.toLowerCase(),
                                                    c = l[t].horizontalScrollAxis.toLowerCase(),
                                                    u = -1 != n.indexOf("x") ? i : 0,
                                                    d = -1 != n.indexOf("y") ? i : 0,
                                                    p = -1 != c.indexOf("x") ? a : 0,
                                                    h = (d + (-1 != c.indexOf("y") ? a : 0) - l[t].top + o) / (l[t].height + o),
                                                    f = (u + p - l[t].left + s) / (l[t].width + s),
                                                    g = (e = T(f, h, l[t].speed, l[t].verticalSpeed, l[t].horizontalSpeed)).y - l[t].baseY,
                                                    v = e.x - l[t].baseX;
                                                null !== l[t].min && (r.options.vertical && !r.options.horizontal && (g = g <= l[t].min ? l[t].min : g), r.options.horizontal && !r.options.vertical && (v = v <= l[t].min ? l[t].min : v)),
                                                    null != l[t].minY && (g = g <= l[t].minY ? l[t].minY : g),
                                                    null != l[t].minX && (v = v <= l[t].minX ? l[t].minX : v),
                                                    null !== l[t].max && (r.options.vertical && !r.options.horizontal && (g = g >= l[t].max ? l[t].max : g), r.options.horizontal && !r.options.vertical && (v = v >= l[t].max ? l[t].max : v)),
                                                    null != l[t].maxY && (g = g >= l[t].maxY ? l[t].maxY : g),
                                                    null != l[t].maxX && (v = v >= l[t].maxX ? l[t].maxX : v);
                                                var y = l[t].zindex,
                                                    b = "translate3d(" + (r.options.horizontal ? v : "0") + "px," + (r.options.vertical ? g : "0") + "px," + y + "px) " + l[t].transform;
                                                r.elems[t].style[m] = b;
                                            }
                                            r.options.callback(e);
                                        };
                                    return (
                                        (r.destroy = function () {
                                            for (var e = 0; e < r.elems.length; e++) r.elems[e].style.cssText = l[e].style;
                                            c || (window.removeEventListener("resize", E), (c = !0)), f(d), (d = null);
                                        }),
                                        E(),
                                        (r.refresh = E),
                                        r
                                    );
                                }
                                console.warn("Rellax: The elements you're trying to select don't exist.");
                            };
                            return e;
                        })
                            ? r.apply(t, i)
                            : r) || (e.exports = o);
        }.call(this, n(3)));
    },
    function (e, t, n) {
        var r, i, o;
        /*!
         * Masonry v4.2.2
         * Cascading grid layout library
         * https://masonry.desandro.com
         * MIT License
         * by David DeSandro
         */ window,
            (i = [n(16), n(7)]),
            void 0 ===
                (o =
                    "function" ==
                    typeof (r = function (e, t) {
                        "use strict";
                        var n = e.create("masonry");
                        n.compatOptions.fitWidth = "isFitWidth";
                        var r = n.prototype;
                        return (
                            (r._resetLayout = function () {
                                this.getSize(), this._getMeasurement("columnWidth", "outerWidth"), this._getMeasurement("gutter", "outerWidth"), this.measureColumns(), (this.colYs = []);
                                for (var e = 0; e < this.cols; e++) this.colYs.push(0);
                                (this.maxY = 0), (this.horizontalColIndex = 0);
                            }),
                            (r.measureColumns = function () {
                                if ((this.getContainerWidth(), !this.columnWidth)) {
                                    var e = this.items[0],
                                        n = e && e.element;
                                    this.columnWidth = (n && t(n).outerWidth) || this.containerWidth;
                                }
                                var r = (this.columnWidth += this.gutter),
                                    i = this.containerWidth + this.gutter,
                                    o = i / r,
                                    a = r - (i % r);
                                (o = Math[a && a < 1 ? "round" : "floor"](o)), (this.cols = Math.max(o, 1));
                            }),
                            (r.getContainerWidth = function () {
                                var e = this._getOption("fitWidth") ? this.element.parentNode : this.element,
                                    n = t(e);
                                this.containerWidth = n && n.innerWidth;
                            }),
                            (r._getItemLayoutPosition = function (e) {
                                e.getSize();
                                var t = e.size.outerWidth % this.columnWidth,
                                    n = Math[t && t < 1 ? "round" : "ceil"](e.size.outerWidth / this.columnWidth);
                                n = Math.min(n, this.cols);
                                for (
                                    var r = this[this.options.horizontalOrder ? "_getHorizontalColPosition" : "_getTopColPosition"](n, e), i = { x: this.columnWidth * r.col, y: r.y }, o = r.y + e.size.outerHeight, a = n + r.col, s = r.col;
                                    s < a;
                                    s++
                                )
                                    this.colYs[s] = o;
                                return i;
                            }),
                            (r._getTopColPosition = function (e) {
                                var t = this._getTopColGroup(e),
                                    n = Math.min.apply(Math, t);
                                return { col: t.indexOf(n), y: n };
                            }),
                            (r._getTopColGroup = function (e) {
                                if (e < 2) return this.colYs;
                                for (var t = [], n = this.cols + 1 - e, r = 0; r < n; r++) t[r] = this._getColGroupY(r, e);
                                return t;
                            }),
                            (r._getColGroupY = function (e, t) {
                                if (t < 2) return this.colYs[e];
                                var n = this.colYs.slice(e, e + t);
                                return Math.max.apply(Math, n);
                            }),
                            (r._getHorizontalColPosition = function (e, t) {
                                var n = this.horizontalColIndex % this.cols;
                                n = e > 1 && n + e > this.cols ? 0 : n;
                                var r = t.size.outerWidth && t.size.outerHeight;
                                return (this.horizontalColIndex = r ? n + e : this.horizontalColIndex), { col: n, y: this._getColGroupY(n, e) };
                            }),
                            (r._manageStamp = function (e) {
                                var n = t(e),
                                    r = this._getElementOffset(e),
                                    i = this._getOption("originLeft") ? r.left : r.right,
                                    o = i + n.outerWidth,
                                    a = Math.floor(i / this.columnWidth);
                                a = Math.max(0, a);
                                var s = Math.floor(o / this.columnWidth);
                                (s -= o % this.columnWidth ? 0 : 1), (s = Math.min(this.cols - 1, s));
                                for (var l = (this._getOption("originTop") ? r.top : r.bottom) + n.outerHeight, c = a; c <= s; c++) this.colYs[c] = Math.max(l, this.colYs[c]);
                            }),
                            (r._getContainerSize = function () {
                                this.maxY = Math.max.apply(Math, this.colYs);
                                var e = { height: this.maxY };
                                return this._getOption("fitWidth") && (e.width = this._getContainerFitWidth()), e;
                            }),
                            (r._getContainerFitWidth = function () {
                                for (var e = 0, t = this.cols; --t && 0 === this.colYs[t]; ) e++;
                                return (this.cols - e) * this.columnWidth - this.gutter;
                            }),
                            (r.needsResizeLayout = function () {
                                var e = this.containerWidth;
                                return this.getContainerWidth(), e != this.containerWidth;
                            }),
                            n
                        );
                    })
                        ? r.apply(t, i)
                        : r) || (e.exports = o);
    },
    function (e, t, n) {
        e.exports = n(25);
    },
    function (e, t, n) {
        var r, i, o;
        !(function (a, s) {
            (s = s.bind(null, a, a.document)), e.exports ? s(n(2)) : ((i = [n(2)]), void 0 === (o = "function" == typeof (r = s) ? r.apply(t, i) : r) || (e.exports = o));
        })(window, function (e, t, n) {
            "use strict";
            var r,
                i,
                o = n.cfg,
                a = { string: 1, number: 1 },
                s = /^\-*\+*\d+\.*\d*$/,
                l = /^picture$/i,
                c = /\s*\{\s*width\s*\}\s*/i,
                u = /\s*\{\s*height\s*\}\s*/i,
                d = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
                p = /^\[.*\]|\{.*\}$/,
                h = /^(?:auto|\d+(px)?)$/,
                f = t.createElement("a"),
                m = t.createElement("img"),
                g = "srcset" in m && !("sizes" in m),
                v = !!e.HTMLPictureElement && !g;
            function y(t, n, r) {
                var o,
                    a,
                    c,
                    u,
                    h,
                    f = e.getComputedStyle(t);
                if (r) {
                    for (u in ((h = {}), r)) h[u] = r[u];
                    r = h;
                } else (a = t.parentNode), (r = { isPicture: !(!a || !l.test(a.nodeName || "")) });
                for (o in ((c = function (e, n) {
                    var o = t.getAttribute("data-" + e);
                    if (!o) {
                        var a = f.getPropertyValue("--ls-" + e);
                        a && (o = a.trim());
                    }
                    if (o) {
                        if ("true" == o) o = !0;
                        else if ("false" == o) o = !1;
                        else if (s.test(o)) o = parseFloat(o);
                        else if ("function" == typeof i[e]) o = i[e](t, o);
                        else if (p.test(o))
                            try {
                                o = JSON.parse(o);
                            } catch (e) {}
                        r[e] = o;
                    } else e in i && "function" != typeof i[e] && !r[e] ? (r[e] = i[e]) : n && "function" == typeof i[e] && (r[e] = i[e](t, o));
                }),
                i))
                    c(o);
                return (
                    n.replace(d, function (e, t) {
                        t in r || c(t, !0);
                    }),
                    r
                );
            }
            function b(e, n, o) {
                var s = 0,
                    l = 0,
                    p = o;
                if (e) {
                    if ("container" === n.ratio) {
                        for (s = p.scrollWidth, l = p.scrollHeight; !((s && l) || p === t); ) (s = (p = p.parentNode).scrollWidth), (l = p.scrollHeight);
                        s && l && (n.ratio = n.traditionalRatio ? l / s : s / l);
                    }
                    var h, m, v;
                    (h = e),
                        (m = n),
                        ((v = []).srcset = []),
                        m.absUrl && (f.setAttribute("href", h), (h = f.href)),
                        (h = ((m.prefix || "") + h + (m.postfix || "")).replace(d, function (e, t) {
                            return a[typeof m[t]] ? m[t] : e;
                        })),
                        m.widths.forEach(function (e) {
                            var t = m.widthmap[e] || e,
                                n = m.aspectratio || m.ratio,
                                r = !m.aspectratio && i.traditionalRatio,
                                o = { u: h.replace(c, t).replace(u, n ? (r ? Math.round(e * n) : Math.round(e / n)) : ""), w: e };
                            v.push(o), v.srcset.push((o.c = o.u + " " + e + "w"));
                        }),
                        ((e = v).isPicture = n.isPicture),
                        g && "IMG" == o.nodeName.toUpperCase() ? o.removeAttribute(r.srcsetAttr) : o.setAttribute(r.srcsetAttr, e.srcset.join(", ")),
                        Object.defineProperty(o, "_lazyrias", { value: e, writable: !0 });
                }
            }
            function w(e) {
                return e.getAttribute(e.getAttribute("data-srcattr") || i.srcAttr) || e.getAttribute(r.srcsetAttr) || e.getAttribute(r.srcAttr) || e.getAttribute("data-pfsrcset") || "";
            }
            !(function () {
                var e,
                    t = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: function () {}, widthmap: {}, ratio: !1, traditionalRatio: !1, aspectratio: !1 };
                for (e in ((r = n && n.cfg).supportsType ||
                    (r.supportsType = function (e) {
                        return !e;
                    }),
                r.rias || (r.rias = {}),
                "widths" in (i = r.rias) ||
                    ((i.widths = []),
                    (function (e) {
                        for (var t, n = 0; !t || t < 3e3; ) (n += 5) > 30 && (n += 1), (t = 36 * n), e.push(t);
                    })(i.widths)),
                t))
                    e in i || (i[e] = t[e]);
            })(),
                addEventListener(
                    "lazybeforesizes",
                    function (e) {
                        var t, o, a, s, l, u, d, p, f, m, g, E, C;
                        if (e.detail.instance == n && ((t = e.target), e.detail.dataAttr && !e.defaultPrevented && !i.disabled && (f = t.getAttribute(r.sizesAttr) || t.getAttribute("sizes")) && h.test(f))) {
                            if (
                                ((a = (function (e, t) {
                                    var r = y(e, t);
                                    return i.modifyOptions.call(e, { target: e, details: r, detail: r }), n.fire(e, "lazyriasmodifyoptions", r), r;
                                })(t, (o = w(t)))),
                                (g = c.test(a.prefix) || c.test(a.postfix)),
                                a.isPicture && (s = t.parentNode))
                            )
                                for (u = 0, d = (l = s.getElementsByTagName("source")).length; u < d; u++) (g || c.test((p = w(l[u])))) && (b(p, y(l[u], p, a), l[u]), (E = !0));
                            g || c.test(o) ? (b(o, a, t), (E = !0)) : E && (((C = []).srcset = []), (C.isPicture = !0), Object.defineProperty(t, "_lazyrias", { value: C, writable: !0 })),
                                E && (v ? t.removeAttribute(r.srcAttr) : "auto" != f && ((m = { width: parseInt(f, 10) }), x({ target: t, detail: m })));
                        }
                    },
                    !0
                );
            var x = (function () {
                var i = function (e, t) {
                        return e.w - t.w;
                    },
                    a = function (e, t) {
                        var i;
                        return (
                            !e._lazyrias &&
                                n.pWS &&
                                (i = n.pWS(e.getAttribute(r.srcsetAttr || ""))).length &&
                                (Object.defineProperty(e, "_lazyrias", { value: i, writable: !0 }), t && e.parentNode && (i.isPicture = "PICTURE" == e.parentNode.nodeName.toUpperCase())),
                            e._lazyrias
                        );
                    },
                    s = function (t, r) {
                        var o, s, l, c, u, d;
                        if ((u = t._lazyrias).isPicture && e.matchMedia)
                            for (s = 0, l = (o = t.parentNode.getElementsByTagName("source")).length; s < l; s++)
                                if (a(o[s]) && !o[s].getAttribute("type") && (!(c = o[s].getAttribute("media")) || (matchMedia(c) || {}).matches)) {
                                    u = o[s]._lazyrias;
                                    break;
                                }
                        return (
                            (!u.w || u.w < r) &&
                                ((u.w = r),
                                (u.d = (function (t) {
                                    var r = e.devicePixelRatio || 1,
                                        i = n.getX && n.getX(t);
                                    return Math.min(i || r, 2.4, r);
                                })(t)),
                                (d = (function (e) {
                                    for (var t, n, r = e.length, i = e[r - 1], o = 0; o < r; o++)
                                        if ((((i = e[o]).d = i.w / e.w), i.d >= e.d)) {
                                            !i.cached && (t = e[o - 1]) && t.d > e.d - 0.13 * Math.pow(e.d, 2.2) && ((n = Math.pow(t.d - 0.6, 1.6)), t.cached && (t.d += 0.15 * n), t.d + (i.d - e.d) * n > e.d && (i = t));
                                            break;
                                        }
                                    return i;
                                })(u.sort(i)))),
                            d
                        );
                    },
                    l = function (i) {
                        if (i.detail.instance == n) {
                            var c,
                                u = i.target;
                            g || !(e.respimage || e.picturefill || o.pf)
                                ? ("_lazyrias" in u || (i.detail.dataAttr && a(u, !0))) &&
                                  (c = s(u, i.detail.width)) &&
                                  c.u &&
                                  u._lazyrias.cur != c.u &&
                                  ((u._lazyrias.cur = c.u),
                                  (c.cached = !0),
                                  n.rAF(function () {
                                      u.setAttribute(r.srcAttr, c.u), u.setAttribute("src", c.u);
                                  }))
                                : t.removeEventListener("lazybeforesizes", l);
                        }
                    };
                return v ? (l = function () {}) : addEventListener("lazybeforesizes", l), l;
            })();
        });
    },
    function (e, t, n) {
        var r, i, o;
        !(function (a, s) {
            if (a) {
                (s = s.bind(null, a, a.document)), e.exports ? s(n(2)) : ((i = [n(2)]), void 0 === (o = "function" == typeof (r = s) ? r.apply(t, i) : r) || (e.exports = o));
            }
        })("undefined" != typeof window ? window : 0, function (e, t, n, r) {
            "use strict";
            var i,
                o = t.createElement("a").style,
                a = "objectFit" in o,
                s = /object-fit["']*\s*:\s*["']*(contain|cover)/,
                l = /object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/,
                c = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
                u = /\(|\)|'/,
                d = { center: "center", "50% 50%": "center" };
            function p(e, r) {
                var o,
                    a,
                    s,
                    l,
                    d = n.cfg,
                    p = function () {
                        var t = e.currentSrc || e.src;
                        t && a !== t && ((a = t), (l.backgroundImage = "url(" + (u.test(t) ? JSON.stringify(t) : t) + ")"), o || ((o = !0), n.rC(s, d.loadingClass), n.aC(s, d.loadedClass)));
                    },
                    h = function () {
                        n.rAF(p);
                    };
                (e._lazysizesParentFit = r.fit),
                    e.addEventListener("lazyloaded", h, !0),
                    e.addEventListener("load", h, !0),
                    n.rAF(function () {
                        var o = e,
                            a = e.parentNode;
                        "PICTURE" == a.nodeName.toUpperCase() && ((o = a), (a = a.parentNode)),
                            (function (e) {
                                var t = e.previousElementSibling;
                                t && n.hC(t, i) && (t.parentNode.removeChild(t), (e.style.position = t.getAttribute("data-position") || ""), (e.style.visibility = t.getAttribute("data-visibility") || ""));
                            })(o),
                            i ||
                                (function () {
                                    if (!i) {
                                        var e = t.createElement("style");
                                        (i = n.cfg.objectFitClass || "lazysizes-display-clone"), t.querySelector("head").appendChild(e);
                                    }
                                })(),
                            (s = e.cloneNode(!1)),
                            (l = s.style),
                            s.addEventListener("load", function () {
                                var e = s.currentSrc || s.src;
                                e && e != c && ((s.src = c), (s.srcset = ""));
                            }),
                            n.rC(s, d.loadedClass),
                            n.rC(s, d.lazyClass),
                            n.rC(s, d.autosizesClass),
                            n.aC(s, d.loadingClass),
                            n.aC(s, i),
                            ["data-parent-fit", "data-parent-container", "data-object-fit-polyfilled", d.srcsetAttr, d.srcAttr].forEach(function (e) {
                                s.removeAttribute(e);
                            }),
                            (s.src = c),
                            (s.srcset = ""),
                            (l.backgroundRepeat = "no-repeat"),
                            (l.backgroundPosition = r.position),
                            (l.backgroundSize = r.fit),
                            s.setAttribute("data-position", o.style.position),
                            s.setAttribute("data-visibility", o.style.visibility),
                            (o.style.visibility = "hidden"),
                            (o.style.position = "absolute"),
                            e.setAttribute("data-parent-fit", r.fit),
                            e.setAttribute("data-parent-container", "prev"),
                            e.setAttribute("data-object-fit-polyfilled", ""),
                            (e._objectFitPolyfilledDisplay = s),
                            a.insertBefore(s, o),
                            e._lazysizesParentFit && delete e._lazysizesParentFit,
                            e.complete && p();
                    });
            }
            if (!a || !(a && "objectPosition" in o)) {
                var h = function (e) {
                    if (e.detail.instance == n) {
                        var t = e.target,
                            r = (function (e) {
                                var t = (getComputedStyle(e, null) || {}).fontFamily || "",
                                    n = t.match(s) || "",
                                    r = (n && t.match(l)) || "";
                                return r && (r = r[1]), { fit: (n && n[1]) || "", position: d[r] || r || "center" };
                            })(t);
                        return !(!r.fit || (a && "center" == r.position)) && (p(t, r), !0);
                    }
                };
                e.addEventListener("lazybeforesizes", function (e) {
                    if (e.detail.instance == n) {
                        var t = e.target;
                        null == t.getAttribute("data-object-fit-polyfilled") ||
                            t._objectFitPolyfilledDisplay ||
                            h(e) ||
                            n.rAF(function () {
                                t.removeAttribute("data-object-fit-polyfilled");
                            });
                    }
                }),
                    e.addEventListener("lazyunveilread", h, !0),
                    r && r.detail && h(r);
            }
        });
    },
    function (e, t, n) {
        var r, i, o;
        !(function (a, s) {
            if (a) {
                (s = s.bind(null, a, a.document)), e.exports ? s(n(2)) : ((i = [n(2)]), void 0 === (o = "function" == typeof (r = s) ? r.apply(t, i) : r) || (e.exports = o));
            }
        })("undefined" != typeof window ? window : 0, function (e, t, n) {
            "use strict";
            var r;
            !(function () {
                var e,
                    t = { blurUpClass: "ls-blur-up-img", blurUpLoadingClass: "ls-blur-up-is-loading", blurUpInviewClass: "ls-inview", blurUpLoadedClass: "ls-blur-up-loaded", blurUpLoadedOriginalClass: "ls-original-loaded" };
                for (e in ((r = n.cfg || {}), t)) e in r || (r[e] = t[e]);
            })();
            var i = [].slice,
                o = /blur-up["']*\s*:\s*["']*(always|auto)/,
                a = /image\/(jpeg|png|gif|svg\+xml)/,
                s = function (t, r) {
                    var o;
                    return (
                        (t ? i.call(t.querySelectorAll("source, img")) : [r]).forEach(function (t) {
                            if (!o) {
                                var r,
                                    i,
                                    s,
                                    l = t.getAttribute("data-lowsrc");
                                !l || ((i = (r = t).getAttribute("data-media") || r.getAttribute("media")), ((s = r.getAttribute("type")) && !a.test(s)) || (i && !e.matchMedia(n.cfg.customMedia[i] || i).matches)) || (o = l);
                            }
                        }),
                        o
                    );
                };
            e.addEventListener("lazybeforeunveil", function (e) {
                var r = e.detail;
                if (r.instance == n && r.blurUp) {
                    var i = e.target,
                        o = i.parentNode;
                    "PICTURE" != o.nodeName && (o = null),
                        (function (e, r, i, o) {
                            var a,
                                s = !1,
                                l = !1,
                                c = "always" == o ? 0 : Date.now(),
                                u = 0,
                                d = (e || r).parentNode,
                                p = function () {
                                    a &&
                                        n.rAF(function () {
                                            n.rC(r, n.cfg.blurUpLoadingClass);
                                            try {
                                                a.parentNode.removeChild(a);
                                            } catch (e) {}
                                            a = null;
                                        });
                                },
                                h = function (e) {
                                    u++, (l = e || l), e ? p() : u > 1 && setTimeout(p, 5e3);
                                },
                                f = function () {
                                    r.removeEventListener("load", f),
                                        r.removeEventListener("error", f),
                                        a &&
                                            n.rAF(function () {
                                                a && n.aC(a, n.cfg.blurUpLoadedOriginalClass);
                                            }),
                                        n.fire(r, "blurUpLoaded"),
                                        "always" != o && (!s || Date.now() - c < 66) ? h(!0) : h();
                                };
                            !(function () {
                                if (i) {
                                    var c = function (e) {
                                        (s = !0),
                                            a || (a = e.target),
                                            n.rAF(function () {
                                                n.rC(r, n.cfg.blurUpLoadingClass), a && n.aC(a, n.cfg.blurUpLoadedClass);
                                            }),
                                            a && (a.removeEventListener("load", c), a.removeEventListener("error", c));
                                    };
                                    (a = t.createElement("img")).addEventListener("load", c),
                                        a.addEventListener("error", c),
                                        (a.className = n.cfg.blurUpClass),
                                        (a.cssText = r.cssText),
                                        (a.src = i),
                                        (a.alt = ""),
                                        a.setAttribute("aria-hidden", "true"),
                                        d.insertBefore(a, (e || r).nextSibling),
                                        "always" != o &&
                                            ((a.style.visibility = "hidden"),
                                            n.rAF(function () {
                                                a &&
                                                    setTimeout(function () {
                                                        a &&
                                                            n.rAF(function () {
                                                                !l && a && (a.style.visibility = "");
                                                            });
                                                    }, n.cfg.blurupCacheDelay || 33);
                                            }));
                                }
                            })(),
                                r.addEventListener("load", f),
                                r.addEventListener("error", f),
                                n.aC(r, n.cfg.blurUpLoadingClass);
                            var m = function (e) {
                                d == e.target && (n.aC(a || r, n.cfg.blurUpInviewClass), h(), d.removeEventListener("lazybeforeunveil", m));
                            };
                            d.getAttribute("data-expand") || d.setAttribute("data-expand", -1), d.addEventListener("lazybeforeunveil", m), n.aC(d, n.cfg.lazyClass);
                        })(o, i, s(o, i) || "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", r.blurUp);
                }
            }),
                e.addEventListener("lazyunveilread", function (e) {
                    var t = e.detail;
                    if (t.instance == n) {
                        var r = e.target,
                            i = (getComputedStyle(r, null) || { fontFamily: "" }).fontFamily.match(o);
                        (i || r.getAttribute("data-lowsrc")) && (t.blurUp = (i && i[1]) || n.cfg.blurupMode || "always");
                    }
                });
        });
    },
    function (e, t, n) {
        var r, i;
        /*!
         * Outlayer v2.1.1
         * the brains and guts of a layout library
         * MIT license
         */ !(function (o, a) {
            "use strict";
            (r = [n(6), n(7), n(17), n(19)]),
                (i = function (e, t, n, r) {
                    return (function (e, t, n, r, i) {
                        var o = e.console,
                            a = e.jQuery,
                            s = function () {},
                            l = 0,
                            c = {};
                        function u(e, t) {
                            var n = r.getQueryElement(e);
                            if (n) {
                                (this.element = n), a && (this.$element = a(this.element)), (this.options = r.extend({}, this.constructor.defaults)), this.option(t);
                                var i = ++l;
                                (this.element.outlayerGUID = i), (c[i] = this), this._create(), this._getOption("initLayout") && this.layout();
                            } else o && o.error("Bad element for " + this.constructor.namespace + ": " + (n || e));
                        }
                        (u.namespace = "outlayer"),
                            (u.Item = i),
                            (u.defaults = {
                                containerStyle: { position: "relative" },
                                initLayout: !0,
                                originLeft: !0,
                                originTop: !0,
                                resize: !0,
                                resizeContainer: !0,
                                transitionDuration: "0.4s",
                                hiddenStyle: { opacity: 0, transform: "scale(0.001)" },
                                visibleStyle: { opacity: 1, transform: "scale(1)" },
                            });
                        var d = u.prototype;
                        function p(e) {
                            function t() {
                                e.apply(this, arguments);
                            }
                            return (t.prototype = Object.create(e.prototype)), (t.prototype.constructor = t), t;
                        }
                        r.extend(d, t.prototype),
                            (d.option = function (e) {
                                r.extend(this.options, e);
                            }),
                            (d._getOption = function (e) {
                                var t = this.constructor.compatOptions[e];
                                return t && void 0 !== this.options[t] ? this.options[t] : this.options[e];
                            }),
                            (u.compatOptions = {
                                initLayout: "isInitLayout",
                                horizontal: "isHorizontal",
                                layoutInstant: "isLayoutInstant",
                                originLeft: "isOriginLeft",
                                originTop: "isOriginTop",
                                resize: "isResizeBound",
                                resizeContainer: "isResizingContainer",
                            }),
                            (d._create = function () {
                                this.reloadItems(), (this.stamps = []), this.stamp(this.options.stamp), r.extend(this.element.style, this.options.containerStyle), this._getOption("resize") && this.bindResize();
                            }),
                            (d.reloadItems = function () {
                                this.items = this._itemize(this.element.children);
                            }),
                            (d._itemize = function (e) {
                                for (var t = this._filterFindItemElements(e), n = this.constructor.Item, r = [], i = 0; i < t.length; i++) {
                                    var o = new n(t[i], this);
                                    r.push(o);
                                }
                                return r;
                            }),
                            (d._filterFindItemElements = function (e) {
                                return r.filterFindElements(e, this.options.itemSelector);
                            }),
                            (d.getItemElements = function () {
                                return this.items.map(function (e) {
                                    return e.element;
                                });
                            }),
                            (d.layout = function () {
                                this._resetLayout(), this._manageStamps();
                                var e = this._getOption("layoutInstant"),
                                    t = void 0 !== e ? e : !this._isLayoutInited;
                                this.layoutItems(this.items, t), (this._isLayoutInited = !0);
                            }),
                            (d._init = d.layout),
                            (d._resetLayout = function () {
                                this.getSize();
                            }),
                            (d.getSize = function () {
                                this.size = n(this.element);
                            }),
                            (d._getMeasurement = function (e, t) {
                                var r,
                                    i = this.options[e];
                                i ? ("string" == typeof i ? (r = this.element.querySelector(i)) : i instanceof HTMLElement && (r = i), (this[e] = r ? n(r)[t] : i)) : (this[e] = 0);
                            }),
                            (d.layoutItems = function (e, t) {
                                (e = this._getItemsForLayout(e)), this._layoutItems(e, t), this._postLayout();
                            }),
                            (d._getItemsForLayout = function (e) {
                                return e.filter(function (e) {
                                    return !e.isIgnored;
                                });
                            }),
                            (d._layoutItems = function (e, t) {
                                if ((this._emitCompleteOnItems("layout", e), e && e.length)) {
                                    var n = [];
                                    e.forEach(function (e) {
                                        var r = this._getItemLayoutPosition(e);
                                        (r.item = e), (r.isInstant = t || e.isLayoutInstant), n.push(r);
                                    }, this),
                                        this._processLayoutQueue(n);
                                }
                            }),
                            (d._getItemLayoutPosition = function () {
                                return { x: 0, y: 0 };
                            }),
                            (d._processLayoutQueue = function (e) {
                                this.updateStagger(),
                                    e.forEach(function (e, t) {
                                        this._positionItem(e.item, e.x, e.y, e.isInstant, t);
                                    }, this);
                            }),
                            (d.updateStagger = function () {
                                var e = this.options.stagger;
                                if (null != e) return (this.stagger = f(e)), this.stagger;
                                this.stagger = 0;
                            }),
                            (d._positionItem = function (e, t, n, r, i) {
                                r ? e.goTo(t, n) : (e.stagger(i * this.stagger), e.moveTo(t, n));
                            }),
                            (d._postLayout = function () {
                                this.resizeContainer();
                            }),
                            (d.resizeContainer = function () {
                                if (this._getOption("resizeContainer")) {
                                    var e = this._getContainerSize();
                                    e && (this._setContainerMeasure(e.width, !0), this._setContainerMeasure(e.height, !1));
                                }
                            }),
                            (d._getContainerSize = s),
                            (d._setContainerMeasure = function (e, t) {
                                if (void 0 !== e) {
                                    var n = this.size;
                                    n.isBorderBox && (e += t ? n.paddingLeft + n.paddingRight + n.borderLeftWidth + n.borderRightWidth : n.paddingBottom + n.paddingTop + n.borderTopWidth + n.borderBottomWidth),
                                        (e = Math.max(e, 0)),
                                        (this.element.style[t ? "width" : "height"] = e + "px");
                                }
                            }),
                            (d._emitCompleteOnItems = function (e, t) {
                                var n = this;
                                function r() {
                                    n.dispatchEvent(e + "Complete", null, [t]);
                                }
                                var i = t.length;
                                if (t && i) {
                                    var o = 0;
                                    t.forEach(function (t) {
                                        t.once(e, a);
                                    });
                                } else r();
                                function a() {
                                    ++o == i && r();
                                }
                            }),
                            (d.dispatchEvent = function (e, t, n) {
                                var r = t ? [t].concat(n) : n;
                                if ((this.emitEvent(e, r), a))
                                    if (((this.$element = this.$element || a(this.element)), t)) {
                                        var i = a.Event(t);
                                        (i.type = e), this.$element.trigger(i, n);
                                    } else this.$element.trigger(e, n);
                            }),
                            (d.ignore = function (e) {
                                var t = this.getItem(e);
                                t && (t.isIgnored = !0);
                            }),
                            (d.unignore = function (e) {
                                var t = this.getItem(e);
                                t && delete t.isIgnored;
                            }),
                            (d.stamp = function (e) {
                                (e = this._find(e)) && ((this.stamps = this.stamps.concat(e)), e.forEach(this.ignore, this));
                            }),
                            (d.unstamp = function (e) {
                                (e = this._find(e)) &&
                                    e.forEach(function (e) {
                                        r.removeFrom(this.stamps, e), this.unignore(e);
                                    }, this);
                            }),
                            (d._find = function (e) {
                                if (e) return "string" == typeof e && (e = this.element.querySelectorAll(e)), (e = r.makeArray(e));
                            }),
                            (d._manageStamps = function () {
                                this.stamps && this.stamps.length && (this._getBoundingRect(), this.stamps.forEach(this._manageStamp, this));
                            }),
                            (d._getBoundingRect = function () {
                                var e = this.element.getBoundingClientRect(),
                                    t = this.size;
                                this._boundingRect = {
                                    left: e.left + t.paddingLeft + t.borderLeftWidth,
                                    top: e.top + t.paddingTop + t.borderTopWidth,
                                    right: e.right - (t.paddingRight + t.borderRightWidth),
                                    bottom: e.bottom - (t.paddingBottom + t.borderBottomWidth),
                                };
                            }),
                            (d._manageStamp = s),
                            (d._getElementOffset = function (e) {
                                var t = e.getBoundingClientRect(),
                                    r = this._boundingRect,
                                    i = n(e);
                                return { left: t.left - r.left - i.marginLeft, top: t.top - r.top - i.marginTop, right: r.right - t.right - i.marginRight, bottom: r.bottom - t.bottom - i.marginBottom };
                            }),
                            (d.handleEvent = r.handleEvent),
                            (d.bindResize = function () {
                                e.addEventListener("resize", this), (this.isResizeBound = !0);
                            }),
                            (d.unbindResize = function () {
                                e.removeEventListener("resize", this), (this.isResizeBound = !1);
                            }),
                            (d.onresize = function () {
                                this.resize();
                            }),
                            r.debounceMethod(u, "onresize", 100),
                            (d.resize = function () {
                                this.isResizeBound && this.needsResizeLayout() && this.layout();
                            }),
                            (d.needsResizeLayout = function () {
                                var e = n(this.element);
                                return this.size && e && e.innerWidth !== this.size.innerWidth;
                            }),
                            (d.addItems = function (e) {
                                var t = this._itemize(e);
                                return t.length && (this.items = this.items.concat(t)), t;
                            }),
                            (d.appended = function (e) {
                                var t = this.addItems(e);
                                t.length && (this.layoutItems(t, !0), this.reveal(t));
                            }),
                            (d.prepended = function (e) {
                                var t = this._itemize(e);
                                if (t.length) {
                                    var n = this.items.slice(0);
                                    (this.items = t.concat(n)), this._resetLayout(), this._manageStamps(), this.layoutItems(t, !0), this.reveal(t), this.layoutItems(n);
                                }
                            }),
                            (d.reveal = function (e) {
                                if ((this._emitCompleteOnItems("reveal", e), e && e.length)) {
                                    var t = this.updateStagger();
                                    e.forEach(function (e, n) {
                                        e.stagger(n * t), e.reveal();
                                    });
                                }
                            }),
                            (d.hide = function (e) {
                                if ((this._emitCompleteOnItems("hide", e), e && e.length)) {
                                    var t = this.updateStagger();
                                    e.forEach(function (e, n) {
                                        e.stagger(n * t), e.hide();
                                    });
                                }
                            }),
                            (d.revealItemElements = function (e) {
                                var t = this.getItems(e);
                                this.reveal(t);
                            }),
                            (d.hideItemElements = function (e) {
                                var t = this.getItems(e);
                                this.hide(t);
                            }),
                            (d.getItem = function (e) {
                                for (var t = 0; t < this.items.length; t++) {
                                    var n = this.items[t];
                                    if (n.element == e) return n;
                                }
                            }),
                            (d.getItems = function (e) {
                                e = r.makeArray(e);
                                var t = [];
                                return (
                                    e.forEach(function (e) {
                                        var n = this.getItem(e);
                                        n && t.push(n);
                                    }, this),
                                    t
                                );
                            }),
                            (d.remove = function (e) {
                                var t = this.getItems(e);
                                this._emitCompleteOnItems("remove", t),
                                    t &&
                                        t.length &&
                                        t.forEach(function (e) {
                                            e.remove(), r.removeFrom(this.items, e);
                                        }, this);
                            }),
                            (d.destroy = function () {
                                var e = this.element.style;
                                (e.height = ""),
                                    (e.position = ""),
                                    (e.width = ""),
                                    this.items.forEach(function (e) {
                                        e.destroy();
                                    }),
                                    this.unbindResize();
                                var t = this.element.outlayerGUID;
                                delete c[t], delete this.element.outlayerGUID, a && a.removeData(this.element, this.constructor.namespace);
                            }),
                            (u.data = function (e) {
                                var t = (e = r.getQueryElement(e)) && e.outlayerGUID;
                                return t && c[t];
                            }),
                            (u.create = function (e, t) {
                                var n = p(u);
                                return (
                                    (n.defaults = r.extend({}, u.defaults)),
                                    r.extend(n.defaults, t),
                                    (n.compatOptions = r.extend({}, u.compatOptions)),
                                    (n.namespace = e),
                                    (n.data = u.data),
                                    (n.Item = p(i)),
                                    r.htmlInit(n, e),
                                    a && a.bridget && a.bridget(e, n),
                                    n
                                );
                            });
                        var h = { ms: 1, s: 1e3 };
                        function f(e) {
                            if ("number" == typeof e) return e;
                            var t = e.match(/(^\d*\.?\d*)(\w*)/),
                                n = t && t[1],
                                r = t && t[2];
                            return n.length ? (n = parseFloat(n)) * (h[r] || 1) : 0;
                        }
                        return (u.Item = i), u;
                    })(o, e, t, n, r);
                }.apply(t, r)),
                void 0 === i || (e.exports = i);
        })(window);
    },
    function (e, t, n) {
        var r, i;
        !(function (o, a) {
            (r = [n(18)]),
                (i = function (e) {
                    return (function (e, t) {
                        "use strict";
                        var n = {
                                extend: function (e, t) {
                                    for (var n in t) e[n] = t[n];
                                    return e;
                                },
                                modulo: function (e, t) {
                                    return ((e % t) + t) % t;
                                },
                            },
                            r = Array.prototype.slice;
                        (n.makeArray = function (e) {
                            return Array.isArray(e) ? e : null == e ? [] : "object" == typeof e && "number" == typeof e.length ? r.call(e) : [e];
                        }),
                            (n.removeFrom = function (e, t) {
                                var n = e.indexOf(t);
                                -1 != n && e.splice(n, 1);
                            }),
                            (n.getParent = function (e, n) {
                                for (; e.parentNode && e != document.body; ) if (((e = e.parentNode), t(e, n))) return e;
                            }),
                            (n.getQueryElement = function (e) {
                                return "string" == typeof e ? document.querySelector(e) : e;
                            }),
                            (n.handleEvent = function (e) {
                                var t = "on" + e.type;
                                this[t] && this[t](e);
                            }),
                            (n.filterFindElements = function (e, r) {
                                e = n.makeArray(e);
                                var i = [];
                                return (
                                    e.forEach(function (e) {
                                        if (e instanceof HTMLElement)
                                            if (r) {
                                                t(e, r) && i.push(e);
                                                for (var n = e.querySelectorAll(r), o = 0; o < n.length; o++) i.push(n[o]);
                                            } else i.push(e);
                                    }),
                                    i
                                );
                            }),
                            (n.debounceMethod = function (e, t, n) {
                                n = n || 100;
                                var r = e.prototype[t],
                                    i = t + "Timeout";
                                e.prototype[t] = function () {
                                    var e = this[i];
                                    clearTimeout(e);
                                    var t = arguments,
                                        o = this;
                                    this[i] = setTimeout(function () {
                                        r.apply(o, t), delete o[i];
                                    }, n);
                                };
                            }),
                            (n.docReady = function (e) {
                                var t = document.readyState;
                                "complete" == t || "interactive" == t ? setTimeout(e) : document.addEventListener("DOMContentLoaded", e);
                            }),
                            (n.toDashed = function (e) {
                                return e
                                    .replace(/(.)([A-Z])/g, function (e, t, n) {
                                        return t + "-" + n;
                                    })
                                    .toLowerCase();
                            });
                        var i = e.console;
                        return (
                            (n.htmlInit = function (t, r) {
                                n.docReady(function () {
                                    var o = n.toDashed(r),
                                        a = "data-" + o,
                                        s = document.querySelectorAll("[" + a + "]"),
                                        l = document.querySelectorAll(".js-" + o),
                                        c = n.makeArray(s).concat(n.makeArray(l)),
                                        u = a + "-options",
                                        d = e.jQuery;
                                    c.forEach(function (e) {
                                        var n,
                                            o = e.getAttribute(a) || e.getAttribute(u);
                                        try {
                                            n = o && JSON.parse(o);
                                        } catch (t) {
                                            return void (i && i.error("Error parsing " + a + " on " + e.className + ": " + t));
                                        }
                                        var s = new t(e, n);
                                        d && d.data(e, r, s);
                                    });
                                });
                            }),
                            n
                        );
                    })(o, e);
                }.apply(t, r)),
                void 0 === i || (e.exports = i);
        })(window);
    },
    function (e, t, n) {
        var r, i;
        !(function (o, a) {
            "use strict";
            void 0 === (i = "function" == typeof (r = a) ? r.call(t, n, t, e) : r) || (e.exports = i);
        })(window, function () {
            "use strict";
            var e = (function () {
                var e = window.Element.prototype;
                if (e.matches) return "matches";
                if (e.matchesSelector) return "matchesSelector";
                for (var t = ["webkit", "moz", "ms", "o"], n = 0; n < t.length; n++) {
                    var r = t[n] + "MatchesSelector";
                    if (e[r]) return r;
                }
            })();
            return function (t, n) {
                return t[e](n);
            };
        });
    },
    function (e, t, n) {
        var r, i, o;
        window,
            (i = [n(6), n(7)]),
            void 0 ===
                (o =
                    "function" ==
                    typeof (r = function (e, t) {
                        "use strict";
                        function n(e) {
                            for (var t in e) return !1;
                            return !0;
                        }
                        var r = document.documentElement.style,
                            i = "string" == typeof r.transition ? "transition" : "WebkitTransition",
                            o = "string" == typeof r.transform ? "transform" : "WebkitTransform",
                            a = { WebkitTransition: "webkitTransitionEnd", transition: "transitionend" }[i],
                            s = { transform: o, transition: i, transitionDuration: i + "Duration", transitionProperty: i + "Property", transitionDelay: i + "Delay" };
                        function l(e, t) {
                            e && ((this.element = e), (this.layout = t), (this.position = { x: 0, y: 0 }), this._create());
                        }
                        var c = (l.prototype = Object.create(e.prototype));
                        function u(e) {
                            return e.replace(/([A-Z])/g, function (e) {
                                return "-" + e.toLowerCase();
                            });
                        }
                        (c.constructor = l),
                            (c._create = function () {
                                (this._transn = { ingProperties: {}, clean: {}, onEnd: {} }), this.css({ position: "absolute" });
                            }),
                            (c.handleEvent = function (e) {
                                var t = "on" + e.type;
                                this[t] && this[t](e);
                            }),
                            (c.getSize = function () {
                                this.size = t(this.element);
                            }),
                            (c.css = function (e) {
                                var t = this.element.style;
                                for (var n in e) t[s[n] || n] = e[n];
                            }),
                            (c.getPosition = function () {
                                var e = getComputedStyle(this.element),
                                    t = this.layout._getOption("originLeft"),
                                    n = this.layout._getOption("originTop"),
                                    r = e[t ? "left" : "right"],
                                    i = e[n ? "top" : "bottom"],
                                    o = parseFloat(r),
                                    a = parseFloat(i),
                                    s = this.layout.size;
                                -1 != r.indexOf("%") && (o = (o / 100) * s.width),
                                    -1 != i.indexOf("%") && (a = (a / 100) * s.height),
                                    (o = isNaN(o) ? 0 : o),
                                    (a = isNaN(a) ? 0 : a),
                                    (o -= t ? s.paddingLeft : s.paddingRight),
                                    (a -= n ? s.paddingTop : s.paddingBottom),
                                    (this.position.x = o),
                                    (this.position.y = a);
                            }),
                            (c.layoutPosition = function () {
                                var e = this.layout.size,
                                    t = {},
                                    n = this.layout._getOption("originLeft"),
                                    r = this.layout._getOption("originTop"),
                                    i = n ? "paddingLeft" : "paddingRight",
                                    o = n ? "left" : "right",
                                    a = n ? "right" : "left",
                                    s = this.position.x + e[i];
                                (t[o] = this.getXValue(s)), (t[a] = "");
                                var l = r ? "paddingTop" : "paddingBottom",
                                    c = r ? "top" : "bottom",
                                    u = r ? "bottom" : "top",
                                    d = this.position.y + e[l];
                                (t[c] = this.getYValue(d)), (t[u] = ""), this.css(t), this.emitEvent("layout", [this]);
                            }),
                            (c.getXValue = function (e) {
                                var t = this.layout._getOption("horizontal");
                                return this.layout.options.percentPosition && !t ? (e / this.layout.size.width) * 100 + "%" : e + "px";
                            }),
                            (c.getYValue = function (e) {
                                var t = this.layout._getOption("horizontal");
                                return this.layout.options.percentPosition && t ? (e / this.layout.size.height) * 100 + "%" : e + "px";
                            }),
                            (c._transitionTo = function (e, t) {
                                this.getPosition();
                                var n = this.position.x,
                                    r = this.position.y,
                                    i = e == this.position.x && t == this.position.y;
                                if ((this.setPosition(e, t), !i || this.isTransitioning)) {
                                    var o = e - n,
                                        a = t - r,
                                        s = {};
                                    (s.transform = this.getTranslate(o, a)), this.transition({ to: s, onTransitionEnd: { transform: this.layoutPosition }, isCleaning: !0 });
                                } else this.layoutPosition();
                            }),
                            (c.getTranslate = function (e, t) {
                                return "translate3d(" + (e = this.layout._getOption("originLeft") ? e : -e) + "px, " + (t = this.layout._getOption("originTop") ? t : -t) + "px, 0)";
                            }),
                            (c.goTo = function (e, t) {
                                this.setPosition(e, t), this.layoutPosition();
                            }),
                            (c.moveTo = c._transitionTo),
                            (c.setPosition = function (e, t) {
                                (this.position.x = parseFloat(e)), (this.position.y = parseFloat(t));
                            }),
                            (c._nonTransition = function (e) {
                                for (var t in (this.css(e.to), e.isCleaning && this._removeStyles(e.to), e.onTransitionEnd)) e.onTransitionEnd[t].call(this);
                            }),
                            (c.transition = function (e) {
                                if (parseFloat(this.layout.options.transitionDuration)) {
                                    var t = this._transn;
                                    for (var n in e.onTransitionEnd) t.onEnd[n] = e.onTransitionEnd[n];
                                    for (n in e.to) (t.ingProperties[n] = !0), e.isCleaning && (t.clean[n] = !0);
                                    e.from && (this.css(e.from), this.element.offsetHeight), this.enableTransition(e.to), this.css(e.to), (this.isTransitioning = !0);
                                } else this._nonTransition(e);
                            });
                        var d = "opacity," + u(o);
                        (c.enableTransition = function () {
                            if (!this.isTransitioning) {
                                var e = this.layout.options.transitionDuration;
                                (e = "number" == typeof e ? e + "ms" : e), this.css({ transitionProperty: d, transitionDuration: e, transitionDelay: this.staggerDelay || 0 }), this.element.addEventListener(a, this, !1);
                            }
                        }),
                            (c.onwebkitTransitionEnd = function (e) {
                                this.ontransitionend(e);
                            }),
                            (c.onotransitionend = function (e) {
                                this.ontransitionend(e);
                            });
                        var p = { "-webkit-transform": "transform" };
                        (c.ontransitionend = function (e) {
                            if (e.target === this.element) {
                                var t = this._transn,
                                    r = p[e.propertyName] || e.propertyName;
                                delete t.ingProperties[r],
                                    n(t.ingProperties) && this.disableTransition(),
                                    r in t.clean && ((this.element.style[e.propertyName] = ""), delete t.clean[r]),
                                    r in t.onEnd && (t.onEnd[r].call(this), delete t.onEnd[r]),
                                    this.emitEvent("transitionEnd", [this]);
                            }
                        }),
                            (c.disableTransition = function () {
                                this.removeTransitionStyles(), this.element.removeEventListener(a, this, !1), (this.isTransitioning = !1);
                            }),
                            (c._removeStyles = function (e) {
                                var t = {};
                                for (var n in e) t[n] = "";
                                this.css(t);
                            });
                        var h = { transitionProperty: "", transitionDuration: "", transitionDelay: "" };
                        return (
                            (c.removeTransitionStyles = function () {
                                this.css(h);
                            }),
                            (c.stagger = function (e) {
                                (e = isNaN(e) ? 0 : e), (this.staggerDelay = e + "ms");
                            }),
                            (c.removeElem = function () {
                                this.element.parentNode.removeChild(this.element), this.css({ display: "" }), this.emitEvent("remove", [this]);
                            }),
                            (c.remove = function () {
                                i && parseFloat(this.layout.options.transitionDuration)
                                    ? (this.once("transitionEnd", function () {
                                          this.removeElem();
                                      }),
                                      this.hide())
                                    : this.removeElem();
                            }),
                            (c.reveal = function () {
                                delete this.isHidden, this.css({ display: "" });
                                var e = this.layout.options,
                                    t = {};
                                (t[this.getHideRevealTransitionEndProperty("visibleStyle")] = this.onRevealTransitionEnd), this.transition({ from: e.hiddenStyle, to: e.visibleStyle, isCleaning: !0, onTransitionEnd: t });
                            }),
                            (c.onRevealTransitionEnd = function () {
                                this.isHidden || this.emitEvent("reveal");
                            }),
                            (c.getHideRevealTransitionEndProperty = function (e) {
                                var t = this.layout.options[e];
                                if (t.opacity) return "opacity";
                                for (var n in t) return n;
                            }),
                            (c.hide = function () {
                                (this.isHidden = !0), this.css({ display: "" });
                                var e = this.layout.options,
                                    t = {};
                                (t[this.getHideRevealTransitionEndProperty("hiddenStyle")] = this.onHideTransitionEnd), this.transition({ from: e.visibleStyle, to: e.hiddenStyle, isCleaning: !0, onTransitionEnd: t });
                            }),
                            (c.onHideTransitionEnd = function () {
                                this.isHidden && (this.css({ display: "none" }), this.emitEvent("hide"));
                            }),
                            (c.destroy = function () {
                                this.css({ position: "", left: "", right: "", top: "", bottom: "", transition: "", transform: "" });
                            }),
                            l
                        );
                    })
                        ? r.apply(t, i)
                        : r) || (e.exports = o);
    },
    function (e, t, n) {
        (function (e, n) {
            var r;
            (r = function (t) {
                "use strict";
                var r = /\r?\n/g,
                    i = /^\s*$/,
                    o = /^(\r?\n)*[\t\s]/;
                function a(e, t) {
                    for (var n = 0; e.charAt(n) === t; ) n++;
                    return n;
                }
                var s = Object.freeze({}),
                    l = Object.prototype.toString;
                function c(e) {
                    return "[object Object]" === l.call(e);
                }
                function u(e, t) {
                    for (var n = Object.create(null), r = e.split(","), i = 0; i < r.length; i++) n[r[i]] = !0;
                    return t
                        ? function (e) {
                              return n[e.toLowerCase()];
                          }
                        : function (e) {
                              return n[e];
                          };
                }
                var d = u("slot,component", !0);
                u("key,ref,slot,slot-scope,is");
                var p = Object.prototype.hasOwnProperty;
                function h(e, t) {
                    return p.call(e, t);
                }
                function f(e) {
                    var t = Object.create(null);
                    return function (n) {
                        return t[n] || (t[n] = e(n));
                    };
                }
                var m = /-(\w)/g,
                    g = f(function (e) {
                        return e.replace(m, function (e, t) {
                            return t ? t.toUpperCase() : "";
                        });
                    }),
                    v = /\B([A-Z])/g,
                    y = f(function (e) {
                        return e.replace(v, "-$1").toLowerCase();
                    });
                function b(e, t) {
                    for (var n in t) e[n] = t[n];
                    return e;
                }
                function w(e, t, n) {}
                Function.prototype.bind;
                var x = function (e, t, n) {
                        return !1;
                    },
                    E = u("area,base,br,col,embed,frame,hr,img,input,isindex,keygen,link,meta,param,source,track,wbr"),
                    C = u("colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source"),
                    S = u(
                        "address,article,aside,base,blockquote,body,caption,col,colgroup,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,title,tr,track"
                    );
                function T(e, t, n, r) {
                    Object.defineProperty(e, t, { value: n, enumerable: !!r, writable: !0, configurable: !0 });
                }
                var k = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,
                    A = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,
                    _ = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/.source + "]*",
                    L = "((?:" + _ + "\\:)?" + _ + ")",
                    $ = new RegExp("^<" + L),
                    D = /^\s*(\/?)>/,
                    O = new RegExp("^<\\/" + L + "[^>]*>"),
                    q = /^<!DOCTYPE [^>]+>/i,
                    M = /^<!\--/,
                    P = /^<!\[/,
                    I = u("script,style,textarea", !0),
                    N = {},
                    z = { "&lt;": "<", "&gt;": ">", "&quot;": '"', "&amp;": "&", "&#10;": "\n", "&#9;": "\t", "&#39;": "'" },
                    R = /&(?:lt|gt|quot|amp|#39);/g,
                    F = /&(?:lt|gt|quot|amp|#39|#10|#9);/g,
                    B = u("pre,textarea", !0),
                    j = function (e, t) {
                        return e && B(e) && "\n" === t[0];
                    };
                function H(e, t) {
                    var n = t ? F : R;
                    return e.replace(n, function (e) {
                        return z[e];
                    });
                }
                function V(e, t) {
                    for (var n, r, i = [], o = t.expectHTML, a = t.isUnaryTag || x, s = t.canBeLeftOpenTag || x, l = 0; e; ) {
                        if (((n = e), r && I(r))) {
                            var c = 0,
                                u = r.toLowerCase(),
                                d = N[u] || (N[u] = new RegExp("([\\s\\S]*?)(</" + u + "[^>]*>)", "i")),
                                p = e.replace(d, function (e, n, r) {
                                    return (c = r.length), I(u) || "noscript" === u || (n = n.replace(/<!\--([\s\S]*?)-->/g, "$1").replace(/<!\[CDATA\[([\s\S]*?)]]>/g, "$1")), j(u, n) && (n = n.slice(1)), t.chars && t.chars(n), "";
                                });
                            (l += e.length - p.length), (e = p), z(u, l - c, l);
                        } else {
                            var h = e.indexOf("<");
                            if (0 === h) {
                                if (M.test(e)) {
                                    var f = e.indexOf("--\x3e");
                                    if (f >= 0) {
                                        t.shouldKeepComment && t.comment(e.substring(4, f), l, l + f + 3), T(f + 3);
                                        continue;
                                    }
                                }
                                if (P.test(e)) {
                                    var m = e.indexOf("]>");
                                    if (m >= 0) {
                                        T(m + 2);
                                        continue;
                                    }
                                }
                                var g = e.match(q);
                                if (g) {
                                    T(g[0].length);
                                    continue;
                                }
                                var v = e.match(O);
                                if (v) {
                                    var y = l;
                                    T(v[0].length), z(v[1], y, l);
                                    continue;
                                }
                                var b = _();
                                if (b) {
                                    L(b), j(b.tagName, e) && T(1);
                                    continue;
                                }
                            }
                            var w = void 0,
                                E = void 0,
                                C = void 0;
                            if (h >= 0) {
                                for (E = e.slice(h); !(O.test(E) || $.test(E) || M.test(E) || P.test(E) || (C = E.indexOf("<", 1)) < 0); ) (h += C), (E = e.slice(h));
                                w = e.substring(0, h);
                            }
                            h < 0 && (w = e), w && T(w.length), t.chars && w && t.chars(w, l - w.length, l);
                        }
                        if (e === n) {
                            t.chars && t.chars(e), !i.length && t.warn && t.warn('Mal-formatted tag at end of template: "' + e + '"', { start: l + e.length });
                            break;
                        }
                    }
                    function T(t) {
                        (l += t), (e = e.substring(t));
                    }
                    function _() {
                        var t = e.match($);
                        if (t) {
                            var n,
                                r,
                                i = { tagName: t[1], attrs: [], start: l };
                            for (T(t[0].length); !(n = e.match(D)) && (r = e.match(A) || e.match(k)); ) (r.start = l), T(r[0].length), (r.end = l), i.attrs.push(r);
                            if (n) return (i.unarySlash = n[1]), T(n[0].length), (i.end = l), i;
                        }
                    }
                    function L(e) {
                        var n = e.tagName,
                            l = e.unarySlash;
                        o && ("p" === r && S(n) && z(r), s(n) && r === n && z(n));
                        for (var c = a(n) || !!l, u = e.attrs.length, d = new Array(u), p = 0; p < u; p++) {
                            var h = e.attrs[p],
                                f = h[3] || h[4] || h[5] || "",
                                m = "a" === n && "href" === h[1] ? t.shouldDecodeNewlinesForHref : t.shouldDecodeNewlines;
                            (d[p] = { name: h[1], value: H(f, m) }), t.outputSourceRange && ((d[p].start = h.start + h[0].match(/^\s*/).length), (d[p].end = h.end));
                        }
                        c || (i.push({ tag: n, lowerCasedTag: n.toLowerCase(), attrs: d, start: e.start, end: e.end }), (r = n)), t.start && t.start(n, d, c, e.start, e.end);
                    }
                    function z(e, n, o) {
                        var a, s;
                        if ((null == n && (n = l), null == o && (o = l), e)) for (s = e.toLowerCase(), a = i.length - 1; a >= 0 && i[a].lowerCasedTag !== s; a--);
                        else a = 0;
                        if (a >= 0) {
                            for (var c = i.length - 1; c >= a; c--) (c > a || (!e && t.warn)) && t.warn("tag <" + i[c].tag + "> has no matching end tag.", { start: i[c].start, end: i[c].end }), t.end && t.end(i[c].tag, n, o);
                            (i.length = a), (r = a && i[a - 1].tag);
                        } else "br" === s ? t.start && t.start(e, [], !0, n, o) : "p" === s && (t.start && t.start(e, [], !1, n, o), t.end && t.end(e, n, o));
                    }
                    z();
                }
                var W,
                    U = /\r?\n/g,
                    G = /./g,
                    Y = u("script,style,template", !0),
                    X = "__proto__" in {},
                    K = "undefined" != typeof window,
                    J = "undefined" != typeof WXEnvironment && !!WXEnvironment.platform,
                    Z = (J && WXEnvironment.platform.toLowerCase(), K && window.navigator.userAgent.toLowerCase()),
                    Q = Z && /msie|trident/.test(Z),
                    ee = (Z && Z.indexOf("msie 9.0"), Z && Z.indexOf("edge/") > 0),
                    te = (Z && Z.indexOf("android"), Z && /iphone|ipad|ipod|ios/.test(Z), Z && /chrome\/\d+/.test(Z), Z && /phantomjs/.test(Z), Z && Z.match(/firefox\/(\d+)/), {}.watch);
                if (K)
                    try {
                        var ne = {};
                        Object.defineProperty(ne, "passive", { get: function () {} }), window.addEventListener("test-passive", null, ne);
                    } catch (e) {}
                var re = function () {
                    return void 0 === W && (W = !K && !J && void 0 !== e && e.process && "server" === e.process.env.VUE_ENV), W;
                };
                function ie(e) {
                    return "function" == typeof e && /native code/.test(e.toString());
                }
                K && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
                var oe = "undefined" != typeof Symbol && ie(Symbol) && "undefined" != typeof Reflect && ie(Reflect.ownKeys);
                "undefined" != typeof Set && ie(Set) && Set;
                var ae,
                    se = ["beforeCreate", "created", "beforeMount", "mounted", "beforeUpdate", "updated", "beforeDestroy", "destroyed", "activated", "deactivated", "errorCaptured", "serverPrefetch"],
                    le = {
                        optionMergeStrategies: Object.create(null),
                        silent: !1,
                        productionTip: !0,
                        devtools: !0,
                        performance: !1,
                        errorHandler: null,
                        warnHandler: null,
                        ignoredElements: [],
                        keyCodes: Object.create(null),
                        isReservedTag: x,
                        isReservedAttr: x,
                        isUnknownElement: x,
                        getTagNamespace: w,
                        parsePlatformTagName: function (e) {
                            return e;
                        },
                        mustUseProp: x,
                        async: !0,
                        _lifecycleHooks: se,
                    },
                    ce = w,
                    ue = w,
                    de = w,
                    pe = "undefined" != typeof console,
                    he = /(?:^|[-_])(\w)/g;
                (ce = function (e, t) {
                    var n = t ? de(t) : "";
                    pe && !le.silent && console.error("[Vue warn]: " + e + n);
                }),
                    (ue = function (e, t) {
                        pe && !le.silent && console.warn("[Vue tip]: " + e + (t ? de(t) : ""));
                    }),
                    (ae = function (e, t) {
                        if (e.$root === e) return "<Root>";
                        var n = "function" == typeof e && null != e.cid ? e.options : e._isVue ? e.$options || e.constructor.options : e,
                            r = n.name || n._componentTag,
                            i = n.__file;
                        if (!r && i) {
                            var o = i.match(/([^/\\]+)\.vue$/);
                            r = o && o[1];
                        }
                        return (
                            (r
                                ? "<" +
                                  (function (e) {
                                      return e
                                          .replace(he, function (e) {
                                              return e.toUpperCase();
                                          })
                                          .replace(/[-_]/g, "");
                                  })(r) +
                                  ">"
                                : "<Anonymous>") + (i && !1 !== t ? " at " + i : "")
                        );
                    }),
                    (de = function (e) {
                        if (e._isVue && e.$parent) {
                            for (var t = [], n = 0; e; ) {
                                if (t.length > 0) {
                                    var r = t[t.length - 1];
                                    if (r.constructor === e.constructor) {
                                        n++, (e = e.$parent);
                                        continue;
                                    }
                                    n > 0 && ((t[t.length - 1] = [r, n]), (n = 0));
                                }
                                t.push(e), (e = e.$parent);
                            }
                            return (
                                "\n\nfound in\n\n" +
                                t
                                    .map(function (e, t) {
                                        return (
                                            "" +
                                            (0 === t
                                                ? "---\x3e "
                                                : (function (e, t) {
                                                      for (var n = ""; t; ) t % 2 == 1 && (n += e), t > 1 && (e += e), (t >>= 1);
                                                      return n;
                                                  })(" ", 5 + 2 * t)) +
                                            (Array.isArray(e) ? ae(e[0]) + "... (" + e[1] + " recursive calls)" : ae(e))
                                        );
                                    })
                                    .join("\n")
                            );
                        }
                        return "\n\n(found in " + ae(e) + ")";
                    });
                var fe = 0,
                    me = function () {
                        (this.id = fe++), (this.subs = []);
                    };
                (me.prototype.addSub = function (e) {
                    this.subs.push(e);
                }),
                    (me.prototype.removeSub = function (e) {
                        !(function (e, t) {
                            if (e.length) {
                                var n = e.indexOf(t);
                                n > -1 && e.splice(n, 1);
                            }
                        })(this.subs, e);
                    }),
                    (me.prototype.depend = function () {
                        me.target && me.target.addDep(this);
                    }),
                    (me.prototype.notify = function () {
                        for (var e = this.subs.slice(), t = 0, n = e.length; t < n; t++) e[t].update();
                    }),
                    (me.target = null);
                var ge = function (e, t, n, r, i, o, a, s) {
                        (this.tag = e),
                            (this.data = t),
                            (this.children = n),
                            (this.text = r),
                            (this.elm = i),
                            (this.ns = void 0),
                            (this.context = o),
                            (this.fnContext = void 0),
                            (this.fnOptions = void 0),
                            (this.fnScopeId = void 0),
                            (this.key = t && t.key),
                            (this.componentOptions = a),
                            (this.componentInstance = void 0),
                            (this.parent = void 0),
                            (this.raw = !1),
                            (this.isStatic = !1),
                            (this.isRootInsert = !0),
                            (this.isComment = !1),
                            (this.isCloned = !1),
                            (this.isOnce = !1),
                            (this.asyncFactory = s),
                            (this.asyncMeta = void 0),
                            (this.isAsyncPlaceholder = !1);
                    },
                    ve = { child: { configurable: !0 } };
                (ve.child.get = function () {
                    return this.componentInstance;
                }),
                    Object.defineProperties(ge.prototype, ve);
                var ye = Array.prototype,
                    be = Object.create(ye);
                ["push", "pop", "shift", "unshift", "splice", "sort", "reverse"].forEach(function (e) {
                    var t = ye[e];
                    T(be, e, function () {
                        for (var n = [], r = arguments.length; r--; ) n[r] = arguments[r];
                        var i,
                            o = t.apply(this, n),
                            a = this.__ob__;
                        switch (e) {
                            case "push":
                            case "unshift":
                                i = n;
                                break;
                            case "splice":
                                i = n.slice(2);
                        }
                        return i && a.observeArray(i), a.dep.notify(), o;
                    });
                });
                var we = Object.getOwnPropertyNames(be),
                    xe = !0,
                    Ee = function (e) {
                        var t;
                        (this.value = e),
                            (this.dep = new me()),
                            (this.vmCount = 0),
                            T(e, "__ob__", this),
                            Array.isArray(e)
                                ? (X
                                      ? ((t = be), (e.__proto__ = t))
                                      : (function (e, t, n) {
                                            for (var r = 0, i = n.length; r < i; r++) {
                                                var o = n[r];
                                                T(e, o, t[o]);
                                            }
                                        })(e, be, we),
                                  this.observeArray(e))
                                : this.walk(e);
                    };
                function Ce(e, t) {
                    var n, r;
                    if (!(null === (n = e) || "object" != typeof n || e instanceof ge))
                        return h(e, "__ob__") && e.__ob__ instanceof Ee ? (r = e.__ob__) : xe && !re() && (Array.isArray(e) || c(e)) && Object.isExtensible(e) && !e._isVue && (r = new Ee(e)), t && r && r.vmCount++, r;
                }
                function Se(e, t, n, r, i) {
                    var o = new me(),
                        a = Object.getOwnPropertyDescriptor(e, t);
                    if (!a || !1 !== a.configurable) {
                        var s = a && a.get,
                            l = a && a.set;
                        (s && !l) || 2 !== arguments.length || (n = e[t]);
                        var c = !i && Ce(n);
                        Object.defineProperty(e, t, {
                            enumerable: !0,
                            configurable: !0,
                            get: function () {
                                var t = s ? s.call(e) : n;
                                return me.target && (o.depend(), c && (c.dep.depend(), Array.isArray(t) && ke(t))), t;
                            },
                            set: function (t) {
                                var a = s ? s.call(e) : n;
                                t === a || (t != t && a != a) || (r && r(), (s && !l) || (l ? l.call(e, t) : (n = t), (c = !i && Ce(t)), o.notify()));
                            },
                        });
                    }
                }
                function Te(e, t, n) {
                    var r;
                    if (
                        ((null == e || "string" == typeof (r = e) || "number" == typeof r || "symbol" == typeof r || "boolean" == typeof r) && ce("Cannot set reactive property on undefined, null, or primitive value: " + e),
                        Array.isArray(e) &&
                            (function (e) {
                                var t = parseFloat(String(e));
                                return t >= 0 && Math.floor(t) === t && isFinite(e);
                            })(t))
                    )
                        return (e.length = Math.max(e.length, t)), e.splice(t, 1, n), n;
                    if (t in e && !(t in Object.prototype)) return (e[t] = n), n;
                    var i = e.__ob__;
                    return e._isVue || (i && i.vmCount)
                        ? (ce("Avoid adding reactive properties to a Vue instance or its root $data at runtime - declare it upfront in the data option."), n)
                        : i
                        ? (Se(i.value, t, n), i.dep.notify(), n)
                        : ((e[t] = n), n);
                }
                function ke(e) {
                    for (var t = void 0, n = 0, r = e.length; n < r; n++) (t = e[n]) && t.__ob__ && t.__ob__.dep.depend(), Array.isArray(t) && ke(t);
                }
                (Ee.prototype.walk = function (e) {
                    for (var t = Object.keys(e), n = 0; n < t.length; n++) Se(e, t[n]);
                }),
                    (Ee.prototype.observeArray = function (e) {
                        for (var t = 0, n = e.length; t < n; t++) Ce(e[t]);
                    });
                var Ae = le.optionMergeStrategies;
                function _e(e, t) {
                    if (!t) return e;
                    for (var n, r, i, o = oe ? Reflect.ownKeys(t) : Object.keys(t), a = 0; a < o.length; a++) "__ob__" !== (n = o[a]) && ((r = e[n]), (i = t[n]), h(e, n) ? r !== i && c(r) && c(i) && _e(r, i) : Te(e, n, i));
                    return e;
                }
                function Le(e, t, n) {
                    return n
                        ? function () {
                              var r = "function" == typeof t ? t.call(n, n) : t,
                                  i = "function" == typeof e ? e.call(n, n) : e;
                              return r ? _e(r, i) : i;
                          }
                        : t
                        ? e
                            ? function () {
                                  return _e("function" == typeof t ? t.call(this, this) : t, "function" == typeof e ? e.call(this, this) : e);
                              }
                            : t
                        : e;
                }
                function $e(e, t) {
                    var n = t ? (e ? e.concat(t) : Array.isArray(t) ? t : [t]) : e;
                    return n
                        ? (function (e) {
                              for (var t = [], n = 0; n < e.length; n++) -1 === t.indexOf(e[n]) && t.push(e[n]);
                              return t;
                          })(n)
                        : n;
                }
                function De(e, t, n, r) {
                    var i = Object.create(e || null);
                    return t ? (qe(r, t, n), b(i, t)) : i;
                }
                (Ae.el = Ae.propsData = function (e, t, n, r) {
                    return n || ce('option "' + r + '" can only be used during instance creation with the `new` keyword.'), Oe(e, t);
                }),
                    (Ae.data = function (e, t, n) {
                        return n ? Le(e, t, n) : t && "function" != typeof t ? (ce('The "data" option should be a function that returns a per-instance value in component definitions.', n), e) : Le(e, t);
                    }),
                    se.forEach(function (e) {
                        Ae[e] = $e;
                    }),
                    ["component", "directive", "filter"].forEach(function (e) {
                        Ae[e + "s"] = De;
                    }),
                    (Ae.watch = function (e, t, n, r) {
                        if ((e === te && (e = void 0), t === te && (t = void 0), !t)) return Object.create(e || null);
                        if ((qe(r, t, n), !e)) return t;
                        var i = {};
                        for (var o in (b(i, e), t)) {
                            var a = i[o],
                                s = t[o];
                            a && !Array.isArray(a) && (a = [a]), (i[o] = a ? a.concat(s) : Array.isArray(s) ? s : [s]);
                        }
                        return i;
                    }),
                    (Ae.props = Ae.methods = Ae.inject = Ae.computed = function (e, t, n, r) {
                        if ((t && qe(r, t, n), !e)) return t;
                        var i = Object.create(null);
                        return b(i, e), t && b(i, t), i;
                    }),
                    (Ae.provide = Le);
                var Oe = function (e, t) {
                    return void 0 === t ? e : t;
                };
                function qe(e, t, n) {
                    c(t) ||
                        ce(
                            'Invalid value for option "' +
                                e +
                                '": expected an Object, but got ' +
                                (function (e) {
                                    return l.call(e).slice(8, -1);
                                })(t) +
                                ".",
                            n
                        );
                }
                var Me = [];
                if ("undefined" != typeof Promise && ie(Promise));
                else if (Q || "undefined" == typeof MutationObserver || (!ie(MutationObserver) && "[object MutationObserverConstructor]" !== MutationObserver.toString())) void 0 !== n && ie(n);
                else {
                    var Pe = new MutationObserver(function () {
                            var e = Me.slice(0);
                            Me.length = 0;
                            for (var t = 0; t < e.length; t++) e[t]();
                        }),
                        Ie = document.createTextNode(String(1));
                    Pe.observe(Ie, { characterData: !0 });
                }
                u("style,class");
                var Ne = u("input,textarea,option,select,progress"),
                    ze = u("contenteditable,draggable,spellcheck"),
                    Re =
                        (u("events,caret,typing,plaintext-only"),
                        u(
                            "allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,translate,truespeed,typemustmatch,visible"
                        )),
                    Fe = u(
                        "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"
                    ),
                    Be = u(
                        "svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view",
                        !0
                    );
                u("text,number,password,search,email,tel,url");
                var je = /[\w).+\-_$\]]/;
                function He(e) {
                    var t,
                        n,
                        r,
                        i,
                        o,
                        a = !1,
                        s = !1,
                        l = !1,
                        c = !1,
                        u = 0,
                        d = 0,
                        p = 0,
                        h = 0;
                    for (r = 0; r < e.length; r++)
                        if (((n = t), (t = e.charCodeAt(r)), a)) 39 === t && 92 !== n && (a = !1);
                        else if (s) 34 === t && 92 !== n && (s = !1);
                        else if (l) 96 === t && 92 !== n && (l = !1);
                        else if (c) 47 === t && 92 !== n && (c = !1);
                        else if (124 !== t || 124 === e.charCodeAt(r + 1) || 124 === e.charCodeAt(r - 1) || u || d || p) {
                            switch (t) {
                                case 34:
                                    s = !0;
                                    break;
                                case 39:
                                    a = !0;
                                    break;
                                case 96:
                                    l = !0;
                                    break;
                                case 40:
                                    p++;
                                    break;
                                case 41:
                                    p--;
                                    break;
                                case 91:
                                    d++;
                                    break;
                                case 93:
                                    d--;
                                    break;
                                case 123:
                                    u++;
                                    break;
                                case 125:
                                    u--;
                            }
                            if (47 === t) {
                                for (var f = r - 1, m = void 0; f >= 0 && " " === (m = e.charAt(f)); f--);
                                (m && je.test(m)) || (c = !0);
                            }
                        } else void 0 === i ? ((h = r + 1), (i = e.slice(0, r).trim())) : g();
                    function g() {
                        (o || (o = [])).push(e.slice(h, r).trim()), (h = r + 1);
                    }
                    if ((void 0 === i ? (i = e.slice(0, r).trim()) : 0 !== h && g(), o)) for (r = 0; r < o.length; r++) i = Ve(i, o[r]);
                    return i;
                }
                function Ve(e, t) {
                    var n = t.indexOf("(");
                    if (n < 0) return '_f("' + t + '")(' + e + ")";
                    var r = t.slice(0, n),
                        i = t.slice(n + 1);
                    return '_f("' + r + '")(' + e + (")" !== i ? "," + i : i);
                }
                var We = /\{\{((?:.|\r?\n)+?)\}\}/g,
                    Ue = /[-.*+?^${}()|[\]\/\\]/g,
                    Ge = f(function (e) {
                        var t = e[0].replace(Ue, "\\$&"),
                            n = e[1].replace(Ue, "\\$&");
                        return new RegExp(t + "((?:.|\\n)+?)" + n, "g");
                    });
                function Ye(e, t) {
                    var n = t ? Ge(t) : We;
                    if (n.test(e)) {
                        for (var r, i, o, a = [], s = [], l = (n.lastIndex = 0); (r = n.exec(e)); ) {
                            (i = r.index) > l && (s.push((o = e.slice(l, i))), a.push(JSON.stringify(o)));
                            var c = He(r[1].trim());
                            a.push("_s(" + c + ")"), s.push({ "@binding": c }), (l = i + r[0].length);
                        }
                        return l < e.length && (s.push((o = e.slice(l))), a.push(JSON.stringify(o))), { expression: a.join("+"), tokens: s };
                    }
                }
                function Xe(e, t) {
                    console.error("[Vue compiler]: " + e);
                }
                function Ke(e, t) {
                    return e
                        ? e
                              .map(function (e) {
                                  return e[t];
                              })
                              .filter(function (e) {
                                  return e;
                              })
                        : [];
                }
                function Je(e, t, n, r, i) {
                    (e.props || (e.props = [])).push(st({ name: t, value: n, dynamic: i }, r)), (e.plain = !1);
                }
                function Ze(e, t, n, r, i) {
                    (i ? e.dynamicAttrs || (e.dynamicAttrs = []) : e.attrs || (e.attrs = [])).push(st({ name: t, value: n, dynamic: i }, r)), (e.plain = !1);
                }
                function Qe(e, t, n, r) {
                    (e.attrsMap[t] = n), e.attrsList.push(st({ name: t, value: n }, r));
                }
                function et(e, t, n, r, i, o, a, s) {
                    (e.directives || (e.directives = [])).push(st({ name: t, rawName: n, value: r, arg: i, isDynamicArg: o, modifiers: a }, s)), (e.plain = !1);
                }
                function tt(e, t, n) {
                    return n ? "_p(" + t + ',"' + e + '")' : e + t;
                }
                function nt(e, t, n, r, i, o, a, l) {
                    var c;
                    (r = r || s),
                        o && r.prevent && r.passive && o("passive and prevent can't be used together. Passive handler can't prevent default event.", a),
                        r.right
                            ? l
                                ? (t = "(" + t + ")==='click'?'contextmenu':(" + t + ")")
                                : "click" === t && ((t = "contextmenu"), delete r.right)
                            : r.middle && (l ? (t = "(" + t + ")==='click'?'mouseup':(" + t + ")") : "click" === t && (t = "mouseup")),
                        r.capture && (delete r.capture, (t = tt("!", t, l))),
                        r.once && (delete r.once, (t = tt("~", t, l))),
                        r.passive && (delete r.passive, (t = tt("&", t, l))),
                        r.native ? (delete r.native, (c = e.nativeEvents || (e.nativeEvents = {}))) : (c = e.events || (e.events = {}));
                    var u = st({ value: n.trim(), dynamic: l }, a);
                    r !== s && (u.modifiers = r);
                    var d = c[t];
                    Array.isArray(d) ? (i ? d.unshift(u) : d.push(u)) : (c[t] = d ? (i ? [u, d] : [d, u]) : u), (e.plain = !1);
                }
                function rt(e, t) {
                    return e.rawAttrsMap[":" + t] || e.rawAttrsMap["v-bind:" + t] || e.rawAttrsMap[t];
                }
                function it(e, t, n) {
                    var r = ot(e, ":" + t) || ot(e, "v-bind:" + t);
                    if (null != r) return He(r);
                    if (!1 !== n) {
                        var i = ot(e, t);
                        if (null != i) return JSON.stringify(i);
                    }
                }
                function ot(e, t, n) {
                    var r;
                    if (null != (r = e.attrsMap[t]))
                        for (var i = e.attrsList, o = 0, a = i.length; o < a; o++)
                            if (i[o].name === t) {
                                i.splice(o, 1);
                                break;
                            }
                    return n && delete e.attrsMap[t], r;
                }
                function at(e, t) {
                    for (var n = e.attrsList, r = 0, i = n.length; r < i; r++) {
                        var o = n[r];
                        if (t.test(o.name)) return n.splice(r, 1), o;
                    }
                }
                function st(e, t) {
                    return t && (null != t.start && (e.start = t.start), null != t.end && (e.end = t.end)), e;
                }
                var lt,
                    ct,
                    ut,
                    dt,
                    pt,
                    ht,
                    ft = {
                        staticKeys: ["staticClass"],
                        transformNode: function (e, t) {
                            var n = t.warn || Xe,
                                r = ot(e, "class");
                            r &&
                                Ye(r, t.delimiters) &&
                                n(
                                    'class="' + r + '": Interpolation inside attributes has been removed. Use v-bind or the colon shorthand instead. For example, instead of <div class="{{ val }}">, use <div :class="val">.',
                                    e.rawAttrsMap.class
                                ),
                                r && (e.staticClass = JSON.stringify(r));
                            var i = it(e, "class", !1);
                            i && (e.classBinding = i);
                        },
                        genData: function (e) {
                            var t = "";
                            return e.staticClass && (t += "staticClass:" + e.staticClass + ","), e.classBinding && (t += "class:" + e.classBinding + ","), t;
                        },
                    },
                    mt = f(function (e) {
                        var t = {},
                            n = /:(.+)/;
                        return (
                            e.split(/;(?![^(]*\))/g).forEach(function (e) {
                                if (e) {
                                    var r = e.split(n);
                                    r.length > 1 && (t[r[0].trim()] = r[1].trim());
                                }
                            }),
                            t
                        );
                    }),
                    gt = {
                        staticKeys: ["staticStyle"],
                        transformNode: function (e, t) {
                            var n = t.warn || Xe,
                                r = ot(e, "style");
                            r &&
                                (Ye(r, t.delimiters) &&
                                    n(
                                        'style="' + r + '": Interpolation inside attributes has been removed. Use v-bind or the colon shorthand instead. For example, instead of <div style="{{ val }}">, use <div :style="val">.',
                                        e.rawAttrsMap.style
                                    ),
                                (e.staticStyle = JSON.stringify(mt(r))));
                            var i = it(e, "style", !1);
                            i && (e.styleBinding = i);
                        },
                        genData: function (e) {
                            var t = "";
                            return e.staticStyle && (t += "staticStyle:" + e.staticStyle + ","), e.styleBinding && (t += "style:(" + e.styleBinding + "),"), t;
                        },
                    },
                    vt = "undefined" != typeof window ? window : void 0 !== e ? e : "undefined" != typeof self ? self : {},
                    yt = (function (e, t) {
                        return e((t = { exports: {} }), t.exports), t.exports;
                    })(function (e, t) {
                        !(function (n) {
                            var r = t,
                                i = e && e.exports == r && e,
                                o = "object" == typeof vt && vt;
                            (o.global !== o && o.window !== o) || (n = o);
                            var a = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
                                s = /[\x01-\x7F]/g,
                                l = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g,
                                c = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g,
                                u = {
                                    "­": "shy",
                                    "‌": "zwnj",
                                    "‍": "zwj",
                                    "‎": "lrm",
                                    "⁣": "ic",
                                    "⁢": "it",
                                    "⁡": "af",
                                    "‏": "rlm",
                                    "​": "ZeroWidthSpace",
                                    "⁠": "NoBreak",
                                    "̑": "DownBreve",
                                    "⃛": "tdot",
                                    "⃜": "DotDot",
                                    "\t": "Tab",
                                    "\n": "NewLine",
                                    " ": "puncsp",
                                    " ": "MediumSpace",
                                    " ": "thinsp",
                                    " ": "hairsp",
                                    " ": "emsp13",
                                    " ": "ensp",
                                    " ": "emsp14",
                                    " ": "emsp",
                                    " ": "numsp",
                                    " ": "nbsp",
                                    "  ": "ThickSpace",
                                    "‾": "oline",
                                    _: "lowbar",
                                    "‐": "dash",
                                    "–": "ndash",
                                    "—": "mdash",
                                    "―": "horbar",
                                    ",": "comma",
                                    ";": "semi",
                                    "⁏": "bsemi",
                                    ":": "colon",
                                    "⩴": "Colone",
                                    "!": "excl",
                                    "¡": "iexcl",
                                    "?": "quest",
                                    "¿": "iquest",
                                    ".": "period",
                                    "‥": "nldr",
                                    "…": "mldr",
                                    "·": "middot",
                                    "'": "apos",
                                    "‘": "lsquo",
                                    "’": "rsquo",
                                    "‚": "sbquo",
                                    "‹": "lsaquo",
                                    "›": "rsaquo",
                                    '"': "quot",
                                    "“": "ldquo",
                                    "”": "rdquo",
                                    "„": "bdquo",
                                    "«": "laquo",
                                    "»": "raquo",
                                    "(": "lpar",
                                    ")": "rpar",
                                    "[": "lsqb",
                                    "]": "rsqb",
                                    "{": "lcub",
                                    "}": "rcub",
                                    "⌈": "lceil",
                                    "⌉": "rceil",
                                    "⌊": "lfloor",
                                    "⌋": "rfloor",
                                    "⦅": "lopar",
                                    "⦆": "ropar",
                                    "⦋": "lbrke",
                                    "⦌": "rbrke",
                                    "⦍": "lbrkslu",
                                    "⦎": "rbrksld",
                                    "⦏": "lbrksld",
                                    "⦐": "rbrkslu",
                                    "⦑": "langd",
                                    "⦒": "rangd",
                                    "⦓": "lparlt",
                                    "⦔": "rpargt",
                                    "⦕": "gtlPar",
                                    "⦖": "ltrPar",
                                    "⟦": "lobrk",
                                    "⟧": "robrk",
                                    "⟨": "lang",
                                    "⟩": "rang",
                                    "⟪": "Lang",
                                    "⟫": "Rang",
                                    "⟬": "loang",
                                    "⟭": "roang",
                                    "❲": "lbbrk",
                                    "❳": "rbbrk",
                                    "‖": "Vert",
                                    "§": "sect",
                                    "¶": "para",
                                    "@": "commat",
                                    "*": "ast",
                                    "/": "sol",
                                    undefined: null,
                                    "&": "amp",
                                    "#": "num",
                                    "%": "percnt",
                                    "‰": "permil",
                                    "‱": "pertenk",
                                    "†": "dagger",
                                    "‡": "Dagger",
                                    "•": "bull",
                                    "⁃": "hybull",
                                    "′": "prime",
                                    "″": "Prime",
                                    "‴": "tprime",
                                    "⁗": "qprime",
                                    "‵": "bprime",
                                    "⁁": "caret",
                                    "`": "grave",
                                    "´": "acute",
                                    "˜": "tilde",
                                    "^": "Hat",
                                    "¯": "macr",
                                    "˘": "breve",
                                    "˙": "dot",
                                    "¨": "die",
                                    "˚": "ring",
                                    "˝": "dblac",
                                    "¸": "cedil",
                                    "˛": "ogon",
                                    ˆ: "circ",
                                    ˇ: "caron",
                                    "°": "deg",
                                    "©": "copy",
                                    "®": "reg",
                                    "℗": "copysr",
                                    "℘": "wp",
                                    "℞": "rx",
                                    "℧": "mho",
                                    "℩": "iiota",
                                    "←": "larr",
                                    "↚": "nlarr",
                                    "→": "rarr",
                                    "↛": "nrarr",
                                    "↑": "uarr",
                                    "↓": "darr",
                                    "↔": "harr",
                                    "↮": "nharr",
                                    "↕": "varr",
                                    "↖": "nwarr",
                                    "↗": "nearr",
                                    "↘": "searr",
                                    "↙": "swarr",
                                    "↝": "rarrw",
                                    "↝̸": "nrarrw",
                                    "↞": "Larr",
                                    "↟": "Uarr",
                                    "↠": "Rarr",
                                    "↡": "Darr",
                                    "↢": "larrtl",
                                    "↣": "rarrtl",
                                    "↤": "mapstoleft",
                                    "↥": "mapstoup",
                                    "↦": "map",
                                    "↧": "mapstodown",
                                    "↩": "larrhk",
                                    "↪": "rarrhk",
                                    "↫": "larrlp",
                                    "↬": "rarrlp",
                                    "↭": "harrw",
                                    "↰": "lsh",
                                    "↱": "rsh",
                                    "↲": "ldsh",
                                    "↳": "rdsh",
                                    "↵": "crarr",
                                    "↶": "cularr",
                                    "↷": "curarr",
                                    "↺": "olarr",
                                    "↻": "orarr",
                                    "↼": "lharu",
                                    "↽": "lhard",
                                    "↾": "uharr",
                                    "↿": "uharl",
                                    "⇀": "rharu",
                                    "⇁": "rhard",
                                    "⇂": "dharr",
                                    "⇃": "dharl",
                                    "⇄": "rlarr",
                                    "⇅": "udarr",
                                    "⇆": "lrarr",
                                    "⇇": "llarr",
                                    "⇈": "uuarr",
                                    "⇉": "rrarr",
                                    "⇊": "ddarr",
                                    "⇋": "lrhar",
                                    "⇌": "rlhar",
                                    "⇐": "lArr",
                                    "⇍": "nlArr",
                                    "⇑": "uArr",
                                    "⇒": "rArr",
                                    "⇏": "nrArr",
                                    "⇓": "dArr",
                                    "⇔": "iff",
                                    "⇎": "nhArr",
                                    "⇕": "vArr",
                                    "⇖": "nwArr",
                                    "⇗": "neArr",
                                    "⇘": "seArr",
                                    "⇙": "swArr",
                                    "⇚": "lAarr",
                                    "⇛": "rAarr",
                                    "⇝": "zigrarr",
                                    "⇤": "larrb",
                                    "⇥": "rarrb",
                                    "⇵": "duarr",
                                    "⇽": "loarr",
                                    "⇾": "roarr",
                                    "⇿": "hoarr",
                                    "∀": "forall",
                                    "∁": "comp",
                                    "∂": "part",
                                    "∂̸": "npart",
                                    "∃": "exist",
                                    "∄": "nexist",
                                    "∅": "empty",
                                    "∇": "Del",
                                    "∈": "in",
                                    "∉": "notin",
                                    "∋": "ni",
                                    "∌": "notni",
                                    "϶": "bepsi",
                                    "∏": "prod",
                                    "∐": "coprod",
                                    "∑": "sum",
                                    "+": "plus",
                                    "±": "pm",
                                    "÷": "div",
                                    "×": "times",
                                    "<": "lt",
                                    "≮": "nlt",
                                    "<⃒": "nvlt",
                                    "=": "equals",
                                    "≠": "ne",
                                    "=⃥": "bne",
                                    "⩵": "Equal",
                                    ">": "gt",
                                    "≯": "ngt",
                                    ">⃒": "nvgt",
                                    "¬": "not",
                                    "|": "vert",
                                    "¦": "brvbar",
                                    "−": "minus",
                                    "∓": "mp",
                                    "∔": "plusdo",
                                    "⁄": "frasl",
                                    "∖": "setmn",
                                    "∗": "lowast",
                                    "∘": "compfn",
                                    "√": "Sqrt",
                                    "∝": "prop",
                                    "∞": "infin",
                                    "∟": "angrt",
                                    "∠": "ang",
                                    "∠⃒": "nang",
                                    "∡": "angmsd",
                                    "∢": "angsph",
                                    "∣": "mid",
                                    "∤": "nmid",
                                    "∥": "par",
                                    "∦": "npar",
                                    "∧": "and",
                                    "∨": "or",
                                    "∩": "cap",
                                    "∩︀": "caps",
                                    "∪": "cup",
                                    "∪︀": "cups",
                                    "∫": "int",
                                    "∬": "Int",
                                    "∭": "tint",
                                    "⨌": "qint",
                                    "∮": "oint",
                                    "∯": "Conint",
                                    "∰": "Cconint",
                                    "∱": "cwint",
                                    "∲": "cwconint",
                                    "∳": "awconint",
                                    "∴": "there4",
                                    "∵": "becaus",
                                    "∶": "ratio",
                                    "∷": "Colon",
                                    "∸": "minusd",
                                    "∺": "mDDot",
                                    "∻": "homtht",
                                    "∼": "sim",
                                    "≁": "nsim",
                                    "∼⃒": "nvsim",
                                    "∽": "bsim",
                                    "∽̱": "race",
                                    "∾": "ac",
                                    "∾̳": "acE",
                                    "∿": "acd",
                                    "≀": "wr",
                                    "≂": "esim",
                                    "≂̸": "nesim",
                                    "≃": "sime",
                                    "≄": "nsime",
                                    "≅": "cong",
                                    "≇": "ncong",
                                    "≆": "simne",
                                    "≈": "ap",
                                    "≉": "nap",
                                    "≊": "ape",
                                    "≋": "apid",
                                    "≋̸": "napid",
                                    "≌": "bcong",
                                    "≍": "CupCap",
                                    "≭": "NotCupCap",
                                    "≍⃒": "nvap",
                                    "≎": "bump",
                                    "≎̸": "nbump",
                                    "≏": "bumpe",
                                    "≏̸": "nbumpe",
                                    "≐": "doteq",
                                    "≐̸": "nedot",
                                    "≑": "eDot",
                                    "≒": "efDot",
                                    "≓": "erDot",
                                    "≔": "colone",
                                    "≕": "ecolon",
                                    "≖": "ecir",
                                    "≗": "cire",
                                    "≙": "wedgeq",
                                    "≚": "veeeq",
                                    "≜": "trie",
                                    "≟": "equest",
                                    "≡": "equiv",
                                    "≢": "nequiv",
                                    "≡⃥": "bnequiv",
                                    "≤": "le",
                                    "≰": "nle",
                                    "≤⃒": "nvle",
                                    "≥": "ge",
                                    "≱": "nge",
                                    "≥⃒": "nvge",
                                    "≦": "lE",
                                    "≦̸": "nlE",
                                    "≧": "gE",
                                    "≧̸": "ngE",
                                    "≨︀": "lvnE",
                                    "≨": "lnE",
                                    "≩": "gnE",
                                    "≩︀": "gvnE",
                                    "≪": "ll",
                                    "≪̸": "nLtv",
                                    "≪⃒": "nLt",
                                    "≫": "gg",
                                    "≫̸": "nGtv",
                                    "≫⃒": "nGt",
                                    "≬": "twixt",
                                    "≲": "lsim",
                                    "≴": "nlsim",
                                    "≳": "gsim",
                                    "≵": "ngsim",
                                    "≶": "lg",
                                    "≸": "ntlg",
                                    "≷": "gl",
                                    "≹": "ntgl",
                                    "≺": "pr",
                                    "⊀": "npr",
                                    "≻": "sc",
                                    "⊁": "nsc",
                                    "≼": "prcue",
                                    "⋠": "nprcue",
                                    "≽": "sccue",
                                    "⋡": "nsccue",
                                    "≾": "prsim",
                                    "≿": "scsim",
                                    "≿̸": "NotSucceedsTilde",
                                    "⊂": "sub",
                                    "⊄": "nsub",
                                    "⊂⃒": "vnsub",
                                    "⊃": "sup",
                                    "⊅": "nsup",
                                    "⊃⃒": "vnsup",
                                    "⊆": "sube",
                                    "⊈": "nsube",
                                    "⊇": "supe",
                                    "⊉": "nsupe",
                                    "⊊︀": "vsubne",
                                    "⊊": "subne",
                                    "⊋︀": "vsupne",
                                    "⊋": "supne",
                                    "⊍": "cupdot",
                                    "⊎": "uplus",
                                    "⊏": "sqsub",
                                    "⊏̸": "NotSquareSubset",
                                    "⊐": "sqsup",
                                    "⊐̸": "NotSquareSuperset",
                                    "⊑": "sqsube",
                                    "⋢": "nsqsube",
                                    "⊒": "sqsupe",
                                    "⋣": "nsqsupe",
                                    "⊓": "sqcap",
                                    "⊓︀": "sqcaps",
                                    "⊔": "sqcup",
                                    "⊔︀": "sqcups",
                                    "⊕": "oplus",
                                    "⊖": "ominus",
                                    "⊗": "otimes",
                                    "⊘": "osol",
                                    "⊙": "odot",
                                    "⊚": "ocir",
                                    "⊛": "oast",
                                    "⊝": "odash",
                                    "⊞": "plusb",
                                    "⊟": "minusb",
                                    "⊠": "timesb",
                                    "⊡": "sdotb",
                                    "⊢": "vdash",
                                    "⊬": "nvdash",
                                    "⊣": "dashv",
                                    "⊤": "top",
                                    "⊥": "bot",
                                    "⊧": "models",
                                    "⊨": "vDash",
                                    "⊭": "nvDash",
                                    "⊩": "Vdash",
                                    "⊮": "nVdash",
                                    "⊪": "Vvdash",
                                    "⊫": "VDash",
                                    "⊯": "nVDash",
                                    "⊰": "prurel",
                                    "⊲": "vltri",
                                    "⋪": "nltri",
                                    "⊳": "vrtri",
                                    "⋫": "nrtri",
                                    "⊴": "ltrie",
                                    "⋬": "nltrie",
                                    "⊴⃒": "nvltrie",
                                    "⊵": "rtrie",
                                    "⋭": "nrtrie",
                                    "⊵⃒": "nvrtrie",
                                    "⊶": "origof",
                                    "⊷": "imof",
                                    "⊸": "mumap",
                                    "⊹": "hercon",
                                    "⊺": "intcal",
                                    "⊻": "veebar",
                                    "⊽": "barvee",
                                    "⊾": "angrtvb",
                                    "⊿": "lrtri",
                                    "⋀": "Wedge",
                                    "⋁": "Vee",
                                    "⋂": "xcap",
                                    "⋃": "xcup",
                                    "⋄": "diam",
                                    "⋅": "sdot",
                                    "⋆": "Star",
                                    "⋇": "divonx",
                                    "⋈": "bowtie",
                                    "⋉": "ltimes",
                                    "⋊": "rtimes",
                                    "⋋": "lthree",
                                    "⋌": "rthree",
                                    "⋍": "bsime",
                                    "⋎": "cuvee",
                                    "⋏": "cuwed",
                                    "⋐": "Sub",
                                    "⋑": "Sup",
                                    "⋒": "Cap",
                                    "⋓": "Cup",
                                    "⋔": "fork",
                                    "⋕": "epar",
                                    "⋖": "ltdot",
                                    "⋗": "gtdot",
                                    "⋘": "Ll",
                                    "⋘̸": "nLl",
                                    "⋙": "Gg",
                                    "⋙̸": "nGg",
                                    "⋚︀": "lesg",
                                    "⋚": "leg",
                                    "⋛": "gel",
                                    "⋛︀": "gesl",
                                    "⋞": "cuepr",
                                    "⋟": "cuesc",
                                    "⋦": "lnsim",
                                    "⋧": "gnsim",
                                    "⋨": "prnsim",
                                    "⋩": "scnsim",
                                    "⋮": "vellip",
                                    "⋯": "ctdot",
                                    "⋰": "utdot",
                                    "⋱": "dtdot",
                                    "⋲": "disin",
                                    "⋳": "isinsv",
                                    "⋴": "isins",
                                    "⋵": "isindot",
                                    "⋵̸": "notindot",
                                    "⋶": "notinvc",
                                    "⋷": "notinvb",
                                    "⋹": "isinE",
                                    "⋹̸": "notinE",
                                    "⋺": "nisd",
                                    "⋻": "xnis",
                                    "⋼": "nis",
                                    "⋽": "notnivc",
                                    "⋾": "notnivb",
                                    "⌅": "barwed",
                                    "⌆": "Barwed",
                                    "⌌": "drcrop",
                                    "⌍": "dlcrop",
                                    "⌎": "urcrop",
                                    "⌏": "ulcrop",
                                    "⌐": "bnot",
                                    "⌒": "profline",
                                    "⌓": "profsurf",
                                    "⌕": "telrec",
                                    "⌖": "target",
                                    "⌜": "ulcorn",
                                    "⌝": "urcorn",
                                    "⌞": "dlcorn",
                                    "⌟": "drcorn",
                                    "⌢": "frown",
                                    "⌣": "smile",
                                    "⌭": "cylcty",
                                    "⌮": "profalar",
                                    "⌶": "topbot",
                                    "⌽": "ovbar",
                                    "⌿": "solbar",
                                    "⍼": "angzarr",
                                    "⎰": "lmoust",
                                    "⎱": "rmoust",
                                    "⎴": "tbrk",
                                    "⎵": "bbrk",
                                    "⎶": "bbrktbrk",
                                    "⏜": "OverParenthesis",
                                    "⏝": "UnderParenthesis",
                                    "⏞": "OverBrace",
                                    "⏟": "UnderBrace",
                                    "⏢": "trpezium",
                                    "⏧": "elinters",
                                    "␣": "blank",
                                    "─": "boxh",
                                    "│": "boxv",
                                    "┌": "boxdr",
                                    "┐": "boxdl",
                                    "└": "boxur",
                                    "┘": "boxul",
                                    "├": "boxvr",
                                    "┤": "boxvl",
                                    "┬": "boxhd",
                                    "┴": "boxhu",
                                    "┼": "boxvh",
                                    "═": "boxH",
                                    "║": "boxV",
                                    "╒": "boxdR",
                                    "╓": "boxDr",
                                    "╔": "boxDR",
                                    "╕": "boxdL",
                                    "╖": "boxDl",
                                    "╗": "boxDL",
                                    "╘": "boxuR",
                                    "╙": "boxUr",
                                    "╚": "boxUR",
                                    "╛": "boxuL",
                                    "╜": "boxUl",
                                    "╝": "boxUL",
                                    "╞": "boxvR",
                                    "╟": "boxVr",
                                    "╠": "boxVR",
                                    "╡": "boxvL",
                                    "╢": "boxVl",
                                    "╣": "boxVL",
                                    "╤": "boxHd",
                                    "╥": "boxhD",
                                    "╦": "boxHD",
                                    "╧": "boxHu",
                                    "╨": "boxhU",
                                    "╩": "boxHU",
                                    "╪": "boxvH",
                                    "╫": "boxVh",
                                    "╬": "boxVH",
                                    "▀": "uhblk",
                                    "▄": "lhblk",
                                    "█": "block",
                                    "░": "blk14",
                                    "▒": "blk12",
                                    "▓": "blk34",
                                    "□": "squ",
                                    "▪": "squf",
                                    "▫": "EmptyVerySmallSquare",
                                    "▭": "rect",
                                    "▮": "marker",
                                    "▱": "fltns",
                                    "△": "xutri",
                                    "▴": "utrif",
                                    "▵": "utri",
                                    "▸": "rtrif",
                                    "▹": "rtri",
                                    "▽": "xdtri",
                                    "▾": "dtrif",
                                    "▿": "dtri",
                                    "◂": "ltrif",
                                    "◃": "ltri",
                                    "◊": "loz",
                                    "○": "cir",
                                    "◬": "tridot",
                                    "◯": "xcirc",
                                    "◸": "ultri",
                                    "◹": "urtri",
                                    "◺": "lltri",
                                    "◻": "EmptySmallSquare",
                                    "◼": "FilledSmallSquare",
                                    "★": "starf",
                                    "☆": "star",
                                    "☎": "phone",
                                    "♀": "female",
                                    "♂": "male",
                                    "♠": "spades",
                                    "♣": "clubs",
                                    "♥": "hearts",
                                    "♦": "diams",
                                    "♪": "sung",
                                    "✓": "check",
                                    "✗": "cross",
                                    "✠": "malt",
                                    "✶": "sext",
                                    "❘": "VerticalSeparator",
                                    "⟈": "bsolhsub",
                                    "⟉": "suphsol",
                                    "⟵": "xlarr",
                                    "⟶": "xrarr",
                                    "⟷": "xharr",
                                    "⟸": "xlArr",
                                    "⟹": "xrArr",
                                    "⟺": "xhArr",
                                    "⟼": "xmap",
                                    "⟿": "dzigrarr",
                                    "⤂": "nvlArr",
                                    "⤃": "nvrArr",
                                    "⤄": "nvHarr",
                                    "⤅": "Map",
                                    "⤌": "lbarr",
                                    "⤍": "rbarr",
                                    "⤎": "lBarr",
                                    "⤏": "rBarr",
                                    "⤐": "RBarr",
                                    "⤑": "DDotrahd",
                                    "⤒": "UpArrowBar",
                                    "⤓": "DownArrowBar",
                                    "⤖": "Rarrtl",
                                    "⤙": "latail",
                                    "⤚": "ratail",
                                    "⤛": "lAtail",
                                    "⤜": "rAtail",
                                    "⤝": "larrfs",
                                    "⤞": "rarrfs",
                                    "⤟": "larrbfs",
                                    "⤠": "rarrbfs",
                                    "⤣": "nwarhk",
                                    "⤤": "nearhk",
                                    "⤥": "searhk",
                                    "⤦": "swarhk",
                                    "⤧": "nwnear",
                                    "⤨": "toea",
                                    "⤩": "tosa",
                                    "⤪": "swnwar",
                                    "⤳": "rarrc",
                                    "⤳̸": "nrarrc",
                                    "⤵": "cudarrr",
                                    "⤶": "ldca",
                                    "⤷": "rdca",
                                    "⤸": "cudarrl",
                                    "⤹": "larrpl",
                                    "⤼": "curarrm",
                                    "⤽": "cularrp",
                                    "⥅": "rarrpl",
                                    "⥈": "harrcir",
                                    "⥉": "Uarrocir",
                                    "⥊": "lurdshar",
                                    "⥋": "ldrushar",
                                    "⥎": "LeftRightVector",
                                    "⥏": "RightUpDownVector",
                                    "⥐": "DownLeftRightVector",
                                    "⥑": "LeftUpDownVector",
                                    "⥒": "LeftVectorBar",
                                    "⥓": "RightVectorBar",
                                    "⥔": "RightUpVectorBar",
                                    "⥕": "RightDownVectorBar",
                                    "⥖": "DownLeftVectorBar",
                                    "⥗": "DownRightVectorBar",
                                    "⥘": "LeftUpVectorBar",
                                    "⥙": "LeftDownVectorBar",
                                    "⥚": "LeftTeeVector",
                                    "⥛": "RightTeeVector",
                                    "⥜": "RightUpTeeVector",
                                    "⥝": "RightDownTeeVector",
                                    "⥞": "DownLeftTeeVector",
                                    "⥟": "DownRightTeeVector",
                                    "⥠": "LeftUpTeeVector",
                                    "⥡": "LeftDownTeeVector",
                                    "⥢": "lHar",
                                    "⥣": "uHar",
                                    "⥤": "rHar",
                                    "⥥": "dHar",
                                    "⥦": "luruhar",
                                    "⥧": "ldrdhar",
                                    "⥨": "ruluhar",
                                    "⥩": "rdldhar",
                                    "⥪": "lharul",
                                    "⥫": "llhard",
                                    "⥬": "rharul",
                                    "⥭": "lrhard",
                                    "⥮": "udhar",
                                    "⥯": "duhar",
                                    "⥰": "RoundImplies",
                                    "⥱": "erarr",
                                    "⥲": "simrarr",
                                    "⥳": "larrsim",
                                    "⥴": "rarrsim",
                                    "⥵": "rarrap",
                                    "⥶": "ltlarr",
                                    "⥸": "gtrarr",
                                    "⥹": "subrarr",
                                    "⥻": "suplarr",
                                    "⥼": "lfisht",
                                    "⥽": "rfisht",
                                    "⥾": "ufisht",
                                    "⥿": "dfisht",
                                    "⦚": "vzigzag",
                                    "⦜": "vangrt",
                                    "⦝": "angrtvbd",
                                    "⦤": "ange",
                                    "⦥": "range",
                                    "⦦": "dwangle",
                                    "⦧": "uwangle",
                                    "⦨": "angmsdaa",
                                    "⦩": "angmsdab",
                                    "⦪": "angmsdac",
                                    "⦫": "angmsdad",
                                    "⦬": "angmsdae",
                                    "⦭": "angmsdaf",
                                    "⦮": "angmsdag",
                                    "⦯": "angmsdah",
                                    "⦰": "bemptyv",
                                    "⦱": "demptyv",
                                    "⦲": "cemptyv",
                                    "⦳": "raemptyv",
                                    "⦴": "laemptyv",
                                    "⦵": "ohbar",
                                    "⦶": "omid",
                                    "⦷": "opar",
                                    "⦹": "operp",
                                    "⦻": "olcross",
                                    "⦼": "odsold",
                                    "⦾": "olcir",
                                    "⦿": "ofcir",
                                    "⧀": "olt",
                                    "⧁": "ogt",
                                    "⧂": "cirscir",
                                    "⧃": "cirE",
                                    "⧄": "solb",
                                    "⧅": "bsolb",
                                    "⧉": "boxbox",
                                    "⧍": "trisb",
                                    "⧎": "rtriltri",
                                    "⧏": "LeftTriangleBar",
                                    "⧏̸": "NotLeftTriangleBar",
                                    "⧐": "RightTriangleBar",
                                    "⧐̸": "NotRightTriangleBar",
                                    "⧜": "iinfin",
                                    "⧝": "infintie",
                                    "⧞": "nvinfin",
                                    "⧣": "eparsl",
                                    "⧤": "smeparsl",
                                    "⧥": "eqvparsl",
                                    "⧫": "lozf",
                                    "⧴": "RuleDelayed",
                                    "⧶": "dsol",
                                    "⨀": "xodot",
                                    "⨁": "xoplus",
                                    "⨂": "xotime",
                                    "⨄": "xuplus",
                                    "⨆": "xsqcup",
                                    "⨍": "fpartint",
                                    "⨐": "cirfnint",
                                    "⨑": "awint",
                                    "⨒": "rppolint",
                                    "⨓": "scpolint",
                                    "⨔": "npolint",
                                    "⨕": "pointint",
                                    "⨖": "quatint",
                                    "⨗": "intlarhk",
                                    "⨢": "pluscir",
                                    "⨣": "plusacir",
                                    "⨤": "simplus",
                                    "⨥": "plusdu",
                                    "⨦": "plussim",
                                    "⨧": "plustwo",
                                    "⨩": "mcomma",
                                    "⨪": "minusdu",
                                    "⨭": "loplus",
                                    "⨮": "roplus",
                                    "⨯": "Cross",
                                    "⨰": "timesd",
                                    "⨱": "timesbar",
                                    "⨳": "smashp",
                                    "⨴": "lotimes",
                                    "⨵": "rotimes",
                                    "⨶": "otimesas",
                                    "⨷": "Otimes",
                                    "⨸": "odiv",
                                    "⨹": "triplus",
                                    "⨺": "triminus",
                                    "⨻": "tritime",
                                    "⨼": "iprod",
                                    "⨿": "amalg",
                                    "⩀": "capdot",
                                    "⩂": "ncup",
                                    "⩃": "ncap",
                                    "⩄": "capand",
                                    "⩅": "cupor",
                                    "⩆": "cupcap",
                                    "⩇": "capcup",
                                    "⩈": "cupbrcap",
                                    "⩉": "capbrcup",
                                    "⩊": "cupcup",
                                    "⩋": "capcap",
                                    "⩌": "ccups",
                                    "⩍": "ccaps",
                                    "⩐": "ccupssm",
                                    "⩓": "And",
                                    "⩔": "Or",
                                    "⩕": "andand",
                                    "⩖": "oror",
                                    "⩗": "orslope",
                                    "⩘": "andslope",
                                    "⩚": "andv",
                                    "⩛": "orv",
                                    "⩜": "andd",
                                    "⩝": "ord",
                                    "⩟": "wedbar",
                                    "⩦": "sdote",
                                    "⩪": "simdot",
                                    "⩭": "congdot",
                                    "⩭̸": "ncongdot",
                                    "⩮": "easter",
                                    "⩯": "apacir",
                                    "⩰": "apE",
                                    "⩰̸": "napE",
                                    "⩱": "eplus",
                                    "⩲": "pluse",
                                    "⩳": "Esim",
                                    "⩷": "eDDot",
                                    "⩸": "equivDD",
                                    "⩹": "ltcir",
                                    "⩺": "gtcir",
                                    "⩻": "ltquest",
                                    "⩼": "gtquest",
                                    "⩽": "les",
                                    "⩽̸": "nles",
                                    "⩾": "ges",
                                    "⩾̸": "nges",
                                    "⩿": "lesdot",
                                    "⪀": "gesdot",
                                    "⪁": "lesdoto",
                                    "⪂": "gesdoto",
                                    "⪃": "lesdotor",
                                    "⪄": "gesdotol",
                                    "⪅": "lap",
                                    "⪆": "gap",
                                    "⪇": "lne",
                                    "⪈": "gne",
                                    "⪉": "lnap",
                                    "⪊": "gnap",
                                    "⪋": "lEg",
                                    "⪌": "gEl",
                                    "⪍": "lsime",
                                    "⪎": "gsime",
                                    "⪏": "lsimg",
                                    "⪐": "gsiml",
                                    "⪑": "lgE",
                                    "⪒": "glE",
                                    "⪓": "lesges",
                                    "⪔": "gesles",
                                    "⪕": "els",
                                    "⪖": "egs",
                                    "⪗": "elsdot",
                                    "⪘": "egsdot",
                                    "⪙": "el",
                                    "⪚": "eg",
                                    "⪝": "siml",
                                    "⪞": "simg",
                                    "⪟": "simlE",
                                    "⪠": "simgE",
                                    "⪡": "LessLess",
                                    "⪡̸": "NotNestedLessLess",
                                    "⪢": "GreaterGreater",
                                    "⪢̸": "NotNestedGreaterGreater",
                                    "⪤": "glj",
                                    "⪥": "gla",
                                    "⪦": "ltcc",
                                    "⪧": "gtcc",
                                    "⪨": "lescc",
                                    "⪩": "gescc",
                                    "⪪": "smt",
                                    "⪫": "lat",
                                    "⪬": "smte",
                                    "⪬︀": "smtes",
                                    "⪭": "late",
                                    "⪭︀": "lates",
                                    "⪮": "bumpE",
                                    "⪯": "pre",
                                    "⪯̸": "npre",
                                    "⪰": "sce",
                                    "⪰̸": "nsce",
                                    "⪳": "prE",
                                    "⪴": "scE",
                                    "⪵": "prnE",
                                    "⪶": "scnE",
                                    "⪷": "prap",
                                    "⪸": "scap",
                                    "⪹": "prnap",
                                    "⪺": "scnap",
                                    "⪻": "Pr",
                                    "⪼": "Sc",
                                    "⪽": "subdot",
                                    "⪾": "supdot",
                                    "⪿": "subplus",
                                    "⫀": "supplus",
                                    "⫁": "submult",
                                    "⫂": "supmult",
                                    "⫃": "subedot",
                                    "⫄": "supedot",
                                    "⫅": "subE",
                                    "⫅̸": "nsubE",
                                    "⫆": "supE",
                                    "⫆̸": "nsupE",
                                    "⫇": "subsim",
                                    "⫈": "supsim",
                                    "⫋︀": "vsubnE",
                                    "⫋": "subnE",
                                    "⫌︀": "vsupnE",
                                    "⫌": "supnE",
                                    "⫏": "csub",
                                    "⫐": "csup",
                                    "⫑": "csube",
                                    "⫒": "csupe",
                                    "⫓": "subsup",
                                    "⫔": "supsub",
                                    "⫕": "subsub",
                                    "⫖": "supsup",
                                    "⫗": "suphsub",
                                    "⫘": "supdsub",
                                    "⫙": "forkv",
                                    "⫚": "topfork",
                                    "⫛": "mlcp",
                                    "⫤": "Dashv",
                                    "⫦": "Vdashl",
                                    "⫧": "Barv",
                                    "⫨": "vBar",
                                    "⫩": "vBarv",
                                    "⫫": "Vbar",
                                    "⫬": "Not",
                                    "⫭": "bNot",
                                    "⫮": "rnmid",
                                    "⫯": "cirmid",
                                    "⫰": "midcir",
                                    "⫱": "topcir",
                                    "⫲": "nhpar",
                                    "⫳": "parsim",
                                    "⫽": "parsl",
                                    "⫽⃥": "nparsl",
                                    "♭": "flat",
                                    "♮": "natur",
                                    "♯": "sharp",
                                    "¤": "curren",
                                    "¢": "cent",
                                    $: "dollar",
                                    "£": "pound",
                                    "¥": "yen",
                                    "€": "euro",
                                    "¹": "sup1",
                                    "½": "half",
                                    "⅓": "frac13",
                                    "¼": "frac14",
                                    "⅕": "frac15",
                                    "⅙": "frac16",
                                    "⅛": "frac18",
                                    "²": "sup2",
                                    "⅔": "frac23",
                                    "⅖": "frac25",
                                    "³": "sup3",
                                    "¾": "frac34",
                                    "⅗": "frac35",
                                    "⅜": "frac38",
                                    "⅘": "frac45",
                                    "⅚": "frac56",
                                    "⅝": "frac58",
                                    "⅞": "frac78",
                                    "𝒶": "ascr",
                                    "𝕒": "aopf",
                                    "𝔞": "afr",
                                    "𝔸": "Aopf",
                                    "𝔄": "Afr",
                                    "𝒜": "Ascr",
                                    ª: "ordf",
                                    á: "aacute",
                                    Á: "Aacute",
                                    à: "agrave",
                                    À: "Agrave",
                                    ă: "abreve",
                                    Ă: "Abreve",
                                    â: "acirc",
                                    Â: "Acirc",
                                    å: "aring",
                                    Å: "angst",
                                    ä: "auml",
                                    Ä: "Auml",
                                    ã: "atilde",
                                    Ã: "Atilde",
                                    ą: "aogon",
                                    Ą: "Aogon",
                                    ā: "amacr",
                                    Ā: "Amacr",
                                    æ: "aelig",
                                    Æ: "AElig",
                                    "𝒷": "bscr",
                                    "𝕓": "bopf",
                                    "𝔟": "bfr",
                                    "𝔹": "Bopf",
                                    ℬ: "Bscr",
                                    "𝔅": "Bfr",
                                    "𝔠": "cfr",
                                    "𝒸": "cscr",
                                    "𝕔": "copf",
                                    ℭ: "Cfr",
                                    "𝒞": "Cscr",
                                    ℂ: "Copf",
                                    ć: "cacute",
                                    Ć: "Cacute",
                                    ĉ: "ccirc",
                                    Ĉ: "Ccirc",
                                    č: "ccaron",
                                    Č: "Ccaron",
                                    ċ: "cdot",
                                    Ċ: "Cdot",
                                    ç: "ccedil",
                                    Ç: "Ccedil",
                                    "℅": "incare",
                                    "𝔡": "dfr",
                                    ⅆ: "dd",
                                    "𝕕": "dopf",
                                    "𝒹": "dscr",
                                    "𝒟": "Dscr",
                                    "𝔇": "Dfr",
                                    ⅅ: "DD",
                                    "𝔻": "Dopf",
                                    ď: "dcaron",
                                    Ď: "Dcaron",
                                    đ: "dstrok",
                                    Đ: "Dstrok",
                                    ð: "eth",
                                    Ð: "ETH",
                                    ⅇ: "ee",
                                    ℯ: "escr",
                                    "𝔢": "efr",
                                    "𝕖": "eopf",
                                    ℰ: "Escr",
                                    "𝔈": "Efr",
                                    "𝔼": "Eopf",
                                    é: "eacute",
                                    É: "Eacute",
                                    è: "egrave",
                                    È: "Egrave",
                                    ê: "ecirc",
                                    Ê: "Ecirc",
                                    ě: "ecaron",
                                    Ě: "Ecaron",
                                    ë: "euml",
                                    Ë: "Euml",
                                    ė: "edot",
                                    Ė: "Edot",
                                    ę: "eogon",
                                    Ę: "Eogon",
                                    ē: "emacr",
                                    Ē: "Emacr",
                                    "𝔣": "ffr",
                                    "𝕗": "fopf",
                                    "𝒻": "fscr",
                                    "𝔉": "Ffr",
                                    "𝔽": "Fopf",
                                    ℱ: "Fscr",
                                    ﬀ: "fflig",
                                    ﬃ: "ffilig",
                                    ﬄ: "ffllig",
                                    ﬁ: "filig",
                                    fj: "fjlig",
                                    ﬂ: "fllig",
                                    ƒ: "fnof",
                                    ℊ: "gscr",
                                    "𝕘": "gopf",
                                    "𝔤": "gfr",
                                    "𝒢": "Gscr",
                                    "𝔾": "Gopf",
                                    "𝔊": "Gfr",
                                    ǵ: "gacute",
                                    ğ: "gbreve",
                                    Ğ: "Gbreve",
                                    ĝ: "gcirc",
                                    Ĝ: "Gcirc",
                                    ġ: "gdot",
                                    Ġ: "Gdot",
                                    Ģ: "Gcedil",
                                    "𝔥": "hfr",
                                    ℎ: "planckh",
                                    "𝒽": "hscr",
                                    "𝕙": "hopf",
                                    ℋ: "Hscr",
                                    ℌ: "Hfr",
                                    ℍ: "Hopf",
                                    ĥ: "hcirc",
                                    Ĥ: "Hcirc",
                                    ℏ: "hbar",
                                    ħ: "hstrok",
                                    Ħ: "Hstrok",
                                    "𝕚": "iopf",
                                    "𝔦": "ifr",
                                    "𝒾": "iscr",
                                    ⅈ: "ii",
                                    "𝕀": "Iopf",
                                    ℐ: "Iscr",
                                    ℑ: "Im",
                                    í: "iacute",
                                    Í: "Iacute",
                                    ì: "igrave",
                                    Ì: "Igrave",
                                    î: "icirc",
                                    Î: "Icirc",
                                    ï: "iuml",
                                    Ï: "Iuml",
                                    ĩ: "itilde",
                                    Ĩ: "Itilde",
                                    İ: "Idot",
                                    į: "iogon",
                                    Į: "Iogon",
                                    ī: "imacr",
                                    Ī: "Imacr",
                                    ĳ: "ijlig",
                                    Ĳ: "IJlig",
                                    ı: "imath",
                                    "𝒿": "jscr",
                                    "𝕛": "jopf",
                                    "𝔧": "jfr",
                                    "𝒥": "Jscr",
                                    "𝔍": "Jfr",
                                    "𝕁": "Jopf",
                                    ĵ: "jcirc",
                                    Ĵ: "Jcirc",
                                    ȷ: "jmath",
                                    "𝕜": "kopf",
                                    "𝓀": "kscr",
                                    "𝔨": "kfr",
                                    "𝒦": "Kscr",
                                    "𝕂": "Kopf",
                                    "𝔎": "Kfr",
                                    ķ: "kcedil",
                                    Ķ: "Kcedil",
                                    "𝔩": "lfr",
                                    "𝓁": "lscr",
                                    ℓ: "ell",
                                    "𝕝": "lopf",
                                    ℒ: "Lscr",
                                    "𝔏": "Lfr",
                                    "𝕃": "Lopf",
                                    ĺ: "lacute",
                                    Ĺ: "Lacute",
                                    ľ: "lcaron",
                                    Ľ: "Lcaron",
                                    ļ: "lcedil",
                                    Ļ: "Lcedil",
                                    ł: "lstrok",
                                    Ł: "Lstrok",
                                    ŀ: "lmidot",
                                    Ŀ: "Lmidot",
                                    "𝔪": "mfr",
                                    "𝕞": "mopf",
                                    "𝓂": "mscr",
                                    "𝔐": "Mfr",
                                    "𝕄": "Mopf",
                                    ℳ: "Mscr",
                                    "𝔫": "nfr",
                                    "𝕟": "nopf",
                                    "𝓃": "nscr",
                                    ℕ: "Nopf",
                                    "𝒩": "Nscr",
                                    "𝔑": "Nfr",
                                    ń: "nacute",
                                    Ń: "Nacute",
                                    ň: "ncaron",
                                    Ň: "Ncaron",
                                    ñ: "ntilde",
                                    Ñ: "Ntilde",
                                    ņ: "ncedil",
                                    Ņ: "Ncedil",
                                    "№": "numero",
                                    ŋ: "eng",
                                    Ŋ: "ENG",
                                    "𝕠": "oopf",
                                    "𝔬": "ofr",
                                    ℴ: "oscr",
                                    "𝒪": "Oscr",
                                    "𝔒": "Ofr",
                                    "𝕆": "Oopf",
                                    º: "ordm",
                                    ó: "oacute",
                                    Ó: "Oacute",
                                    ò: "ograve",
                                    Ò: "Ograve",
                                    ô: "ocirc",
                                    Ô: "Ocirc",
                                    ö: "ouml",
                                    Ö: "Ouml",
                                    ő: "odblac",
                                    Ő: "Odblac",
                                    õ: "otilde",
                                    Õ: "Otilde",
                                    ø: "oslash",
                                    Ø: "Oslash",
                                    ō: "omacr",
                                    Ō: "Omacr",
                                    œ: "oelig",
                                    Œ: "OElig",
                                    "𝔭": "pfr",
                                    "𝓅": "pscr",
                                    "𝕡": "popf",
                                    ℙ: "Popf",
                                    "𝔓": "Pfr",
                                    "𝒫": "Pscr",
                                    "𝕢": "qopf",
                                    "𝔮": "qfr",
                                    "𝓆": "qscr",
                                    "𝒬": "Qscr",
                                    "𝔔": "Qfr",
                                    ℚ: "Qopf",
                                    ĸ: "kgreen",
                                    "𝔯": "rfr",
                                    "𝕣": "ropf",
                                    "𝓇": "rscr",
                                    ℛ: "Rscr",
                                    ℜ: "Re",
                                    ℝ: "Ropf",
                                    ŕ: "racute",
                                    Ŕ: "Racute",
                                    ř: "rcaron",
                                    Ř: "Rcaron",
                                    ŗ: "rcedil",
                                    Ŗ: "Rcedil",
                                    "𝕤": "sopf",
                                    "𝓈": "sscr",
                                    "𝔰": "sfr",
                                    "𝕊": "Sopf",
                                    "𝔖": "Sfr",
                                    "𝒮": "Sscr",
                                    "Ⓢ": "oS",
                                    ś: "sacute",
                                    Ś: "Sacute",
                                    ŝ: "scirc",
                                    Ŝ: "Scirc",
                                    š: "scaron",
                                    Š: "Scaron",
                                    ş: "scedil",
                                    Ş: "Scedil",
                                    ß: "szlig",
                                    "𝔱": "tfr",
                                    "𝓉": "tscr",
                                    "𝕥": "topf",
                                    "𝒯": "Tscr",
                                    "𝔗": "Tfr",
                                    "𝕋": "Topf",
                                    ť: "tcaron",
                                    Ť: "Tcaron",
                                    ţ: "tcedil",
                                    Ţ: "Tcedil",
                                    "™": "trade",
                                    ŧ: "tstrok",
                                    Ŧ: "Tstrok",
                                    "𝓊": "uscr",
                                    "𝕦": "uopf",
                                    "𝔲": "ufr",
                                    "𝕌": "Uopf",
                                    "𝔘": "Ufr",
                                    "𝒰": "Uscr",
                                    ú: "uacute",
                                    Ú: "Uacute",
                                    ù: "ugrave",
                                    Ù: "Ugrave",
                                    ŭ: "ubreve",
                                    Ŭ: "Ubreve",
                                    û: "ucirc",
                                    Û: "Ucirc",
                                    ů: "uring",
                                    Ů: "Uring",
                                    ü: "uuml",
                                    Ü: "Uuml",
                                    ű: "udblac",
                                    Ű: "Udblac",
                                    ũ: "utilde",
                                    Ũ: "Utilde",
                                    ų: "uogon",
                                    Ų: "Uogon",
                                    ū: "umacr",
                                    Ū: "Umacr",
                                    "𝔳": "vfr",
                                    "𝕧": "vopf",
                                    "𝓋": "vscr",
                                    "𝔙": "Vfr",
                                    "𝕍": "Vopf",
                                    "𝒱": "Vscr",
                                    "𝕨": "wopf",
                                    "𝓌": "wscr",
                                    "𝔴": "wfr",
                                    "𝒲": "Wscr",
                                    "𝕎": "Wopf",
                                    "𝔚": "Wfr",
                                    ŵ: "wcirc",
                                    Ŵ: "Wcirc",
                                    "𝔵": "xfr",
                                    "𝓍": "xscr",
                                    "𝕩": "xopf",
                                    "𝕏": "Xopf",
                                    "𝔛": "Xfr",
                                    "𝒳": "Xscr",
                                    "𝔶": "yfr",
                                    "𝓎": "yscr",
                                    "𝕪": "yopf",
                                    "𝒴": "Yscr",
                                    "𝔜": "Yfr",
                                    "𝕐": "Yopf",
                                    ý: "yacute",
                                    Ý: "Yacute",
                                    ŷ: "ycirc",
                                    Ŷ: "Ycirc",
                                    ÿ: "yuml",
                                    Ÿ: "Yuml",
                                    "𝓏": "zscr",
                                    "𝔷": "zfr",
                                    "𝕫": "zopf",
                                    ℨ: "Zfr",
                                    ℤ: "Zopf",
                                    "𝒵": "Zscr",
                                    ź: "zacute",
                                    Ź: "Zacute",
                                    ž: "zcaron",
                                    Ž: "Zcaron",
                                    ż: "zdot",
                                    Ż: "Zdot",
                                    Ƶ: "imped",
                                    þ: "thorn",
                                    Þ: "THORN",
                                    ŉ: "napos",
                                    α: "alpha",
                                    Α: "Alpha",
                                    β: "beta",
                                    Β: "Beta",
                                    γ: "gamma",
                                    Γ: "Gamma",
                                    δ: "delta",
                                    Δ: "Delta",
                                    ε: "epsi",
                                    ϵ: "epsiv",
                                    Ε: "Epsilon",
                                    ϝ: "gammad",
                                    Ϝ: "Gammad",
                                    ζ: "zeta",
                                    Ζ: "Zeta",
                                    η: "eta",
                                    Η: "Eta",
                                    θ: "theta",
                                    ϑ: "thetav",
                                    Θ: "Theta",
                                    ι: "iota",
                                    Ι: "Iota",
                                    κ: "kappa",
                                    ϰ: "kappav",
                                    Κ: "Kappa",
                                    λ: "lambda",
                                    Λ: "Lambda",
                                    μ: "mu",
                                    µ: "micro",
                                    Μ: "Mu",
                                    ν: "nu",
                                    Ν: "Nu",
                                    ξ: "xi",
                                    Ξ: "Xi",
                                    ο: "omicron",
                                    Ο: "Omicron",
                                    π: "pi",
                                    ϖ: "piv",
                                    Π: "Pi",
                                    ρ: "rho",
                                    ϱ: "rhov",
                                    Ρ: "Rho",
                                    σ: "sigma",
                                    Σ: "Sigma",
                                    ς: "sigmaf",
                                    τ: "tau",
                                    Τ: "Tau",
                                    υ: "upsi",
                                    Υ: "Upsilon",
                                    ϒ: "Upsi",
                                    φ: "phi",
                                    ϕ: "phiv",
                                    Φ: "Phi",
                                    χ: "chi",
                                    Χ: "Chi",
                                    ψ: "psi",
                                    Ψ: "Psi",
                                    ω: "omega",
                                    Ω: "ohm",
                                    а: "acy",
                                    А: "Acy",
                                    б: "bcy",
                                    Б: "Bcy",
                                    в: "vcy",
                                    В: "Vcy",
                                    г: "gcy",
                                    Г: "Gcy",
                                    ѓ: "gjcy",
                                    Ѓ: "GJcy",
                                    д: "dcy",
                                    Д: "Dcy",
                                    ђ: "djcy",
                                    Ђ: "DJcy",
                                    е: "iecy",
                                    Е: "IEcy",
                                    ё: "iocy",
                                    Ё: "IOcy",
                                    є: "jukcy",
                                    Є: "Jukcy",
                                    ж: "zhcy",
                                    Ж: "ZHcy",
                                    з: "zcy",
                                    З: "Zcy",
                                    ѕ: "dscy",
                                    Ѕ: "DScy",
                                    и: "icy",
                                    И: "Icy",
                                    і: "iukcy",
                                    І: "Iukcy",
                                    ї: "yicy",
                                    Ї: "YIcy",
                                    й: "jcy",
                                    Й: "Jcy",
                                    ј: "jsercy",
                                    Ј: "Jsercy",
                                    к: "kcy",
                                    К: "Kcy",
                                    ќ: "kjcy",
                                    Ќ: "KJcy",
                                    л: "lcy",
                                    Л: "Lcy",
                                    љ: "ljcy",
                                    Љ: "LJcy",
                                    м: "mcy",
                                    М: "Mcy",
                                    н: "ncy",
                                    Н: "Ncy",
                                    њ: "njcy",
                                    Њ: "NJcy",
                                    о: "ocy",
                                    О: "Ocy",
                                    п: "pcy",
                                    П: "Pcy",
                                    р: "rcy",
                                    Р: "Rcy",
                                    с: "scy",
                                    С: "Scy",
                                    т: "tcy",
                                    Т: "Tcy",
                                    ћ: "tshcy",
                                    Ћ: "TSHcy",
                                    у: "ucy",
                                    У: "Ucy",
                                    ў: "ubrcy",
                                    Ў: "Ubrcy",
                                    ф: "fcy",
                                    Ф: "Fcy",
                                    х: "khcy",
                                    Х: "KHcy",
                                    ц: "tscy",
                                    Ц: "TScy",
                                    ч: "chcy",
                                    Ч: "CHcy",
                                    џ: "dzcy",
                                    Џ: "DZcy",
                                    ш: "shcy",
                                    Ш: "SHcy",
                                    щ: "shchcy",
                                    Щ: "SHCHcy",
                                    ъ: "hardcy",
                                    Ъ: "HARDcy",
                                    ы: "ycy",
                                    Ы: "Ycy",
                                    ь: "softcy",
                                    Ь: "SOFTcy",
                                    э: "ecy",
                                    Э: "Ecy",
                                    ю: "yucy",
                                    Ю: "YUcy",
                                    я: "yacy",
                                    Я: "YAcy",
                                    ℵ: "aleph",
                                    ℶ: "beth",
                                    ℷ: "gimel",
                                    ℸ: "daleth",
                                },
                                d = /["&'<>`]/g,
                                p = { '"': "&quot;", "&": "&amp;", "'": "&#x27;", "<": "&lt;", ">": "&gt;", "`": "&#x60;" },
                                h = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/,
                                f = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/,
                                m = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g,
                                g = {
                                    aacute: "á",
                                    Aacute: "Á",
                                    abreve: "ă",
                                    Abreve: "Ă",
                                    ac: "∾",
                                    acd: "∿",
                                    acE: "∾̳",
                                    acirc: "â",
                                    Acirc: "Â",
                                    acute: "´",
                                    acy: "а",
                                    Acy: "А",
                                    aelig: "æ",
                                    AElig: "Æ",
                                    af: "⁡",
                                    afr: "𝔞",
                                    Afr: "𝔄",
                                    agrave: "à",
                                    Agrave: "À",
                                    alefsym: "ℵ",
                                    aleph: "ℵ",
                                    alpha: "α",
                                    Alpha: "Α",
                                    amacr: "ā",
                                    Amacr: "Ā",
                                    amalg: "⨿",
                                    amp: "&",
                                    AMP: "&",
                                    and: "∧",
                                    And: "⩓",
                                    andand: "⩕",
                                    andd: "⩜",
                                    andslope: "⩘",
                                    andv: "⩚",
                                    ang: "∠",
                                    ange: "⦤",
                                    angle: "∠",
                                    angmsd: "∡",
                                    angmsdaa: "⦨",
                                    angmsdab: "⦩",
                                    angmsdac: "⦪",
                                    angmsdad: "⦫",
                                    angmsdae: "⦬",
                                    angmsdaf: "⦭",
                                    angmsdag: "⦮",
                                    angmsdah: "⦯",
                                    angrt: "∟",
                                    angrtvb: "⊾",
                                    angrtvbd: "⦝",
                                    angsph: "∢",
                                    angst: "Å",
                                    angzarr: "⍼",
                                    aogon: "ą",
                                    Aogon: "Ą",
                                    aopf: "𝕒",
                                    Aopf: "𝔸",
                                    ap: "≈",
                                    apacir: "⩯",
                                    ape: "≊",
                                    apE: "⩰",
                                    apid: "≋",
                                    apos: "'",
                                    ApplyFunction: "⁡",
                                    approx: "≈",
                                    approxeq: "≊",
                                    aring: "å",
                                    Aring: "Å",
                                    ascr: "𝒶",
                                    Ascr: "𝒜",
                                    Assign: "≔",
                                    ast: "*",
                                    asymp: "≈",
                                    asympeq: "≍",
                                    atilde: "ã",
                                    Atilde: "Ã",
                                    auml: "ä",
                                    Auml: "Ä",
                                    awconint: "∳",
                                    awint: "⨑",
                                    backcong: "≌",
                                    backepsilon: "϶",
                                    backprime: "‵",
                                    backsim: "∽",
                                    backsimeq: "⋍",
                                    Backslash: "∖",
                                    Barv: "⫧",
                                    barvee: "⊽",
                                    barwed: "⌅",
                                    Barwed: "⌆",
                                    barwedge: "⌅",
                                    bbrk: "⎵",
                                    bbrktbrk: "⎶",
                                    bcong: "≌",
                                    bcy: "б",
                                    Bcy: "Б",
                                    bdquo: "„",
                                    becaus: "∵",
                                    because: "∵",
                                    Because: "∵",
                                    bemptyv: "⦰",
                                    bepsi: "϶",
                                    bernou: "ℬ",
                                    Bernoullis: "ℬ",
                                    beta: "β",
                                    Beta: "Β",
                                    beth: "ℶ",
                                    between: "≬",
                                    bfr: "𝔟",
                                    Bfr: "𝔅",
                                    bigcap: "⋂",
                                    bigcirc: "◯",
                                    bigcup: "⋃",
                                    bigodot: "⨀",
                                    bigoplus: "⨁",
                                    bigotimes: "⨂",
                                    bigsqcup: "⨆",
                                    bigstar: "★",
                                    bigtriangledown: "▽",
                                    bigtriangleup: "△",
                                    biguplus: "⨄",
                                    bigvee: "⋁",
                                    bigwedge: "⋀",
                                    bkarow: "⤍",
                                    blacklozenge: "⧫",
                                    blacksquare: "▪",
                                    blacktriangle: "▴",
                                    blacktriangledown: "▾",
                                    blacktriangleleft: "◂",
                                    blacktriangleright: "▸",
                                    blank: "␣",
                                    blk12: "▒",
                                    blk14: "░",
                                    blk34: "▓",
                                    block: "█",
                                    bne: "=⃥",
                                    bnequiv: "≡⃥",
                                    bnot: "⌐",
                                    bNot: "⫭",
                                    bopf: "𝕓",
                                    Bopf: "𝔹",
                                    bot: "⊥",
                                    bottom: "⊥",
                                    bowtie: "⋈",
                                    boxbox: "⧉",
                                    boxdl: "┐",
                                    boxdL: "╕",
                                    boxDl: "╖",
                                    boxDL: "╗",
                                    boxdr: "┌",
                                    boxdR: "╒",
                                    boxDr: "╓",
                                    boxDR: "╔",
                                    boxh: "─",
                                    boxH: "═",
                                    boxhd: "┬",
                                    boxhD: "╥",
                                    boxHd: "╤",
                                    boxHD: "╦",
                                    boxhu: "┴",
                                    boxhU: "╨",
                                    boxHu: "╧",
                                    boxHU: "╩",
                                    boxminus: "⊟",
                                    boxplus: "⊞",
                                    boxtimes: "⊠",
                                    boxul: "┘",
                                    boxuL: "╛",
                                    boxUl: "╜",
                                    boxUL: "╝",
                                    boxur: "└",
                                    boxuR: "╘",
                                    boxUr: "╙",
                                    boxUR: "╚",
                                    boxv: "│",
                                    boxV: "║",
                                    boxvh: "┼",
                                    boxvH: "╪",
                                    boxVh: "╫",
                                    boxVH: "╬",
                                    boxvl: "┤",
                                    boxvL: "╡",
                                    boxVl: "╢",
                                    boxVL: "╣",
                                    boxvr: "├",
                                    boxvR: "╞",
                                    boxVr: "╟",
                                    boxVR: "╠",
                                    bprime: "‵",
                                    breve: "˘",
                                    Breve: "˘",
                                    brvbar: "¦",
                                    bscr: "𝒷",
                                    Bscr: "ℬ",
                                    bsemi: "⁏",
                                    bsim: "∽",
                                    bsime: "⋍",
                                    bsol: "\\",
                                    bsolb: "⧅",
                                    bsolhsub: "⟈",
                                    bull: "•",
                                    bullet: "•",
                                    bump: "≎",
                                    bumpe: "≏",
                                    bumpE: "⪮",
                                    bumpeq: "≏",
                                    Bumpeq: "≎",
                                    cacute: "ć",
                                    Cacute: "Ć",
                                    cap: "∩",
                                    Cap: "⋒",
                                    capand: "⩄",
                                    capbrcup: "⩉",
                                    capcap: "⩋",
                                    capcup: "⩇",
                                    capdot: "⩀",
                                    CapitalDifferentialD: "ⅅ",
                                    caps: "∩︀",
                                    caret: "⁁",
                                    caron: "ˇ",
                                    Cayleys: "ℭ",
                                    ccaps: "⩍",
                                    ccaron: "č",
                                    Ccaron: "Č",
                                    ccedil: "ç",
                                    Ccedil: "Ç",
                                    ccirc: "ĉ",
                                    Ccirc: "Ĉ",
                                    Cconint: "∰",
                                    ccups: "⩌",
                                    ccupssm: "⩐",
                                    cdot: "ċ",
                                    Cdot: "Ċ",
                                    cedil: "¸",
                                    Cedilla: "¸",
                                    cemptyv: "⦲",
                                    cent: "¢",
                                    centerdot: "·",
                                    CenterDot: "·",
                                    cfr: "𝔠",
                                    Cfr: "ℭ",
                                    chcy: "ч",
                                    CHcy: "Ч",
                                    check: "✓",
                                    checkmark: "✓",
                                    chi: "χ",
                                    Chi: "Χ",
                                    cir: "○",
                                    circ: "ˆ",
                                    circeq: "≗",
                                    circlearrowleft: "↺",
                                    circlearrowright: "↻",
                                    circledast: "⊛",
                                    circledcirc: "⊚",
                                    circleddash: "⊝",
                                    CircleDot: "⊙",
                                    circledR: "®",
                                    circledS: "Ⓢ",
                                    CircleMinus: "⊖",
                                    CirclePlus: "⊕",
                                    CircleTimes: "⊗",
                                    cire: "≗",
                                    cirE: "⧃",
                                    cirfnint: "⨐",
                                    cirmid: "⫯",
                                    cirscir: "⧂",
                                    ClockwiseContourIntegral: "∲",
                                    CloseCurlyDoubleQuote: "”",
                                    CloseCurlyQuote: "’",
                                    clubs: "♣",
                                    clubsuit: "♣",
                                    colon: ":",
                                    Colon: "∷",
                                    colone: "≔",
                                    Colone: "⩴",
                                    coloneq: "≔",
                                    comma: ",",
                                    commat: "@",
                                    comp: "∁",
                                    compfn: "∘",
                                    complement: "∁",
                                    complexes: "ℂ",
                                    cong: "≅",
                                    congdot: "⩭",
                                    Congruent: "≡",
                                    conint: "∮",
                                    Conint: "∯",
                                    ContourIntegral: "∮",
                                    copf: "𝕔",
                                    Copf: "ℂ",
                                    coprod: "∐",
                                    Coproduct: "∐",
                                    copy: "©",
                                    COPY: "©",
                                    copysr: "℗",
                                    CounterClockwiseContourIntegral: "∳",
                                    crarr: "↵",
                                    cross: "✗",
                                    Cross: "⨯",
                                    cscr: "𝒸",
                                    Cscr: "𝒞",
                                    csub: "⫏",
                                    csube: "⫑",
                                    csup: "⫐",
                                    csupe: "⫒",
                                    ctdot: "⋯",
                                    cudarrl: "⤸",
                                    cudarrr: "⤵",
                                    cuepr: "⋞",
                                    cuesc: "⋟",
                                    cularr: "↶",
                                    cularrp: "⤽",
                                    cup: "∪",
                                    Cup: "⋓",
                                    cupbrcap: "⩈",
                                    cupcap: "⩆",
                                    CupCap: "≍",
                                    cupcup: "⩊",
                                    cupdot: "⊍",
                                    cupor: "⩅",
                                    cups: "∪︀",
                                    curarr: "↷",
                                    curarrm: "⤼",
                                    curlyeqprec: "⋞",
                                    curlyeqsucc: "⋟",
                                    curlyvee: "⋎",
                                    curlywedge: "⋏",
                                    curren: "¤",
                                    curvearrowleft: "↶",
                                    curvearrowright: "↷",
                                    cuvee: "⋎",
                                    cuwed: "⋏",
                                    cwconint: "∲",
                                    cwint: "∱",
                                    cylcty: "⌭",
                                    dagger: "†",
                                    Dagger: "‡",
                                    daleth: "ℸ",
                                    darr: "↓",
                                    dArr: "⇓",
                                    Darr: "↡",
                                    dash: "‐",
                                    dashv: "⊣",
                                    Dashv: "⫤",
                                    dbkarow: "⤏",
                                    dblac: "˝",
                                    dcaron: "ď",
                                    Dcaron: "Ď",
                                    dcy: "д",
                                    Dcy: "Д",
                                    dd: "ⅆ",
                                    DD: "ⅅ",
                                    ddagger: "‡",
                                    ddarr: "⇊",
                                    DDotrahd: "⤑",
                                    ddotseq: "⩷",
                                    deg: "°",
                                    Del: "∇",
                                    delta: "δ",
                                    Delta: "Δ",
                                    demptyv: "⦱",
                                    dfisht: "⥿",
                                    dfr: "𝔡",
                                    Dfr: "𝔇",
                                    dHar: "⥥",
                                    dharl: "⇃",
                                    dharr: "⇂",
                                    DiacriticalAcute: "´",
                                    DiacriticalDot: "˙",
                                    DiacriticalDoubleAcute: "˝",
                                    DiacriticalGrave: "`",
                                    DiacriticalTilde: "˜",
                                    diam: "⋄",
                                    diamond: "⋄",
                                    Diamond: "⋄",
                                    diamondsuit: "♦",
                                    diams: "♦",
                                    die: "¨",
                                    DifferentialD: "ⅆ",
                                    digamma: "ϝ",
                                    disin: "⋲",
                                    div: "÷",
                                    divide: "÷",
                                    divideontimes: "⋇",
                                    divonx: "⋇",
                                    djcy: "ђ",
                                    DJcy: "Ђ",
                                    dlcorn: "⌞",
                                    dlcrop: "⌍",
                                    dollar: "$",
                                    dopf: "𝕕",
                                    Dopf: "𝔻",
                                    dot: "˙",
                                    Dot: "¨",
                                    DotDot: "⃜",
                                    doteq: "≐",
                                    doteqdot: "≑",
                                    DotEqual: "≐",
                                    dotminus: "∸",
                                    dotplus: "∔",
                                    dotsquare: "⊡",
                                    doublebarwedge: "⌆",
                                    DoubleContourIntegral: "∯",
                                    DoubleDot: "¨",
                                    DoubleDownArrow: "⇓",
                                    DoubleLeftArrow: "⇐",
                                    DoubleLeftRightArrow: "⇔",
                                    DoubleLeftTee: "⫤",
                                    DoubleLongLeftArrow: "⟸",
                                    DoubleLongLeftRightArrow: "⟺",
                                    DoubleLongRightArrow: "⟹",
                                    DoubleRightArrow: "⇒",
                                    DoubleRightTee: "⊨",
                                    DoubleUpArrow: "⇑",
                                    DoubleUpDownArrow: "⇕",
                                    DoubleVerticalBar: "∥",
                                    downarrow: "↓",
                                    Downarrow: "⇓",
                                    DownArrow: "↓",
                                    DownArrowBar: "⤓",
                                    DownArrowUpArrow: "⇵",
                                    DownBreve: "̑",
                                    downdownarrows: "⇊",
                                    downharpoonleft: "⇃",
                                    downharpoonright: "⇂",
                                    DownLeftRightVector: "⥐",
                                    DownLeftTeeVector: "⥞",
                                    DownLeftVector: "↽",
                                    DownLeftVectorBar: "⥖",
                                    DownRightTeeVector: "⥟",
                                    DownRightVector: "⇁",
                                    DownRightVectorBar: "⥗",
                                    DownTee: "⊤",
                                    DownTeeArrow: "↧",
                                    drbkarow: "⤐",
                                    drcorn: "⌟",
                                    drcrop: "⌌",
                                    dscr: "𝒹",
                                    Dscr: "𝒟",
                                    dscy: "ѕ",
                                    DScy: "Ѕ",
                                    dsol: "⧶",
                                    dstrok: "đ",
                                    Dstrok: "Đ",
                                    dtdot: "⋱",
                                    dtri: "▿",
                                    dtrif: "▾",
                                    duarr: "⇵",
                                    duhar: "⥯",
                                    dwangle: "⦦",
                                    dzcy: "џ",
                                    DZcy: "Џ",
                                    dzigrarr: "⟿",
                                    eacute: "é",
                                    Eacute: "É",
                                    easter: "⩮",
                                    ecaron: "ě",
                                    Ecaron: "Ě",
                                    ecir: "≖",
                                    ecirc: "ê",
                                    Ecirc: "Ê",
                                    ecolon: "≕",
                                    ecy: "э",
                                    Ecy: "Э",
                                    eDDot: "⩷",
                                    edot: "ė",
                                    eDot: "≑",
                                    Edot: "Ė",
                                    ee: "ⅇ",
                                    efDot: "≒",
                                    efr: "𝔢",
                                    Efr: "𝔈",
                                    eg: "⪚",
                                    egrave: "è",
                                    Egrave: "È",
                                    egs: "⪖",
                                    egsdot: "⪘",
                                    el: "⪙",
                                    Element: "∈",
                                    elinters: "⏧",
                                    ell: "ℓ",
                                    els: "⪕",
                                    elsdot: "⪗",
                                    emacr: "ē",
                                    Emacr: "Ē",
                                    empty: "∅",
                                    emptyset: "∅",
                                    EmptySmallSquare: "◻",
                                    emptyv: "∅",
                                    EmptyVerySmallSquare: "▫",
                                    emsp: " ",
                                    emsp13: " ",
                                    emsp14: " ",
                                    eng: "ŋ",
                                    ENG: "Ŋ",
                                    ensp: " ",
                                    eogon: "ę",
                                    Eogon: "Ę",
                                    eopf: "𝕖",
                                    Eopf: "𝔼",
                                    epar: "⋕",
                                    eparsl: "⧣",
                                    eplus: "⩱",
                                    epsi: "ε",
                                    epsilon: "ε",
                                    Epsilon: "Ε",
                                    epsiv: "ϵ",
                                    eqcirc: "≖",
                                    eqcolon: "≕",
                                    eqsim: "≂",
                                    eqslantgtr: "⪖",
                                    eqslantless: "⪕",
                                    Equal: "⩵",
                                    equals: "=",
                                    EqualTilde: "≂",
                                    equest: "≟",
                                    Equilibrium: "⇌",
                                    equiv: "≡",
                                    equivDD: "⩸",
                                    eqvparsl: "⧥",
                                    erarr: "⥱",
                                    erDot: "≓",
                                    escr: "ℯ",
                                    Escr: "ℰ",
                                    esdot: "≐",
                                    esim: "≂",
                                    Esim: "⩳",
                                    eta: "η",
                                    Eta: "Η",
                                    eth: "ð",
                                    ETH: "Ð",
                                    euml: "ë",
                                    Euml: "Ë",
                                    euro: "€",
                                    excl: "!",
                                    exist: "∃",
                                    Exists: "∃",
                                    expectation: "ℰ",
                                    exponentiale: "ⅇ",
                                    ExponentialE: "ⅇ",
                                    fallingdotseq: "≒",
                                    fcy: "ф",
                                    Fcy: "Ф",
                                    female: "♀",
                                    ffilig: "ﬃ",
                                    fflig: "ﬀ",
                                    ffllig: "ﬄ",
                                    ffr: "𝔣",
                                    Ffr: "𝔉",
                                    filig: "ﬁ",
                                    FilledSmallSquare: "◼",
                                    FilledVerySmallSquare: "▪",
                                    fjlig: "fj",
                                    flat: "♭",
                                    fllig: "ﬂ",
                                    fltns: "▱",
                                    fnof: "ƒ",
                                    fopf: "𝕗",
                                    Fopf: "𝔽",
                                    forall: "∀",
                                    ForAll: "∀",
                                    fork: "⋔",
                                    forkv: "⫙",
                                    Fouriertrf: "ℱ",
                                    fpartint: "⨍",
                                    frac12: "½",
                                    frac13: "⅓",
                                    frac14: "¼",
                                    frac15: "⅕",
                                    frac16: "⅙",
                                    frac18: "⅛",
                                    frac23: "⅔",
                                    frac25: "⅖",
                                    frac34: "¾",
                                    frac35: "⅗",
                                    frac38: "⅜",
                                    frac45: "⅘",
                                    frac56: "⅚",
                                    frac58: "⅝",
                                    frac78: "⅞",
                                    frasl: "⁄",
                                    frown: "⌢",
                                    fscr: "𝒻",
                                    Fscr: "ℱ",
                                    gacute: "ǵ",
                                    gamma: "γ",
                                    Gamma: "Γ",
                                    gammad: "ϝ",
                                    Gammad: "Ϝ",
                                    gap: "⪆",
                                    gbreve: "ğ",
                                    Gbreve: "Ğ",
                                    Gcedil: "Ģ",
                                    gcirc: "ĝ",
                                    Gcirc: "Ĝ",
                                    gcy: "г",
                                    Gcy: "Г",
                                    gdot: "ġ",
                                    Gdot: "Ġ",
                                    ge: "≥",
                                    gE: "≧",
                                    gel: "⋛",
                                    gEl: "⪌",
                                    geq: "≥",
                                    geqq: "≧",
                                    geqslant: "⩾",
                                    ges: "⩾",
                                    gescc: "⪩",
                                    gesdot: "⪀",
                                    gesdoto: "⪂",
                                    gesdotol: "⪄",
                                    gesl: "⋛︀",
                                    gesles: "⪔",
                                    gfr: "𝔤",
                                    Gfr: "𝔊",
                                    gg: "≫",
                                    Gg: "⋙",
                                    ggg: "⋙",
                                    gimel: "ℷ",
                                    gjcy: "ѓ",
                                    GJcy: "Ѓ",
                                    gl: "≷",
                                    gla: "⪥",
                                    glE: "⪒",
                                    glj: "⪤",
                                    gnap: "⪊",
                                    gnapprox: "⪊",
                                    gne: "⪈",
                                    gnE: "≩",
                                    gneq: "⪈",
                                    gneqq: "≩",
                                    gnsim: "⋧",
                                    gopf: "𝕘",
                                    Gopf: "𝔾",
                                    grave: "`",
                                    GreaterEqual: "≥",
                                    GreaterEqualLess: "⋛",
                                    GreaterFullEqual: "≧",
                                    GreaterGreater: "⪢",
                                    GreaterLess: "≷",
                                    GreaterSlantEqual: "⩾",
                                    GreaterTilde: "≳",
                                    gscr: "ℊ",
                                    Gscr: "𝒢",
                                    gsim: "≳",
                                    gsime: "⪎",
                                    gsiml: "⪐",
                                    gt: ">",
                                    Gt: "≫",
                                    GT: ">",
                                    gtcc: "⪧",
                                    gtcir: "⩺",
                                    gtdot: "⋗",
                                    gtlPar: "⦕",
                                    gtquest: "⩼",
                                    gtrapprox: "⪆",
                                    gtrarr: "⥸",
                                    gtrdot: "⋗",
                                    gtreqless: "⋛",
                                    gtreqqless: "⪌",
                                    gtrless: "≷",
                                    gtrsim: "≳",
                                    gvertneqq: "≩︀",
                                    gvnE: "≩︀",
                                    Hacek: "ˇ",
                                    hairsp: " ",
                                    half: "½",
                                    hamilt: "ℋ",
                                    hardcy: "ъ",
                                    HARDcy: "Ъ",
                                    harr: "↔",
                                    hArr: "⇔",
                                    harrcir: "⥈",
                                    harrw: "↭",
                                    Hat: "^",
                                    hbar: "ℏ",
                                    hcirc: "ĥ",
                                    Hcirc: "Ĥ",
                                    hearts: "♥",
                                    heartsuit: "♥",
                                    hellip: "…",
                                    hercon: "⊹",
                                    hfr: "𝔥",
                                    Hfr: "ℌ",
                                    HilbertSpace: "ℋ",
                                    hksearow: "⤥",
                                    hkswarow: "⤦",
                                    hoarr: "⇿",
                                    homtht: "∻",
                                    hookleftarrow: "↩",
                                    hookrightarrow: "↪",
                                    hopf: "𝕙",
                                    Hopf: "ℍ",
                                    horbar: "―",
                                    HorizontalLine: "─",
                                    hscr: "𝒽",
                                    Hscr: "ℋ",
                                    hslash: "ℏ",
                                    hstrok: "ħ",
                                    Hstrok: "Ħ",
                                    HumpDownHump: "≎",
                                    HumpEqual: "≏",
                                    hybull: "⁃",
                                    hyphen: "‐",
                                    iacute: "í",
                                    Iacute: "Í",
                                    ic: "⁣",
                                    icirc: "î",
                                    Icirc: "Î",
                                    icy: "и",
                                    Icy: "И",
                                    Idot: "İ",
                                    iecy: "е",
                                    IEcy: "Е",
                                    iexcl: "¡",
                                    iff: "⇔",
                                    ifr: "𝔦",
                                    Ifr: "ℑ",
                                    igrave: "ì",
                                    Igrave: "Ì",
                                    ii: "ⅈ",
                                    iiiint: "⨌",
                                    iiint: "∭",
                                    iinfin: "⧜",
                                    iiota: "℩",
                                    ijlig: "ĳ",
                                    IJlig: "Ĳ",
                                    Im: "ℑ",
                                    imacr: "ī",
                                    Imacr: "Ī",
                                    image: "ℑ",
                                    ImaginaryI: "ⅈ",
                                    imagline: "ℐ",
                                    imagpart: "ℑ",
                                    imath: "ı",
                                    imof: "⊷",
                                    imped: "Ƶ",
                                    Implies: "⇒",
                                    in: "∈",
                                    incare: "℅",
                                    infin: "∞",
                                    infintie: "⧝",
                                    inodot: "ı",
                                    int: "∫",
                                    Int: "∬",
                                    intcal: "⊺",
                                    integers: "ℤ",
                                    Integral: "∫",
                                    intercal: "⊺",
                                    Intersection: "⋂",
                                    intlarhk: "⨗",
                                    intprod: "⨼",
                                    InvisibleComma: "⁣",
                                    InvisibleTimes: "⁢",
                                    iocy: "ё",
                                    IOcy: "Ё",
                                    iogon: "į",
                                    Iogon: "Į",
                                    iopf: "𝕚",
                                    Iopf: "𝕀",
                                    iota: "ι",
                                    Iota: "Ι",
                                    iprod: "⨼",
                                    iquest: "¿",
                                    iscr: "𝒾",
                                    Iscr: "ℐ",
                                    isin: "∈",
                                    isindot: "⋵",
                                    isinE: "⋹",
                                    isins: "⋴",
                                    isinsv: "⋳",
                                    isinv: "∈",
                                    it: "⁢",
                                    itilde: "ĩ",
                                    Itilde: "Ĩ",
                                    iukcy: "і",
                                    Iukcy: "І",
                                    iuml: "ï",
                                    Iuml: "Ï",
                                    jcirc: "ĵ",
                                    Jcirc: "Ĵ",
                                    jcy: "й",
                                    Jcy: "Й",
                                    jfr: "𝔧",
                                    Jfr: "𝔍",
                                    jmath: "ȷ",
                                    jopf: "𝕛",
                                    Jopf: "𝕁",
                                    jscr: "𝒿",
                                    Jscr: "𝒥",
                                    jsercy: "ј",
                                    Jsercy: "Ј",
                                    jukcy: "є",
                                    Jukcy: "Є",
                                    kappa: "κ",
                                    Kappa: "Κ",
                                    kappav: "ϰ",
                                    kcedil: "ķ",
                                    Kcedil: "Ķ",
                                    kcy: "к",
                                    Kcy: "К",
                                    kfr: "𝔨",
                                    Kfr: "𝔎",
                                    kgreen: "ĸ",
                                    khcy: "х",
                                    KHcy: "Х",
                                    kjcy: "ќ",
                                    KJcy: "Ќ",
                                    kopf: "𝕜",
                                    Kopf: "𝕂",
                                    kscr: "𝓀",
                                    Kscr: "𝒦",
                                    lAarr: "⇚",
                                    lacute: "ĺ",
                                    Lacute: "Ĺ",
                                    laemptyv: "⦴",
                                    lagran: "ℒ",
                                    lambda: "λ",
                                    Lambda: "Λ",
                                    lang: "⟨",
                                    Lang: "⟪",
                                    langd: "⦑",
                                    langle: "⟨",
                                    lap: "⪅",
                                    Laplacetrf: "ℒ",
                                    laquo: "«",
                                    larr: "←",
                                    lArr: "⇐",
                                    Larr: "↞",
                                    larrb: "⇤",
                                    larrbfs: "⤟",
                                    larrfs: "⤝",
                                    larrhk: "↩",
                                    larrlp: "↫",
                                    larrpl: "⤹",
                                    larrsim: "⥳",
                                    larrtl: "↢",
                                    lat: "⪫",
                                    latail: "⤙",
                                    lAtail: "⤛",
                                    late: "⪭",
                                    lates: "⪭︀",
                                    lbarr: "⤌",
                                    lBarr: "⤎",
                                    lbbrk: "❲",
                                    lbrace: "{",
                                    lbrack: "[",
                                    lbrke: "⦋",
                                    lbrksld: "⦏",
                                    lbrkslu: "⦍",
                                    lcaron: "ľ",
                                    Lcaron: "Ľ",
                                    lcedil: "ļ",
                                    Lcedil: "Ļ",
                                    lceil: "⌈",
                                    lcub: "{",
                                    lcy: "л",
                                    Lcy: "Л",
                                    ldca: "⤶",
                                    ldquo: "“",
                                    ldquor: "„",
                                    ldrdhar: "⥧",
                                    ldrushar: "⥋",
                                    ldsh: "↲",
                                    le: "≤",
                                    lE: "≦",
                                    LeftAngleBracket: "⟨",
                                    leftarrow: "←",
                                    Leftarrow: "⇐",
                                    LeftArrow: "←",
                                    LeftArrowBar: "⇤",
                                    LeftArrowRightArrow: "⇆",
                                    leftarrowtail: "↢",
                                    LeftCeiling: "⌈",
                                    LeftDoubleBracket: "⟦",
                                    LeftDownTeeVector: "⥡",
                                    LeftDownVector: "⇃",
                                    LeftDownVectorBar: "⥙",
                                    LeftFloor: "⌊",
                                    leftharpoondown: "↽",
                                    leftharpoonup: "↼",
                                    leftleftarrows: "⇇",
                                    leftrightarrow: "↔",
                                    Leftrightarrow: "⇔",
                                    LeftRightArrow: "↔",
                                    leftrightarrows: "⇆",
                                    leftrightharpoons: "⇋",
                                    leftrightsquigarrow: "↭",
                                    LeftRightVector: "⥎",
                                    LeftTee: "⊣",
                                    LeftTeeArrow: "↤",
                                    LeftTeeVector: "⥚",
                                    leftthreetimes: "⋋",
                                    LeftTriangle: "⊲",
                                    LeftTriangleBar: "⧏",
                                    LeftTriangleEqual: "⊴",
                                    LeftUpDownVector: "⥑",
                                    LeftUpTeeVector: "⥠",
                                    LeftUpVector: "↿",
                                    LeftUpVectorBar: "⥘",
                                    LeftVector: "↼",
                                    LeftVectorBar: "⥒",
                                    leg: "⋚",
                                    lEg: "⪋",
                                    leq: "≤",
                                    leqq: "≦",
                                    leqslant: "⩽",
                                    les: "⩽",
                                    lescc: "⪨",
                                    lesdot: "⩿",
                                    lesdoto: "⪁",
                                    lesdotor: "⪃",
                                    lesg: "⋚︀",
                                    lesges: "⪓",
                                    lessapprox: "⪅",
                                    lessdot: "⋖",
                                    lesseqgtr: "⋚",
                                    lesseqqgtr: "⪋",
                                    LessEqualGreater: "⋚",
                                    LessFullEqual: "≦",
                                    LessGreater: "≶",
                                    lessgtr: "≶",
                                    LessLess: "⪡",
                                    lesssim: "≲",
                                    LessSlantEqual: "⩽",
                                    LessTilde: "≲",
                                    lfisht: "⥼",
                                    lfloor: "⌊",
                                    lfr: "𝔩",
                                    Lfr: "𝔏",
                                    lg: "≶",
                                    lgE: "⪑",
                                    lHar: "⥢",
                                    lhard: "↽",
                                    lharu: "↼",
                                    lharul: "⥪",
                                    lhblk: "▄",
                                    ljcy: "љ",
                                    LJcy: "Љ",
                                    ll: "≪",
                                    Ll: "⋘",
                                    llarr: "⇇",
                                    llcorner: "⌞",
                                    Lleftarrow: "⇚",
                                    llhard: "⥫",
                                    lltri: "◺",
                                    lmidot: "ŀ",
                                    Lmidot: "Ŀ",
                                    lmoust: "⎰",
                                    lmoustache: "⎰",
                                    lnap: "⪉",
                                    lnapprox: "⪉",
                                    lne: "⪇",
                                    lnE: "≨",
                                    lneq: "⪇",
                                    lneqq: "≨",
                                    lnsim: "⋦",
                                    loang: "⟬",
                                    loarr: "⇽",
                                    lobrk: "⟦",
                                    longleftarrow: "⟵",
                                    Longleftarrow: "⟸",
                                    LongLeftArrow: "⟵",
                                    longleftrightarrow: "⟷",
                                    Longleftrightarrow: "⟺",
                                    LongLeftRightArrow: "⟷",
                                    longmapsto: "⟼",
                                    longrightarrow: "⟶",
                                    Longrightarrow: "⟹",
                                    LongRightArrow: "⟶",
                                    looparrowleft: "↫",
                                    looparrowright: "↬",
                                    lopar: "⦅",
                                    lopf: "𝕝",
                                    Lopf: "𝕃",
                                    loplus: "⨭",
                                    lotimes: "⨴",
                                    lowast: "∗",
                                    lowbar: "_",
                                    LowerLeftArrow: "↙",
                                    LowerRightArrow: "↘",
                                    loz: "◊",
                                    lozenge: "◊",
                                    lozf: "⧫",
                                    lpar: "(",
                                    lparlt: "⦓",
                                    lrarr: "⇆",
                                    lrcorner: "⌟",
                                    lrhar: "⇋",
                                    lrhard: "⥭",
                                    lrm: "‎",
                                    lrtri: "⊿",
                                    lsaquo: "‹",
                                    lscr: "𝓁",
                                    Lscr: "ℒ",
                                    lsh: "↰",
                                    Lsh: "↰",
                                    lsim: "≲",
                                    lsime: "⪍",
                                    lsimg: "⪏",
                                    lsqb: "[",
                                    lsquo: "‘",
                                    lsquor: "‚",
                                    lstrok: "ł",
                                    Lstrok: "Ł",
                                    lt: "<",
                                    Lt: "≪",
                                    LT: "<",
                                    ltcc: "⪦",
                                    ltcir: "⩹",
                                    ltdot: "⋖",
                                    lthree: "⋋",
                                    ltimes: "⋉",
                                    ltlarr: "⥶",
                                    ltquest: "⩻",
                                    ltri: "◃",
                                    ltrie: "⊴",
                                    ltrif: "◂",
                                    ltrPar: "⦖",
                                    lurdshar: "⥊",
                                    luruhar: "⥦",
                                    lvertneqq: "≨︀",
                                    lvnE: "≨︀",
                                    macr: "¯",
                                    male: "♂",
                                    malt: "✠",
                                    maltese: "✠",
                                    map: "↦",
                                    Map: "⤅",
                                    mapsto: "↦",
                                    mapstodown: "↧",
                                    mapstoleft: "↤",
                                    mapstoup: "↥",
                                    marker: "▮",
                                    mcomma: "⨩",
                                    mcy: "м",
                                    Mcy: "М",
                                    mdash: "—",
                                    mDDot: "∺",
                                    measuredangle: "∡",
                                    MediumSpace: " ",
                                    Mellintrf: "ℳ",
                                    mfr: "𝔪",
                                    Mfr: "𝔐",
                                    mho: "℧",
                                    micro: "µ",
                                    mid: "∣",
                                    midast: "*",
                                    midcir: "⫰",
                                    middot: "·",
                                    minus: "−",
                                    minusb: "⊟",
                                    minusd: "∸",
                                    minusdu: "⨪",
                                    MinusPlus: "∓",
                                    mlcp: "⫛",
                                    mldr: "…",
                                    mnplus: "∓",
                                    models: "⊧",
                                    mopf: "𝕞",
                                    Mopf: "𝕄",
                                    mp: "∓",
                                    mscr: "𝓂",
                                    Mscr: "ℳ",
                                    mstpos: "∾",
                                    mu: "μ",
                                    Mu: "Μ",
                                    multimap: "⊸",
                                    mumap: "⊸",
                                    nabla: "∇",
                                    nacute: "ń",
                                    Nacute: "Ń",
                                    nang: "∠⃒",
                                    nap: "≉",
                                    napE: "⩰̸",
                                    napid: "≋̸",
                                    napos: "ŉ",
                                    napprox: "≉",
                                    natur: "♮",
                                    natural: "♮",
                                    naturals: "ℕ",
                                    nbsp: " ",
                                    nbump: "≎̸",
                                    nbumpe: "≏̸",
                                    ncap: "⩃",
                                    ncaron: "ň",
                                    Ncaron: "Ň",
                                    ncedil: "ņ",
                                    Ncedil: "Ņ",
                                    ncong: "≇",
                                    ncongdot: "⩭̸",
                                    ncup: "⩂",
                                    ncy: "н",
                                    Ncy: "Н",
                                    ndash: "–",
                                    ne: "≠",
                                    nearhk: "⤤",
                                    nearr: "↗",
                                    neArr: "⇗",
                                    nearrow: "↗",
                                    nedot: "≐̸",
                                    NegativeMediumSpace: "​",
                                    NegativeThickSpace: "​",
                                    NegativeThinSpace: "​",
                                    NegativeVeryThinSpace: "​",
                                    nequiv: "≢",
                                    nesear: "⤨",
                                    nesim: "≂̸",
                                    NestedGreaterGreater: "≫",
                                    NestedLessLess: "≪",
                                    NewLine: "\n",
                                    nexist: "∄",
                                    nexists: "∄",
                                    nfr: "𝔫",
                                    Nfr: "𝔑",
                                    nge: "≱",
                                    ngE: "≧̸",
                                    ngeq: "≱",
                                    ngeqq: "≧̸",
                                    ngeqslant: "⩾̸",
                                    nges: "⩾̸",
                                    nGg: "⋙̸",
                                    ngsim: "≵",
                                    ngt: "≯",
                                    nGt: "≫⃒",
                                    ngtr: "≯",
                                    nGtv: "≫̸",
                                    nharr: "↮",
                                    nhArr: "⇎",
                                    nhpar: "⫲",
                                    ni: "∋",
                                    nis: "⋼",
                                    nisd: "⋺",
                                    niv: "∋",
                                    njcy: "њ",
                                    NJcy: "Њ",
                                    nlarr: "↚",
                                    nlArr: "⇍",
                                    nldr: "‥",
                                    nle: "≰",
                                    nlE: "≦̸",
                                    nleftarrow: "↚",
                                    nLeftarrow: "⇍",
                                    nleftrightarrow: "↮",
                                    nLeftrightarrow: "⇎",
                                    nleq: "≰",
                                    nleqq: "≦̸",
                                    nleqslant: "⩽̸",
                                    nles: "⩽̸",
                                    nless: "≮",
                                    nLl: "⋘̸",
                                    nlsim: "≴",
                                    nlt: "≮",
                                    nLt: "≪⃒",
                                    nltri: "⋪",
                                    nltrie: "⋬",
                                    nLtv: "≪̸",
                                    nmid: "∤",
                                    NoBreak: "⁠",
                                    NonBreakingSpace: " ",
                                    nopf: "𝕟",
                                    Nopf: "ℕ",
                                    not: "¬",
                                    Not: "⫬",
                                    NotCongruent: "≢",
                                    NotCupCap: "≭",
                                    NotDoubleVerticalBar: "∦",
                                    NotElement: "∉",
                                    NotEqual: "≠",
                                    NotEqualTilde: "≂̸",
                                    NotExists: "∄",
                                    NotGreater: "≯",
                                    NotGreaterEqual: "≱",
                                    NotGreaterFullEqual: "≧̸",
                                    NotGreaterGreater: "≫̸",
                                    NotGreaterLess: "≹",
                                    NotGreaterSlantEqual: "⩾̸",
                                    NotGreaterTilde: "≵",
                                    NotHumpDownHump: "≎̸",
                                    NotHumpEqual: "≏̸",
                                    notin: "∉",
                                    notindot: "⋵̸",
                                    notinE: "⋹̸",
                                    notinva: "∉",
                                    notinvb: "⋷",
                                    notinvc: "⋶",
                                    NotLeftTriangle: "⋪",
                                    NotLeftTriangleBar: "⧏̸",
                                    NotLeftTriangleEqual: "⋬",
                                    NotLess: "≮",
                                    NotLessEqual: "≰",
                                    NotLessGreater: "≸",
                                    NotLessLess: "≪̸",
                                    NotLessSlantEqual: "⩽̸",
                                    NotLessTilde: "≴",
                                    NotNestedGreaterGreater: "⪢̸",
                                    NotNestedLessLess: "⪡̸",
                                    notni: "∌",
                                    notniva: "∌",
                                    notnivb: "⋾",
                                    notnivc: "⋽",
                                    NotPrecedes: "⊀",
                                    NotPrecedesEqual: "⪯̸",
                                    NotPrecedesSlantEqual: "⋠",
                                    NotReverseElement: "∌",
                                    NotRightTriangle: "⋫",
                                    NotRightTriangleBar: "⧐̸",
                                    NotRightTriangleEqual: "⋭",
                                    NotSquareSubset: "⊏̸",
                                    NotSquareSubsetEqual: "⋢",
                                    NotSquareSuperset: "⊐̸",
                                    NotSquareSupersetEqual: "⋣",
                                    NotSubset: "⊂⃒",
                                    NotSubsetEqual: "⊈",
                                    NotSucceeds: "⊁",
                                    NotSucceedsEqual: "⪰̸",
                                    NotSucceedsSlantEqual: "⋡",
                                    NotSucceedsTilde: "≿̸",
                                    NotSuperset: "⊃⃒",
                                    NotSupersetEqual: "⊉",
                                    NotTilde: "≁",
                                    NotTildeEqual: "≄",
                                    NotTildeFullEqual: "≇",
                                    NotTildeTilde: "≉",
                                    NotVerticalBar: "∤",
                                    npar: "∦",
                                    nparallel: "∦",
                                    nparsl: "⫽⃥",
                                    npart: "∂̸",
                                    npolint: "⨔",
                                    npr: "⊀",
                                    nprcue: "⋠",
                                    npre: "⪯̸",
                                    nprec: "⊀",
                                    npreceq: "⪯̸",
                                    nrarr: "↛",
                                    nrArr: "⇏",
                                    nrarrc: "⤳̸",
                                    nrarrw: "↝̸",
                                    nrightarrow: "↛",
                                    nRightarrow: "⇏",
                                    nrtri: "⋫",
                                    nrtrie: "⋭",
                                    nsc: "⊁",
                                    nsccue: "⋡",
                                    nsce: "⪰̸",
                                    nscr: "𝓃",
                                    Nscr: "𝒩",
                                    nshortmid: "∤",
                                    nshortparallel: "∦",
                                    nsim: "≁",
                                    nsime: "≄",
                                    nsimeq: "≄",
                                    nsmid: "∤",
                                    nspar: "∦",
                                    nsqsube: "⋢",
                                    nsqsupe: "⋣",
                                    nsub: "⊄",
                                    nsube: "⊈",
                                    nsubE: "⫅̸",
                                    nsubset: "⊂⃒",
                                    nsubseteq: "⊈",
                                    nsubseteqq: "⫅̸",
                                    nsucc: "⊁",
                                    nsucceq: "⪰̸",
                                    nsup: "⊅",
                                    nsupe: "⊉",
                                    nsupE: "⫆̸",
                                    nsupset: "⊃⃒",
                                    nsupseteq: "⊉",
                                    nsupseteqq: "⫆̸",
                                    ntgl: "≹",
                                    ntilde: "ñ",
                                    Ntilde: "Ñ",
                                    ntlg: "≸",
                                    ntriangleleft: "⋪",
                                    ntrianglelefteq: "⋬",
                                    ntriangleright: "⋫",
                                    ntrianglerighteq: "⋭",
                                    nu: "ν",
                                    Nu: "Ν",
                                    num: "#",
                                    numero: "№",
                                    numsp: " ",
                                    nvap: "≍⃒",
                                    nvdash: "⊬",
                                    nvDash: "⊭",
                                    nVdash: "⊮",
                                    nVDash: "⊯",
                                    nvge: "≥⃒",
                                    nvgt: ">⃒",
                                    nvHarr: "⤄",
                                    nvinfin: "⧞",
                                    nvlArr: "⤂",
                                    nvle: "≤⃒",
                                    nvlt: "<⃒",
                                    nvltrie: "⊴⃒",
                                    nvrArr: "⤃",
                                    nvrtrie: "⊵⃒",
                                    nvsim: "∼⃒",
                                    nwarhk: "⤣",
                                    nwarr: "↖",
                                    nwArr: "⇖",
                                    nwarrow: "↖",
                                    nwnear: "⤧",
                                    oacute: "ó",
                                    Oacute: "Ó",
                                    oast: "⊛",
                                    ocir: "⊚",
                                    ocirc: "ô",
                                    Ocirc: "Ô",
                                    ocy: "о",
                                    Ocy: "О",
                                    odash: "⊝",
                                    odblac: "ő",
                                    Odblac: "Ő",
                                    odiv: "⨸",
                                    odot: "⊙",
                                    odsold: "⦼",
                                    oelig: "œ",
                                    OElig: "Œ",
                                    ofcir: "⦿",
                                    ofr: "𝔬",
                                    Ofr: "𝔒",
                                    ogon: "˛",
                                    ograve: "ò",
                                    Ograve: "Ò",
                                    ogt: "⧁",
                                    ohbar: "⦵",
                                    ohm: "Ω",
                                    oint: "∮",
                                    olarr: "↺",
                                    olcir: "⦾",
                                    olcross: "⦻",
                                    oline: "‾",
                                    olt: "⧀",
                                    omacr: "ō",
                                    Omacr: "Ō",
                                    omega: "ω",
                                    Omega: "Ω",
                                    omicron: "ο",
                                    Omicron: "Ο",
                                    omid: "⦶",
                                    ominus: "⊖",
                                    oopf: "𝕠",
                                    Oopf: "𝕆",
                                    opar: "⦷",
                                    OpenCurlyDoubleQuote: "“",
                                    OpenCurlyQuote: "‘",
                                    operp: "⦹",
                                    oplus: "⊕",
                                    or: "∨",
                                    Or: "⩔",
                                    orarr: "↻",
                                    ord: "⩝",
                                    order: "ℴ",
                                    orderof: "ℴ",
                                    ordf: "ª",
                                    ordm: "º",
                                    origof: "⊶",
                                    oror: "⩖",
                                    orslope: "⩗",
                                    orv: "⩛",
                                    oS: "Ⓢ",
                                    oscr: "ℴ",
                                    Oscr: "𝒪",
                                    oslash: "ø",
                                    Oslash: "Ø",
                                    osol: "⊘",
                                    otilde: "õ",
                                    Otilde: "Õ",
                                    otimes: "⊗",
                                    Otimes: "⨷",
                                    otimesas: "⨶",
                                    ouml: "ö",
                                    Ouml: "Ö",
                                    ovbar: "⌽",
                                    OverBar: "‾",
                                    OverBrace: "⏞",
                                    OverBracket: "⎴",
                                    OverParenthesis: "⏜",
                                    par: "∥",
                                    para: "¶",
                                    parallel: "∥",
                                    parsim: "⫳",
                                    parsl: "⫽",
                                    part: "∂",
                                    PartialD: "∂",
                                    pcy: "п",
                                    Pcy: "П",
                                    percnt: "%",
                                    period: ".",
                                    permil: "‰",
                                    perp: "⊥",
                                    pertenk: "‱",
                                    pfr: "𝔭",
                                    Pfr: "𝔓",
                                    phi: "φ",
                                    Phi: "Φ",
                                    phiv: "ϕ",
                                    phmmat: "ℳ",
                                    phone: "☎",
                                    pi: "π",
                                    Pi: "Π",
                                    pitchfork: "⋔",
                                    piv: "ϖ",
                                    planck: "ℏ",
                                    planckh: "ℎ",
                                    plankv: "ℏ",
                                    plus: "+",
                                    plusacir: "⨣",
                                    plusb: "⊞",
                                    pluscir: "⨢",
                                    plusdo: "∔",
                                    plusdu: "⨥",
                                    pluse: "⩲",
                                    PlusMinus: "±",
                                    plusmn: "±",
                                    plussim: "⨦",
                                    plustwo: "⨧",
                                    pm: "±",
                                    Poincareplane: "ℌ",
                                    pointint: "⨕",
                                    popf: "𝕡",
                                    Popf: "ℙ",
                                    pound: "£",
                                    pr: "≺",
                                    Pr: "⪻",
                                    prap: "⪷",
                                    prcue: "≼",
                                    pre: "⪯",
                                    prE: "⪳",
                                    prec: "≺",
                                    precapprox: "⪷",
                                    preccurlyeq: "≼",
                                    Precedes: "≺",
                                    PrecedesEqual: "⪯",
                                    PrecedesSlantEqual: "≼",
                                    PrecedesTilde: "≾",
                                    preceq: "⪯",
                                    precnapprox: "⪹",
                                    precneqq: "⪵",
                                    precnsim: "⋨",
                                    precsim: "≾",
                                    prime: "′",
                                    Prime: "″",
                                    primes: "ℙ",
                                    prnap: "⪹",
                                    prnE: "⪵",
                                    prnsim: "⋨",
                                    prod: "∏",
                                    Product: "∏",
                                    profalar: "⌮",
                                    profline: "⌒",
                                    profsurf: "⌓",
                                    prop: "∝",
                                    Proportion: "∷",
                                    Proportional: "∝",
                                    propto: "∝",
                                    prsim: "≾",
                                    prurel: "⊰",
                                    pscr: "𝓅",
                                    Pscr: "𝒫",
                                    psi: "ψ",
                                    Psi: "Ψ",
                                    puncsp: " ",
                                    qfr: "𝔮",
                                    Qfr: "𝔔",
                                    qint: "⨌",
                                    qopf: "𝕢",
                                    Qopf: "ℚ",
                                    qprime: "⁗",
                                    qscr: "𝓆",
                                    Qscr: "𝒬",
                                    quaternions: "ℍ",
                                    quatint: "⨖",
                                    quest: "?",
                                    questeq: "≟",
                                    quot: '"',
                                    QUOT: '"',
                                    rAarr: "⇛",
                                    race: "∽̱",
                                    racute: "ŕ",
                                    Racute: "Ŕ",
                                    radic: "√",
                                    raemptyv: "⦳",
                                    rang: "⟩",
                                    Rang: "⟫",
                                    rangd: "⦒",
                                    range: "⦥",
                                    rangle: "⟩",
                                    raquo: "»",
                                    rarr: "→",
                                    rArr: "⇒",
                                    Rarr: "↠",
                                    rarrap: "⥵",
                                    rarrb: "⇥",
                                    rarrbfs: "⤠",
                                    rarrc: "⤳",
                                    rarrfs: "⤞",
                                    rarrhk: "↪",
                                    rarrlp: "↬",
                                    rarrpl: "⥅",
                                    rarrsim: "⥴",
                                    rarrtl: "↣",
                                    Rarrtl: "⤖",
                                    rarrw: "↝",
                                    ratail: "⤚",
                                    rAtail: "⤜",
                                    ratio: "∶",
                                    rationals: "ℚ",
                                    rbarr: "⤍",
                                    rBarr: "⤏",
                                    RBarr: "⤐",
                                    rbbrk: "❳",
                                    rbrace: "}",
                                    rbrack: "]",
                                    rbrke: "⦌",
                                    rbrksld: "⦎",
                                    rbrkslu: "⦐",
                                    rcaron: "ř",
                                    Rcaron: "Ř",
                                    rcedil: "ŗ",
                                    Rcedil: "Ŗ",
                                    rceil: "⌉",
                                    rcub: "}",
                                    rcy: "р",
                                    Rcy: "Р",
                                    rdca: "⤷",
                                    rdldhar: "⥩",
                                    rdquo: "”",
                                    rdquor: "”",
                                    rdsh: "↳",
                                    Re: "ℜ",
                                    real: "ℜ",
                                    realine: "ℛ",
                                    realpart: "ℜ",
                                    reals: "ℝ",
                                    rect: "▭",
                                    reg: "®",
                                    REG: "®",
                                    ReverseElement: "∋",
                                    ReverseEquilibrium: "⇋",
                                    ReverseUpEquilibrium: "⥯",
                                    rfisht: "⥽",
                                    rfloor: "⌋",
                                    rfr: "𝔯",
                                    Rfr: "ℜ",
                                    rHar: "⥤",
                                    rhard: "⇁",
                                    rharu: "⇀",
                                    rharul: "⥬",
                                    rho: "ρ",
                                    Rho: "Ρ",
                                    rhov: "ϱ",
                                    RightAngleBracket: "⟩",
                                    rightarrow: "→",
                                    Rightarrow: "⇒",
                                    RightArrow: "→",
                                    RightArrowBar: "⇥",
                                    RightArrowLeftArrow: "⇄",
                                    rightarrowtail: "↣",
                                    RightCeiling: "⌉",
                                    RightDoubleBracket: "⟧",
                                    RightDownTeeVector: "⥝",
                                    RightDownVector: "⇂",
                                    RightDownVectorBar: "⥕",
                                    RightFloor: "⌋",
                                    rightharpoondown: "⇁",
                                    rightharpoonup: "⇀",
                                    rightleftarrows: "⇄",
                                    rightleftharpoons: "⇌",
                                    rightrightarrows: "⇉",
                                    rightsquigarrow: "↝",
                                    RightTee: "⊢",
                                    RightTeeArrow: "↦",
                                    RightTeeVector: "⥛",
                                    rightthreetimes: "⋌",
                                    RightTriangle: "⊳",
                                    RightTriangleBar: "⧐",
                                    RightTriangleEqual: "⊵",
                                    RightUpDownVector: "⥏",
                                    RightUpTeeVector: "⥜",
                                    RightUpVector: "↾",
                                    RightUpVectorBar: "⥔",
                                    RightVector: "⇀",
                                    RightVectorBar: "⥓",
                                    ring: "˚",
                                    risingdotseq: "≓",
                                    rlarr: "⇄",
                                    rlhar: "⇌",
                                    rlm: "‏",
                                    rmoust: "⎱",
                                    rmoustache: "⎱",
                                    rnmid: "⫮",
                                    roang: "⟭",
                                    roarr: "⇾",
                                    robrk: "⟧",
                                    ropar: "⦆",
                                    ropf: "𝕣",
                                    Ropf: "ℝ",
                                    roplus: "⨮",
                                    rotimes: "⨵",
                                    RoundImplies: "⥰",
                                    rpar: ")",
                                    rpargt: "⦔",
                                    rppolint: "⨒",
                                    rrarr: "⇉",
                                    Rrightarrow: "⇛",
                                    rsaquo: "›",
                                    rscr: "𝓇",
                                    Rscr: "ℛ",
                                    rsh: "↱",
                                    Rsh: "↱",
                                    rsqb: "]",
                                    rsquo: "’",
                                    rsquor: "’",
                                    rthree: "⋌",
                                    rtimes: "⋊",
                                    rtri: "▹",
                                    rtrie: "⊵",
                                    rtrif: "▸",
                                    rtriltri: "⧎",
                                    RuleDelayed: "⧴",
                                    ruluhar: "⥨",
                                    rx: "℞",
                                    sacute: "ś",
                                    Sacute: "Ś",
                                    sbquo: "‚",
                                    sc: "≻",
                                    Sc: "⪼",
                                    scap: "⪸",
                                    scaron: "š",
                                    Scaron: "Š",
                                    sccue: "≽",
                                    sce: "⪰",
                                    scE: "⪴",
                                    scedil: "ş",
                                    Scedil: "Ş",
                                    scirc: "ŝ",
                                    Scirc: "Ŝ",
                                    scnap: "⪺",
                                    scnE: "⪶",
                                    scnsim: "⋩",
                                    scpolint: "⨓",
                                    scsim: "≿",
                                    scy: "с",
                                    Scy: "С",
                                    sdot: "⋅",
                                    sdotb: "⊡",
                                    sdote: "⩦",
                                    searhk: "⤥",
                                    searr: "↘",
                                    seArr: "⇘",
                                    searrow: "↘",
                                    sect: "§",
                                    semi: ";",
                                    seswar: "⤩",
                                    setminus: "∖",
                                    setmn: "∖",
                                    sext: "✶",
                                    sfr: "𝔰",
                                    Sfr: "𝔖",
                                    sfrown: "⌢",
                                    sharp: "♯",
                                    shchcy: "щ",
                                    SHCHcy: "Щ",
                                    shcy: "ш",
                                    SHcy: "Ш",
                                    ShortDownArrow: "↓",
                                    ShortLeftArrow: "←",
                                    shortmid: "∣",
                                    shortparallel: "∥",
                                    ShortRightArrow: "→",
                                    ShortUpArrow: "↑",
                                    shy: "­",
                                    sigma: "σ",
                                    Sigma: "Σ",
                                    sigmaf: "ς",
                                    sigmav: "ς",
                                    sim: "∼",
                                    simdot: "⩪",
                                    sime: "≃",
                                    simeq: "≃",
                                    simg: "⪞",
                                    simgE: "⪠",
                                    siml: "⪝",
                                    simlE: "⪟",
                                    simne: "≆",
                                    simplus: "⨤",
                                    simrarr: "⥲",
                                    slarr: "←",
                                    SmallCircle: "∘",
                                    smallsetminus: "∖",
                                    smashp: "⨳",
                                    smeparsl: "⧤",
                                    smid: "∣",
                                    smile: "⌣",
                                    smt: "⪪",
                                    smte: "⪬",
                                    smtes: "⪬︀",
                                    softcy: "ь",
                                    SOFTcy: "Ь",
                                    sol: "/",
                                    solb: "⧄",
                                    solbar: "⌿",
                                    sopf: "𝕤",
                                    Sopf: "𝕊",
                                    spades: "♠",
                                    spadesuit: "♠",
                                    spar: "∥",
                                    sqcap: "⊓",
                                    sqcaps: "⊓︀",
                                    sqcup: "⊔",
                                    sqcups: "⊔︀",
                                    Sqrt: "√",
                                    sqsub: "⊏",
                                    sqsube: "⊑",
                                    sqsubset: "⊏",
                                    sqsubseteq: "⊑",
                                    sqsup: "⊐",
                                    sqsupe: "⊒",
                                    sqsupset: "⊐",
                                    sqsupseteq: "⊒",
                                    squ: "□",
                                    square: "□",
                                    Square: "□",
                                    SquareIntersection: "⊓",
                                    SquareSubset: "⊏",
                                    SquareSubsetEqual: "⊑",
                                    SquareSuperset: "⊐",
                                    SquareSupersetEqual: "⊒",
                                    SquareUnion: "⊔",
                                    squarf: "▪",
                                    squf: "▪",
                                    srarr: "→",
                                    sscr: "𝓈",
                                    Sscr: "𝒮",
                                    ssetmn: "∖",
                                    ssmile: "⌣",
                                    sstarf: "⋆",
                                    star: "☆",
                                    Star: "⋆",
                                    starf: "★",
                                    straightepsilon: "ϵ",
                                    straightphi: "ϕ",
                                    strns: "¯",
                                    sub: "⊂",
                                    Sub: "⋐",
                                    subdot: "⪽",
                                    sube: "⊆",
                                    subE: "⫅",
                                    subedot: "⫃",
                                    submult: "⫁",
                                    subne: "⊊",
                                    subnE: "⫋",
                                    subplus: "⪿",
                                    subrarr: "⥹",
                                    subset: "⊂",
                                    Subset: "⋐",
                                    subseteq: "⊆",
                                    subseteqq: "⫅",
                                    SubsetEqual: "⊆",
                                    subsetneq: "⊊",
                                    subsetneqq: "⫋",
                                    subsim: "⫇",
                                    subsub: "⫕",
                                    subsup: "⫓",
                                    succ: "≻",
                                    succapprox: "⪸",
                                    succcurlyeq: "≽",
                                    Succeeds: "≻",
                                    SucceedsEqual: "⪰",
                                    SucceedsSlantEqual: "≽",
                                    SucceedsTilde: "≿",
                                    succeq: "⪰",
                                    succnapprox: "⪺",
                                    succneqq: "⪶",
                                    succnsim: "⋩",
                                    succsim: "≿",
                                    SuchThat: "∋",
                                    sum: "∑",
                                    Sum: "∑",
                                    sung: "♪",
                                    sup: "⊃",
                                    Sup: "⋑",
                                    sup1: "¹",
                                    sup2: "²",
                                    sup3: "³",
                                    supdot: "⪾",
                                    supdsub: "⫘",
                                    supe: "⊇",
                                    supE: "⫆",
                                    supedot: "⫄",
                                    Superset: "⊃",
                                    SupersetEqual: "⊇",
                                    suphsol: "⟉",
                                    suphsub: "⫗",
                                    suplarr: "⥻",
                                    supmult: "⫂",
                                    supne: "⊋",
                                    supnE: "⫌",
                                    supplus: "⫀",
                                    supset: "⊃",
                                    Supset: "⋑",
                                    supseteq: "⊇",
                                    supseteqq: "⫆",
                                    supsetneq: "⊋",
                                    supsetneqq: "⫌",
                                    supsim: "⫈",
                                    supsub: "⫔",
                                    supsup: "⫖",
                                    swarhk: "⤦",
                                    swarr: "↙",
                                    swArr: "⇙",
                                    swarrow: "↙",
                                    swnwar: "⤪",
                                    szlig: "ß",
                                    Tab: "\t",
                                    target: "⌖",
                                    tau: "τ",
                                    Tau: "Τ",
                                    tbrk: "⎴",
                                    tcaron: "ť",
                                    Tcaron: "Ť",
                                    tcedil: "ţ",
                                    Tcedil: "Ţ",
                                    tcy: "т",
                                    Tcy: "Т",
                                    tdot: "⃛",
                                    telrec: "⌕",
                                    tfr: "𝔱",
                                    Tfr: "𝔗",
                                    there4: "∴",
                                    therefore: "∴",
                                    Therefore: "∴",
                                    theta: "θ",
                                    Theta: "Θ",
                                    thetasym: "ϑ",
                                    thetav: "ϑ",
                                    thickapprox: "≈",
                                    thicksim: "∼",
                                    ThickSpace: "  ",
                                    thinsp: " ",
                                    ThinSpace: " ",
                                    thkap: "≈",
                                    thksim: "∼",
                                    thorn: "þ",
                                    THORN: "Þ",
                                    tilde: "˜",
                                    Tilde: "∼",
                                    TildeEqual: "≃",
                                    TildeFullEqual: "≅",
                                    TildeTilde: "≈",
                                    times: "×",
                                    timesb: "⊠",
                                    timesbar: "⨱",
                                    timesd: "⨰",
                                    tint: "∭",
                                    toea: "⤨",
                                    top: "⊤",
                                    topbot: "⌶",
                                    topcir: "⫱",
                                    topf: "𝕥",
                                    Topf: "𝕋",
                                    topfork: "⫚",
                                    tosa: "⤩",
                                    tprime: "‴",
                                    trade: "™",
                                    TRADE: "™",
                                    triangle: "▵",
                                    triangledown: "▿",
                                    triangleleft: "◃",
                                    trianglelefteq: "⊴",
                                    triangleq: "≜",
                                    triangleright: "▹",
                                    trianglerighteq: "⊵",
                                    tridot: "◬",
                                    trie: "≜",
                                    triminus: "⨺",
                                    TripleDot: "⃛",
                                    triplus: "⨹",
                                    trisb: "⧍",
                                    tritime: "⨻",
                                    trpezium: "⏢",
                                    tscr: "𝓉",
                                    Tscr: "𝒯",
                                    tscy: "ц",
                                    TScy: "Ц",
                                    tshcy: "ћ",
                                    TSHcy: "Ћ",
                                    tstrok: "ŧ",
                                    Tstrok: "Ŧ",
                                    twixt: "≬",
                                    twoheadleftarrow: "↞",
                                    twoheadrightarrow: "↠",
                                    uacute: "ú",
                                    Uacute: "Ú",
                                    uarr: "↑",
                                    uArr: "⇑",
                                    Uarr: "↟",
                                    Uarrocir: "⥉",
                                    ubrcy: "ў",
                                    Ubrcy: "Ў",
                                    ubreve: "ŭ",
                                    Ubreve: "Ŭ",
                                    ucirc: "û",
                                    Ucirc: "Û",
                                    ucy: "у",
                                    Ucy: "У",
                                    udarr: "⇅",
                                    udblac: "ű",
                                    Udblac: "Ű",
                                    udhar: "⥮",
                                    ufisht: "⥾",
                                    ufr: "𝔲",
                                    Ufr: "𝔘",
                                    ugrave: "ù",
                                    Ugrave: "Ù",
                                    uHar: "⥣",
                                    uharl: "↿",
                                    uharr: "↾",
                                    uhblk: "▀",
                                    ulcorn: "⌜",
                                    ulcorner: "⌜",
                                    ulcrop: "⌏",
                                    ultri: "◸",
                                    umacr: "ū",
                                    Umacr: "Ū",
                                    uml: "¨",
                                    UnderBar: "_",
                                    UnderBrace: "⏟",
                                    UnderBracket: "⎵",
                                    UnderParenthesis: "⏝",
                                    Union: "⋃",
                                    UnionPlus: "⊎",
                                    uogon: "ų",
                                    Uogon: "Ų",
                                    uopf: "𝕦",
                                    Uopf: "𝕌",
                                    uparrow: "↑",
                                    Uparrow: "⇑",
                                    UpArrow: "↑",
                                    UpArrowBar: "⤒",
                                    UpArrowDownArrow: "⇅",
                                    updownarrow: "↕",
                                    Updownarrow: "⇕",
                                    UpDownArrow: "↕",
                                    UpEquilibrium: "⥮",
                                    upharpoonleft: "↿",
                                    upharpoonright: "↾",
                                    uplus: "⊎",
                                    UpperLeftArrow: "↖",
                                    UpperRightArrow: "↗",
                                    upsi: "υ",
                                    Upsi: "ϒ",
                                    upsih: "ϒ",
                                    upsilon: "υ",
                                    Upsilon: "Υ",
                                    UpTee: "⊥",
                                    UpTeeArrow: "↥",
                                    upuparrows: "⇈",
                                    urcorn: "⌝",
                                    urcorner: "⌝",
                                    urcrop: "⌎",
                                    uring: "ů",
                                    Uring: "Ů",
                                    urtri: "◹",
                                    uscr: "𝓊",
                                    Uscr: "𝒰",
                                    utdot: "⋰",
                                    utilde: "ũ",
                                    Utilde: "Ũ",
                                    utri: "▵",
                                    utrif: "▴",
                                    uuarr: "⇈",
                                    uuml: "ü",
                                    Uuml: "Ü",
                                    uwangle: "⦧",
                                    vangrt: "⦜",
                                    varepsilon: "ϵ",
                                    varkappa: "ϰ",
                                    varnothing: "∅",
                                    varphi: "ϕ",
                                    varpi: "ϖ",
                                    varpropto: "∝",
                                    varr: "↕",
                                    vArr: "⇕",
                                    varrho: "ϱ",
                                    varsigma: "ς",
                                    varsubsetneq: "⊊︀",
                                    varsubsetneqq: "⫋︀",
                                    varsupsetneq: "⊋︀",
                                    varsupsetneqq: "⫌︀",
                                    vartheta: "ϑ",
                                    vartriangleleft: "⊲",
                                    vartriangleright: "⊳",
                                    vBar: "⫨",
                                    Vbar: "⫫",
                                    vBarv: "⫩",
                                    vcy: "в",
                                    Vcy: "В",
                                    vdash: "⊢",
                                    vDash: "⊨",
                                    Vdash: "⊩",
                                    VDash: "⊫",
                                    Vdashl: "⫦",
                                    vee: "∨",
                                    Vee: "⋁",
                                    veebar: "⊻",
                                    veeeq: "≚",
                                    vellip: "⋮",
                                    verbar: "|",
                                    Verbar: "‖",
                                    vert: "|",
                                    Vert: "‖",
                                    VerticalBar: "∣",
                                    VerticalLine: "|",
                                    VerticalSeparator: "❘",
                                    VerticalTilde: "≀",
                                    VeryThinSpace: " ",
                                    vfr: "𝔳",
                                    Vfr: "𝔙",
                                    vltri: "⊲",
                                    vnsub: "⊂⃒",
                                    vnsup: "⊃⃒",
                                    vopf: "𝕧",
                                    Vopf: "𝕍",
                                    vprop: "∝",
                                    vrtri: "⊳",
                                    vscr: "𝓋",
                                    Vscr: "𝒱",
                                    vsubne: "⊊︀",
                                    vsubnE: "⫋︀",
                                    vsupne: "⊋︀",
                                    vsupnE: "⫌︀",
                                    Vvdash: "⊪",
                                    vzigzag: "⦚",
                                    wcirc: "ŵ",
                                    Wcirc: "Ŵ",
                                    wedbar: "⩟",
                                    wedge: "∧",
                                    Wedge: "⋀",
                                    wedgeq: "≙",
                                    weierp: "℘",
                                    wfr: "𝔴",
                                    Wfr: "𝔚",
                                    wopf: "𝕨",
                                    Wopf: "𝕎",
                                    wp: "℘",
                                    wr: "≀",
                                    wreath: "≀",
                                    wscr: "𝓌",
                                    Wscr: "𝒲",
                                    xcap: "⋂",
                                    xcirc: "◯",
                                    xcup: "⋃",
                                    xdtri: "▽",
                                    xfr: "𝔵",
                                    Xfr: "𝔛",
                                    xharr: "⟷",
                                    xhArr: "⟺",
                                    xi: "ξ",
                                    Xi: "Ξ",
                                    xlarr: "⟵",
                                    xlArr: "⟸",
                                    xmap: "⟼",
                                    xnis: "⋻",
                                    xodot: "⨀",
                                    xopf: "𝕩",
                                    Xopf: "𝕏",
                                    xoplus: "⨁",
                                    xotime: "⨂",
                                    xrarr: "⟶",
                                    xrArr: "⟹",
                                    xscr: "𝓍",
                                    Xscr: "𝒳",
                                    xsqcup: "⨆",
                                    xuplus: "⨄",
                                    xutri: "△",
                                    xvee: "⋁",
                                    xwedge: "⋀",
                                    yacute: "ý",
                                    Yacute: "Ý",
                                    yacy: "я",
                                    YAcy: "Я",
                                    ycirc: "ŷ",
                                    Ycirc: "Ŷ",
                                    ycy: "ы",
                                    Ycy: "Ы",
                                    yen: "¥",
                                    yfr: "𝔶",
                                    Yfr: "𝔜",
                                    yicy: "ї",
                                    YIcy: "Ї",
                                    yopf: "𝕪",
                                    Yopf: "𝕐",
                                    yscr: "𝓎",
                                    Yscr: "𝒴",
                                    yucy: "ю",
                                    YUcy: "Ю",
                                    yuml: "ÿ",
                                    Yuml: "Ÿ",
                                    zacute: "ź",
                                    Zacute: "Ź",
                                    zcaron: "ž",
                                    Zcaron: "Ž",
                                    zcy: "з",
                                    Zcy: "З",
                                    zdot: "ż",
                                    Zdot: "Ż",
                                    zeetrf: "ℨ",
                                    ZeroWidthSpace: "​",
                                    zeta: "ζ",
                                    Zeta: "Ζ",
                                    zfr: "𝔷",
                                    Zfr: "ℨ",
                                    zhcy: "ж",
                                    ZHcy: "Ж",
                                    zigrarr: "⇝",
                                    zopf: "𝕫",
                                    Zopf: "ℤ",
                                    zscr: "𝓏",
                                    Zscr: "𝒵",
                                    zwj: "‍",
                                    zwnj: "‌",
                                },
                                v = {
                                    aacute: "á",
                                    Aacute: "Á",
                                    acirc: "â",
                                    Acirc: "Â",
                                    acute: "´",
                                    aelig: "æ",
                                    AElig: "Æ",
                                    agrave: "à",
                                    Agrave: "À",
                                    amp: "&",
                                    AMP: "&",
                                    aring: "å",
                                    Aring: "Å",
                                    atilde: "ã",
                                    Atilde: "Ã",
                                    auml: "ä",
                                    Auml: "Ä",
                                    brvbar: "¦",
                                    ccedil: "ç",
                                    Ccedil: "Ç",
                                    cedil: "¸",
                                    cent: "¢",
                                    copy: "©",
                                    COPY: "©",
                                    curren: "¤",
                                    deg: "°",
                                    divide: "÷",
                                    eacute: "é",
                                    Eacute: "É",
                                    ecirc: "ê",
                                    Ecirc: "Ê",
                                    egrave: "è",
                                    Egrave: "È",
                                    eth: "ð",
                                    ETH: "Ð",
                                    euml: "ë",
                                    Euml: "Ë",
                                    frac12: "½",
                                    frac14: "¼",
                                    frac34: "¾",
                                    gt: ">",
                                    GT: ">",
                                    iacute: "í",
                                    Iacute: "Í",
                                    icirc: "î",
                                    Icirc: "Î",
                                    iexcl: "¡",
                                    igrave: "ì",
                                    Igrave: "Ì",
                                    iquest: "¿",
                                    iuml: "ï",
                                    Iuml: "Ï",
                                    laquo: "«",
                                    lt: "<",
                                    LT: "<",
                                    macr: "¯",
                                    micro: "µ",
                                    middot: "·",
                                    nbsp: " ",
                                    not: "¬",
                                    ntilde: "ñ",
                                    Ntilde: "Ñ",
                                    oacute: "ó",
                                    Oacute: "Ó",
                                    ocirc: "ô",
                                    Ocirc: "Ô",
                                    ograve: "ò",
                                    Ograve: "Ò",
                                    ordf: "ª",
                                    ordm: "º",
                                    oslash: "ø",
                                    Oslash: "Ø",
                                    otilde: "õ",
                                    Otilde: "Õ",
                                    ouml: "ö",
                                    Ouml: "Ö",
                                    para: "¶",
                                    plusmn: "±",
                                    pound: "£",
                                    quot: '"',
                                    QUOT: '"',
                                    raquo: "»",
                                    reg: "®",
                                    REG: "®",
                                    sect: "§",
                                    shy: "­",
                                    sup1: "¹",
                                    sup2: "²",
                                    sup3: "³",
                                    szlig: "ß",
                                    thorn: "þ",
                                    THORN: "Þ",
                                    times: "×",
                                    uacute: "ú",
                                    Uacute: "Ú",
                                    ucirc: "û",
                                    Ucirc: "Û",
                                    ugrave: "ù",
                                    Ugrave: "Ù",
                                    uml: "¨",
                                    uuml: "ü",
                                    Uuml: "Ü",
                                    yacute: "ý",
                                    Yacute: "Ý",
                                    yen: "¥",
                                    yuml: "ÿ",
                                },
                                y = {
                                    0: "�",
                                    128: "€",
                                    130: "‚",
                                    131: "ƒ",
                                    132: "„",
                                    133: "…",
                                    134: "†",
                                    135: "‡",
                                    136: "ˆ",
                                    137: "‰",
                                    138: "Š",
                                    139: "‹",
                                    140: "Œ",
                                    142: "Ž",
                                    145: "‘",
                                    146: "’",
                                    147: "“",
                                    148: "”",
                                    149: "•",
                                    150: "–",
                                    151: "—",
                                    152: "˜",
                                    153: "™",
                                    154: "š",
                                    155: "›",
                                    156: "œ",
                                    158: "ž",
                                    159: "Ÿ",
                                },
                                b = [
                                    1,
                                    2,
                                    3,
                                    4,
                                    5,
                                    6,
                                    7,
                                    8,
                                    11,
                                    13,
                                    14,
                                    15,
                                    16,
                                    17,
                                    18,
                                    19,
                                    20,
                                    21,
                                    22,
                                    23,
                                    24,
                                    25,
                                    26,
                                    27,
                                    28,
                                    29,
                                    30,
                                    31,
                                    127,
                                    128,
                                    129,
                                    130,
                                    131,
                                    132,
                                    133,
                                    134,
                                    135,
                                    136,
                                    137,
                                    138,
                                    139,
                                    140,
                                    141,
                                    142,
                                    143,
                                    144,
                                    145,
                                    146,
                                    147,
                                    148,
                                    149,
                                    150,
                                    151,
                                    152,
                                    153,
                                    154,
                                    155,
                                    156,
                                    157,
                                    158,
                                    159,
                                    64976,
                                    64977,
                                    64978,
                                    64979,
                                    64980,
                                    64981,
                                    64982,
                                    64983,
                                    64984,
                                    64985,
                                    64986,
                                    64987,
                                    64988,
                                    64989,
                                    64990,
                                    64991,
                                    64992,
                                    64993,
                                    64994,
                                    64995,
                                    64996,
                                    64997,
                                    64998,
                                    64999,
                                    65e3,
                                    65001,
                                    65002,
                                    65003,
                                    65004,
                                    65005,
                                    65006,
                                    65007,
                                    65534,
                                    65535,
                                    131070,
                                    131071,
                                    196606,
                                    196607,
                                    262142,
                                    262143,
                                    327678,
                                    327679,
                                    393214,
                                    393215,
                                    458750,
                                    458751,
                                    524286,
                                    524287,
                                    589822,
                                    589823,
                                    655358,
                                    655359,
                                    720894,
                                    720895,
                                    786430,
                                    786431,
                                    851966,
                                    851967,
                                    917502,
                                    917503,
                                    983038,
                                    983039,
                                    1048574,
                                    1048575,
                                    1114110,
                                    1114111,
                                ],
                                w = String.fromCharCode,
                                x = {}.hasOwnProperty,
                                E = function (e, t) {
                                    return x.call(e, t);
                                },
                                C = function (e, t) {
                                    if (!e) return t;
                                    var n,
                                        r = {};
                                    for (n in t) r[n] = E(e, n) ? e[n] : t[n];
                                    return r;
                                },
                                S = function (e, t) {
                                    var n = "";
                                    return (e >= 55296 && e <= 57343) || e > 1114111
                                        ? (t && A("character reference outside the permissible Unicode range"), "�")
                                        : E(y, e)
                                        ? (t && A("disallowed character reference"), y[e])
                                        : (t &&
                                              (function (e, t) {
                                                  for (var n = -1, r = e.length; ++n < r; ) if (e[n] == t) return !0;
                                                  return !1;
                                              })(b, e) &&
                                              A("disallowed character reference"),
                                          e > 65535 && ((n += w((((e -= 65536) >>> 10) & 1023) | 55296)), (e = 56320 | (1023 & e))),
                                          (n += w(e)));
                                },
                                T = function (e) {
                                    return "&#x" + e.toString(16).toUpperCase() + ";";
                                },
                                k = function (e) {
                                    return "&#" + e + ";";
                                },
                                A = function (e) {
                                    throw Error("Parse error: " + e);
                                },
                                _ = function (e, t) {
                                    (t = C(t, _.options)).strict && f.test(e) && A("forbidden code point");
                                    var n = t.encodeEverything,
                                        r = t.useNamedReferences,
                                        i = t.allowUnsafeSymbols,
                                        o = t.decimal ? k : T,
                                        p = function (e) {
                                            return o(e.charCodeAt(0));
                                        };
                                    return (
                                        n
                                            ? ((e = e.replace(s, function (e) {
                                                  return r && E(u, e) ? "&" + u[e] + ";" : p(e);
                                              })),
                                              r &&
                                                  (e = e
                                                      .replace(/&gt;\u20D2/g, "&nvgt;")
                                                      .replace(/&lt;\u20D2/g, "&nvlt;")
                                                      .replace(/&#x66;&#x6A;/g, "&fjlig;")),
                                              r &&
                                                  (e = e.replace(c, function (e) {
                                                      return "&" + u[e] + ";";
                                                  })))
                                            : r
                                            ? (i ||
                                                  (e = e.replace(d, function (e) {
                                                      return "&" + u[e] + ";";
                                                  })),
                                              (e = (e = e.replace(/&gt;\u20D2/g, "&nvgt;").replace(/&lt;\u20D2/g, "&nvlt;")).replace(c, function (e) {
                                                  return "&" + u[e] + ";";
                                              })))
                                            : i || (e = e.replace(d, p)),
                                        e
                                            .replace(a, function (e) {
                                                var t = e.charCodeAt(0),
                                                    n = e.charCodeAt(1);
                                                return o(1024 * (t - 55296) + n - 56320 + 65536);
                                            })
                                            .replace(l, p)
                                    );
                                };
                            _.options = { allowUnsafeSymbols: !1, encodeEverything: !1, strict: !1, useNamedReferences: !1, decimal: !1 };
                            var L = function (e, t) {
                                var n = (t = C(t, L.options)).strict;
                                return (
                                    n && h.test(e) && A("malformed character reference"),
                                    e.replace(m, function (e, r, i, o, a, s, l, c, u) {
                                        var d, p, h, f, m, y;
                                        return r
                                            ? g[(m = r)]
                                            : i
                                            ? ((m = i),
                                              (y = o) && t.isAttributeValue ? (n && "=" == y && A("`&` did not start a character reference"), e) : (n && A("named character reference was not terminated by a semicolon"), v[m] + (y || "")))
                                            : a
                                            ? ((h = a), (p = s), n && !p && A("character reference was not terminated by a semicolon"), (d = parseInt(h, 10)), S(d, n))
                                            : l
                                            ? ((f = l), (p = c), n && !p && A("character reference was not terminated by a semicolon"), (d = parseInt(f, 16)), S(d, n))
                                            : (n && A("named character reference was not terminated by a semicolon"), e);
                                    })
                                );
                            };
                            L.options = { isAttributeValue: !1, strict: !1 };
                            var $ = {
                                version: "1.2.0",
                                encode: _,
                                decode: L,
                                escape: function (e) {
                                    return e.replace(d, function (e) {
                                        return p[e];
                                    });
                                },
                                unescape: L,
                            };
                            if (r && !r.nodeType)
                                if (i) i.exports = $;
                                else for (var D in $) E($, D) && (r[D] = $[D]);
                            else n.he = $;
                        })(vt);
                    });
                function bt(e, t, n) {
                    var r = n || {},
                        i = r.number,
                        o = "$$v",
                        a = o;
                    r.trim && (a = "(typeof $$v === 'string'? $$v.trim(): $$v)"), i && (a = "_n(" + a + ")");
                    var s = wt(t, a);
                    e.model = { value: "(" + t + ")", expression: JSON.stringify(t), callback: "function ($$v) {" + s + "}" };
                }
                function wt(e, t) {
                    var n = (function (e) {
                        if (((e = e.trim()), (lt = e.length), e.indexOf("[") < 0 || e.lastIndexOf("]") < lt - 1)) return (dt = e.lastIndexOf(".")) > -1 ? { exp: e.slice(0, dt), key: '"' + e.slice(dt + 1) + '"' } : { exp: e, key: null };
                        for (ct = e, dt = pt = ht = 0; !Et(); ) Ct((ut = xt())) ? Tt(ut) : 91 === ut && St(ut);
                        return { exp: e.slice(0, pt), key: e.slice(pt + 1, ht) };
                    })(e);
                    return null === n.key ? e + "=" + t : "$set(" + n.exp + ", " + n.key + ", " + t + ")";
                }
                function xt() {
                    return ct.charCodeAt(++dt);
                }
                function Et() {
                    return dt >= lt;
                }
                function Ct(e) {
                    return 34 === e || 39 === e;
                }
                function St(e) {
                    var t = 1;
                    for (pt = dt; !Et(); )
                        if (Ct((e = xt()))) Tt(e);
                        else if ((91 === e && t++, 93 === e && t--, 0 === t)) {
                            ht = dt;
                            break;
                        }
                }
                function Tt(e) {
                    for (var t = e; !Et() && (e = xt()) !== t; );
                }
                var kt,
                    At,
                    _t,
                    Lt,
                    $t,
                    Dt,
                    Ot,
                    qt,
                    Mt,
                    Pt = /^@|^v-on:/,
                    It = /^v-|^@|^:|^#/,
                    Nt = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,
                    zt = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/,
                    Rt = /^\(|\)$/g,
                    Ft = /^\[.*\]$/,
                    Bt = /:(.*)$/,
                    jt = /^:|^\.|^v-bind:/,
                    Ht = /\.[^.\]]+(?=[^\]]*$)/g,
                    Vt = /^v-slot(:|$)|^#/,
                    Wt = /[\r\n]/,
                    Ut = /\s+/g,
                    Gt = /[\s"'<>\/=]/,
                    Yt = f(yt.decode),
                    Xt = "_empty_";
                function Kt(e, t, n) {
                    return { type: 1, tag: e, attrsList: t, attrsMap: rn(t), rawAttrsMap: {}, parent: n, children: [] };
                }
                function Jt(e, t) {
                    (kt = t.warn || Xe), (Dt = t.isPreTag || x), (Ot = t.mustUseProp || x), (qt = t.getTagNamespace || x);
                    var n = t.isReservedTag || x;
                    (Mt = function (e) {
                        return !!e.component || !n(e.tag);
                    }),
                        (_t = Ke(t.modules, "transformNode")),
                        (Lt = Ke(t.modules, "preTransformNode")),
                        ($t = Ke(t.modules, "postTransformNode")),
                        (At = t.delimiters);
                    var r,
                        i,
                        o = [],
                        a = !1 !== t.preserveWhitespace,
                        s = t.whitespace,
                        l = !1,
                        c = !1,
                        u = !1;
                    function d(e, t) {
                        u || ((u = !0), kt(e, t));
                    }
                    function p(e) {
                        if (
                            (h(e),
                            l || e.processed || (e = Zt(e, t)),
                            o.length ||
                                e === r ||
                                (r.if && (e.elseif || e.else)
                                    ? (f(e), en(r, { exp: e.elseif, block: e }))
                                    : d("Component template should contain exactly one root element. If you are using v-if on multiple elements, use v-else-if to chain them instead.", { start: e.start })),
                            i && !e.forbidden)
                        )
                            if (e.elseif || e.else)
                                (a = e),
                                    (s = (function (e) {
                                        for (var t = e.length; t--; ) {
                                            if (1 === e[t].type) return e[t];
                                            " " !== e[t].text && kt('text "' + e[t].text.trim() + '" between v-if and v-else(-if) will be ignored.', e[t]), e.pop();
                                        }
                                    })(i.children)),
                                    s && s.if
                                        ? en(s, { exp: a.elseif, block: a })
                                        : kt("v-" + (a.elseif ? 'else-if="' + a.elseif + '"' : "else") + " used on element <" + a.tag + "> without corresponding v-if.", a.rawAttrsMap[a.elseif ? "v-else-if" : "v-else"]);
                            else {
                                if (e.slotScope) {
                                    var n = e.slotTarget || '"default"';
                                    (i.scopedSlots || (i.scopedSlots = {}))[n] = e;
                                }
                                i.children.push(e), (e.parent = i);
                            }
                        var a, s;
                        (e.children = e.children.filter(function (e) {
                            return !e.slotScope;
                        })),
                            h(e),
                            e.pre && (l = !1),
                            Dt(e.tag) && (c = !1);
                        for (var u = 0; u < $t.length; u++) $t[u](e, t);
                    }
                    function h(e) {
                        if (!c) for (var t; (t = e.children[e.children.length - 1]) && 3 === t.type && " " === t.text; ) e.children.pop();
                    }
                    function f(e) {
                        ("slot" !== e.tag && "template" !== e.tag) || d("Cannot use <" + e.tag + "> as component root element because it may contain multiple nodes.", { start: e.start }),
                            e.attrsMap.hasOwnProperty("v-for") && d("Cannot use v-for on stateful component root element because it renders multiple elements.", e.rawAttrsMap["v-for"]);
                    }
                    return (
                        V(e, {
                            warn: kt,
                            expectHTML: t.expectHTML,
                            isUnaryTag: t.isUnaryTag,
                            canBeLeftOpenTag: t.canBeLeftOpenTag,
                            shouldDecodeNewlines: t.shouldDecodeNewlines,
                            shouldDecodeNewlinesForHref: t.shouldDecodeNewlinesForHref,
                            shouldKeepComment: t.comments,
                            outputSourceRange: t.outputSourceRange,
                            start: function (e, n, a, s, u) {
                                var d = (i && i.ns) || qt(e);
                                Q &&
                                    "svg" === d &&
                                    (n = (function (e) {
                                        for (var t = [], n = 0; n < e.length; n++) {
                                            var r = e[n];
                                            on.test(r.name) || ((r.name = r.name.replace(an, "")), t.push(r));
                                        }
                                        return t;
                                    })(n));
                                var h,
                                    m = Kt(e, n, i);
                                d && (m.ns = d),
                                    t.outputSourceRange &&
                                        ((m.start = s),
                                        (m.end = u),
                                        (m.rawAttrsMap = m.attrsList.reduce(function (e, t) {
                                            return (e[t.name] = t), e;
                                        }, {}))),
                                    n.forEach(function (e) {
                                        Gt.test(e.name) && kt("Invalid dynamic argument expression: attribute names cannot contain spaces, quotes, <, >, / or =.", { start: e.start + e.name.indexOf("["), end: e.start + e.name.length });
                                    }),
                                    ("style" !== (h = m).tag && ("script" !== h.tag || (h.attrsMap.type && "text/javascript" !== h.attrsMap.type))) ||
                                        re() ||
                                        ((m.forbidden = !0),
                                        kt("Templates should only be responsible for mapping the state to the UI. Avoid placing tags with side-effects in your templates, such as <" + e + ">, as they will not be parsed.", {
                                            start: m.start,
                                        }));
                                for (var g = 0; g < Lt.length; g++) m = Lt[g](m, t) || m;
                                l ||
                                    ((function (e) {
                                        null != ot(e, "v-pre") && (e.pre = !0);
                                    })(m),
                                    m.pre && (l = !0)),
                                    Dt(m.tag) && (c = !0),
                                    l
                                        ? (function (e) {
                                              var t = e.attrsList,
                                                  n = t.length;
                                              if (n)
                                                  for (var r = (e.attrs = new Array(n)), i = 0; i < n; i++)
                                                      (r[i] = { name: t[i].name, value: JSON.stringify(t[i].value) }), null != t[i].start && ((r[i].start = t[i].start), (r[i].end = t[i].end));
                                              else e.pre || (e.plain = !0);
                                          })(m)
                                        : m.processed ||
                                          (Qt(m),
                                          (function (e) {
                                              var t = ot(e, "v-if");
                                              if (t) (e.if = t), en(e, { exp: t, block: e });
                                              else {
                                                  null != ot(e, "v-else") && (e.else = !0);
                                                  var n = ot(e, "v-else-if");
                                                  n && (e.elseif = n);
                                              }
                                          })(m),
                                          (function (e) {
                                              var t = ot(e, "v-once");
                                              null != t && (e.once = !0);
                                          })(m)),
                                    r || f((r = m)),
                                    a ? p(m) : ((i = m), o.push(m));
                            },
                            end: function (e, n, r) {
                                var a = o[o.length - 1];
                                (o.length -= 1), (i = o[o.length - 1]), t.outputSourceRange && (a.end = r), p(a);
                            },
                            chars: function (n, r, o) {
                                if (i) {
                                    if (!Q || "textarea" !== i.tag || i.attrsMap.placeholder !== n) {
                                        var u,
                                            p,
                                            h,
                                            f = i.children;
                                        (n = c || n.trim() ? ("script" === (u = i).tag || "style" === u.tag ? n : Yt(n)) : f.length ? (s ? ("condense" === s && Wt.test(n) ? "" : " ") : a ? " " : "") : "") &&
                                            (c || "condense" !== s || (n = n.replace(Ut, " ")),
                                            !l && " " !== n && (p = Ye(n, At)) ? (h = { type: 2, expression: p.expression, tokens: p.tokens, text: n }) : (" " === n && f.length && " " === f[f.length - 1].text) || (h = { type: 3, text: n }),
                                            h && (t.outputSourceRange && ((h.start = r), (h.end = o)), f.push(h)));
                                    }
                                } else n === e ? d("Component template requires a root element, rather than just text.", { start: r }) : (n = n.trim()) && d('text "' + n + '" outside root element will be ignored.', { start: r });
                            },
                            comment: function (e, n, r) {
                                if (i) {
                                    var o = { type: 3, text: e, isComment: !0 };
                                    t.outputSourceRange && ((o.start = n), (o.end = r)), i.children.push(o);
                                }
                            },
                        }),
                        r
                    );
                }
                function Zt(e, t) {
                    var n;
                    !(function (e) {
                        var t = it(e, "key");
                        if (t) {
                            if (("template" === e.tag && kt("<template> cannot be keyed. Place the key on real elements instead.", rt(e, "key")), e.for)) {
                                var n = e.iterator2 || e.iterator1,
                                    r = e.parent;
                                n && n === t && r && "transition-group" === r.tag && kt("Do not use v-for index as key on <transition-group> children, this is the same as not using keys.", rt(e, "key"), !0);
                            }
                            e.key = t;
                        }
                    })(e),
                        (e.plain = !e.key && !e.scopedSlots && !e.attrsList.length),
                        (function (e) {
                            var t = it(e, "ref");
                            t &&
                                ((e.ref = t),
                                (e.refInFor = (function (e) {
                                    for (var t = e; t; ) {
                                        if (void 0 !== t.for) return !0;
                                        t = t.parent;
                                    }
                                    return !1;
                                })(e)));
                        })(e),
                        (function (e) {
                            var t;
                            "template" === e.tag
                                ? ((t = ot(e, "scope")) &&
                                      kt(
                                          'the "scope" attribute for scoped slots have been deprecated and replaced by "slot-scope" since 2.5. The new "slot-scope" attribute can also be used on plain elements in addition to <template> to denote scoped slots.',
                                          e.rawAttrsMap.scope,
                                          !0
                                      ),
                                  (e.slotScope = t || ot(e, "slot-scope")))
                                : (t = ot(e, "slot-scope")) &&
                                  (e.attrsMap["v-for"] &&
                                      kt(
                                          "Ambiguous combined usage of slot-scope and v-for on <" + e.tag + "> (v-for takes higher priority). Use a wrapper <template> for the scoped slot to make it clearer.",
                                          e.rawAttrsMap["slot-scope"],
                                          !0
                                      ),
                                  (e.slotScope = t));
                            var n = it(e, "slot");
                            if (
                                (n && ((e.slotTarget = '""' === n ? '"default"' : n), (e.slotTargetDynamic = !(!e.attrsMap[":slot"] && !e.attrsMap["v-bind:slot"])), "template" === e.tag || e.slotScope || Ze(e, "slot", n, rt(e, "slot"))),
                                "template" === e.tag)
                            ) {
                                var r = at(e, Vt);
                                if (r) {
                                    (e.slotTarget || e.slotScope) && kt("Unexpected mixed usage of different slot syntaxes.", e),
                                        e.parent && !Mt(e.parent) && kt("<template v-slot> can only appear at the root level inside the receiving component", e);
                                    var i = tn(r),
                                        o = i.name,
                                        a = i.dynamic;
                                    (e.slotTarget = o), (e.slotTargetDynamic = a), (e.slotScope = r.value || Xt);
                                }
                            } else {
                                var s = at(e, Vt);
                                if (s) {
                                    Mt(e) || kt("v-slot can only be used on components or <template>.", s),
                                        (e.slotScope || e.slotTarget) && kt("Unexpected mixed usage of different slot syntaxes.", e),
                                        e.scopedSlots && kt("To avoid scope ambiguity, the default slot should also use <template> syntax when there are other named slots.", s);
                                    var l = e.scopedSlots || (e.scopedSlots = {}),
                                        c = tn(s),
                                        u = c.name,
                                        d = c.dynamic,
                                        p = (l[u] = Kt("template", [], e));
                                    (p.slotTarget = u),
                                        (p.slotTargetDynamic = d),
                                        (p.children = e.children.filter(function (e) {
                                            if (!e.slotScope) return (e.parent = p), !0;
                                        })),
                                        (p.slotScope = s.value || Xt),
                                        (e.children = []),
                                        (e.plain = !1);
                                }
                            }
                        })(e),
                        "slot" === (n = e).tag &&
                            ((n.slotName = it(n, "name")),
                            n.key && kt("`key` does not work on <slot> because slots are abstract outlets and can possibly expand into multiple elements. Use the key on a wrapping element instead.", rt(n, "key"))),
                        (function (e) {
                            var t;
                            (t = it(e, "is")) && (e.component = t), null != ot(e, "inline-template") && (e.inlineTemplate = !0);
                        })(e);
                    for (var r = 0; r < _t.length; r++) e = _t[r](e, t) || e;
                    return (
                        (function (e) {
                            var t,
                                n,
                                r,
                                i,
                                o,
                                a,
                                s,
                                l,
                                c = e.attrsList;
                            for (t = 0, n = c.length; t < n; t++)
                                if (((r = i = c[t].name), (o = c[t].value), It.test(r)))
                                    if (((e.hasBindings = !0), (a = nn(r.replace(It, ""))) && (r = r.replace(Ht, "")), jt.test(r)))
                                        (r = r.replace(jt, "")),
                                            (o = He(o)),
                                            (l = Ft.test(r)) && (r = r.slice(1, -1)),
                                            0 === o.trim().length && kt('The value for a v-bind expression cannot be empty. Found in "v-bind:' + r + '"'),
                                            a &&
                                                (a.prop && !l && "innerHtml" === (r = g(r)) && (r = "innerHTML"),
                                                a.camel && !l && (r = g(r)),
                                                a.sync &&
                                                    ((s = wt(o, "$event")),
                                                    l ? nt(e, '"update:"+(' + r + ")", s, null, !1, kt, c[t], !0) : (nt(e, "update:" + g(r), s, null, !1, kt, c[t]), y(r) !== g(r) && nt(e, "update:" + y(r), s, null, !1, kt, c[t])))),
                                            (a && a.prop) || (!e.component && Ot(e.tag, e.attrsMap.type, r)) ? Je(e, r, o, c[t], l) : Ze(e, r, o, c[t], l);
                                    else if (Pt.test(r)) (r = r.replace(Pt, "")), (l = Ft.test(r)) && (r = r.slice(1, -1)), nt(e, r, o, a, !1, kt, c[t], l);
                                    else {
                                        var u = (r = r.replace(It, "")).match(Bt),
                                            d = u && u[1];
                                        (l = !1), d && ((r = r.slice(0, -(d.length + 1))), Ft.test(d) && ((d = d.slice(1, -1)), (l = !0))), et(e, r, i, o, d, l, a, c[t]), "model" === r && sn(e, o);
                                    }
                                else
                                    Ye(o, At) && kt(r + '="' + o + '": Interpolation inside attributes has been removed. Use v-bind or the colon shorthand instead. For example, instead of <div id="{{ val }}">, use <div :id="val">.', c[t]),
                                        Ze(e, r, JSON.stringify(o), c[t]),
                                        !e.component && "muted" === r && Ot(e.tag, e.attrsMap.type, r) && Je(e, r, "true", c[t]);
                        })(e),
                        e
                    );
                }
                function Qt(e) {
                    var t;
                    if ((t = ot(e, "v-for"))) {
                        var n = (function (e) {
                            var t = e.match(Nt);
                            if (t) {
                                var n = {};
                                n.for = t[2].trim();
                                var r = t[1].trim().replace(Rt, ""),
                                    i = r.match(zt);
                                return i ? ((n.alias = r.replace(zt, "").trim()), (n.iterator1 = i[1].trim()), i[2] && (n.iterator2 = i[2].trim())) : (n.alias = r), n;
                            }
                        })(t);
                        n ? b(e, n) : kt("Invalid v-for expression: " + t, e.rawAttrsMap["v-for"]);
                    }
                }
                function en(e, t) {
                    e.ifConditions || (e.ifConditions = []), e.ifConditions.push(t);
                }
                function tn(e) {
                    var t = e.name.replace(Vt, "");
                    return t || ("#" !== e.name[0] ? (t = "default") : kt("v-slot shorthand syntax requires a slot name.", e)), Ft.test(t) ? { name: t.slice(1, -1), dynamic: !0 } : { name: '"' + t + '"', dynamic: !1 };
                }
                function nn(e) {
                    var t = e.match(Ht);
                    if (t) {
                        var n = {};
                        return (
                            t.forEach(function (e) {
                                n[e.slice(1)] = !0;
                            }),
                            n
                        );
                    }
                }
                function rn(e) {
                    for (var t = {}, n = 0, r = e.length; n < r; n++) !t[e[n].name] || Q || ee || kt("duplicate attribute: " + e[n].name, e[n]), (t[e[n].name] = e[n].value);
                    return t;
                }
                var on = /^xmlns:NS\d+/,
                    an = /^NS\d+:/;
                function sn(e, t) {
                    for (var n = e; n; )
                        n.for &&
                            n.alias === t &&
                            kt(
                                "<" +
                                    e.tag +
                                    ' v-model="' +
                                    t +
                                    '">: You are binding v-model directly to a v-for iteration alias. This will not be able to modify the v-for source array because writing to the alias is like modifying a function local variable. Consider using an array of objects and use v-model on an object property instead.',
                                e.rawAttrsMap["v-model"]
                            ),
                            (n = n.parent);
                }
                function ln(e) {
                    return Kt(e.tag, e.attrsList.slice(), e.parent);
                }
                var cn,
                    un,
                    dn,
                    pn = [
                        ft,
                        gt,
                        {
                            preTransformNode: function (e, t) {
                                if ("input" === e.tag) {
                                    var n,
                                        r = e.attrsMap;
                                    if (!r["v-model"]) return;
                                    if (((r[":type"] || r["v-bind:type"]) && (n = it(e, "type")), r.type || n || !r["v-bind"] || (n = "(" + r["v-bind"] + ").type"), n)) {
                                        var i = ot(e, "v-if", !0),
                                            o = i ? "&&(" + i + ")" : "",
                                            a = null != ot(e, "v-else", !0),
                                            s = ot(e, "v-else-if", !0),
                                            l = ln(e);
                                        Qt(l), Qe(l, "type", "checkbox"), Zt(l, t), (l.processed = !0), (l.if = "(" + n + ")==='checkbox'" + o), en(l, { exp: l.if, block: l });
                                        var c = ln(e);
                                        ot(c, "v-for", !0), Qe(c, "type", "radio"), Zt(c, t), en(l, { exp: "(" + n + ")==='radio'" + o, block: c });
                                        var u = ln(e);
                                        return ot(u, "v-for", !0), Qe(u, ":type", n), Zt(u, t), en(l, { exp: i, block: u }), a ? (l.else = !0) : s && (l.elseif = s), l;
                                    }
                                }
                            },
                        },
                    ],
                    hn = "__r",
                    fn = {
                        model: function (e, t, n) {
                            cn = n;
                            var r = t.value,
                                i = t.modifiers,
                                o = e.tag,
                                a = e.attrsMap.type;
                            if (("input" === o && "file" === a && cn("<" + e.tag + ' v-model="' + r + '" type="file">:\nFile inputs are read only. Use a v-on:change listener instead.', e.rawAttrsMap["v-model"]), e.component))
                                return bt(e, r, i), !1;
                            if ("select" === o)
                                !(function (e, t, n) {
                                    var r = n && n.number,
                                        i =
                                            'var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return ' +
                                            (r ? "_n(val)" : "val") +
                                            "});";
                                    (i = i + " " + wt(t, "$event.target.multiple ? $$selectedVal : $$selectedVal[0]")), nt(e, "change", i, null, !0);
                                })(e, r, i);
                            else if ("input" === o && "checkbox" === a)
                                !(function (e, t, n) {
                                    var r = n && n.number,
                                        i = it(e, "value") || "null",
                                        o = it(e, "true-value") || "true",
                                        a = it(e, "false-value") || "false";
                                    Je(e, "checked", "Array.isArray(" + t + ")?_i(" + t + "," + i + ")>-1" + ("true" === o ? ":(" + t + ")" : ":_q(" + t + "," + o + ")")),
                                        nt(
                                            e,
                                            "change",
                                            "var $$a=" +
                                                t +
                                                ",$$el=$event.target,$$c=$$el.checked?(" +
                                                o +
                                                "):(" +
                                                a +
                                                ");if(Array.isArray($$a)){var $$v=" +
                                                (r ? "_n(" + i + ")" : i) +
                                                ",$$i=_i($$a,$$v);if($$el.checked){$$i<0&&(" +
                                                wt(t, "$$a.concat([$$v])") +
                                                ")}else{$$i>-1&&(" +
                                                wt(t, "$$a.slice(0,$$i).concat($$a.slice($$i+1))") +
                                                ")}}else{" +
                                                wt(t, "$$c") +
                                                "}",
                                            null,
                                            !0
                                        );
                                })(e, r, i);
                            else if ("input" === o && "radio" === a)
                                !(function (e, t, n) {
                                    var r = n && n.number,
                                        i = it(e, "value") || "null";
                                    Je(e, "checked", "_q(" + t + "," + (i = r ? "_n(" + i + ")" : i) + ")"), nt(e, "change", wt(t, i), null, !0);
                                })(e, r, i);
                            else {
                                if ("input" !== o && "textarea" !== o) return bt(e, r, i), !1;
                                !(function (e, t, n) {
                                    var r = e.attrsMap.type,
                                        i = e.attrsMap["v-bind:value"] || e.attrsMap[":value"],
                                        o = e.attrsMap["v-bind:type"] || e.attrsMap[":type"];
                                    if (i && !o) {
                                        var a = e.attrsMap["v-bind:value"] ? "v-bind:value" : ":value";
                                        cn(a + '="' + i + '" conflicts with v-model on the same element because the latter already expands to a value binding internally', e.rawAttrsMap[a]);
                                    }
                                    var s = n || {},
                                        l = s.lazy,
                                        c = s.number,
                                        u = s.trim,
                                        d = !l && "range" !== r,
                                        p = l ? "change" : "range" === r ? hn : "input",
                                        h = "$event.target.value";
                                    u && (h = "$event.target.value.trim()"), c && (h = "_n(" + h + ")");
                                    var f = wt(t, h);
                                    d && (f = "if($event.target.composing)return;" + f), Je(e, "value", "(" + t + ")"), nt(e, p, f, null, !0), (u || c) && nt(e, "blur", "$forceUpdate()");
                                })(e, r, i);
                            }
                            return !0;
                        },
                        text: function (e, t) {
                            t.value && Je(e, "textContent", "_s(" + t.value + ")", t);
                        },
                        html: function (e, t) {
                            t.value && Je(e, "innerHTML", "_s(" + t.value + ")", t);
                        },
                    },
                    mn = {
                        expectHTML: !0,
                        modules: pn,
                        directives: fn,
                        isPreTag: function (e) {
                            return "pre" === e;
                        },
                        isUnaryTag: E,
                        mustUseProp: function (e, t, n) {
                            return ("value" === n && Ne(e) && "button" !== t) || ("selected" === n && "option" === e) || ("checked" === n && "input" === e) || ("muted" === n && "video" === e);
                        },
                        canBeLeftOpenTag: C,
                        isReservedTag: function (e) {
                            return Fe(e) || Be(e);
                        },
                        getTagNamespace: function (e) {
                            return Be(e) ? "svg" : "math" === e ? "math" : void 0;
                        },
                        staticKeys: (function (e) {
                            return e
                                .reduce(function (e, t) {
                                    return e.concat(t.staticKeys || []);
                                }, [])
                                .join(",");
                        })(pn),
                    },
                    gn = f(function (e) {
                        return u("type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap" + (e ? "," + e : ""));
                    });
                function vn(e, t) {
                    e && ((un = gn(t.staticKeys || "")), (dn = t.isReservedTag || x), yn(e), bn(e, !1));
                }
                function yn(e) {
                    if (
                        ((e.static = (function (e) {
                            return (
                                2 !== e.type &&
                                (3 === e.type ||
                                    !(
                                        !e.pre &&
                                        (e.hasBindings ||
                                            e.if ||
                                            e.for ||
                                            d(e.tag) ||
                                            !dn(e.tag) ||
                                            (function (e) {
                                                for (; e.parent; ) {
                                                    if ("template" !== (e = e.parent).tag) return !1;
                                                    if (e.for) return !0;
                                                }
                                                return !1;
                                            })(e) ||
                                            !Object.keys(e).every(un))
                                    ))
                            );
                        })(e)),
                        1 === e.type)
                    ) {
                        if (!dn(e.tag) && "slot" !== e.tag && null == e.attrsMap["inline-template"]) return;
                        for (var t = 0, n = e.children.length; t < n; t++) {
                            var r = e.children[t];
                            yn(r), r.static || (e.static = !1);
                        }
                        if (e.ifConditions)
                            for (var i = 1, o = e.ifConditions.length; i < o; i++) {
                                var a = e.ifConditions[i].block;
                                yn(a), a.static || (e.static = !1);
                            }
                    }
                }
                function bn(e, t) {
                    if (1 === e.type) {
                        if (((e.static || e.once) && (e.staticInFor = t), e.static && e.children.length && (1 !== e.children.length || 3 !== e.children[0].type))) return void (e.staticRoot = !0);
                        if (((e.staticRoot = !1), e.children)) for (var n = 0, r = e.children.length; n < r; n++) bn(e.children[n], t || !!e.for);
                        if (e.ifConditions) for (var i = 1, o = e.ifConditions.length; i < o; i++) bn(e.ifConditions[i].block, t);
                    }
                }
                var wn = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/,
                    xn = /\([^)]*?\);*$/,
                    En = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/,
                    Cn = { esc: 27, tab: 9, enter: 13, space: 32, up: 38, left: 37, right: 39, down: 40, delete: [8, 46] },
                    Sn = {
                        esc: ["Esc", "Escape"],
                        tab: "Tab",
                        enter: "Enter",
                        space: [" ", "Spacebar"],
                        up: ["Up", "ArrowUp"],
                        left: ["Left", "ArrowLeft"],
                        right: ["Right", "ArrowRight"],
                        down: ["Down", "ArrowDown"],
                        delete: ["Backspace", "Delete", "Del"],
                    },
                    Tn = function (e) {
                        return "if(" + e + ")return null;";
                    },
                    kn = {
                        stop: "$event.stopPropagation();",
                        prevent: "$event.preventDefault();",
                        self: Tn("$event.target !== $event.currentTarget"),
                        ctrl: Tn("!$event.ctrlKey"),
                        shift: Tn("!$event.shiftKey"),
                        alt: Tn("!$event.altKey"),
                        meta: Tn("!$event.metaKey"),
                        left: Tn("'button' in $event && $event.button !== 0"),
                        middle: Tn("'button' in $event && $event.button !== 1"),
                        right: Tn("'button' in $event && $event.button !== 2"),
                    };
                function An(e, t) {
                    var n = t ? "nativeOn:" : "on:",
                        r = "",
                        i = "";
                    for (var o in e) {
                        var a = _n(e[o]);
                        e[o] && e[o].dynamic ? (i += o + "," + a + ",") : (r += '"' + o + '":' + a + ",");
                    }
                    return (r = "{" + r.slice(0, -1) + "}"), i ? n + "_d(" + r + ",[" + i.slice(0, -1) + "])" : n + r;
                }
                function _n(e) {
                    if (!e) return "function(){}";
                    if (Array.isArray(e))
                        return (
                            "[" +
                            e
                                .map(function (e) {
                                    return _n(e);
                                })
                                .join(",") +
                            "]"
                        );
                    var t = En.test(e.value),
                        n = wn.test(e.value),
                        r = En.test(e.value.replace(xn, ""));
                    if (e.modifiers) {
                        var i = "",
                            o = "",
                            a = [];
                        for (var s in e.modifiers)
                            if (kn[s]) (o += kn[s]), Cn[s] && a.push(s);
                            else if ("exact" === s) {
                                var l = e.modifiers;
                                o += Tn(
                                    ["ctrl", "shift", "alt", "meta"]
                                        .filter(function (e) {
                                            return !l[e];
                                        })
                                        .map(function (e) {
                                            return "$event." + e + "Key";
                                        })
                                        .join("||")
                                );
                            } else a.push(s);
                        return (
                            a.length &&
                                (i += (function (e) {
                                    return "if(!$event.type.indexOf('key')&&" + e.map(Ln).join("&&") + ")return null;";
                                })(a)),
                            o && (i += o),
                            "function($event){" + i + (t ? "return " + e.value + "($event)" : n ? "return (" + e.value + ")($event)" : r ? "return " + e.value : e.value) + "}"
                        );
                    }
                    return t || n ? e.value : "function($event){" + (r ? "return " + e.value : e.value) + "}";
                }
                function Ln(e) {
                    var t = parseInt(e, 10);
                    if (t) return "$event.keyCode!==" + t;
                    var n = Cn[e],
                        r = Sn[e];
                    return "_k($event.keyCode," + JSON.stringify(e) + "," + JSON.stringify(n) + ",$event.key," + JSON.stringify(r) + ")";
                }
                var $n = {
                        on: function (e, t) {
                            t.modifiers && ce("v-on without argument does not support modifiers."),
                                (e.wrapListeners = function (e) {
                                    return "_g(" + e + "," + t.value + ")";
                                });
                        },
                        bind: function (e, t) {
                            e.wrapData = function (n) {
                                return "_b(" + n + ",'" + e.tag + "'," + t.value + "," + (t.modifiers && t.modifiers.prop ? "true" : "false") + (t.modifiers && t.modifiers.sync ? ",true" : "") + ")";
                            };
                        },
                        cloak: w,
                    },
                    Dn = function (e) {
                        (this.options = e), (this.warn = e.warn || Xe), (this.transforms = Ke(e.modules, "transformCode")), (this.dataGenFns = Ke(e.modules, "genData")), (this.directives = b(b({}, $n), e.directives));
                        var t = e.isReservedTag || x;
                        (this.maybeComponent = function (e) {
                            return !!e.component || !t(e.tag);
                        }),
                            (this.onceId = 0),
                            (this.staticRenderFns = []),
                            (this.pre = !1);
                    };
                function On(e, t) {
                    var n = new Dn(t);
                    return { render: "with(this){return " + (e ? qn(e, n) : '_c("div")') + "}", staticRenderFns: n.staticRenderFns };
                }
                function qn(e, t) {
                    if ((e.parent && (e.pre = e.pre || e.parent.pre), e.staticRoot && !e.staticProcessed)) return Mn(e, t);
                    if (e.once && !e.onceProcessed) return Pn(e, t);
                    if (e.for && !e.forProcessed) return zn(e, t);
                    if (e.if && !e.ifProcessed) return In(e, t);
                    if ("template" !== e.tag || e.slotTarget || t.pre) {
                        if ("slot" === e.tag)
                            return (function (e, t) {
                                var n = e.slotName || '"default"',
                                    r = jn(e, t),
                                    i = "_t(" + n + (r ? "," + r : ""),
                                    o =
                                        e.attrs || e.dynamicAttrs
                                            ? Un(
                                                  (e.attrs || []).concat(e.dynamicAttrs || []).map(function (e) {
                                                      return { name: g(e.name), value: e.value, dynamic: e.dynamic };
                                                  })
                                              )
                                            : null,
                                    a = e.attrsMap["v-bind"];
                                return (!o && !a) || r || (i += ",null"), o && (i += "," + o), a && (i += (o ? "" : ",null") + "," + a), i + ")";
                            })(e, t);
                        var n;
                        if (e.component)
                            n = (function (e, t, n) {
                                var r = t.inlineTemplate ? null : jn(t, n, !0);
                                return "_c(" + e + "," + Rn(t, n) + (r ? "," + r : "") + ")";
                            })(e.component, e, t);
                        else {
                            var r;
                            (!e.plain || (e.pre && t.maybeComponent(e))) && (r = Rn(e, t));
                            var i = e.inlineTemplate ? null : jn(e, t, !0);
                            n = "_c('" + e.tag + "'" + (r ? "," + r : "") + (i ? "," + i : "") + ")";
                        }
                        for (var o = 0; o < t.transforms.length; o++) n = t.transforms[o](e, n);
                        return n;
                    }
                    return jn(e, t) || "void 0";
                }
                function Mn(e, t) {
                    e.staticProcessed = !0;
                    var n = t.pre;
                    return e.pre && (t.pre = e.pre), t.staticRenderFns.push("with(this){return " + qn(e, t) + "}"), (t.pre = n), "_m(" + (t.staticRenderFns.length - 1) + (e.staticInFor ? ",true" : "") + ")";
                }
                function Pn(e, t) {
                    if (((e.onceProcessed = !0), e.if && !e.ifProcessed)) return In(e, t);
                    if (e.staticInFor) {
                        for (var n = "", r = e.parent; r; ) {
                            if (r.for) {
                                n = r.key;
                                break;
                            }
                            r = r.parent;
                        }
                        return n ? "_o(" + qn(e, t) + "," + t.onceId++ + "," + n + ")" : (t.warn("v-once can only be used inside v-for that is keyed. ", e.rawAttrsMap["v-once"]), qn(e, t));
                    }
                    return Mn(e, t);
                }
                function In(e, t, n, r) {
                    return (e.ifProcessed = !0), Nn(e.ifConditions.slice(), t, n, r);
                }
                function Nn(e, t, n, r) {
                    if (!e.length) return r || "_e()";
                    var i = e.shift();
                    return i.exp ? "(" + i.exp + ")?" + o(i.block) + ":" + Nn(e, t, n, r) : "" + o(i.block);
                    function o(e) {
                        return n ? n(e, t) : e.once ? Pn(e, t) : qn(e, t);
                    }
                }
                function zn(e, t, n, r) {
                    var i = e.for,
                        o = e.alias,
                        a = e.iterator1 ? "," + e.iterator1 : "",
                        s = e.iterator2 ? "," + e.iterator2 : "";
                    return (
                        t.maybeComponent(e) &&
                            "slot" !== e.tag &&
                            "template" !== e.tag &&
                            !e.key &&
                            t.warn("<" + e.tag + ' v-for="' + o + " in " + i + '">: component lists rendered with v-for should have explicit keys. See https://vuejs.org/guide/list.html#key for more info.', e.rawAttrsMap["v-for"], !0),
                        (e.forProcessed = !0),
                        (r || "_l") + "((" + i + "),function(" + o + a + s + "){return " + (n || qn)(e, t) + "})"
                    );
                }
                function Rn(e, t) {
                    var n = "{",
                        r = (function (e, t) {
                            var n = e.directives;
                            if (n) {
                                var r,
                                    i,
                                    o,
                                    a,
                                    s = "directives:[",
                                    l = !1;
                                for (r = 0, i = n.length; r < i; r++) {
                                    (o = n[r]), (a = !0);
                                    var c = t.directives[o.name];
                                    c && (a = !!c(e, o, t.warn)),
                                        a &&
                                            ((l = !0),
                                            (s +=
                                                '{name:"' +
                                                o.name +
                                                '",rawName:"' +
                                                o.rawName +
                                                '"' +
                                                (o.value ? ",value:(" + o.value + "),expression:" + JSON.stringify(o.value) : "") +
                                                (o.arg ? ",arg:" + (o.isDynamicArg ? o.arg : '"' + o.arg + '"') : "") +
                                                (o.modifiers ? ",modifiers:" + JSON.stringify(o.modifiers) : "") +
                                                "},"));
                                }
                                return l ? s.slice(0, -1) + "]" : void 0;
                            }
                        })(e, t);
                    r && (n += r + ","), e.key && (n += "key:" + e.key + ","), e.ref && (n += "ref:" + e.ref + ","), e.refInFor && (n += "refInFor:true,"), e.pre && (n += "pre:true,"), e.component && (n += 'tag:"' + e.tag + '",');
                    for (var i = 0; i < t.dataGenFns.length; i++) n += t.dataGenFns[i](e);
                    if (
                        (e.attrs && (n += "attrs:" + Un(e.attrs) + ","),
                        e.props && (n += "domProps:" + Un(e.props) + ","),
                        e.events && (n += An(e.events, !1) + ","),
                        e.nativeEvents && (n += An(e.nativeEvents, !0) + ","),
                        e.slotTarget && !e.slotScope && (n += "slot:" + e.slotTarget + ","),
                        e.scopedSlots &&
                            (n +=
                                (function (e, t, n) {
                                    var r =
                                            e.for ||
                                            Object.keys(t).some(function (e) {
                                                var n = t[e];
                                                return n.slotTargetDynamic || n.if || n.for || Fn(n);
                                            }),
                                        i = !!e.if;
                                    if (!r)
                                        for (var o = e.parent; o; ) {
                                            if ((o.slotScope && o.slotScope !== Xt) || o.for) {
                                                r = !0;
                                                break;
                                            }
                                            o.if && (i = !0), (o = o.parent);
                                        }
                                    var a = Object.keys(t)
                                        .map(function (e) {
                                            return Bn(t[e], n);
                                        })
                                        .join(",");
                                    return (
                                        "scopedSlots:_u([" +
                                        a +
                                        "]" +
                                        (r ? ",null,true" : "") +
                                        (!r && i
                                            ? ",null,false," +
                                              (function (e) {
                                                  for (var t = 5381, n = e.length; n; ) t = (33 * t) ^ e.charCodeAt(--n);
                                                  return t >>> 0;
                                              })(a)
                                            : "") +
                                        ")"
                                    );
                                })(e, e.scopedSlots, t) + ","),
                        e.model && (n += "model:{value:" + e.model.value + ",callback:" + e.model.callback + ",expression:" + e.model.expression + "},"),
                        e.inlineTemplate)
                    ) {
                        var o = (function (e, t) {
                            var n = e.children[0];
                            if (((1 === e.children.length && 1 === n.type) || t.warn("Inline-template components must have exactly one child element.", { start: e.start }), n && 1 === n.type)) {
                                var r = On(n, t.options);
                                return (
                                    "inlineTemplate:{render:function(){" +
                                    r.render +
                                    "},staticRenderFns:[" +
                                    r.staticRenderFns
                                        .map(function (e) {
                                            return "function(){" + e + "}";
                                        })
                                        .join(",") +
                                    "]}"
                                );
                            }
                        })(e, t);
                        o && (n += o + ",");
                    }
                    return (n = n.replace(/,$/, "") + "}"), e.dynamicAttrs && (n = "_b(" + n + ',"' + e.tag + '",' + Un(e.dynamicAttrs) + ")"), e.wrapData && (n = e.wrapData(n)), e.wrapListeners && (n = e.wrapListeners(n)), n;
                }
                function Fn(e) {
                    return 1 === e.type && ("slot" === e.tag || e.children.some(Fn));
                }
                function Bn(e, t) {
                    var n = e.attrsMap["slot-scope"];
                    if (e.if && !e.ifProcessed && !n) return In(e, t, Bn, "null");
                    if (e.for && !e.forProcessed) return zn(e, t, Bn);
                    var r = e.slotScope === Xt ? "" : String(e.slotScope),
                        i = "function(" + r + "){return " + ("template" === e.tag ? (e.if && n ? "(" + e.if + ")?" + (jn(e, t) || "undefined") + ":undefined" : jn(e, t) || "undefined") : qn(e, t)) + "}",
                        o = r ? "" : ",proxy:true";
                    return "{key:" + (e.slotTarget || '"default"') + ",fn:" + i + o + "}";
                }
                function jn(e, t, n, r, i) {
                    var o = e.children;
                    if (o.length) {
                        var a = o[0];
                        if (1 === o.length && a.for && "template" !== a.tag && "slot" !== a.tag) {
                            var s = n ? (t.maybeComponent(a) ? ",1" : ",0") : "";
                            return "" + (r || qn)(a, t) + s;
                        }
                        var l = n
                                ? (function (e, t) {
                                      for (var n = 0, r = 0; r < e.length; r++) {
                                          var i = e[r];
                                          if (1 === i.type) {
                                              if (
                                                  Hn(i) ||
                                                  (i.ifConditions &&
                                                      i.ifConditions.some(function (e) {
                                                          return Hn(e.block);
                                                      }))
                                              ) {
                                                  n = 2;
                                                  break;
                                              }
                                              (t(i) ||
                                                  (i.ifConditions &&
                                                      i.ifConditions.some(function (e) {
                                                          return t(e.block);
                                                      }))) &&
                                                  (n = 1);
                                          }
                                      }
                                      return n;
                                  })(o, t.maybeComponent)
                                : 0,
                            c = i || Vn;
                        return (
                            "[" +
                            o
                                .map(function (e) {
                                    return c(e, t);
                                })
                                .join(",") +
                            "]" +
                            (l ? "," + l : "")
                        );
                    }
                }
                function Hn(e) {
                    return void 0 !== e.for || "template" === e.tag || "slot" === e.tag;
                }
                function Vn(e, t) {
                    return 1 === e.type
                        ? qn(e, t)
                        : 3 === e.type && e.isComment
                        ? (function (e) {
                              return "_e(" + JSON.stringify(e.text) + ")";
                          })(e)
                        : Wn(e);
                }
                function Wn(e) {
                    return "_v(" + (2 === e.type ? e.expression : Gn(JSON.stringify(e.text))) + ")";
                }
                function Un(e) {
                    for (var t = "", n = "", r = 0; r < e.length; r++) {
                        var i = e[r],
                            o = Gn(i.value);
                        i.dynamic ? (n += i.name + "," + o + ",") : (t += '"' + i.name + '":' + o + ",");
                    }
                    return (t = "{" + t.slice(0, -1) + "}"), n ? "_d(" + t + ",[" + n.slice(0, -1) + "])" : t;
                }
                function Gn(e) {
                    return e.replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
                }
                var Yn = new RegExp(
                        "\\b" +
                            "do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,super,throw,while,yield,delete,export,import,return,switch,default,extends,finally,continue,debugger,function,arguments"
                                .split(",")
                                .join("\\b|\\b") +
                            "\\b"
                    ),
                    Xn = new RegExp("\\b" + "delete,typeof,void".split(",").join("\\s*\\([^\\)]*\\)|\\b") + "\\s*\\([^\\)]*\\)"),
                    Kn = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
                function Jn(e, t) {
                    e && Zn(e, t);
                }
                function Zn(e, t) {
                    if (1 === e.type) {
                        for (var n in e.attrsMap)
                            if (It.test(n)) {
                                var r = e.attrsMap[n];
                                if (r) {
                                    var i = e.rawAttrsMap[n];
                                    "v-for" === n ? er(e, 'v-for="' + r + '"', t, i) : "v-slot" === n || "#" === n[0] ? rr(r, n + '="' + r + '"', t, i) : Pt.test(n) ? Qn(r, n + '="' + r + '"', t, i) : nr(r, n + '="' + r + '"', t, i);
                                }
                            }
                        if (e.children) for (var o = 0; o < e.children.length; o++) Zn(e.children[o], t);
                    } else 2 === e.type && nr(e.expression, e.text, t, e);
                }
                function Qn(e, t, n, r) {
                    var i = e.replace(Kn, ""),
                        o = i.match(Xn);
                    o && "$" !== i.charAt(o.index - 1) && n('avoid using JavaScript unary operator as property name: "' + o[0] + '" in expression ' + t.trim(), r), nr(e, t, n, r);
                }
                function er(e, t, n, r) {
                    nr(e.for || "", t, n, r), tr(e.alias, "v-for alias", t, n, r), tr(e.iterator1, "v-for iterator", t, n, r), tr(e.iterator2, "v-for iterator", t, n, r);
                }
                function tr(e, t, n, r, i) {
                    if ("string" == typeof e)
                        try {
                            new Function("var " + e + "=_");
                        } catch (o) {
                            r("invalid " + t + ' "' + e + '" in expression: ' + n.trim(), i);
                        }
                }
                function nr(e, t, n, r) {
                    try {
                        new Function("return " + e);
                    } catch (o) {
                        var i = e.replace(Kn, "").match(Yn);
                        n(i ? 'avoid using JavaScript keyword as property name: "' + i[0] + '"\n  Raw expression: ' + t.trim() : "invalid expression: " + o.message + " in\n\n    " + e + "\n\n  Raw expression: " + t.trim() + "\n", r);
                    }
                }
                function rr(e, t, n, r) {
                    try {
                        new Function(e, "");
                    } catch (i) {
                        n("invalid function parameter expression: " + i.message + " in\n\n    " + e + "\n\n  Raw expression: " + t.trim() + "\n", r);
                    }
                }
                var ir = 2;
                function or(e, t, n) {
                    void 0 === t && (t = 0), void 0 === n && (n = e.length);
                    for (var r = e.split(/\r?\n/), i = 0, o = [], a = 0; a < r.length; a++)
                        if ((i += r[a].length + 1) >= t) {
                            for (var s = a - ir; s <= a + ir || n > i; s++)
                                if (!(s < 0 || s >= r.length)) {
                                    o.push("" + (s + 1) + ar(" ", 3 - String(s + 1).length) + "|  " + r[s]);
                                    var l = r[s].length;
                                    if (s === a) {
                                        var c = t - (i - l) + 1,
                                            u = n > i ? l - c : n - t;
                                        o.push("   |  " + ar(" ", c) + ar("^", u));
                                    } else if (s > a) {
                                        if (n > i) {
                                            var d = Math.min(n - i, l);
                                            o.push("   |  " + ar("^", d));
                                        }
                                        i += l + 1;
                                    }
                                }
                            break;
                        }
                    return o.join("\n");
                }
                function ar(e, t) {
                    var n = "";
                    if (t > 0) for (; 1 & t && (n += e), !((t >>>= 1) <= 0); ) e += e;
                    return n;
                }
                function sr(e, t) {
                    try {
                        return new Function(e);
                    } catch (n) {
                        return t.push({ err: n, code: e }), w;
                    }
                }
                function lr(e) {
                    var t = Object.create(null);
                    return function (n, r, i) {
                        var o = (r = b({}, r)).warn || ce;
                        delete r.warn;
                        try {
                            new Function("return 1");
                        } catch (e) {
                            e.toString().match(/unsafe-eval|CSP/) &&
                                o(
                                    "It seems you are using the standalone build of Vue.js in an environment with Content Security Policy that prohibits unsafe-eval. The template compiler cannot work in this environment. Consider relaxing the policy to allow unsafe-eval or pre-compiling your templates into render functions."
                                );
                        }
                        var a = r.delimiters ? String(r.delimiters) + n : n;
                        if (t[a]) return t[a];
                        var s = e(n, r);
                        s.errors &&
                            s.errors.length &&
                            (r.outputSourceRange
                                ? s.errors.forEach(function (e) {
                                      o("Error compiling template:\n\n" + e.msg + "\n\n" + or(n, e.start, e.end), i);
                                  })
                                : o(
                                      "Error compiling template:\n\n" +
                                          n +
                                          "\n\n" +
                                          s.errors
                                              .map(function (e) {
                                                  return "- " + e;
                                              })
                                              .join("\n") +
                                          "\n",
                                      i
                                  )),
                            s.tips &&
                                s.tips.length &&
                                (r.outputSourceRange
                                    ? s.tips.forEach(function (e) {
                                          return ue(e.msg, i);
                                      })
                                    : s.tips.forEach(function (e) {
                                          return ue(e, i);
                                      }));
                        var l = {},
                            c = [];
                        return (
                            (l.render = sr(s.render, c)),
                            (l.staticRenderFns = s.staticRenderFns.map(function (e) {
                                return sr(e, c);
                            })),
                            (s.errors && s.errors.length) ||
                                !c.length ||
                                o(
                                    "Failed to generate render function:\n\n" +
                                        c
                                            .map(function (e) {
                                                var t = e.err,
                                                    n = e.code;
                                                return t.toString() + " in\n\n" + n + "\n";
                                            })
                                            .join("\n"),
                                    i
                                ),
                            (t[a] = l)
                        );
                    };
                }
                function cr(e) {
                    return function (t) {
                        function n(n, r) {
                            var i = Object.create(t),
                                o = [],
                                a = [],
                                s = function (e, t, n) {
                                    (n ? a : o).push(e);
                                };
                            if (r) {
                                if (r.outputSourceRange) {
                                    var l = n.match(/^\s*/)[0].length;
                                    s = function (e, t, n) {
                                        var r = { msg: e };
                                        t && (null != t.start && (r.start = t.start + l), null != t.end && (r.end = t.end + l)), (n ? a : o).push(r);
                                    };
                                }
                                for (var c in (r.modules && (i.modules = (t.modules || []).concat(r.modules)), r.directives && (i.directives = b(Object.create(t.directives || null), r.directives)), r))
                                    "modules" !== c && "directives" !== c && (i[c] = r[c]);
                            }
                            i.warn = s;
                            var u = e(n.trim(), i);
                            return Jn(u.ast, s), (u.errors = o), (u.tips = a), u;
                        }
                        return { compile: n, compileToFunctions: lr(n) };
                    };
                }
                var ur = cr(function (e, t) {
                        var n = Jt(e.trim(), t);
                        !1 !== t.optimize && vn(n, t);
                        var r = On(n, t);
                        return { ast: n, render: r.render, staticRenderFns: r.staticRenderFns };
                    })(mn),
                    dr = ur.compile,
                    pr = ur.compileToFunctions,
                    hr = u(
                        "accept,accept-charset,accesskey,action,align,alt,async,autocomplete,autofocus,autoplay,autosave,bgcolor,border,buffered,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,data,datetime,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,for,form,formaction,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,ismap,itemprop,keytype,kind,label,lang,language,list,loop,low,manifest,max,maxlength,media,method,GET,POST,min,multiple,email,file,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,seamless,selected,shape,size,type,text,password,sizes,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,usemap,value,width,wrap"
                    ),
                    fr = function (e) {
                        return hr(e) || 0 === e.indexOf("data-") || 0 === e.indexOf("aria-");
                    },
                    mr = { acceptCharset: "accept-charset", className: "class", htmlFor: "for", httpEquiv: "http-equiv" },
                    gr = { "<": "&lt;", ">": "&gt;", '"': "&quot;", "&": "&amp;" };
                function vr(e) {
                    return e.replace(/[<>"&]/g, yr);
                }
                function yr(e) {
                    return gr[e] || e;
                }
                var br = /^"(?:[^"\\]|\\.)*"$|^'(?:[^'\\]|\\.)*'$/;
                function wr(e, t) {
                    return br.test(t)
                        ? ((t = t.replace(/^'|'$/g, '"')), ze(e) && '"false"' !== t && (t = '"true"'), { type: kr, value: Re(e) ? " " + e + '="' + e + '"' : '""' === t ? " " + e : " " + e + '="' + JSON.parse(t) + '"' })
                        : { type: _r, value: "_ssrAttr(" + JSON.stringify(e) + "," + t + ")" };
                }
                var xr,
                    Er = { FALSE: 0, FULL: 1, SELF: 2, CHILDREN: 3, PARTIAL: 4 };
                function Cr(e, t) {
                    e && ((xr = t.isReservedTag || x), Sr(e, !0));
                }
                function Sr(e, t) {
                    if (
                        (function (e) {
                            return (
                                2 !== e.type &&
                                3 !== e.type &&
                                (d(e.tag) ||
                                    !xr(e.tag) ||
                                    !!e.component ||
                                    (function (e) {
                                        return (
                                            1 === e.type &&
                                            "select" === e.tag &&
                                            null != e.directives &&
                                            e.directives.some(function (e) {
                                                return "model" === e.name;
                                            })
                                        );
                                    })(e))
                            );
                        })(e)
                    )
                        e.ssrOptimizability = Er.FALSE;
                    else {
                        var n =
                                t ||
                                (function (e) {
                                    return (
                                        1 === e.type &&
                                        e.directives &&
                                        e.directives.some(function (e) {
                                            return !Tr(e.name);
                                        })
                                    );
                                })(e),
                            r = function (t) {
                                t.ssrOptimizability !== Er.FULL && (e.ssrOptimizability = n ? Er.PARTIAL : Er.SELF);
                            };
                        if ((n && (e.ssrOptimizability = Er.CHILDREN), 1 === e.type)) {
                            for (var i = 0, o = e.children.length; i < o; i++) {
                                var a = e.children[i];
                                Sr(a), r(a);
                            }
                            if (e.ifConditions)
                                for (var s = 1, l = e.ifConditions.length; s < l; s++) {
                                    var c = e.ifConditions[s].block;
                                    Sr(c, t), r(c);
                                }
                            null == e.ssrOptimizability || (!t && (e.attrsMap["v-html"] || e.attrsMap["v-text"]))
                                ? (e.ssrOptimizability = Er.FULL)
                                : (e.children = (function (e) {
                                      for (
                                          var t = e.children,
                                              n = [],
                                              r = [],
                                              i = function () {
                                                  r.length && n.push({ type: 1, parent: e, tag: "template", attrsList: [], attrsMap: {}, rawAttrsMap: {}, children: r, ssrOptimizability: Er.FULL }), (r = []);
                                              },
                                              o = 0;
                                          o < t.length;
                                          o++
                                      ) {
                                          var a = t[o];
                                          a.ssrOptimizability === Er.FULL ? r.push(a) : (i(), n.push(a));
                                      }
                                      return i(), n;
                                  })(e));
                        } else e.ssrOptimizability = Er.FULL;
                    }
                }
                var Tr = u("text,html,show,on,bind,model,pre,cloak,once"),
                    kr = 0,
                    Ar = 1,
                    _r = 2;
                function Lr(e, t) {
                    if (e.for && !e.forProcessed) return zn(e, t, Lr);
                    if (e.if && !e.ifProcessed) return In(e, t, Lr);
                    if ("template" === e.tag && !e.slotTarget) return e.ssrOptimizability === Er.FULL ? qr(e, t) : Dr(e, t) || "void 0";
                    switch (e.ssrOptimizability) {
                        case Er.FULL:
                            return (function (e, t) {
                                return "_ssrNode(" + Mr(e, t) + ")";
                            })(e, t);
                        case Er.SELF:
                            return (function (e, t) {
                                var n = Dr(e, t, !0);
                                return "_ssrNode(" + zr(Ir(e, t)) + ',"</' + e.tag + '>"' + (n ? "," + n : "") + ")";
                            })(e, t);
                        case Er.CHILDREN:
                            return $r(e, t, !0);
                        case Er.PARTIAL:
                            return $r(e, t, !1);
                        default:
                            return qn(e, t);
                    }
                }
                function $r(e, t, n) {
                    var r = e.plain ? void 0 : Rn(e, t),
                        i = n ? "[" + qr(e, t) + "]" : Dr(e, t, !0);
                    return "_c('" + e.tag + "'" + (r ? "," + r : "") + (i ? "," + i : "") + ")";
                }
                function Dr(e, t, n) {
                    return jn(e, t, n, Lr, Or);
                }
                function Or(e, t) {
                    return 1 === e.type ? Lr(e, t) : Wn(e);
                }
                function qr(e, t) {
                    return e.children.length ? "_ssrNode(" + zr(Nr(e, t)) + ")" : "";
                }
                function Mr(e, t) {
                    return "(" + zr(Pr(e, t)) + ")";
                }
                function Pr(e, t) {
                    if (e.for && !e.forProcessed) return (e.forProcessed = !0), [{ type: _r, value: zn(e, t, Mr, "_ssrList") }];
                    if (e.if && !e.ifProcessed) return (e.ifProcessed = !0), [{ type: _r, value: In(e, t, Mr, '"\x3c!----\x3e"') }];
                    if ("template" === e.tag) return Nr(e, t);
                    var n = Ir(e, t),
                        r = Nr(e, t),
                        i = t.options.isUnaryTag,
                        o = i && i(e.tag) ? [] : [{ type: kr, value: "</" + e.tag + ">" }];
                    return n.concat(r, o);
                }
                function Ir(e, t) {
                    var n;
                    !(function (e, t) {
                        if (e.directives)
                            for (var n = 0; n < e.directives.length; n++) {
                                var r = e.directives[n];
                                if ("model" === r.name) {
                                    t.directives.model(e, r, t.warn),
                                        "textarea" === e.tag &&
                                            e.props &&
                                            (e.props = e.props.filter(function (e) {
                                                return "value" !== e.name;
                                            }));
                                    break;
                                }
                            }
                    })(e, t);
                    var r,
                        i,
                        o,
                        a,
                        s,
                        l,
                        c = [{ type: kr, value: "<" + e.tag }];
                    return (
                        e.attrs &&
                            c.push.apply(
                                c,
                                e.attrs.map(function (e) {
                                    return wr(e.name, e.value);
                                })
                            ),
                        e.props &&
                            c.push.apply(
                                c,
                                (function (e, t) {
                                    var n = [];
                                    return (
                                        e.forEach(function (e) {
                                            var r = e.name,
                                                i = e.value;
                                            (r = mr[r] || r.toLowerCase()),
                                                !fr(r) ||
                                                    (t &&
                                                        t.some(function (e) {
                                                            return e.name === r;
                                                        })) ||
                                                    n.push(wr(r, i));
                                        }),
                                        n
                                    );
                                })(e.props, e.attrs)
                            ),
                        (n = e.attrsMap["v-bind"]) && c.push({ type: _r, value: "_ssrAttrs(" + n + ")" }),
                        (n = e.attrsMap["v-bind.prop"]) && c.push({ type: _r, value: "_ssrDOMProps(" + n + ")" }),
                        (e.staticClass || e.classBinding) &&
                            c.push.apply(c, ((r = e.staticClass), (i = e.classBinding), r && !i ? [{ type: kr, value: ' class="' + JSON.parse(r) + '"' }] : [{ type: _r, value: "_ssrClass(" + (r || "null") + "," + (i || "null") + ")" }])),
                        (e.staticStyle || e.styleBinding || e.attrsMap["v-show"]) &&
                            c.push.apply(
                                c,
                                ((o = e.attrsMap.style),
                                (a = e.staticStyle),
                                (s = e.styleBinding),
                                (l = e.attrsMap["v-show"]),
                                !o || s || l
                                    ? [{ type: _r, value: "_ssrStyle(" + (a || "null") + "," + (s || "null") + ", " + (l ? "{ display: (" + l + ") ? '' : 'none' }" : "null") + ")" }]
                                    : [{ type: kr, value: " style=" + JSON.stringify(o) }])
                            ),
                        t.options.scopeId && c.push({ type: kr, value: " " + t.options.scopeId }),
                        c.push({ type: kr, value: ">" }),
                        c
                    );
                }
                function Nr(e, t) {
                    var n;
                    return (n = e.attrsMap["v-html"])
                        ? [{ type: _r, value: "_s(" + n + ")" }]
                        : (n = e.attrsMap["v-text"]) || ("textarea" === e.tag && (n = e.attrsMap["v-model"]))
                        ? [{ type: Ar, value: "_s(" + n + ")" }]
                        : e.children
                        ? (function (e, t) {
                              for (var n = [], r = 0; r < e.length; r++) {
                                  var i = e[r];
                                  if (1 === i.type) n.push.apply(n, Pr(i, t));
                                  else if (2 === i.type) n.push({ type: Ar, value: i.expression });
                                  else if (3 === i.type) {
                                      var o = vr(i.text);
                                      i.isComment && (o = "\x3c!--" + o + "--\x3e"), n.push({ type: kr, value: o });
                                  }
                              }
                              return n;
                          })(e.children, t)
                        : [];
                }
                function zr(e) {
                    for (
                        var t = [],
                            n = "",
                            r = function () {
                                n && (t.push(JSON.stringify(n)), (n = ""));
                            },
                            i = 0;
                        i < e.length;
                        i++
                    ) {
                        var o = e[i];
                        o.type === kr ? (n += o.value) : o.type === Ar ? (r(), t.push("_ssrEscape(" + o.value + ")")) : o.type === _r && (r(), t.push("(" + o.value + ")"));
                    }
                    return r(), t.join("+");
                }
                var Rr = cr(function (e, t) {
                        var n = Jt(e.trim(), t);
                        Cr(n, t);
                        var r = (function (e, t) {
                            var n = new Dn(t);
                            return { render: "with(this){return " + (e ? Lr(e, n) : '_c("div")') + "}", staticRenderFns: n.staticRenderFns };
                        })(n, t);
                        return { ast: n, render: r.render, staticRenderFns: r.staticRenderFns };
                    })(mn),
                    Fr = Rr.compile,
                    Br = Rr.compileToFunctions;
                (t.parseComponent = function (e, t) {
                    void 0 === t && (t = {});
                    var n = { template: null, script: null, styles: [], customBlocks: [], errors: [] },
                        s = 0,
                        l = null,
                        c = function (e) {
                            n.errors.push(e);
                        };
                    return (
                        t.outputSourceRange &&
                            (c = function (e, t) {
                                var r = { msg: e };
                                null != t.start && (r.start = t.start), null != t.end && (r.end = t.end), n.errors.push(r);
                            }),
                        V(e, {
                            warn: c,
                            start: function (e, t, r, i, o) {
                                0 === s &&
                                    ((l = {
                                        type: e,
                                        content: "",
                                        start: o,
                                        attrs: t.reduce(function (e, t) {
                                            var n = t.name,
                                                r = t.value;
                                            return (e[n] = r || !0), e;
                                        }, {}),
                                    }),
                                    Y(e)
                                        ? ((function (e, t) {
                                              for (var n = 0; n < t.length; n++) {
                                                  var r = t[n];
                                                  "lang" === r.name && (e.lang = r.value), "scoped" === r.name && (e.scoped = !0), "module" === r.name && (e.module = r.value || !0), "src" === r.name && (e.src = r.value);
                                              }
                                          })(l, t),
                                          "style" === e ? n.styles.push(l) : (n[e] = l))
                                        : n.customBlocks.push(l)),
                                    r || s++;
                            },
                            end: function (n, c) {
                                if (1 === s && l) {
                                    l.end = c;
                                    var u = e.slice(l.start, l.end);
                                    !1 !== t.deindent &&
                                        (u = (function (e) {
                                            if (!o.test(e)) return e;
                                            for (var t, n, s, l = e.split(r), c = 1 / 0, u = 0; u < l.length; u++) {
                                                var d = l[u];
                                                if (!i.test(d))
                                                    if (t) (n = a(d, t)) < c && (c = n);
                                                    else {
                                                        if (" " !== (s = d.charAt(0)) && "\t" !== s) return e;
                                                        (n = a(d, (t = s))) < c && (c = n);
                                                    }
                                            }
                                            return l
                                                .map(function (e) {
                                                    return e.slice(c);
                                                })
                                                .join("\n");
                                        })(u)),
                                        "template" !== l.type &&
                                            t.pad &&
                                            (u =
                                                (function (t, n) {
                                                    if ("space" === n) return e.slice(0, t.start).replace(G, " ");
                                                    var r = e.slice(0, t.start).split(U).length,
                                                        i = "script" !== t.type || t.lang ? "\n" : "//\n";
                                                    return Array(r).join(i);
                                                })(l, t.pad) + u),
                                        (l.content = u),
                                        (l = null);
                                }
                                s--;
                            },
                            outputSourceRange: t.outputSourceRange,
                        }),
                        n
                    );
                }),
                    (t.compile = dr),
                    (t.compileToFunctions = pr),
                    (t.ssrCompile = Fr),
                    (t.ssrCompileToFunctions = Br),
                    (t.generateCodeFrame = or),
                    Object.defineProperty(t, "__esModule", { value: !0 });
            }),
                r(t);
        }.call(this, n(3), n(8).setImmediate));
    },
    function (e, t, n) {
        (function (e, t) {
            !(function (e, n) {
                "use strict";
                if (!e.setImmediate) {
                    var r,
                        i,
                        o,
                        a,
                        s,
                        l = 1,
                        c = {},
                        u = !1,
                        d = e.document,
                        p = Object.getPrototypeOf && Object.getPrototypeOf(e);
                    (p = p && p.setTimeout ? p : e),
                        "[object process]" === {}.toString.call(e.process)
                            ? (r = function (e) {
                                  t.nextTick(function () {
                                      f(e);
                                  });
                              })
                            : !(function () {
                                  if (e.postMessage && !e.importScripts) {
                                      var t = !0,
                                          n = e.onmessage;
                                      return (
                                          (e.onmessage = function () {
                                              t = !1;
                                          }),
                                          e.postMessage("", "*"),
                                          (e.onmessage = n),
                                          t
                                      );
                                  }
                              })()
                            ? e.MessageChannel
                                ? (((o = new MessageChannel()).port1.onmessage = function (e) {
                                      f(e.data);
                                  }),
                                  (r = function (e) {
                                      o.port2.postMessage(e);
                                  }))
                                : d && "onreadystatechange" in d.createElement("script")
                                ? ((i = d.documentElement),
                                  (r = function (e) {
                                      var t = d.createElement("script");
                                      (t.onreadystatechange = function () {
                                          f(e), (t.onreadystatechange = null), i.removeChild(t), (t = null);
                                      }),
                                          i.appendChild(t);
                                  }))
                                : (r = function (e) {
                                      setTimeout(f, 0, e);
                                  })
                            : ((a = "setImmediate$" + Math.random() + "$"),
                              (s = function (t) {
                                  t.source === e && "string" == typeof t.data && 0 === t.data.indexOf(a) && f(+t.data.slice(a.length));
                              }),
                              e.addEventListener ? e.addEventListener("message", s, !1) : e.attachEvent("onmessage", s),
                              (r = function (t) {
                                  e.postMessage(a + t, "*");
                              })),
                        (p.setImmediate = function (e) {
                            "function" != typeof e && (e = new Function("" + e));
                            for (var t = new Array(arguments.length - 1), n = 0; n < t.length; n++) t[n] = arguments[n + 1];
                            var i = { callback: e, args: t };
                            return (c[l] = i), r(l), l++;
                        }),
                        (p.clearImmediate = h);
                }
                function h(e) {
                    delete c[e];
                }
                function f(e) {
                    if (u) setTimeout(f, 0, e);
                    else {
                        var t = c[e];
                        if (t) {
                            u = !0;
                            try {
                                !(function (e) {
                                    var t = e.callback,
                                        r = e.args;
                                    switch (r.length) {
                                        case 0:
                                            t();
                                            break;
                                        case 1:
                                            t(r[0]);
                                            break;
                                        case 2:
                                            t(r[0], r[1]);
                                            break;
                                        case 3:
                                            t(r[0], r[1], r[2]);
                                            break;
                                        default:
                                            t.apply(n, r);
                                    }
                                })(t);
                            } finally {
                                h(e), (u = !1);
                            }
                        }
                    }
                }
            })("undefined" == typeof self ? (void 0 === e ? this : e) : self);
        }.call(this, n(3), n(22)));
    },
    function (e, t) {
        var n,
            r,
            i = (e.exports = {});
        function o() {
            throw new Error("setTimeout has not been defined");
        }
        function a() {
            throw new Error("clearTimeout has not been defined");
        }
        function s(e) {
            if (n === setTimeout) return setTimeout(e, 0);
            if ((n === o || !n) && setTimeout) return (n = setTimeout), setTimeout(e, 0);
            try {
                return n(e, 0);
            } catch (t) {
                try {
                    return n.call(null, e, 0);
                } catch (t) {
                    return n.call(this, e, 0);
                }
            }
        }
        !(function () {
            try {
                n = "function" == typeof setTimeout ? setTimeout : o;
            } catch (e) {
                n = o;
            }
            try {
                r = "function" == typeof clearTimeout ? clearTimeout : a;
            } catch (e) {
                r = a;
            }
        })();
        var l,
            c = [],
            u = !1,
            d = -1;
        function p() {
            u && l && ((u = !1), l.length ? (c = l.concat(c)) : (d = -1), c.length && h());
        }
        function h() {
            if (!u) {
                var e = s(p);
                u = !0;
                for (var t = c.length; t; ) {
                    for (l = c, c = []; ++d < t; ) l && l[d].run();
                    (d = -1), (t = c.length);
                }
                (l = null),
                    (u = !1),
                    (function (e) {
                        if (r === clearTimeout) return clearTimeout(e);
                        if ((r === a || !r) && clearTimeout) return (r = clearTimeout), clearTimeout(e);
                        try {
                            return r(e);
                        } catch (t) {
                            try {
                                return r.call(null, e);
                            } catch (t) {
                                return r.call(this, e);
                            }
                        }
                    })(e);
            }
        }
        function f(e, t) {
            (this.fun = e), (this.array = t);
        }
        function m() {}
        (i.nextTick = function (e) {
            var t = new Array(arguments.length - 1);
            if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
            c.push(new f(e, t)), 1 !== c.length || u || s(h);
        }),
            (f.prototype.run = function () {
                this.fun.apply(null, this.array);
            }),
            (i.title = "browser"),
            (i.browser = !0),
            (i.env = {}),
            (i.argv = []),
            (i.version = ""),
            (i.versions = {}),
            (i.on = m),
            (i.addListener = m),
            (i.once = m),
            (i.off = m),
            (i.removeListener = m),
            (i.removeAllListeners = m),
            (i.emit = m),
            (i.prependListener = m),
            (i.prependOnceListener = m),
            (i.listeners = function (e) {
                return [];
            }),
            (i.binding = function (e) {
                throw new Error("process.binding is not supported");
            }),
            (i.cwd = function () {
                return "/";
            }),
            (i.chdir = function (e) {
                throw new Error("process.chdir is not supported");
            }),
            (i.umask = function () {
                return 0;
            });
    },
    function (e, t, n) {
        (function (e) {
            /*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
            !(function (e) {
                var t = { url: !1, callback: !1, target: !1, duration: 120, on: "mouseover", touch: !0, onZoomIn: !1, onZoomOut: !1, magnify: 1 };
                (e.zoom = function (t, n, r, i) {
                    var o,
                        a,
                        s,
                        l,
                        c,
                        u,
                        d,
                        p = e(t),
                        h = p.css("position"),
                        f = e(n);
                    return (
                        (t.style.position = /(absolute|fixed)/.test(h) ? h : "relative"),
                        (t.style.overflow = "hidden"),
                        (r.style.width = r.style.height = ""),
                        e(r)
                            .addClass("zoomImg")
                            .css({ position: "absolute", top: 0, left: 0, opacity: 0, width: r.width * i, height: r.height * i, border: "none", maxWidth: "none", maxHeight: "none" })
                            .appendTo(t),
                        {
                            init: function () {
                                (a = p.outerWidth()), (o = p.outerHeight()), n === t ? ((l = a), (s = o)) : ((l = f.outerWidth()), (s = f.outerHeight())), (c = (r.width - a) / l), (u = (r.height - o) / s), (d = f.offset());
                            },
                            move: function (e) {
                                var t = e.pageX - d.left,
                                    n = e.pageY - d.top;
                                (n = Math.max(Math.min(n, s), 0)), (t = Math.max(Math.min(t, l), 0)), (r.style.left = t * -c + "px"), (r.style.top = n * -u + "px");
                            },
                        }
                    );
                }),
                    (e.fn.zoom = function (n) {
                        return this.each(function () {
                            var r = e.extend({}, t, n || {}),
                                i = (r.target && e(r.target)[0]) || this,
                                o = this,
                                a = e(o),
                                s = document.createElement("img"),
                                l = e(s),
                                c = "mousemove.zoom",
                                u = !1,
                                d = !1;
                            if (!r.url) {
                                var p = o.querySelector("img");
                                if ((p && (r.url = p.getAttribute("data-src") || p.currentSrc || p.src), !r.url)) return;
                            }
                            a.one(
                                "zoom.destroy",
                                function (e, t) {
                                    a.off(".zoom"), (i.style.position = e), (i.style.overflow = t), (s.onload = null), l.remove();
                                }.bind(this, i.style.position, i.style.overflow)
                            ),
                                (s.onload = function () {
                                    var t = e.zoom(i, o, s, r.magnify);
                                    function n(n) {
                                        t.init(), t.move(n), l.stop().fadeTo(e.support.opacity ? r.duration : 0, 1, !!e.isFunction(r.onZoomIn) && r.onZoomIn.call(s));
                                    }
                                    function p() {
                                        l.stop().fadeTo(r.duration, 0, !!e.isFunction(r.onZoomOut) && r.onZoomOut.call(s));
                                    }
                                    "grab" === r.on
                                        ? a.on("mousedown.zoom", function (r) {
                                              1 === r.which &&
                                                  (e(document).one("mouseup.zoom", function () {
                                                      p(), e(document).off(c, t.move);
                                                  }),
                                                  n(r),
                                                  e(document).on(c, t.move),
                                                  r.preventDefault());
                                          })
                                        : "click" === r.on
                                        ? a.on("click.zoom", function (r) {
                                              return u
                                                  ? void 0
                                                  : ((u = !0),
                                                    n(r),
                                                    e(document).on(c, t.move),
                                                    e(document).one("click.zoom", function () {
                                                        p(), (u = !1), e(document).off(c, t.move);
                                                    }),
                                                    !1);
                                          })
                                        : "toggle" === r.on
                                        ? a.on("click.zoom", function (e) {
                                              u ? p() : n(e), (u = !u);
                                          })
                                        : "mouseover" === r.on && (t.init(), a.on("mouseenter.zoom", n).on("mouseleave.zoom", p).on(c, t.move)),
                                        r.touch &&
                                            a
                                                .on("touchstart.zoom", function (e) {
                                                    e.preventDefault(), d ? ((d = !1), p()) : ((d = !0), n(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]));
                                                })
                                                .on("touchmove.zoom", function (e) {
                                                    e.preventDefault(), t.move(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]);
                                                })
                                                .on("touchend.zoom", function (e) {
                                                    e.preventDefault(), d && ((d = !1), p());
                                                }),
                                        e.isFunction(r.callback) && r.callback.call(s);
                                }),
                                s.setAttribute("role", "presentation"),
                                (s.alt = ""),
                                (s.src = r.url);
                        });
                    }),
                    (e.fn.zoom.defaults = t);
            })(e);
        }.call(this, n(0)));
    },
    function (e, t, n) {
        (function (e) {
            /*!
             * fancyBox - jQuery Plugin
             * version: 2.1.5 (Fri, 14 Jun 2013)
             * requires jQuery v1.6 or later
             *
             * Examples at http://fancyapps.com/fancybox/
             * License: www.fancyapps.com/fancybox/#license
             *
             * Copyright 2012 Janis Skarnelis - janis@fancyapps.com
             *
             */
            !(function (e, t, n, r) {
                "use strict";
                var i = n("html"),
                    o = n(e),
                    a = n(t),
                    s = (n.fancybox = function () {
                        s.open.apply(this, arguments);
                    }),
                    l = navigator.userAgent.match(/msie/i),
                    c = null,
                    u = t.createTouch !== r,
                    d = function (e) {
                        return e && e.hasOwnProperty && e instanceof n;
                    },
                    p = function (e) {
                        return e && "string" === n.type(e);
                    },
                    h = function (e) {
                        return p(e) && e.indexOf("%") > 0;
                    },
                    f = function (e, t) {
                        var n = parseInt(e, 10) || 0;
                        return t && h(e) && (n = (s.getViewport()[t] / 100) * n), Math.ceil(n);
                    },
                    m = function (e, t) {
                        return f(e, t) + "px";
                    };
                n.extend(s, {
                    version: "2.1.5",
                    defaults: {
                        padding: 15,
                        margin: 20,
                        width: 800,
                        height: 600,
                        minWidth: 100,
                        minHeight: 100,
                        maxWidth: 9999,
                        maxHeight: 9999,
                        pixelRatio: 1,
                        autoSize: !0,
                        autoHeight: !1,
                        autoWidth: !1,
                        autoResize: !0,
                        autoCenter: !u,
                        fitToView: !0,
                        aspectRatio: !1,
                        topRatio: 0.5,
                        leftRatio: 0.5,
                        scrolling: "auto",
                        wrapCSS: "",
                        arrows: !0,
                        closeBtn: !0,
                        closeClick: !1,
                        nextClick: !1,
                        mouseWheel: !0,
                        autoPlay: !1,
                        playSpeed: 3e3,
                        preload: 3,
                        modal: !1,
                        loop: !0,
                        ajax: { dataType: "html", headers: { "X-fancyBox": !0 } },
                        iframe: { scrolling: "auto", preload: !0 },
                        swf: { wmode: "transparent", allowfullscreen: "true", allowscriptaccess: "always" },
                        keys: { next: { 13: "left", 34: "up", 39: "left", 40: "up" }, prev: { 8: "right", 33: "down", 37: "right", 38: "down" }, close: [27], play: [32], toggle: [70] },
                        direction: { next: "left", prev: "right" },
                        scrollOutside: !0,
                        index: 0,
                        type: null,
                        href: null,
                        content: null,
                        title: null,
                        tpl: {
                            wrap: '<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
                            image: '<img class="fancybox-image" src="{href}" alt="" />',
                            iframe:
                                '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen' +
                                (l ? ' allowtransparency="true"' : "") +
                                "></iframe>",
                            error: '<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',
                            closeBtn: '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',
                            next: '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
                            prev: '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>',
                            loading: '<div id="fancybox-loading"><div></div></div>',
                        },
                        openEffect: "fade",
                        openSpeed: 250,
                        openEasing: "swing",
                        openOpacity: !0,
                        openMethod: "zoomIn",
                        closeEffect: "fade",
                        closeSpeed: 250,
                        closeEasing: "swing",
                        closeOpacity: !0,
                        closeMethod: "zoomOut",
                        nextEffect: "elastic",
                        nextSpeed: 250,
                        nextEasing: "swing",
                        nextMethod: "changeIn",
                        prevEffect: "elastic",
                        prevSpeed: 250,
                        prevEasing: "swing",
                        prevMethod: "changeOut",
                        helpers: { overlay: !0, title: !0 },
                        onCancel: n.noop,
                        beforeLoad: n.noop,
                        afterLoad: n.noop,
                        beforeShow: n.noop,
                        afterShow: n.noop,
                        beforeChange: n.noop,
                        beforeClose: n.noop,
                        afterClose: n.noop,
                    },
                    group: {},
                    opts: {},
                    previous: null,
                    coming: null,
                    current: null,
                    isActive: !1,
                    isOpen: !1,
                    isOpened: !1,
                    wrap: null,
                    skin: null,
                    outer: null,
                    inner: null,
                    player: { timer: null, isActive: !1 },
                    ajaxLoad: null,
                    imgPreload: null,
                    transitions: {},
                    helpers: {},
                    open: function (e, t) {
                        if (e && (n.isPlainObject(t) || (t = {}), !1 !== s.close(!0)))
                            return (
                                n.isArray(e) || (e = d(e) ? n(e).get() : [e]),
                                n.each(e, function (i, o) {
                                    var a,
                                        l,
                                        c,
                                        u,
                                        h,
                                        f,
                                        m,
                                        g = {};
                                    "object" === n.type(o) &&
                                        (o.nodeType && (o = n(o)),
                                        d(o)
                                            ? ((g = {
                                                  href: o.data("fancybox-href") || o.attr("href"),
                                                  title: n("<div/>")
                                                      .text(o.data("fancybox-title") || o.attr("title") || "")
                                                      .html(),
                                                  isDom: !0,
                                                  element: o,
                                              }),
                                              n.metadata && n.extend(!0, g, o.metadata()))
                                            : (g = o)),
                                        (a = t.href || g.href || (p(o) ? o : null)),
                                        (l = t.title !== r ? t.title : g.title || ""),
                                        !(u = (c = t.content || g.content) ? "html" : t.type || g.type) && g.isDom && ((u = o.data("fancybox-type")) || (u = (h = o.prop("class").match(/fancybox\.(\w+)/)) ? h[1] : null)),
                                        p(a) &&
                                            (u || (s.isImage(a) ? (u = "image") : s.isSWF(a) ? (u = "swf") : "#" === a.charAt(0) ? (u = "inline") : p(o) && ((u = "html"), (c = o))),
                                            "ajax" === u && ((f = a.split(/\s+/, 2)), (a = f.shift()), (m = f.shift()))),
                                        c || ("inline" === u ? (a ? (c = n(p(a) ? a.replace(/.*(?=#[^\s]+$)/, "") : a)) : g.isDom && (c = o)) : "html" === u ? (c = a) : u || a || !g.isDom || ((u = "inline"), (c = o))),
                                        n.extend(g, { href: a, type: u, content: c, title: l, selector: m }),
                                        (e[i] = g);
                                }),
                                (s.opts = n.extend(!0, {}, s.defaults, t)),
                                t.keys !== r && (s.opts.keys = !!t.keys && n.extend({}, s.defaults.keys, t.keys)),
                                (s.group = e),
                                s._start(s.opts.index)
                            );
                    },
                    cancel: function () {
                        var e = s.coming;
                        (e && !1 === s.trigger("onCancel")) ||
                            (s.hideLoading(),
                            e &&
                                (s.ajaxLoad && s.ajaxLoad.abort(),
                                (s.ajaxLoad = null),
                                s.imgPreload && (s.imgPreload.onload = s.imgPreload.onerror = null),
                                e.wrap && e.wrap.stop(!0, !0).trigger("onReset").remove(),
                                (s.coming = null),
                                s.current || s._afterZoomOut(e)));
                    },
                    close: function (e) {
                        s.cancel(),
                            !1 !== s.trigger("beforeClose") &&
                                (s.unbindEvents(),
                                s.isActive &&
                                    (s.isOpen && !0 !== e
                                        ? ((s.isOpen = s.isOpened = !1), (s.isClosing = !0), n(".fancybox-item, .fancybox-nav").remove(), s.wrap.stop(!0, !0).removeClass("fancybox-opened"), s.transitions[s.current.closeMethod]())
                                        : (n(".fancybox-wrap").stop(!0).trigger("onReset").remove(), s._afterZoomOut())));
                    },
                    play: function (e) {
                        var t = function () {
                                clearTimeout(s.player.timer);
                            },
                            n = function () {
                                t(), s.current && s.player.isActive && (s.player.timer = setTimeout(s.next, s.current.playSpeed));
                            },
                            r = function () {
                                t(), a.unbind(".player"), (s.player.isActive = !1), s.trigger("onPlayEnd");
                            };
                        !0 === e || (!s.player.isActive && !1 !== e)
                            ? s.current &&
                              (s.current.loop || s.current.index < s.group.length - 1) &&
                              ((s.player.isActive = !0), a.bind({ "onCancel.player beforeClose.player": r, "onUpdate.player": n, "beforeLoad.player": t }), n(), s.trigger("onPlayStart"))
                            : r();
                    },
                    next: function (e) {
                        var t = s.current;
                        t && (p(e) || (e = t.direction.next), s.jumpto(t.index + 1, e, "next"));
                    },
                    prev: function (e) {
                        var t = s.current;
                        t && (p(e) || (e = t.direction.prev), s.jumpto(t.index - 1, e, "prev"));
                    },
                    jumpto: function (e, t, n) {
                        var i = s.current;
                        i &&
                            ((e = f(e)),
                            (s.direction = t || i.direction[e >= i.index ? "next" : "prev"]),
                            (s.router = n || "jumpto"),
                            i.loop && (e < 0 && (e = i.group.length + (e % i.group.length)), (e %= i.group.length)),
                            i.group[e] !== r && (s.cancel(), s._start(e)));
                    },
                    reposition: function (e, t) {
                        var r,
                            i = s.current,
                            o = i ? i.wrap : null;
                        o && ((r = s._getPosition(t)), e && "scroll" === e.type ? (delete r.position, o.stop(!0, !0).animate(r, 200)) : (o.css(r), (i.pos = n.extend({}, i.dim, r))));
                    },
                    update: function (e) {
                        var t = e && e.originalEvent && e.originalEvent.type,
                            n = !t || "orientationchange" === t;
                        n && (clearTimeout(c), (c = null)),
                            s.isOpen &&
                                !c &&
                                (c = setTimeout(
                                    function () {
                                        var r = s.current;
                                        r &&
                                            !s.isClosing &&
                                            (s.wrap.removeClass("fancybox-tmp"),
                                            (n || "load" === t || ("resize" === t && r.autoResize)) && s._setDimension(),
                                            ("scroll" === t && r.canShrink) || s.reposition(e),
                                            s.trigger("onUpdate"),
                                            (c = null));
                                    },
                                    n && !u ? 0 : 300
                                ));
                    },
                    toggle: function (e) {
                        s.isOpen && ((s.current.fitToView = "boolean" === n.type(e) ? e : !s.current.fitToView), u && (s.wrap.removeAttr("style").addClass("fancybox-tmp"), s.trigger("onUpdate")), s.update());
                    },
                    hideLoading: function () {
                        a.unbind(".loading"), n("#fancybox-loading").remove();
                    },
                    showLoading: function () {
                        var e, t;
                        s.hideLoading(),
                            (e = n(s.opts.tpl.loading).click(s.cancel).appendTo("body")),
                            a.bind("keydown.loading", function (e) {
                                27 === (e.which || e.keyCode) && (e.preventDefault(), s.cancel());
                            }),
                            s.defaults.fixed || ((t = s.getViewport()), e.css({ position: "absolute", top: 0.5 * t.h + t.y, left: 0.5 * t.w + t.x })),
                            s.trigger("onLoading");
                    },
                    getViewport: function () {
                        var t = (s.current && s.current.locked) || !1,
                            n = { x: o.scrollLeft(), y: o.scrollTop() };
                        return t && t.length ? ((n.w = t[0].clientWidth), (n.h = t[0].clientHeight)) : ((n.w = u && e.innerWidth ? e.innerWidth : o.width()), (n.h = u && e.innerHeight ? e.innerHeight : o.height())), n;
                    },
                    unbindEvents: function () {
                        s.wrap && d(s.wrap) && s.wrap.unbind(".fb"), a.unbind(".fb"), o.unbind(".fb");
                    },
                    bindEvents: function () {
                        var e,
                            t = s.current;
                        t &&
                            (o.bind("orientationchange.fb" + (u ? "" : " resize.fb") + (t.autoCenter && !t.locked ? " scroll.fb" : ""), s.update),
                            (e = t.keys) &&
                                a.bind("keydown.fb", function (i) {
                                    var o = i.which || i.keyCode,
                                        a = i.target || i.srcElement;
                                    if (27 === o && s.coming) return !1;
                                    i.ctrlKey ||
                                        i.altKey ||
                                        i.shiftKey ||
                                        i.metaKey ||
                                        (a && (a.type || n(a).is("[contenteditable]"))) ||
                                        n.each(e, function (e, a) {
                                            return t.group.length > 1 && a[o] !== r ? (s[e](a[o]), i.preventDefault(), !1) : n.inArray(o, a) > -1 ? (s[e](), i.preventDefault(), !1) : void 0;
                                        });
                                }),
                            n.fn.mousewheel &&
                                t.mouseWheel &&
                                s.wrap.bind("mousewheel.fb", function (e, r, i, o) {
                                    for (var a, l = e.target || null, c = n(l), u = !1; c.length && !(u || c.is(".fancybox-skin") || c.is(".fancybox-wrap")); )
                                        (u = (a = c[0]) && !(a.style.overflow && "hidden" === a.style.overflow) && ((a.clientWidth && a.scrollWidth > a.clientWidth) || (a.clientHeight && a.scrollHeight > a.clientHeight))),
                                            (c = n(c).parent());
                                    0 === r || u || (s.group.length > 1 && !t.canShrink && (o > 0 || i > 0 ? s.prev(o > 0 ? "down" : "left") : (o < 0 || i < 0) && s.next(o < 0 ? "up" : "right"), e.preventDefault()));
                                }));
                    },
                    trigger: function (e, t) {
                        var r,
                            i = t || s.coming || s.current;
                        if (i) {
                            if ((n.isFunction(i[e]) && (r = i[e].apply(i, Array.prototype.slice.call(arguments, 1))), !1 === r)) return !1;
                            i.helpers &&
                                n.each(i.helpers, function (t, r) {
                                    r && s.helpers[t] && n.isFunction(s.helpers[t][e]) && s.helpers[t][e](n.extend(!0, {}, s.helpers[t].defaults, r), i);
                                });
                        }
                        a.trigger(e);
                    },
                    isImage: function (e) {
                        return p(e) && e.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i);
                    },
                    isSWF: function (e) {
                        return p(e) && e.match(/\.(swf)((\?|#).*)?$/i);
                    },
                    _start: function (e) {
                        var t,
                            r,
                            i,
                            o,
                            a,
                            l = {};
                        if (((e = f(e)), !(t = s.group[e] || null))) return !1;
                        if (
                            ((o = (l = n.extend(!0, {}, s.opts, t)).margin),
                            (a = l.padding),
                            "number" === n.type(o) && (l.margin = [o, o, o, o]),
                            "number" === n.type(a) && (l.padding = [a, a, a, a]),
                            l.modal && n.extend(!0, l, { closeBtn: !1, closeClick: !1, nextClick: !1, arrows: !1, mouseWheel: !1, keys: null, helpers: { overlay: { closeClick: !1 } } }),
                            l.autoSize && (l.autoWidth = l.autoHeight = !0),
                            "auto" === l.width && (l.autoWidth = !0),
                            "auto" === l.height && (l.autoHeight = !0),
                            (l.group = s.group),
                            (l.index = e),
                            (s.coming = l),
                            !1 !== s.trigger("beforeLoad"))
                        ) {
                            if (((i = l.type), (r = l.href), !i)) return (s.coming = null), !(!s.current || !s.router || "jumpto" === s.router) && ((s.current.index = e), s[s.router](s.direction));
                            if (
                                ((s.isActive = !0),
                                ("image" !== i && "swf" !== i) || ((l.autoHeight = l.autoWidth = !1), (l.scrolling = "visible")),
                                "image" === i && (l.aspectRatio = !0),
                                "iframe" === i && u && (l.scrolling = "scroll"),
                                (l.wrap = n(l.tpl.wrap)
                                    .addClass("fancybox-" + (u ? "mobile" : "desktop") + " fancybox-type-" + i + " fancybox-tmp " + l.wrapCSS)
                                    .appendTo(l.parent || "body")),
                                n.extend(l, { skin: n(".fancybox-skin", l.wrap), outer: n(".fancybox-outer", l.wrap), inner: n(".fancybox-inner", l.wrap) }),
                                n.each(["Top", "Right", "Bottom", "Left"], function (e, t) {
                                    l.skin.css("padding" + t, m(l.padding[e]));
                                }),
                                s.trigger("onReady"),
                                "inline" === i || "html" === i)
                            ) {
                                if (!l.content || !l.content.length) return s._error("content");
                            } else if (!r) return s._error("href");
                            "image" === i ? s._loadImage() : "ajax" === i ? s._loadAjax() : "iframe" === i ? s._loadIframe() : s._afterLoad();
                        } else s.coming = null;
                    },
                    _error: function (e) {
                        n.extend(s.coming, { type: "html", autoWidth: !0, autoHeight: !0, minWidth: 0, minHeight: 0, scrolling: "no", hasError: e, content: s.coming.tpl.error }), s._afterLoad();
                    },
                    _loadImage: function () {
                        var e = (s.imgPreload = new Image());
                        (e.onload = function () {
                            (this.onload = this.onerror = null), (s.coming.width = this.width / s.opts.pixelRatio), (s.coming.height = this.height / s.opts.pixelRatio), s._afterLoad();
                        }),
                            (e.onerror = function () {
                                (this.onload = this.onerror = null), s._error("image");
                            }),
                            (e.src = s.coming.href),
                            !0 !== e.complete && s.showLoading();
                    },
                    _loadAjax: function () {
                        var e = s.coming;
                        s.showLoading(),
                            (s.ajaxLoad = n.ajax(
                                n.extend({}, e.ajax, {
                                    url: e.href,
                                    error: function (e, t) {
                                        s.coming && "abort" !== t ? s._error("ajax", e) : s.hideLoading();
                                    },
                                    success: function (t, n) {
                                        "success" === n && ((e.content = t), s._afterLoad());
                                    },
                                })
                            ));
                    },
                    _loadIframe: function () {
                        var e = s.coming,
                            t = n(e.tpl.iframe.replace(/\{rnd\}/g, new Date().getTime()))
                                .attr("scrolling", u ? "auto" : e.iframe.scrolling)
                                .attr("src", e.href);
                        n(e.wrap).bind("onReset", function () {
                            try {
                                n(this).find("iframe").hide().attr("src", "//about:blank").end().empty();
                            } catch (e) {}
                        }),
                            e.iframe.preload &&
                                (s.showLoading(),
                                t.one("load", function () {
                                    n(this).data("ready", 1), u || n(this).bind("load.fb", s.update), n(this).parents(".fancybox-wrap").width("100%").removeClass("fancybox-tmp").show(), s._afterLoad();
                                })),
                            (e.content = t.appendTo(e.inner)),
                            e.iframe.preload || s._afterLoad();
                    },
                    _preloadImages: function () {
                        var e,
                            t,
                            n = s.group,
                            r = s.current,
                            i = n.length,
                            o = r.preload ? Math.min(r.preload, i - 1) : 0;
                        for (t = 1; t <= o; t += 1) "image" === (e = n[(r.index + t) % i]).type && e.href && (new Image().src = e.href);
                    },
                    _afterLoad: function () {
                        var e,
                            t,
                            r,
                            i,
                            o,
                            a,
                            l = s.coming,
                            c = s.current,
                            u = "fancybox-placeholder";
                        if ((s.hideLoading(), l && !1 !== s.isActive)) {
                            if (!1 === s.trigger("afterLoad", l, c)) return l.wrap.stop(!0).trigger("onReset").remove(), void (s.coming = null);
                            switch (
                                (c && (s.trigger("beforeChange", c), c.wrap.stop(!0).removeClass("fancybox-opened").find(".fancybox-item, .fancybox-nav").remove()),
                                s.unbindEvents(),
                                (e = l),
                                (t = l.content),
                                (r = l.type),
                                (i = l.scrolling),
                                n.extend(s, { wrap: e.wrap, skin: e.skin, outer: e.outer, inner: e.inner, current: e, previous: c }),
                                (o = e.href),
                                r)
                            ) {
                                case "inline":
                                case "ajax":
                                case "html":
                                    e.selector
                                        ? (t = n("<div>").html(t).find(e.selector))
                                        : d(t) &&
                                          (t.data(u) ||
                                              t.data(
                                                  u,
                                                  n('<div class="' + u + '"></div>')
                                                      .insertAfter(t)
                                                      .hide()
                                              ),
                                          (t = t.show().detach()),
                                          e.wrap.bind("onReset", function () {
                                              n(this).find(t).length && t.hide().replaceAll(t.data(u)).data(u, !1);
                                          }));
                                    break;
                                case "image":
                                    t = e.tpl.image.replace(/\{href\}/g, o);
                                    break;
                                case "swf":
                                    (t = '<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="' + o + '"></param>'),
                                        (a = ""),
                                        n.each(e.swf, function (e, n) {
                                            (t += '<param name="' + e + '" value="' + n + '"></param>'), (a += " " + e + '="' + n + '"');
                                        }),
                                        (t += '<embed src="' + o + '" type="application/x-shockwave-flash" width="100%" height="100%"' + a + "></embed></object>");
                            }
                            (d(t) && t.parent().is(e.inner)) || e.inner.append(t),
                                s.trigger("beforeShow"),
                                e.inner.css("overflow", "yes" === i ? "scroll" : "no" === i ? "hidden" : i),
                                s._setDimension(),
                                s.reposition(),
                                (s.isOpen = !1),
                                (s.coming = null),
                                s.bindEvents(),
                                s.isOpened ? c.prevMethod && s.transitions[c.prevMethod]() : n(".fancybox-wrap").not(e.wrap).stop(!0).trigger("onReset").remove(),
                                s.transitions[s.isOpened ? e.nextMethod : e.openMethod](),
                                s._preloadImages();
                        }
                    },
                    _setDimension: function () {
                        var e,
                            t,
                            r,
                            i,
                            o,
                            a,
                            l,
                            c,
                            u,
                            d,
                            p,
                            g,
                            v,
                            y,
                            b,
                            w,
                            x,
                            E = s.getViewport(),
                            C = 0,
                            S = s.wrap,
                            T = s.skin,
                            k = s.inner,
                            A = s.current,
                            _ = A.width,
                            L = A.height,
                            $ = A.minWidth,
                            D = A.minHeight,
                            O = A.maxWidth,
                            q = A.maxHeight,
                            M = A.scrolling,
                            P = A.scrollOutside ? A.scrollbarWidth : 0,
                            I = A.margin,
                            N = f(I[1] + I[3]),
                            z = f(I[0] + I[2]);
                        if (
                            (S.add(T).add(k).width("auto").height("auto").removeClass("fancybox-tmp"),
                            (o = N + (r = f(T.outerWidth(!0) - T.width()))),
                            (a = z + (i = f(T.outerHeight(!0) - T.height()))),
                            (l = h(_) ? ((E.w - o) * f(_)) / 100 : _),
                            (c = h(L) ? ((E.h - a) * f(L)) / 100 : L),
                            "iframe" === A.type)
                        ) {
                            if (((w = A.content), A.autoHeight && 1 === w.data("ready")))
                                try {
                                    w[0].contentWindow.document.location && (k.width(l).height(9999), (x = w.contents().find("body")), P && x.css("overflow-x", "hidden"), (c = x.outerHeight(!0)));
                                } catch (e) {}
                        } else
                            (A.autoWidth || A.autoHeight) &&
                                (k.addClass("fancybox-tmp"), A.autoWidth || k.width(l), A.autoHeight || k.height(c), A.autoWidth && (l = k.width()), A.autoHeight && (c = k.height()), k.removeClass("fancybox-tmp"));
                        if (
                            ((_ = f(l)),
                            (L = f(c)),
                            (p = l / c),
                            ($ = f(h($) ? f($, "w") - o : $)),
                            (O = f(h(O) ? f(O, "w") - o : O)),
                            (D = f(h(D) ? f(D, "h") - a : D)),
                            (u = O),
                            (d = q = f(h(q) ? f(q, "h") - a : q)),
                            A.fitToView && ((O = Math.min(E.w - o, O)), (q = Math.min(E.h - a, q))),
                            (y = E.w - N),
                            (b = E.h - z),
                            A.aspectRatio
                                ? (_ > O && (L = f((_ = O) / p)), L > q && (_ = f((L = q) * p)), _ < $ && (L = f((_ = $) / p)), L < D && (_ = f((L = D) * p)))
                                : ((_ = Math.max($, Math.min(_, O))), A.autoHeight && "iframe" !== A.type && (k.width(_), (L = k.height())), (L = Math.max(D, Math.min(L, q)))),
                            A.fitToView)
                        )
                            if ((k.width(_).height(L), S.width(_ + r), (g = S.width()), (v = S.height()), A.aspectRatio))
                                for (; (g > y || v > b) && _ > $ && L > D && !(C++ > 19); )
                                    (L = Math.max(D, Math.min(q, L - 10))), (_ = f(L * p)) < $ && (L = f((_ = $) / p)), _ > O && (L = f((_ = O) / p)), k.width(_).height(L), S.width(_ + r), (g = S.width()), (v = S.height());
                            else (_ = Math.max($, Math.min(_, _ - (g - y)))), (L = Math.max(D, Math.min(L, L - (v - b))));
                        P && "auto" === M && L < c && _ + r + P < y && (_ += P),
                            k.width(_).height(L),
                            S.width(_ + r),
                            (g = S.width()),
                            (v = S.height()),
                            (e = (g > y || v > b) && _ > $ && L > D),
                            (t = A.aspectRatio ? _ < u && L < d && _ < l && L < c : (_ < u || L < d) && (_ < l || L < c)),
                            n.extend(A, { dim: { width: m(g), height: m(v) }, origWidth: l, origHeight: c, canShrink: e, canExpand: t, wPadding: r, hPadding: i, wrapSpace: v - T.outerHeight(!0), skinSpace: T.height() - L }),
                            !w && A.autoHeight && L > D && L < q && !t && k.height("auto");
                    },
                    _getPosition: function (e) {
                        var t = s.current,
                            n = s.getViewport(),
                            r = t.margin,
                            i = s.wrap.width() + r[1] + r[3],
                            o = s.wrap.height() + r[0] + r[2],
                            a = { position: "absolute", top: r[0], left: r[3] };
                        return (
                            t.autoCenter && t.fixed && !e && o <= n.h && i <= n.w ? (a.position = "fixed") : t.locked || ((a.top += n.y), (a.left += n.x)),
                            (a.top = m(Math.max(a.top, a.top + (n.h - o) * t.topRatio))),
                            (a.left = m(Math.max(a.left, a.left + (n.w - i) * t.leftRatio))),
                            a
                        );
                    },
                    _afterZoomIn: function () {
                        var e = s.current;
                        e &&
                            ((s.isOpen = s.isOpened = !0),
                            s.wrap.css("overflow", "visible").addClass("fancybox-opened").hide().show(0),
                            s.update(),
                            (e.closeClick || (e.nextClick && s.group.length > 1)) &&
                                s.inner.css("cursor", "pointer").bind("click.fb", function (t) {
                                    n(t.target).is("a") || n(t.target).parent().is("a") || (t.preventDefault(), s[e.closeClick ? "close" : "next"]());
                                }),
                            e.closeBtn &&
                                n(e.tpl.closeBtn)
                                    .appendTo(s.skin)
                                    .bind("click.fb", function (e) {
                                        e.preventDefault(), s.close();
                                    }),
                            e.arrows &&
                                s.group.length > 1 &&
                                ((e.loop || e.index > 0) && n(e.tpl.prev).appendTo(s.outer).bind("click.fb", s.prev), (e.loop || e.index < s.group.length - 1) && n(e.tpl.next).appendTo(s.outer).bind("click.fb", s.next)),
                            s.trigger("afterShow"),
                            e.loop || e.index !== e.group.length - 1 ? s.opts.autoPlay && !s.player.isActive && ((s.opts.autoPlay = !1), s.play(!0)) : s.play(!1));
                    },
                    _afterZoomOut: function (e) {
                        (e = e || s.current),
                            n(".fancybox-wrap").trigger("onReset").remove(),
                            n.extend(s, { group: {}, opts: {}, router: !1, current: null, isActive: !1, isOpened: !1, isOpen: !1, isClosing: !1, wrap: null, skin: null, outer: null, inner: null }),
                            s.trigger("afterClose", e);
                    },
                }),
                    (s.transitions = {
                        getOrigPosition: function () {
                            var e = s.current,
                                t = e.element,
                                n = e.orig,
                                r = {},
                                i = 50,
                                o = 50,
                                a = e.hPadding,
                                l = e.wPadding,
                                c = s.getViewport();
                            return (
                                !n && e.isDom && t.is(":visible") && ((n = t.find("img:first")).length || (n = t)),
                                d(n) ? ((r = n.offset()), n.is("img") && ((i = n.outerWidth()), (o = n.outerHeight()))) : ((r.top = c.y + (c.h - o) * e.topRatio), (r.left = c.x + (c.w - i) * e.leftRatio)),
                                ("fixed" === s.wrap.css("position") || e.locked) && ((r.top -= c.y), (r.left -= c.x)),
                                (r = { top: m(r.top - a * e.topRatio), left: m(r.left - l * e.leftRatio), width: m(i + l), height: m(o + a) })
                            );
                        },
                        step: function (e, t) {
                            var n,
                                r,
                                i = t.prop,
                                o = s.current,
                                a = o.wrapSpace,
                                l = o.skinSpace;
                            ("width" !== i && "height" !== i) ||
                                ((n = t.end === t.start ? 1 : (e - t.start) / (t.end - t.start)),
                                s.isClosing && (n = 1 - n),
                                (r = e - ("width" === i ? o.wPadding : o.hPadding)),
                                s.skin[i](f("width" === i ? r : r - a * n)),
                                s.inner[i](f("width" === i ? r : r - a * n - l * n)));
                        },
                        zoomIn: function () {
                            var e = s.current,
                                t = e.pos,
                                r = e.openEffect,
                                i = "elastic" === r,
                                o = n.extend({ opacity: 1 }, t);
                            delete o.position,
                                i ? ((t = this.getOrigPosition()), e.openOpacity && (t.opacity = 0.1)) : "fade" === r && (t.opacity = 0.1),
                                s.wrap.css(t).animate(o, { duration: "none" === r ? 0 : e.openSpeed, easing: e.openEasing, step: i ? this.step : null, complete: s._afterZoomIn });
                        },
                        zoomOut: function () {
                            var e = s.current,
                                t = e.closeEffect,
                                n = "elastic" === t,
                                r = { opacity: 0.1 };
                            n && ((r = this.getOrigPosition()), e.closeOpacity && (r.opacity = 0.1)),
                                s.wrap.animate(r, { duration: "none" === t ? 0 : e.closeSpeed, easing: e.closeEasing, step: n ? this.step : null, complete: s._afterZoomOut });
                        },
                        changeIn: function () {
                            var e,
                                t = s.current,
                                n = t.nextEffect,
                                r = t.pos,
                                i = { opacity: 1 },
                                o = s.direction,
                                a = 200;
                            (r.opacity = 0.1),
                                "elastic" === n && ((e = "down" === o || "up" === o ? "top" : "left"), "down" === o || "right" === o ? ((r[e] = m(f(r[e]) - a)), (i[e] = "+=200px")) : ((r[e] = m(f(r[e]) + a)), (i[e] = "-=200px"))),
                                "none" === n ? s._afterZoomIn() : s.wrap.css(r).animate(i, { duration: t.nextSpeed, easing: t.nextEasing, complete: s._afterZoomIn });
                        },
                        changeOut: function () {
                            var e = s.previous,
                                t = e.prevEffect,
                                r = { opacity: 0.1 },
                                i = s.direction;
                            "elastic" === t && (r["down" === i || "up" === i ? "top" : "left"] = ("up" === i || "left" === i ? "-" : "+") + "=200px"),
                                e.wrap.animate(r, {
                                    duration: "none" === t ? 0 : e.prevSpeed,
                                    easing: e.prevEasing,
                                    complete: function () {
                                        n(this).trigger("onReset").remove();
                                    },
                                });
                        },
                    }),
                    (s.helpers.overlay = {
                        defaults: { closeClick: !0, speedOut: 200, showEarly: !0, css: {}, locked: !u, fixed: !0 },
                        overlay: null,
                        fixed: !1,
                        el: n("html"),
                        create: function (e) {
                            var t;
                            (e = n.extend({}, this.defaults, e)),
                                this.overlay && this.close(),
                                (t = s.coming ? s.coming.parent : e.parent),
                                (this.overlay = n('<div class="fancybox-overlay"></div>').appendTo(t && t.length ? t : "body")),
                                (this.fixed = !1),
                                e.fixed && s.defaults.fixed && (this.overlay.addClass("fancybox-overlay-fixed"), (this.fixed = !0));
                        },
                        open: function (e) {
                            var t = this;
                            (e = n.extend({}, this.defaults, e)),
                                this.overlay ? this.overlay.unbind(".overlay").width("auto").height("auto") : this.create(e),
                                this.fixed || (o.bind("resize.overlay", n.proxy(this.update, this)), this.update()),
                                e.closeClick &&
                                    this.overlay.bind("click.overlay", function (e) {
                                        if (n(e.target).hasClass("fancybox-overlay")) return s.isActive ? s.close() : t.close(), !1;
                                    }),
                                this.overlay.css(e.css).show();
                        },
                        close: function () {
                            o.unbind("resize.overlay"),
                                this.el.hasClass("fancybox-lock") && (n(".fancybox-margin").removeClass("fancybox-margin"), this.el.removeClass("fancybox-lock"), o.scrollTop(this.scrollV).scrollLeft(this.scrollH)),
                                n(".fancybox-overlay").remove().hide(),
                                n.extend(this, { overlay: null, fixed: !1 });
                        },
                        update: function () {
                            var e,
                                n = "100%";
                            this.overlay.width(n).height("100%"),
                                l ? ((e = Math.max(t.documentElement.offsetWidth, t.body.offsetWidth)), a.width() > e && (n = a.width())) : a.width() > o.width() && (n = a.width()),
                                this.overlay.width(n).height(a.height());
                        },
                        onReady: function (e, t) {
                            var r = this.overlay;
                            n(".fancybox-overlay").stop(!0, !0),
                                r || this.create(e),
                                e.locked && this.fixed && t.fixed && ((t.locked = this.overlay.append(t.wrap)), (t.fixed = !1)),
                                !0 === e.showEarly && this.beforeShow.apply(this, arguments);
                        },
                        beforeShow: function (e, t) {
                            t.locked &&
                                !this.el.hasClass("fancybox-lock") &&
                                (!1 !== this.fixPosition &&
                                    n("*")
                                        .filter(function () {
                                            return "fixed" === n(this).css("position") && !n(this).hasClass("fancybox-overlay") && !n(this).hasClass("fancybox-wrap");
                                        })
                                        .addClass("fancybox-margin"),
                                this.el.addClass("fancybox-margin"),
                                (this.scrollV = o.scrollTop()),
                                (this.scrollH = o.scrollLeft()),
                                this.el.addClass("fancybox-lock"),
                                o.scrollTop(this.scrollV).scrollLeft(this.scrollH)),
                                this.open(e);
                        },
                        onUpdate: function () {
                            this.fixed || this.update();
                        },
                        afterClose: function (e) {
                            this.overlay && !s.coming && this.overlay.fadeOut(e.speedOut, n.proxy(this.close, this));
                        },
                    }),
                    (s.helpers.title = {
                        defaults: { type: "float", position: "bottom" },
                        beforeShow: function (e) {
                            var t,
                                r,
                                i = s.current,
                                o = i.title,
                                a = e.type;
                            if ((n.isFunction(o) && (o = o.call(i.element, i)), p(o) && "" !== n.trim(o))) {
                                switch (((t = n('<div class="fancybox-title fancybox-title-' + a + '-wrap">' + o + "</div>")), a)) {
                                    case "inside":
                                        r = s.skin;
                                        break;
                                    case "outside":
                                        r = s.wrap;
                                        break;
                                    case "over":
                                        r = s.inner;
                                        break;
                                    default:
                                        (r = s.skin), t.appendTo("body"), l && t.width(t.width()), t.wrapInner('<span class="child"></span>'), (s.current.margin[2] += Math.abs(f(t.css("margin-bottom"))));
                                }
                                t["top" === e.position ? "prependTo" : "appendTo"](r);
                            }
                        },
                    }),
                    (n.fn.fancybox = function (e) {
                        var t,
                            r = n(this),
                            i = this.selector || "",
                            o = function (o) {
                                var a,
                                    l,
                                    c = n(this).blur(),
                                    u = t;
                                o.ctrlKey ||
                                    o.altKey ||
                                    o.shiftKey ||
                                    o.metaKey ||
                                    c.is(".fancybox-wrap") ||
                                    ((a = e.groupAttr || "data-fancybox-group"),
                                    (l = c.attr(a)) || ((a = "rel"), (l = c.get(0)[a])),
                                    l && "" !== l && "nofollow" !== l && (u = (c = (c = i.length ? n(i) : r).filter("[" + a + '="' + l + '"]')).index(this)),
                                    (e.index = u),
                                    !1 !== s.open(c, e) && o.preventDefault());
                            };
                        return (
                            (t = (e = e || {}).index || 0),
                            i && !1 !== e.live ? a.undelegate(i, "click.fb-start").delegate(i + ":not('.fancybox-item, .fancybox-nav')", "click.fb-start", o) : r.unbind("click.fb-start").bind("click.fb-start", o),
                            this.filter("[data-fancybox-start=1]").trigger("click"),
                            this
                        );
                    }),
                    a.ready(function () {
                        var t, o, a, l;
                        n.scrollbarWidth === r &&
                            (n.scrollbarWidth = function () {
                                var e = n('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo("body"),
                                    t = e.children(),
                                    r = t.innerWidth() - t.height(99).innerWidth();
                                return e.remove(), r;
                            }),
                            n.support.fixedPosition === r && (n.support.fixedPosition = ((a = n('<div style="position:fixed;top:20px;"></div>').appendTo("body")), (l = 20 === a[0].offsetTop || 15 === a[0].offsetTop), a.remove(), l)),
                            n.extend(s.defaults, { scrollbarWidth: n.scrollbarWidth(), fixed: n.support.fixedPosition, parent: n("body") }),
                            (t = n(e).width()),
                            i.addClass("fancybox-lock-test"),
                            (o = n(e).width()),
                            i.removeClass("fancybox-lock-test"),
                            n("<style type='text/css'>.fancybox-margin{margin-right:" + (o - t) + "px;}</style>").appendTo("head");
                    });
            })(window, document, e);
        }.call(this, n(0)));
    },
    function (e, t, n) {
        "use strict";
        n.r(t);
        var r = n(0),
            i = n.n(r),
            o = n(9),
            a = n.n(o),
            s = n(1);
        n(2), n(13), n(14), n(15);
        const l = {
                xs: { min: 0, max: 480, name: "xs", order: 1 },
                sm: { min: 481, max: 767, name: "sm", order: 2 },
                md: { min: 768, max: 991, name: "md", order: 3 },
                lg: { min: 992, max: 1199, name: "lg", order: 4 },
                xl: { min: 1200, max: Number.POSITIVE_INFINITY, name: "xl", order: 5 },
            },
            c = "wetheme-toggle-right-drawer",
            u = "wetheme-toggle-left-drawer",
            d = "wetheme-cart-update";
        class p {
            constructor() {
                (this.$ = void 0),
                    (this.translations = void 0),
                    (this.moneyFormat = void 0),
                    (this.giftwrapProduct = void 0),
                    (this.giftwrapEnabled = void 0),
                    (this.breakpoint = void 0),
                    (this.formatMoney = (e, t) => {
                        var n = this.moneyFormat;
                        "string" == typeof e && (e = e.replace(".", ""));
                        var r = "",
                            i = /\{\{\s*(\w+)\s*\}\}/,
                            o = t || n;
                        function a(e, t, n, r) {
                            if ((null == t && (t = 2), (n = n || ","), (r = r || "."), isNaN(e) || null == e)) return 0;
                            var i = (e = (e / 100).toFixed(t)).split(".");
                            return i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n) + (i[1] ? r + i[1] : "");
                        }
                        switch (o.match(i)[1]) {
                            case "amount":
                                r = a(e, 2);
                                break;
                            case "amount_no_decimals":
                                r = a(e, 0);
                                break;
                            case "amount_with_comma_separator":
                                r = a(e, 2, ".", ",");
                                break;
                            case "amount_no_decimals_with_comma_separator":
                                r = a(e, 0, ".", ",");
                                break;
                            case "amount_no_decimals_with_space_separator":
                                r = a(e, 0, " ");
                        }
                        return '<span class="money">' + o.replace(i, r) + "</span>";
                    }),
                    (this.getWindowWidth = () => Math.max(document.documentElement.clientWidth, window.innerWidth || 0)),
                    (this.getBreakpoint = (e = void 0) => {
                        const t = null == e ? this.getWindowWidth() : e;
                        let n;
                        return (
                            Object.values(l).forEach((e) => {
                                t >= e.min && t <= e.max && (n = e);
                            }),
                            n
                        );
                    }),
                    (this.toggleRightDrawer = (e = "cart", t = void 0, n = {}) => {}),
                    (this.toggleLeftDrawer = (e = void 0) => {}),
                    (this.updateCartDrawer = (e) => {}),
                    (this.loadYoutubeApi = () => {}),
                    (this.loadVimeoApi = () => {}),
                    (this.loadGoogleMapApi = (e) => {}),
                    (this.createScript = (e, t) => {}),
                    (this.registerComponent = (e) => {}),
                    (this.addBadges = (e, t) => {}),
                    (this.loadReviews = ({ products: e, badges: t }) => {});
            }
        }
        class h {
            constructor(e, t) {
                (this.onWindowResizeRaw = ({ width: e }) => {}),
                    (this.onWindowResize = ({ width: e, oldWidth: t, breakpoint: n }) => {}),
                    (this.onWindowResizeBreakpoint = ({ width: e, breakpoint: t, oldBreakpoint: n }) => {}),
                    (this.onWindowScroll = () => {}),
                    (this.theme = e),
                    (this.element = t),
                    e.registerComponent(this);
            }
        }
        class f extends h {
            constructor(e, t, n) {
                super(e, t),
                    (this.onSectionSelect = ({ element: e, sectionId: t, load: n }) => {}),
                    (this.onSectionDeselect = ({ element: e, sectionId: t }) => {}),
                    (this.onSectionReorder = ({ element: e, sectionId: t }) => {}),
                    (this.onBlockSelect = ({ element: e, sectionId: t, blockId: n, load: r }) => {}),
                    (this.onBlockDeselect = ({ element: e, sectionId: t, blockId: n }) => {}),
                    (this.destroy = ({ element: e }) => {}),
                    (this.theme = e),
                    (this.element = t);
            }
        }
        class m {
            constructor(e, t) {
                (this.handleToggle = (e) => {
                    this.toggle(e.detail.forceOpen);
                }),
                    (this.close = () => {
                        document.body.classList.remove("js-drawer-open"), document.body.classList.remove("js-drawer-open-left"), (this.isOpen = !1);
                    }),
                    (this.open = () => {
                        document.body.classList.add("js-drawer-open"), document.body.classList.add("js-drawer-open-left"), (this.isOpen = !0);
                    }),
                    (this.toggle = (e = void 0) => {
                        !0 === e ? this.open() : !1 === e || this.isOpen ? this.close() : this.open();
                    }),
                    (this.theme = e),
                    (this.element = t),
                    (this.isOpen = !1),
                    document.documentElement.addEventListener(u, this.handleToggle),
                    i()(".mobile-nav__toggle")
                        .off("click")
                        .on("click", function (e) {
                            i()(this).parent().toggleClass("mobile-nav--expanded");
                        }),
                    this.element.querySelector(".mobile-menu--close-btn").addEventListener("click", (e) => {
                        e.preventDefault, this.close();
                    });
            }
        }
        var g = n(4),
            v = n.n(g);
        class y {
            constructor(e, t) {
                (this.handleFocus = (e) => {
                    i()(".site-nav__dropdown").has(e).length > 0 ? this.addFocus(e.closest(".site-nav--has-dropdown").find("a")) : (this.removeFocus(this.$topLevel), this.addFocus(e));
                }),
                    (this.showDropdown = (e) => {
                        e.addClass(this.activeClass);
                        const t = this;
                        i()(".site-header").hasClass("overlay-header") && i()(".sticky-header").addClass("sticked sticky-header-open"), i()(".sticky-header").removeClass("sticky-header-transformed");
                        var n = e.parent().find(".site-nav__subdropdown"),
                            r = Math.max.apply(
                                null,
                                n
                                    .map(function () {
                                        return i()(this).width();
                                    })
                                    .get()
                            );
                        e.offset().left + e.outerWidth() + r > i()("body").width() ? n.css({ right: "100%", left: "auto" }) : n.css({ left: "100%", right: "auto" }),
                            setTimeout(function () {
                                i()(document.body).on("touchstart", (n) => {
                                    0 === i()(n.target).closest(".site-nav__link,.dropdown-submenu").length && t.hideDropdown(e);
                                });
                            }, 250);
                    }),
                    (this.hideDropdown = (e) => {
                        void 0 !== e ? e.removeClass(this.activeClass) : i()(".site-nav--has-dropdown").removeClass(this.activeClass),
                            i()(document.body).off("touchstart"),
                            i()(".site-header").hasClass("overlay-header") && i()(".sticky-header").removeClass("sticky-header-open"),
                            0 === i()(".nav-hover").length && i()(".sticky-header").addClass("sticky-header-transformed");
                    }),
                    (this.addFocus = (e) => {
                        e.addClass(this.focusClass);
                    }),
                    (this.removeFocus = (e) => {
                        e.removeClass(this.focusClass);
                    });
                const n = this;
                (this.theme = e),
                    (this.element = t),
                    (this.$element = i()(t)),
                    (this.$nav = i()("#AccessibleNav")),
                    (this.$allLinks = this.$nav.find("a")),
                    (this.$topLevel = this.$nav.children("li").find("a")),
                    (this.$parents = this.$nav.find(".site-nav--has-dropdown")),
                    (this.$subMenuLinks = this.$nav.find(".site-nav__dropdown").find("a")),
                    (this.activeClass = "nav-hover"),
                    (this.focusClass = "nav-focus"),
                    this.$parents.on("mouseover touchstart", function (e) {
                        var t = !0,
                            r = i()(this);
                        return r.hasClass(n.activeClass) || (e.preventDefault(), n.hideDropdown(r.siblings()), (t = !1)), n.showDropdown(r), t;
                    }),
                    this.$parents.each((e, t) => {
                        v()(
                            t,
                            function (e) {
                                i()("." + n.activeClass).each(function (t) {
                                    var r = i()(this);
                                    0 === r.has(e.target).length && r.removeClass(n.activeClass);
                                });
                            },
                            function () {}
                        );
                    }),
                    i()(".site-header").on("mouseleave", () => {
                        n.hideDropdown();
                    }),
                    i()(".site-nav__dropdown").on("mouseleave", (e) => {
                        n.hideDropdown(i()(this));
                    }),
                    this.$parents.each((e, t) => {
                        !i()(t).hasClass("mega-menu") &&
                            i()(t).parent().hasClass("site-nav") &&
                            i()(t).on("mouseleave", () => {
                                n.hideDropdown();
                            });
                    }),
                    this.$subMenuLinks.on("touchstart", function (e) {
                        e.stopImmediatePropagation();
                    }),
                    this.$allLinks.focus(function () {
                        n.handleFocus(i()(this));
                    }),
                    this.$allLinks.blur(() => {
                        n.removeFocus(n.$topLevel);
                    });
            }
        }
        class b extends h {
            constructor(e, t) {
                super(e, t),
                    (this.onSelectChange = () => {
                        this.form.submit();
                    }),
                    (this.form = this.element.querySelector(".localization-selector-form-autosubmit")),
                    this.form &&
                        Array.prototype.forEach.call(this.form.querySelectorAll("select"), (e) => {
                            e.addEventListener("change", this.onSelectChange);
                        });
            }
        }
        class w extends f {
            constructor(e, t, n) {
                super(e, t, n),
                    (this.onCartUpdate = (e) => {
                        Array.prototype.forEach.call(document.querySelectorAll(".cart-item-count-header--quantity"), (t) => {
                            t.classList.add("hide");
                            const n = e.detail.cart.item_count > 0;
                            (t.textContent = e.detail.cart.item_count), n && t.classList.remove("hide");
                        });
                        const t = this.theme.formatMoney(e.detail.cart.total_price);
                        Array.prototype.forEach.call(document.querySelectorAll(".cart-item-count-header--total"), (n) => {
                            n.classList.add("hide");
                            const r = e.detail.cart.total_price > 0;
                            (n.innerHTML = t), r && n.classList.remove("hide");
                        });
                    }),
                    (this.onCartButtonClick = (e) => {
                        e.preventDefault(), this.theme.toggleRightDrawer("cart");
                    }),
                    (this.onMobileMenuButtonClick = (e) => {
                        e.preventDefault(), this.mobileMenu.toggle();
                    }),
                    (this.loadLogIn = () => {
                        const e = this.element.querySelector(".log-in-button");
                        e && e.addEventListener("click", this.onLogIn);
                    }),
                    (this.onLogIn = (e) => {
                        e.preventDefault(), this.theme.toggleRightDrawer("login", !0);
                    }),
                    (this.loadSearchDrawer = () => {
                        document.querySelectorAll(".search-button").forEach((e) => {
                            e.addEventListener("click", this.onSearch);
                        });
                    }),
                    (this.onSearch = (e) => {
                        e.preventDefault(), this.theme.toggleRightDrawer("search", !0);
                    }),
                    (this.loadAccessibleMenu = () => {
                        this.$element.find(".site-nav").addClass("js"),
                            this.$element.find(".site-nav li a").focus(function () {
                                i()(this).parent().children("ul").fadeIn();
                            }),
                            this.$element.find(".site-nav li li a").off();
                        const e = this;
                        this.$element.find(".mobile-nav__link").on("click", function () {
                            this.href && this.href.split("#")[0] === window.location.href.split("#")[0] && e.theme.toggleLeftDrawer(!1);
                        });
                    }),
                    (this.loadStickyHeader = () => {
                        const e = this.element.closest(".shopify-section");
                        e.classList.add("sticky-header");
                        new IntersectionObserver(
                            ([e]) => {
                                e.target.classList.toggle("sticked", e.intersectionRatio < 1);
                            },
                            { threshold: [1] }
                        ).observe(e);
                    }),
                    (this.onBlockSelect = ({ element: e }) => {
                        e.dataset.megaMenuBlockId &&
                            (this.$element
                                .find("[data-mega-menu-block-id=" + e.dataset.megaMenuBlockId + "]")
                                .closest("li.mega-menu")
                                .addClass("force-open"),
                            this.$element.find(".overlay-header").addClass("force-hover"));
                    }),
                    (this.onBlockDeselect = () => {
                        this.$element.find("li.mega-menu.force-open").removeClass("force-open"), this.$element.find(".overlay-header").removeClass("force-hover");
                    }),
                    (this.$element = i()(this.element)),
                    Array.prototype.forEach.call(this.element.querySelectorAll(".js-drawer-open-right-link"), (e) => e.addEventListener("click", this.onCartButtonClick)),
                    this.element.querySelector(".js-drawer-open-left-link").addEventListener("click", this.onMobileMenuButtonClick),
                    (this.mobileMenu = new m(e, this.element.querySelector(".drawer--left"))),
                    document.documentElement.addEventListener(d, this.onCartUpdate),
                    this.element.querySelector("#NavDrawerOverlay").addEventListener("click", () => this.theme.toggleLeftDrawer(!1)),
                    this.loadAccessibleMenu(),
                    "true" === this.element.dataset.headerSticky && this.loadStickyHeader(),
                    this.loadLogIn(),
                    this.loadSearchDrawer(),
                    (this.menu = new y(this, t)),
                    (this.localization = new b(e, t));
            }
        }
        class x extends f {
            constructor(e, t, n) {
                super(e, t, n),
                    (this.fixFooterToBottom = () => {
                        this.footerWrapper.classList.remove("fix-to-bottom"), window.innerHeight > document.body.offsetHeight && this.footerWrapper.classList.add("fix-to-bottom");
                    }),
                    (this.onWindowResize = () => {
                        this.fixFooterToBottom();
                    }),
                    (this.footerWrapper = document.querySelector(".footer-wrapper")),
                    this.fixFooterToBottom(),
                    (this.localization = new b(e, t));
            }
        }
        class E extends f {}
        class C extends f {}
        var S = n(5),
            T = n.n(S);
        class k {
            constructor(e, t) {
                (this.load = () => {
                    (this.observer = new IntersectionObserver(
                        () => {
                            this.apply();
                        },
                        { threshold: [1] }
                    )),
                        this.observer.observe(this.element);
                }),
                    (this.apply = () => {
                        Array.prototype.forEach.call(this.element.querySelectorAll(".kb-enabled"), (e, t) => {
                            setTimeout(() => {
                                e.classList.add("in-viewport");
                            }, 150 * t);
                        });
                    }),
                    (this.reapply = () => {
                        Array.prototype.forEach.call(this.element.querySelectorAll(".kb-enabled"), (e) => {
                            e.classList.contains("in-viewport") &&
                                (e.classList.add("no-anim"),
                                e.classList.remove("in-viewport"),
                                setTimeout(() => {
                                    e.classList.remove("no-anim"), e.classList.add("in-viewport");
                                }, 150));
                        });
                    }),
                    (this.theme = e),
                    (this.element = t),
                    this.load();
            }
        }
        class A extends f {
            constructor(e, t, n) {
                super(e, t, n),
                    (this.hoverEffect = (e) => {
                        const t = i()("#" + e.data("overlayId"));
                        e.hover(
                            () => {
                                t.addClass("active");
                            },
                            () => {
                                t.removeClass("active");
                            }
                        ),
                            e.is(":hover") && t.addClass("active");
                    }),
                    T()(this.element.querySelectorAll(".homepage-hero-content-overlay-menu-item"), { background: !0 }, () => {
                        (this.kenBurns = new k(e, t)),
                            i()(".homepage-hero-text-advert-link").each((e, t) => {
                                this.hoverEffect(i()(t));
                            }),
                            i()(".homepage-hero-menu li").each((e, t) => {
                                this.hoverEffect(i()(t));
                            });
                    });
            }
        }
        function _(e) {
            return null !== e && "object" == typeof e && "constructor" in e && e.constructor === Object;
        }
        function L(e, t) {
            void 0 === e && (e = {}),
                void 0 === t && (t = {}),
                Object.keys(t).forEach(function (n) {
                    void 0 === e[n] ? (e[n] = t[n]) : _(t[n]) && _(e[n]) && Object.keys(t[n]).length > 0 && L(e[n], t[n]);
                });
        }
        var $ = "undefined" != typeof document ? document : {},
            D = {
                body: {},
                addEventListener: function () {},
                removeEventListener: function () {},
                activeElement: { blur: function () {}, nodeName: "" },
                querySelector: function () {
                    return null;
                },
                querySelectorAll: function () {
                    return [];
                },
                getElementById: function () {
                    return null;
                },
                createEvent: function () {
                    return { initEvent: function () {} };
                },
                createElement: function () {
                    return {
                        children: [],
                        childNodes: [],
                        style: {},
                        setAttribute: function () {},
                        getElementsByTagName: function () {
                            return [];
                        },
                    };
                },
                createElementNS: function () {
                    return {};
                },
                importNode: function () {
                    return null;
                },
                location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
            };
        L($, D);
        var O = "undefined" != typeof window ? window : {};
        L(O, {
            document: D,
            navigator: { userAgent: "" },
            location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
            history: { replaceState: function () {}, pushState: function () {}, go: function () {}, back: function () {} },
            CustomEvent: function () {
                return this;
            },
            addEventListener: function () {},
            removeEventListener: function () {},
            getComputedStyle: function () {
                return {
                    getPropertyValue: function () {
                        return "";
                    },
                };
            },
            Image: function () {},
            Date: function () {},
            screen: {},
            setTimeout: function () {},
            clearTimeout: function () {},
            matchMedia: function () {
                return {};
            },
        });
        class q {
            constructor(e) {
                const t = this;
                for (let n = 0; n < e.length; n += 1) t[n] = e[n];
                return (t.length = e.length), this;
            }
        }
        function M(e, t) {
            const n = [];
            let r = 0;
            if (e && !t && e instanceof q) return e;
            if (e)
                if ("string" == typeof e) {
                    let i, o;
                    const a = e.trim();
                    if (a.indexOf("<") >= 0 && a.indexOf(">") >= 0) {
                        let e = "div";
                        for (
                            0 === a.indexOf("<li") && (e = "ul"),
                                0 === a.indexOf("<tr") && (e = "tbody"),
                                (0 !== a.indexOf("<td") && 0 !== a.indexOf("<th")) || (e = "tr"),
                                0 === a.indexOf("<tbody") && (e = "table"),
                                0 === a.indexOf("<option") && (e = "select"),
                                o = $.createElement(e),
                                o.innerHTML = a,
                                r = 0;
                            r < o.childNodes.length;
                            r += 1
                        )
                            n.push(o.childNodes[r]);
                    } else for (i = t || "#" !== e[0] || e.match(/[ .<>:~]/) ? (t || $).querySelectorAll(e.trim()) : [$.getElementById(e.trim().split("#")[1])], r = 0; r < i.length; r += 1) i[r] && n.push(i[r]);
                } else if (e.nodeType || e === O || e === $) n.push(e);
                else if (e.length > 0 && e[0].nodeType) for (r = 0; r < e.length; r += 1) n.push(e[r]);
            return new q(n);
        }
        function P(e) {
            const t = [];
            for (let n = 0; n < e.length; n += 1) -1 === t.indexOf(e[n]) && t.push(e[n]);
            return t;
        }
        (M.fn = q.prototype), (M.Class = q), (M.Dom7 = q);
        "resize scroll".split(" ");
        const I = {
            addClass: function (e) {
                if (void 0 === e) return this;
                const t = e.split(" ");
                for (let e = 0; e < t.length; e += 1) for (let n = 0; n < this.length; n += 1) void 0 !== this[n] && void 0 !== this[n].classList && this[n].classList.add(t[e]);
                return this;
            },
            removeClass: function (e) {
                const t = e.split(" ");
                for (let e = 0; e < t.length; e += 1) for (let n = 0; n < this.length; n += 1) void 0 !== this[n] && void 0 !== this[n].classList && this[n].classList.remove(t[e]);
                return this;
            },
            hasClass: function (e) {
                return !!this[0] && this[0].classList.contains(e);
            },
            toggleClass: function (e) {
                const t = e.split(" ");
                for (let e = 0; e < t.length; e += 1) for (let n = 0; n < this.length; n += 1) void 0 !== this[n] && void 0 !== this[n].classList && this[n].classList.toggle(t[e]);
                return this;
            },
            attr: function (e, t) {
                if (1 === arguments.length && "string" == typeof e) return this[0] ? this[0].getAttribute(e) : void 0;
                for (let n = 0; n < this.length; n += 1)
                    if (2 === arguments.length) this[n].setAttribute(e, t);
                    else for (const t in e) (this[n][t] = e[t]), this[n].setAttribute(t, e[t]);
                return this;
            },
            removeAttr: function (e) {
                for (let t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
                return this;
            },
            data: function (e, t) {
                let n;
                if (void 0 !== t) {
                    for (let r = 0; r < this.length; r += 1) (n = this[r]), n.dom7ElementDataStorage || (n.dom7ElementDataStorage = {}), (n.dom7ElementDataStorage[e] = t);
                    return this;
                }
                if (((n = this[0]), n)) {
                    if (n.dom7ElementDataStorage && e in n.dom7ElementDataStorage) return n.dom7ElementDataStorage[e];
                    const t = n.getAttribute(`data-${e}`);
                    return t || void 0;
                }
            },
            transform: function (e) {
                for (let t = 0; t < this.length; t += 1) {
                    const n = this[t].style;
                    (n.webkitTransform = e), (n.transform = e);
                }
                return this;
            },
            transition: function (e) {
                "string" != typeof e && (e = `${e}ms`);
                for (let t = 0; t < this.length; t += 1) {
                    const n = this[t].style;
                    (n.webkitTransitionDuration = e), (n.transitionDuration = e);
                }
                return this;
            },
            on: function (...e) {
                let [t, n, r, i] = e;
                function o(e) {
                    const t = e.target;
                    if (!t) return;
                    const i = e.target.dom7EventData || [];
                    if ((i.indexOf(e) < 0 && i.unshift(e), M(t).is(n))) r.apply(t, i);
                    else {
                        const e = M(t).parents();
                        for (let t = 0; t < e.length; t += 1) M(e[t]).is(n) && r.apply(e[t], i);
                    }
                }
                function a(e) {
                    const t = (e && e.target && e.target.dom7EventData) || [];
                    t.indexOf(e) < 0 && t.unshift(e), r.apply(this, t);
                }
                "function" == typeof e[1] && (([t, r, i] = e), (n = void 0)), i || (i = !1);
                const s = t.split(" ");
                let l;
                for (let e = 0; e < this.length; e += 1) {
                    const t = this[e];
                    if (n)
                        for (l = 0; l < s.length; l += 1) {
                            const e = s[l];
                            t.dom7LiveListeners || (t.dom7LiveListeners = {}), t.dom7LiveListeners[e] || (t.dom7LiveListeners[e] = []), t.dom7LiveListeners[e].push({ listener: r, proxyListener: o }), t.addEventListener(e, o, i);
                        }
                    else
                        for (l = 0; l < s.length; l += 1) {
                            const e = s[l];
                            t.dom7Listeners || (t.dom7Listeners = {}), t.dom7Listeners[e] || (t.dom7Listeners[e] = []), t.dom7Listeners[e].push({ listener: r, proxyListener: a }), t.addEventListener(e, a, i);
                        }
                }
                return this;
            },
            off: function (...e) {
                let [t, n, r, i] = e;
                "function" == typeof e[1] && (([t, r, i] = e), (n = void 0)), i || (i = !1);
                const o = t.split(" ");
                for (let e = 0; e < o.length; e += 1) {
                    const t = o[e];
                    for (let e = 0; e < this.length; e += 1) {
                        const o = this[e];
                        let a;
                        if ((!n && o.dom7Listeners ? (a = o.dom7Listeners[t]) : n && o.dom7LiveListeners && (a = o.dom7LiveListeners[t]), a && a.length))
                            for (let e = a.length - 1; e >= 0; e -= 1) {
                                const n = a[e];
                                (r && n.listener === r) || (r && n.listener && n.listener.dom7proxy && n.listener.dom7proxy === r)
                                    ? (o.removeEventListener(t, n.proxyListener, i), a.splice(e, 1))
                                    : r || (o.removeEventListener(t, n.proxyListener, i), a.splice(e, 1));
                            }
                    }
                }
                return this;
            },
            trigger: function (...e) {
                const t = e[0].split(" "),
                    n = e[1];
                for (let r = 0; r < t.length; r += 1) {
                    const i = t[r];
                    for (let t = 0; t < this.length; t += 1) {
                        const r = this[t];
                        let o;
                        try {
                            o = new O.CustomEvent(i, { detail: n, bubbles: !0, cancelable: !0 });
                        } catch (e) {
                            (o = $.createEvent("Event")), o.initEvent(i, !0, !0), (o.detail = n);
                        }
                        (r.dom7EventData = e.filter((e, t) => t > 0)), r.dispatchEvent(o), (r.dom7EventData = []), delete r.dom7EventData;
                    }
                }
                return this;
            },
            transitionEnd: function (e) {
                const t = ["webkitTransitionEnd", "transitionend"],
                    n = this;
                let r;
                function i(o) {
                    if (o.target === this) for (e.call(this, o), r = 0; r < t.length; r += 1) n.off(t[r], i);
                }
                if (e) for (r = 0; r < t.length; r += 1) n.on(t[r], i);
                return this;
            },
            outerWidth: function (e) {
                if (this.length > 0) {
                    if (e) {
                        const e = this.styles();
                        return this[0].offsetWidth + parseFloat(e.getPropertyValue("margin-right")) + parseFloat(e.getPropertyValue("margin-left"));
                    }
                    return this[0].offsetWidth;
                }
                return null;
            },
            outerHeight: function (e) {
                if (this.length > 0) {
                    if (e) {
                        const e = this.styles();
                        return this[0].offsetHeight + parseFloat(e.getPropertyValue("margin-top")) + parseFloat(e.getPropertyValue("margin-bottom"));
                    }
                    return this[0].offsetHeight;
                }
                return null;
            },
            offset: function () {
                if (this.length > 0) {
                    const e = this[0],
                        t = e.getBoundingClientRect(),
                        n = $.body,
                        r = e.clientTop || n.clientTop || 0,
                        i = e.clientLeft || n.clientLeft || 0,
                        o = e === O ? O.scrollY : e.scrollTop,
                        a = e === O ? O.scrollX : e.scrollLeft;
                    return { top: t.top + o - r, left: t.left + a - i };
                }
                return null;
            },
            css: function (e, t) {
                let n;
                if (1 === arguments.length) {
                    if ("string" != typeof e) {
                        for (n = 0; n < this.length; n += 1) for (let t in e) this[n].style[t] = e[t];
                        return this;
                    }
                    if (this[0]) return O.getComputedStyle(this[0], null).getPropertyValue(e);
                }
                if (2 === arguments.length && "string" == typeof e) {
                    for (n = 0; n < this.length; n += 1) this[n].style[e] = t;
                    return this;
                }
                return this;
            },
            each: function (e) {
                if (!e) return this;
                for (let t = 0; t < this.length; t += 1) if (!1 === e.call(this[t], t, this[t])) return this;
                return this;
            },
            html: function (e) {
                if (void 0 === e) return this[0] ? this[0].innerHTML : void 0;
                for (let t = 0; t < this.length; t += 1) this[t].innerHTML = e;
                return this;
            },
            text: function (e) {
                if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
                for (let t = 0; t < this.length; t += 1) this[t].textContent = e;
                return this;
            },
            is: function (e) {
                const t = this[0];
                let n, r;
                if (!t || void 0 === e) return !1;
                if ("string" == typeof e) {
                    if (t.matches) return t.matches(e);
                    if (t.webkitMatchesSelector) return t.webkitMatchesSelector(e);
                    if (t.msMatchesSelector) return t.msMatchesSelector(e);
                    for (n = M(e), r = 0; r < n.length; r += 1) if (n[r] === t) return !0;
                    return !1;
                }
                if (e === $) return t === $;
                if (e === O) return t === O;
                if (e.nodeType || e instanceof q) {
                    for (n = e.nodeType ? [e] : e, r = 0; r < n.length; r += 1) if (n[r] === t) return !0;
                    return !1;
                }
                return !1;
            },
            index: function () {
                let e,
                    t = this[0];
                if (t) {
                    for (e = 0; null !== (t = t.previousSibling); ) 1 === t.nodeType && (e += 1);
                    return e;
                }
            },
            eq: function (e) {
                if (void 0 === e) return this;
                const t = this.length;
                let n;
                return e > t - 1 ? new q([]) : e < 0 ? ((n = t + e), new q(n < 0 ? [] : [this[n]])) : new q([this[e]]);
            },
            append: function (...e) {
                let t;
                for (let n = 0; n < e.length; n += 1) {
                    t = e[n];
                    for (let e = 0; e < this.length; e += 1)
                        if ("string" == typeof t) {
                            const n = $.createElement("div");
                            for (n.innerHTML = t; n.firstChild; ) this[e].appendChild(n.firstChild);
                        } else if (t instanceof q) for (let n = 0; n < t.length; n += 1) this[e].appendChild(t[n]);
                        else this[e].appendChild(t);
                }
                return this;
            },
            prepend: function (e) {
                let t, n;
                for (t = 0; t < this.length; t += 1)
                    if ("string" == typeof e) {
                        const r = $.createElement("div");
                        for (r.innerHTML = e, n = r.childNodes.length - 1; n >= 0; n -= 1) this[t].insertBefore(r.childNodes[n], this[t].childNodes[0]);
                    } else if (e instanceof q) for (n = 0; n < e.length; n += 1) this[t].insertBefore(e[n], this[t].childNodes[0]);
                    else this[t].insertBefore(e, this[t].childNodes[0]);
                return this;
            },
            next: function (e) {
                return this.length > 0
                    ? e
                        ? this[0].nextElementSibling && M(this[0].nextElementSibling).is(e)
                            ? new q([this[0].nextElementSibling])
                            : new q([])
                        : this[0].nextElementSibling
                        ? new q([this[0].nextElementSibling])
                        : new q([])
                    : new q([]);
            },
            nextAll: function (e) {
                const t = [];
                let n = this[0];
                if (!n) return new q([]);
                for (; n.nextElementSibling; ) {
                    const r = n.nextElementSibling;
                    e ? M(r).is(e) && t.push(r) : t.push(r), (n = r);
                }
                return new q(t);
            },
            prev: function (e) {
                if (this.length > 0) {
                    const t = this[0];
                    return e ? (t.previousElementSibling && M(t.previousElementSibling).is(e) ? new q([t.previousElementSibling]) : new q([])) : t.previousElementSibling ? new q([t.previousElementSibling]) : new q([]);
                }
                return new q([]);
            },
            prevAll: function (e) {
                const t = [];
                let n = this[0];
                if (!n) return new q([]);
                for (; n.previousElementSibling; ) {
                    const r = n.previousElementSibling;
                    e ? M(r).is(e) && t.push(r) : t.push(r), (n = r);
                }
                return new q(t);
            },
            parent: function (e) {
                const t = [];
                for (let n = 0; n < this.length; n += 1) null !== this[n].parentNode && (e ? M(this[n].parentNode).is(e) && t.push(this[n].parentNode) : t.push(this[n].parentNode));
                return M(P(t));
            },
            parents: function (e) {
                const t = [];
                for (let n = 0; n < this.length; n += 1) {
                    let r = this[n].parentNode;
                    for (; r; ) e ? M(r).is(e) && t.push(r) : t.push(r), (r = r.parentNode);
                }
                return M(P(t));
            },
            closest: function (e) {
                let t = this;
                return void 0 === e ? new q([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
            },
            find: function (e) {
                const t = [];
                for (let n = 0; n < this.length; n += 1) {
                    const r = this[n].querySelectorAll(e);
                    for (let e = 0; e < r.length; e += 1) t.push(r[e]);
                }
                return new q(t);
            },
            children: function (e) {
                const t = [];
                for (let n = 0; n < this.length; n += 1) {
                    const r = this[n].childNodes;
                    for (let n = 0; n < r.length; n += 1) e ? 1 === r[n].nodeType && M(r[n]).is(e) && t.push(r[n]) : 1 === r[n].nodeType && t.push(r[n]);
                }
                return new q(P(t));
            },
            filter: function (e) {
                const t = [],
                    n = this;
                for (let r = 0; r < n.length; r += 1) e.call(n[r], r, n[r]) && t.push(n[r]);
                return new q(t);
            },
            remove: function () {
                for (let e = 0; e < this.length; e += 1) this[e].parentNode && this[e].parentNode.removeChild(this[e]);
                return this;
            },
            add: function (...e) {
                const t = this;
                let n, r;
                for (n = 0; n < e.length; n += 1) {
                    const i = M(e[n]);
                    for (r = 0; r < i.length; r += 1) (t[t.length] = i[r]), (t.length += 1);
                }
                return t;
            },
            styles: function () {
                return this[0] ? O.getComputedStyle(this[0], null) : {};
            },
        };
        Object.keys(I).forEach((e) => {
            M.fn[e] = M.fn[e] || I[e];
        });
        const N = {
                deleteProps(e) {
                    const t = e;
                    Object.keys(t).forEach((e) => {
                        try {
                            t[e] = null;
                        } catch (e) {}
                        try {
                            delete t[e];
                        } catch (e) {}
                    });
                },
                nextTick: (e, t = 0) => setTimeout(e, t),
                now: () => Date.now(),
                getTranslate(e, t = "x") {
                    let n, r, i;
                    const o = O.getComputedStyle(e, null);
                    return (
                        O.WebKitCSSMatrix
                            ? ((r = o.transform || o.webkitTransform),
                              r.split(",").length > 6 &&
                                  (r = r
                                      .split(", ")
                                      .map((e) => e.replace(",", "."))
                                      .join(", ")),
                              (i = new O.WebKitCSSMatrix("none" === r ? "" : r)))
                            : ((i = o.MozTransform || o.OTransform || o.MsTransform || o.msTransform || o.transform || o.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")), (n = i.toString().split(","))),
                        "x" === t && (r = O.WebKitCSSMatrix ? i.m41 : 16 === n.length ? parseFloat(n[12]) : parseFloat(n[4])),
                        "y" === t && (r = O.WebKitCSSMatrix ? i.m42 : 16 === n.length ? parseFloat(n[13]) : parseFloat(n[5])),
                        r || 0
                    );
                },
                parseUrlQuery(e) {
                    const t = {};
                    let n,
                        r,
                        i,
                        o,
                        a = e || O.location.href;
                    if ("string" == typeof a && a.length)
                        for (a = a.indexOf("?") > -1 ? a.replace(/\S*\?/, "") : "", r = a.split("&").filter((e) => "" !== e), o = r.length, n = 0; n < o; n += 1)
                            (i = r[n].replace(/#\S+/g, "").split("=")), (t[decodeURIComponent(i[0])] = void 0 === i[1] ? void 0 : decodeURIComponent(i[1]) || "");
                    return t;
                },
                isObject: (e) => "object" == typeof e && null !== e && e.constructor && e.constructor === Object,
                extend(...e) {
                    const t = Object(e[0]);
                    for (let n = 1; n < e.length; n += 1) {
                        const r = e[n];
                        if (null != r) {
                            const e = Object.keys(Object(r));
                            for (let n = 0, i = e.length; n < i; n += 1) {
                                const i = e[n],
                                    o = Object.getOwnPropertyDescriptor(r, i);
                                void 0 !== o && o.enumerable && (N.isObject(t[i]) && N.isObject(r[i]) ? N.extend(t[i], r[i]) : !N.isObject(t[i]) && N.isObject(r[i]) ? ((t[i] = {}), N.extend(t[i], r[i])) : (t[i] = r[i]));
                            }
                        }
                    }
                    return t;
                },
            },
            z = {
                touch: !!("ontouchstart" in O || (O.DocumentTouch && $ instanceof O.DocumentTouch)),
                pointerEvents: !!O.PointerEvent && "maxTouchPoints" in O.navigator && O.navigator.maxTouchPoints >= 0,
                observer: "MutationObserver" in O || "WebkitMutationObserver" in O,
                passiveListener: (function () {
                    let e = !1;
                    try {
                        const t = Object.defineProperty({}, "passive", {
                            get() {
                                e = !0;
                            },
                        });
                        O.addEventListener("testPassiveListener", null, t);
                    } catch (e) {}
                    return e;
                })(),
                gestures: "ongesturestart" in O,
            };
        class R {
            constructor(e = {}) {
                const t = this;
                (t.params = e),
                    (t.eventsListeners = {}),
                    t.params &&
                        t.params.on &&
                        Object.keys(t.params.on).forEach((e) => {
                            t.on(e, t.params.on[e]);
                        });
            }
            on(e, t, n) {
                const r = this;
                if ("function" != typeof t) return r;
                const i = n ? "unshift" : "push";
                return (
                    e.split(" ").forEach((e) => {
                        r.eventsListeners[e] || (r.eventsListeners[e] = []), r.eventsListeners[e][i](t);
                    }),
                    r
                );
            }
            once(e, t, n) {
                const r = this;
                if ("function" != typeof t) return r;
                function i(...n) {
                    r.off(e, i), i.f7proxy && delete i.f7proxy, t.apply(r, n);
                }
                return (i.f7proxy = t), r.on(e, i, n);
            }
            off(e, t) {
                const n = this;
                return n.eventsListeners
                    ? (e.split(" ").forEach((e) => {
                          void 0 === t
                              ? (n.eventsListeners[e] = [])
                              : n.eventsListeners[e] &&
                                n.eventsListeners[e].length &&
                                n.eventsListeners[e].forEach((r, i) => {
                                    (r === t || (r.f7proxy && r.f7proxy === t)) && n.eventsListeners[e].splice(i, 1);
                                });
                      }),
                      n)
                    : n;
            }
            emit(...e) {
                const t = this;
                if (!t.eventsListeners) return t;
                let n, r, i;
                "string" == typeof e[0] || Array.isArray(e[0]) ? ((n = e[0]), (r = e.slice(1, e.length)), (i = t)) : ((n = e[0].events), (r = e[0].data), (i = e[0].context || t));
                return (
                    (Array.isArray(n) ? n : n.split(" ")).forEach((e) => {
                        if (t.eventsListeners && t.eventsListeners[e]) {
                            const n = [];
                            t.eventsListeners[e].forEach((e) => {
                                n.push(e);
                            }),
                                n.forEach((e) => {
                                    e.apply(i, r);
                                });
                        }
                    }),
                    t
                );
            }
            useModulesParams(e) {
                const t = this;
                t.modules &&
                    Object.keys(t.modules).forEach((n) => {
                        const r = t.modules[n];
                        r.params && N.extend(e, r.params);
                    });
            }
            useModules(e = {}) {
                const t = this;
                t.modules &&
                    Object.keys(t.modules).forEach((n) => {
                        const r = t.modules[n],
                            i = e[n] || {};
                        r.instance &&
                            Object.keys(r.instance).forEach((e) => {
                                const n = r.instance[e];
                                t[e] = "function" == typeof n ? n.bind(t) : n;
                            }),
                            r.on &&
                                t.on &&
                                Object.keys(r.on).forEach((e) => {
                                    t.on(e, r.on[e]);
                                }),
                            r.create && r.create.bind(t)(i);
                    });
            }
            static set components(e) {
                this.use && this.use(e);
            }
            static installModule(e, ...t) {
                const n = this;
                n.prototype.modules || (n.prototype.modules = {});
                const r = e.name || `${Object.keys(n.prototype.modules).length}_${N.now()}`;
                return (
                    (n.prototype.modules[r] = e),
                    e.proto &&
                        Object.keys(e.proto).forEach((t) => {
                            n.prototype[t] = e.proto[t];
                        }),
                    e.static &&
                        Object.keys(e.static).forEach((t) => {
                            n[t] = e.static[t];
                        }),
                    e.install && e.install.apply(n, t),
                    n
                );
            }
            static use(e, ...t) {
                const n = this;
                return Array.isArray(e) ? (e.forEach((e) => n.installModule(e)), n) : n.installModule(e, ...t);
            }
        }
        var F = {
            updateSize: function () {
                const e = this;
                let t, n;
                const r = e.$el;
                (t = void 0 !== e.params.width ? e.params.width : r[0].clientWidth),
                    (n = void 0 !== e.params.height ? e.params.height : r[0].clientHeight),
                    (0 === t && e.isHorizontal()) ||
                        (0 === n && e.isVertical()) ||
                        ((t = t - parseInt(r.css("padding-left"), 10) - parseInt(r.css("padding-right"), 10)),
                        (n = n - parseInt(r.css("padding-top"), 10) - parseInt(r.css("padding-bottom"), 10)),
                        N.extend(e, { width: t, height: n, size: e.isHorizontal() ? t : n }));
            },
            updateSlides: function () {
                const e = this,
                    t = e.params,
                    { $wrapperEl: n, size: r, rtlTranslate: i, wrongRTL: o } = e,
                    a = e.virtual && t.virtual.enabled,
                    s = a ? e.virtual.slides.length : e.slides.length,
                    l = n.children(`.${e.params.slideClass}`),
                    c = a ? e.virtual.slides.length : l.length;
                let u = [];
                const d = [],
                    p = [];
                function h(e) {
                    return !t.cssMode || e !== l.length - 1;
                }
                let f = t.slidesOffsetBefore;
                "function" == typeof f && (f = t.slidesOffsetBefore.call(e));
                let m = t.slidesOffsetAfter;
                "function" == typeof m && (m = t.slidesOffsetAfter.call(e));
                const g = e.snapGrid.length,
                    v = e.snapGrid.length;
                let y,
                    b,
                    w = t.spaceBetween,
                    x = -f,
                    E = 0,
                    C = 0;
                if (void 0 === r) return;
                "string" == typeof w && w.indexOf("%") >= 0 && (w = (parseFloat(w.replace("%", "")) / 100) * r),
                    (e.virtualSize = -w),
                    i ? l.css({ marginLeft: "", marginTop: "" }) : l.css({ marginRight: "", marginBottom: "" }),
                    t.slidesPerColumn > 1 &&
                        ((y = Math.floor(c / t.slidesPerColumn) === c / e.params.slidesPerColumn ? c : Math.ceil(c / t.slidesPerColumn) * t.slidesPerColumn),
                        "auto" !== t.slidesPerView && "row" === t.slidesPerColumnFill && (y = Math.max(y, t.slidesPerView * t.slidesPerColumn)));
                const S = t.slidesPerColumn,
                    T = y / S,
                    k = Math.floor(c / t.slidesPerColumn);
                for (let n = 0; n < c; n += 1) {
                    b = 0;
                    const i = l.eq(n);
                    if (t.slidesPerColumn > 1) {
                        let r, o, a;
                        if ("row" === t.slidesPerColumnFill && t.slidesPerGroup > 1) {
                            const e = Math.floor(n / (t.slidesPerGroup * t.slidesPerColumn)),
                                s = n - t.slidesPerColumn * t.slidesPerGroup * e,
                                l = 0 === e ? t.slidesPerGroup : Math.min(Math.ceil((c - e * S * t.slidesPerGroup) / S), t.slidesPerGroup);
                            (a = Math.floor(s / l)), (o = s - a * l + e * t.slidesPerGroup), (r = o + (a * y) / S), i.css({ "-webkit-box-ordinal-group": r, "-moz-box-ordinal-group": r, "-ms-flex-order": r, "-webkit-order": r, order: r });
                        } else "column" === t.slidesPerColumnFill ? ((o = Math.floor(n / S)), (a = n - o * S), (o > k || (o === k && a === S - 1)) && ((a += 1), a >= S && ((a = 0), (o += 1)))) : ((a = Math.floor(n / T)), (o = n - a * T));
                        i.css("margin-" + (e.isHorizontal() ? "top" : "left"), 0 !== a && t.spaceBetween && `${t.spaceBetween}px`);
                    }
                    if ("none" !== i.css("display")) {
                        if ("auto" === t.slidesPerView) {
                            const n = O.getComputedStyle(i[0], null),
                                r = i[0].style.transform,
                                o = i[0].style.webkitTransform;
                            if ((r && (i[0].style.transform = "none"), o && (i[0].style.webkitTransform = "none"), t.roundLengths)) b = e.isHorizontal() ? i.outerWidth(!0) : i.outerHeight(!0);
                            else if (e.isHorizontal()) {
                                const e = parseFloat(n.getPropertyValue("width")),
                                    t = parseFloat(n.getPropertyValue("padding-left")),
                                    r = parseFloat(n.getPropertyValue("padding-right")),
                                    i = parseFloat(n.getPropertyValue("margin-left")),
                                    o = parseFloat(n.getPropertyValue("margin-right")),
                                    a = n.getPropertyValue("box-sizing");
                                b = a && "border-box" === a ? e + i + o : e + t + r + i + o;
                            } else {
                                const e = parseFloat(n.getPropertyValue("height")),
                                    t = parseFloat(n.getPropertyValue("padding-top")),
                                    r = parseFloat(n.getPropertyValue("padding-bottom")),
                                    i = parseFloat(n.getPropertyValue("margin-top")),
                                    o = parseFloat(n.getPropertyValue("margin-bottom")),
                                    a = n.getPropertyValue("box-sizing");
                                b = a && "border-box" === a ? e + i + o : e + t + r + i + o;
                            }
                            r && (i[0].style.transform = r), o && (i[0].style.webkitTransform = o), t.roundLengths && (b = Math.floor(b));
                        } else (b = (r - (t.slidesPerView - 1) * w) / t.slidesPerView), t.roundLengths && (b = Math.floor(b)), l[n] && (e.isHorizontal() ? (l[n].style.width = `${b}px`) : (l[n].style.height = `${b}px`));
                        l[n] && (l[n].swiperSlideSize = b),
                            p.push(b),
                            t.centeredSlides
                                ? ((x = x + b / 2 + E / 2 + w),
                                  0 === E && 0 !== n && (x = x - r / 2 - w),
                                  0 === n && (x = x - r / 2 - w),
                                  Math.abs(x) < 0.001 && (x = 0),
                                  t.roundLengths && (x = Math.floor(x)),
                                  C % t.slidesPerGroup == 0 && u.push(x),
                                  d.push(x))
                                : (t.roundLengths && (x = Math.floor(x)), (C - Math.min(e.params.slidesPerGroupSkip, C)) % e.params.slidesPerGroup == 0 && u.push(x), d.push(x), (x = x + b + w)),
                            (e.virtualSize += b + w),
                            (E = b),
                            (C += 1);
                    }
                }
                let A;
                if (
                    ((e.virtualSize = Math.max(e.virtualSize, r) + m),
                    i && o && ("slide" === t.effect || "coverflow" === t.effect) && n.css({ width: `${e.virtualSize + t.spaceBetween}px` }),
                    t.setWrapperSize && (e.isHorizontal() ? n.css({ width: `${e.virtualSize + t.spaceBetween}px` }) : n.css({ height: `${e.virtualSize + t.spaceBetween}px` })),
                    t.slidesPerColumn > 1 &&
                        ((e.virtualSize = (b + t.spaceBetween) * y),
                        (e.virtualSize = Math.ceil(e.virtualSize / t.slidesPerColumn) - t.spaceBetween),
                        e.isHorizontal() ? n.css({ width: `${e.virtualSize + t.spaceBetween}px` }) : n.css({ height: `${e.virtualSize + t.spaceBetween}px` }),
                        t.centeredSlides))
                ) {
                    A = [];
                    for (let n = 0; n < u.length; n += 1) {
                        let r = u[n];
                        t.roundLengths && (r = Math.floor(r)), u[n] < e.virtualSize + u[0] && A.push(r);
                    }
                    u = A;
                }
                if (!t.centeredSlides) {
                    A = [];
                    for (let n = 0; n < u.length; n += 1) {
                        let i = u[n];
                        t.roundLengths && (i = Math.floor(i)), u[n] <= e.virtualSize - r && A.push(i);
                    }
                    (u = A), Math.floor(e.virtualSize - r) - Math.floor(u[u.length - 1]) > 1 && u.push(e.virtualSize - r);
                }
                if (
                    (0 === u.length && (u = [0]),
                    0 !== t.spaceBetween && (e.isHorizontal() ? (i ? l.filter(h).css({ marginLeft: `${w}px` }) : l.filter(h).css({ marginRight: `${w}px` })) : l.filter(h).css({ marginBottom: `${w}px` })),
                    t.centeredSlides && t.centeredSlidesBounds)
                ) {
                    let e = 0;
                    p.forEach((n) => {
                        e += n + (t.spaceBetween ? t.spaceBetween : 0);
                    }),
                        (e -= t.spaceBetween);
                    const n = e - r;
                    u = u.map((e) => (e < 0 ? -f : e > n ? n + m : e));
                }
                if (t.centerInsufficientSlides) {
                    let e = 0;
                    if (
                        (p.forEach((n) => {
                            e += n + (t.spaceBetween ? t.spaceBetween : 0);
                        }),
                        (e -= t.spaceBetween),
                        e < r)
                    ) {
                        const t = (r - e) / 2;
                        u.forEach((e, n) => {
                            u[n] = e - t;
                        }),
                            d.forEach((e, n) => {
                                d[n] = e + t;
                            });
                    }
                }
                N.extend(e, { slides: l, snapGrid: u, slidesGrid: d, slidesSizesGrid: p }),
                    c !== s && e.emit("slidesLengthChange"),
                    u.length !== g && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")),
                    d.length !== v && e.emit("slidesGridLengthChange"),
                    (t.watchSlidesProgress || t.watchSlidesVisibility) && e.updateSlidesOffset();
            },
            updateAutoHeight: function (e) {
                const t = this,
                    n = [];
                let r,
                    i = 0;
                if (("number" == typeof e ? t.setTransition(e) : !0 === e && t.setTransition(t.params.speed), "auto" !== t.params.slidesPerView && t.params.slidesPerView > 1))
                    if (t.params.centeredSlides)
                        t.visibleSlides.each((e, t) => {
                            n.push(t);
                        });
                    else
                        for (r = 0; r < Math.ceil(t.params.slidesPerView); r += 1) {
                            const e = t.activeIndex + r;
                            if (e > t.slides.length) break;
                            n.push(t.slides.eq(e)[0]);
                        }
                else n.push(t.slides.eq(t.activeIndex)[0]);
                for (r = 0; r < n.length; r += 1)
                    if (void 0 !== n[r]) {
                        const e = n[r].offsetHeight;
                        i = e > i ? e : i;
                    }
                i && t.$wrapperEl.css("height", `${i}px`);
            },
            updateSlidesOffset: function () {
                const e = this,
                    t = e.slides;
                for (let n = 0; n < t.length; n += 1) t[n].swiperSlideOffset = e.isHorizontal() ? t[n].offsetLeft : t[n].offsetTop;
            },
            updateSlidesProgress: function (e = (this && this.translate) || 0) {
                const t = this,
                    n = t.params,
                    { slides: r, rtlTranslate: i } = t;
                if (0 === r.length) return;
                void 0 === r[0].swiperSlideOffset && t.updateSlidesOffset();
                let o = -e;
                i && (o = e), r.removeClass(n.slideVisibleClass), (t.visibleSlidesIndexes = []), (t.visibleSlides = []);
                for (let e = 0; e < r.length; e += 1) {
                    const a = r[e],
                        s = (o + (n.centeredSlides ? t.minTranslate() : 0) - a.swiperSlideOffset) / (a.swiperSlideSize + n.spaceBetween);
                    if (n.watchSlidesVisibility || (n.centeredSlides && n.autoHeight)) {
                        const i = -(o - a.swiperSlideOffset),
                            s = i + t.slidesSizesGrid[e];
                        ((i >= 0 && i < t.size - 1) || (s > 1 && s <= t.size) || (i <= 0 && s >= t.size)) && (t.visibleSlides.push(a), t.visibleSlidesIndexes.push(e), r.eq(e).addClass(n.slideVisibleClass));
                    }
                    a.progress = i ? -s : s;
                }
                t.visibleSlides = M(t.visibleSlides);
            },
            updateProgress: function (e) {
                const t = this;
                if (void 0 === e) {
                    const n = t.rtlTranslate ? -1 : 1;
                    e = (t && t.translate && t.translate * n) || 0;
                }
                const n = t.params,
                    r = t.maxTranslate() - t.minTranslate();
                let { progress: i, isBeginning: o, isEnd: a } = t;
                const s = o,
                    l = a;
                0 === r ? ((i = 0), (o = !0), (a = !0)) : ((i = (e - t.minTranslate()) / r), (o = i <= 0), (a = i >= 1)),
                    N.extend(t, { progress: i, isBeginning: o, isEnd: a }),
                    (n.watchSlidesProgress || n.watchSlidesVisibility || (n.centeredSlides && n.autoHeight)) && t.updateSlidesProgress(e),
                    o && !s && t.emit("reachBeginning toEdge"),
                    a && !l && t.emit("reachEnd toEdge"),
                    ((s && !o) || (l && !a)) && t.emit("fromEdge"),
                    t.emit("progress", i);
            },
            updateSlidesClasses: function () {
                const e = this,
                    { slides: t, params: n, $wrapperEl: r, activeIndex: i, realIndex: o } = e,
                    a = e.virtual && n.virtual.enabled;
                let s;
                t.removeClass(`${n.slideActiveClass} ${n.slideNextClass} ${n.slidePrevClass} ${n.slideDuplicateActiveClass} ${n.slideDuplicateNextClass} ${n.slideDuplicatePrevClass}`),
                    (s = a ? e.$wrapperEl.find(`.${n.slideClass}[data-swiper-slide-index="${i}"]`) : t.eq(i)),
                    s.addClass(n.slideActiveClass),
                    n.loop &&
                        (s.hasClass(n.slideDuplicateClass)
                            ? r.children(`.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${o}"]`).addClass(n.slideDuplicateActiveClass)
                            : r.children(`.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${o}"]`).addClass(n.slideDuplicateActiveClass));
                let l = s.nextAll(`.${n.slideClass}`).eq(0).addClass(n.slideNextClass);
                n.loop && 0 === l.length && ((l = t.eq(0)), l.addClass(n.slideNextClass));
                let c = s.prevAll(`.${n.slideClass}`).eq(0).addClass(n.slidePrevClass);
                n.loop && 0 === c.length && ((c = t.eq(-1)), c.addClass(n.slidePrevClass)),
                    n.loop &&
                        (l.hasClass(n.slideDuplicateClass)
                            ? r.children(`.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`).addClass(n.slideDuplicateNextClass)
                            : r.children(`.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`).addClass(n.slideDuplicateNextClass),
                        c.hasClass(n.slideDuplicateClass)
                            ? r.children(`.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${c.attr("data-swiper-slide-index")}"]`).addClass(n.slideDuplicatePrevClass)
                            : r.children(`.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${c.attr("data-swiper-slide-index")}"]`).addClass(n.slideDuplicatePrevClass));
            },
            updateActiveIndex: function (e) {
                const t = this,
                    n = t.rtlTranslate ? t.translate : -t.translate,
                    { slidesGrid: r, snapGrid: i, params: o, activeIndex: a, realIndex: s, snapIndex: l } = t;
                let c,
                    u = e;
                if (void 0 === u) {
                    for (let e = 0; e < r.length; e += 1) void 0 !== r[e + 1] ? (n >= r[e] && n < r[e + 1] - (r[e + 1] - r[e]) / 2 ? (u = e) : n >= r[e] && n < r[e + 1] && (u = e + 1)) : n >= r[e] && (u = e);
                    o.normalizeSlideIndex && (u < 0 || void 0 === u) && (u = 0);
                }
                if (i.indexOf(n) >= 0) c = i.indexOf(n);
                else {
                    const e = Math.min(o.slidesPerGroupSkip, u);
                    c = e + Math.floor((u - e) / o.slidesPerGroup);
                }
                if ((c >= i.length && (c = i.length - 1), u === a)) return void (c !== l && ((t.snapIndex = c), t.emit("snapIndexChange")));
                const d = parseInt(t.slides.eq(u).attr("data-swiper-slide-index") || u, 10);
                N.extend(t, { snapIndex: c, realIndex: d, previousIndex: a, activeIndex: u }),
                    t.emit("activeIndexChange"),
                    t.emit("snapIndexChange"),
                    s !== d && t.emit("realIndexChange"),
                    (t.initialized || t.params.runCallbacksOnInit) && t.emit("slideChange");
            },
            updateClickedSlide: function (e) {
                const t = this,
                    n = t.params,
                    r = M(e.target).closest(`.${n.slideClass}`)[0];
                let i = !1;
                if (r) for (let e = 0; e < t.slides.length; e += 1) t.slides[e] === r && (i = !0);
                if (!r || !i) return (t.clickedSlide = void 0), void (t.clickedIndex = void 0);
                (t.clickedSlide = r),
                    t.virtual && t.params.virtual.enabled ? (t.clickedIndex = parseInt(M(r).attr("data-swiper-slide-index"), 10)) : (t.clickedIndex = M(r).index()),
                    n.slideToClickedSlide && void 0 !== t.clickedIndex && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide();
            },
        };
        var B = {
            getTranslate: function (e = this.isHorizontal() ? "x" : "y") {
                const { params: t, rtlTranslate: n, translate: r, $wrapperEl: i } = this;
                if (t.virtualTranslate) return n ? -r : r;
                if (t.cssMode) return r;
                let o = N.getTranslate(i[0], e);
                return n && (o = -o), o || 0;
            },
            setTranslate: function (e, t) {
                const n = this,
                    { rtlTranslate: r, params: i, $wrapperEl: o, wrapperEl: a, progress: s } = n;
                let l,
                    c = 0,
                    u = 0;
                n.isHorizontal() ? (c = r ? -e : e) : (u = e),
                    i.roundLengths && ((c = Math.floor(c)), (u = Math.floor(u))),
                    i.cssMode ? (a[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal() ? -c : -u) : i.virtualTranslate || o.transform(`translate3d(${c}px, ${u}px, 0px)`),
                    (n.previousTranslate = n.translate),
                    (n.translate = n.isHorizontal() ? c : u);
                const d = n.maxTranslate() - n.minTranslate();
                (l = 0 === d ? 0 : (e - n.minTranslate()) / d), l !== s && n.updateProgress(e), n.emit("setTranslate", n.translate, t);
            },
            minTranslate: function () {
                return -this.snapGrid[0];
            },
            maxTranslate: function () {
                return -this.snapGrid[this.snapGrid.length - 1];
            },
            translateTo: function (e = 0, t = this.params.speed, n = !0, r = !0, i) {
                const o = this,
                    { params: a, wrapperEl: s } = o;
                if (o.animating && a.preventInteractionOnTransition) return !1;
                const l = o.minTranslate(),
                    c = o.maxTranslate();
                let u;
                if (((u = r && e > l ? l : r && e < c ? c : e), o.updateProgress(u), a.cssMode)) {
                    const e = o.isHorizontal();
                    return 0 === t ? (s[e ? "scrollLeft" : "scrollTop"] = -u) : s.scrollTo ? s.scrollTo({ [e ? "left" : "top"]: -u, behavior: "smooth" }) : (s[e ? "scrollLeft" : "scrollTop"] = -u), !0;
                }
                return (
                    0 === t
                        ? (o.setTransition(0), o.setTranslate(u), n && (o.emit("beforeTransitionStart", t, i), o.emit("transitionEnd")))
                        : (o.setTransition(t),
                          o.setTranslate(u),
                          n && (o.emit("beforeTransitionStart", t, i), o.emit("transitionStart")),
                          o.animating ||
                              ((o.animating = !0),
                              o.onTranslateToWrapperTransitionEnd ||
                                  (o.onTranslateToWrapperTransitionEnd = function (e) {
                                      o &&
                                          !o.destroyed &&
                                          e.target === this &&
                                          (o.$wrapperEl[0].removeEventListener("transitionend", o.onTranslateToWrapperTransitionEnd),
                                          o.$wrapperEl[0].removeEventListener("webkitTransitionEnd", o.onTranslateToWrapperTransitionEnd),
                                          (o.onTranslateToWrapperTransitionEnd = null),
                                          delete o.onTranslateToWrapperTransitionEnd,
                                          n && o.emit("transitionEnd"));
                                  }),
                              o.$wrapperEl[0].addEventListener("transitionend", o.onTranslateToWrapperTransitionEnd),
                              o.$wrapperEl[0].addEventListener("webkitTransitionEnd", o.onTranslateToWrapperTransitionEnd))),
                    !0
                );
            },
        };
        var j = {
            setTransition: function (e, t) {
                const n = this;
                n.params.cssMode || n.$wrapperEl.transition(e), n.emit("setTransition", e, t);
            },
            transitionStart: function (e = !0, t) {
                const n = this,
                    { activeIndex: r, params: i, previousIndex: o } = n;
                if (i.cssMode) return;
                i.autoHeight && n.updateAutoHeight();
                let a = t;
                if ((a || (a = r > o ? "next" : r < o ? "prev" : "reset"), n.emit("transitionStart"), e && r !== o)) {
                    if ("reset" === a) return void n.emit("slideResetTransitionStart");
                    n.emit("slideChangeTransitionStart"), "next" === a ? n.emit("slideNextTransitionStart") : n.emit("slidePrevTransitionStart");
                }
            },
            transitionEnd: function (e = !0, t) {
                const n = this,
                    { activeIndex: r, previousIndex: i, params: o } = n;
                if (((n.animating = !1), o.cssMode)) return;
                n.setTransition(0);
                let a = t;
                if ((a || (a = r > i ? "next" : r < i ? "prev" : "reset"), n.emit("transitionEnd"), e && r !== i)) {
                    if ("reset" === a) return void n.emit("slideResetTransitionEnd");
                    n.emit("slideChangeTransitionEnd"), "next" === a ? n.emit("slideNextTransitionEnd") : n.emit("slidePrevTransitionEnd");
                }
            },
        };
        var H = {
            slideTo: function (e = 0, t = this.params.speed, n = !0, r) {
                const i = this;
                let o = e;
                o < 0 && (o = 0);
                const { params: a, snapGrid: s, slidesGrid: l, previousIndex: c, activeIndex: u, rtlTranslate: d, wrapperEl: p } = i;
                if (i.animating && a.preventInteractionOnTransition) return !1;
                const h = Math.min(i.params.slidesPerGroupSkip, o);
                let f = h + Math.floor((o - h) / i.params.slidesPerGroup);
                f >= s.length && (f = s.length - 1), (u || a.initialSlide || 0) === (c || 0) && n && i.emit("beforeSlideChangeStart");
                const m = -s[f];
                if ((i.updateProgress(m), a.normalizeSlideIndex)) for (let e = 0; e < l.length; e += 1) -Math.floor(100 * m) >= Math.floor(100 * l[e]) && (o = e);
                if (i.initialized && o !== u) {
                    if (!i.allowSlideNext && m < i.translate && m < i.minTranslate()) return !1;
                    if (!i.allowSlidePrev && m > i.translate && m > i.maxTranslate() && (u || 0) !== o) return !1;
                }
                let g;
                if (((g = o > u ? "next" : o < u ? "prev" : "reset"), (d && -m === i.translate) || (!d && m === i.translate)))
                    return i.updateActiveIndex(o), a.autoHeight && i.updateAutoHeight(), i.updateSlidesClasses(), "slide" !== a.effect && i.setTranslate(m), "reset" !== g && (i.transitionStart(n, g), i.transitionEnd(n, g)), !1;
                if (a.cssMode) {
                    const e = i.isHorizontal();
                    let n = -m;
                    return (
                        d && (n = p.scrollWidth - p.offsetWidth - n), 0 === t ? (p[e ? "scrollLeft" : "scrollTop"] = n) : p.scrollTo ? p.scrollTo({ [e ? "left" : "top"]: n, behavior: "smooth" }) : (p[e ? "scrollLeft" : "scrollTop"] = n), !0
                    );
                }
                return (
                    0 === t
                        ? (i.setTransition(0), i.setTranslate(m), i.updateActiveIndex(o), i.updateSlidesClasses(), i.emit("beforeTransitionStart", t, r), i.transitionStart(n, g), i.transitionEnd(n, g))
                        : (i.setTransition(t),
                          i.setTranslate(m),
                          i.updateActiveIndex(o),
                          i.updateSlidesClasses(),
                          i.emit("beforeTransitionStart", t, r),
                          i.transitionStart(n, g),
                          i.animating ||
                              ((i.animating = !0),
                              i.onSlideToWrapperTransitionEnd ||
                                  (i.onSlideToWrapperTransitionEnd = function (e) {
                                      i &&
                                          !i.destroyed &&
                                          e.target === this &&
                                          (i.$wrapperEl[0].removeEventListener("transitionend", i.onSlideToWrapperTransitionEnd),
                                          i.$wrapperEl[0].removeEventListener("webkitTransitionEnd", i.onSlideToWrapperTransitionEnd),
                                          (i.onSlideToWrapperTransitionEnd = null),
                                          delete i.onSlideToWrapperTransitionEnd,
                                          i.transitionEnd(n, g));
                                  }),
                              i.$wrapperEl[0].addEventListener("transitionend", i.onSlideToWrapperTransitionEnd),
                              i.$wrapperEl[0].addEventListener("webkitTransitionEnd", i.onSlideToWrapperTransitionEnd))),
                    !0
                );
            },
            slideToLoop: function (e = 0, t = this.params.speed, n = !0, r) {
                const i = this;
                let o = e;
                return i.params.loop && (o += i.loopedSlides), i.slideTo(o, t, n, r);
            },
            slideNext: function (e = this.params.speed, t = !0, n) {
                const r = this,
                    { params: i, animating: o } = r,
                    a = r.activeIndex < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup;
                if (i.loop) {
                    if (o) return !1;
                    r.loopFix(), (r._clientLeft = r.$wrapperEl[0].clientLeft);
                }
                return r.slideTo(r.activeIndex + a, e, t, n);
            },
            slidePrev: function (e = this.params.speed, t = !0, n) {
                const r = this,
                    { params: i, animating: o, snapGrid: a, slidesGrid: s, rtlTranslate: l } = r;
                if (i.loop) {
                    if (o) return !1;
                    r.loopFix(), (r._clientLeft = r.$wrapperEl[0].clientLeft);
                }
                function c(e) {
                    return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
                }
                const u = c(l ? r.translate : -r.translate),
                    d = a.map((e) => c(e));
                s.map((e) => c(e)), a[d.indexOf(u)];
                let p,
                    h = a[d.indexOf(u) - 1];
                return (
                    void 0 === h &&
                        i.cssMode &&
                        a.forEach((e) => {
                            !h && u >= e && (h = e);
                        }),
                    void 0 !== h && ((p = s.indexOf(h)), p < 0 && (p = r.activeIndex - 1)),
                    r.slideTo(p, e, t, n)
                );
            },
            slideReset: function (e = this.params.speed, t = !0, n) {
                return this.slideTo(this.activeIndex, e, t, n);
            },
            slideToClosest: function (e = this.params.speed, t = !0, n, r = 0.5) {
                const i = this;
                let o = i.activeIndex;
                const a = Math.min(i.params.slidesPerGroupSkip, o),
                    s = a + Math.floor((o - a) / i.params.slidesPerGroup),
                    l = i.rtlTranslate ? i.translate : -i.translate;
                if (l >= i.snapGrid[s]) {
                    const e = i.snapGrid[s];
                    l - e > (i.snapGrid[s + 1] - e) * r && (o += i.params.slidesPerGroup);
                } else {
                    const e = i.snapGrid[s - 1];
                    l - e <= (i.snapGrid[s] - e) * r && (o -= i.params.slidesPerGroup);
                }
                return (o = Math.max(o, 0)), (o = Math.min(o, i.slidesGrid.length - 1)), i.slideTo(o, e, t, n);
            },
            slideToClickedSlide: function () {
                const e = this,
                    { params: t, $wrapperEl: n } = e,
                    r = "auto" === t.slidesPerView ? e.slidesPerViewDynamic() : t.slidesPerView;
                let i,
                    o = e.clickedIndex;
                if (t.loop) {
                    if (e.animating) return;
                    (i = parseInt(M(e.clickedSlide).attr("data-swiper-slide-index"), 10)),
                        t.centeredSlides
                            ? o < e.loopedSlides - r / 2 || o > e.slides.length - e.loopedSlides + r / 2
                                ? (e.loopFix(),
                                  (o = n.children(`.${t.slideClass}[data-swiper-slide-index="${i}"]:not(.${t.slideDuplicateClass})`).eq(0).index()),
                                  N.nextTick(() => {
                                      e.slideTo(o);
                                  }))
                                : e.slideTo(o)
                            : o > e.slides.length - r
                            ? (e.loopFix(),
                              (o = n.children(`.${t.slideClass}[data-swiper-slide-index="${i}"]:not(.${t.slideDuplicateClass})`).eq(0).index()),
                              N.nextTick(() => {
                                  e.slideTo(o);
                              }))
                            : e.slideTo(o);
                } else e.slideTo(o);
            },
        };
        var V = {
            loopCreate: function () {
                const e = this,
                    { params: t, $wrapperEl: n } = e;
                n.children(`.${t.slideClass}.${t.slideDuplicateClass}`).remove();
                let r = n.children(`.${t.slideClass}`);
                if (t.loopFillGroupWithBlank) {
                    const e = t.slidesPerGroup - (r.length % t.slidesPerGroup);
                    if (e !== t.slidesPerGroup) {
                        for (let r = 0; r < e; r += 1) {
                            const e = M($.createElement("div")).addClass(`${t.slideClass} ${t.slideBlankClass}`);
                            n.append(e);
                        }
                        r = n.children(`.${t.slideClass}`);
                    }
                }
                "auto" !== t.slidesPerView || t.loopedSlides || (t.loopedSlides = r.length),
                    (e.loopedSlides = Math.ceil(parseFloat(t.loopedSlides || t.slidesPerView, 10))),
                    (e.loopedSlides += t.loopAdditionalSlides),
                    e.loopedSlides > r.length && (e.loopedSlides = r.length);
                const i = [],
                    o = [];
                r.each((t, n) => {
                    const a = M(n);
                    t < e.loopedSlides && o.push(n), t < r.length && t >= r.length - e.loopedSlides && i.push(n), a.attr("data-swiper-slide-index", t);
                });
                for (let e = 0; e < o.length; e += 1) n.append(M(o[e].cloneNode(!0)).addClass(t.slideDuplicateClass));
                for (let e = i.length - 1; e >= 0; e -= 1) n.prepend(M(i[e].cloneNode(!0)).addClass(t.slideDuplicateClass));
            },
            loopFix: function () {
                const e = this;
                e.emit("beforeLoopFix");
                const { activeIndex: t, slides: n, loopedSlides: r, allowSlidePrev: i, allowSlideNext: o, snapGrid: a, rtlTranslate: s } = e;
                let l;
                (e.allowSlidePrev = !0), (e.allowSlideNext = !0);
                const c = -a[t] - e.getTranslate();
                if (t < r) {
                    (l = n.length - 3 * r + t), (l += r);
                    e.slideTo(l, 0, !1, !0) && 0 !== c && e.setTranslate((s ? -e.translate : e.translate) - c);
                } else if (t >= n.length - r) {
                    (l = -n.length + t + r), (l += r);
                    e.slideTo(l, 0, !1, !0) && 0 !== c && e.setTranslate((s ? -e.translate : e.translate) - c);
                }
                (e.allowSlidePrev = i), (e.allowSlideNext = o), e.emit("loopFix");
            },
            loopDestroy: function () {
                const { $wrapperEl: e, params: t, slides: n } = this;
                e.children(`.${t.slideClass}.${t.slideDuplicateClass},.${t.slideClass}.${t.slideBlankClass}`).remove(), n.removeAttr("data-swiper-slide-index");
            },
        };
        var W = {
            setGrabCursor: function (e) {
                const t = this;
                if (z.touch || !t.params.simulateTouch || (t.params.watchOverflow && t.isLocked) || t.params.cssMode) return;
                const n = t.el;
                (n.style.cursor = "move"), (n.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab"), (n.style.cursor = e ? "-moz-grabbin" : "-moz-grab"), (n.style.cursor = e ? "grabbing" : "grab");
            },
            unsetGrabCursor: function () {
                const e = this;
                z.touch || (e.params.watchOverflow && e.isLocked) || e.params.cssMode || (e.el.style.cursor = "");
            },
        };
        var U = {
            appendSlide: function (e) {
                const t = this,
                    { $wrapperEl: n, params: r } = t;
                if ((r.loop && t.loopDestroy(), "object" == typeof e && "length" in e)) for (let t = 0; t < e.length; t += 1) e[t] && n.append(e[t]);
                else n.append(e);
                r.loop && t.loopCreate(), (r.observer && z.observer) || t.update();
            },
            prependSlide: function (e) {
                const t = this,
                    { params: n, $wrapperEl: r, activeIndex: i } = t;
                n.loop && t.loopDestroy();
                let o = i + 1;
                if ("object" == typeof e && "length" in e) {
                    for (let t = 0; t < e.length; t += 1) e[t] && r.prepend(e[t]);
                    o = i + e.length;
                } else r.prepend(e);
                n.loop && t.loopCreate(), (n.observer && z.observer) || t.update(), t.slideTo(o, 0, !1);
            },
            addSlide: function (e, t) {
                const n = this,
                    { $wrapperEl: r, params: i, activeIndex: o } = n;
                let a = o;
                i.loop && ((a -= n.loopedSlides), n.loopDestroy(), (n.slides = r.children(`.${i.slideClass}`)));
                const s = n.slides.length;
                if (e <= 0) return void n.prependSlide(t);
                if (e >= s) return void n.appendSlide(t);
                let l = a > e ? a + 1 : a;
                const c = [];
                for (let t = s - 1; t >= e; t -= 1) {
                    const e = n.slides.eq(t);
                    e.remove(), c.unshift(e);
                }
                if ("object" == typeof t && "length" in t) {
                    for (let e = 0; e < t.length; e += 1) t[e] && r.append(t[e]);
                    l = a > e ? a + t.length : a;
                } else r.append(t);
                for (let e = 0; e < c.length; e += 1) r.append(c[e]);
                i.loop && n.loopCreate(), (i.observer && z.observer) || n.update(), i.loop ? n.slideTo(l + n.loopedSlides, 0, !1) : n.slideTo(l, 0, !1);
            },
            removeSlide: function (e) {
                const t = this,
                    { params: n, $wrapperEl: r, activeIndex: i } = t;
                let o = i;
                n.loop && ((o -= t.loopedSlides), t.loopDestroy(), (t.slides = r.children(`.${n.slideClass}`)));
                let a,
                    s = o;
                if ("object" == typeof e && "length" in e) {
                    for (let n = 0; n < e.length; n += 1) (a = e[n]), t.slides[a] && t.slides.eq(a).remove(), a < s && (s -= 1);
                    s = Math.max(s, 0);
                } else (a = e), t.slides[a] && t.slides.eq(a).remove(), a < s && (s -= 1), (s = Math.max(s, 0));
                n.loop && t.loopCreate(), (n.observer && z.observer) || t.update(), n.loop ? t.slideTo(s + t.loopedSlides, 0, !1) : t.slideTo(s, 0, !1);
            },
            removeAllSlides: function () {
                const e = this,
                    t = [];
                for (let n = 0; n < e.slides.length; n += 1) t.push(n);
                e.removeSlide(t);
            },
        };
        const G = (function () {
            const e = O.navigator.platform,
                t = O.navigator.userAgent,
                n = {
                    ios: !1,
                    android: !1,
                    androidChrome: !1,
                    desktop: !1,
                    iphone: !1,
                    ipod: !1,
                    ipad: !1,
                    edge: !1,
                    ie: !1,
                    firefox: !1,
                    macos: !1,
                    windows: !1,
                    cordova: !(!O.cordova && !O.phonegap),
                    phonegap: !(!O.cordova && !O.phonegap),
                    electron: !1,
                },
                r = O.screen.width,
                i = O.screen.height,
                o = t.match(/(Android);?[\s\/]+([\d.]+)?/);
            let a = t.match(/(iPad).*OS\s([\d_]+)/);
            const s = t.match(/(iPod)(.*OS\s([\d_]+))?/),
                l = !a && t.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                c = t.indexOf("MSIE ") >= 0 || t.indexOf("Trident/") >= 0,
                u = t.indexOf("Edge/") >= 0,
                d = t.indexOf("Gecko/") >= 0 && t.indexOf("Firefox/") >= 0,
                p = "Win32" === e,
                h = t.toLowerCase().indexOf("electron") >= 0;
            let f = "MacIntel" === e;
            return (
                !a && f && z.touch && ((1024 === r && 1366 === i) || (834 === r && 1194 === i) || (834 === r && 1112 === i) || (768 === r && 1024 === i)) && ((a = t.match(/(Version)\/([\d.]+)/)), (f = !1)),
                (n.ie = c),
                (n.edge = u),
                (n.firefox = d),
                o && !p && ((n.os = "android"), (n.osVersion = o[2]), (n.android = !0), (n.androidChrome = t.toLowerCase().indexOf("chrome") >= 0)),
                (a || l || s) && ((n.os = "ios"), (n.ios = !0)),
                l && !s && ((n.osVersion = l[2].replace(/_/g, ".")), (n.iphone = !0)),
                a && ((n.osVersion = a[2].replace(/_/g, ".")), (n.ipad = !0)),
                s && ((n.osVersion = s[3] ? s[3].replace(/_/g, ".") : null), (n.ipod = !0)),
                n.ios && n.osVersion && t.indexOf("Version/") >= 0 && "10" === n.osVersion.split(".")[0] && (n.osVersion = t.toLowerCase().split("version/")[1].split(" ")[0]),
                (n.webView = !(!(l || a || s) || (!t.match(/.*AppleWebKit(?!.*Safari)/i) && !O.navigator.standalone)) || (O.matchMedia && O.matchMedia("(display-mode: standalone)").matches)),
                (n.webview = n.webView),
                (n.standalone = n.webView),
                (n.desktop = !(n.ios || n.android) || h),
                n.desktop && ((n.electron = h), (n.macos = f), (n.windows = p), n.macos && (n.os = "macos"), n.windows && (n.os = "windows")),
                (n.pixelRatio = O.devicePixelRatio || 1),
                n
            );
        })();
        function Y(e) {
            const t = this,
                n = t.touchEventsData,
                { params: r, touches: i } = t;
            if (t.animating && r.preventInteractionOnTransition) return;
            let o = e;
            o.originalEvent && (o = o.originalEvent);
            const a = M(o.target);
            if ("wrapper" === r.touchEventsTarget && !a.closest(t.wrapperEl).length) return;
            if (((n.isTouchEvent = "touchstart" === o.type), !n.isTouchEvent && "which" in o && 3 === o.which)) return;
            if (!n.isTouchEvent && "button" in o && o.button > 0) return;
            if (n.isTouched && n.isMoved) return;
            if (r.noSwiping && a.closest(r.noSwipingSelector ? r.noSwipingSelector : `.${r.noSwipingClass}`)[0]) return void (t.allowClick = !0);
            if (r.swipeHandler && !a.closest(r.swipeHandler)[0]) return;
            (i.currentX = "touchstart" === o.type ? o.targetTouches[0].pageX : o.pageX), (i.currentY = "touchstart" === o.type ? o.targetTouches[0].pageY : o.pageY);
            const s = i.currentX,
                l = i.currentY,
                c = r.edgeSwipeDetection || r.iOSEdgeSwipeDetection,
                u = r.edgeSwipeThreshold || r.iOSEdgeSwipeThreshold;
            if (!c || !(s <= u || s >= O.screen.width - u)) {
                if (
                    (N.extend(n, { isTouched: !0, isMoved: !1, allowTouchCallbacks: !0, isScrolling: void 0, startMoving: void 0 }),
                    (i.startX = s),
                    (i.startY = l),
                    (n.touchStartTime = N.now()),
                    (t.allowClick = !0),
                    t.updateSize(),
                    (t.swipeDirection = void 0),
                    r.threshold > 0 && (n.allowThresholdMove = !1),
                    "touchstart" !== o.type)
                ) {
                    let e = !0;
                    a.is(n.formElements) && (e = !1), $.activeElement && M($.activeElement).is(n.formElements) && $.activeElement !== a[0] && $.activeElement.blur();
                    const i = e && t.allowTouchMove && r.touchStartPreventDefault;
                    (r.touchStartForcePreventDefault || i) && o.preventDefault();
                }
                t.emit("touchStart", o);
            }
        }
        function X(e) {
            const t = this,
                n = t.touchEventsData,
                { params: r, touches: i, rtlTranslate: o } = t;
            let a = e;
            if ((a.originalEvent && (a = a.originalEvent), !n.isTouched)) return void (n.startMoving && n.isScrolling && t.emit("touchMoveOpposite", a));
            if (n.isTouchEvent && "touchmove" !== a.type) return;
            const s = "touchmove" === a.type && a.targetTouches && (a.targetTouches[0] || a.changedTouches[0]),
                l = "touchmove" === a.type ? s.pageX : a.pageX,
                c = "touchmove" === a.type ? s.pageY : a.pageY;
            if (a.preventedByNestedSwiper) return (i.startX = l), void (i.startY = c);
            if (!t.allowTouchMove) return (t.allowClick = !1), void (n.isTouched && (N.extend(i, { startX: l, startY: c, currentX: l, currentY: c }), (n.touchStartTime = N.now())));
            if (n.isTouchEvent && r.touchReleaseOnEdges && !r.loop)
                if (t.isVertical()) {
                    if ((c < i.startY && t.translate <= t.maxTranslate()) || (c > i.startY && t.translate >= t.minTranslate())) return (n.isTouched = !1), void (n.isMoved = !1);
                } else if ((l < i.startX && t.translate <= t.maxTranslate()) || (l > i.startX && t.translate >= t.minTranslate())) return;
            if (n.isTouchEvent && $.activeElement && a.target === $.activeElement && M(a.target).is(n.formElements)) return (n.isMoved = !0), void (t.allowClick = !1);
            if ((n.allowTouchCallbacks && t.emit("touchMove", a), a.targetTouches && a.targetTouches.length > 1)) return;
            (i.currentX = l), (i.currentY = c);
            const u = i.currentX - i.startX,
                d = i.currentY - i.startY;
            if (t.params.threshold && Math.sqrt(u ** 2 + d ** 2) < t.params.threshold) return;
            if (void 0 === n.isScrolling) {
                let e;
                (t.isHorizontal() && i.currentY === i.startY) || (t.isVertical() && i.currentX === i.startX)
                    ? (n.isScrolling = !1)
                    : u * u + d * d >= 25 && ((e = (180 * Math.atan2(Math.abs(d), Math.abs(u))) / Math.PI), (n.isScrolling = t.isHorizontal() ? e > r.touchAngle : 90 - e > r.touchAngle));
            }
            if ((n.isScrolling && t.emit("touchMoveOpposite", a), void 0 === n.startMoving && ((i.currentX === i.startX && i.currentY === i.startY) || (n.startMoving = !0)), n.isScrolling)) return void (n.isTouched = !1);
            if (!n.startMoving) return;
            (t.allowClick = !1),
                !r.cssMode && a.cancelable && a.preventDefault(),
                r.touchMoveStopPropagation && !r.nested && a.stopPropagation(),
                n.isMoved ||
                    (r.loop && t.loopFix(),
                    (n.startTranslate = t.getTranslate()),
                    t.setTransition(0),
                    t.animating && t.$wrapperEl.trigger("webkitTransitionEnd transitionend"),
                    (n.allowMomentumBounce = !1),
                    !r.grabCursor || (!0 !== t.allowSlideNext && !0 !== t.allowSlidePrev) || t.setGrabCursor(!0),
                    t.emit("sliderFirstMove", a)),
                t.emit("sliderMove", a),
                (n.isMoved = !0);
            let p = t.isHorizontal() ? u : d;
            (i.diff = p), (p *= r.touchRatio), o && (p = -p), (t.swipeDirection = p > 0 ? "prev" : "next"), (n.currentTranslate = p + n.startTranslate);
            let h = !0,
                f = r.resistanceRatio;
            if (
                (r.touchReleaseOnEdges && (f = 0),
                p > 0 && n.currentTranslate > t.minTranslate()
                    ? ((h = !1), r.resistance && (n.currentTranslate = t.minTranslate() - 1 + (-t.minTranslate() + n.startTranslate + p) ** f))
                    : p < 0 && n.currentTranslate < t.maxTranslate() && ((h = !1), r.resistance && (n.currentTranslate = t.maxTranslate() + 1 - (t.maxTranslate() - n.startTranslate - p) ** f)),
                h && (a.preventedByNestedSwiper = !0),
                !t.allowSlideNext && "next" === t.swipeDirection && n.currentTranslate < n.startTranslate && (n.currentTranslate = n.startTranslate),
                !t.allowSlidePrev && "prev" === t.swipeDirection && n.currentTranslate > n.startTranslate && (n.currentTranslate = n.startTranslate),
                r.threshold > 0)
            ) {
                if (!(Math.abs(p) > r.threshold || n.allowThresholdMove)) return void (n.currentTranslate = n.startTranslate);
                if (!n.allowThresholdMove)
                    return (n.allowThresholdMove = !0), (i.startX = i.currentX), (i.startY = i.currentY), (n.currentTranslate = n.startTranslate), void (i.diff = t.isHorizontal() ? i.currentX - i.startX : i.currentY - i.startY);
            }
            r.followFinger &&
                !r.cssMode &&
                ((r.freeMode || r.watchSlidesProgress || r.watchSlidesVisibility) && (t.updateActiveIndex(), t.updateSlidesClasses()),
                r.freeMode &&
                    (0 === n.velocities.length && n.velocities.push({ position: i[t.isHorizontal() ? "startX" : "startY"], time: n.touchStartTime }),
                    n.velocities.push({ position: i[t.isHorizontal() ? "currentX" : "currentY"], time: N.now() })),
                t.updateProgress(n.currentTranslate),
                t.setTranslate(n.currentTranslate));
        }
        function K(e) {
            const t = this,
                n = t.touchEventsData,
                { params: r, touches: i, rtlTranslate: o, $wrapperEl: a, slidesGrid: s, snapGrid: l } = t;
            let c = e;
            if ((c.originalEvent && (c = c.originalEvent), n.allowTouchCallbacks && t.emit("touchEnd", c), (n.allowTouchCallbacks = !1), !n.isTouched))
                return n.isMoved && r.grabCursor && t.setGrabCursor(!1), (n.isMoved = !1), void (n.startMoving = !1);
            r.grabCursor && n.isMoved && n.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
            const u = N.now(),
                d = u - n.touchStartTime;
            if (
                (t.allowClick && (t.updateClickedSlide(c), t.emit("tap click", c), d < 300 && u - n.lastClickTime < 300 && t.emit("doubleTap doubleClick", c)),
                (n.lastClickTime = N.now()),
                N.nextTick(() => {
                    t.destroyed || (t.allowClick = !0);
                }),
                !n.isTouched || !n.isMoved || !t.swipeDirection || 0 === i.diff || n.currentTranslate === n.startTranslate)
            )
                return (n.isTouched = !1), (n.isMoved = !1), void (n.startMoving = !1);
            let p;
            if (((n.isTouched = !1), (n.isMoved = !1), (n.startMoving = !1), (p = r.followFinger ? (o ? t.translate : -t.translate) : -n.currentTranslate), r.cssMode)) return;
            if (r.freeMode) {
                if (p < -t.minTranslate()) return void t.slideTo(t.activeIndex);
                if (p > -t.maxTranslate()) return void (t.slides.length < l.length ? t.slideTo(l.length - 1) : t.slideTo(t.slides.length - 1));
                if (r.freeModeMomentum) {
                    if (n.velocities.length > 1) {
                        const e = n.velocities.pop(),
                            i = n.velocities.pop(),
                            o = e.position - i.position,
                            a = e.time - i.time;
                        (t.velocity = o / a), (t.velocity /= 2), Math.abs(t.velocity) < r.freeModeMinimumVelocity && (t.velocity = 0), (a > 150 || N.now() - e.time > 300) && (t.velocity = 0);
                    } else t.velocity = 0;
                    (t.velocity *= r.freeModeMomentumVelocityRatio), (n.velocities.length = 0);
                    let e = 1e3 * r.freeModeMomentumRatio;
                    const i = t.velocity * e;
                    let s = t.translate + i;
                    o && (s = -s);
                    let c,
                        u = !1;
                    const d = 20 * Math.abs(t.velocity) * r.freeModeMomentumBounceRatio;
                    let p;
                    if (s < t.maxTranslate())
                        r.freeModeMomentumBounce ? (s + t.maxTranslate() < -d && (s = t.maxTranslate() - d), (c = t.maxTranslate()), (u = !0), (n.allowMomentumBounce = !0)) : (s = t.maxTranslate()), r.loop && r.centeredSlides && (p = !0);
                    else if (s > t.minTranslate())
                        r.freeModeMomentumBounce ? (s - t.minTranslate() > d && (s = t.minTranslate() + d), (c = t.minTranslate()), (u = !0), (n.allowMomentumBounce = !0)) : (s = t.minTranslate()), r.loop && r.centeredSlides && (p = !0);
                    else if (r.freeModeSticky) {
                        let e;
                        for (let t = 0; t < l.length; t += 1)
                            if (l[t] > -s) {
                                e = t;
                                break;
                            }
                        (s = Math.abs(l[e] - s) < Math.abs(l[e - 1] - s) || "next" === t.swipeDirection ? l[e] : l[e - 1]), (s = -s);
                    }
                    if (
                        (p &&
                            t.once("transitionEnd", () => {
                                t.loopFix();
                            }),
                        0 !== t.velocity)
                    ) {
                        if (((e = o ? Math.abs((-s - t.translate) / t.velocity) : Math.abs((s - t.translate) / t.velocity)), r.freeModeSticky)) {
                            const n = Math.abs((o ? -s : s) - t.translate),
                                i = t.slidesSizesGrid[t.activeIndex];
                            e = n < i ? r.speed : n < 2 * i ? 1.5 * r.speed : 2.5 * r.speed;
                        }
                    } else if (r.freeModeSticky) return void t.slideToClosest();
                    r.freeModeMomentumBounce && u
                        ? (t.updateProgress(c),
                          t.setTransition(e),
                          t.setTranslate(s),
                          t.transitionStart(!0, t.swipeDirection),
                          (t.animating = !0),
                          a.transitionEnd(() => {
                              t &&
                                  !t.destroyed &&
                                  n.allowMomentumBounce &&
                                  (t.emit("momentumBounce"),
                                  t.setTransition(r.speed),
                                  setTimeout(() => {
                                      t.setTranslate(c),
                                          a.transitionEnd(() => {
                                              t && !t.destroyed && t.transitionEnd();
                                          });
                                  }, 0));
                          }))
                        : t.velocity
                        ? (t.updateProgress(s),
                          t.setTransition(e),
                          t.setTranslate(s),
                          t.transitionStart(!0, t.swipeDirection),
                          t.animating ||
                              ((t.animating = !0),
                              a.transitionEnd(() => {
                                  t && !t.destroyed && t.transitionEnd();
                              })))
                        : t.updateProgress(s),
                        t.updateActiveIndex(),
                        t.updateSlidesClasses();
                } else if (r.freeModeSticky) return void t.slideToClosest();
                return void ((!r.freeModeMomentum || d >= r.longSwipesMs) && (t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses()));
            }
            let h = 0,
                f = t.slidesSizesGrid[0];
            for (let e = 0; e < s.length; e += e < r.slidesPerGroupSkip ? 1 : r.slidesPerGroup) {
                const t = e < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
                void 0 !== s[e + t] ? p >= s[e] && p < s[e + t] && ((h = e), (f = s[e + t] - s[e])) : p >= s[e] && ((h = e), (f = s[s.length - 1] - s[s.length - 2]));
            }
            const m = (p - s[h]) / f,
                g = h < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
            if (d > r.longSwipesMs) {
                if (!r.longSwipes) return void t.slideTo(t.activeIndex);
                "next" === t.swipeDirection && (m >= r.longSwipesRatio ? t.slideTo(h + g) : t.slideTo(h)), "prev" === t.swipeDirection && (m > 1 - r.longSwipesRatio ? t.slideTo(h + g) : t.slideTo(h));
            } else {
                if (!r.shortSwipes) return void t.slideTo(t.activeIndex);
                t.navigation && (c.target === t.navigation.nextEl || c.target === t.navigation.prevEl)
                    ? c.target === t.navigation.nextEl
                        ? t.slideTo(h + g)
                        : t.slideTo(h)
                    : ("next" === t.swipeDirection && t.slideTo(h + g), "prev" === t.swipeDirection && t.slideTo(h));
            }
        }
        function J() {
            const e = this,
                { params: t, el: n } = e;
            if (n && 0 === n.offsetWidth) return;
            t.breakpoints && e.setBreakpoint();
            const { allowSlideNext: r, allowSlidePrev: i, snapGrid: o } = e;
            (e.allowSlideNext = !0),
                (e.allowSlidePrev = !0),
                e.updateSize(),
                e.updateSlides(),
                e.updateSlidesClasses(),
                ("auto" === t.slidesPerView || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0),
                e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.run(),
                (e.allowSlidePrev = i),
                (e.allowSlideNext = r),
                e.params.watchOverflow && o !== e.snapGrid && e.checkOverflow();
        }
        function Z(e) {
            const t = this;
            t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation()));
        }
        function Q() {
            const e = this,
                { wrapperEl: t, rtlTranslate: n } = e;
            let r;
            (e.previousTranslate = e.translate),
                e.isHorizontal() ? (e.translate = n ? t.scrollWidth - t.offsetWidth - t.scrollLeft : -t.scrollLeft) : (e.translate = -t.scrollTop),
                -0 === e.translate && (e.translate = 0),
                e.updateActiveIndex(),
                e.updateSlidesClasses();
            const i = e.maxTranslate() - e.minTranslate();
            (r = 0 === i ? 0 : (e.translate - e.minTranslate()) / i), r !== e.progress && e.updateProgress(n ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
        }
        let ee = !1;
        function te() {}
        var ne = {
            init: !0,
            direction: "horizontal",
            touchEventsTarget: "container",
            initialSlide: 0,
            speed: 300,
            cssMode: !1,
            updateOnWindowResize: !0,
            preventInteractionOnTransition: !1,
            edgeSwipeDetection: !1,
            edgeSwipeThreshold: 20,
            freeMode: !1,
            freeModeMomentum: !0,
            freeModeMomentumRatio: 1,
            freeModeMomentumBounce: !0,
            freeModeMomentumBounceRatio: 1,
            freeModeMomentumVelocityRatio: 1,
            freeModeSticky: !1,
            freeModeMinimumVelocity: 0.02,
            autoHeight: !1,
            setWrapperSize: !1,
            virtualTranslate: !1,
            effect: "slide",
            breakpoints: void 0,
            spaceBetween: 0,
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerColumnFill: "column",
            slidesPerGroup: 1,
            slidesPerGroupSkip: 0,
            centeredSlides: !1,
            centeredSlidesBounds: !1,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            normalizeSlideIndex: !0,
            centerInsufficientSlides: !1,
            watchOverflow: !1,
            roundLengths: !1,
            touchRatio: 1,
            touchAngle: 45,
            simulateTouch: !0,
            shortSwipes: !0,
            longSwipes: !0,
            longSwipesRatio: 0.5,
            longSwipesMs: 300,
            followFinger: !0,
            allowTouchMove: !0,
            threshold: 0,
            touchMoveStopPropagation: !1,
            touchStartPreventDefault: !0,
            touchStartForcePreventDefault: !1,
            touchReleaseOnEdges: !1,
            uniqueNavElements: !0,
            resistance: !0,
            resistanceRatio: 0.85,
            watchSlidesProgress: !1,
            watchSlidesVisibility: !1,
            grabCursor: !1,
            preventClicks: !0,
            preventClicksPropagation: !0,
            slideToClickedSlide: !1,
            preloadImages: !0,
            updateOnImagesReady: !0,
            loop: !1,
            loopAdditionalSlides: 0,
            loopedSlides: null,
            loopFillGroupWithBlank: !1,
            allowSlidePrev: !0,
            allowSlideNext: !0,
            swipeHandler: null,
            noSwiping: !0,
            noSwipingClass: "swiper-no-swiping",
            noSwipingSelector: null,
            passiveListeners: !0,
            containerModifierClass: "swiper-container-",
            slideClass: "swiper-slide",
            slideBlankClass: "swiper-slide-invisible-blank",
            slideActiveClass: "swiper-slide-active",
            slideDuplicateActiveClass: "swiper-slide-duplicate-active",
            slideVisibleClass: "swiper-slide-visible",
            slideDuplicateClass: "swiper-slide-duplicate",
            slideNextClass: "swiper-slide-next",
            slideDuplicateNextClass: "swiper-slide-duplicate-next",
            slidePrevClass: "swiper-slide-prev",
            slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
            wrapperClass: "swiper-wrapper",
            runCallbacksOnInit: !0,
        };
        const re = {
                update: F,
                translate: B,
                transition: j,
                slide: H,
                loop: V,
                grabCursor: W,
                manipulation: U,
                events: {
                    attachEvents: function () {
                        const e = this,
                            { params: t, touchEvents: n, el: r, wrapperEl: i } = e;
                        (e.onTouchStart = Y.bind(e)), (e.onTouchMove = X.bind(e)), (e.onTouchEnd = K.bind(e)), t.cssMode && (e.onScroll = Q.bind(e)), (e.onClick = Z.bind(e));
                        const o = !!t.nested;
                        if (!z.touch && z.pointerEvents) r.addEventListener(n.start, e.onTouchStart, !1), $.addEventListener(n.move, e.onTouchMove, o), $.addEventListener(n.end, e.onTouchEnd, !1);
                        else {
                            if (z.touch) {
                                const i = !("touchstart" !== n.start || !z.passiveListener || !t.passiveListeners) && { passive: !0, capture: !1 };
                                r.addEventListener(n.start, e.onTouchStart, i),
                                    r.addEventListener(n.move, e.onTouchMove, z.passiveListener ? { passive: !1, capture: o } : o),
                                    r.addEventListener(n.end, e.onTouchEnd, i),
                                    n.cancel && r.addEventListener(n.cancel, e.onTouchEnd, i),
                                    ee || ($.addEventListener("touchstart", te), (ee = !0));
                            }
                            ((t.simulateTouch && !G.ios && !G.android) || (t.simulateTouch && !z.touch && G.ios)) &&
                                (r.addEventListener("mousedown", e.onTouchStart, !1), $.addEventListener("mousemove", e.onTouchMove, o), $.addEventListener("mouseup", e.onTouchEnd, !1));
                        }
                        (t.preventClicks || t.preventClicksPropagation) && r.addEventListener("click", e.onClick, !0),
                            t.cssMode && i.addEventListener("scroll", e.onScroll),
                            t.updateOnWindowResize ? e.on(G.ios || G.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", J, !0) : e.on("observerUpdate", J, !0);
                    },
                    detachEvents: function () {
                        const e = this,
                            { params: t, touchEvents: n, el: r, wrapperEl: i } = e,
                            o = !!t.nested;
                        if (!z.touch && z.pointerEvents) r.removeEventListener(n.start, e.onTouchStart, !1), $.removeEventListener(n.move, e.onTouchMove, o), $.removeEventListener(n.end, e.onTouchEnd, !1);
                        else {
                            if (z.touch) {
                                const i = !("onTouchStart" !== n.start || !z.passiveListener || !t.passiveListeners) && { passive: !0, capture: !1 };
                                r.removeEventListener(n.start, e.onTouchStart, i), r.removeEventListener(n.move, e.onTouchMove, o), r.removeEventListener(n.end, e.onTouchEnd, i), n.cancel && r.removeEventListener(n.cancel, e.onTouchEnd, i);
                            }
                            ((t.simulateTouch && !G.ios && !G.android) || (t.simulateTouch && !z.touch && G.ios)) &&
                                (r.removeEventListener("mousedown", e.onTouchStart, !1), $.removeEventListener("mousemove", e.onTouchMove, o), $.removeEventListener("mouseup", e.onTouchEnd, !1));
                        }
                        (t.preventClicks || t.preventClicksPropagation) && r.removeEventListener("click", e.onClick, !0),
                            t.cssMode && i.removeEventListener("scroll", e.onScroll),
                            e.off(G.ios || G.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", J);
                    },
                },
                breakpoints: {
                    setBreakpoint: function () {
                        const e = this,
                            { activeIndex: t, initialized: n, loopedSlides: r = 0, params: i, $el: o } = e,
                            a = i.breakpoints;
                        if (!a || (a && 0 === Object.keys(a).length)) return;
                        const s = e.getBreakpoint(a);
                        if (s && e.currentBreakpoint !== s) {
                            const l = s in a ? a[s] : void 0;
                            l &&
                                ["slidesPerView", "spaceBetween", "slidesPerGroup", "slidesPerGroupSkip", "slidesPerColumn"].forEach((e) => {
                                    const t = l[e];
                                    void 0 !== t && (l[e] = "slidesPerView" !== e || ("AUTO" !== t && "auto" !== t) ? ("slidesPerView" === e ? parseFloat(t) : parseInt(t, 10)) : "auto");
                                });
                            const c = l || e.originalParams,
                                u = i.slidesPerColumn > 1,
                                d = c.slidesPerColumn > 1;
                            u && !d
                                ? o.removeClass(`${i.containerModifierClass}multirow ${i.containerModifierClass}multirow-column`)
                                : !u && d && (o.addClass(`${i.containerModifierClass}multirow`), "column" === c.slidesPerColumnFill && o.addClass(`${i.containerModifierClass}multirow-column`));
                            const p = c.direction && c.direction !== i.direction,
                                h = i.loop && (c.slidesPerView !== i.slidesPerView || p);
                            p && n && e.changeDirection(),
                                N.extend(e.params, c),
                                N.extend(e, { allowTouchMove: e.params.allowTouchMove, allowSlideNext: e.params.allowSlideNext, allowSlidePrev: e.params.allowSlidePrev }),
                                (e.currentBreakpoint = s),
                                h && n && (e.loopDestroy(), e.loopCreate(), e.updateSlides(), e.slideTo(t - r + e.loopedSlides, 0, !1)),
                                e.emit("breakpoint", c);
                        }
                    },
                    getBreakpoint: function (e) {
                        if (!e) return;
                        let t = !1;
                        const n = Object.keys(e).map((e) => {
                            if ("string" == typeof e && 0 === e.indexOf("@")) {
                                const t = parseFloat(e.substr(1));
                                return { value: O.innerHeight * t, point: e };
                            }
                            return { value: e, point: e };
                        });
                        n.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
                        for (let e = 0; e < n.length; e += 1) {
                            const { point: r, value: i } = n[e];
                            i <= O.innerWidth && (t = r);
                        }
                        return t || "max";
                    },
                },
                checkOverflow: {
                    checkOverflow: function () {
                        const e = this,
                            t = e.params,
                            n = e.isLocked,
                            r = e.slides.length > 0 && t.slidesOffsetBefore + t.spaceBetween * (e.slides.length - 1) + e.slides[0].offsetWidth * e.slides.length;
                        t.slidesOffsetBefore && t.slidesOffsetAfter && r ? (e.isLocked = r <= e.size) : (e.isLocked = 1 === e.snapGrid.length),
                            (e.allowSlideNext = !e.isLocked),
                            (e.allowSlidePrev = !e.isLocked),
                            n !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock"),
                            n && n !== e.isLocked && ((e.isEnd = !1), e.navigation && e.navigation.update());
                    },
                },
                classes: {
                    addClasses: function () {
                        const { classNames: e, params: t, rtl: n, $el: r } = this,
                            i = [];
                        i.push("initialized"),
                            i.push(t.direction),
                            t.freeMode && i.push("free-mode"),
                            t.autoHeight && i.push("autoheight"),
                            n && i.push("rtl"),
                            t.slidesPerColumn > 1 && (i.push("multirow"), "column" === t.slidesPerColumnFill && i.push("multirow-column")),
                            G.android && i.push("android"),
                            G.ios && i.push("ios"),
                            t.cssMode && i.push("css-mode"),
                            i.forEach((n) => {
                                e.push(t.containerModifierClass + n);
                            }),
                            r.addClass(e.join(" "));
                    },
                    removeClasses: function () {
                        const { $el: e, classNames: t } = this;
                        e.removeClass(t.join(" "));
                    },
                },
                images: {
                    loadImage: function (e, t, n, r, i, o) {
                        let a;
                        function s() {
                            o && o();
                        }
                        M(e).parent("picture")[0] || (e.complete && i) ? s() : t ? ((a = new O.Image()), (a.onload = s), (a.onerror = s), r && (a.sizes = r), n && (a.srcset = n), t && (a.src = t)) : s();
                    },
                    preloadImages: function () {
                        const e = this;
                        function t() {
                            null != e && e && !e.destroyed && (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1), e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(), e.emit("imagesReady")));
                        }
                        e.imagesToLoad = e.$el.find("img");
                        for (let n = 0; n < e.imagesToLoad.length; n += 1) {
                            const r = e.imagesToLoad[n];
                            e.loadImage(r, r.currentSrc || r.getAttribute("src"), r.srcset || r.getAttribute("srcset"), r.sizes || r.getAttribute("sizes"), !0, t);
                        }
                    },
                },
            },
            ie = {};
        class oe extends R {
            constructor(...e) {
                let t, n;
                1 === e.length && e[0].constructor && e[0].constructor === Object ? (n = e[0]) : ([t, n] = e),
                    n || (n = {}),
                    (n = N.extend({}, n)),
                    t && !n.el && (n.el = t),
                    super(n),
                    Object.keys(re).forEach((e) => {
                        Object.keys(re[e]).forEach((t) => {
                            oe.prototype[t] || (oe.prototype[t] = re[e][t]);
                        });
                    });
                const r = this;
                void 0 === r.modules && (r.modules = {}),
                    Object.keys(r.modules).forEach((e) => {
                        const t = r.modules[e];
                        if (t.params) {
                            const e = Object.keys(t.params)[0],
                                r = t.params[e];
                            if ("object" != typeof r || null === r) return;
                            if (!(e in n) || !("enabled" in r)) return;
                            !0 === n[e] && (n[e] = { enabled: !0 }), "object" != typeof n[e] || "enabled" in n[e] || (n[e].enabled = !0), n[e] || (n[e] = { enabled: !1 });
                        }
                    });
                const i = N.extend({}, ne);
                r.useModulesParams(i), (r.params = N.extend({}, i, ie, n)), (r.originalParams = N.extend({}, r.params)), (r.passedParams = N.extend({}, n)), (r.$ = M);
                const o = M(r.params.el);
                if (((t = o[0]), !t)) return;
                if (o.length > 1) {
                    const e = [];
                    return (
                        o.each((t, r) => {
                            const i = N.extend({}, n, { el: r });
                            e.push(new oe(i));
                        }),
                        e
                    );
                }
                let a;
                return (
                    (t.swiper = r),
                    o.data("swiper", r),
                    t && t.shadowRoot && t.shadowRoot.querySelector ? ((a = M(t.shadowRoot.querySelector(`.${r.params.wrapperClass}`))), (a.children = (e) => o.children(e))) : (a = o.children(`.${r.params.wrapperClass}`)),
                    N.extend(r, {
                        $el: o,
                        el: t,
                        $wrapperEl: a,
                        wrapperEl: a[0],
                        classNames: [],
                        slides: M(),
                        slidesGrid: [],
                        snapGrid: [],
                        slidesSizesGrid: [],
                        isHorizontal: () => "horizontal" === r.params.direction,
                        isVertical: () => "vertical" === r.params.direction,
                        rtl: "rtl" === t.dir.toLowerCase() || "rtl" === o.css("direction"),
                        rtlTranslate: "horizontal" === r.params.direction && ("rtl" === t.dir.toLowerCase() || "rtl" === o.css("direction")),
                        wrongRTL: "-webkit-box" === a.css("display"),
                        activeIndex: 0,
                        realIndex: 0,
                        isBeginning: !0,
                        isEnd: !1,
                        translate: 0,
                        previousTranslate: 0,
                        progress: 0,
                        velocity: 0,
                        animating: !1,
                        allowSlideNext: r.params.allowSlideNext,
                        allowSlidePrev: r.params.allowSlidePrev,
                        touchEvents: (function () {
                            const e = ["touchstart", "touchmove", "touchend", "touchcancel"];
                            let t = ["mousedown", "mousemove", "mouseup"];
                            return (
                                z.pointerEvents && (t = ["pointerdown", "pointermove", "pointerup"]),
                                (r.touchEventsTouch = { start: e[0], move: e[1], end: e[2], cancel: e[3] }),
                                (r.touchEventsDesktop = { start: t[0], move: t[1], end: t[2] }),
                                z.touch || !r.params.simulateTouch ? r.touchEventsTouch : r.touchEventsDesktop
                            );
                        })(),
                        touchEventsData: {
                            isTouched: void 0,
                            isMoved: void 0,
                            allowTouchCallbacks: void 0,
                            touchStartTime: void 0,
                            isScrolling: void 0,
                            currentTranslate: void 0,
                            startTranslate: void 0,
                            allowThresholdMove: void 0,
                            formElements: "input, select, option, textarea, button, video, label",
                            lastClickTime: N.now(),
                            clickTimeout: void 0,
                            velocities: [],
                            allowMomentumBounce: void 0,
                            isTouchEvent: void 0,
                            startMoving: void 0,
                        },
                        allowClick: !0,
                        allowTouchMove: r.params.allowTouchMove,
                        touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
                        imagesToLoad: [],
                        imagesLoaded: 0,
                    }),
                    r.useModules(),
                    r.params.init && r.init(),
                    r
                );
            }
            slidesPerViewDynamic() {
                const { params: e, slides: t, slidesGrid: n, size: r, activeIndex: i } = this;
                let o = 1;
                if (e.centeredSlides) {
                    let e,
                        n = t[i].swiperSlideSize;
                    for (let a = i + 1; a < t.length; a += 1) t[a] && !e && ((n += t[a].swiperSlideSize), (o += 1), n > r && (e = !0));
                    for (let a = i - 1; a >= 0; a -= 1) t[a] && !e && ((n += t[a].swiperSlideSize), (o += 1), n > r && (e = !0));
                } else for (let e = i + 1; e < t.length; e += 1) n[e] - n[i] < r && (o += 1);
                return o;
            }
            update() {
                const e = this;
                if (!e || e.destroyed) return;
                const { snapGrid: t, params: n } = e;
                function r() {
                    const t = e.rtlTranslate ? -1 * e.translate : e.translate,
                        n = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
                    e.setTranslate(n), e.updateActiveIndex(), e.updateSlidesClasses();
                }
                let i;
                n.breakpoints && e.setBreakpoint(),
                    e.updateSize(),
                    e.updateSlides(),
                    e.updateProgress(),
                    e.updateSlidesClasses(),
                    e.params.freeMode
                        ? (r(), e.params.autoHeight && e.updateAutoHeight())
                        : ((i = ("auto" === e.params.slidesPerView || e.params.slidesPerView > 1) && e.isEnd && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0)), i || r()),
                    n.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
                    e.emit("update");
            }
            changeDirection(e, t = !0) {
                const n = this,
                    r = n.params.direction;
                return (
                    e || (e = "horizontal" === r ? "vertical" : "horizontal"),
                    e === r ||
                        ("horizontal" !== e && "vertical" !== e) ||
                        (n.$el.removeClass(`${n.params.containerModifierClass}${r}`).addClass(`${n.params.containerModifierClass}${e}`),
                        (n.params.direction = e),
                        n.slides.each((t, n) => {
                            "vertical" === e ? (n.style.width = "") : (n.style.height = "");
                        }),
                        n.emit("changeDirection"),
                        t && n.update()),
                    n
                );
            }
            init() {
                const e = this;
                e.initialized ||
                    (e.emit("beforeInit"),
                    e.params.breakpoints && e.setBreakpoint(),
                    e.addClasses(),
                    e.params.loop && e.loopCreate(),
                    e.updateSize(),
                    e.updateSlides(),
                    e.params.watchOverflow && e.checkOverflow(),
                    e.params.grabCursor && e.setGrabCursor(),
                    e.params.preloadImages && e.preloadImages(),
                    e.params.loop ? e.slideTo(e.params.initialSlide + e.loopedSlides, 0, e.params.runCallbacksOnInit) : e.slideTo(e.params.initialSlide, 0, e.params.runCallbacksOnInit),
                    e.attachEvents(),
                    (e.initialized = !0),
                    e.emit("init"));
            }
            destroy(e = !0, t = !0) {
                const n = this,
                    { params: r, $el: i, $wrapperEl: o, slides: a } = n;
                return (
                    void 0 === n.params ||
                        n.destroyed ||
                        (n.emit("beforeDestroy"),
                        (n.initialized = !1),
                        n.detachEvents(),
                        r.loop && n.loopDestroy(),
                        t &&
                            (n.removeClasses(),
                            i.removeAttr("style"),
                            o.removeAttr("style"),
                            a && a.length && a.removeClass([r.slideVisibleClass, r.slideActiveClass, r.slideNextClass, r.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")),
                        n.emit("destroy"),
                        Object.keys(n.eventsListeners).forEach((e) => {
                            n.off(e);
                        }),
                        !1 !== e && ((n.$el[0].swiper = null), n.$el.data("swiper", null), N.deleteProps(n)),
                        (n.destroyed = !0)),
                    null
                );
            }
            static extendDefaults(e) {
                N.extend(ie, e);
            }
            static get extendedDefaults() {
                return ie;
            }
            static get defaults() {
                return ne;
            }
            static get Class() {
                return R;
            }
            static get $() {
                return M;
            }
        }
        var ae = { name: "device", proto: { device: G }, static: { device: G } },
            se = { name: "support", proto: { support: z }, static: { support: z } };
        const le = {
            isEdge: !!O.navigator.userAgent.match(/Edge/g),
            isSafari: (function () {
                const e = O.navigator.userAgent.toLowerCase();
                return e.indexOf("safari") >= 0 && e.indexOf("chrome") < 0 && e.indexOf("android") < 0;
            })(),
            isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(O.navigator.userAgent),
        };
        var ce = { name: "browser", proto: { browser: le }, static: { browser: le } },
            ue = {
                name: "resize",
                create() {
                    const e = this;
                    N.extend(e, {
                        resize: {
                            resizeHandler() {
                                e && !e.destroyed && e.initialized && (e.emit("beforeResize"), e.emit("resize"));
                            },
                            orientationChangeHandler() {
                                e && !e.destroyed && e.initialized && e.emit("orientationchange");
                            },
                        },
                    });
                },
                on: {
                    init() {
                        O.addEventListener("resize", this.resize.resizeHandler), O.addEventListener("orientationchange", this.resize.orientationChangeHandler);
                    },
                    destroy() {
                        O.removeEventListener("resize", this.resize.resizeHandler), O.removeEventListener("orientationchange", this.resize.orientationChangeHandler);
                    },
                },
            };
        const de = {
            func: O.MutationObserver || O.WebkitMutationObserver,
            attach(e, t = {}) {
                const n = this,
                    r = new (0, de.func)((e) => {
                        if (1 === e.length) return void n.emit("observerUpdate", e[0]);
                        const t = function () {
                            n.emit("observerUpdate", e[0]);
                        };
                        O.requestAnimationFrame ? O.requestAnimationFrame(t) : O.setTimeout(t, 0);
                    });
                r.observe(e, { attributes: void 0 === t.attributes || t.attributes, childList: void 0 === t.childList || t.childList, characterData: void 0 === t.characterData || t.characterData }), n.observer.observers.push(r);
            },
            init() {
                const e = this;
                if (z.observer && e.params.observer) {
                    if (e.params.observeParents) {
                        const t = e.$el.parents();
                        for (let n = 0; n < t.length; n += 1) e.observer.attach(t[n]);
                    }
                    e.observer.attach(e.$el[0], { childList: e.params.observeSlideChildren }), e.observer.attach(e.$wrapperEl[0], { attributes: !1 });
                }
            },
            destroy() {
                this.observer.observers.forEach((e) => {
                    e.disconnect();
                }),
                    (this.observer.observers = []);
            },
        };
        var pe = {
            name: "observer",
            params: { observer: !1, observeParents: !1, observeSlideChildren: !1 },
            create() {
                const e = this;
                N.extend(e, { observer: { init: de.init.bind(e), attach: de.attach.bind(e), destroy: de.destroy.bind(e), observers: [] } });
            },
            on: {
                init() {
                    this.observer.init();
                },
                destroy() {
                    this.observer.destroy();
                },
            },
        };
        const he = {
            update(e) {
                const t = this,
                    { slidesPerView: n, slidesPerGroup: r, centeredSlides: i } = t.params,
                    { addSlidesBefore: o, addSlidesAfter: a } = t.params.virtual,
                    { from: s, to: l, slides: c, slidesGrid: u, renderSlide: d, offset: p } = t.virtual;
                t.updateActiveIndex();
                const h = t.activeIndex || 0;
                let f, m, g;
                (f = t.rtlTranslate ? "right" : t.isHorizontal() ? "left" : "top"), i ? ((m = Math.floor(n / 2) + r + o), (g = Math.floor(n / 2) + r + a)) : ((m = n + (r - 1) + o), (g = r + a));
                const v = Math.max((h || 0) - g, 0),
                    y = Math.min((h || 0) + m, c.length - 1),
                    b = (t.slidesGrid[v] || 0) - (t.slidesGrid[0] || 0);
                function w() {
                    t.updateSlides(), t.updateProgress(), t.updateSlidesClasses(), t.lazy && t.params.lazy.enabled && t.lazy.load();
                }
                if ((N.extend(t.virtual, { from: v, to: y, offset: b, slidesGrid: t.slidesGrid }), s === v && l === y && !e)) return t.slidesGrid !== u && b !== p && t.slides.css(f, `${b}px`), void t.updateProgress();
                if (t.params.virtual.renderExternal)
                    return (
                        t.params.virtual.renderExternal.call(t, {
                            offset: b,
                            from: v,
                            to: y,
                            slides: (function () {
                                const e = [];
                                for (let t = v; t <= y; t += 1) e.push(c[t]);
                                return e;
                            })(),
                        }),
                        void w()
                    );
                const x = [],
                    E = [];
                if (e) t.$wrapperEl.find(`.${t.params.slideClass}`).remove();
                else for (let e = s; e <= l; e += 1) (e < v || e > y) && t.$wrapperEl.find(`.${t.params.slideClass}[data-swiper-slide-index="${e}"]`).remove();
                for (let t = 0; t < c.length; t += 1) t >= v && t <= y && (void 0 === l || e ? E.push(t) : (t > l && E.push(t), t < s && x.push(t)));
                E.forEach((e) => {
                    t.$wrapperEl.append(d(c[e], e));
                }),
                    x
                        .sort((e, t) => t - e)
                        .forEach((e) => {
                            t.$wrapperEl.prepend(d(c[e], e));
                        }),
                    t.$wrapperEl.children(".swiper-slide").css(f, `${b}px`),
                    w();
            },
            renderSlide(e, t) {
                const n = this,
                    r = n.params.virtual;
                if (r.cache && n.virtual.cache[t]) return n.virtual.cache[t];
                const i = r.renderSlide ? M(r.renderSlide.call(n, e, t)) : M(`<div class="${n.params.slideClass}" data-swiper-slide-index="${t}">${e}</div>`);
                return i.attr("data-swiper-slide-index") || i.attr("data-swiper-slide-index", t), r.cache && (n.virtual.cache[t] = i), i;
            },
            appendSlide(e) {
                const t = this;
                if ("object" == typeof e && "length" in e) for (let n = 0; n < e.length; n += 1) e[n] && t.virtual.slides.push(e[n]);
                else t.virtual.slides.push(e);
                t.virtual.update(!0);
            },
            prependSlide(e) {
                const t = this,
                    n = t.activeIndex;
                let r = n + 1,
                    i = 1;
                if (Array.isArray(e)) {
                    for (let n = 0; n < e.length; n += 1) e[n] && t.virtual.slides.unshift(e[n]);
                    (r = n + e.length), (i = e.length);
                } else t.virtual.slides.unshift(e);
                if (t.params.virtual.cache) {
                    const e = t.virtual.cache,
                        n = {};
                    Object.keys(e).forEach((t) => {
                        const r = e[t],
                            o = r.attr("data-swiper-slide-index");
                        o && r.attr("data-swiper-slide-index", parseInt(o, 10) + 1), (n[parseInt(t, 10) + i] = r);
                    }),
                        (t.virtual.cache = n);
                }
                t.virtual.update(!0), t.slideTo(r, 0);
            },
            removeSlide(e) {
                const t = this;
                if (null == e) return;
                let n = t.activeIndex;
                if (Array.isArray(e)) for (let r = e.length - 1; r >= 0; r -= 1) t.virtual.slides.splice(e[r], 1), t.params.virtual.cache && delete t.virtual.cache[e[r]], e[r] < n && (n -= 1), (n = Math.max(n, 0));
                else t.virtual.slides.splice(e, 1), t.params.virtual.cache && delete t.virtual.cache[e], e < n && (n -= 1), (n = Math.max(n, 0));
                t.virtual.update(!0), t.slideTo(n, 0);
            },
            removeAllSlides() {
                const e = this;
                (e.virtual.slides = []), e.params.virtual.cache && (e.virtual.cache = {}), e.virtual.update(!0), e.slideTo(0, 0);
            },
        };
        var fe = {
            name: "virtual",
            params: { virtual: { enabled: !1, slides: [], cache: !0, renderSlide: null, renderExternal: null, addSlidesBefore: 0, addSlidesAfter: 0 } },
            create() {
                const e = this;
                N.extend(e, {
                    virtual: {
                        update: he.update.bind(e),
                        appendSlide: he.appendSlide.bind(e),
                        prependSlide: he.prependSlide.bind(e),
                        removeSlide: he.removeSlide.bind(e),
                        removeAllSlides: he.removeAllSlides.bind(e),
                        renderSlide: he.renderSlide.bind(e),
                        slides: e.params.virtual.slides,
                        cache: {},
                    },
                });
            },
            on: {
                beforeInit() {
                    const e = this;
                    if (!e.params.virtual.enabled) return;
                    e.classNames.push(`${e.params.containerModifierClass}virtual`);
                    const t = { watchSlidesProgress: !0 };
                    N.extend(e.params, t), N.extend(e.originalParams, t), e.params.initialSlide || e.virtual.update();
                },
                setTranslate() {
                    this.params.virtual.enabled && this.virtual.update();
                },
            },
        };
        const me = {
            handle(e) {
                const t = this,
                    { rtlTranslate: n } = t;
                let r = e;
                r.originalEvent && (r = r.originalEvent);
                const i = r.keyCode || r.charCode,
                    o = t.params.keyboard.pageUpDown,
                    a = o && 33 === i,
                    s = o && 34 === i,
                    l = 37 === i,
                    c = 39 === i,
                    u = 38 === i,
                    d = 40 === i;
                if (!t.allowSlideNext && ((t.isHorizontal() && c) || (t.isVertical() && d) || s)) return !1;
                if (!t.allowSlidePrev && ((t.isHorizontal() && l) || (t.isVertical() && u) || a)) return !1;
                if (!(r.shiftKey || r.altKey || r.ctrlKey || r.metaKey || ($.activeElement && $.activeElement.nodeName && ("input" === $.activeElement.nodeName.toLowerCase() || "textarea" === $.activeElement.nodeName.toLowerCase())))) {
                    if (t.params.keyboard.onlyInViewport && (a || s || l || c || u || d)) {
                        let e = !1;
                        if (t.$el.parents(`.${t.params.slideClass}`).length > 0 && 0 === t.$el.parents(`.${t.params.slideActiveClass}`).length) return;
                        const r = O.innerWidth,
                            i = O.innerHeight,
                            o = t.$el.offset();
                        n && (o.left -= t.$el[0].scrollLeft);
                        const a = [
                            [o.left, o.top],
                            [o.left + t.width, o.top],
                            [o.left, o.top + t.height],
                            [o.left + t.width, o.top + t.height],
                        ];
                        for (let t = 0; t < a.length; t += 1) {
                            const n = a[t];
                            n[0] >= 0 && n[0] <= r && n[1] >= 0 && n[1] <= i && (e = !0);
                        }
                        if (!e) return;
                    }
                    t.isHorizontal()
                        ? ((a || s || l || c) && (r.preventDefault ? r.preventDefault() : (r.returnValue = !1)), (((s || c) && !n) || ((a || l) && n)) && t.slideNext(), (((a || l) && !n) || ((s || c) && n)) && t.slidePrev())
                        : ((a || s || u || d) && (r.preventDefault ? r.preventDefault() : (r.returnValue = !1)), (s || d) && t.slideNext(), (a || u) && t.slidePrev()),
                        t.emit("keyPress", i);
                }
            },
            enable() {
                const e = this;
                e.keyboard.enabled || (M($).on("keydown", e.keyboard.handle), (e.keyboard.enabled = !0));
            },
            disable() {
                const e = this;
                e.keyboard.enabled && (M($).off("keydown", e.keyboard.handle), (e.keyboard.enabled = !1));
            },
        };
        var ge = {
            name: "keyboard",
            params: { keyboard: { enabled: !1, onlyInViewport: !0, pageUpDown: !0 } },
            create() {
                const e = this;
                N.extend(e, { keyboard: { enabled: !1, enable: me.enable.bind(e), disable: me.disable.bind(e), handle: me.handle.bind(e) } });
            },
            on: {
                init() {
                    const e = this;
                    e.params.keyboard.enabled && e.keyboard.enable();
                },
                destroy() {
                    const e = this;
                    e.keyboard.enabled && e.keyboard.disable();
                },
            },
        };
        const ve = {
            lastScrollTime: N.now(),
            lastEventBeforeSnap: void 0,
            recentWheelEvents: [],
            event: () =>
                O.navigator.userAgent.indexOf("firefox") > -1
                    ? "DOMMouseScroll"
                    : (function () {
                          const e = "onwheel";
                          let t = e in $;
                          if (!t) {
                              const n = $.createElement("div");
                              n.setAttribute(e, "return;"), (t = "function" == typeof n[e]);
                          }
                          return !t && $.implementation && $.implementation.hasFeature && !0 !== $.implementation.hasFeature("", "") && (t = $.implementation.hasFeature("Events.wheel", "3.0")), t;
                      })()
                    ? "wheel"
                    : "mousewheel",
            normalize(e) {
                let t = 0,
                    n = 0,
                    r = 0,
                    i = 0;
                return (
                    "detail" in e && (n = e.detail),
                    "wheelDelta" in e && (n = -e.wheelDelta / 120),
                    "wheelDeltaY" in e && (n = -e.wheelDeltaY / 120),
                    "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120),
                    "axis" in e && e.axis === e.HORIZONTAL_AXIS && ((t = n), (n = 0)),
                    (r = 10 * t),
                    (i = 10 * n),
                    "deltaY" in e && (i = e.deltaY),
                    "deltaX" in e && (r = e.deltaX),
                    e.shiftKey && !r && ((r = i), (i = 0)),
                    (r || i) && e.deltaMode && (1 === e.deltaMode ? ((r *= 40), (i *= 40)) : ((r *= 800), (i *= 800))),
                    r && !t && (t = r < 1 ? -1 : 1),
                    i && !n && (n = i < 1 ? -1 : 1),
                    { spinX: t, spinY: n, pixelX: r, pixelY: i }
                );
            },
            handleMouseEnter() {
                this.mouseEntered = !0;
            },
            handleMouseLeave() {
                this.mouseEntered = !1;
            },
            handle(e) {
                let t = e;
                const n = this,
                    r = n.params.mousewheel;
                n.params.cssMode && t.preventDefault();
                let i = n.$el;
                if (("container" !== n.params.mousewheel.eventsTarged && (i = M(n.params.mousewheel.eventsTarged)), !n.mouseEntered && !i[0].contains(t.target) && !r.releaseOnEdges)) return !0;
                t.originalEvent && (t = t.originalEvent);
                let o = 0;
                const a = n.rtlTranslate ? -1 : 1,
                    s = ve.normalize(t);
                if (r.forceToAxis)
                    if (n.isHorizontal()) {
                        if (!(Math.abs(s.pixelX) > Math.abs(s.pixelY))) return !0;
                        o = -s.pixelX * a;
                    } else {
                        if (!(Math.abs(s.pixelY) > Math.abs(s.pixelX))) return !0;
                        o = -s.pixelY;
                    }
                else o = Math.abs(s.pixelX) > Math.abs(s.pixelY) ? -s.pixelX * a : -s.pixelY;
                if (0 === o) return !0;
                if ((r.invert && (o = -o), n.params.freeMode)) {
                    const e = { time: N.now(), delta: Math.abs(o), direction: Math.sign(o) },
                        { lastEventBeforeSnap: i } = n.mousewheel,
                        a = i && e.time < i.time + 500 && e.delta <= i.delta && e.direction === i.direction;
                    if (!a) {
                        (n.mousewheel.lastEventBeforeSnap = void 0), n.params.loop && n.loopFix();
                        let i = n.getTranslate() + o * r.sensitivity;
                        const s = n.isBeginning,
                            l = n.isEnd;
                        if (
                            (i >= n.minTranslate() && (i = n.minTranslate()),
                            i <= n.maxTranslate() && (i = n.maxTranslate()),
                            n.setTransition(0),
                            n.setTranslate(i),
                            n.updateProgress(),
                            n.updateActiveIndex(),
                            n.updateSlidesClasses(),
                            ((!s && n.isBeginning) || (!l && n.isEnd)) && n.updateSlidesClasses(),
                            n.params.freeModeSticky)
                        ) {
                            clearTimeout(n.mousewheel.timeout), (n.mousewheel.timeout = void 0);
                            const t = n.mousewheel.recentWheelEvents;
                            t.length >= 15 && t.shift();
                            const r = t.length ? t[t.length - 1] : void 0,
                                i = t[0];
                            if ((t.push(e), r && (e.delta > r.delta || e.direction !== r.direction))) t.splice(0);
                            else if (t.length >= 15 && e.time - i.time < 500 && i.delta - e.delta >= 1 && e.delta <= 6) {
                                const r = o > 0 ? 0.8 : 0.2;
                                (n.mousewheel.lastEventBeforeSnap = e),
                                    t.splice(0),
                                    (n.mousewheel.timeout = N.nextTick(() => {
                                        n.slideToClosest(n.params.speed, !0, void 0, r);
                                    }, 0));
                            }
                            n.mousewheel.timeout ||
                                (n.mousewheel.timeout = N.nextTick(() => {
                                    (n.mousewheel.lastEventBeforeSnap = e), t.splice(0), n.slideToClosest(n.params.speed, !0, void 0, 0.5);
                                }, 500));
                        }
                        if ((a || n.emit("scroll", t), n.params.autoplay && n.params.autoplayDisableOnInteraction && n.autoplay.stop(), i === n.minTranslate() || i === n.maxTranslate())) return !0;
                    }
                } else {
                    const t = { time: N.now(), delta: Math.abs(o), direction: Math.sign(o), raw: e },
                        r = n.mousewheel.recentWheelEvents;
                    r.length >= 2 && r.shift();
                    const i = r.length ? r[r.length - 1] : void 0;
                    if ((r.push(t), i ? (t.direction !== i.direction || t.delta > i.delta || t.time > i.time + 150) && n.mousewheel.animateSlider(t) : n.mousewheel.animateSlider(t), n.mousewheel.releaseScroll(t))) return !0;
                }
                return t.preventDefault ? t.preventDefault() : (t.returnValue = !1), !1;
            },
            animateSlider(e) {
                const t = this;
                return (
                    (e.delta >= 6 && N.now() - t.mousewheel.lastScrollTime < 60) ||
                    (e.direction < 0 ? (t.isEnd && !t.params.loop) || t.animating || (t.slideNext(), t.emit("scroll", e.raw)) : (t.isBeginning && !t.params.loop) || t.animating || (t.slidePrev(), t.emit("scroll", e.raw)),
                    (t.mousewheel.lastScrollTime = new O.Date().getTime()),
                    !1)
                );
            },
            releaseScroll(e) {
                const t = this,
                    n = t.params.mousewheel;
                if (e.direction < 0) {
                    if (t.isEnd && !t.params.loop && n.releaseOnEdges) return !0;
                } else if (t.isBeginning && !t.params.loop && n.releaseOnEdges) return !0;
                return !1;
            },
            enable() {
                const e = this,
                    t = ve.event();
                if (e.params.cssMode) return e.wrapperEl.removeEventListener(t, e.mousewheel.handle), !0;
                if (!t) return !1;
                if (e.mousewheel.enabled) return !1;
                let n = e.$el;
                return (
                    "container" !== e.params.mousewheel.eventsTarged && (n = M(e.params.mousewheel.eventsTarged)),
                    n.on("mouseenter", e.mousewheel.handleMouseEnter),
                    n.on("mouseleave", e.mousewheel.handleMouseLeave),
                    n.on(t, e.mousewheel.handle),
                    (e.mousewheel.enabled = !0),
                    !0
                );
            },
            disable() {
                const e = this,
                    t = ve.event();
                if (e.params.cssMode) return e.wrapperEl.addEventListener(t, e.mousewheel.handle), !0;
                if (!t) return !1;
                if (!e.mousewheel.enabled) return !1;
                let n = e.$el;
                return "container" !== e.params.mousewheel.eventsTarged && (n = M(e.params.mousewheel.eventsTarged)), n.off(t, e.mousewheel.handle), (e.mousewheel.enabled = !1), !0;
            },
        };
        const ye = {
            update() {
                const e = this,
                    t = e.params.navigation;
                if (e.params.loop) return;
                const { $nextEl: n, $prevEl: r } = e.navigation;
                r && r.length > 0 && (e.isBeginning ? r.addClass(t.disabledClass) : r.removeClass(t.disabledClass), r[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](t.lockClass)),
                    n && n.length > 0 && (e.isEnd ? n.addClass(t.disabledClass) : n.removeClass(t.disabledClass), n[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](t.lockClass));
            },
            onPrevClick(e) {
                const t = this;
                e.preventDefault(), (t.isBeginning && !t.params.loop) || t.slidePrev();
            },
            onNextClick(e) {
                const t = this;
                e.preventDefault(), (t.isEnd && !t.params.loop) || t.slideNext();
            },
            init() {
                const e = this,
                    t = e.params.navigation;
                if (!t.nextEl && !t.prevEl) return;
                let n, r;
                t.nextEl && ((n = M(t.nextEl)), e.params.uniqueNavElements && "string" == typeof t.nextEl && n.length > 1 && 1 === e.$el.find(t.nextEl).length && (n = e.$el.find(t.nextEl))),
                    t.prevEl && ((r = M(t.prevEl)), e.params.uniqueNavElements && "string" == typeof t.prevEl && r.length > 1 && 1 === e.$el.find(t.prevEl).length && (r = e.$el.find(t.prevEl))),
                    n && n.length > 0 && n.on("click", e.navigation.onNextClick),
                    r && r.length > 0 && r.on("click", e.navigation.onPrevClick),
                    N.extend(e.navigation, { $nextEl: n, nextEl: n && n[0], $prevEl: r, prevEl: r && r[0] });
            },
            destroy() {
                const e = this,
                    { $nextEl: t, $prevEl: n } = e.navigation;
                t && t.length && (t.off("click", e.navigation.onNextClick), t.removeClass(e.params.navigation.disabledClass)), n && n.length && (n.off("click", e.navigation.onPrevClick), n.removeClass(e.params.navigation.disabledClass));
            },
        };
        const be = {
            update() {
                const e = this,
                    t = e.rtl,
                    n = e.params.pagination;
                if (!n.el || !e.pagination.el || !e.pagination.$el || 0 === e.pagination.$el.length) return;
                const r = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
                    i = e.pagination.$el;
                let o;
                const a = e.params.loop ? Math.ceil((r - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;
                if (
                    (e.params.loop
                        ? ((o = Math.ceil((e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup)),
                          o > r - 1 - 2 * e.loopedSlides && (o -= r - 2 * e.loopedSlides),
                          o > a - 1 && (o -= a),
                          o < 0 && "bullets" !== e.params.paginationType && (o = a + o))
                        : (o = void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0),
                    "bullets" === n.type && e.pagination.bullets && e.pagination.bullets.length > 0)
                ) {
                    const r = e.pagination.bullets;
                    let a, s, l;
                    if (
                        (n.dynamicBullets &&
                            ((e.pagination.bulletSize = r.eq(0)[e.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
                            i.css(e.isHorizontal() ? "width" : "height", e.pagination.bulletSize * (n.dynamicMainBullets + 4) + "px"),
                            n.dynamicMainBullets > 1 &&
                                void 0 !== e.previousIndex &&
                                ((e.pagination.dynamicBulletIndex += o - e.previousIndex),
                                e.pagination.dynamicBulletIndex > n.dynamicMainBullets - 1 ? (e.pagination.dynamicBulletIndex = n.dynamicMainBullets - 1) : e.pagination.dynamicBulletIndex < 0 && (e.pagination.dynamicBulletIndex = 0)),
                            (a = o - e.pagination.dynamicBulletIndex),
                            (s = a + (Math.min(r.length, n.dynamicMainBullets) - 1)),
                            (l = (s + a) / 2)),
                        r.removeClass(`${n.bulletActiveClass} ${n.bulletActiveClass}-next ${n.bulletActiveClass}-next-next ${n.bulletActiveClass}-prev ${n.bulletActiveClass}-prev-prev ${n.bulletActiveClass}-main`),
                        i.length > 1)
                    )
                        r.each((e, t) => {
                            const r = M(t),
                                i = r.index();
                            i === o && r.addClass(n.bulletActiveClass),
                                n.dynamicBullets &&
                                    (i >= a && i <= s && r.addClass(`${n.bulletActiveClass}-main`),
                                    i === a && r.prev().addClass(`${n.bulletActiveClass}-prev`).prev().addClass(`${n.bulletActiveClass}-prev-prev`),
                                    i === s && r.next().addClass(`${n.bulletActiveClass}-next`).next().addClass(`${n.bulletActiveClass}-next-next`));
                        });
                    else {
                        const t = r.eq(o),
                            i = t.index();
                        if ((t.addClass(n.bulletActiveClass), n.dynamicBullets)) {
                            const t = r.eq(a),
                                o = r.eq(s);
                            for (let e = a; e <= s; e += 1) r.eq(e).addClass(`${n.bulletActiveClass}-main`);
                            if (e.params.loop)
                                if (i >= r.length - n.dynamicMainBullets) {
                                    for (let e = n.dynamicMainBullets; e >= 0; e -= 1) r.eq(r.length - e).addClass(`${n.bulletActiveClass}-main`);
                                    r.eq(r.length - n.dynamicMainBullets - 1).addClass(`${n.bulletActiveClass}-prev`);
                                } else
                                    t.prev().addClass(`${n.bulletActiveClass}-prev`).prev().addClass(`${n.bulletActiveClass}-prev-prev`), o.next().addClass(`${n.bulletActiveClass}-next`).next().addClass(`${n.bulletActiveClass}-next-next`);
                            else t.prev().addClass(`${n.bulletActiveClass}-prev`).prev().addClass(`${n.bulletActiveClass}-prev-prev`), o.next().addClass(`${n.bulletActiveClass}-next`).next().addClass(`${n.bulletActiveClass}-next-next`);
                        }
                    }
                    if (n.dynamicBullets) {
                        const i = Math.min(r.length, n.dynamicMainBullets + 4),
                            o = (e.pagination.bulletSize * i - e.pagination.bulletSize) / 2 - l * e.pagination.bulletSize,
                            a = t ? "right" : "left";
                        r.css(e.isHorizontal() ? a : "top", `${o}px`);
                    }
                }
                if (("fraction" === n.type && (i.find(`.${n.currentClass}`).text(n.formatFractionCurrent(o + 1)), i.find(`.${n.totalClass}`).text(n.formatFractionTotal(a))), "progressbar" === n.type)) {
                    let t;
                    t = n.progressbarOpposite ? (e.isHorizontal() ? "vertical" : "horizontal") : e.isHorizontal() ? "horizontal" : "vertical";
                    const r = (o + 1) / a;
                    let s = 1,
                        l = 1;
                    "horizontal" === t ? (s = r) : (l = r), i.find(`.${n.progressbarFillClass}`).transform(`translate3d(0,0,0) scaleX(${s}) scaleY(${l})`).transition(e.params.speed);
                }
                "custom" === n.type && n.renderCustom ? (i.html(n.renderCustom(e, o + 1, a)), e.emit("paginationRender", e, i[0])) : e.emit("paginationUpdate", e, i[0]),
                    i[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](n.lockClass);
            },
            render() {
                const e = this,
                    t = e.params.pagination;
                if (!t.el || !e.pagination.el || !e.pagination.$el || 0 === e.pagination.$el.length) return;
                const n = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
                    r = e.pagination.$el;
                let i = "";
                if ("bullets" === t.type) {
                    const o = e.params.loop ? Math.ceil((n - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;
                    for (let n = 0; n < o; n += 1) t.renderBullet ? (i += t.renderBullet.call(e, n, t.bulletClass)) : (i += `<${t.bulletElement} class="${t.bulletClass}"></${t.bulletElement}>`);
                    r.html(i), (e.pagination.bullets = r.find(`.${t.bulletClass}`));
                }
                "fraction" === t.type && ((i = t.renderFraction ? t.renderFraction.call(e, t.currentClass, t.totalClass) : `<span class="${t.currentClass}"></span> / <span class="${t.totalClass}"></span>`), r.html(i)),
                    "progressbar" === t.type && ((i = t.renderProgressbar ? t.renderProgressbar.call(e, t.progressbarFillClass) : `<span class="${t.progressbarFillClass}"></span>`), r.html(i)),
                    "custom" !== t.type && e.emit("paginationRender", e.pagination.$el[0]);
            },
            init() {
                const e = this,
                    t = e.params.pagination;
                if (!t.el) return;
                let n = M(t.el);
                0 !== n.length &&
                    (e.params.uniqueNavElements && "string" == typeof t.el && n.length > 1 && (n = e.$el.find(t.el)),
                    "bullets" === t.type && t.clickable && n.addClass(t.clickableClass),
                    n.addClass(t.modifierClass + t.type),
                    "bullets" === t.type && t.dynamicBullets && (n.addClass(`${t.modifierClass}${t.type}-dynamic`), (e.pagination.dynamicBulletIndex = 0), t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)),
                    "progressbar" === t.type && t.progressbarOpposite && n.addClass(t.progressbarOppositeClass),
                    t.clickable &&
                        n.on("click", `.${t.bulletClass}`, function (t) {
                            t.preventDefault();
                            let n = M(this).index() * e.params.slidesPerGroup;
                            e.params.loop && (n += e.loopedSlides), e.slideTo(n);
                        }),
                    N.extend(e.pagination, { $el: n, el: n[0] }));
            },
            destroy() {
                const e = this,
                    t = e.params.pagination;
                if (!t.el || !e.pagination.el || !e.pagination.$el || 0 === e.pagination.$el.length) return;
                const n = e.pagination.$el;
                n.removeClass(t.hiddenClass), n.removeClass(t.modifierClass + t.type), e.pagination.bullets && e.pagination.bullets.removeClass(t.bulletActiveClass), t.clickable && n.off("click", `.${t.bulletClass}`);
            },
        };
        const we = {
            setTranslate() {
                const e = this;
                if (!e.params.scrollbar.el || !e.scrollbar.el) return;
                const { scrollbar: t, rtlTranslate: n, progress: r } = e,
                    { dragSize: i, trackSize: o, $dragEl: a, $el: s } = t,
                    l = e.params.scrollbar;
                let c = i,
                    u = (o - i) * r;
                n ? ((u = -u), u > 0 ? ((c = i - u), (u = 0)) : -u + i > o && (c = o + u)) : u < 0 ? ((c = i + u), (u = 0)) : u + i > o && (c = o - u),
                    e.isHorizontal() ? (a.transform(`translate3d(${u}px, 0, 0)`), (a[0].style.width = `${c}px`)) : (a.transform(`translate3d(0px, ${u}px, 0)`), (a[0].style.height = `${c}px`)),
                    l.hide &&
                        (clearTimeout(e.scrollbar.timeout),
                        (s[0].style.opacity = 1),
                        (e.scrollbar.timeout = setTimeout(() => {
                            (s[0].style.opacity = 0), s.transition(400);
                        }, 1e3)));
            },
            setTransition(e) {
                const t = this;
                t.params.scrollbar.el && t.scrollbar.el && t.scrollbar.$dragEl.transition(e);
            },
            updateSize() {
                const e = this;
                if (!e.params.scrollbar.el || !e.scrollbar.el) return;
                const { scrollbar: t } = e,
                    { $dragEl: n, $el: r } = t;
                (n[0].style.width = ""), (n[0].style.height = "");
                const i = e.isHorizontal() ? r[0].offsetWidth : r[0].offsetHeight,
                    o = e.size / e.virtualSize,
                    a = o * (i / e.size);
                let s;
                (s = "auto" === e.params.scrollbar.dragSize ? i * o : parseInt(e.params.scrollbar.dragSize, 10)),
                    e.isHorizontal() ? (n[0].style.width = `${s}px`) : (n[0].style.height = `${s}px`),
                    (r[0].style.display = o >= 1 ? "none" : ""),
                    e.params.scrollbar.hide && (r[0].style.opacity = 0),
                    N.extend(t, { trackSize: i, divider: o, moveDivider: a, dragSize: s }),
                    t.$el[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](e.params.scrollbar.lockClass);
            },
            getPointerPosition(e) {
                return this.isHorizontal() ? ("touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].clientX : e.clientX) : "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].clientY : e.clientY;
            },
            setDragPosition(e) {
                const t = this,
                    { scrollbar: n, rtlTranslate: r } = t,
                    { $el: i, dragSize: o, trackSize: a, dragStartPos: s } = n;
                let l;
                (l = (n.getPointerPosition(e) - i.offset()[t.isHorizontal() ? "left" : "top"] - (null !== s ? s : o / 2)) / (a - o)), (l = Math.max(Math.min(l, 1), 0)), r && (l = 1 - l);
                const c = t.minTranslate() + (t.maxTranslate() - t.minTranslate()) * l;
                t.updateProgress(c), t.setTranslate(c), t.updateActiveIndex(), t.updateSlidesClasses();
            },
            onDragStart(e) {
                const t = this,
                    n = t.params.scrollbar,
                    { scrollbar: r, $wrapperEl: i } = t,
                    { $el: o, $dragEl: a } = r;
                (t.scrollbar.isTouched = !0),
                    (t.scrollbar.dragStartPos = e.target === a[0] || e.target === a ? r.getPointerPosition(e) - e.target.getBoundingClientRect()[t.isHorizontal() ? "left" : "top"] : null),
                    e.preventDefault(),
                    e.stopPropagation(),
                    i.transition(100),
                    a.transition(100),
                    r.setDragPosition(e),
                    clearTimeout(t.scrollbar.dragTimeout),
                    o.transition(0),
                    n.hide && o.css("opacity", 1),
                    t.params.cssMode && t.$wrapperEl.css("scroll-snap-type", "none"),
                    t.emit("scrollbarDragStart", e);
            },
            onDragMove(e) {
                const t = this,
                    { scrollbar: n, $wrapperEl: r } = t,
                    { $el: i, $dragEl: o } = n;
                t.scrollbar.isTouched && (e.preventDefault ? e.preventDefault() : (e.returnValue = !1), n.setDragPosition(e), r.transition(0), i.transition(0), o.transition(0), t.emit("scrollbarDragMove", e));
            },
            onDragEnd(e) {
                const t = this,
                    n = t.params.scrollbar,
                    { scrollbar: r, $wrapperEl: i } = t,
                    { $el: o } = r;
                t.scrollbar.isTouched &&
                    ((t.scrollbar.isTouched = !1),
                    t.params.cssMode && (t.$wrapperEl.css("scroll-snap-type", ""), i.transition("")),
                    n.hide &&
                        (clearTimeout(t.scrollbar.dragTimeout),
                        (t.scrollbar.dragTimeout = N.nextTick(() => {
                            o.css("opacity", 0), o.transition(400);
                        }, 1e3))),
                    t.emit("scrollbarDragEnd", e),
                    n.snapOnRelease && t.slideToClosest());
            },
            enableDraggable() {
                const e = this;
                if (!e.params.scrollbar.el) return;
                const { scrollbar: t, touchEventsTouch: n, touchEventsDesktop: r, params: i } = e,
                    o = t.$el[0],
                    a = !(!z.passiveListener || !i.passiveListeners) && { passive: !1, capture: !1 },
                    s = !(!z.passiveListener || !i.passiveListeners) && { passive: !0, capture: !1 };
                z.touch
                    ? (o.addEventListener(n.start, e.scrollbar.onDragStart, a), o.addEventListener(n.move, e.scrollbar.onDragMove, a), o.addEventListener(n.end, e.scrollbar.onDragEnd, s))
                    : (o.addEventListener(r.start, e.scrollbar.onDragStart, a), $.addEventListener(r.move, e.scrollbar.onDragMove, a), $.addEventListener(r.end, e.scrollbar.onDragEnd, s));
            },
            disableDraggable() {
                const e = this;
                if (!e.params.scrollbar.el) return;
                const { scrollbar: t, touchEventsTouch: n, touchEventsDesktop: r, params: i } = e,
                    o = t.$el[0],
                    a = !(!z.passiveListener || !i.passiveListeners) && { passive: !1, capture: !1 },
                    s = !(!z.passiveListener || !i.passiveListeners) && { passive: !0, capture: !1 };
                z.touch
                    ? (o.removeEventListener(n.start, e.scrollbar.onDragStart, a), o.removeEventListener(n.move, e.scrollbar.onDragMove, a), o.removeEventListener(n.end, e.scrollbar.onDragEnd, s))
                    : (o.removeEventListener(r.start, e.scrollbar.onDragStart, a), $.removeEventListener(r.move, e.scrollbar.onDragMove, a), $.removeEventListener(r.end, e.scrollbar.onDragEnd, s));
            },
            init() {
                const e = this;
                if (!e.params.scrollbar.el) return;
                const { scrollbar: t, $el: n } = e,
                    r = e.params.scrollbar;
                let i = M(r.el);
                e.params.uniqueNavElements && "string" == typeof r.el && i.length > 1 && 1 === n.find(r.el).length && (i = n.find(r.el));
                let o = i.find(`.${e.params.scrollbar.dragClass}`);
                0 === o.length && ((o = M(`<div class="${e.params.scrollbar.dragClass}"></div>`)), i.append(o)), N.extend(t, { $el: i, el: i[0], $dragEl: o, dragEl: o[0] }), r.draggable && t.enableDraggable();
            },
            destroy() {
                this.scrollbar.disableDraggable();
            },
        };
        const xe = {
            setTransform(e, t) {
                const { rtl: n } = this,
                    r = M(e),
                    i = n ? -1 : 1,
                    o = r.attr("data-swiper-parallax") || "0";
                let a = r.attr("data-swiper-parallax-x"),
                    s = r.attr("data-swiper-parallax-y");
                const l = r.attr("data-swiper-parallax-scale"),
                    c = r.attr("data-swiper-parallax-opacity");
                if (
                    (a || s ? ((a = a || "0"), (s = s || "0")) : this.isHorizontal() ? ((a = o), (s = "0")) : ((s = o), (a = "0")),
                    (a = a.indexOf("%") >= 0 ? parseInt(a, 10) * t * i + "%" : a * t * i + "px"),
                    (s = s.indexOf("%") >= 0 ? parseInt(s, 10) * t + "%" : s * t + "px"),
                    null != c)
                ) {
                    const e = c - (c - 1) * (1 - Math.abs(t));
                    r[0].style.opacity = e;
                }
                if (null == l) r.transform(`translate3d(${a}, ${s}, 0px)`);
                else {
                    const e = l - (l - 1) * (1 - Math.abs(t));
                    r.transform(`translate3d(${a}, ${s}, 0px) scale(${e})`);
                }
            },
            setTranslate() {
                const e = this,
                    { $el: t, slides: n, progress: r, snapGrid: i } = e;
                t.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((t, n) => {
                    e.parallax.setTransform(n, r);
                }),
                    n.each((t, n) => {
                        let o = n.progress;
                        e.params.slidesPerGroup > 1 && "auto" !== e.params.slidesPerView && (o += Math.ceil(t / 2) - r * (i.length - 1)),
                            (o = Math.min(Math.max(o, -1), 1)),
                            M(n)
                                .find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]")
                                .each((t, n) => {
                                    e.parallax.setTransform(n, o);
                                });
                    });
            },
            setTransition(e = this.params.speed) {
                const { $el: t } = this;
                t.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((t, n) => {
                    const r = M(n);
                    let i = parseInt(r.attr("data-swiper-parallax-duration"), 10) || e;
                    0 === e && (i = 0), r.transition(i);
                });
            },
        };
        const Ee = {
            getDistanceBetweenTouches(e) {
                if (e.targetTouches.length < 2) return 1;
                const t = e.targetTouches[0].pageX,
                    n = e.targetTouches[0].pageY,
                    r = e.targetTouches[1].pageX,
                    i = e.targetTouches[1].pageY;
                return Math.sqrt((r - t) ** 2 + (i - n) ** 2);
            },
            onGestureStart(e) {
                const t = this,
                    n = t.params.zoom,
                    r = t.zoom,
                    { gesture: i } = r;
                if (((r.fakeGestureTouched = !1), (r.fakeGestureMoved = !1), !z.gestures)) {
                    if ("touchstart" !== e.type || ("touchstart" === e.type && e.targetTouches.length < 2)) return;
                    (r.fakeGestureTouched = !0), (i.scaleStart = Ee.getDistanceBetweenTouches(e));
                }
                (i.$slideEl && i.$slideEl.length) ||
                ((i.$slideEl = M(e.target).closest(`.${t.params.slideClass}`)),
                0 === i.$slideEl.length && (i.$slideEl = t.slides.eq(t.activeIndex)),
                (i.$imageEl = i.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target")),
                (i.$imageWrapEl = i.$imageEl.parent(`.${n.containerClass}`)),
                (i.maxRatio = i.$imageWrapEl.attr("data-swiper-zoom") || n.maxRatio),
                0 !== i.$imageWrapEl.length)
                    ? (i.$imageEl && i.$imageEl.transition(0), (t.zoom.isScaling = !0))
                    : (i.$imageEl = void 0);
            },
            onGestureChange(e) {
                const t = this.params.zoom,
                    n = this.zoom,
                    { gesture: r } = n;
                if (!z.gestures) {
                    if ("touchmove" !== e.type || ("touchmove" === e.type && e.targetTouches.length < 2)) return;
                    (n.fakeGestureMoved = !0), (r.scaleMove = Ee.getDistanceBetweenTouches(e));
                }
                r.$imageEl &&
                    0 !== r.$imageEl.length &&
                    ((n.scale = z.gestures ? e.scale * n.currentScale : (r.scaleMove / r.scaleStart) * n.currentScale),
                    n.scale > r.maxRatio && (n.scale = r.maxRatio - 1 + (n.scale - r.maxRatio + 1) ** 0.5),
                    n.scale < t.minRatio && (n.scale = t.minRatio + 1 - (t.minRatio - n.scale + 1) ** 0.5),
                    r.$imageEl.transform(`translate3d(0,0,0) scale(${n.scale})`));
            },
            onGestureEnd(e) {
                const t = this,
                    n = t.params.zoom,
                    r = t.zoom,
                    { gesture: i } = r;
                if (!z.gestures) {
                    if (!r.fakeGestureTouched || !r.fakeGestureMoved) return;
                    if ("touchend" !== e.type || ("touchend" === e.type && e.changedTouches.length < 2 && !G.android)) return;
                    (r.fakeGestureTouched = !1), (r.fakeGestureMoved = !1);
                }
                i.$imageEl &&
                    0 !== i.$imageEl.length &&
                    ((r.scale = Math.max(Math.min(r.scale, i.maxRatio), n.minRatio)),
                    i.$imageEl.transition(t.params.speed).transform(`translate3d(0,0,0) scale(${r.scale})`),
                    (r.currentScale = r.scale),
                    (r.isScaling = !1),
                    1 === r.scale && (i.$slideEl = void 0));
            },
            onTouchStart(e) {
                const t = this.zoom,
                    { gesture: n, image: r } = t;
                n.$imageEl &&
                    0 !== n.$imageEl.length &&
                    (r.isTouched ||
                        (G.android && e.cancelable && e.preventDefault(),
                        (r.isTouched = !0),
                        (r.touchesStart.x = "touchstart" === e.type ? e.targetTouches[0].pageX : e.pageX),
                        (r.touchesStart.y = "touchstart" === e.type ? e.targetTouches[0].pageY : e.pageY)));
            },
            onTouchMove(e) {
                const t = this,
                    n = t.zoom,
                    { gesture: r, image: i, velocity: o } = n;
                if (!r.$imageEl || 0 === r.$imageEl.length) return;
                if (((t.allowClick = !1), !i.isTouched || !r.$slideEl)) return;
                i.isMoved ||
                    ((i.width = r.$imageEl[0].offsetWidth),
                    (i.height = r.$imageEl[0].offsetHeight),
                    (i.startX = N.getTranslate(r.$imageWrapEl[0], "x") || 0),
                    (i.startY = N.getTranslate(r.$imageWrapEl[0], "y") || 0),
                    (r.slideWidth = r.$slideEl[0].offsetWidth),
                    (r.slideHeight = r.$slideEl[0].offsetHeight),
                    r.$imageWrapEl.transition(0),
                    t.rtl && ((i.startX = -i.startX), (i.startY = -i.startY)));
                const a = i.width * n.scale,
                    s = i.height * n.scale;
                if (!(a < r.slideWidth && s < r.slideHeight)) {
                    if (
                        ((i.minX = Math.min(r.slideWidth / 2 - a / 2, 0)),
                        (i.maxX = -i.minX),
                        (i.minY = Math.min(r.slideHeight / 2 - s / 2, 0)),
                        (i.maxY = -i.minY),
                        (i.touchesCurrent.x = "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX),
                        (i.touchesCurrent.y = "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY),
                        !i.isMoved && !n.isScaling)
                    ) {
                        if (t.isHorizontal() && ((Math.floor(i.minX) === Math.floor(i.startX) && i.touchesCurrent.x < i.touchesStart.x) || (Math.floor(i.maxX) === Math.floor(i.startX) && i.touchesCurrent.x > i.touchesStart.x)))
                            return void (i.isTouched = !1);
                        if (!t.isHorizontal() && ((Math.floor(i.minY) === Math.floor(i.startY) && i.touchesCurrent.y < i.touchesStart.y) || (Math.floor(i.maxY) === Math.floor(i.startY) && i.touchesCurrent.y > i.touchesStart.y)))
                            return void (i.isTouched = !1);
                    }
                    e.cancelable && e.preventDefault(),
                        e.stopPropagation(),
                        (i.isMoved = !0),
                        (i.currentX = i.touchesCurrent.x - i.touchesStart.x + i.startX),
                        (i.currentY = i.touchesCurrent.y - i.touchesStart.y + i.startY),
                        i.currentX < i.minX && (i.currentX = i.minX + 1 - (i.minX - i.currentX + 1) ** 0.8),
                        i.currentX > i.maxX && (i.currentX = i.maxX - 1 + (i.currentX - i.maxX + 1) ** 0.8),
                        i.currentY < i.minY && (i.currentY = i.minY + 1 - (i.minY - i.currentY + 1) ** 0.8),
                        i.currentY > i.maxY && (i.currentY = i.maxY - 1 + (i.currentY - i.maxY + 1) ** 0.8),
                        o.prevPositionX || (o.prevPositionX = i.touchesCurrent.x),
                        o.prevPositionY || (o.prevPositionY = i.touchesCurrent.y),
                        o.prevTime || (o.prevTime = Date.now()),
                        (o.x = (i.touchesCurrent.x - o.prevPositionX) / (Date.now() - o.prevTime) / 2),
                        (o.y = (i.touchesCurrent.y - o.prevPositionY) / (Date.now() - o.prevTime) / 2),
                        Math.abs(i.touchesCurrent.x - o.prevPositionX) < 2 && (o.x = 0),
                        Math.abs(i.touchesCurrent.y - o.prevPositionY) < 2 && (o.y = 0),
                        (o.prevPositionX = i.touchesCurrent.x),
                        (o.prevPositionY = i.touchesCurrent.y),
                        (o.prevTime = Date.now()),
                        r.$imageWrapEl.transform(`translate3d(${i.currentX}px, ${i.currentY}px,0)`);
                }
            },
            onTouchEnd() {
                const e = this.zoom,
                    { gesture: t, image: n, velocity: r } = e;
                if (!t.$imageEl || 0 === t.$imageEl.length) return;
                if (!n.isTouched || !n.isMoved) return (n.isTouched = !1), void (n.isMoved = !1);
                (n.isTouched = !1), (n.isMoved = !1);
                let i = 300,
                    o = 300;
                const a = r.x * i,
                    s = n.currentX + a,
                    l = r.y * o,
                    c = n.currentY + l;
                0 !== r.x && (i = Math.abs((s - n.currentX) / r.x)), 0 !== r.y && (o = Math.abs((c - n.currentY) / r.y));
                const u = Math.max(i, o);
                (n.currentX = s), (n.currentY = c);
                const d = n.width * e.scale,
                    p = n.height * e.scale;
                (n.minX = Math.min(t.slideWidth / 2 - d / 2, 0)),
                    (n.maxX = -n.minX),
                    (n.minY = Math.min(t.slideHeight / 2 - p / 2, 0)),
                    (n.maxY = -n.minY),
                    (n.currentX = Math.max(Math.min(n.currentX, n.maxX), n.minX)),
                    (n.currentY = Math.max(Math.min(n.currentY, n.maxY), n.minY)),
                    t.$imageWrapEl.transition(u).transform(`translate3d(${n.currentX}px, ${n.currentY}px,0)`);
            },
            onTransitionEnd() {
                const e = this,
                    t = e.zoom,
                    { gesture: n } = t;
                n.$slideEl &&
                    e.previousIndex !== e.activeIndex &&
                    (n.$imageEl && n.$imageEl.transform("translate3d(0,0,0) scale(1)"),
                    n.$imageWrapEl && n.$imageWrapEl.transform("translate3d(0,0,0)"),
                    (t.scale = 1),
                    (t.currentScale = 1),
                    (n.$slideEl = void 0),
                    (n.$imageEl = void 0),
                    (n.$imageWrapEl = void 0));
            },
            toggle(e) {
                const t = this.zoom;
                t.scale && 1 !== t.scale ? t.out() : t.in(e);
            },
            in(e) {
                const t = this,
                    n = t.zoom,
                    r = t.params.zoom,
                    { gesture: i, image: o } = n;
                if (
                    (i.$slideEl ||
                        (t.params.virtual && t.params.virtual.enabled && t.virtual ? (i.$slideEl = t.$wrapperEl.children(`.${t.params.slideActiveClass}`)) : (i.$slideEl = t.slides.eq(t.activeIndex)),
                        (i.$imageEl = i.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target")),
                        (i.$imageWrapEl = i.$imageEl.parent(`.${r.containerClass}`))),
                    !i.$imageEl || 0 === i.$imageEl.length)
                )
                    return;
                let a, s, l, c, u, d, p, h, f, m, g, v, y, b, w, x, E, C;
                i.$slideEl.addClass(`${r.zoomedSlideClass}`),
                    void 0 === o.touchesStart.x && e
                        ? ((a = "touchend" === e.type ? e.changedTouches[0].pageX : e.pageX), (s = "touchend" === e.type ? e.changedTouches[0].pageY : e.pageY))
                        : ((a = o.touchesStart.x), (s = o.touchesStart.y)),
                    (n.scale = i.$imageWrapEl.attr("data-swiper-zoom") || r.maxRatio),
                    (n.currentScale = i.$imageWrapEl.attr("data-swiper-zoom") || r.maxRatio),
                    e
                        ? ((E = i.$slideEl[0].offsetWidth),
                          (C = i.$slideEl[0].offsetHeight),
                          (l = i.$slideEl.offset().left),
                          (c = i.$slideEl.offset().top),
                          (u = l + E / 2 - a),
                          (d = c + C / 2 - s),
                          (f = i.$imageEl[0].offsetWidth),
                          (m = i.$imageEl[0].offsetHeight),
                          (g = f * n.scale),
                          (v = m * n.scale),
                          (y = Math.min(E / 2 - g / 2, 0)),
                          (b = Math.min(C / 2 - v / 2, 0)),
                          (w = -y),
                          (x = -b),
                          (p = u * n.scale),
                          (h = d * n.scale),
                          p < y && (p = y),
                          p > w && (p = w),
                          h < b && (h = b),
                          h > x && (h = x))
                        : ((p = 0), (h = 0)),
                    i.$imageWrapEl.transition(300).transform(`translate3d(${p}px, ${h}px,0)`),
                    i.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${n.scale})`);
            },
            out() {
                const e = this,
                    t = e.zoom,
                    n = e.params.zoom,
                    { gesture: r } = t;
                r.$slideEl ||
                    (e.params.virtual && e.params.virtual.enabled && e.virtual ? (r.$slideEl = e.$wrapperEl.children(`.${e.params.slideActiveClass}`)) : (r.$slideEl = e.slides.eq(e.activeIndex)),
                    (r.$imageEl = r.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target")),
                    (r.$imageWrapEl = r.$imageEl.parent(`.${n.containerClass}`))),
                    r.$imageEl &&
                        0 !== r.$imageEl.length &&
                        ((t.scale = 1),
                        (t.currentScale = 1),
                        r.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"),
                        r.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"),
                        r.$slideEl.removeClass(`${n.zoomedSlideClass}`),
                        (r.$slideEl = void 0));
            },
            enable() {
                const e = this,
                    t = e.zoom;
                if (t.enabled) return;
                t.enabled = !0;
                const n = !("touchstart" !== e.touchEvents.start || !z.passiveListener || !e.params.passiveListeners) && { passive: !0, capture: !1 },
                    r = !z.passiveListener || { passive: !1, capture: !0 },
                    i = `.${e.params.slideClass}`;
                z.gestures
                    ? (e.$wrapperEl.on("gesturestart", i, t.onGestureStart, n), e.$wrapperEl.on("gesturechange", i, t.onGestureChange, n), e.$wrapperEl.on("gestureend", i, t.onGestureEnd, n))
                    : "touchstart" === e.touchEvents.start &&
                      (e.$wrapperEl.on(e.touchEvents.start, i, t.onGestureStart, n),
                      e.$wrapperEl.on(e.touchEvents.move, i, t.onGestureChange, r),
                      e.$wrapperEl.on(e.touchEvents.end, i, t.onGestureEnd, n),
                      e.touchEvents.cancel && e.$wrapperEl.on(e.touchEvents.cancel, i, t.onGestureEnd, n)),
                    e.$wrapperEl.on(e.touchEvents.move, `.${e.params.zoom.containerClass}`, t.onTouchMove, r);
            },
            disable() {
                const e = this,
                    t = e.zoom;
                if (!t.enabled) return;
                e.zoom.enabled = !1;
                const n = !("touchstart" !== e.touchEvents.start || !z.passiveListener || !e.params.passiveListeners) && { passive: !0, capture: !1 },
                    r = !z.passiveListener || { passive: !1, capture: !0 },
                    i = `.${e.params.slideClass}`;
                z.gestures
                    ? (e.$wrapperEl.off("gesturestart", i, t.onGestureStart, n), e.$wrapperEl.off("gesturechange", i, t.onGestureChange, n), e.$wrapperEl.off("gestureend", i, t.onGestureEnd, n))
                    : "touchstart" === e.touchEvents.start &&
                      (e.$wrapperEl.off(e.touchEvents.start, i, t.onGestureStart, n),
                      e.$wrapperEl.off(e.touchEvents.move, i, t.onGestureChange, r),
                      e.$wrapperEl.off(e.touchEvents.end, i, t.onGestureEnd, n),
                      e.touchEvents.cancel && e.$wrapperEl.off(e.touchEvents.cancel, i, t.onGestureEnd, n)),
                    e.$wrapperEl.off(e.touchEvents.move, `.${e.params.zoom.containerClass}`, t.onTouchMove, r);
            },
        };
        const Ce = {
            loadInSlide(e, t = !0) {
                const n = this,
                    r = n.params.lazy;
                if (void 0 === e) return;
                if (0 === n.slides.length) return;
                const i = n.virtual && n.params.virtual.enabled ? n.$wrapperEl.children(`.${n.params.slideClass}[data-swiper-slide-index="${e}"]`) : n.slides.eq(e);
                let o = i.find(`.${r.elementClass}:not(.${r.loadedClass}):not(.${r.loadingClass})`);
                !i.hasClass(r.elementClass) || i.hasClass(r.loadedClass) || i.hasClass(r.loadingClass) || (o = o.add(i[0])),
                    0 !== o.length &&
                        o.each((e, o) => {
                            const a = M(o);
                            a.addClass(r.loadingClass);
                            const s = a.attr("data-background"),
                                l = a.attr("data-src"),
                                c = a.attr("data-srcset"),
                                u = a.attr("data-sizes"),
                                d = a.parent("picture");
                            n.loadImage(a[0], l || s, c, u, !1, () => {
                                if (null != n && n && (!n || n.params) && !n.destroyed) {
                                    if (
                                        (s
                                            ? (a.css("background-image", `url("${s}")`), a.removeAttr("data-background"))
                                            : (c && (a.attr("srcset", c), a.removeAttr("data-srcset")),
                                              u && (a.attr("sizes", u), a.removeAttr("data-sizes")),
                                              d.length &&
                                                  d.children("source").each((e, t) => {
                                                      const n = M(t);
                                                      n.attr("data-srcset") && (n.attr("srcset", n.attr("data-srcset")), n.removeAttr("data-srcset"));
                                                  }),
                                              l && (a.attr("src", l), a.removeAttr("data-src"))),
                                        a.addClass(r.loadedClass).removeClass(r.loadingClass),
                                        i.find(`.${r.preloaderClass}`).remove(),
                                        n.params.loop && t)
                                    ) {
                                        const e = i.attr("data-swiper-slide-index");
                                        if (i.hasClass(n.params.slideDuplicateClass)) {
                                            const t = n.$wrapperEl.children(`[data-swiper-slide-index="${e}"]:not(.${n.params.slideDuplicateClass})`);
                                            n.lazy.loadInSlide(t.index(), !1);
                                        } else {
                                            const t = n.$wrapperEl.children(`.${n.params.slideDuplicateClass}[data-swiper-slide-index="${e}"]`);
                                            n.lazy.loadInSlide(t.index(), !1);
                                        }
                                    }
                                    n.emit("lazyImageReady", i[0], a[0]), n.params.autoHeight && n.updateAutoHeight();
                                }
                            }),
                                n.emit("lazyImageLoad", i[0], a[0]);
                        });
            },
            load() {
                const e = this,
                    { $wrapperEl: t, params: n, slides: r, activeIndex: i } = e,
                    o = e.virtual && n.virtual.enabled,
                    a = n.lazy;
                let s = n.slidesPerView;
                function l(e) {
                    if (o) {
                        if (t.children(`.${n.slideClass}[data-swiper-slide-index="${e}"]`).length) return !0;
                    } else if (r[e]) return !0;
                    return !1;
                }
                function c(e) {
                    return o ? M(e).attr("data-swiper-slide-index") : M(e).index();
                }
                if (("auto" === s && (s = 0), e.lazy.initialImageLoaded || (e.lazy.initialImageLoaded = !0), e.params.watchSlidesVisibility))
                    t.children(`.${n.slideVisibleClass}`).each((t, n) => {
                        const r = o ? M(n).attr("data-swiper-slide-index") : M(n).index();
                        e.lazy.loadInSlide(r);
                    });
                else if (s > 1) for (let t = i; t < i + s; t += 1) l(t) && e.lazy.loadInSlide(t);
                else e.lazy.loadInSlide(i);
                if (a.loadPrevNext)
                    if (s > 1 || (a.loadPrevNextAmount && a.loadPrevNextAmount > 1)) {
                        const t = a.loadPrevNextAmount,
                            n = s,
                            o = Math.min(i + n + Math.max(t, n), r.length),
                            c = Math.max(i - Math.max(n, t), 0);
                        for (let t = i + s; t < o; t += 1) l(t) && e.lazy.loadInSlide(t);
                        for (let t = c; t < i; t += 1) l(t) && e.lazy.loadInSlide(t);
                    } else {
                        const r = t.children(`.${n.slideNextClass}`);
                        r.length > 0 && e.lazy.loadInSlide(c(r));
                        const i = t.children(`.${n.slidePrevClass}`);
                        i.length > 0 && e.lazy.loadInSlide(c(i));
                    }
            },
        };
        const Se = {
            LinearSpline: function (e, t) {
                const n = (function () {
                    let e, t, n;
                    return (r, i) => {
                        for (t = -1, e = r.length; e - t > 1; ) (n = (e + t) >> 1), r[n] <= i ? (t = n) : (e = n);
                        return e;
                    };
                })();
                let r, i;
                return (
                    (this.x = e),
                    (this.y = t),
                    (this.lastIndex = e.length - 1),
                    (this.interpolate = function (e) {
                        return e ? ((i = n(this.x, e)), (r = i - 1), ((e - this.x[r]) * (this.y[i] - this.y[r])) / (this.x[i] - this.x[r]) + this.y[r]) : 0;
                    }),
                    this
                );
            },
            getInterpolateFunction(e) {
                const t = this;
                t.controller.spline || (t.controller.spline = t.params.loop ? new Se.LinearSpline(t.slidesGrid, e.slidesGrid) : new Se.LinearSpline(t.snapGrid, e.snapGrid));
            },
            setTranslate(e, t) {
                const n = this,
                    r = n.controller.control;
                let i, o;
                function a(e) {
                    const t = n.rtlTranslate ? -n.translate : n.translate;
                    "slide" === n.params.controller.by && (n.controller.getInterpolateFunction(e), (o = -n.controller.spline.interpolate(-t))),
                        (o && "container" !== n.params.controller.by) || ((i = (e.maxTranslate() - e.minTranslate()) / (n.maxTranslate() - n.minTranslate())), (o = (t - n.minTranslate()) * i + e.minTranslate())),
                        n.params.controller.inverse && (o = e.maxTranslate() - o),
                        e.updateProgress(o),
                        e.setTranslate(o, n),
                        e.updateActiveIndex(),
                        e.updateSlidesClasses();
                }
                if (Array.isArray(r)) for (let e = 0; e < r.length; e += 1) r[e] !== t && r[e] instanceof oe && a(r[e]);
                else r instanceof oe && t !== r && a(r);
            },
            setTransition(e, t) {
                const n = this,
                    r = n.controller.control;
                let i;
                function o(t) {
                    t.setTransition(e, n),
                        0 !== e &&
                            (t.transitionStart(),
                            t.params.autoHeight &&
                                N.nextTick(() => {
                                    t.updateAutoHeight();
                                }),
                            t.$wrapperEl.transitionEnd(() => {
                                r && (t.params.loop && "slide" === n.params.controller.by && t.loopFix(), t.transitionEnd());
                            }));
                }
                if (Array.isArray(r)) for (i = 0; i < r.length; i += 1) r[i] !== t && r[i] instanceof oe && o(r[i]);
                else r instanceof oe && t !== r && o(r);
            },
        };
        const Te = {
            makeElFocusable: (e) => (e.attr("tabIndex", "0"), e),
            makeElNotFocusable: (e) => (e.attr("tabIndex", "-1"), e),
            addElRole: (e, t) => (e.attr("role", t), e),
            addElLabel: (e, t) => (e.attr("aria-label", t), e),
            disableEl: (e) => (e.attr("aria-disabled", !0), e),
            enableEl: (e) => (e.attr("aria-disabled", !1), e),
            onEnterKey(e) {
                const t = this,
                    n = t.params.a11y;
                if (13 !== e.keyCode) return;
                const r = M(e.target);
                t.navigation && t.navigation.$nextEl && r.is(t.navigation.$nextEl) && ((t.isEnd && !t.params.loop) || t.slideNext(), t.isEnd ? t.a11y.notify(n.lastSlideMessage) : t.a11y.notify(n.nextSlideMessage)),
                    t.navigation && t.navigation.$prevEl && r.is(t.navigation.$prevEl) && ((t.isBeginning && !t.params.loop) || t.slidePrev(), t.isBeginning ? t.a11y.notify(n.firstSlideMessage) : t.a11y.notify(n.prevSlideMessage)),
                    t.pagination && r.is(`.${t.params.pagination.bulletClass}`) && r[0].click();
            },
            notify(e) {
                const t = this.a11y.liveRegion;
                0 !== t.length && (t.html(""), t.html(e));
            },
            updateNavigation() {
                const e = this;
                if (e.params.loop || !e.navigation) return;
                const { $nextEl: t, $prevEl: n } = e.navigation;
                n && n.length > 0 && (e.isBeginning ? (e.a11y.disableEl(n), e.a11y.makeElNotFocusable(n)) : (e.a11y.enableEl(n), e.a11y.makeElFocusable(n))),
                    t && t.length > 0 && (e.isEnd ? (e.a11y.disableEl(t), e.a11y.makeElNotFocusable(t)) : (e.a11y.enableEl(t), e.a11y.makeElFocusable(t)));
            },
            updatePagination() {
                const e = this,
                    t = e.params.a11y;
                e.pagination &&
                    e.params.pagination.clickable &&
                    e.pagination.bullets &&
                    e.pagination.bullets.length &&
                    e.pagination.bullets.each((n, r) => {
                        const i = M(r);
                        e.a11y.makeElFocusable(i), e.a11y.addElRole(i, "button"), e.a11y.addElLabel(i, t.paginationBulletMessage.replace(/\{\{index\}\}/, i.index() + 1));
                    });
            },
            init() {
                const e = this;
                e.$el.append(e.a11y.liveRegion);
                const t = e.params.a11y;
                let n, r;
                e.navigation && e.navigation.$nextEl && (n = e.navigation.$nextEl),
                    e.navigation && e.navigation.$prevEl && (r = e.navigation.$prevEl),
                    n && (e.a11y.makeElFocusable(n), e.a11y.addElRole(n, "button"), e.a11y.addElLabel(n, t.nextSlideMessage), n.on("keydown", e.a11y.onEnterKey)),
                    r && (e.a11y.makeElFocusable(r), e.a11y.addElRole(r, "button"), e.a11y.addElLabel(r, t.prevSlideMessage), r.on("keydown", e.a11y.onEnterKey)),
                    e.pagination && e.params.pagination.clickable && e.pagination.bullets && e.pagination.bullets.length && e.pagination.$el.on("keydown", `.${e.params.pagination.bulletClass}`, e.a11y.onEnterKey);
            },
            destroy() {
                const e = this;
                let t, n;
                e.a11y.liveRegion && e.a11y.liveRegion.length > 0 && e.a11y.liveRegion.remove(),
                    e.navigation && e.navigation.$nextEl && (t = e.navigation.$nextEl),
                    e.navigation && e.navigation.$prevEl && (n = e.navigation.$prevEl),
                    t && t.off("keydown", e.a11y.onEnterKey),
                    n && n.off("keydown", e.a11y.onEnterKey),
                    e.pagination && e.params.pagination.clickable && e.pagination.bullets && e.pagination.bullets.length && e.pagination.$el.off("keydown", `.${e.params.pagination.bulletClass}`, e.a11y.onEnterKey);
            },
        };
        const ke = {
            init() {
                const e = this;
                if (!e.params.history) return;
                if (!O.history || !O.history.pushState) return (e.params.history.enabled = !1), void (e.params.hashNavigation.enabled = !0);
                const t = e.history;
                (t.initialized = !0),
                    (t.paths = ke.getPathValues()),
                    (t.paths.key || t.paths.value) && (t.scrollToSlide(0, t.paths.value, e.params.runCallbacksOnInit), e.params.history.replaceState || O.addEventListener("popstate", e.history.setHistoryPopState));
            },
            destroy() {
                const e = this;
                e.params.history.replaceState || O.removeEventListener("popstate", e.history.setHistoryPopState);
            },
            setHistoryPopState() {
                const e = this;
                (e.history.paths = ke.getPathValues()), e.history.scrollToSlide(e.params.speed, e.history.paths.value, !1);
            },
            getPathValues() {
                const e = O.location.pathname
                        .slice(1)
                        .split("/")
                        .filter((e) => "" !== e),
                    t = e.length;
                return { key: e[t - 2], value: e[t - 1] };
            },
            setHistory(e, t) {
                const n = this;
                if (!n.history.initialized || !n.params.history.enabled) return;
                const r = n.slides.eq(t);
                let i = ke.slugify(r.attr("data-history"));
                O.location.pathname.includes(e) || (i = `${e}/${i}`);
                const o = O.history.state;
                (o && o.value === i) || (n.params.history.replaceState ? O.history.replaceState({ value: i }, null, i) : O.history.pushState({ value: i }, null, i));
            },
            slugify: (e) =>
                e
                    .toString()
                    .replace(/\s+/g, "-")
                    .replace(/[^\w-]+/g, "")
                    .replace(/--+/g, "-")
                    .replace(/^-+/, "")
                    .replace(/-+$/, ""),
            scrollToSlide(e, t, n) {
                const r = this;
                if (t)
                    for (let i = 0, o = r.slides.length; i < o; i += 1) {
                        const o = r.slides.eq(i);
                        if (ke.slugify(o.attr("data-history")) === t && !o.hasClass(r.params.slideDuplicateClass)) {
                            const t = o.index();
                            r.slideTo(t, e, n);
                        }
                    }
                else r.slideTo(0, e, n);
            },
        };
        const Ae = {
            onHashCange() {
                const e = this;
                e.emit("hashChange");
                const t = $.location.hash.replace("#", "");
                if (t !== e.slides.eq(e.activeIndex).attr("data-hash")) {
                    const n = e.$wrapperEl.children(`.${e.params.slideClass}[data-hash="${t}"]`).index();
                    if (void 0 === n) return;
                    e.slideTo(n);
                }
            },
            setHash() {
                const e = this;
                if (e.hashNavigation.initialized && e.params.hashNavigation.enabled)
                    if (e.params.hashNavigation.replaceState && O.history && O.history.replaceState) O.history.replaceState(null, null, `#${e.slides.eq(e.activeIndex).attr("data-hash")}` || ""), e.emit("hashSet");
                    else {
                        const t = e.slides.eq(e.activeIndex),
                            n = t.attr("data-hash") || t.attr("data-history");
                        ($.location.hash = n || ""), e.emit("hashSet");
                    }
            },
            init() {
                const e = this;
                if (!e.params.hashNavigation.enabled || (e.params.history && e.params.history.enabled)) return;
                e.hashNavigation.initialized = !0;
                const t = $.location.hash.replace("#", "");
                if (t) {
                    const n = 0;
                    for (let r = 0, i = e.slides.length; r < i; r += 1) {
                        const i = e.slides.eq(r);
                        if ((i.attr("data-hash") || i.attr("data-history")) === t && !i.hasClass(e.params.slideDuplicateClass)) {
                            const t = i.index();
                            e.slideTo(t, n, e.params.runCallbacksOnInit, !0);
                        }
                    }
                }
                e.params.hashNavigation.watchState && M(O).on("hashchange", e.hashNavigation.onHashCange);
            },
            destroy() {
                const e = this;
                e.params.hashNavigation.watchState && M(O).off("hashchange", e.hashNavigation.onHashCange);
            },
        };
        const _e = {
            run() {
                const e = this,
                    t = e.slides.eq(e.activeIndex);
                let n = e.params.autoplay.delay;
                t.attr("data-swiper-autoplay") && (n = t.attr("data-swiper-autoplay") || e.params.autoplay.delay),
                    clearTimeout(e.autoplay.timeout),
                    (e.autoplay.timeout = N.nextTick(() => {
                        e.params.autoplay.reverseDirection
                            ? e.params.loop
                                ? (e.loopFix(), e.slidePrev(e.params.speed, !0, !0), e.emit("autoplay"))
                                : e.isBeginning
                                ? e.params.autoplay.stopOnLastSlide
                                    ? e.autoplay.stop()
                                    : (e.slideTo(e.slides.length - 1, e.params.speed, !0, !0), e.emit("autoplay"))
                                : (e.slidePrev(e.params.speed, !0, !0), e.emit("autoplay"))
                            : e.params.loop
                            ? (e.loopFix(), e.slideNext(e.params.speed, !0, !0), e.emit("autoplay"))
                            : e.isEnd
                            ? e.params.autoplay.stopOnLastSlide
                                ? e.autoplay.stop()
                                : (e.slideTo(0, e.params.speed, !0, !0), e.emit("autoplay"))
                            : (e.slideNext(e.params.speed, !0, !0), e.emit("autoplay")),
                            e.params.cssMode && e.autoplay.running && e.autoplay.run();
                    }, n));
            },
            start() {
                const e = this;
                return void 0 === e.autoplay.timeout && !e.autoplay.running && ((e.autoplay.running = !0), e.emit("autoplayStart"), e.autoplay.run(), !0);
            },
            stop() {
                const e = this;
                return !!e.autoplay.running && void 0 !== e.autoplay.timeout && (e.autoplay.timeout && (clearTimeout(e.autoplay.timeout), (e.autoplay.timeout = void 0)), (e.autoplay.running = !1), e.emit("autoplayStop"), !0);
            },
            pause(e) {
                const t = this;
                t.autoplay.running &&
                    (t.autoplay.paused ||
                        (t.autoplay.timeout && clearTimeout(t.autoplay.timeout),
                        (t.autoplay.paused = !0),
                        0 !== e && t.params.autoplay.waitForTransition
                            ? (t.$wrapperEl[0].addEventListener("transitionend", t.autoplay.onTransitionEnd), t.$wrapperEl[0].addEventListener("webkitTransitionEnd", t.autoplay.onTransitionEnd))
                            : ((t.autoplay.paused = !1), t.autoplay.run())));
            },
        };
        const Le = {
            setTranslate() {
                const e = this,
                    { slides: t } = e;
                for (let n = 0; n < t.length; n += 1) {
                    const t = e.slides.eq(n);
                    let r = -t[0].swiperSlideOffset;
                    e.params.virtualTranslate || (r -= e.translate);
                    let i = 0;
                    e.isHorizontal() || ((i = r), (r = 0));
                    const o = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(t[0].progress), 0) : 1 + Math.min(Math.max(t[0].progress, -1), 0);
                    t.css({ opacity: o }).transform(`translate3d(${r}px, ${i}px, 0px)`);
                }
            },
            setTransition(e) {
                const t = this,
                    { slides: n, $wrapperEl: r } = t;
                if ((n.transition(e), t.params.virtualTranslate && 0 !== e)) {
                    let e = !1;
                    n.transitionEnd(() => {
                        if (e) return;
                        if (!t || t.destroyed) return;
                        (e = !0), (t.animating = !1);
                        const n = ["webkitTransitionEnd", "transitionend"];
                        for (let e = 0; e < n.length; e += 1) r.trigger(n[e]);
                    });
                }
            },
        };
        const $e = {
            setTranslate() {
                const e = this,
                    { $el: t, $wrapperEl: n, slides: r, width: i, height: o, rtlTranslate: a, size: s } = e,
                    l = e.params.cubeEffect,
                    c = e.isHorizontal(),
                    u = e.virtual && e.params.virtual.enabled;
                let d,
                    p = 0;
                l.shadow &&
                    (c
                        ? ((d = n.find(".swiper-cube-shadow")), 0 === d.length && ((d = M('<div class="swiper-cube-shadow"></div>')), n.append(d)), d.css({ height: `${i}px` }))
                        : ((d = t.find(".swiper-cube-shadow")), 0 === d.length && ((d = M('<div class="swiper-cube-shadow"></div>')), t.append(d))));
                for (let e = 0; e < r.length; e += 1) {
                    const t = r.eq(e);
                    let n = e;
                    u && (n = parseInt(t.attr("data-swiper-slide-index"), 10));
                    let i = 90 * n,
                        o = Math.floor(i / 360);
                    a && ((i = -i), (o = Math.floor(-i / 360)));
                    const d = Math.max(Math.min(t[0].progress, 1), -1);
                    let h = 0,
                        f = 0,
                        m = 0;
                    n % 4 == 0 ? ((h = 4 * -o * s), (m = 0)) : (n - 1) % 4 == 0 ? ((h = 0), (m = 4 * -o * s)) : (n - 2) % 4 == 0 ? ((h = s + 4 * o * s), (m = s)) : (n - 3) % 4 == 0 && ((h = -s), (m = 3 * s + 4 * s * o)),
                        a && (h = -h),
                        c || ((f = h), (h = 0));
                    const g = `rotateX(${c ? 0 : -i}deg) rotateY(${c ? i : 0}deg) translate3d(${h}px, ${f}px, ${m}px)`;
                    if ((d <= 1 && d > -1 && ((p = 90 * n + 90 * d), a && (p = 90 * -n - 90 * d)), t.transform(g), l.slideShadows)) {
                        let e = c ? t.find(".swiper-slide-shadow-left") : t.find(".swiper-slide-shadow-top"),
                            n = c ? t.find(".swiper-slide-shadow-right") : t.find(".swiper-slide-shadow-bottom");
                        0 === e.length && ((e = M(`<div class="swiper-slide-shadow-${c ? "left" : "top"}"></div>`)), t.append(e)),
                            0 === n.length && ((n = M(`<div class="swiper-slide-shadow-${c ? "right" : "bottom"}"></div>`)), t.append(n)),
                            e.length && (e[0].style.opacity = Math.max(-d, 0)),
                            n.length && (n[0].style.opacity = Math.max(d, 0));
                    }
                }
                if ((n.css({ "-webkit-transform-origin": `50% 50% -${s / 2}px`, "-moz-transform-origin": `50% 50% -${s / 2}px`, "-ms-transform-origin": `50% 50% -${s / 2}px`, "transform-origin": `50% 50% -${s / 2}px` }), l.shadow))
                    if (c) d.transform(`translate3d(0px, ${i / 2 + l.shadowOffset}px, ${-i / 2}px) rotateX(90deg) rotateZ(0deg) scale(${l.shadowScale})`);
                    else {
                        const e = Math.abs(p) - 90 * Math.floor(Math.abs(p) / 90),
                            t = 1.5 - (Math.sin((2 * e * Math.PI) / 360) / 2 + Math.cos((2 * e * Math.PI) / 360) / 2),
                            n = l.shadowScale,
                            r = l.shadowScale / t,
                            i = l.shadowOffset;
                        d.transform(`scale3d(${n}, 1, ${r}) translate3d(0px, ${o / 2 + i}px, ${-o / 2 / r}px) rotateX(-90deg)`);
                    }
                const h = le.isSafari || le.isWebView ? -s / 2 : 0;
                n.transform(`translate3d(0px,0,${h}px) rotateX(${e.isHorizontal() ? 0 : p}deg) rotateY(${e.isHorizontal() ? -p : 0}deg)`);
            },
            setTransition(e) {
                const t = this,
                    { $el: n, slides: r } = t;
                r.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e),
                    t.params.cubeEffect.shadow && !t.isHorizontal() && n.find(".swiper-cube-shadow").transition(e);
            },
        };
        const De = {
            setTranslate() {
                const e = this,
                    { slides: t, rtlTranslate: n } = e;
                for (let r = 0; r < t.length; r += 1) {
                    const i = t.eq(r);
                    let o = i[0].progress;
                    e.params.flipEffect.limitRotation && (o = Math.max(Math.min(i[0].progress, 1), -1));
                    let a = -180 * o,
                        s = 0,
                        l = -i[0].swiperSlideOffset,
                        c = 0;
                    if ((e.isHorizontal() ? n && (a = -a) : ((c = l), (l = 0), (s = -a), (a = 0)), (i[0].style.zIndex = -Math.abs(Math.round(o)) + t.length), e.params.flipEffect.slideShadows)) {
                        let t = e.isHorizontal() ? i.find(".swiper-slide-shadow-left") : i.find(".swiper-slide-shadow-top"),
                            n = e.isHorizontal() ? i.find(".swiper-slide-shadow-right") : i.find(".swiper-slide-shadow-bottom");
                        0 === t.length && ((t = M(`<div class="swiper-slide-shadow-${e.isHorizontal() ? "left" : "top"}"></div>`)), i.append(t)),
                            0 === n.length && ((n = M(`<div class="swiper-slide-shadow-${e.isHorizontal() ? "right" : "bottom"}"></div>`)), i.append(n)),
                            t.length && (t[0].style.opacity = Math.max(-o, 0)),
                            n.length && (n[0].style.opacity = Math.max(o, 0));
                    }
                    i.transform(`translate3d(${l}px, ${c}px, 0px) rotateX(${s}deg) rotateY(${a}deg)`);
                }
            },
            setTransition(e) {
                const t = this,
                    { slides: n, activeIndex: r, $wrapperEl: i } = t;
                if ((n.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e), t.params.virtualTranslate && 0 !== e)) {
                    let e = !1;
                    n.eq(r).transitionEnd(function () {
                        if (e) return;
                        if (!t || t.destroyed) return;
                        (e = !0), (t.animating = !1);
                        const n = ["webkitTransitionEnd", "transitionend"];
                        for (let e = 0; e < n.length; e += 1) i.trigger(n[e]);
                    });
                }
            },
        };
        const Oe = {
            setTranslate() {
                const e = this,
                    { width: t, height: n, slides: r, $wrapperEl: i, slidesSizesGrid: o } = e,
                    a = e.params.coverflowEffect,
                    s = e.isHorizontal(),
                    l = e.translate,
                    c = s ? t / 2 - l : n / 2 - l,
                    u = s ? a.rotate : -a.rotate,
                    d = a.depth;
                for (let e = 0, t = r.length; e < t; e += 1) {
                    const t = r.eq(e),
                        n = o[e],
                        i = ((c - t[0].swiperSlideOffset - n / 2) / n) * a.modifier;
                    let l = s ? u * i : 0,
                        p = s ? 0 : u * i,
                        h = -d * Math.abs(i),
                        f = a.stretch;
                    "string" == typeof f && -1 !== f.indexOf("%") && (f = (parseFloat(a.stretch) / 100) * n);
                    let m = s ? 0 : f * i,
                        g = s ? f * i : 0,
                        v = 1 - (1 - a.scale) * Math.abs(i);
                    Math.abs(g) < 0.001 && (g = 0), Math.abs(m) < 0.001 && (m = 0), Math.abs(h) < 0.001 && (h = 0), Math.abs(l) < 0.001 && (l = 0), Math.abs(p) < 0.001 && (p = 0), Math.abs(v) < 0.001 && (v = 0);
                    const y = `translate3d(${g}px,${m}px,${h}px)  rotateX(${p}deg) rotateY(${l}deg) scale(${v})`;
                    if ((t.transform(y), (t[0].style.zIndex = 1 - Math.abs(Math.round(i))), a.slideShadows)) {
                        let e = s ? t.find(".swiper-slide-shadow-left") : t.find(".swiper-slide-shadow-top"),
                            n = s ? t.find(".swiper-slide-shadow-right") : t.find(".swiper-slide-shadow-bottom");
                        0 === e.length && ((e = M(`<div class="swiper-slide-shadow-${s ? "left" : "top"}"></div>`)), t.append(e)),
                            0 === n.length && ((n = M(`<div class="swiper-slide-shadow-${s ? "right" : "bottom"}"></div>`)), t.append(n)),
                            e.length && (e[0].style.opacity = i > 0 ? i : 0),
                            n.length && (n[0].style.opacity = -i > 0 ? -i : 0);
                    }
                }
                if (z.pointerEvents || z.prefixedPointerEvents) {
                    i[0].style.perspectiveOrigin = `${c}px 50%`;
                }
            },
            setTransition(e) {
                this.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e);
            },
        };
        const qe = {
            init() {
                const e = this,
                    { thumbs: t } = e.params,
                    n = e.constructor;
                t.swiper instanceof n
                    ? ((e.thumbs.swiper = t.swiper), N.extend(e.thumbs.swiper.originalParams, { watchSlidesProgress: !0, slideToClickedSlide: !1 }), N.extend(e.thumbs.swiper.params, { watchSlidesProgress: !0, slideToClickedSlide: !1 }))
                    : N.isObject(t.swiper) && ((e.thumbs.swiper = new n(N.extend({}, t.swiper, { watchSlidesVisibility: !0, watchSlidesProgress: !0, slideToClickedSlide: !1 }))), (e.thumbs.swiperCreated = !0)),
                    e.thumbs.swiper.$el.addClass(e.params.thumbs.thumbsContainerClass),
                    e.thumbs.swiper.on("tap", e.thumbs.onThumbClick);
            },
            onThumbClick() {
                const e = this,
                    t = e.thumbs.swiper;
                if (!t) return;
                const n = t.clickedIndex,
                    r = t.clickedSlide;
                if (r && M(r).hasClass(e.params.thumbs.slideThumbActiveClass)) return;
                if (null == n) return;
                let i;
                if (((i = t.params.loop ? parseInt(M(t.clickedSlide).attr("data-swiper-slide-index"), 10) : n), e.params.loop)) {
                    let t = e.activeIndex;
                    e.slides.eq(t).hasClass(e.params.slideDuplicateClass) && (e.loopFix(), (e._clientLeft = e.$wrapperEl[0].clientLeft), (t = e.activeIndex));
                    const n = e.slides.eq(t).prevAll(`[data-swiper-slide-index="${i}"]`).eq(0).index(),
                        r = e.slides.eq(t).nextAll(`[data-swiper-slide-index="${i}"]`).eq(0).index();
                    i = void 0 === n ? r : void 0 === r ? n : r - t < t - n ? r : n;
                }
                e.slideTo(i);
            },
            update(e) {
                const t = this,
                    n = t.thumbs.swiper;
                if (!n) return;
                const r = "auto" === n.params.slidesPerView ? n.slidesPerViewDynamic() : n.params.slidesPerView,
                    i = t.params.thumbs.autoScrollOffset,
                    o = i && !n.params.loop;
                if (t.realIndex !== n.realIndex || o) {
                    let a,
                        s,
                        l = n.activeIndex;
                    if (n.params.loop) {
                        n.slides.eq(l).hasClass(n.params.slideDuplicateClass) && (n.loopFix(), (n._clientLeft = n.$wrapperEl[0].clientLeft), (l = n.activeIndex));
                        const e = n.slides.eq(l).prevAll(`[data-swiper-slide-index="${t.realIndex}"]`).eq(0).index(),
                            r = n.slides.eq(l).nextAll(`[data-swiper-slide-index="${t.realIndex}"]`).eq(0).index();
                        (a = void 0 === e ? r : void 0 === r ? e : r - l == l - e ? l : r - l < l - e ? r : e), (s = t.activeIndex > t.previousIndex ? "next" : "prev");
                    } else (a = t.realIndex), (s = a > t.previousIndex ? "next" : "prev");
                    o && (a += "next" === s ? i : -1 * i),
                        n.visibleSlidesIndexes &&
                            n.visibleSlidesIndexes.indexOf(a) < 0 &&
                            (n.params.centeredSlides ? (a = a > l ? a - Math.floor(r / 2) + 1 : a + Math.floor(r / 2) - 1) : a > l && (a = a - r + 1), n.slideTo(a, e ? 0 : void 0));
                }
                let a = 1;
                const s = t.params.thumbs.slideThumbActiveClass;
                if (
                    (t.params.slidesPerView > 1 && !t.params.centeredSlides && (a = t.params.slidesPerView),
                    t.params.thumbs.multipleActiveThumbs || (a = 1),
                    (a = Math.floor(a)),
                    n.slides.removeClass(s),
                    n.params.loop || (n.params.virtual && n.params.virtual.enabled))
                )
                    for (let e = 0; e < a; e += 1) n.$wrapperEl.children(`[data-swiper-slide-index="${t.realIndex + e}"]`).addClass(s);
                else for (let e = 0; e < a; e += 1) n.slides.eq(t.realIndex + e).addClass(s);
            },
        };
        const Me = [
            ae,
            se,
            ce,
            ue,
            pe,
            fe,
            ge,
            {
                name: "mousewheel",
                params: { mousewheel: { enabled: !1, releaseOnEdges: !1, invert: !1, forceToAxis: !1, sensitivity: 1, eventsTarged: "container" } },
                create() {
                    const e = this;
                    N.extend(e, {
                        mousewheel: {
                            enabled: !1,
                            enable: ve.enable.bind(e),
                            disable: ve.disable.bind(e),
                            handle: ve.handle.bind(e),
                            handleMouseEnter: ve.handleMouseEnter.bind(e),
                            handleMouseLeave: ve.handleMouseLeave.bind(e),
                            animateSlider: ve.animateSlider.bind(e),
                            releaseScroll: ve.releaseScroll.bind(e),
                            lastScrollTime: N.now(),
                            lastEventBeforeSnap: void 0,
                            recentWheelEvents: [],
                        },
                    });
                },
                on: {
                    init() {
                        const e = this;
                        !e.params.mousewheel.enabled && e.params.cssMode && e.mousewheel.disable(), e.params.mousewheel.enabled && e.mousewheel.enable();
                    },
                    destroy() {
                        const e = this;
                        e.params.cssMode && e.mousewheel.enable(), e.mousewheel.enabled && e.mousewheel.disable();
                    },
                },
            },
            {
                name: "navigation",
                params: { navigation: { nextEl: null, prevEl: null, hideOnClick: !1, disabledClass: "swiper-button-disabled", hiddenClass: "swiper-button-hidden", lockClass: "swiper-button-lock" } },
                create() {
                    const e = this;
                    N.extend(e, { navigation: { init: ye.init.bind(e), update: ye.update.bind(e), destroy: ye.destroy.bind(e), onNextClick: ye.onNextClick.bind(e), onPrevClick: ye.onPrevClick.bind(e) } });
                },
                on: {
                    init() {
                        this.navigation.init(), this.navigation.update();
                    },
                    toEdge() {
                        this.navigation.update();
                    },
                    fromEdge() {
                        this.navigation.update();
                    },
                    destroy() {
                        this.navigation.destroy();
                    },
                    click(e) {
                        const t = this,
                            { $nextEl: n, $prevEl: r } = t.navigation;
                        if (t.params.navigation.hideOnClick && !M(e.target).is(r) && !M(e.target).is(n)) {
                            let e;
                            n ? (e = n.hasClass(t.params.navigation.hiddenClass)) : r && (e = r.hasClass(t.params.navigation.hiddenClass)),
                                !0 === e ? t.emit("navigationShow", t) : t.emit("navigationHide", t),
                                n && n.toggleClass(t.params.navigation.hiddenClass),
                                r && r.toggleClass(t.params.navigation.hiddenClass);
                        }
                    },
                },
            },
            {
                name: "pagination",
                params: {
                    pagination: {
                        el: null,
                        bulletElement: "span",
                        clickable: !1,
                        hideOnClick: !1,
                        renderBullet: null,
                        renderProgressbar: null,
                        renderFraction: null,
                        renderCustom: null,
                        progressbarOpposite: !1,
                        type: "bullets",
                        dynamicBullets: !1,
                        dynamicMainBullets: 1,
                        formatFractionCurrent: (e) => e,
                        formatFractionTotal: (e) => e,
                        bulletClass: "swiper-pagination-bullet",
                        bulletActiveClass: "swiper-pagination-bullet-active",
                        modifierClass: "swiper-pagination-",
                        currentClass: "swiper-pagination-current",
                        totalClass: "swiper-pagination-total",
                        hiddenClass: "swiper-pagination-hidden",
                        progressbarFillClass: "swiper-pagination-progressbar-fill",
                        progressbarOppositeClass: "swiper-pagination-progressbar-opposite",
                        clickableClass: "swiper-pagination-clickable",
                        lockClass: "swiper-pagination-lock",
                    },
                },
                create() {
                    const e = this;
                    N.extend(e, { pagination: { init: be.init.bind(e), render: be.render.bind(e), update: be.update.bind(e), destroy: be.destroy.bind(e), dynamicBulletIndex: 0 } });
                },
                on: {
                    init() {
                        const e = this;
                        e.pagination.init(), e.pagination.render(), e.pagination.update();
                    },
                    activeIndexChange() {
                        const e = this;
                        (e.params.loop || void 0 === e.snapIndex) && e.pagination.update();
                    },
                    snapIndexChange() {
                        const e = this;
                        e.params.loop || e.pagination.update();
                    },
                    slidesLengthChange() {
                        const e = this;
                        e.params.loop && (e.pagination.render(), e.pagination.update());
                    },
                    snapGridLengthChange() {
                        const e = this;
                        e.params.loop || (e.pagination.render(), e.pagination.update());
                    },
                    destroy() {
                        this.pagination.destroy();
                    },
                    click(e) {
                        const t = this;
                        if (t.params.pagination.el && t.params.pagination.hideOnClick && t.pagination.$el.length > 0 && !M(e.target).hasClass(t.params.pagination.bulletClass)) {
                            !0 === t.pagination.$el.hasClass(t.params.pagination.hiddenClass) ? t.emit("paginationShow", t) : t.emit("paginationHide", t), t.pagination.$el.toggleClass(t.params.pagination.hiddenClass);
                        }
                    },
                },
            },
            {
                name: "scrollbar",
                params: { scrollbar: { el: null, dragSize: "auto", hide: !1, draggable: !1, snapOnRelease: !0, lockClass: "swiper-scrollbar-lock", dragClass: "swiper-scrollbar-drag" } },
                create() {
                    const e = this;
                    N.extend(e, {
                        scrollbar: {
                            init: we.init.bind(e),
                            destroy: we.destroy.bind(e),
                            updateSize: we.updateSize.bind(e),
                            setTranslate: we.setTranslate.bind(e),
                            setTransition: we.setTransition.bind(e),
                            enableDraggable: we.enableDraggable.bind(e),
                            disableDraggable: we.disableDraggable.bind(e),
                            setDragPosition: we.setDragPosition.bind(e),
                            getPointerPosition: we.getPointerPosition.bind(e),
                            onDragStart: we.onDragStart.bind(e),
                            onDragMove: we.onDragMove.bind(e),
                            onDragEnd: we.onDragEnd.bind(e),
                            isTouched: !1,
                            timeout: null,
                            dragTimeout: null,
                        },
                    });
                },
                on: {
                    init() {
                        const e = this;
                        e.scrollbar.init(), e.scrollbar.updateSize(), e.scrollbar.setTranslate();
                    },
                    update() {
                        this.scrollbar.updateSize();
                    },
                    resize() {
                        this.scrollbar.updateSize();
                    },
                    observerUpdate() {
                        this.scrollbar.updateSize();
                    },
                    setTranslate() {
                        this.scrollbar.setTranslate();
                    },
                    setTransition(e) {
                        this.scrollbar.setTransition(e);
                    },
                    destroy() {
                        this.scrollbar.destroy();
                    },
                },
            },
            {
                name: "parallax",
                params: { parallax: { enabled: !1 } },
                create() {
                    const e = this;
                    N.extend(e, { parallax: { setTransform: xe.setTransform.bind(e), setTranslate: xe.setTranslate.bind(e), setTransition: xe.setTransition.bind(e) } });
                },
                on: {
                    beforeInit() {
                        const e = this;
                        e.params.parallax.enabled && ((e.params.watchSlidesProgress = !0), (e.originalParams.watchSlidesProgress = !0));
                    },
                    init() {
                        this.params.parallax.enabled && this.parallax.setTranslate();
                    },
                    setTranslate() {
                        this.params.parallax.enabled && this.parallax.setTranslate();
                    },
                    setTransition(e) {
                        this.params.parallax.enabled && this.parallax.setTransition(e);
                    },
                },
            },
            {
                name: "zoom",
                params: { zoom: { enabled: !1, maxRatio: 3, minRatio: 1, toggle: !0, containerClass: "swiper-zoom-container", zoomedSlideClass: "swiper-slide-zoomed" } },
                create() {
                    const e = this,
                        t = {
                            enabled: !1,
                            scale: 1,
                            currentScale: 1,
                            isScaling: !1,
                            gesture: { $slideEl: void 0, slideWidth: void 0, slideHeight: void 0, $imageEl: void 0, $imageWrapEl: void 0, maxRatio: 3 },
                            image: {
                                isTouched: void 0,
                                isMoved: void 0,
                                currentX: void 0,
                                currentY: void 0,
                                minX: void 0,
                                minY: void 0,
                                maxX: void 0,
                                maxY: void 0,
                                width: void 0,
                                height: void 0,
                                startX: void 0,
                                startY: void 0,
                                touchesStart: {},
                                touchesCurrent: {},
                            },
                            velocity: { x: void 0, y: void 0, prevPositionX: void 0, prevPositionY: void 0, prevTime: void 0 },
                        };
                    "onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out".split(" ").forEach((n) => {
                        t[n] = Ee[n].bind(e);
                    }),
                        N.extend(e, { zoom: t });
                    let n = 1;
                    Object.defineProperty(e.zoom, "scale", {
                        get: () => n,
                        set(t) {
                            if (n !== t) {
                                const n = e.zoom.gesture.$imageEl ? e.zoom.gesture.$imageEl[0] : void 0,
                                    r = e.zoom.gesture.$slideEl ? e.zoom.gesture.$slideEl[0] : void 0;
                                e.emit("zoomChange", t, n, r);
                            }
                            n = t;
                        },
                    });
                },
                on: {
                    init() {
                        const e = this;
                        e.params.zoom.enabled && e.zoom.enable();
                    },
                    destroy() {
                        this.zoom.disable();
                    },
                    touchStart(e) {
                        this.zoom.enabled && this.zoom.onTouchStart(e);
                    },
                    touchEnd(e) {
                        this.zoom.enabled && this.zoom.onTouchEnd(e);
                    },
                    doubleTap(e) {
                        const t = this;
                        t.params.zoom.enabled && t.zoom.enabled && t.params.zoom.toggle && t.zoom.toggle(e);
                    },
                    transitionEnd() {
                        const e = this;
                        e.zoom.enabled && e.params.zoom.enabled && e.zoom.onTransitionEnd();
                    },
                    slideChange() {
                        const e = this;
                        e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && e.zoom.onTransitionEnd();
                    },
                },
            },
            {
                name: "lazy",
                params: {
                    lazy: {
                        enabled: !1,
                        loadPrevNext: !1,
                        loadPrevNextAmount: 1,
                        loadOnTransitionStart: !1,
                        elementClass: "swiper-lazy",
                        loadingClass: "swiper-lazy-loading",
                        loadedClass: "swiper-lazy-loaded",
                        preloaderClass: "swiper-lazy-preloader",
                    },
                },
                create() {
                    const e = this;
                    N.extend(e, { lazy: { initialImageLoaded: !1, load: Ce.load.bind(e), loadInSlide: Ce.loadInSlide.bind(e) } });
                },
                on: {
                    beforeInit() {
                        const e = this;
                        e.params.lazy.enabled && e.params.preloadImages && (e.params.preloadImages = !1);
                    },
                    init() {
                        const e = this;
                        e.params.lazy.enabled && !e.params.loop && 0 === e.params.initialSlide && e.lazy.load();
                    },
                    scroll() {
                        const e = this;
                        e.params.freeMode && !e.params.freeModeSticky && e.lazy.load();
                    },
                    resize() {
                        const e = this;
                        e.params.lazy.enabled && e.lazy.load();
                    },
                    scrollbarDragMove() {
                        const e = this;
                        e.params.lazy.enabled && e.lazy.load();
                    },
                    transitionStart() {
                        const e = this;
                        e.params.lazy.enabled && (e.params.lazy.loadOnTransitionStart || (!e.params.lazy.loadOnTransitionStart && !e.lazy.initialImageLoaded)) && e.lazy.load();
                    },
                    transitionEnd() {
                        const e = this;
                        e.params.lazy.enabled && !e.params.lazy.loadOnTransitionStart && e.lazy.load();
                    },
                    slideChange() {
                        const e = this;
                        e.params.lazy.enabled && e.params.cssMode && e.lazy.load();
                    },
                },
            },
            {
                name: "controller",
                params: { controller: { control: void 0, inverse: !1, by: "slide" } },
                create() {
                    const e = this;
                    N.extend(e, { controller: { control: e.params.controller.control, getInterpolateFunction: Se.getInterpolateFunction.bind(e), setTranslate: Se.setTranslate.bind(e), setTransition: Se.setTransition.bind(e) } });
                },
                on: {
                    update() {
                        const e = this;
                        e.controller.control && e.controller.spline && ((e.controller.spline = void 0), delete e.controller.spline);
                    },
                    resize() {
                        const e = this;
                        e.controller.control && e.controller.spline && ((e.controller.spline = void 0), delete e.controller.spline);
                    },
                    observerUpdate() {
                        const e = this;
                        e.controller.control && e.controller.spline && ((e.controller.spline = void 0), delete e.controller.spline);
                    },
                    setTranslate(e, t) {
                        this.controller.control && this.controller.setTranslate(e, t);
                    },
                    setTransition(e, t) {
                        this.controller.control && this.controller.setTransition(e, t);
                    },
                },
            },
            {
                name: "a11y",
                params: {
                    a11y: {
                        enabled: !0,
                        notificationClass: "swiper-notification",
                        prevSlideMessage: "Previous slide",
                        nextSlideMessage: "Next slide",
                        firstSlideMessage: "This is the first slide",
                        lastSlideMessage: "This is the last slide",
                        paginationBulletMessage: "Go to slide {{index}}",
                    },
                },
                create() {
                    const e = this;
                    N.extend(e, { a11y: { liveRegion: M(`<span class="${e.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`) } }),
                        Object.keys(Te).forEach((t) => {
                            e.a11y[t] = Te[t].bind(e);
                        });
                },
                on: {
                    init() {
                        const e = this;
                        e.params.a11y.enabled && (e.a11y.init(), e.a11y.updateNavigation());
                    },
                    toEdge() {
                        this.params.a11y.enabled && this.a11y.updateNavigation();
                    },
                    fromEdge() {
                        this.params.a11y.enabled && this.a11y.updateNavigation();
                    },
                    paginationUpdate() {
                        this.params.a11y.enabled && this.a11y.updatePagination();
                    },
                    destroy() {
                        this.params.a11y.enabled && this.a11y.destroy();
                    },
                },
            },
            {
                name: "history",
                params: { history: { enabled: !1, replaceState: !1, key: "slides" } },
                create() {
                    const e = this;
                    N.extend(e, { history: { init: ke.init.bind(e), setHistory: ke.setHistory.bind(e), setHistoryPopState: ke.setHistoryPopState.bind(e), scrollToSlide: ke.scrollToSlide.bind(e), destroy: ke.destroy.bind(e) } });
                },
                on: {
                    init() {
                        const e = this;
                        e.params.history.enabled && e.history.init();
                    },
                    destroy() {
                        const e = this;
                        e.params.history.enabled && e.history.destroy();
                    },
                    transitionEnd() {
                        const e = this;
                        e.history.initialized && e.history.setHistory(e.params.history.key, e.activeIndex);
                    },
                    slideChange() {
                        const e = this;
                        e.history.initialized && e.params.cssMode && e.history.setHistory(e.params.history.key, e.activeIndex);
                    },
                },
            },
            {
                name: "hash-navigation",
                params: { hashNavigation: { enabled: !1, replaceState: !1, watchState: !1 } },
                create() {
                    const e = this;
                    N.extend(e, { hashNavigation: { initialized: !1, init: Ae.init.bind(e), destroy: Ae.destroy.bind(e), setHash: Ae.setHash.bind(e), onHashCange: Ae.onHashCange.bind(e) } });
                },
                on: {
                    init() {
                        const e = this;
                        e.params.hashNavigation.enabled && e.hashNavigation.init();
                    },
                    destroy() {
                        const e = this;
                        e.params.hashNavigation.enabled && e.hashNavigation.destroy();
                    },
                    transitionEnd() {
                        const e = this;
                        e.hashNavigation.initialized && e.hashNavigation.setHash();
                    },
                    slideChange() {
                        const e = this;
                        e.hashNavigation.initialized && e.params.cssMode && e.hashNavigation.setHash();
                    },
                },
            },
            {
                name: "autoplay",
                params: { autoplay: { enabled: !1, delay: 3e3, waitForTransition: !0, disableOnInteraction: !0, stopOnLastSlide: !1, reverseDirection: !1 } },
                create() {
                    const e = this;
                    N.extend(e, {
                        autoplay: {
                            running: !1,
                            paused: !1,
                            run: _e.run.bind(e),
                            start: _e.start.bind(e),
                            stop: _e.stop.bind(e),
                            pause: _e.pause.bind(e),
                            onVisibilityChange() {
                                "hidden" === document.visibilityState && e.autoplay.running && e.autoplay.pause(), "visible" === document.visibilityState && e.autoplay.paused && (e.autoplay.run(), (e.autoplay.paused = !1));
                            },
                            onTransitionEnd(t) {
                                e &&
                                    !e.destroyed &&
                                    e.$wrapperEl &&
                                    t.target === this &&
                                    (e.$wrapperEl[0].removeEventListener("transitionend", e.autoplay.onTransitionEnd),
                                    e.$wrapperEl[0].removeEventListener("webkitTransitionEnd", e.autoplay.onTransitionEnd),
                                    (e.autoplay.paused = !1),
                                    e.autoplay.running ? e.autoplay.run() : e.autoplay.stop());
                            },
                        },
                    });
                },
                on: {
                    init() {
                        const e = this;
                        e.params.autoplay.enabled && (e.autoplay.start(), document.addEventListener("visibilitychange", e.autoplay.onVisibilityChange));
                    },
                    beforeTransitionStart(e, t) {
                        const n = this;
                        n.autoplay.running && (t || !n.params.autoplay.disableOnInteraction ? n.autoplay.pause(e) : n.autoplay.stop());
                    },
                    sliderFirstMove() {
                        const e = this;
                        e.autoplay.running && (e.params.autoplay.disableOnInteraction ? e.autoplay.stop() : e.autoplay.pause());
                    },
                    touchEnd() {
                        const e = this;
                        e.params.cssMode && e.autoplay.paused && !e.params.autoplay.disableOnInteraction && e.autoplay.run();
                    },
                    destroy() {
                        const e = this;
                        e.autoplay.running && e.autoplay.stop(), document.removeEventListener("visibilitychange", e.autoplay.onVisibilityChange);
                    },
                },
            },
            {
                name: "effect-fade",
                params: { fadeEffect: { crossFade: !1 } },
                create() {
                    const e = this;
                    N.extend(e, { fadeEffect: { setTranslate: Le.setTranslate.bind(e), setTransition: Le.setTransition.bind(e) } });
                },
                on: {
                    beforeInit() {
                        const e = this;
                        if ("fade" !== e.params.effect) return;
                        e.classNames.push(`${e.params.containerModifierClass}fade`);
                        const t = { slidesPerView: 1, slidesPerColumn: 1, slidesPerGroup: 1, watchSlidesProgress: !0, spaceBetween: 0, virtualTranslate: !0 };
                        N.extend(e.params, t), N.extend(e.originalParams, t);
                    },
                    setTranslate() {
                        "fade" === this.params.effect && this.fadeEffect.setTranslate();
                    },
                    setTransition(e) {
                        "fade" === this.params.effect && this.fadeEffect.setTransition(e);
                    },
                },
            },
            {
                name: "effect-cube",
                params: { cubeEffect: { slideShadows: !0, shadow: !0, shadowOffset: 20, shadowScale: 0.94 } },
                create() {
                    const e = this;
                    N.extend(e, { cubeEffect: { setTranslate: $e.setTranslate.bind(e), setTransition: $e.setTransition.bind(e) } });
                },
                on: {
                    beforeInit() {
                        const e = this;
                        if ("cube" !== e.params.effect) return;
                        e.classNames.push(`${e.params.containerModifierClass}cube`), e.classNames.push(`${e.params.containerModifierClass}3d`);
                        const t = { slidesPerView: 1, slidesPerColumn: 1, slidesPerGroup: 1, watchSlidesProgress: !0, resistanceRatio: 0, spaceBetween: 0, centeredSlides: !1, virtualTranslate: !0 };
                        N.extend(e.params, t), N.extend(e.originalParams, t);
                    },
                    setTranslate() {
                        "cube" === this.params.effect && this.cubeEffect.setTranslate();
                    },
                    setTransition(e) {
                        "cube" === this.params.effect && this.cubeEffect.setTransition(e);
                    },
                },
            },
            {
                name: "effect-flip",
                params: { flipEffect: { slideShadows: !0, limitRotation: !0 } },
                create() {
                    const e = this;
                    N.extend(e, { flipEffect: { setTranslate: De.setTranslate.bind(e), setTransition: De.setTransition.bind(e) } });
                },
                on: {
                    beforeInit() {
                        const e = this;
                        if ("flip" !== e.params.effect) return;
                        e.classNames.push(`${e.params.containerModifierClass}flip`), e.classNames.push(`${e.params.containerModifierClass}3d`);
                        const t = { slidesPerView: 1, slidesPerColumn: 1, slidesPerGroup: 1, watchSlidesProgress: !0, spaceBetween: 0, virtualTranslate: !0 };
                        N.extend(e.params, t), N.extend(e.originalParams, t);
                    },
                    setTranslate() {
                        "flip" === this.params.effect && this.flipEffect.setTranslate();
                    },
                    setTransition(e) {
                        "flip" === this.params.effect && this.flipEffect.setTransition(e);
                    },
                },
            },
            {
                name: "effect-coverflow",
                params: { coverflowEffect: { rotate: 50, stretch: 0, depth: 100, scale: 1, modifier: 1, slideShadows: !0 } },
                create() {
                    const e = this;
                    N.extend(e, { coverflowEffect: { setTranslate: Oe.setTranslate.bind(e), setTransition: Oe.setTransition.bind(e) } });
                },
                on: {
                    beforeInit() {
                        const e = this;
                        "coverflow" === e.params.effect &&
                            (e.classNames.push(`${e.params.containerModifierClass}coverflow`), e.classNames.push(`${e.params.containerModifierClass}3d`), (e.params.watchSlidesProgress = !0), (e.originalParams.watchSlidesProgress = !0));
                    },
                    setTranslate() {
                        "coverflow" === this.params.effect && this.coverflowEffect.setTranslate();
                    },
                    setTransition(e) {
                        "coverflow" === this.params.effect && this.coverflowEffect.setTransition(e);
                    },
                },
            },
            {
                name: "thumbs",
                params: { thumbs: { swiper: null, multipleActiveThumbs: !0, autoScrollOffset: 0, slideThumbActiveClass: "swiper-slide-thumb-active", thumbsContainerClass: "swiper-container-thumbs" } },
                create() {
                    const e = this;
                    N.extend(e, { thumbs: { swiper: null, init: qe.init.bind(e), update: qe.update.bind(e), onThumbClick: qe.onThumbClick.bind(e) } });
                },
                on: {
                    beforeInit() {
                        const e = this,
                            { thumbs: t } = e.params;
                        t && t.swiper && (e.thumbs.init(), e.thumbs.update(!0));
                    },
                    slideChange() {
                        this.thumbs.swiper && this.thumbs.update();
                    },
                    update() {
                        this.thumbs.swiper && this.thumbs.update();
                    },
                    resize() {
                        this.thumbs.swiper && this.thumbs.update();
                    },
                    observerUpdate() {
                        this.thumbs.swiper && this.thumbs.update();
                    },
                    setTransition(e) {
                        const t = this.thumbs.swiper;
                        t && t.setTransition(e);
                    },
                    beforeDestroy() {
                        const e = this.thumbs.swiper;
                        e && this.thumbs.swiperCreated && e && e.destroy();
                    },
                },
            },
        ];
        void 0 === oe.use && ((oe.use = oe.Class.use), (oe.installModule = oe.Class.installModule)), oe.use(Me);
        var Pe = oe;
        class Ie extends f {
            constructor(e, t, n) {
                super(e, t, n), (this.kenBurns = new k(e, t));
                const r = this.element.querySelector(".swiper-container");
                this.swiper = new Pe(r, { slidesPerView: 1, watchOverflow: !0, autoHeight: !0, pagination: { el: r.querySelectorAll(".swiper-pagination"), clickable: !0 } });
            }
        }
        var Ne = n(10),
            ze = n.n(Ne);
        class Re extends h {
            constructor(e, t) {
                super(e, t),
                    (this.init = () => {
                        this.rellaxes = Array.prototype.map.call(this.element.querySelectorAll(".rellax"), (e) => new ze.a(e, { center: !0 }));
                    }),
                    (this.destroy = () => {
                        this.rellaxes.forEach((e) => e.destroy()), (this.rellaxes = []);
                    }),
                    (this.isMobile = (e = null) => (e || this.theme.getBreakpoint()).order < l.md.order),
                    (this.onWindowResizeBreakpoint = ({ breakpoint: e }) => {
                        const t = this.isMobile(e);
                        t || 0 !== this.rellaxes.length ? t && this.rellaxes.length > 0 && this.destroy() : this.init();
                    }),
                    (this.rellaxes = []),
                    this.isMobile() || this.init();
            }
        }
        class Fe extends f {
            constructor(e, t, n) {
                super(e, t, n), (this.parallax = new Re(e, t.parentNode)), this.theme.addBadges(this.element, 1e3);
            }
        }
        class Be extends h {
            constructor(e, t) {
                super(e, t),
                    (this.theme = e),
                    (this.element = t),
                    (this.onSubmit = this.onSubmit.bind(this)),
                    (this.currentButton = null),
                    (this.cartAction = document.getElementById("PageContainer").dataset.cartAction),
                    (this.formWrapper = this.element.querySelectorAll(".quick-add-wrapper.is-singular")),
                    this.formWrapper &&
                        Array.prototype.forEach.call(this.element.querySelectorAll(".quick-add-wrapper.is-singular .shopify-product-form"), (e) => {
                            e.addEventListener("submit", this.onSubmit);
                        });
            }
            async onSubmit(e) {
                if ("page" != this.cartAction) {
                    e.preventDefault(),
                        (this.currentButton = e.currentTarget.querySelector(".quick-add-button")),
                        (this.currentButton.innerHTML = `<i class="fa fa-circle-o-notch fa-spin fa-fw js"></i><span class="sr-only">${this.theme.translations.loading}</span>`);
                    try {
                        const t = i()(e.currentTarget).serialize();
                        if (!(await window.fetch("/cart/add.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/x-www-form-urlencoded" }, body: t })).ok) return !1;
                        const n = await window.fetch("/cart?view=compare");
                        if (!n.ok) return !1;
                        const r = await n.json();
                        "drawer" == this.cartAction ? this.theme.toggleRightDrawer("cart", !0, { cart: r }) : ((this.currentButton.innerHTML = this.theme.translations.productAdded), this.theme.updateCartDrawer(r)),
                            setTimeout(() => {
                                this.currentButton.innerHTML = this.theme.translations.addToCart;
                            }, 2e3);
                    } catch (e) {
                        console.error("Unable to add to cart: ", e);
                    }
                    return !1;
                }
            }
        }
        class je extends f {
            constructor(e, t, n) {
                super(e, t, n),
                    (this.handleShopNow = (e) => {
                        e.preventDefault(), this.theme.toggleRightDrawer("shop-now", !0, { url: e.target.href });
                    }),
                    Array.prototype.forEach.call(t.querySelectorAll(".shop-now-button, .quick-add-button-variants"), (e) => {
                        e && e.addEventListener("click", this.handleShopNow);
                    }),
                    (this.quickAddButtons = new Be(e, t)),
                    this.theme.loadReviews({ badges: !0 }),
                    this.theme.addBadges(this.element, 1e3);
            }
        }
        var He = n(11),
            Ve = n.n(He);
        class We extends f {
            constructor(e, t, n) {
                super(e, t, n),
                    (this.applyFadeEffect = (e, t) => {
                        this.$element.find(e).each((e, n) => {
                            this.applyFadeEffectToElement(n, t);
                        });
                    }),
                    (this.applyFadeEffectToElement = (e, t) => {
                        const n = this.$element.find(e).find(t);
                        n.on("mouseenter mouseleave", function (e) {
                            n.not(this)
                                .stop(!0)
                                .fadeTo("fast", "mouseenter" === e.type ? 0.2 : 1);
                        });
                    }),
                    (this.$element = i()(t)),
                    (this.grid = t.querySelector(".homepage-featured-products-grid")),
                    (this.masonry = new Ve.a(this.grid, { itemSelector: ".homepage-featured-grid-item", columnWidth: ".homepage-featured-grid-item", percentPosition: !0, gutter: ".gutter-sizer" })),
                    T()(this.grid).on("progress", () => {
                        this.masonry.layout();
                    }),
                    this.applyFadeEffect(".homepage-featured-products-grid", ".homepage-featured-grid-item"),
                    (window.onpageshow = (e) => {
                        e.persisted && window.location.reload();
                    });
            }
        }
        class Ue extends f {}
        class Ge extends f {
            constructor(e, t, n) {
                super(e, t, n), (this.kenBurns = new k(e, t));
            }
        }
        class Ye extends f {
            constructor(e, t, n) {
                super(e, t, n),
                    (this.onSectionSelect = () => {
                        this.kenBurns.reapply();
                    }),
                    (this.kenBurns = new k(e, t));
            }
        }
        function Xe(e) {
            const t = e.querySelector("[data-section-main-link]");
            if (!t) return;
            "true" == t.ariaHidden &&
                t &&
                e.addEventListener("click", () => {
                    window.getSelection().toString() || t.click();
                });
        }
        class Ke extends Ye {
            constructor(e, t, n) {
                super(e, t, n),
                    (this.onWindowResize = () => {
                        this.sectionHeightSetToOriginal && this.setToOriginalHeight();
                    }),
                    (this.setToOriginalHeight = () => {
                        this.setImageWrapperHeight("auto"), this.contentIsTallerThanImage() ? (this.toggleCoverClass("true"), this.setImageWrapperHeight("100%")) : (this.toggleCoverClass(), this.setSectionMinHeight());
                    }),
                    (this.toggleCoverClass = (e) => {
                        this.imageElement.classList.remove("image-cover"), e && this.imageElement.classList.add("image-cover");
                    }),
                    (this.setImageWrapperHeight = (e) => {
                        this.imageWrapper.style.height = e;
                    }),
                    (this.setSectionMinHeight = () => {
                        this.sectionWrapper.style.minHeight = `${this.getImageHeight()}px`;
                    }),
                    (this.getContentHeight = () => this.contentWrapper.offsetHeight),
                    (this.getImageHeight = () => this.imageWrapper.offsetHeight),
                    (this.contentIsTallerThanImage = () => this.getContentHeight() > this.getImageHeight()),
                    (this.element = t),
                    (this.sectionWrapper = this.element.querySelector(".homepage-featured-content-wrapper")),
                    (this.imageWrapper = this.element.querySelector(".homepage-content--image")),
                    (this.contentWrapper = this.element.querySelector(".homepage-featured-content-box-inner")),
                    (this.imageElement = this.imageWrapper.getElementsByTagName("img").item(0)),
                    (this.sectionHeightSetToOriginal = this.element.classList.contains("size-original")),
                    this.sectionHeightSetToOriginal && this.setToOriginalHeight(),
                    (this.parallax = new Re(e, t)),
                    Xe(this.element);
            }
        }
        class Je extends f {}
        class Ze {
            constructor(e, t, n) {
                (this.stop = () => {
                    this.element.querySelectorAll(".swiper-slide").length <= 1 || this.swiper.autoplay.stop();
                }),
                    (this.start = () => {
                        this.element.querySelectorAll(".swiper-slide").length <= 1 || this.swiper.autoplay.start();
                    }),
                    (this.isRunning = () => this.swiper.autoplay.running),
                    (this.slideTo = (e, t = !1) => {
                        this.swiper.slideTo(e, t ? 0 : 200);
                    }),
                    (this.onSlideChange = () => {
                        this.slideChangeCallback && this.slideChangeCallback();
                    }),
                    (this.configure = () => {
                        if (this.element.querySelectorAll(".swiper-slide").length <= 1) return;
                        const e = new Pe(this.element, {
                            allowTouchMove: !1,
                            loop: !0,
                            loopedSlides: "fade" === this.effect ? 0 : 2,
                            autoplay: this.speed > 0 && { delay: this.speed, disableOnInteraction: !1 },
                            effect: this.effect,
                            slidesPerView: 1,
                            speed: 300,
                            watchOverflow: !0,
                            fadeEffect: { crossFade: !0 },
                            navigation: { nextEl: this.element.querySelector(".flex-next"), prevEl: this.element.querySelector(".flex-prev") },
                            pagination: { el: this.element.querySelector(".swiper-pagination"), clickable: !0 },
                        });
                        return e.on("slideChange", this.onSlideChange), e;
                    }),
                    (this.theme = e),
                    (this.element = t),
                    (this.restartTimer = null),
                    (this.running = !0),
                    (this.speed = void 0 !== n.speed ? n.speed : 200),
                    (this.effect = n.animation || "slide"),
                    (this.slideChangeCallback = n.onSlideChange),
                    (this.swiper = this.configure());
            }
        }
        class Qe extends f {
            constructor(e, t, n) {
                super(e, t, n),
                    (this.SLIDER_SELECTOR = ".swiper-container"),
                    (this.SLIDER_REENABLE_INTERVAL = 6e3),
                    (this.isInViewport = () => {
                        const e = this.slider.element.getBoundingClientRect(),
                            t = document.querySelector(".sticky-header.sticked"),
                            n = document.querySelector(".site-header"),
                            r = t ? n.offsetHeight : 0,
                            i = e.top >= r && e.top < (window.innerHeight || document.documentElement.clientHeight),
                            o = e.bottom >= r && e.bottom < (window.innerHeight || document.documentElement.clientHeight),
                            a = e.top <= r && e.bottom >= r;
                        return i || o || a;
                    }),
                    (this.onWindowScroll = () => {
                        this.isInViewport() ? this.slider.start() : this.slider.stop();
                    }),
                    (this.onSlideChange = () => {
                        this.slider.isRunning &&
                            this.speed > 0 &&
                            (clearTimeout(this.restartTimer),
                            (this.restartTimer = setTimeout(() => {
                                this.slider.start();
                            }, Math.max(0, this.SLIDER_REENABLE_INTERVAL - this.speed))));
                    }),
                    (this.onBlockSelect = ({ element: e }) => {
                        const t = parseInt(e.dataset.slideIndex, 0);
                        this.slider.slideTo(t), this.slider.stop();
                    }),
                    (this.onBlockDeselect = () => {
                        this.slider.start();
                    }),
                    (this.restartTimer = null);
                const r = t.querySelector(this.SLIDER_SELECTOR);
                (this.speed = parseInt(r.dataset.sliderSlideTime, 10)), (this.slider = new Ze(e, r, { speed: this.speed, animation: r.dataset.sliderAnimation, onSlideChange: this.onSlideChange }));
                this.slider.element.querySelectorAll(".slideshow__link").forEach((e) => Xe(e));
            }
        }
        class et extends f {}
        class tt extends f {
            constructor(e, t, n) {
                super(e, t, n),
                    (this.load = () => {
                        var e = this;
                        i()(".password-show").click(function () {
                            e.$head.slideToggle("slow").addClass("open"), i()(".password--container").addClass("password-modal--open"), e.$password.focus();
                        }),
                            i()(".password--close").click(function () {
                                e.$head.slideToggle("slow").removeClass("open"), i()(".password--container").removeClass("password-modal--open"), e.$password.blur();
                            }),
                            i()(function () {
                                i()(".storefront-password-form .errors").length && (e.$head.slideDown("slow").addClass("open"), e.$password.focus());
                            }),
                            i()(".password--wrapper").click((t) => {
                                e.$head.hasClass("open") && (e.$head.is(t.target) || 0 !== e.$head.has(t.target).length || i()(".password-show").is(t.target) || e.$head.slideUp("slow"));
                            }),
                            i()(document).on("keydown", function (t) {
                                9 == (t = t || window.event).keyCode
                                    ? t.shiftKey
                                        ? document.activeElement === e.firstFocusableEl && (t.preventDefault(), e.lastFocusableEl.focus())
                                        : document.activeElement === e.lastFocusableEl && (t.preventDefault(), e.firstFocusableEl.focus())
                                    : 27 == t.keyCode && e.$head.hasClass("open") && (e.$head.slideToggle("slow").removeClass("open"), e.$password.blur());
                            });
                    }),
                    (this.$head = i()(".site-header")),
                    (this.$focusableEls = this.$head.find('a[href], input:not([disabled]):not([type="hidden"]), button:not([disabled]), [tabindex="0"]')),
                    (this.$password = this.$head.find("input#password")),
                    (this.firstFocusableEl = this.$focusableEls[0]),
                    (this.lastFocusableEl = this.$focusableEls[this.$focusableEls.length - 1]),
                    this.load();
            }
        }
        n(20);
        /**
         * vue-class-component v7.2.6
         * (c) 2015-present Evan You
         * @license MIT
         */ function nt(e) {
            return (
                (nt =
                    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                        ? function (e) {
                              return typeof e;
                          }
                        : function (e) {
                              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                          }),
                nt(e)
            );
        }
        function rt(e) {
            return (
                (function (e) {
                    if (Array.isArray(e)) {
                        for (var t = 0, n = new Array(e.length); t < e.length; t++) n[t] = e[t];
                        return n;
                    }
                })(e) ||
                (function (e) {
                    if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
                })(e) ||
                (function () {
                    throw new TypeError("Invalid attempt to spread non-iterable instance");
                })()
            );
        }
        function it(e, t, n) {
            (n ? Reflect.getOwnMetadataKeys(t, n) : Reflect.getOwnMetadataKeys(t)).forEach(function (r) {
                var i = n ? Reflect.getOwnMetadata(r, t, n) : Reflect.getOwnMetadata(r, t);
                n ? Reflect.defineMetadata(r, i, e, n) : Reflect.defineMetadata(r, i, e);
            });
        }
        var ot = { __proto__: [] } instanceof Array;
        function at(e) {
            return function (t, n, r) {
                var i = "function" == typeof t ? t : t.constructor;
                i.__decorators__ || (i.__decorators__ = []),
                    "number" != typeof r && (r = void 0),
                    i.__decorators__.push(function (t) {
                        return e(t, n, r);
                    });
            };
        }
        var st = ["data", "beforeCreate", "created", "beforeMount", "mounted", "beforeDestroy", "destroyed", "beforeUpdate", "updated", "activated", "deactivated", "render", "errorCaptured", "serverPrefetch"];
        function lt(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            t.name = t.name || e._componentTag || e.name;
            var n = e.prototype;
            Object.getOwnPropertyNames(n).forEach(function (e) {
                if ("constructor" !== e)
                    if (st.indexOf(e) > -1) t[e] = n[e];
                    else {
                        var r = Object.getOwnPropertyDescriptor(n, e);
                        void 0 !== r.value
                            ? "function" == typeof r.value
                                ? ((t.methods || (t.methods = {}))[e] = r.value)
                                : (t.mixins || (t.mixins = [])).push({
                                      data: function () {
                                          return (function (e, t, n) {
                                              return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n), e;
                                          })({}, e, r.value);
                                      },
                                  })
                            : (r.get || r.set) && ((t.computed || (t.computed = {}))[e] = { get: r.get, set: r.set });
                    }
            }),
                (t.mixins || (t.mixins = [])).push({
                    data: function () {
                        return (function (e, t) {
                            var n = t.prototype._init;
                            t.prototype._init = function () {
                                var t = this,
                                    n = Object.getOwnPropertyNames(e);
                                if (e.$options.props) for (var r in e.$options.props) e.hasOwnProperty(r) || n.push(r);
                                n.forEach(function (n) {
                                    Object.defineProperty(t, n, {
                                        get: function () {
                                            return e[n];
                                        },
                                        set: function (t) {
                                            e[n] = t;
                                        },
                                        configurable: !0,
                                    });
                                });
                            };
                            var r = new t();
                            t.prototype._init = n;
                            var i = {};
                            return (
                                Object.keys(r).forEach(function (e) {
                                    void 0 !== r[e] && (i[e] = r[e]);
                                }),
                                i
                            );
                        })(this, e);
                    },
                });
            var r = e.__decorators__;
            r &&
                (r.forEach(function (e) {
                    return e(t);
                }),
                delete e.__decorators__);
            var i,
                o,
                a = Object.getPrototypeOf(e.prototype),
                l = a instanceof s.a ? a.constructor : s.a,
                c = l.extend(t);
            return (
                (function (e, t, n) {
                    Object.getOwnPropertyNames(t).forEach(function (r) {
                        if (!ct[r]) {
                            var i = Object.getOwnPropertyDescriptor(e, r);
                            if (!i || i.configurable) {
                                var o,
                                    a,
                                    s = Object.getOwnPropertyDescriptor(t, r);
                                if (!ot) {
                                    if ("cid" === r) return;
                                    var l = Object.getOwnPropertyDescriptor(n, r);
                                    if (((o = s.value), (a = nt(o)), null != o && ("object" === a || "function" === a) && l && l.value === s.value)) return;
                                }
                                0, Object.defineProperty(e, r, s);
                            }
                        }
                    });
                })(c, e, l),
                "undefined" != typeof Reflect &&
                    Reflect.defineMetadata &&
                    Reflect.getOwnMetadataKeys &&
                    (it((i = c), (o = e)),
                    Object.getOwnPropertyNames(o.prototype).forEach(function (e) {
                        it(i.prototype, o.prototype, e);
                    }),
                    Object.getOwnPropertyNames(o).forEach(function (e) {
                        it(i, o, e);
                    })),
                c
            );
        }
        var ct = { prototype: !0, arguments: !0, callee: !0, caller: !0 };
        function ut(e) {
            return "function" == typeof e
                ? lt(e)
                : function (t) {
                      return lt(t, e);
                  };
        }
        ut.registerHooks = function (e) {
            st.push.apply(st, rt(e));
        };
        var dt = ut;
        var pt = "undefined" != typeof Reflect && void 0 !== Reflect.getMetadata;
        function ht(e, t, n) {
            if (pt && !Array.isArray(e) && "function" != typeof e && void 0 === e.type) {
                var r = Reflect.getMetadata("design:type", t, n);
                r !== Object && (e.type = r);
            }
        }
        function ft(e) {
            return (
                void 0 === e && (e = {}),
                function (t, n) {
                    ht(e, t, n),
                        at(function (t, n) {
                            (t.props || (t.props = {}))[n] = e;
                        })(t, n);
                }
            );
        }
        function mt(e, t) {
            void 0 === t && (t = {});
            var n = t.deep,
                r = void 0 !== n && n,
                i = t.immediate,
                o = void 0 !== i && i;
            return at(function (t, n) {
                "object" != typeof t.watch && (t.watch = Object.create(null));
                var i = t.watch;
                "object" != typeof i[e] || Array.isArray(i[e]) ? void 0 === i[e] && (i[e] = []) : (i[e] = [i[e]]), i[e].push({ handler: n, deep: r, immediate: o });
            });
        }
        /*!
         * @preserve
         *
         * Readmore.js plugin
         * Author: @jed_foster
         * Project home: jedfoster.com/Readmore.js
         * Version: 3.0.0-beta-1
         * Licensed under the MIT license
         *
         * Debounce function from davidwalsh.name/javascript-debounce-function
         */
        let gt = 0;
        const vt = [];
        function yt(e, t, n) {
            for (let r = 0; r < e.length; r += 1) t.call(n, e[r], r);
        }
        function bt(...e) {
            const t = {}.hasOwnProperty;
            let n = e[0],
                r = e[1];
            if (e.length > 2) {
                const t = [];
                for (
                    Object.keys(e).forEach((n) => {
                        t.push(e[n]);
                    });
                    t.length > 2;

                ) {
                    const e = t.shift(),
                        n = t.shift();
                    t.unshift(bt(e, n));
                }
                (n = t.shift()), (r = t.shift());
            }
            return (
                r &&
                    Object.keys(r).forEach((e) => {
                        t.call(r, e) && ("object" == typeof r[e] ? ((n[e] = n[e] || {}), (n[e] = bt(n[e], r[e]))) : (n[e] = r[e]));
                    }),
                n
            );
        }
        function wt() {
            return (gt += 1), `rmjs-${gt}`;
        }
        function xt(e) {
            e.style.height = "auto";
            const t = parseInt(e.getBoundingClientRect().height, 10),
                n = parseInt(window.getComputedStyle(e).maxHeight, 10),
                r = parseInt(e.readmore.defaultHeight, 10);
            (e.readmore.expandedHeight = t), (e.readmore.maxHeight = n), (e.readmore.collapsedHeight = n || e.readmore.collapsedHeight || r), (e.style.maxHeight = "none");
        }
        function Et(e, t) {
            if (!vt[e]) {
                let n = "";
                t.embedCSS && "" !== t.blockCSS && (n += `${e} + [data-readmore-toggle], ${e}[data-readmore] {\n        ${t.blockCSS}\n      }`),
                    (n += `${e}[data-readmore] {\n      transition: height ${t.speed}ms;\n      overflow: hidden;\n    }`),
                    ((e, t) => {
                        const n = e.createElement("style");
                        (n.type = "text/css"), n.styleSheet ? (n.styleSheet.cssText = t) : n.appendChild(e.createTextNode(t)), e.getElementsByTagName("head")[0].appendChild(n);
                    })(document, n),
                    (vt[e] = !0);
            }
        }
        function Ct(e, t, n) {
            let r = e;
            "function" == typeof e && (r = e(t));
            const i = (function (e) {
                const t = document.createElement("div");
                return (t.innerHTML = e), t.firstChild;
            })(r);
            return (
                i.setAttribute("data-readmore-toggle", t.id),
                i.setAttribute("aria-controls", t.id),
                i.addEventListener(
                    "click",
                    function (e) {
                        this.toggle(t, e);
                    }.bind(n)
                ),
                i
            );
        }
        [Element.prototype, CharacterData.prototype, DocumentType.prototype].forEach((e) => {
            Object.prototype.hasOwnProperty.call(e, "remove") ||
                Object.defineProperty(e, "remove", {
                    configurable: !0,
                    enumerable: !0,
                    writable: !0,
                    value: function () {
                        null !== this.parentNode && this.parentNode.removeChild(this);
                    },
                });
        });
        const St = (function (e, t, n) {
                let r;
                return function (...i) {
                    const o = n && !r;
                    clearTimeout(r),
                        (r = setTimeout(() => {
                            (r = null), n || e.apply(this, i);
                        }, t)),
                        o && e.apply(this, i);
                };
            })(() => {
                yt(document.querySelectorAll("[data-readmore]"), (e) => {
                    const t = "true" === e.getAttribute("aria-expanded");
                    xt(e), (e.style.height = `${t ? e.readmore.expandedHeight : e.readmore.collapsedHeight}px`);
                });
            }, 100),
            Tt = {
                speed: 100,
                collapsedHeight: 200,
                heightMargin: 16,
                moreLink: '<a href="#">Read More</a>',
                lessLink: '<a href="#">Close</a>',
                embedCSS: !0,
                blockCSS: "display: block; width: 100%;",
                startOpen: !1,
                sourceOrder: "after",
                blockProcessed: () => {},
                beforeToggle: () => {},
                afterToggle: () => {},
            };
        class kt {
            constructor(...e) {
                if ("undefined" == typeof window || "undefined" == typeof document || !document.querySelectorAll || !window.addEventListener) return;
                const [t, n] = e;
                let r;
                (r = "string" == typeof t ? document.querySelectorAll(t) : t.nodeName ? [t] : t),
                    r.length &&
                        ((this.options = bt({}, Tt, n)),
                        "string" == typeof t ? Et(t, this.options) : ((this.instanceSelector = `.${wt()}`), Et(this.instanceSelector, this.options)),
                        window.addEventListener("load", St),
                        window.addEventListener("resize", St),
                        (this.elements = []),
                        yt(r, (e) => {
                            this.instanceSelector && e.classList.add(this.instanceSelector.substr(1));
                            const t = this.options.startOpen;
                            (e.readmore = { defaultHeight: this.options.collapsedHeight, heightMargin: this.options.heightMargin }), xt(e);
                            const { heightMargin: n } = e.readmore;
                            if (e.getBoundingClientRect().height <= e.readmore.collapsedHeight + n) return void ("function" == typeof this.options.blockProcessed && this.options.blockProcessed(e, !1));
                            e.setAttribute("data-readmore", ""), e.setAttribute("aria-expanded", t), (e.id = e.id || wt());
                            const r = Ct(t ? this.options.lessLink : this.options.moreLink, e, this);
                            e.parentNode.insertBefore(r, "before" === this.options.sourceOrder ? e : e.nextSibling),
                                (e.style.height = `${t ? e.readmore.expandedHeight : e.readmore.collapsedHeight}px`),
                                "function" == typeof this.options.blockProcessed && this.options.blockProcessed(e, !0),
                                this.elements.push(e);
                        }));
            }
            toggle(...e) {
                let t = e[0];
                const n = (e) => {
                    const t = document.querySelector(`[aria-controls="${e.id}"]`),
                        n = e.getBoundingClientRect().height <= e.readmore.collapsedHeight,
                        r = n ? e.readmore.expandedHeight : e.readmore.collapsedHeight;
                    if ("function" == typeof this.options.beforeToggle) {
                        if (!1 === this.options.beforeToggle(t, e, !n)) return;
                    }
                    e.style.height = `${r}px`;
                    const i = (r) => {
                        "function" == typeof this.options.afterToggle && this.options.afterToggle(t, e, n), r.stopPropagation(), e.setAttribute("aria-expanded", n), e.removeEventListener("transitionend", i, !1);
                    };
                    e.addEventListener("transitionend", i, !1), this.options.speed < 1 && i.call(this, { target: e });
                    const o = n ? this.options.lessLink : this.options.moreLink;
                    o ? t && t.parentNode && t.parentNode.replaceChild(Ct(o, e, this), t) : t.remove();
                };
                if (("string" == typeof t && (t = document.querySelectorAll(t)), !t)) throw new Error("Element MUST be either an HTML node or querySelector string");
                const r = e[1];
                r && (r.preventDefault(), r.stopPropagation()), "object" != typeof t || t.nodeName ? n(t) : yt(t, n);
            }
            destroy(e) {
                let t;
                (t = e ? ("string" == typeof e ? document.querySelectorAll(e) : e.nodeName ? [e] : e) : this.elements),
                    yt(t, (e) => {
                        if (-1 === this.elements.indexOf(e)) return;
                        (this.elements = this.elements.filter((t) => t !== e)),
                            this.instanceSelector && e.classList.remove(this.instanceSelector.substr(1)),
                            delete e.readmore,
                            (e.style.height = "initial"),
                            (e.style.maxHeight = "initial"),
                            e.removeAttribute("data-readmore"),
                            e.removeAttribute("aria-expanded");
                        const t = document.querySelector(`[aria-controls="${e.id}"]`);
                        t && t.remove(), -1 !== e.id.indexOf("rmjs-") && e.removeAttribute("id");
                    });
            }
        }
        kt.VERSION = "3.0.0-beta-1";
        var At = kt;
        var _t = !1;
        if ("undefined" != typeof window) {
            var Lt = {
                get passive() {
                    _t = !0;
                },
            };
            window.addEventListener("testPassive", null, Lt), window.removeEventListener("testPassive", null, Lt);
        }
        var $t = "undefined" != typeof window && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || ("MacIntel" === window.navigator.platform && window.navigator.maxTouchPoints > 1)),
            Dt = [],
            Ot = !1,
            qt = -1,
            Mt = void 0,
            Pt = void 0,
            It = function (e) {
                return Dt.some(function (t) {
                    return !(!t.options.allowTouchMove || !t.options.allowTouchMove(e));
                });
            },
            Nt = function (e) {
                var t = e || window.event;
                return !!It(t.target) || t.touches.length > 1 || (t.preventDefault && t.preventDefault(), !1);
            },
            zt = function () {
                void 0 !== Pt && ((document.body.style.paddingRight = Pt), (Pt = void 0)), void 0 !== Mt && ((document.body.style.overflow = Mt), (Mt = void 0));
            },
            Rt = function (e, t) {
                if (e) {
                    if (
                        !Dt.some(function (t) {
                            return t.targetElement === e;
                        })
                    ) {
                        var n = { targetElement: e, options: t || {} };
                        (Dt = [].concat(
                            (function (e) {
                                if (Array.isArray(e)) {
                                    for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
                                    return n;
                                }
                                return Array.from(e);
                            })(Dt),
                            [n]
                        )),
                            $t
                                ? ((e.ontouchstart = function (e) {
                                      1 === e.targetTouches.length && (qt = e.targetTouches[0].clientY);
                                  }),
                                  (e.ontouchmove = function (t) {
                                      1 === t.targetTouches.length &&
                                          (function (e, t) {
                                              var n = e.targetTouches[0].clientY - qt;
                                              !It(e.target) &&
                                                  ((t && 0 === t.scrollTop && n > 0) ||
                                                  ((function (e) {
                                                      return !!e && e.scrollHeight - e.scrollTop <= e.clientHeight;
                                                  })(t) &&
                                                      n < 0)
                                                      ? Nt(e)
                                                      : e.stopPropagation());
                                          })(t, e);
                                  }),
                                  Ot || (document.addEventListener("touchmove", Nt, _t ? { passive: !1 } : void 0), (Ot = !0)))
                                : (function (e) {
                                      if (void 0 === Pt) {
                                          var t = !!e && !0 === e.reserveScrollBarGap,
                                              n = window.innerWidth - document.documentElement.clientWidth;
                                          t && n > 0 && ((Pt = document.body.style.paddingRight), (document.body.style.paddingRight = n + "px"));
                                      }
                                      void 0 === Mt && ((Mt = document.body.style.overflow), (document.body.style.overflow = "hidden"));
                                  })(t);
                    }
                } else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
            },
            Ft = function (e) {
                e
                    ? ((Dt = Dt.filter(function (t) {
                          return t.targetElement !== e;
                      })),
                      $t ? ((e.ontouchstart = null), (e.ontouchmove = null), Ot && 0 === Dt.length && (document.removeEventListener("touchmove", Nt, _t ? { passive: !1 } : void 0), (Ot = !1))) : Dt.length || zt())
                    : console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
            };
        n(23);
        class Bt {
            constructor(e, t) {
                (this.DURATION = 120),
                    (this.imgLoaded = () => {
                        this.$loader.addClass("hidden");
                    }),
                    (this.onZoomIn = (e) => {
                        this.$element.width() >= i()(e).width()
                            ? this.$element.find(".zoomImg").addClass("hide")
                            : (this.$element.find(".zoomImg").removeClass("hide"),
                              (this.timer = setTimeout(() => {
                                  this.img.classList.add("product-image-hidden"), (this.timer = null);
                              }, this.DURATION)));
                    }),
                    (this.onZoomOut = () => {
                        this.timer && (clearTimeout(this.timer), (this.timer = null)), this.img.classList.remove("product-image-hidden");
                    }),
                    (this.destroy = () => {
                        this.$element.trigger("zoom.destroy");
                    }),
                    (this.theme = e),
                    (this.element = t),
                    (this.$element = i()(t)),
                    (this.img = t.querySelector("img")),
                    (this.timer = null),
                    (this.$loader = i()(this.img).next(".featured-image-loader"));
                const n = this;
                this.$loader.removeClass("hidden"),
                    this.$element.zoom({
                        url: this.img.dataset.imageZoom || this.img.src,
                        touch: !1,
                        duration: this.DURATION,
                        onZoomIn: function () {
                            n.onZoomIn(this);
                        },
                        onZoomOut: this.onZoomOut,
                        callback: this.imgLoaded(),
                    });
            }
        }
        class jt {
            constructor(e, t, n, r) {
                (this.load = () =>
                    new Promise((e) => {
                        if (this.loaded) return void e();
                        if ("image" === this.media.media_type) return this.loadImageZoom(), this.on_load(), void e();
                        var t = document.querySelector(`#media-template-${this.sectionId}-${this.media.id}`);
                        if (!t) return this.on_load(), void e();
                        const n = document.importNode(t.content, !0);
                        for (; this.target.firstChild; ) this.target.removeChild(this.target.lastChild);
                        switch ((this.target.appendChild(n), (this.renderedElement = this.target.lastElementChild), this.media.media_type)) {
                            case "model":
                                window.Shopify.loadFeatures([{ name: "model-viewer-ui", version: "1.0" }], () => {
                                    (this.modelController = new window.Shopify.ModelViewerUI(this.renderedElement.querySelector("model-viewer"))),
                                        this.modelController.viewer.parentElement.addEventListener(
                                            "mouseup",
                                            (e) => {
                                                e.stopPropagation = function () {};
                                            },
                                            { capture: !0 }
                                        ),
                                        this.modelController.elements.controlButton.addEventListener(
                                            "click",
                                            (e) => {
                                                e.stopImmediatePropagation();
                                            },
                                            { capture: !0 }
                                        ),
                                        this.modelController.viewer.addEventListener("shopify_model_viewer_ui_toggle_pause", this.on_pause.bind(this)),
                                        this.modelController.viewer.addEventListener("shopify_model_viewer_ui_toggle_play", this.on_play.bind(this)),
                                        this.on_load(),
                                        e();
                                });
                                break;
                            case "video":
                                window.Shopify.loadFeatures([
                                    {
                                        name: "video-ui",
                                        version: "1.0",
                                        onLoad: function () {
                                            var t = this.renderedElement.querySelector("video"),
                                                n = "true" === t.parentNode.dataset.videoLoop;
                                            (this.plyrController = new window.Shopify.Plyr(t, { loop: { active: n }, focusOnPlay: !1 })),
                                                t.addEventListener("play", this.on_play.bind(this)),
                                                t.addEventListener("pause", this.on_pause.bind(this)),
                                                t.addEventListener("ended", this.on_pause.bind(this)),
                                                this.on_load(),
                                                e();
                                        }.bind(this),
                                    },
                                ]);
                                break;
                            case "external_video":
                                this.theme.loadYoutubeApi().then(() => {
                                    const t = this.renderedElement.querySelector("iframe"),
                                        n = "true" === t.parentNode.dataset.videoLoop;
                                    new window.YT.Player(t, {
                                        events: {
                                            onReady: (t) => {
                                                (this.youtubeController = t.target), this.on_load(), e();
                                            },
                                            onStateChange: (e) => {
                                                e.data === window.YT.PlayerState.PLAYING
                                                    ? this.on_play()
                                                    : e.data === window.YT.PlayerState.PAUSED
                                                    ? this.on_pause()
                                                    : e.data === window.YT.PlayerState.ENDED && (n ? this.youtubeController.playVideo() : this.on_pause());
                                            },
                                            onError: (e) => {
                                                console.warn("Youtube video error", e, e.data), this.on_pause();
                                            },
                                        },
                                    });
                                });
                                break;
                            default:
                                this.on_load(), e();
                        }
                    })),
                    (this.loadImageZoom = () => {
                        this.target.querySelector("img").dataset.imageZoom && !this.isMobile() && new Bt(this.theme, this.target);
                    }),
                    (this.isMobile = () => window.matchMedia("only screen and (max-width: 768px)").matches),
                    (this.on_load = () => {
                        (this.loaded = !0), this.target.querySelector(".product-medias__media").classList.add("product-medias__media--loaded");
                        var e = new CustomEvent("media-load", { detail: { parent: this.target, media: this } });
                        this.target.dispatchEvent(e), window.ShopifyXR && window.ShopifyXR.setupXRElements && window.ShopifyXR.setupXRElements();
                    }),
                    (this.play = () => {
                        this.loaded ? this._play() : this.load().then(this._play.bind(this));
                    }),
                    (this._play = () => {
                        switch (this.media.media_type) {
                            case "model":
                                this.modelController.play(), this.on_play();
                                break;
                            case "video":
                                this.plyrController.play().then(this.on_play.bind(this)).catch(console.warn);
                                break;
                            case "external_video":
                                this.youtubeController.playVideo(), this.on_play();
                        }
                    }),
                    (this.on_play = () => {
                        (this.active = !0),
                            this.target.querySelector(".product-medias__media").classList.add("product-medias__media--active"),
                            this.loaded || ((this.loaded = !0), this.target.querySelector(".product-medias__media").classList.add("product-medias__media--loaded"));
                        var e = new CustomEvent("media-play", { detail: { parent: this.target, media: this } });
                        this.target.dispatchEvent(e), document.activeElement === document.body && this.focus();
                    }),
                    (this.autoplay = () => {
                        i()(window).width() > 767 && !window.matchMedia("(prefers-reduced-motion: reduce)").matches && this.play();
                    }),
                    (this.pause = () => {
                        if (this.active) {
                            switch (this.media.media_type) {
                                case "model":
                                    break;
                                case "video":
                                    this.plyrController.pause();
                                    break;
                                case "external_video":
                                    this.youtubeController.pauseVideo();
                            }
                            this.on_pause();
                        }
                    }),
                    (this.togglePlay = () => {
                        this.active ? this.pause() : this.play();
                    }),
                    (this.on_pause = () => {
                        (this.active = !1), this.target.querySelector(".product-medias__media").classList.remove("product-medias__media--active");
                        var e = new CustomEvent("media-pause", { detail: { parent: this.target, media: this } });
                        this.target.dispatchEvent(e);
                    }),
                    (this.focus = () => {
                        switch (this.media.media_type) {
                            case "video":
                                this.target.querySelector(".plyr").focus();
                                break;
                            case "model":
                                var e = this.target.querySelector("model-viewer");
                                e && e.shadowRoot ? e.focus() : setTimeout(this.focus.bind(this), 1e3);
                                break;
                            case "external_video":
                                this.target.querySelector("iframe").contentWindow.focus();
                                break;
                            default:
                                this.target.focus();
                        }
                    }),
                    (this.destroy = () => {}),
                    (this.theme = e),
                    (this.sectionId = t),
                    (this.mediaId = n.id),
                    (this.media = n),
                    (this.target = r),
                    (this.renderedElement = null),
                    (this.loaded = !1),
                    (this.active = !1),
                    (this.plyrController = null),
                    (this.modelController = null),
                    (this.youtubeController = null);
            }
        }
        class Ht {
            constructor() {
                this.state = { firstFocusable: null, lastFocusable: null };
            }
            trapFocus(e) {
                var t = Array.from(e.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])')).filter(function (e) {
                    var t = e.offsetWidth,
                        n = e.offsetHeight;
                    return 0 !== t && 0 !== n && "none" !== getComputedStyle(e).getPropertyValue("display");
                });
                (this.state.firstFocusable = t[0]),
                    (this.state.lastFocusable = t[t.length - 1]),
                    e.elementToFocus || (e.elementToFocus = e.container),
                    e.container.setAttribute("tabindex", "-1"),
                    e.elementToFocus.focus(),
                    this._setupHandlers(),
                    document.addEventListener("focusin", this._onFocusInHandler),
                    document.addEventListener("focusout", this._onFocusOutHandler);
            }
            _setupHandlers() {
                this._onFocusInHandler || (this._onFocusInHandler = this._onFocusIn.bind(this)),
                    this._onFocusOutHandler || (this._onFocusOutHandler = this._onFocusIn.bind(this)),
                    this._manageFocusHandler || (this._manageFocusHandler = this._manageFocus.bind(this));
            }
            _onFocusOut() {
                document.removeEventListener("keydown", this._manageFocusHandler);
            }
            _onFocusIn(e) {
                (e.target !== this.state.lastFocusable && e.target !== this.state.firstFocusable) || document.addEventListener("keydown", this._manageFocusHandler);
            }
            _manageFocus(e) {
                9 === e.keyCode &&
                    (e.target !== this.state.lastFocusable || e.shiftKey || (e.preventDefault(), this.state.firstFocusable.focus()),
                    e.target === this.state.firstFocusable && e.shiftKey && (e.preventDefault(), this.state.lastFocusable.focus()));
            }
            removeTrapFocus(e) {
                e.container && e.container.removeAttribute("tabindex"), e.elementToFocus && e.elementToFocus.focus(), document.removeEventListener("focusin", this._onFocusInHandler);
            }
        }
        var Vt = function () {
            var e = this,
                t = e.$createElement,
                n = e._self._c || t;
            return n("div", { ref: "component", staticClass: "wetheme-dropdown", class: ["fit-" + e.fit, e.open ? "wetheme-dropdown--open" : "wetheme-dropdown--closed", "wetheme-dropdown--" + e.direction] }, [
                e.title ? n("label", { attrs: { for: e.id }, domProps: { textContent: e._s(e.title) } }) : e._e(),
                e._v(" "),
                n(
                    "div",
                    { staticClass: "wetheme-dropdown__wrapper" },
                    [
                        n(
                            "button",
                            {
                                ref: "button",
                                attrs: { id: e.id, type: "button", autocomplete: "off", readonly: "true", tabindex: "0", "aria-controls": e.dropdownId, "aria-expanded": e.open },
                                on: {
                                    click: e.toggleOpen,
                                    blur: function (t) {
                                        e.open = !1;
                                    },
                                    keydown: [
                                        function (t) {
                                            return !t.type.indexOf("key") && e._k(t.keyCode, "up", 38, t.key, ["Up", "ArrowUp"]) ? null : (t.preventDefault(), e.moveFocusedIndex(-1));
                                        },
                                        function (t) {
                                            return !t.type.indexOf("key") && e._k(t.keyCode, "down", 40, t.key, ["Down", "ArrowDown"]) ? null : (t.preventDefault(), e.moveFocusedIndex(1));
                                        },
                                        function (t) {
                                            return !t.type.indexOf("key") && e._k(t.keyCode, "enter", 13, t.key, "Enter") ? null : (t.preventDefault(), e.applyFocused(!1));
                                        },
                                        function (t) {
                                            return !t.type.indexOf("key") && e._k(t.keyCode, "space", 32, t.key, [" ", "Spacebar"]) ? null : (t.preventDefault(), e.applyFocused(!1));
                                        },
                                        function (t) {
                                            return !t.type.indexOf("key") && e._k(t.keyCode, "esc", 27, t.key, ["Esc", "Escape"]) ? null : (t.preventDefault(), e.close(t));
                                        },
                                    ],
                                },
                            },
                            [
                                n("span", { staticClass: "header--supporting-text", domProps: { textContent: e._s(e.selectedOption.label || " ") } }),
                                e._v(" "),
                                n("span", { staticClass: "icon-dropdown" }, [
                                    n(
                                        "svg",
                                        {
                                            staticClass: "feather feather-chevron-down",
                                            attrs: {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "24",
                                                height: "24",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                "stroke-width": "2",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                            },
                                        },
                                        [n("polyline", { attrs: { points: "6 9 12 15 18 9" } })]
                                    ),
                                ]),
                            ]
                        ),
                        e._v(" "),
                        n("transition", { attrs: { name: "wetheme-dropdown-fade" } }, [
                            n(
                                "ul",
                                { directives: [{ name: "show", rawName: "v-show", value: e.open, expression: "open" }], ref: "ul", attrs: { id: e.dropdownId } },
                                e._l(e.options, function (t) {
                                    return n("li", {
                                        key: t.value,
                                        class: { selected: t.value === e.options[e.focusedIndex].value },
                                        attrs: { value: t.value },
                                        domProps: { textContent: e._s(t.label) },
                                        on: {
                                            click: function (n) {
                                                return e.optionClicked(t);
                                            },
                                        },
                                    });
                                }),
                                0
                            ),
                        ]),
                    ],
                    1
                ),
            ]);
        };
        Vt._withStripped = !0;
        let Wt = 0;
        function Ut(e, t, n, r, i, o, a, s) {
            var l,
                c = "function" == typeof e ? e.options : e;
            if (
                (t && ((c.render = t), (c.staticRenderFns = n), (c._compiled = !0)),
                r && (c.functional = !0),
                o && (c._scopeId = "data-v-" + o),
                a
                    ? ((l = function (e) {
                          (e = e || (this.$vnode && this.$vnode.ssrContext) || (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext)) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (e = __VUE_SSR_CONTEXT__),
                              i && i.call(this, e),
                              e && e._registeredComponents && e._registeredComponents.add(a);
                      }),
                      (c._ssrRegister = l))
                    : i &&
                      (l = s
                          ? function () {
                                i.call(this, (c.functional ? this.parent : this).$root.$options.shadowRoot);
                            }
                          : i),
                l)
            )
                if (c.functional) {
                    c._injectStyles = l;
                    var u = c.render;
                    c.render = function (e, t) {
                        return l.call(t), u(e, t);
                    };
                } else {
                    var d = c.beforeCreate;
                    c.beforeCreate = d ? [].concat(d, l) : [l];
                }
            return { exports: e, options: c };
        }
        var Gt = Ut(
            s.a.extend({
                props: {
                    fit: {
                        type: String,
                        default: "parent",
                        validator: function (e) {
                            return -1 !== ["parent", "current", "longest"].indexOf(e);
                        },
                    },
                    direction: {
                        type: String,
                        default: "down",
                        validator: function (e) {
                            return -1 !== ["down", "up"].indexOf(e);
                        },
                    },
                    name: { type: String, default: "" },
                    value: { type: String, default: null },
                },
                data: function () {
                    return { id: "", title: "", open: !1, options: [], selectedOption: void 0, focusedIndex: 0, selectComponent: void 0 };
                },
                computed: {
                    dropdownId: function () {
                        return this.id + "-dropdown";
                    },
                },
                watch: {
                    value: function (e) {
                        this.options.forEach((t, n) => {
                            t.value === e && ((this.selectedOption = t), (this.focusedIndex = n));
                        });
                    },
                },
                beforeMount: function () {
                    const e = "WETHEME-DROPDOWN" === this.$root.$el.tagName ? this.$root.$el : this.$root.$el.querySelector("wetheme-dropdown");
                    var t = e.querySelector("select");
                    t.id ? (this.id = t.id) : ((Wt += 1), (this.id = "wetheme-dropdown-" + Wt));
                    var n = e.querySelector("label");
                    this.title = n ? n.textContent : void 0;
                    var r = [];
                    Array.prototype.forEach.call(t.querySelectorAll("option"), (e, t) => {
                        r.push({ value: e.value, label: e.textContent }), e.defaultSelected && ((this.selectedOption = e), (this.focusedIndex = t));
                    }),
                        (this.options = r),
                        this.selectedOption || ((this.selectedOption = r[0]), (this.focusedIndex = 0)),
                        (this.selectWidth = (function (e) {
                            const t = e.cloneNode(!0);
                            (t.style.cssText = "position: fixed; top: 0; left: 0; overflow: auto; visibility: hidden; pointer-events: none; height: unset; max-height: unset"), document.body.appendChild(t);
                            const n = t.getBoundingClientRect().width;
                            return document.body.removeChild(t), n;
                        })(t)),
                        (this.selectComponent = t),
                        (this.selectComponent.style.display = "none"),
                        this.selectComponent.addEventListener("input", console.log),
                        e.parentNode.removeChild(e);
                },
                mounted: function () {
                    if ("longest" === this.fit) {
                        var e = this.selectWidth + 20;
                        (this.$el.style.width = e + "px"), (this.$refs.ul.style.width = e + "px");
                    }
                    this.$el.appendChild(this.selectComponent);
                },
                methods: {
                    findOptionIndex: function (e) {
                        var t;
                        return (
                            this.options.forEach(function (n, r) {
                                n.value === e.value && (t = r);
                            }),
                            t
                        );
                    },
                    optionClicked: function (e) {
                        (this.selectedOption = e),
                            (this.focusedIndex = this.findOptionIndex(e)),
                            (this.selectComponent.value = e.value),
                            (this.open = !1),
                            this.$nextTick(function () {
                                var e = new CustomEvent("change");
                                this.selectComponent.dispatchEvent(e);
                            }),
                            this.$emit("change", e.value, this.name);
                    },
                    moveFocusedIndex: function (e) {
                        var t = this.focusedIndex + e;
                        t >= 0 && t < this.options.length && (this.focusedIndex = t), this.open || this.applyFocused(!0);
                    },
                    toggleOpen: function () {
                        this.$nextTick(function () {
                            this.open ? ((this.open = !1), this.$refs.button.blur()) : ((this.open = !0), this.$refs.button.focus());
                        });
                    },
                    applyFocused: function (e) {
                        this.open || e ? (this.optionClicked(this.options[this.focusedIndex]), (this.open = !1)) : (this.open = !0);
                    },
                    close: function () {
                        this.open = !1;
                    },
                },
            }),
            Vt,
            [],
            !1,
            null,
            null,
            null
        );
        Gt.options.__file = "src/javascripts/components/Dropdown.vue";
        var Yt,
            Xt,
            Kt,
            Jt,
            Zt,
            Qt,
            en,
            tn,
            nn,
            rn,
            on,
            an,
            sn,
            ln,
            cn,
            un,
            dn,
            pn,
            hn,
            fn,
            mn,
            gn,
            vn,
            yn,
            bn,
            wn,
            xn,
            En,
            Cn,
            Sn,
            Tn,
            kn,
            An = Gt.exports;
        function _n(e, t, n, r) {
            n && Object.defineProperty(e, t, { enumerable: n.enumerable, configurable: n.configurable, writable: n.writable, value: n.initializer ? n.initializer.call(r) : void 0 });
        }
        function Ln(e, t, n, r, i) {
            var o = {};
            return (
                Object.keys(r).forEach(function (e) {
                    o[e] = r[e];
                }),
                (o.enumerable = !!o.enumerable),
                (o.configurable = !!o.configurable),
                ("value" in o || o.initializer) && (o.writable = !0),
                (o = n
                    .slice()
                    .reverse()
                    .reduce(function (n, r) {
                        return r(e, t, n) || n;
                    }, o)),
                i && void 0 !== o.initializer && ((o.value = o.initializer ? o.initializer.call(i) : void 0), (o.initializer = void 0)),
                void 0 === o.initializer && (Object.defineProperty(e, t, o), (o = null)),
                o
            );
        }
        const $n = "ready",
            Dn = "soldOut",
            On = "added",
            qn = "unavailable",
            Mn = "adding",
            Pn = l.xs;
        let In =
            ((Yt = dt({ components: { "wetheme-dropdown": An } })),
            (Xt = ft({ required: !0 })),
            (Kt = ft({ required: !0 })),
            (Jt = ft({ required: !0 })),
            (Zt = ft({ required: !0 })),
            (Qt = ft({ required: !0 })),
            (en = ft({ required: !0 })),
            (tn = ft({ required: !0 })),
            (nn = ft({ required: !0 })),
            (rn = ft({ required: !0 })),
            (on = ft({ required: !0 })),
            (an = ft({ required: !0 })),
            (sn = ft({ required: !0 })),
            (ln = ft({ required: !0 })),
            (cn = ft({ required: !0 })),
            (un = mt("variant")),
            Yt(
                ((pn = class extends s.a {
                    constructor(...e) {
                        super(...e),
                            _n(this, "initialVariantId", hn, this),
                            _n(this, "product", fn, this),
                            _n(this, "theme", mn, this),
                            _n(this, "productSection", gn, this),
                            _n(this, "isFeaturedProduct", vn, this),
                            _n(this, "thumbnailChangesVariant", yn, this),
                            _n(this, "hasThumbnails", bn, this),
                            _n(this, "imageZoomEnabled", wn, this),
                            _n(this, "videoLoopEnabled", xn, this),
                            _n(this, "sectionId", En, this),
                            _n(this, "cartMethod", Cn, this),
                            _n(this, "slidesPerView", Sn, this),
                            _n(this, "giftwrapProductVariantId", Tn, this),
                            _n(this, "locationsEnabled", kn, this),
                            (this.option1 = ""),
                            (this.option2 = null),
                            (this.option3 = null),
                            (this.addingToCart = void 0),
                            (this.afterAddToCart = void 0),
                            (this.mediaWrapperSpacing = void 0),
                            (this.activeMediaId = void 0),
                            (this.mediaWrapperById = void 0),
                            (this.showOutOfStockForm = void 0),
                            (this.isMobile = void 0),
                            (this.quantity = 1),
                            (this.hasErrors = void 0),
                            (this.giftwrapProduct = void 0),
                            (this.mediaSlider = null),
                            (this.locationsModal = null),
                            (this.modalLink = null),
                            (this.Accessibility = void 0),
                            (this.hidePaymentButtons = () => {
                                i()(".shopify-payment-button").hide();
                            }),
                            (this.showPaymentButtons = () => {
                                i()(".shopify-payment-button").show();
                            });
                    }
                    data() {
                        const e = this.product.variants.find((e) => e.id === this.initialVariantId);
                        let t;
                        return (
                            e.featured_media ? (t = e.featured_media) : this.product.media && this.product.media.length > 0 && (t = this.product.media[0]),
                            {
                                option1: e.option1,
                                option2: e.option2,
                                option3: e.option3,
                                addingToCart: !1,
                                afterAddToCart: !1,
                                mediaWrapperSpacing: "",
                                activeMediaId: t ? t.id : void 0,
                                mediaWrapperById: new Map(),
                                showOutOfStockForm: !1,
                                isMobile: window.matchMedia(`only screen and (max-width: ${Pn.max}px)`).matches,
                                quantity: 1,
                                hasErrors: "",
                                giftwrapProduct: !1,
                                hasLocalPickup: "",
                                locationsModal: null,
                                modalLink: null,
                                Accessibility: null,
                            }
                        );
                    }
                    get variant() {
                        return this.product.variants.find((e) => e.option1 === this.option1 && e.option2 == this.option2 && e.option3 === this.option3);
                    }
                    get isSale() {
                        return this.variant && this.variant.compare_at_price && this.variant.compare_at_price > this.variant.price;
                    }
                    get state() {
                        return this.addingToCart ? Mn : this.afterAddToCart ? On : this.variant ? (this.variant.available ? $n : Dn) : qn;
                    }
                    get addToCartDisabled() {
                        return !this.variant || !this.variant.available;
                    }
                    get activeMedia() {
                        return (this.product.media || []).find((e) => e.id === this.activeMediaId);
                    }
                    get firstOrActiveModel() {
                        return this.activeMedia && "model" === this.activeMedia.media_type ? this.activeMedia : (this.product.media || []).find((e) => "model" === e.media_type);
                    }
                    increaseQuantity() {
                        this.quantity = +this.quantity + 1;
                    }
                    decreaseQuantity() {
                        this.quantity = Math.max(1, +this.quantity - 1);
                    }
                    getMedia(e) {
                        let t = this.mediaWrapperById.get(e);
                        if (!t) {
                            const n = (this.product.media || []).find((t) => t.id === e),
                                r = this.$refs.mediaTargets[n.position - 1];
                            (t = new jt(this.theme, this.sectionId, n, r)),
                                r.addEventListener("media-play", this.onMediaPlay.bind(this)),
                                r.addEventListener("media-pause", this.onMediaPause.bind(this)),
                                r.addEventListener("media-load", this.onMediaLoaded.bind(this)),
                                this.mediaWrapperById.set(e, t);
                        }
                        return t;
                    }
                    async updateStoreAvailabilityContent(e, t) {
                        if (
                            (M(".product_info .original-select option").each(function () {
                                var t = M(this).attr("value");
                                if (e == t) {
                                    M(this).attr("selected", "selected");
                                    var n = M(this).attr("price");
                                    M(document).find(".product-details-wrapper .productTitle_price.variant-price").text(n);
                                } else M(this).removeAttr("selected", "selected");
                            }),
                            !this.locationsEnabled)
                        )
                            return;
                        const n = "/variants/" + e + "/?section_id=store-availability",
                            r = await window.fetch(n),
                            i = await r.text();
                        let o = document.createElement("div");
                        o.innerHTML = i;
                        o.querySelector(".store-availability-information") && (this.hasLocalPickup = o.firstElementChild.innerHTML),
                            this.$nextTick(() => {
                                let e = this.$el.querySelector(".store-availabilities-modal__product-title");
                                if (e && ((e.textContent = t), (this.locationsModal = this.$el.querySelector(".store-availabilities-modal")), this.locationsModal)) {
                                    (this.modalLink = this.$el.querySelector(".store-availability-information__link")),
                                        this.modalLink && this.modalLink.addEventListener("click", this.openLocationsModal),
                                        (this.modalClose = this.$el.querySelector(".store-availabilities-modal__close")),
                                        this.modalClose && this.modalClose.addEventListener("click", this.closeLocationsModal);
                                    var n = document.querySelector("#PageContainer");
                                    n.insertBefore(this.locationsModal, n.firstChild);
                                }
                            });

                              $(".product_info .original-select option").each(function () {
                                var select_variant_id_ = $(this).attr("value");
                                if (variantId == select_variant_id_) {
                                    $(this).attr("selected", "selected");
                                    var variant_price = $(this).attr("price");
                                    $(document)
                                    .find(
                                        ".product-details-wrapper .productTitle_price.variant-price"
                                    )
                                    .text(variant_price);
                                } else {
                                    $(this).removeAttr("selected", "selected");
                                }
                                });
                    }
                    handleLocationsClickOutside(e) {
                        e.target.classList.contains("store-availability-information__link") || this.locationsModal.contains(e.target) || (e.preventDefault(), this.closeLocationsModal());
                    }
                    openLocationsModal() {
                        document.body.classList.add("js-drawer-location-modal-open"),
                            this.locationsModal.classList.add("locations-modal--is-active"),
                            Rt(this.locationsModal),
                            document.addEventListener("click", this.handleLocationsClickOutside),
                            this.Accessibility.trapFocus({ container: this.locationsModal, elementToFocus: this.$el.querySelector(".store-availability-information__link") });
                    }
                    closeLocationsModal() {
                        document.body.classList.remove("js-drawer-location-modal-open"),
                            this.locationsModal.classList.remove("locations-modal--is-active"),
                            Ft(this.locationsModal),
                            document.removeEventListener("click", this.handleLocationsClickOutside),
                            this.Accessibility.removeTrapFocus({ container: this.locationsModal, elementToFocus: this.$el.querySelector(".store-availability-information__link") });
                    }
                    loadSlider() {
                        if (
                            ((this.mediaSlider = new Pe(this.$el.querySelector(".swiper-container"), {
                                direction: "horizontal",
                                slidesPerView: this.slidesPerView,
                                centeredSlides: this.slidesPerView > 1,
                                updateOnImagesReady: !0,
                                spaceBetween: 20,
                                threshold: 10,
                                autoHeight: !0,
                                pagination: { el: ".swiper-pagination", clickable: !0 },
                            })),
                            this.mediaSlider.on("slideChange", () => {
                                if (this.thumbnailChangesVariant) {
                                    const e = this.product.media[this.mediaSlider.activeIndex];
                                    this.changeDropdownsToMedia(e);
                                }
                                this.mediaWrapperById.forEach((e) => e.pause());
                            }),
                            (this.mediaSlider.allowTouchMove = this.isFeaturedProduct || this.isMobile),
                            this.variant.featured_media && this.slideTo(this.getMedia(this.variant.featured_media.id), !0),
                            !this.isFeaturedProduct)
                        ) {
                            let e = null;
                            if (this.$el.querySelector(".product-medias__primary .product-medias__media")) {
                                const t = parseInt(this.$el.querySelector(".product-medias__primary .product-medias__media").dataset.mediaId, 10);
                                e = this.getMedia(t);
                            }
                            e && this.imageZoomEnabled && e.loadImageZoom();
                        }
                    }
                    unloadSlider() {
                        console.log("destroy"), this.mediaSlider.destroy(), (this.mediaSlider = void 0);
                    }
                    get hasSlider() {
                        return this.isFeaturedProduct || this.isMobile;
                    }
                    get showThumbails() {
                        return !this.isFeaturedProduct && this.hasThumbnails && !this.isMobile;
                    }
                    mounted() {
                        if (
                            (this.$el.querySelector("#AddToCartForm").addEventListener("submit", this.onAddToCart),
                            (this.mediaWrapperById = new Map()),
                            (this.Accessibility = new Ht()),
                            (this.showThumbails || this.hasSlider) && this.loadSlider(),
                            this.updateStoreAvailabilityContent(this.variant.id, this.product.title),
                            this.$el.addEventListener("product-media-select", this.onMediaSelect.bind(this)),
                            !this.hasThumbnails)
                        ) {
                            this.$el.querySelectorAll(".product-medias__fullsize .product-medias__media").forEach((e) => {
                                if ("image" == e.dataset.mediaType) {
                                    const t = parseInt(e.dataset.mediaId, 10),
                                        n = this.getMedia(t);
                                    n && this.imageZoomEnabled && n.loadImageZoom();
                                }
                            });
                        }
                        this.firstOrActiveModel &&
                            (window.Shopify.loadFeatures([{ name: "shopify-xr", version: "1.0" }]),
                            document.addEventListener("shopify_xr_launch", () => {
                                setTimeout(() => {
                                    document.body.classList.remove("unloading");
                                }, 100);
                            })),
                            (window.ShopifyXR =
                                window.ShopifyXR ||
                                function () {
                                    (window.ShopifyXR.q = window.ShopifyXR.q || []).push(arguments);
                                });
                        const e = (this.product.media || []).filter((e) => "model" === e.media_type);
                        window.ShopifyXR.addModels ? window.ShopifyXR.addModels(e) : window.ShopifyXR("addModels", e);
                    }
                    onVariantChange() {
                        if (this.variant) {
                            if (
                                (this.variant.available ? this.showPaymentButtons() : ((this.showOutOfStockForm = !1), this.hidePaymentButtons()),
                                this.setVariantUrl(this.variant),
                                this.updateStoreAvailabilityContent(this.variant.id, this.product.title),
                                this.variant.featured_media)
                            ) {
                                const e = this.$el.querySelector(`[data-media-id="${this.variant.featured_media.id}"]`);
                                this.onMediaElementSelect(e, { load: !0 });
                            }
                            const e = this;
                            (this.addToCartForm = this.$el.querySelector("#AddToCartForm")),
                                this.$nextTick(() => {
                                    const t = new Event("change");
                                    e.addToCartForm.dispatchEvent(t);
                                });
                        } else this.hidePaymentButtons();
                    }
                    onShowOutOfStockForm(e) {
                        e.preventDefault(), e.currentTarget.contains(e.target.closest("a")) && (this.showOutOfStockForm = !0);
                    }
                    onMediaPlay(e) {
                        this.mediaSlider && (this.mediaSlider.allowTouchMove = !1);
                    }
                    onMediaPause(e) {
                        this.mediaSlider && (this.mediaSlider.allowTouchMove = this.isFeaturedProduct || this.isMobile);
                    }
                    onMediaLoaded(e) {
                        e.detail.parent.querySelector(".product-medias__media").addEventListener("click", this.onMediaActivate.bind(this));
                    }
                    onMediaSelect(e) {
                        const t = i()(this.$el).find(".product-single__media")[e.detail.index],
                            n = this.mediaWrapperById.get(parseInt(t.dataset.mediaId, 10)),
                            r = "video" === n.media.media_type || "external_video" === n.media.media_type,
                            o = this.$el.closest("#ShopNowContainer");
                        this.onMediaElementSelect(t, { load: e.detail.forceLoad, forcePlay: e.detail.forcePlay || (!this.isMobile && !o && r), focus: e.detail.focus });
                    }
                    onMediaActivate(e) {
                        const t = e.target,
                          n = e.currentTarget.closest('[data-media-id]') || e.currentTarget;
                        if ("keydown" === e.type) {
                            if (13 !== e.keyCode && 27 !== e.keyCode) return;
                            if (t.classList.contains("shopify-model-viewer-ui__button") || t.classList.contains("plyr__controls__item")) return;
                        }
                        if ((e.preventDefault(), t.classList.contains("product-medias__view-in-space"))) return;
                        if ("MODEL-VIEWER" === t.tagName || t.classList.contains("shopify-model-viewer-ui__controls-overlay")) return;
                        const r = n.classList.contains("product-single__media--loaded"),
                            i = n.classList.contains("product-single__media--active");
                        this.hasThumbnails && this.onThumbnailClick(n), (r && i) || this.onMediaElementSelect(n, { load: !0, togglePlay: !0 });
                    }
                    onMediaElementSelect(e, t) {
                        if (!e) return;
                        const n = this.getMedia(parseInt(e.dataset.mediaId, 10));
                        (this.activeMediaId = n.media.id),
                            this.slideTo(n),
                            this.mediaWrapperById.forEach((e) => {
                                e.mediaId !== n.mediaId && e.pause();
                            }),
                            i()(this.$el).find(".product-single__media--selected").not(e).removeClass("product-single__media--selected"),
                            e.classList.add("product-single__media--selected"),
                            t.togglePlay ? n.togglePlay() : t.forcePlay ? n.play() : t.load && n.load(),
                            t.focus && n.focus();
                    }
                    async onAddToCart(e) {
                        e.preventDefault(), (this.addingToCart = !0), (this.hasErrors = "");
                        try {
                            const e = i()(this.$el.querySelector("#AddToCartForm")).serialize();
                            i()(this.$el.querySelector("#AddToCartForm"));
                            let t = "";
                            if (
                                (this.giftwrapProduct && this.giftwrapProductVariantId && (t = "&properties[" + this.theme.translations.giftwrap_label + "]=" + this.theme.translations.yes),
                                this.giftwrapProduct && this.giftwrapProductVariantId)
                            ) {
                                const e = { items: [{ id: this.giftwrapProductVariantId, quantity: this.quantity }] },
                                    t = await window.fetch("/cart/add.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" }, body: JSON.stringify(e) }),
                                    n = await t.json();
                                if (!t.ok) return 422 == n.status && (this.hasErrors = n.description), void (this.addingToCart = !1);
                            }
                            const n = await window.fetch("/cart/add.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/x-www-form-urlencoded", "X-Requested-With": "XMLHttpRequest" }, body: e + t }),
                                r = await n.json();
                            if (!n.ok) return 422 == r.status && (this.hasErrors = r.description), void (this.addingToCart = !1);
                            const o = await window.fetch("/cart?view=compare");
                            if (!o.ok) return void (this.addingToCart = !1);
                            const a = await o.json();
                            (this.addingToCart = !1),
                                "drawer" === this.cartMethod
                                    ? this.theme.toggleRightDrawer("cart", !0, { cart: a })
                                    : "added" === this.cartMethod
                                    ? ((this.afterAddToCart = !0),
                                      setTimeout(() => {
                                          this.afterAddToCart = !1;
                                      }, 2e3),
                                      this.theme.updateCartDrawer(a))
                                    : "page" === this.cartMethod && (window.location.href = "/cart");
                        } catch (e) {
                            console.error("Unable to add to cart: ", e);
                        }
                    }
                    onThumbnailClick(e) {
                        const t = this.getMedia(parseInt(e.dataset.mediaId, 10));
                        this.slideTo(t), this.changeDropdownsToMedia(t.media);
                    }
                    slideTo(e, t = !1) {
                        this.mediaSlider && this.mediaSlider.slideTo(e.media.position - 1, this.hasSlider && !t ? 200 : 0);
                    }
                    changeDropdownsToMedia(e) {
                        if (this.thumbnailChangesVariant) {
                            const t = this.product.variants.find((t) => t.featured_media && t.featured_media.id === e.id);
                            t && ((this.option1 = t.option1), (this.option2 = t.option2), (this.option3 = t.option3));
                        }
                    }
                    setVariantOption(e, t) {
                        this[`option${t}`] = e;
                    }
                    setVariantUrl(e) {
                        const t = this.product.variants.length > 1;
                        if (history.replaceState && !this.isFeaturedProduct && t) {
                            let t = [];
                            window.location.search.length > 1 &&
                                (t = window.location.search
                                    .slice(1)
                                    .split("&")
                                    .filter((e) => 0 !== e.indexOf("variant="))),
                                t.push("variant=" + e.id);
                            const n = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + t.join("&");
                            window.history.replaceState({ path: n }, "", n);
                        }
                    }
                    money(e) {
                        return this.theme.formatMoney(e);
                    }
                    onWindowResizeBreakpoint({ breakpoint: e, oldBreakpoint: t }) {
                        const n = e.order <= Pn.order;
                        n !== t.order <= Pn.order &&
                            ((this.isMobile = n),
                            this.mediaSlider && (this.mediaSlider.allowTouchMove = this.hasSlider),
                            this.hasThumbnails || (this.hasSlider && !this.mediaSlider ? this.loadSlider() : !this.hasSlider && this.mediaSlider && this.unloadSlider()));
                    }
                }),
                (hn = Ln(pn.prototype, "initialVariantId", [Xt], { configurable: !0, enumerable: !0, writable: !0, initializer: null })),
                (fn = Ln(pn.prototype, "product", [Kt], { configurable: !0, enumerable: !0, writable: !0, initializer: null })),
                (mn = Ln(pn.prototype, "theme", [Jt], { configurable: !0, enumerable: !0, writable: !0, initializer: null })),
                (gn = Ln(pn.prototype, "productSection", [Zt], { configurable: !0, enumerable: !0, writable: !0, initializer: null })),
                (vn = Ln(pn.prototype, "isFeaturedProduct", [Qt], { configurable: !0, enumerable: !0, writable: !0, initializer: null })),
                (yn = Ln(pn.prototype, "thumbnailChangesVariant", [en], { configurable: !0, enumerable: !0, writable: !0, initializer: null })),
                (bn = Ln(pn.prototype, "hasThumbnails", [tn], { configurable: !0, enumerable: !0, writable: !0, initializer: null })),
                (wn = Ln(pn.prototype, "imageZoomEnabled", [nn], { configurable: !0, enumerable: !0, writable: !0, initializer: null })),
                (xn = Ln(pn.prototype, "videoLoopEnabled", [rn], { configurable: !0, enumerable: !0, writable: !0, initializer: null })),
                (En = Ln(pn.prototype, "sectionId", [on], { configurable: !0, enumerable: !0, writable: !0, initializer: null })),
                (Cn = Ln(pn.prototype, "cartMethod", [an], { configurable: !0, enumerable: !0, writable: !0, initializer: null })),
                (Sn = Ln(pn.prototype, "slidesPerView", [sn], { configurable: !0, enumerable: !0, writable: !0, initializer: null })),
                (Tn = Ln(pn.prototype, "giftwrapProductVariantId", [ln], { configurable: !0, enumerable: !0, writable: !0, initializer: null })),
                (kn = Ln(pn.prototype, "locationsEnabled", [cn], { configurable: !0, enumerable: !0, writable: !0, initializer: null })),
                Ln(pn.prototype, "onVariantChange", [un], Object.getOwnPropertyDescriptor(pn.prototype, "onVariantChange"), pn.prototype),
                (dn = pn))
            ) || dn);
        class Nn extends f {
            constructor(e, t, n, r = {}) {
                super(e, t, n),
                    (this.fixSticky = () => {
                        const e = this.element.querySelector(".product-sticky"),
                            t = document.querySelector(".sticky-header");
                        e && t && (e.style.top = `${t.clientHeight}px`);
                    }),
                    (this.onWindowResize = () => {
                        this.fixSticky(), this.loadReadmore();
                    }),
                    (this.onWindowResizeBreakpoint = ({ breakpoint: e, oldBreakpoint: t }) => {
                        this.vue && this.vue.$children[0].onWindowResizeBreakpoint({ breakpoint: e, oldBreakpoint: t });
                    }),
                    (this.loadReadmore = () => {
                        const e = this.element.querySelector(".product-description.readmore");
                        if (!e) return;
                        let t = 100;
                        this.element.querySelector(".product-description_full-width") && ((t = 150), this.theme.getWindowWidth() <= 768 && (t = 100)),
                            e.classList.contains("rmjs-1") ||
                                (this.readMore = new At(e, {
                                    speed: 100,
                                    collapsedHeight: t,
                                    moreLink: `<div class="read-more-link"><a href="#">${this.theme.translations.read_more_html} <i class="fa fa-angle-down" aria-hidden="true"></i></a></div>`,
                                    lessLink: `<div class="read-less-link"><a href="#">${this.theme.translations.read_less_html} <i class="fa fa-angle-up" aria-hidden="true"></i></a></div>`,
                                    beforeToggle: function (e, t, n) {
                                        if (n) {
                                            const e = document.querySelector(".sticky-header"),
                                                n = e ? e.clientHeight : 0;
                                            i()("html, body").animate({ scrollTop: i()(t).offset().top - n }, 100);
                                        }
                                        i()(t).toggleClass("closed");
                                    },
                                }));
                    }),
                    (this.loadTabs = () => {
                        i()(this.element)
                            .find("ul.tabs")
                            .each(function () {
                                var e,
                                    t,
                                    n = i()(this).find("a");
                                (e = n.first().addClass("active")),
                                    (t = i()(e.attr("href"))),
                                    n.not(":first").each(function () {
                                        i()(i()(this).attr("href")).hide();
                                    }),
                                    i()(this)
                                        .find("a")
                                        .click(function (n) {
                                            return e.removeClass("active"), t.hide(), (e = i()(this)), (t = i()(i()(this).attr("href"))), e.addClass("active"), t.fadeIn(), !1;
                                        });
                            });
                    }),
                    (this.scrollToPostedForm = () => {
                        i()(".out-of-stock-form .posted-successfully").length && i()("html, body").animate({ scrollTop: i()(".form-vertical").offset().top }, 100);
                    });
                var o = this.element.querySelector(".product-json");
                o &&
                    ((this.product = JSON.parse(o.textContent)),
                    (this.vue = new s.a({
                        el: this.element.querySelector(".product-form-vue"),
                        components: { "wetheme-product-form": In },
                        data: () => ({ productSection: this, product: this.product, theme: this.theme, isFeaturedProduct: this.isFeaturedProduct, slidesPerView: (r && r.slidesPerView) || 1 }),
                    })),
                    this.theme.loadReviews({ products: !0, badges: !0 }),
                    this.fixSticky(),
                    this.loadReadmore(),
                    this.loadTabs(),
                    this.scrollToPostedForm());
            }
            get isFeaturedProduct() {
                return !1;
            }
        }
        class zn extends Nn {
            get isFeaturedProduct() {
                return !0;
            }
        }
        class Rn extends f {
            constructor(e, t, n) {
                super(e, t, n),
                    (this.onAuthError = (e) => {
                        this.showError(e.detail.reason);
                    }),
                    (this.showError = (e) => {
                        const t = this.element.querySelector(".map-section__container");
                        t.classList.add("hide"),
                            window.Shopify.designMode && i()('<div class="map-container-error"></div>').text(e).appendTo(t.parentElement.querySelector(".map-section__overlay")),
                            t.parentElement.querySelector(".homepage-map--fallback").classList.remove("hide");
                    }),
                    (this.onLoad = (e) => {
                        this.mapsApi = e;
                        let t = [];
                        try {
                            const e = this.element.querySelector(".map-theme");
                            e && (t = JSON.parse(e.textContent));
                        } catch (e) {
                            console.error("Unable to parse theme style:", e);
                        }
                        const n = this.element.querySelector(".map-section__container");
                        n &&
                            ((this.map = new e.Map(n, { zoom: 14, styles: t, disableDefaultUI: !0, draggable: !1, clickableIcons: !1, scrollwheel: !1, disableDoubleClickZoom: !0, draggableCursor: "default" })),
                            (this.geocoder = new e.Geocoder()),
                            this.geocoder.geocode({ address: this.address }, (t, n) => {
                                "OK" === n ? (this.map.setCenter(t[0].geometry.location), (this.marker = new e.Marker({ map: this.map, position: t[0].geometry.location }))) : this.showError("Error looking up that address");
                            }));
                    }),
                    (this.onWindowResize = () => {
                        if (this.map) {
                            const e = this.map.getCenter();
                            this.mapsApi.event.trigger(this.map, "resize"), this.map.setCenter(e);
                        }
                    }),
                    (this.mapsApi = null),
                    (this.mapElement = t.querySelector(".map-wrapper")),
                    (this.apiKey = this.element.dataset.mapsApikey),
                    (this.address = this.element.dataset.mapsAddress),
                    e.loadGoogleMapApi(this.apiKey).then(this.onLoad).catch(this.showError),
                    document.body.addEventListener("google-maps-auth-failure", this.onAuthError),
                    (this.kenBurns = new k(e, t)),
                    (this.parallax = new Re(e, t));
            }
        }
        class Fn extends h {
            constructor(e, t, n, r) {
                super(e, t),
                    (this.PAGINATION_LOAD_OFFSET = 1200),
                    (this.SCROLL_DELAY = 200),
                    (this.PAGINATION_SELECTOR = ".pagination"),
                    (this.COLLECTION_WRAPPER_SELECTOR = ".wrapper.main-content"),
                    (this.COLLECTION_MAIN_SELECTOR = ".collection-main-body-inner"),
                    (this.COLLECTION_HEADER_SELECTOR = ".collection-main-central-header"),
                    (this.COLLECTION_ITEM_SELECTOR = ".grid__item"),
                    (this.COLLECTION_ITEM_EXCLUDE_SELECTOR = ".collection-central-description-block"),
                    (this.initialize = () => {
                        i()(".pagination").hasClass("pagination-infinite")
                            ? (this.pagination_type = "infinite-scroll")
                            : i()(".pagination").hasClass("pagination--load-more") && ((this.pagination_type = "load-more"), this.load_more_button());
                    }),
                    (this.onWindowScroll = () => {
                        "infinite-scroll" === this.pagination_type && this.$wrapper.position().top + this.$wrapper.height() - this.PAGINATION_LOAD_OFFSET < this.$doc.scrollTop() + this.$w.height() && this.load_next_page();
                    }),
                    (this.check_pagination_progress = () => {
                        var e = i()(this.PAGINATION_SELECTOR).find(".pagination-next a").attr("href");
                        this.fully_loaded = !e || "#" === e;
                    }),
                    (this.build_load_more_html = function () {
                        var e = parseInt(i()(".pagination").attr("data-paginate-items"), 10),
                            t = parseInt(i()(".pagination").attr("data-paginate-offset"), 10) + parseInt(i()(".pagination").attr("data-paginate-size"), 10),
                            n = (100 * t) / e;
                        if (void 0 !== this.theme.translations.youve_viewed) var r = this.theme.translations.youve_viewed.replace("{{ x }}", t).replace("{{ y }}", e);
                        else r = "";
                        return (
                            `<div class="pagination__load-more"><p class="pagination__progress-text">${r}</p><div class="progress-bar"><div class="progress-bar__inner" style="width:` +
                            n +
                            '%;"></div></div><button class="btn btn--large btn--load-more">Read more</button></div>'
                        );
                    }),
                    (this.load_more_button = function () {
                        this.check_pagination_progress();
                        var e = 0 !== i()(".pagination .btn--load-more").length,
                            t = this.build_load_more_html();
                        e || this.fully_loaded || i()(".pagination").append(t), i()(".btn--load-more").off("click").on("click", this.load_next_page.bind(this.$self));
                    }),
                    (this.set_loading = (e) => {
                        e ? ((this.loading = !0), this.$loading_indicator.show(), i()(this.PAGINATION_SELECTOR).hide()) : ((this.loading = !1), this.$loading_indicator.hide(), i()(this.PAGINATION_SELECTOR).show());
                    }),
                    (this.load_next_page = () => {
                        if (this.loading) return !1;
                        var e = i()(this.PAGINATION_SELECTOR).find(".pagination-next a").attr("href");
                        e && "#" !== e && (this.set_loading(!0), i.a.ajax({ type: "GET", url: e, dataType: "html" }).then(this.page_loaded.bind(this)).always(this.set_loading.bind(this, !1)));
                    }),
                    (this.scroll_position_history = () => {
                        var e = document.location.pathname;
                        ((window.onbeforeunload = function () {
                            var t = document.querySelector(".collection-main-body-inner").innerHTML,
                                n = document.querySelector(".pagination").innerHTML;
                            sessionStorage.setItem("pagePosition_" + e, t.toString()), sessionStorage.setItem("pagePagination_" + e, n.toString());
                        }),
                        2 == performance.navigation.type && sessionStorage["pagePosition_" + e]) && (document.querySelector(".collection-main-body-inner").innerHTML = sessionStorage.getItem("pagePosition_" + e));
                        2 == performance.navigation.type && sessionStorage["pagePagination_" + e] && (document.querySelector(".pagination").innerHTML = sessionStorage.getItem("pagePagination_" + e));
                    }),
                    (this.page_loaded = (e) => {
                        var t = i()(e),
                            n = i()("#grid_item_width_classes").val();
                        n && t.find(".grid__item").removeClass("large--one-quarter medium--one-quarter small--one-whole large--one-half medium--one-half").addClass(n),
                            this.$collection.append(
                                t.find(this.COLLECTION_HEADER_SELECTOR + " > " + this.COLLECTION_ITEM_SELECTOR).not(this.COLLECTION_ITEM_EXCLUDE_SELECTOR),
                                t.find(this.COLLECTION_MAIN_SELECTOR + " > " + this.COLLECTION_ITEM_SELECTOR)
                            ),
                            i()(this.PAGINATION_SELECTOR).replaceWith(t.find(this.PAGINATION_SELECTOR)),
                            "load-more" === this.pagination_type && this.load_more_button(),
                            this.loadedCallback1 && this.loadedCallback1(),
                            this.loadedCallback2 && this.loadedCallback2();
                    }),
                    (this.loadedCallback1 = n),
                    (this.loadedCallback2 = r),
                    (this.$w = i()(window)),
                    (this.$doc = i()(document)),
                    (this.$self = this),
                    (this.$collection = i()(this.COLLECTION_MAIN_SELECTOR)),
                    (this.$wrapper = i()(this.COLLECTION_WRAPPER_SELECTOR)),
                    (this.$loading_indicator = i()(".pagination-loading")),
                    (this.loading = !1),
                    (this.fully_loaded = !1),
                    (this.scroll_timeout = null),
                    (this.pagination_type = null);
                const o = i()(".pagination-infinite"),
                    a = i()(".pagination--load-more");
                (0 === o.length && 0 === a.length) || (this.initialize(), this.scroll_position_history());
            }
        }
        class Bn extends f {
            constructor(e, t, n) {
                super(e, t, n),
                    (this.loadShopNow = () => {
                        Array.prototype.forEach.call(this.element.querySelectorAll(".shop-now-button, .quick-add-button-variants"), (e) => {
                            e.removeEventListener("click", this.handleShopNow), e.addEventListener("click", this.handleShopNow);
                        }),
                            this.theme.addBadges(this.element, 1e3);
                    }),
                    (this.loadQuickAdd = () => {
                        this.quickAddButtons = new Be(this.theme, this.element);
                    }),
                    (this.loadTagFilter = () => {
                        i()(".coll-filter").on("change", function () {
                            var e = [],
                                t = i()(this).val();
                            if ((t && e.push(t), e.length)) {
                                var n = e.join("+"),
                                    r = i()("#link-to-tag-generic a").attr("href").replace(/\+/g, "%20");
                                window.location.href = r.replace(/(\/|=)tag($|\?|&)/, "$1" + n + "$2");
                            } else window.location.href = i()("#link-to-collection").val().toString();
                        }),
                            i()(".collection-filter-tag-checkbox").on("change", function () {
                                var e = Array.prototype.map
                                        .call(document.querySelectorAll("input.collection-filter-tag-checkbox:checked"), function (e) {
                                            return e.value;
                                        })
                                        .join("+"),
                                    t = i()("#link-to-tag-generic a").attr("href").replace(/\+/g, "%20");
                                window.location.href = t.replace(/(\/|=)tag($|\?|&)/, "$1" + e + "$2");
                            });
                    }),
                    (this.loadSortBy = () => {
                        const e = {};
                        if (location.search.length) for (var t, n = 0, r = location.search.substr(1).split("&"); n < r.length; n++) (t = r[n].split("=")).length > 1 && (e[decodeURIComponent(t[0])] = decodeURIComponent(t[1]));
                        i()(".coll-sort-by").val("{{ collection.sort_by | default: collection.default_sort_by | escape }}"),
                            i()(".coll-sort-by,.collection-sort-by-radio").on("change", function () {
                                (e.sort_by = i()(this).val()), (location.search = i.a.param(e).replace(/\+/g, "%20"));
                            });
                    }),
                    (this.handleShopNow = (e) => {
                        e.preventDefault(), this.theme.toggleRightDrawer("shop-now", !0, { url: e.target.href });
                    }),
                    this.loadTagFilter(),
                    this.loadSortBy(),
                    (this.pagination = new Fn(this.theme, this.element, this.loadShopNow, this.loadQuickAdd)),
                    this.loadShopNow(),
                    this.loadQuickAdd(),
                    this.theme.loadReviews({ badges: !0 }),
                    (this.parallax = new Re(e, t.parentNode)),
                    this.theme.addBadges(this.element, 1e3);
            }
        }
        class jn extends f {
            constructor(e, t, n) {
                super(e, t, n), (this.parallax = new Re(e, t.parentNode)), (this.quickAddButtons = new Be(e, t));
            }
        }
        class Hn extends f {
            constructor(e, t, n) {
                super(e, t, n),
                    (this.load = () => {
                        const e = `${this.baseUrl}?section_id=${this.sectionId}&limit=${this.limit}&product_id=${this.productId}`;
                        var t = new XMLHttpRequest();
                        t.open("GET", e),
                            (t.onload = () => {
                                if (t.status >= 200 && t.status < 300) {
                                    var e = document.createElement("div");
                                    (e.innerHTML = t.response),
                                        Array.prototype.forEach.call(e.children, (e) => {
                                            const t = e.querySelector(".product-page-related-products");
                                            t && this.element.appendChild(t),
                                                Array.prototype.forEach.call(document.querySelectorAll(".shop-now-button, .quick-add-button-variants"), (e) => {
                                                    e && e.addEventListener("click", this.handleShopNow);
                                                });
                                        }),
                                        this.theme.loadReviews({ badges: !0 }),
                                        this.theme.addBadges(this.element, 1e3),
                                        (this.quickAddButtons = new Be(this.theme, this.element));
                                }
                                const n = this.element.querySelector(".swiper-button--next"),
                                    r = this.element.querySelector(".swiper-button--prev");
                                this.swiper = new Pe(this.element.querySelector(".swiper-container"), { slidesPerView: 2, navigation: { nextEl: n, prevEl: r }, breakpoints: { 600: { slidesPerView: 4 } }, watchOverflow: !0 });
                            }),
                            t.send();
                    }),
                    (this.handleShopNow = (e) => {
                        e.preventDefault(), this.theme.toggleRightDrawer("shop-now", !0, { url: e.target.href });
                    }),
                    (this.theme = e),
                    (this.element = t),
                    (this.productId = this.element.dataset.productId),
                    (this.limit = this.element.dataset.limit),
                    (this.baseUrl = this.element.dataset.recommendationsUrl),
                    (this.sectionId = this.element.dataset.wethemeSectionId),
                    this.load();
            }
        }
        class Vn extends f {}
        class Wn extends f {}
        class Un extends f {
            constructor(e, t, n) {
                super(e, t, n), (this.kenBurns = new k(e, t));
            }
        }
        class Gn extends f {
            constructor(e, t, n) {
                super(e, t, n);
                const r = this.element.querySelector(".swiper-container");
                this.swiper = new Pe(r, { slidesPerView: 1, watchOverflow: !0, autoHeight: !0, loop: !0, autoplay: { delay: 5e3 }, speed: 1e3 });
            }
        }
        class Yn extends f {
            constructor(e, t, n) {
                super(e, t, n), Xe(this.element);
            }
        }
        class Xn extends f {
            constructor(e, t, n) {
                super(e, t, n),
                    (this.changeQuantity = (e) => {
                        e.preventDefault();
                        const t = e.currentTarget.closest(".js-qty").querySelector("input");
                        e.currentTarget.classList.contains("js-qty__adjust--minus") ? (t.value = Math.max(1, parseInt(t.value, 10) - 1)) : (t.value = parseInt(t.value, 10) + 1);
                    }),
                    Array.prototype.forEach.call(this.element.querySelectorAll(".js-qty__adjust"), (e) => e.addEventListener("click", this.changeQuantity));
            }
        }
        var Kn = function () {
            var e = this,
                t = e.$createElement,
                n = e._self._c || t;
            return n("div", [
                n("div", { class: e.overlay ? "homepage-hero-content-overlay-wrapper homepage-video-content-overlay-wrapper-" + e.sectionId + " " + (e.isPlaying ? "overlay-hidden" : "") : "" }, [
                    e.isPlaying || e.hero ? e._e() : n("div", { staticClass: "video--video__static-image" }),
                    e._v(" "),
                    e.isPlaying || e.hero ? e._e() : n("div", { staticClass: "video--video__text-block", on: { click: e.play } }, [e._m(0)]),
                    e._v(" "),
                    n("div", { class: { "embed-container": !e.hero } }, [
                        n("div", { ref: "video", staticClass: "video" }, [
                            "mp4" === e.videoType ? n("video", { ref: "videoMP4", staticClass: "hero-video-mp4", attrs: { playsinline: "", controls: "" } }, [n("source", { attrs: { src: e.url, type: "video/mp4" } })]) : e._e(),
                        ]),
                    ]),
                ]),
            ]);
        };
        Kn._withStripped = !0;
        class Jn {
            constructor(e, t) {
                (this.getAutoplay = (e) => (!("connection" in navigator) || !navigator.connection.saveData) && !window.matchMedia("(prefers-reduced-motion: reduce)").matches && e),
                    (this._load = async function () {}),
                    (this.init = (e) => {}),
                    (this.play = () => {}),
                    (this.pause = () => {}),
                    (this.theme = e),
                    (this.element = t);
            }
        }
        class Zn extends Jn {
            constructor(...e) {
                super(...e),
                    (this._load = () => this.theme.loadYoutubeApi()),
                    (this.init = ({ autoplay: e, hideControls: t, url: n, mute: r, loop: i, onPlay: o, onEnd: a }) => {
                        e = this.getAutoplay(e);
                        const s = ((e) => {
                            const t = e.replace(/(>|<)/gi, "").split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
                            return void 0 !== t[2] ? t[2].split(/[^0-9a-z_-]/i)[0] : e;
                        })(n);
                        return new Promise((n) => {
                            this._load().then((l) => {
                                this.player = new l.Player(this.element, {
                                    videoId: s,
                                    playerVars: {
                                        showinfo: 0,
                                        modestbranding: 1,
                                        rel: 0,
                                        autoplay: e ? 1 : 0,
                                        controls: t ? 0 : 1,
                                        mute: r || e ? 1 : 0,
                                        videoId: s,
                                        cc_load_policy: 0,
                                        fs: 0,
                                        iv_load_policy: 3,
                                        playsinline: 1,
                                        branding: 0,
                                        origin: window.location.origin,
                                    },
                                    events: {
                                        onReady: (t) => {
                                            (this.player = t.target), (r || e) && this.player.mute(), e && this.player.playVideo(), n(this.player);
                                        },
                                        onStateChange: (e) => {
                                            e.data === l.PlayerState.PLAYING && o(), e.data === l.PlayerState.ENDED && i && (this.player.playVideo(), a());
                                        },
                                    },
                                });
                            });
                        });
                    }),
                    (this.play = () => {
                        this.player.playVideo();
                    });
            }
        }
        class Qn extends Jn {
            constructor(...e) {
                super(...e),
                    (this._load = () => this.theme.loadVimeoApi()),
                    (this.init = ({ autoplay: e, hideControls: t, url: n, mute: r, loop: i, onPlay: o, onEnd: a }) => {
                        e = this.getAutoplay(e);
                        const s = (function (e) {
                            const t = e.match(/(videos|video|channels|\.com)\/([\d]+)/);
                            return e.split("/").length > 4 ? e : t && void 0 !== t[2] ? t[2] : e;
                        })(n);
                        return new Promise((n, l) => {
                            this._load().then((l) => {
                                (this.player = new l.Player(this.element, { id: s, autoplay: e, controls: !t, byline: !1, portrait: !1, title: !1 })),
                                    this.player.ready().then(() => {
                                        (r || e) && this.player.setVolume(0), i && this.player.setLoop(!0), e && this.player.play(), n(this.player);
                                    }),
                                    this.player.on("play", () => {
                                        o();
                                    }),
                                    this.player.on("ended", () => {
                                        a();
                                    });
                            });
                        });
                    }),
                    (this.play = () => {
                        this.player.play();
                    });
            }
        }
        class er extends Jn {
            constructor(...e) {
                super(...e),
                    (this._load = () =>
                        new Promise((e) => {
                            window.Shopify.loadFeatures([
                                {
                                    name: "video-ui",
                                    version: "1.0",
                                    onLoad: function () {
                                        e(window.Shopify.Plyr);
                                    },
                                },
                            ]);
                        })),
                    (this.init = ({ autoplay: e, hideControls: t, url: n, mute: r, loop: i, onPlay: o, onPause: a, onEnd: s }) => (
                        (e = this.getAutoplay(e)),
                        new Promise((n, l) => {
                            this._load().then((l) => {
                                (this.player = new l(this.element, { loop: { active: i }, autoplay: e, muted: r || e ? 1 : 0, fullscreen: { enabled: !1 } })),
                                    this.player.on("ready", (r) => {
                                        (this.player = r.detail.plyr), e && this.player.play(), t && this.player.toggleControls(!1), n();
                                    }),
                                    this.player.on("playing", () => {
                                        o();
                                    }),
                                    this.player.on("pause", () => {
                                        a();
                                    }),
                                    this.player.on("ended", () => {
                                        s();
                                    });
                            });
                        })
                    )),
                    (this.play = () => {
                        this.player.play();
                    });
            }
        }
        var tr = Ut(
            s.a.extend({
                props: {
                    theme: p,
                    hero: Boolean,
                    videoType: {
                        type: String,
                        required: !0,
                        validator: function (e) {
                            return -1 !== ["youtube", "vimeo", "mp4"].indexOf(e);
                        },
                    },
                    url: { type: String, required: !0 },
                    autoplay: { type: Boolean, required: !0 },
                    loop: Boolean,
                    mute: Boolean,
                    hideControls: { type: Boolean, default: !1 },
                    overlayOpacity: { type: Number, default: 1 },
                    sectionId: { type: String, default: "" },
                    overlay: Boolean,
                },
                data: () => ({ player: null, isPlaying: !1 }),
                mounted() {
                    "youtube" === this.videoType
                        ? (this.player = new Zn(this.$root.theme, this.$refs.video))
                        : "vimeo" === this.videoType
                        ? (this.player = new Qn(this.$root.theme, this.$refs.video))
                        : "mp4" === this.videoType && (this.player = new er(this.$root.theme, this.$refs.videoMP4)),
                        this.player.init({ autoplay: this.autoplay, hideControls: this.hideControls, url: this.url, mute: this.mute, loop: this.loop, onPlay: this.onPlay, onPause: this.onPause, onEnd: this.onEnd });
                },
                methods: {
                    onPlay() {
                        this.isPlaying = !0;
                    },
                    onPause() {
                        this.isPlaying = !1;
                    },
                    onEnd() {
                        this.isPlaying = !1;
                    },
                    play() {
                        this.player.play();
                    },
                },
            }),
            Kn,
            [
                function () {
                    var e = this.$createElement,
                        t = this._self._c || e;
                    return t("div", { staticClass: "homepage-video-play-button", attrs: { tabindex: "0" } }, [t("div", { staticClass: "homepage-video-play-button-inner" })]);
                },
            ],
            !1,
            null,
            null,
            null
        );
        tr.options.__file = "src/javascripts/components/Video.vue";
        var nr,
            rr,
            ir,
            or,
            ar,
            sr,
            lr,
            cr,
            ur,
            dr,
            pr,
            hr,
            fr,
            mr,
            gr,
            vr,
            yr,
            br,
            wr,
            xr = tr.exports;
        class Er {
            constructor(e, t) {
                (this.showRecoverPasswordForm = () => {
                    this.$recoverPasswordForm.show(), this.$customerLoginForm.hide();
                    var e = new Date(Date.now() + 6e5);
                    localStorage.setItem("resettingPassword", JSON.stringify({ expiry: e.toISOString() }));
                }),
                    (this.hideRecoverPasswordForm = () => {
                        this.$recoverPasswordForm.hide(), this.$customerLoginForm.show();
                    }),
                    (this._isLocalStorageSupported = () => {
                        try {
                            return !("undefined" == typeof Storage || !window.localStorage || !window.sessionStorage);
                        } catch (e) {
                            return !1;
                        }
                    }),
                    (this.theme = e),
                    (this.element = t),
                    (this.$element = i()(t)),
                    (this.$recoverPasswordForm = this.$element.find("#RecoverPasswordForm")),
                    (this.$customerLoginForm = this.$element.find("#CustomerLoginForm")),
                    (this.$recoverPasswordLink = this.$element.find("#RecoverPassword")),
                    (this.$hideRecoverPasswordLink = this.$element.find("#HideRecoverPasswordLink")),
                    (this.hasLocalStorage = this._isLocalStorageSupported()),
                    this.$recoverPasswordLink.on("click", (e) => {
                        e.preventDefault(), this.showRecoverPasswordForm();
                    }),
                    this.$hideRecoverPasswordLink.on("click", (e) => {
                        e.preventDefault(), this.hideRecoverPasswordForm(), this.hasLocalStorage && window.localStorage.removeItem("resettingPassword");
                    }),
                    "#recover" === window.location.hash && this.showRecoverPasswordForm();
                var n = null;
                (this.hasLocalStorage && (n = window.localStorage.getItem("resettingPassword")), n) &&
                    (document.querySelector("#RecoverPasswordForm .errors") ? i()("#ResetSuccess").hide() : (i()("#ResetSuccess").show(), this.hasLocalStorage && window.localStorage.removeItem("resettingPassword")));
            }
        }
        function Cr(e, t, n, r) {
            n && Object.defineProperty(e, t, { enumerable: n.enumerable, configurable: n.configurable, writable: n.writable, value: n.initializer ? n.initializer.call(r) : void 0 });
        }
        function Sr(e, t, n, r, i) {
            var o = {};
            return (
                Object.keys(r).forEach(function (e) {
                    o[e] = r[e];
                }),
                (o.enumerable = !!o.enumerable),
                (o.configurable = !!o.configurable),
                ("value" in o || o.initializer) && (o.writable = !0),
                (o = n
                    .slice()
                    .reverse()
                    .reduce(function (n, r) {
                        return r(e, t, n) || n;
                    }, o)),
                i && void 0 !== o.initializer && ((o.value = o.initializer ? o.initializer.call(i) : void 0), (o.initializer = void 0)),
                void 0 === o.initializer && (Object.defineProperty(e, t, o), (o = null)),
                o
            );
        }
        var Tr =
            ((nr = dt({ template: "#wetheme-right-drawer-template" })),
            (rr = ft({ required: !0 })),
            (ir = ft({ required: !0 })),
            (or = ft({ required: !1 })),
            (ar = ft({ required: !1 })),
            (sr = ft({ required: !1 })),
            (lr = ft({ required: !1 })),
            (cr = ft({ required: !1 })),
            (ur = mt("giftNote")),
            (dr = mt("searchQuery")),
            nr(
                ((hr = class extends s.a {
                    constructor(...e) {
                        super(...e),
                            (this.isOpen = !1),
                            (this.type = "cart"),
                            (this.cart = null),
                            (this.lineQuantityUpdating = null),
                            (this.quickShopProductUrl = null),
                            (this.quickShopContent = ""),
                            (this.searching = !1),
                            (this.searchQuery = ""),
                            (this.searchGroups = []),
                            (this.searchChangeTimer = null),
                            (this.searchSummary = ""),
                            (this.searchHasResults = !1),
                            (this.searchResultsNum = 0),
                            (this.searchTypesNum = 0),
                            (this.giftNote = ""),
                            (this.updatingGiftNote = !1),
                            Cr(this, "searchUrl", fr, this),
                            Cr(this, "loginUrl", mr, this),
                            Cr(this, "isPredictive", gr, this),
                            Cr(this, "searchProducts", vr, this),
                            Cr(this, "searchPages", yr, this),
                            Cr(this, "searchArticles", br, this),
                            Cr(this, "searchCollections", wr, this);
                    }
                    data() {
                        return { isOpen: !1, type: "cart", cart: null, lineQuantityUpdating: null, quickShopProductUrl: null, quickShopContent: "", searchQuery: "", searchResults: [], giftNote: "" };
                    }
                    onGiftNoteChange() {
                        this.giftNoteChangeTimer && window.clearTimeout(this.giftNoteChangeTimer),
                            (this.giftNoteChangeTimer = window.setTimeout(() => {
                                (this.updatingGiftNote = !0), this.updateGiftNote(), (this.giftNoteChangeTimer = null);
                            }, 1e3));
                    }
                    onSearchChange() {
                        this.isSearchPredictive &&
                            (this.searchQuery > ""
                                ? (this.searchChangeTimer && window.clearTimeout(this.searchChangeTimer),
                                  (this.searchChangeTimer = window.setTimeout(() => {
                                      this.performSearch(), (this.searchChangeTimer = null);
                                  }, 250)))
                                : ((this.searchResultsNum = 0), (this.searchHasResults = !1), (this.searchGroups = []), (this.searching = !1), (this.searchSummary = "")));
                    }
                    get theme() {
                        return this.$root.theme;
                    }
                    mounted() {
                        document.documentElement.addEventListener(c, this.handleToggle);
                    }
                    beforeDestroy() {
                        document.documentElement.removeEventListener(c, this.handleToggle);
                    }
                    handleToggle(e) {
                        const { type: t, forceOpen: n, params: r } = e.detail;
                        if (r) {
                            if (r.url) {
                                const e = r.url;
                                this.quickShopProductUrl !== e && (this.fetchProductPage(e), (this.quickShopProductId = e));
                            }
                            r.cart && ((this.cart = r.cart), r.cart.attributes.gift_note && (this.giftNote = r.cart.attributes.gift_note), this.theme.updateCartDrawer(r.cart));
                        }
                        "login" === t && this.fetchLoginPage(), this.toggle(t, n);
                    }
                    close() {
                        document.body.classList.remove("js-drawer-open"), document.body.classList.remove("js-drawer-open-right"), (this.isOpen = !1);
                    }
                    open() {
                        this.setSubtotal(),
                            document.body.classList.add("js-drawer-open"),
                            document.body.classList.add("js-drawer-open-right"),
                            (this.isOpen = !0),
                            "cart" === this.type && null === this.cart
                                ? (this.fetchCart(), this.$nextTick(() => this.$refs.drawerClose.focus()))
                                : "login" === this.type
                                ? this.$nextTick(() => this.$refs.drawerFocus.focus())
                                : "search" === this.type && this.$nextTick(() => this.$refs.searchText.focus());
                    }
                    toggle(e, t = void 0) {
                        !0 === t ? ((this.type = e), this.open()) : !1 === t || this.isOpen ? this.close() : ((this.type = e), this.open());
                    }
                    async fetchCart() {
                        try {
                            const e = await window.fetch("/cart?view=compare");
                            e.ok, console.log(e);
                            const t = await e.text();
                            console.log(t);
                            const n = JSON.parse(t);
                            (this.cart = n), n.attributes.gift_note && (this.giftNote = n.attributes.gift_note), this.theme.updateCartDrawer(n);
                        } catch (e) {
                            console.error("Unable to fetch cart: ", e);
                        }
                    }
                    setSubtotal() {
                        setTimeout(function () {
                            let e,
                                t = document.querySelectorAll(".price-no--discount"),
                                n = document.querySelectorAll(".has--discount"),
                                r = document.querySelectorAll(".line-item__compare-at-price"),
                                i = document.querySelector(".line__compare_price"),
                                o = document.querySelector(".cart__total"),
                                a = parseFloat(o).innerHTML;
                            if (r && n && r.length > 0 && n.length > 0) {
                                let o,
                                    s = 0;
                                for (let e = 0; e < r.length; e++) {
                                    const t = r[e];
                                    (s += parseFloat(t.innerText)), (o = s);
                                }
                                let l,
                                    c = 0;
                                for (let e = 0; e < n.length; e++) {
                                    const t = n[e];
                                    (c += parseFloat(t.innerText)), (l = c);
                                }
                                let u,
                                    d = 0;
                                for (let e = 0; e < t.length; e++) {
                                    const n = t[e];
                                    (d += parseFloat(n.innerText)), (u = d);
                                }
                                (e = u > 0 ? o + u : o), i && (i.innerHTML = this.wetheme.formatMoney(e));
                                let p = document.querySelector(".cart-compare-price--with-value.percentage"),
                                    h = document.querySelector(".cart-compare-price--with-value.value");
                                e > l && (p && (p.innerHTML = " -" + Math.round(((e - a) / e) * 100) + "%"), h && (h.innerHTML = " -" + this.wetheme.formatMoney(e - a)));
                            }
                        }, 1500);
                    }
                    async fetchProductPage(e) {
                        const t = await window.fetch(e),
                            n = new DOMParser().parseFromString(await t.text(), "text/html").querySelector('[data-wetheme-section-type="template--product"]'),
                            r = this.$refs.shopNowContent;
                        r.appendChild(n),
                            new zn(this.theme, r.querySelector('[data-wetheme-section-type="template--product"]'), { slidesPerView: 2 }),
                            setTimeout(() => {
                                window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init();
                            }, 1250);
                    }
                    async fetchLoginPage() {
                        const e = await window.fetch(this.loginUrl),
                            t = new DOMParser().parseFromString(await e.text(), "text/html").querySelector(".main-content");
                        t.querySelector(".login-form-cancel").remove(), t.querySelector(".sitewide--title-wrapper").remove();
                        const n = this.$refs.loginContent;
                        n.appendChild(t), (this.loginPage = new Er(this.theme, n));
                    }
                    numDifference(e, t) {
                        return e > t ? e - t : t - e;
                    }
                    get isGiftwrapEnabled() {
                        return this.theme.giftwrapProduct && this.theme.giftwrapEnabled;
                    }
                    isGiftwrapProduct(e) {
                        return !!this.isGiftwrapEnabled && e.handle == this.theme.giftwrapProduct;
                    }
                    async updateGiftwrap(e, t) {
                        const n = this.cart.items[e - 1];
                        if (!this.isGiftwrapEnabled) return e;
                        if (n.properties && this.theme.translations.giftwrap_label in n.properties) {
                            const r = this.cart.items.map((e) => e.handle).indexOf(this.theme.giftwrapProduct);
                            if (r > -1) {
                                let i = this.numDifference(n.quantity, t),
                                    o = 0;
                                o = t > n.quantity ? this.cart.items[r].quantity + i : 0 == t ? this.cart.items[r].quantity - n.quantity : this.cart.items[r].quantity - i;
                                await window.fetch("/cart/change.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ line: r + 1, quantity: o }) });
                                return 0 == o && e > 1 ? e - 1 : e;
                            }
                            return e;
                        }
                        return e;
                    }
                    async setQuantity(e, t) {
                        this.lineQuantityUpdating = e;
                        try {
                            (e = await this.updateGiftwrap(e, t)), (this.lineQuantityUpdating = e);
                            const n = await window.fetch("/cart/change.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ line: e, quantity: t }) }),
                                r = await n.json();
                            (this.cart = r), (this.lineQuantityUpdating = null);
                        } catch (e) {
                            console.error("Unable to fetch cart: ", e);
                        }
                        this.fetchCart();
                    }
                    onSearchSubmit() {
                        window.location.href = this.searchPageUrlWithQuery;
                    }
                    clearSearchInput() {
                        (this.searchQuery = ""), this.$refs.searchText.focus();
                    }
                    get isSearchPredictive() {
                        return "true" == this.isPredictive;
                    }
                    get searchTypesString() {
                        var e = [];
                        return (
                            "false" != this.searchProducts && e.push("product"),
                            "false" !== this.searchArticles && e.push("article"),
                            "false" !== this.searchPages && e.push("page"),
                            "false" !== this.searchCollections && e.push("collection"),
                            (this.searchTypesNum = e.length),
                            e.join()
                        );
                    }
                    get searchUrlWithQuery() {
                        return this.isSearchPredictive
                            ? `${this.searchUrl}?q=${encodeURIComponent(this.searchQuery)}&resources[type]=${this.searchTypesString}`
                            : `/search?type=${this.searchTypesString}&q=${encodeURIComponent(this.searchQuery)}`;
                    }
                    get searchPageUrlWithQuery() {
                        return `/search?type=${this.searchTypesString}&q=${encodeURIComponent(this.searchQuery)}*`;
                    }
                    async performSearch() {
                        let e;
                        (this.searching = !0), (this.searchHasResults = !1), (this.searchResultsNum = 0), (this.searchSummary = "");
                        try {
                            const t = await fetch(`${this.searchUrlWithQuery}`);
                            t.ok, (e = await t.json());
                        } catch (e) {
                            console.error("Search failed", e), (window.location.href = this.searchPageUrlWithQuery);
                        }
                        const t = new Map();
                        Object.keys(e.resources.results).forEach((n) => {
                            let r = t.get(n),
                                i = e.resources.results[n];
                            r ||
                                ((r = {
                                    name: { articles: this.theme.translations.articles, pages: this.theme.translations.pages, products: this.theme.translations.products, collections: this.theme.translations.collections }[n],
                                    results: [],
                                }),
                                t.set(n, r));
                            let o = i.map((e) => {
                                    var t = Object.assign({}, e);
                                    return t.price && (t.price = this.theme.formatMoney(t.price)), t;
                                }),
                                a = 1;
                            1 == this.searchTypesNum ? (a = 4) : 2 == this.searchTypesNum ? (a = 3) : 3 == this.searchTypesNum && (a = 2),
                                (r.results = o.slice(0, a)),
                                r.results && r.results.length > 0 && ((this.searchResultsNum += i.length), (this.searchHasResults = !0));
                        }),
                            !this.searchHasResults && this.searchQuery > "" && (this.searchSummary = this.theme.translations.no_results_html.replace("{{ terms }}", this.searchQuery)),
                            (this.searching = !1),
                            (this.searchGroups = Array.from(t.values()));
                    }
                    async updateGiftNote() {
                        const e = await window.fetch("/cart/update.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: { gift_note: this.giftNote } }) });
                        e.ok || console.log("Could not update gift note in cart drawer", e), (this.updatingGiftNote = !1);
                    }
                }),
                (fr = Sr(hr.prototype, "searchUrl", [rr], { configurable: !0, enumerable: !0, writable: !0, initializer: null })),
                (mr = Sr(hr.prototype, "loginUrl", [ir], { configurable: !0, enumerable: !0, writable: !0, initializer: null })),
                (gr = Sr(hr.prototype, "isPredictive", [or], { configurable: !0, enumerable: !0, writable: !0, initializer: null })),
                (vr = Sr(hr.prototype, "searchProducts", [ar], { configurable: !0, enumerable: !0, writable: !0, initializer: null })),
                (yr = Sr(hr.prototype, "searchPages", [sr], { configurable: !0, enumerable: !0, writable: !0, initializer: null })),
                (br = Sr(hr.prototype, "searchArticles", [lr], { configurable: !0, enumerable: !0, writable: !0, initializer: null })),
                (wr = Sr(hr.prototype, "searchCollections", [cr], { configurable: !0, enumerable: !0, writable: !0, initializer: null })),
                Sr(hr.prototype, "onGiftNoteChange", [ur], Object.getOwnPropertyDescriptor(hr.prototype, "onGiftNoteChange"), hr.prototype),
                Sr(hr.prototype, "onSearchChange", [dr], Object.getOwnPropertyDescriptor(hr.prototype, "onSearchChange"), hr.prototype),
                (pr = hr))
            ) || pr);
        n(24);
        class kr extends h {
            constructor(e, t) {
                super(e, t),
                    (this.isExpiredOrNotSet = () => {
                        var e = !0;
                        if (!this.hasLocalStorage) return e;
                        var t = window.localStorage.getItem(this.STORAGE_KEY);
                        if (t)
                            try {
                                Date.parse(JSON.parse(t).expiry) > Date.now() && (e = !1);
                            } catch (e) {
                                console.warn("Unable to read popup expiry date", e);
                            }
                        return e;
                    }),
                    (this.setExpiry = (e) => {
                        var t = new Date(Date.now() + 24 * e * 60 * 60 * 1e3);
                        try {
                            this.hasLocalStorage && localStorage.setItem(this.STORAGE_KEY, JSON.stringify({ expiry: t.toISOString() }));
                        } catch (e) {
                            console.warn("Unable to set popup expiry:", e);
                        }
                    }),
                    (this.onWindowResize = ({ width: e }) => {
                        var t = i.a.fancybox.isOpen;
                        e < 769
                            ? t && (i.a.fancybox.close(), this.showSlideUp())
                            : (this.element.classList.contains("visible") && this.isFullscreen && (this.element.classList.remove("visible"), this.showFullscreen()), t && i.a.fancybox.reposition());
                    }),
                    (this.show = () => {
                        this.theme.getWindowWidth() < 769 ? (i.a.fancybox.close(), this.showSlideUp()) : this.isFullscreen ? (this.element.classList.remove("visible"), this.showFullscreen()) : this.showSlideUp();
                    }),
                    (this.showSlideUp = () => {
                        document.querySelector("#slide-up").removeAttribute("style"), document.querySelector("#popup").classList.add("slide-up"), document.querySelector("#popup").classList.add("visible");
                    }),
                    (this.showFullscreen = () => {
                        document.querySelector("#popup").classList.add("fullscreen"),
                            document.querySelector("#fullscreen").removeAttribute("style"),
                            i.a.fancybox({
                                autoScale: !0,
                                transitionIn: "elastic",
                                transitionOut: "elastic",
                                speedIn: 500,
                                speedOut: 300,
                                autoDimensions: !0,
                                centerOnScroll: !0,
                                href: "#popup #fullscreen",
                                wrapCSS: "fullscreen-popup-fancybox",
                                tpl: { closeBtn: '<div class="popup--close fancybox-close" tabindex="0"></div>' },
                            });
                    }),
                    (this._isLocalStorageSupported = () => {
                        try {
                            return !("undefined" == typeof Storage || !window.localStorage || !window.sessionStorage);
                        } catch (e) {
                            return !1;
                        }
                    }),
                    (this.STORAGE_KEY = "wetheme-popup"),
                    (this.isFullscreen = "fullscreen" === this.element.dataset.desktopType),
                    (this.popupSkipDays = parseInt(this.element.dataset.popupTime, 10)),
                    (this.popupDelay = parseInt(this.element.dataset.popupDelay, 10)),
                    (this.testMode = "true" === this.element.dataset.popupTestMode),
                    (this.hasLocalStorage = this._isLocalStorageSupported()),
                    this.testMode
                        ? this.show()
                        : this.isExpiredOrNotSet() &&
                          setTimeout(() => {
                              this.setExpiry(this.popupSkipDays), this.show();
                          }, 1e3 * this.popupDelay),
                    this.element.querySelector(".popup--close-btn").addEventListener("click", () => {
                        this.element.classList.remove("visible");
                    });
            }
        }
        class Ar extends h {
            constructor(e, t) {
                super(e, t),
                    (this.load = () => {
                        this.ageTestMode && this.showModal(),
                            this.modalLinks && this.modalLinks.setAttribute("tabindex", "1"),
                            this.readCookie("isAnAdult") || this.showModal(),
                            this.enterButton && this.enterButton.addEventListener("click", this.writeCookie),
                            this.exitButton && this.exitButton.addEventListener("click", this.comeBackModal),
                            this.returnButton && this.returnButton.addEventListener("click", this.confirmAgeModal),
                            this.closeButton && this.closeButton.addEventListener("click", this.confirmAgeModal);
                    }),
                    (this.writeCookie = () => {
                        (document.cookie = "isAnAdult=true; expires=0; path=/"), this.hideModal();
                    }),
                    (this.getModalContent = () => {
                        (this.changeContent = document.querySelector(".modal-deny-content")), (this.hideInitial = document.querySelector(".modal-initial-content"));
                    }),
                    (this.trapFocus = () => {
                        setTimeout(() => {
                            if (document.querySelector(".verification-popup-container")) {
                                var e = i()(".verification-popup-container").find("button, a").filter(":visible"),
                                    t = e.first(),
                                    n = e.last();
                                i()(".verification-popup-container").focus(),
                                    n.on("keydown", function (e) {
                                        9 !== e.which || e.shiftKey || (e.preventDefault(), t.focus());
                                    }),
                                    t.on("keydown", function (e) {
                                        9 === e.which && e.shiftKey && (e.preventDefault(), n.focus());
                                    });
                            }
                        }, 250);
                    }),
                    (this.readCookie = (e) => {
                        for (var t = e + "=", n = document.cookie.split(";"), r = 0; r < n.length; r++) {
                            for (var i = n[r]; " " == i.charAt(0); ) i = i.substring(1, i.length);
                            if (0 == i.indexOf(t)) return i.substring(t.length, i.length);
                        }
                        return null;
                    }),
                    (this.showModal = () => {
                        i()(".verification-popup-container").css("display", "block"), this.trapFocus(), Rt(document.querySelector(".verification-popup-container"));
                    }),
                    (this.hideModal = () => {
                        Ft(document.querySelector(".verification-popup-container")), i()(".verification-popup-container").css("display", "none");
                    }),
                    (this.confirmAgeModal = () => {
                        i()("#verification__prompt").scrollTop(0),
                            i()(".verification-popup__close-button").css("display", "none"),
                            this.getModalContent(),
                            this.changeContent.classList.add("hidden"),
                            this.hideInitial.classList.remove("hidden"),
                            this.trapFocus();
                    }),
                    (this.comeBackModal = () => {
                        i()("#verification__prompt").scrollTop(0),
                            i()(".verification-popup__close-button").css("display", "flex"),
                            this.getModalContent(),
                            this.changeContent.classList.remove("hidden"),
                            this.hideInitial.classList.add("hidden"),
                            this.trapFocus();
                    }),
                    (this.ageSkipDays = parseInt(this.element.dataset.ageTime, 10)),
                    (this.ageDelay = 0),
                    (this.ageTestMode = "true" === this.element.dataset.ageTestMode),
                    (this.enterButton = t.querySelector("#button__enter")),
                    (this.exitButton = t.querySelector("#button__exit")),
                    (this.returnButton = t.querySelector("#button__return")),
                    (this.closeButton = t.querySelector(".verification-popup__close-button")),
                    (this.modalLinks = t.querySelector(".modal-content__wrapper a")),
                    this.load();
            }
        }
        function _r(e, t) {
            let n = !0,
                r = !1;
            return (...i) => {
                const o = () => {
                    r ? (e.apply(this, i), setTimeout(o, t)) : (n = !0), (r = !1);
                };
                n ? ((n = !1), e.apply(this, i), setTimeout(o, t)) : (r = !0);
            };
        }
        class Lr extends h {
            constructor(e, t) {
                super(e, t),
                    (this.add = (e, t) => {
                        this.roots.push(e), this.load(e, t);
                    }),
                    (this.onWindowResize = () => {
                        const e = i()(this.roots).find(".grid-view-item .grid-view-item-image"),
                            t = e.find(".badge");
                        t.css("opacity", 0), this.calculateBadgePositions(e), t.css("opacity", 1);
                    }),
                    (this.load = (e, t = void 0) => {
                        const n = this;
                        void 0 === t && (t = 0);
                        const r = i()(e).find(".grid-view-item .grid-view-item-image");
                        this.calculateBadgePositions(r),
                            t > 0 &&
                                setTimeout(() => {
                                    this.calculateBadgePositions(r);
                                }, t),
                            r.find(".hidden").length > 0 &&
                                this.theme.getWindowWidth() >= l.md.min &&
                                r.each((e, t) => {
                                    v()(
                                        t,
                                        function () {
                                            if (!i()(this).parent(".grid-view-item").hasClass("hovering")) {
                                                var e = i()(this);
                                                e.parent(".grid-view-item").addClass("hovering"),
                                                    e.find(".hidden").fadeTo(200, 1, function () {
                                                        n.calculateHoverBadgePositions(i()(e));
                                                    });
                                            }
                                        },
                                        function () {
                                            var e = i()(this);
                                            i()(this)
                                                .find(".hidden")
                                                .fadeTo(200, 0, function () {
                                                    n.calculateBadgePositions(r);
                                                }),
                                                e.parent(".grid-view-item").removeClass("hovering");
                                        }
                                    ).options({ sensitivity: 10, interval: 25 });
                                });
                    }),
                    (this.calculateHoverBadgePositions = (e) => {
                        e.find(".reveal .hidden").length && (e.find(".reveal .hidden").css("z-index", 4), this.placeBadge(e, !0));
                    }),
                    (this.calculateBadgePositions = (e) => {
                        e.each((e, t) => {
                            this.placeBadge(i()(t)), i()(t).find("*").stop(!0, !0);
                        });
                    }),
                    (this.placeBadge = (e, t) => {
                        void 0 === t && (t = !1);
                        var n = e.parent().find(".badge");
                        if (n.length)
                            if (i()("body").hasClass("images-aspect-ratio")) n.css("top", "0"), n.css("left", "0");
                            else {
                                var r,
                                    o = e.width(),
                                    a = e.height();
                                r = !0 === t ? e.find(".hidden img") : e.find("img");
                                var s = this.getContainedSize(r.get(0)),
                                    l = (o - Math.round(s[0])) / 2,
                                    c = (a - Math.round(s[1])) / 2;
                                l < 1 && (l = 0), c < 1 && (c = 0), n.css("top", c + "px"), n.css("left", l + "px");
                            }
                    }),
                    (this.getContainedSize = (e) => {
                        var t = e.naturalWidth / e.naturalHeight,
                            n = e.height * t,
                            r = e.height;
                        return n > e.width && ((n = e.width), (r = e.width / t)), [n, r];
                    }),
                    (this.roots = []);
            }
        }
        class $r extends f {
            constructor(e, t, n) {
                if (
                    (super(e, t, n),
                    (this.RECENTLY_VIEWED_COUNT = 10),
                    (this.RECENTLY_VIEWED_LOCAL_STORAGE_KEY = "recentlyVisited"),
                    (this.PLACEHOLDER = "PLACEHOLDER"),
                    (this.loadProducts = (e) => {
                        var t = e.map(
                            function (e) {
                                return i.a.get(this.productUrl.replace(this.PLACEHOLDER, e.handle));
                            }.bind(this)
                        );
                        i.a.when.apply(i.a, t).then(() => {
                            let e = !0;
                            t.forEach((t) => {
                                if (200 === t.status) {
                                    var n = document.createElement("div");
                                    (n.innerHTML = t.responseText),
                                        this.$content.append(n.querySelector(".main-content .grid__item").outerHTML),
                                        this.$content.find(".grid__item").addClass("large--one-quarter medium--one-third small--one-half ");
                                } else console.warn("Unable to fetch recently visited product: ", t.status, t.responseText), (e = !1);
                            }),
                                e ? this.show() : this.hideButtons();
                        });
                    }),
                    (this.hideButtons = () => {
                        this.$element.find(".swiper-button--next").hide(), this.$element.find(".swiper-button--prev").hide();
                    }),
                    (this.show = () => {
                        const e = this.element.querySelector(".swiper-button--next"),
                            t = this.element.querySelector(".swiper-button--prev");
                        this.$element.fadeIn(),
                            (this.swiper = new Pe(this.element.querySelector(".swiper-container"), { slidesPerView: 2, navigation: { nextEl: e, prevEl: t }, breakpoints: { 600: { slidesPerView: 4 } }, watchOverflow: !0, autoHeight: !0 })),
                            this.loadShopNow(),
                            this.loadReviews(),
                            (this.badge = this.theme.addBadges(this.element, 1e3));
                    }),
                    (this.loadShopNow = () => {
                        "true" === this.element.dataset.quickShop &&
                            Array.prototype.forEach.call(this.element.querySelectorAll(".grid-view-item"), (e) => {
                                const t = e.querySelector(".product-grid--title"),
                                    n = e.querySelector(".grid-view-item-image"),
                                    r = e.querySelector(".grid-view-item--desc-wrapper"),
                                    i = document.createElement("a");
                                i.classList.add("shop-now-button"), (i.href = t.querySelector("a").href), (i.textContent = this.theme.translations.quick_shop), i.addEventListener("click", this.handleShopNow);
                                const o = document.createElement("div");
                                o.appendChild(i), o.classList.add("shop-now-wrapper");
                                const a = o,
                                    s = o.cloneNode(!0);
                                a.classList.add("shop-now-wrapper--desktop"), s.classList.add("shop-now-wrapper--mobile"), n.appendChild(a), r.parentNode.insertBefore(s, r.nextSibling);
                            }),
                            "true" === this.element.dataset.quickAdd &&
                                Array.prototype.forEach.call(this.element.querySelectorAll(".grid-view-item"), (e) => {
                                    const t = Number(e.dataset.productId),
                                        n = "true" == e.dataset.productAvailable,
                                        r = Number(e.dataset.productVariantsSize),
                                        i = e.querySelector(".product-grid--title"),
                                        o = e.querySelector(".grid-view-item--desc-wrapper"),
                                        a = document.createElement("a"),
                                        s = document.createElement("div");
                                    if ((s.classList.add("quick-add-wrapper"), 1 == r && s.classList.add("is-singular"), r > 1 && n))
                                        a.classList.add("quick-add-button-variants"),
                                            (a.tabIndex = 0),
                                            (a.href = i.querySelector("a").href),
                                            (a.textContent = this.theme.translations.view_options),
                                            a.addEventListener("click", this.handleShopNow),
                                            s.appendChild(a);
                                    else if (n) {
                                        const e = document.createElement("form");
                                        (e.method = "post"), (e.action = "/cart/add"), (e.id = "CollectionAddToCartForm"), (e.acceptCharset = "UTF-8"), e.classList.add("shopify-product-form"), (e.enctype = "multipart/form-data");
                                        const n = document.createElement("input");
                                        (n.type = "hidden"), (n.name = "form_type"), (n.value = "product"), e.appendChild(n);
                                        const r = document.createElement("input");
                                        (r.type = "hidden"), (r.name = "utf8"), (r.value = "✓"), e.appendChild(r);
                                        const i = document.createElement("input");
                                        (i.type = "hidden"), (i.name = "id"), (i.value = t.toString()), e.appendChild(i);
                                        const o = document.createElement("button");
                                        o.classList.add("quick-add-button"), (o.type = "submit"), (o.tabIndex = 0), (o.textContent = this.theme.translations.addToCart), e.appendChild(o), s.appendChild(e);
                                    } else a.classList.add("sold-out-button"), (a.href = i.querySelector("a").href), (a.textContent = this.theme.translations.soldOut), s.appendChild(a);
                                    o.parentNode.insertBefore(s, o.nextSibling);
                                });
                    }),
                    (this.handleShopNow = (e) => {
                        e.preventDefault(), this.theme.toggleRightDrawer("shop-now", !0, { url: e.target.href });
                    }),
                    (this.loadReviews = () => {
                        "true" === this.element.dataset.showReviews &&
                            (Array.prototype.forEach.call(this.element.querySelectorAll(".product-grid--price a"), (e) => {
                                const t = document.createElement("span");
                                t.classList.add("shopify-product-reviews-badge"), (t.dataset.id = e.dataset.productId), e.appendChild(t);
                            }),
                            this.theme.loadReviews({ badges: !0 }));
                    }),
                    (this._isLocalStorageSupported = () => {
                        try {
                            return !("undefined" == typeof Storage || !window.localStorage || !window.sessionStorage);
                        } catch (e) {
                            return !1;
                        }
                    }),
                    (this.$element = i()(t)),
                    (this.handle = this.element.dataset.productHandle),
                    (this.productUrl = this.element.dataset.productUrl),
                    (this.$content = this.$element.find("#recently-viewed-products")),
                    !this.$content.hasClass("recently-viewed-loading"))
                ) {
                    this.$content.empty().addClass("recently-viewed-loading");
                    var r = null;
                    this._isLocalStorageSupported() && (r = localStorage.getItem(this.RECENTLY_VIEWED_LOCAL_STORAGE_KEY));
                    var o = null != r ? JSON.parse(r) : [];
                    if (this.handle) {
                        var a = { handle: this.handle };
                        o.unshift(a);
                    }
                    var s = o.length
                        ? (function (e) {
                              for (var t = new Array(), n = new Array(), r = 0; r < e.length; r++) {
                                  var i = e[r].handle;
                                  -1 === n.indexOf(i) && (t.push(e[r]), n.push(i));
                              }
                              return t;
                          })(o)
                        : o;
                    s.length > this.RECENTLY_VIEWED_COUNT && (s = s.slice(0, this.RECENTLY_VIEWED_COUNT)),
                        this._isLocalStorageSupported() && localStorage.setItem(this.RECENTLY_VIEWED_LOCAL_STORAGE_KEY, JSON.stringify(s)),
                        s.length > 1 || (1 === s.length && s[0].handle !== this.handle) ? this.loadProducts(s.filter((e) => e.handle !== this.handle)) : this.$element.remove();
                    var l = this;
                    window.addEventListener("load", (n) => {
                        (this.quickAddButtons = new Be(e, t)),
                            setTimeout(() => {
                                l.swiper && l.swiper.resize.resizeHandler();
                            }, 1e3);
                    });
                }
            }
        }
        class Dr extends f {
            constructor(e, t, n) {
                super(e, t, n),
                    (this.removeAsterisks = () => {
                        var e = document.querySelector(".page--title");
                        e.textContent = e.textContent.replace("*", "");
                        var t = document.querySelector(".search-bar .input-group-field");
                        t.value = t.value.replace("*", "");
                        var n = document.querySelector("nav.breadcrumb span:last-child");
                        n.textContent = n.textContent.replace("*", "");
                    }),
                    (this.onSearchChange = (e) => {
                        this.searchInput.value.length > 0 ? (this.searchClear.style.opacity = "1") : (this.searchClear.style.opacity = "0");
                    }),
                    (this.clearSearch = (e) => {
                        this.searchInput && ((this.searchInput.value = ""), this.onSearchChange(), this.searchInput.focus());
                    }),
                    (this.tabClearSearch = (e) => {
                        13 === e.keyCode && (e.preventDefault(), (this.searchInput.value = ""), this.onSearchChange(), this.searchInput.focus());
                    }),
                    this.removeAsterisks(),
                    this.clearSearch(),
                    (this.searchInput = t.querySelector('input[type="search"]')),
                    this.searchInput.addEventListener("input", this.onSearchChange),
                    (this.searchClear = t.querySelector(".search-drawer--clear")),
                    this.searchClear.addEventListener("click", this.clearSearch),
                    this.searchClear.addEventListener("keydown", this.tabClearSearch);
            }
        }
        (window.wetheme = new (class extends p {
            constructor() {
                super(),
                    (this.THROTTLE_INTERVAL = 400),
                    (this.SECTIONS = {
                        header: w,
                        footer: x,
                        "announcement-bar": E,
                        "advanced-layout--custom-html": C,
                        "advanced-layout--hero": A,
                        "blog--blog-posts": Ie,
                        "collection--collection-list": Fe,
                        "collection--featured-collection": je,
                        "collection--products-block": We,
                        "footer--newsletter": Ue,
                        "image--gallery": Ge,
                        "image--image-with-text-overlay": Ke,
                        "image--image-with-text": Ye,
                        "image--logo-list": Je,
                        "image--slideshow": Qe,
                        "newsletter--newsletter": et,
                        password: tt,
                        "products--featured-product": zn,
                        "store-information--map": Rn,
                        "template--blog": Un,
                        "template--cart": Xn,
                        "template--collection": Bn,
                        "template--collections-list": jn,
                        "template--page-contact": Rn,
                        "template--product": Nn,
                        "template--product--recommendations": Hn,
                        "template--product--recently-viewed": $r,
                        "template--search": Dr,
                        "text--rich-text": Vn,
                        "text--testimonials": Wn,
                        "text--text-adverts": Gn,
                        "video--video-hero": Yn,
                        "video--video": f,
                    }),
                    (this.VUE_COMPONENTS = { "wetheme-dropdown": An, "wetheme-video": xr }),
                    (this.loadFadeAnimation = () => {
                        document.body.classList.add("loaded"),
                            (-1 != navigator.userAgent.indexOf("Safari") && -1 == navigator.userAgent.indexOf("Chrome")) ||
                                window.addEventListener("beforeunload", function () {
                                    document.body.classList.add("unloading");
                                });
                    }),
                    (this.loadGlobal = () => {
                        const e = document.querySelector("#wetheme-global");
                        if (!e) return void console.warn("Script #wetheme-global with global definitions not found");
                        let t;
                        try {
                            t = JSON.parse(e.textContent);
                        } catch (e) {
                            return void console.warn("Invalid syntax in #wetheme-global", e);
                        }
                        (this.translations = t.translations),
                            (this.moneyFormat = t.moneyFormat),
                            (this.giftwrapProduct = t.giftwrapProduct),
                            (this.giftwrapEnabled = t.giftwrapEnabled),
                            s.a.directive("money", {
                                bind: (e, t) => {
                                    e.innerHTML = this.formatMoney(t.value);
                                },
                                update: (e, t) => {
                                    t.oldValue !== t.value && (e.innerHTML = this.formatMoney(t.value));
                                },
                            }),
                            s.a.directive("responsive", {
                                bind: (e, t) => {
                                    const n = t.value.replace(/(\.[^.]*)$/, "_300x$1").replace("http:", ""),
                                        r = t.value.replace(/(\.[^.]*)$/, "_{width}$1").replace("http:", "");
                                    e.setAttribute("src", n), e.setAttribute("data-src", r), e.setAttribute("data-sizes", "auto"), e.classList.add("lazyload");
                                },
                            });
                    }),
                    (this.loadVueComponents = (e) => {
                        Object.entries(this.VUE_COMPONENTS).forEach(([t, n]) => {
                            this.loadVueComponent(e, t, n);
                        });
                    }),
                    (this.loadVueComponent = (e, t, n) => {
                        Array.prototype.forEach.call(e.querySelectorAll(t), (e) => {
                            const r = new s.a({ el: e.parentNode, components: { [t]: n }, data: () => ({ theme: this }) });
                            this.vueComponents.push(r);
                        });
                    }),
                    (this.loadSection = (e, t, n) => {
                        const r = new t(this, e, n);
                        this.sectionById.set(e.dataset.wethemeSectionId, r);
                        const i = e.dataset.wethemeSectionType;
                        let o = this.sectionsByType.get(i);
                        o || ((o = []), this.sectionsByType.set(i, o)), o.push(r), this.loadVueComponents(e);
                    }),
                    (this.loadSectionsByType = (e, t, n) => {
                        const r = `[data-wetheme-section-type="${e}"]`;
                        Array.prototype.forEach.call(document.querySelectorAll(r), (r) => {
                            try {
                                this.loadSection(r, t, n);
                            } catch (t) {
                                console.error(`Unable to load section ${e} on element`, r, t);
                            }
                        });
                    }),
                    (this.onLoadAll = () => {
                        this.load(),
                            Object.entries(this.SECTIONS).forEach(([e, t]) => {
                                this.loadSectionsByType(e, t, !0);
                            }),
                            this.showOnScroll();
                    }),
                    (this.onSectionLoad = (e) => {
                        const { sectionId: t } = e.detail,
                            n = `[data-wetheme-section-id="${t}"]`,
                            r = document.querySelector(n);
                        if (!r) return void console.warn(`Element with ${n} not found, section won't be loaded`);
                        const i = r.dataset.wethemeSectionType,
                            o = this.SECTIONS[i];
                        if (!o) return void console.warn(`Cannot find class with type "${i}"`);
                        let a = document.querySelectorAll(".show-on-scroll");
                        a.length > 0 && a[0].classList.remove("show-on-scroll"), this.loadSection(r, o, !1), this.showOnScroll();
                    }),
                    (this.onSectionUnload = (e) => {
                        const t = e.target,
                            { sectionId: n } = e.detail,
                            r = this.sectionById.get(n);
                        r ? r.destroy({ element: t }) : console.warn(`No section with id ${n}, nothing will be unloaded`);
                    }),
                    (this.onSectionSelect = (e) => {
                        const t = e.target,
                            { sectionId: n, load: r } = e.detail,
                            i = this.sectionById.get(n);
                        i ? i.onSectionSelect({ element: t, sectionId: n, load: r }) : console.warn(`No section with id ${n}, nothing will be selected`);
                    }),
                    (this.onSectionDeselect = (e) => {
                        const t = e.target,
                            { sectionId: n } = e.detail,
                            r = this.sectionById.get(n);
                        r ? r.onSectionDeselect({ element: t, sectionId: n }) : console.warn(`No section with id ${n}, nothing will be deselected`);
                    }),
                    (this.onSectionReorder = (e) => {
                        const t = e.target,
                            { sectionId: n } = e.detail,
                            r = this.sectionById.get(n);
                        r ? r.onSectionReorder({ element: t, sectionId: n }) : console.warn(`No section with id ${n}, nothing will be done on reorder`);
                    }),
                    (this.onBlockSelect = (e) => {
                        const t = e.target,
                            { sectionId: n, blockId: r, load: i } = e.detail,
                            o = this.sectionById.get(n);
                        o ? o.onBlockSelect({ element: t, sectionId: n, blockId: r, load: i }) : console.warn(`No section with id ${n}, block select will do nothing`);
                    }),
                    (this.onBlockDeselect = (e) => {
                        const t = e.target,
                            { sectionId: n, blockId: r } = e.detail,
                            i = this.sectionById.get(n);
                        i ? i.onBlockDeselect({ element: t, sectionId: n, blockId: r }) : console.warn(`No section with id ${n}, block deselect will do nothing`);
                    }),
                    (this.onRawResize = (e) => {
                        const t = this.getWindowWidth();
                        this.registeredComponents.forEach((e) => e.onWindowResizeRaw({ width: t })), this.onResize();
                    }),
                    (this.onResize = _r(() => {
                        const e = this.getWindowWidth(),
                            t = this.previousWidth,
                            n = this.getBreakpoint(e);
                        this.registeredComponents.forEach((r) => {
                            r.onWindowResize({ width: e, oldWidth: t, breakpoint: n }), n !== this.breakpoint && r.onWindowResizeBreakpoint({ breakpoint: n, oldBreakpoint: this.breakpoint, width: e });
                        }),
                            (this.previousWidth = e),
                            (this.breakpoint = n);
                    }, this.THROTTLE_INTERVAL)),
                    (this.onRawScroll = (e) => {
                        this.onScroll(e);
                    }),
                    (this.onScroll = _r((e) => {
                        this.showOnScroll(),
                            this.registeredComponents.forEach((e) => {
                                e.onWindowScroll();
                            });
                    }, this.THROTTLE_INTERVAL)),
                    (this.showOnScroll = () => {
                        const e = i()(window).height();
                        i()(".show-on-scroll").each(function (t, n) {
                            var r = n.getBoundingClientRect();
                            r.bottom >= 0 && r.top < e && i()(n).removeClass("show-on-scroll").addClass("shown-on-scroll animated fadeInUp");
                        });
                    }),
                    (this.onKeyUp = (e) => {
                        27 == e.keyCode && this.closeDrawers();
                    }),
                    (this.loadYoutubeApi = () =>
                        new Promise((e, t) => {
                            window.YT
                                ? e(window.YT)
                                : document.querySelector("#youtube_api")
                                ? this.youtubeLoadedCallbacks.push({ resolve: e, reject: t })
                                : (this.youtubeLoadedCallbacks.push({ resolve: e, reject: t }), this.createScript("youtube_api", "https://www.youtube.com/player_api", !0));
                        })),
                    (this.onYoutubeLoaded = () => {
                        this.youtubeLoadedCallbacks.forEach(({ resolve: e }) => {
                            e(window.YT);
                        }),
                            this.youtubeLoadedCallbacks.splice(0);
                    }),
                    (this.loadVimeoApi = () =>
                        new Promise((e, t) => {
                            if (window.Vimeo) e(window.Vimeo);
                            else if (document.querySelector("#vimeo_api")) this.vimeoLoadedCallbacks.push({ resolve: e, reject: t });
                            else {
                                this.createScript("vimeo_api", "https://player.vimeo.com/api/player.js").onload = () => {
                                    e(window.Vimeo), this.onVimeoLoaded();
                                };
                            }
                        })),
                    (this.onVimeoLoaded = () => {
                        this.vimeoLoadedCallbacks.forEach(({ resolve: e }) => {
                            e(window.Vimeo);
                        }),
                            this.vimeoLoadedCallbacks.splice(0);
                    }),
                    (this.loadGoogleMapApi = (e) =>
                        new Promise((t, n) => {
                            if (window.google && window.google.maps && window.google.maps.Geocoder && window.google.maps.Map) t(window.google.maps);
                            else if (document.querySelector("#google_maps_api")) this.mapsLoadedCallbacks.push({ resolve: t, reject: n });
                            else {
                                const r = () => {
                                    const t = `https://maps.googleapis.com/maps/api/js?key=${e}&callback=onGoogleMapsAPIReady`;
                                    this.createScript("google_maps_api", t, !0);
                                };
                                this.mapsLoadedCallbacks.push({ resolve: t, reject: n });
                                let i = 6;
                                const o = () => {
                                    const e = document.querySelector('[data-shopify="dynamic-checkout-cart"]');
                                    i > 0 && e && 0 === e.children.length ? ((i -= 1), setTimeout(o, 500)) : r();
                                };
                                o();
                            }
                        })),
                    (this.onGoogleMapsLoaded = () => {
                        this.mapsLoadedCallbacks.forEach(({ resolve: e }) => {
                            e(window.google.maps);
                        }),
                            this.mapsLoadedCallbacks.splice(0);
                    }),
                    (this.onGoogleAuthFailure = (e) => {
                        this.mapsLoadedCallbacks.forEach(({ reject: t }) => {
                            t(e);
                        }),
                            this.mapsLoadedCallbacks.splice(0);
                        const t = new CustomEvent("google-maps-auth-failure", { detail: { reason: e } });
                        document.body.dispatchEvent(t);
                    }),
                    (this._loadCartKey = () => "f1957945-9048-438b-bd2c-0ed182340c65"),
                    (this.toggleRightDrawer = (e = "cart", t = void 0, n = {}) => {
                        const r = new CustomEvent(c, { detail: { type: e, forceOpen: t, params: n } });
                        document.documentElement.dispatchEvent(r);
                    }),
                    (this.toggleLeftDrawer = (e = void 0) => {
                        const t = new CustomEvent(u, { detail: { forceOpen: e } });
                        document.documentElement.dispatchEvent(t);
                    }),
                    (this.updateCartDrawer = (e) => {
                        const t = new CustomEvent(d, { detail: { cart: e } });
                        document.documentElement.dispatchEvent(t);
                    }),
                    (this.createScript = (e, t, n = !1) => {
                        const r = document.createElement("script");
                        (r.id = e), (r.src = t), n && ((r.defer = !0), (r.async = !0));
                        const i = document.getElementsByTagName("script")[0];
                        return i.parentNode.insertBefore(r, i), r;
                    }),
                    (this.registerComponent = (e) => {
                        this.registeredComponents.push(e);
                    }),
                    (this.makeVideoEmbedsResponsive = () => {
                        i()(".template-page iframe, .template-blog iframe, .template-article iframe").each(function (e, t) {
                            var n = i()(t).attr("src");
                            if (n.indexOf("youtube.com") >= 0 || n.indexOf("vimeo.com") >= 0 || n.indexOf("dailymotion.com") >= 0) {
                                var r = document.createElement("div");
                                i()(r).addClass("embed-container");
                                var o = i()(t).clone();
                                i()(r).append(o), i()(t).replaceWith(r);
                            }
                        });
                    }),
                    (this.closeDrawers = (e) => {
                        this.toggleLeftDrawer(!1), this.toggleRightDrawer("cart", !1);
                    }),
                    (this.addBadges = (e, t) => {
                        this.badge.add(e, t);
                    }),
                    (this.loadReviews = ({ products: e, badges: t }) => {
                        window.SPR
                            ? (window.SPR.$ || (window.SPR.$ = i.a), window.SPR.initDomEls(), e && window.SPR.loadProducts(), t && window.SPR.loadBadges())
                            : this._spr_remaining_attemtps >= 0 && ((this._spr_remaining_attemtps -= 1), setTimeout(this.loadReviews, 500, { products: e, badges: t }));
                    }),
                    (this.name = "Flow"),
                    (this.$ = i.a),
                    (this.sectionById = new Map()),
                    (this.sectionsByType = new Map()),
                    (this.registeredComponents = []),
                    (this.vueComponents = []),
                    (this.youtubeLoadedCallbacks = []),
                    (this.vimeoLoadedCallbacks = []),
                    (this.mapsLoadedCallbacks = []),
                    (this.resizeDebounceTimer = null),
                    document.addEventListener("shopify:section:load", this.onSectionLoad),
                    document.addEventListener("shopify:section:unload", this.onSectionUnload),
                    document.addEventListener("shopify:section:select", this.onSectionSelect),
                    document.addEventListener("shopify:section:deselect", this.onSectionDeselect),
                    document.addEventListener("shopify:section:reorder", this.onSectionReorder),
                    document.addEventListener("shopify:block:select", this.onBlockSelect),
                    document.addEventListener("shopify:block:deselect", this.onBlockDeselect),
                    document.addEventListener("DOMContentLoaded", this.onLoadAll),
                    document.addEventListener("keyup", this.onKeyUp),
                    window.addEventListener("resize", this.onRawResize),
                    window.addEventListener("scroll", this.onRawScroll),
                    (this.drawerOverlay = document.querySelector("#DrawerOverlay")),
                    this.drawerOverlay && document.querySelector("#DrawerOverlay").addEventListener("click", this.closeDrawers),
                    (this._spr_remaining_attemtps = 10);
            }
            load() {
                this.loadGlobal(), (this.breakpoint = this.getBreakpoint()), (this.wow = new a.a().init()), document.body.classList.contains("password-page"), (this.popup = null);
                const e = document.querySelector("#popup");
                e && "/challenge" !== window.location.pathname && (this.popup = new kr(this, e)), (this.verificationPopup = null);
                const t = document.querySelector(".verification-popup-container");
                t && "/challenge" !== window.location.pathname && (this.verificationPopup = new Ar(this, t)), document.body.classList.contains("template-customers-login") && (this.login = new Er(this, document.body));
                let n = document.querySelectorAll(".show-on-scroll");
                n.length > 0 && n[0].classList.remove("show-on-scroll"), this.loadFadeAnimation(), this.loadVueComponent(document.body, "wetheme-right-drawer", Tr), (this.badge = new Lr(this, document.body));
            }
        })()),
            (window.onYouTubePlayerAPIReady = () => {
                window.wetheme.onYoutubeLoaded();
            }),
            (window.onGoogleMapsAPIReady = () => {
                window.wetheme.onGoogleMapsLoaded();
            }),
            (window.gm_authFailure = function () {
                window.wetheme.onGoogleAuthFailure("Google Maps authentication error, API key might be invalid");
            });
    },
]),
    $(".slider_text_enable").slick({ dots: !1, infinite: !0, slidesToShow: 1, slidesToScroll: 1, speed: 1e4, autoplay: !0, autoplaySpeed: 0, centerMode: !0, cssEase: "linear" }),
    $(document).ready(function () {
        var e = $(document).find('.selector-wrapper .wetheme-dropdown label[for="SingleOptionSelector-0"]').text();
        $(document).on("click", ".shop-now-button", function () {
            setTimeout(function () {
                "Title" != e && $(".paymentButtonsWrapper .add-to-cart--secondary").addClass("error");
                var t = $(".selector-wrapper.js .wetheme-dropdown__wrapper ul li.selected").attr("value");
                $(".wetheme-dropdown__wrapper button .header--supporting-text").attr("value", t),
                    $(document).on("click", ".wetheme-dropdown__wrapper ul li", function () {
                        var e = $(this).attr("value");
                        $(this).closest(".wetheme-dropdown").find(".wetheme-dropdown__wrapper button .header--supporting-text").attr("value", e);
                    }),
                    $(document).on("click", ".paymentButtonsWrapper .add-to-cart--secondary.btn-error", function (e) {
                        e.preventDefault(),
                            $(".wetheme-dropdown__wrapper button .header--supporting-text").each(function () {
                                $(this).attr("value") == $(this).text().trim() ? $(this).parent().removeClass("error") : $(this).parent().addClass("error");
                            });
                    }),
                    $(document).on("click", ".wetheme-dropdown__wrapper ul li", function () {
                        var e = 0;
                        $(".wetheme-dropdown__wrapper button .header--supporting-text")
                            .each(function () {
                                $(this).attr("value") == $(this).text().trim() ? $(this).parent().removeClass("error") : ($(this).parent().addClass("error"), (e += 1));
                            })
                            .promise()
                            .done(function (t) {
                                "5" == e ? $(document).find(".paymentButtonsWrapper .add-to-cart--secondary").removeClass("btn-error") : $(document).find(".paymentButtonsWrapper .add-to-cart--secondary").addClass("btn-error");
                            });
                    }),
                    $(".Accordion_item summary.title_tab").first().addClass("active"),
                    $(".drawer .Accordion_item summary.title_tab").on("click", function () {
                        $(this).toggleClass("active"), $(this).closest(".product__accordion").find(".accordion__content").slideToggle("slow");
                    });
            }, 2e3);
        }),
            "Title" != e && $(".paymentButtonsWrapper .add-to-cart--secondary").addClass("btn-error");
        var t = $(".selector-wrapper.js .wetheme-dropdown__wrapper ul li.selected").attr("value");
        $(".wetheme-dropdown__wrapper button .header--supporting-text").attr("value", t),
            $(document).on("click", ".wetheme-dropdown__wrapper ul li", function () {
                var e = $(this).attr("value");
                $(this).closest(".wetheme-dropdown").find(".wetheme-dropdown__wrapper button .header--supporting-text").attr("value", e);
            }),
            $(document).on("click", ".paymentButtonsWrapper .add-to-cart--secondary.btn-error", function (e) {
                e.preventDefault(),
                    $(".wetheme-dropdown__wrapper button .header--supporting-text").each(function () {
                        $(this).attr("value") == $(this).text().trim() ? $(this).parent().removeClass("error") : $(this).parent().addClass("error");
                    });
            }),
            $(document).on("click", ".wetheme-dropdown__wrapper ul li", function () {
                var e = 0;
                $(".wetheme-dropdown__wrapper button .header--supporting-text")
                    .each(function () {
                        $(this).attr("value") == $(this).text().trim() ? $(this).parent().removeClass("error") : ($(this).parent().addClass("error"), (e += 1));
                    })
                    .promise()
                    .done(function (t) {
                        "2" == e ? $(document).find(".paymentButtonsWrapper .add-to-cart--secondary").removeClass("btn-error") : $(document).find(".paymentButtonsWrapper .add-to-cart--secondary").addClass("btn-error");
                    });
            }),
            $(document).on("click", ".custom-featured-product-portion .button-part.add-to-cart", function () {
                var e = $(this).attr("variant-id");
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: { quantity: 1, id: e },
                    dataType: "json",
                    success: function (e) {
                        window.location.href = "/cart";
                    },
                });
            });
    }),
    $(document).ready(function () {
        $(document).on("click", ".custom-featured-product-portion a.shop-now-button", function () {
            $("body.template-product").addClass("itg-quick-view");
        }),
            $(document).on("click", "body.template-product .drawer__close button.icon-fallback-text", function () {
                $("body.template-product").removeClass("itg-quick-view");
            }),
            $(".readmore").insertAfter(".product-description"),
            $(".readmore").click(function (e) {
                e.preventDefault();
                var t = document.querySelector(".product-description");
                console.log(t.style.height),
                    "" === t.style.height ? (t.style.height = "auto") : "auto" === t.style.height ? (t.style.height = "") : (t.style.height = "92px"),
                    $(this).text("Read less" == $(this).text() ? "Read more" : "Read less");
            });
    }),
    $(document).ready(function () {}),
    $(document).ready(function () {
        setInterval(function () {
            "" === $('input[type="hidden"].pplr_check_order').val() && $('input[type="hidden"].pplr_check_order').val("-");
        }, 1e3);
        $(".page_tab").length;
        $(".page_tab").on("click", function () {
            $(this).attr("data-length");
            $(this).addClass("past").nextAll().removeClass("past"), $(this).prevAll().addClass("past");
            var e = $(this).attr("data-tab");
            $(".thumb_block-image .pages_image_wrapper").each(function () {
                $(this).attr("data_link") == e && $(this).trigger("click");
            });
        }),
            $(".book_pages_linking_select select").on("change", function () {
                var e = $(this).val();
                $(".thumb_block-image .pages_image_wrapper").each(function () {
                    $(this).attr("data_link") == e && $(this).trigger("click");
                });
            }),
            $(".block_pages_image").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow:
                    '<span class="prevarrows"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg></span>',
                nextArrow:
                    '<span class="nextarrows"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg></span>',
                arrows: !0,
                fade: !0,
                adaptiveHeight: !0,
                asNavFor: ".thumb_block-image",
                responsive: [
                    { breakpoint: 520, settings: {} },
                    { breakpoint: 300, settings: {} },
                ],
            }),
            $(".thumb_block-image").slick({ slidesToShow: 3, slidesToScroll: 1, asNavFor: ".block_pages_image", dots: !0, centerMode: !0, focusOnSelect: !0 });
        var e = $(".count_pages"),
            t = $(".block_pages_image"),
            n = $(".block_pages_image .pages_image_wrapper").length;
        t.on("init reInit afterChange", function (t, r, i, o) {
            var a = (i || 0) + 1;
            e.text(a + " of " + n);
            var s = $(".slick-current .pages_image_wrapper").attr("data_link");
            $(".page_tab").each(function () {
                $(this).attr("data-tab") === s && ($(this).addClass("past").nextAll().removeClass("past"), $(this).prevAll().addClass("past"));
            });
        }),
            window.matchMedia("(max-width: 767px)").matches &&
                setTimeout(function () {
                    $(".desktop_section").appendTo(".mobile_section"), $(".mobile_section").find(".product_pages_blocks_wrapper").removeClass("desktop_section"), $(".block_pages_image, .thumb_block-image").slick("refresh");
                }, 1e3);
    });
